// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'http://localhost:4100' | (string & {});
};

export type UserSettings = {
    theme: 'dark' | 'light';
    notifications: boolean;
    defaultExchange: string;
    defaultLeverage: number;
    timezone: string;
    uiMode?: 'simple' | 'detailed';
    activeModuleId?: string;
};

export type AdminUserOrganization = {
    orgId: number;
    orgName: string;
    orgSlug: string;
};

export type Decision = {
    requestId: string;
    action: 'approve' | 'reject' | 'modify';
    notes: string;
    decidedBy: string;
    decidedAt: string | string;
    modifications?: unknown;
};

export type WorkflowContract = {
    jsonSchema?: {
        [key: string]: unknown;
    };
    schema?: {
        [key: string]: unknown;
    };
    templateId?: string;
    example?: {
        [key: string]: unknown;
    };
    strict?: boolean;
};

export type InputContractMap = {
    [key: string]: WorkflowContract;
};

export type TemplateVariableConfig = {
    name: string;
    description: string;
    default?: string;
};

export type SpawnPolicyConfig = {
    type: string;
    min?: number;
    max?: number;
};

export type TaskProfileConfig = {
    primaryCapability: 'reasoning' | 'vision' | 'fast' | 'code' | 'long-context';
    secondaryCapabilities: Array<'reasoning' | 'vision' | 'fast' | 'code' | 'long-context'>;
    latencyClass: 'realtime' | 'interactive' | 'batch';
    requiresToolCalling: boolean;
    requiresVision: boolean;
    preferredCost: 'free' | 'low' | 'medium' | 'high';
    minContextWindow: number;
    requiresStructuredOutput: boolean;
};

export type HeartbeatConfig = {
    every_n_calls?: number;
    every_t_seconds?: number;
};

export type TemplateUpgradeEvaluation = {
    id: number;
    versionId: number;
    organizationId: number;
    evaluationRunId: number | null;
    workflowRunId: number | null;
    daemonRunId: number | null;
    agentSessionId: number | null;
    toolExecutionId: number | null;
    skillUsageEventId: number | null;
    strategyRunId: number | null;
    forwardRunId: number | null;
    workerRunId: number | null;
    createdByUserId: number | null;
    runContext: 'production' | 'test';
    evaluator: 'golden_fixture' | 'strategy_evaluation' | 'indicator_validation' | 'llm_judge' | 'human_review' | 'paper_trading' | 'live_trading' | 'competition_rating' | 'security_review' | 'quality_review' | 'persona_validity' | 'calibration';
    verdict: 'pass' | 'warn' | 'fail' | null;
    score: string | null;
    effectiveFingerprint: string;
    detail: {
        [key: string]: unknown;
    };
    evaluatedAt: string | string;
};

export type RuntimePolicyRetireCounts = {
    conversationsMoved: number;
    entitiesMoved: number;
    allowedRemoved: number;
    fallbacksCleared: number;
};

export type RuntimePolicySurfaceRule = {
    surface: RuntimePolicySurface;
    organizationId: number | null;
    defaultPolicyId: number;
    allowedPolicyIds: Array<number>;
    system: {
        defaultPolicyId: number;
        allowedPolicyIds: Array<number>;
    } | null;
};

export enum RuntimePolicySurface {
    CONVERSATION = 'conversation',
    WORKFORCE = 'workforce',
    WORKFLOW = 'workflow',
    ANALYSIS = 'analysis',
    EVALUATION = 'evaluation',
    JUDGE = 'judge',
    CODEGEN = 'codegen',
    SYSTEM = 'system',
    RESEARCH = 'research'
}

export type EvaluationTemplate = {
    id: number;
    templateRef: string | null;
    name: string | null;
    description: string | null;
    organizationId: number;
    visibility: 'private' | 'org';
    status: 'draft' | 'active' | 'deprecated' | 'retired';
    subjectKind: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
    templateKind: 'leaf' | 'group';
    spec: {
        schemaVersion: 'evaluation-template-spec/v1';
        subjectKind: string;
        items: Array<{
            kind: 'criterion';
            evaluatorKey: string;
            modality?: string;
            thresholds?: {
                [key: string]: number;
            };
            params?: {
                [key: string]: unknown;
            };
            minTrials?: number;
            required?: boolean;
        } | {
            kind: 'template_ref';
            childTemplateRef: string;
            childVersion: number;
            required?: boolean;
        }>;
    };
    currentVersionId: number | null;
    createdAt: string;
    updatedAt: string;
};

export type EvaluationTemplateVersion = {
    id: number;
    templateId: number;
    organizationId: number;
    version: number;
    state: 'draft' | 'locked';
    subjectKind: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
    templateKind: 'leaf' | 'group';
    spec: {
        schemaVersion: 'evaluation-template-spec/v1';
        subjectKind: string;
        items: Array<{
            kind: 'criterion';
            evaluatorKey: string;
            modality?: string;
            thresholds?: {
                [key: string]: number;
            };
            params?: {
                [key: string]: unknown;
            };
            minTrials?: number;
            required?: boolean;
        } | {
            kind: 'template_ref';
            childTemplateRef: string;
            childVersion: number;
            required?: boolean;
        }>;
    };
    createdAt: string;
};

export type CatalogSourceFragmentSummary = {
    fragmentType: string;
    sourcePath: string | null;
    sourceUrl: string | null;
    sourceRef: string | null;
    title: string | null;
    contentHash: string | null;
    contentType: string | null;
    targetTypeHint: string | null;
    classification: string | null;
    rationale: string | null;
};

export type CatalogIntegrityCheckSummary = {
    id: number;
    checkType: string;
    status: 'passed' | 'warning' | 'blocked';
    severity: 'info' | 'low' | 'medium' | 'high' | 'critical';
    message: string;
    recommendation: string | null;
    checkedAt: string | string;
    sourceFragment: CatalogSourceFragmentSummary | null;
};

export type CatalogSource = {
    id: number;
    organizationId: number;
    moduleId: string;
    sourceType: string;
    canonicalKey: string;
    sourceUrl: string | null;
    sourceRepoUrl: string | null;
    sourcePath: string | null;
    sourceRef: string | null;
    packageName: string | null;
    provider: string | null;
    externalId: string | null;
    title: string | null;
    contentHash: string | null;
    metadata: {
        [key: string]: unknown;
    };
    firstSeenAt: string | string;
    lastSeenAt: string | string;
    lastCheckedAt: string | string | null;
    nextRefreshAt: string | string | null;
    refreshIntervalDays: number;
    createdAt: string | string;
    updatedAt: string | string;
};

export type CatalogRunLink = {
    runId: number;
    daemonId: number;
    daemonName: string | null;
    status: string;
    startedAt: string | string;
    completedAt: string | string | null;
    error: string | null;
};

export type CatalogFindingSummary = {
    id: number;
    daemonId: number;
    daemonName: string;
    workflowRunId: number | null;
    category: 'vulnerability' | 'quality-issue' | 'optimization' | 'insight' | 'alert' | 'template-ecosystem' | 'promotion_candidate' | 'intent_classification_review' | 'edge_decay' | 'survivorship_bias_report';
    severity: 'info' | 'low' | 'medium' | 'high' | 'critical';
    title: string;
    description: string | null;
    recommendation: string | null;
    evidence: {
        [key: string]: unknown;
    } | null;
    affectedFiles: Array<string>;
    affectedSymbols: Array<string>;
    createdAt: string | string;
};

export type CatalogCandidate = {
    id: number;
    organizationId: number;
    moduleId: string;
    sourceId: number;
    targetType: string;
    targetId: number | null;
    proposedAction: string;
    status: string;
    confidence: string | null;
    payload: {
        [key: string]: unknown;
    };
    diffSummary: string | null;
    sourceContentHash: string | null;
    discoveredByEntityId: number | null;
    discoveredRunId: number | null;
    reportId: number | null;
    findingId: number | null;
    securityReviewedRunId: number | null;
    qualityReviewedRunId: number | null;
    queuedAt: string | string;
    reviewReadyAt: string | string | null;
    appliedAt: string | string | null;
    idempotencyKey: string;
    metadata: {
        [key: string]: unknown;
    };
    createdAt: string | string;
    updatedAt: string | string;
};

export type WorkOutputPart = {
    id: number;
    workOutputId: number;
    runId?: number | null;
    workflowId?: number | null;
    stepId?: string | null;
    sourceType: string;
    sourceId: string;
    kind: string;
    key: string;
    title: string;
    portType?: string | null;
    payload?: unknown;
    payloadUrl?: string | null;
    mimeType?: string | null;
    sizeBytes?: number | null;
    visibility?: string | null;
    source?: string | null;
    schema?: {
        [key: string]: unknown;
    } | null;
    metadata?: {
        [key: string]: unknown;
    } | null;
    ttlHours?: number | null;
    createdAt: string;
    updatedAt: string;
};

export type SafeOutputConstraint = {
    maxValue?: number;
    allowedValues?: Array<string>;
    maxLength?: number;
    maxCalls?: number;
    appliesTo?: 'all' | 'cloud' | 'local';
};

export type JsonObject = {
    [key: string]: unknown;
};

export type WorkflowScheduleConfig = {
    type: 'cron' | 'interval' | 'event';
    cron?: string;
    intervalMs?: number;
    eventTrigger?: string;
    eventFilter?: {
        [key: string]: string | number | boolean;
    };
    enabled: boolean;
};

export type MarketplaceAcquisitionVersion = {
    id: number;
    version: number;
    note: string | null;
    publishedAt: string | null;
};

export enum ConversationIntentKind {
    DIRECT_ANSWER = 'direct_answer',
    WORKFLOW = 'workflow',
    TASK = 'task',
    PROJECT = 'project',
    MARKETPLACE = 'marketplace',
    AMBIGUOUS = 'ambiguous',
    TEMPLATE = 'template',
    WORKFORCE = 'workforce'
}

export type Strategy = {
    name: string;
    version: string;
    description: string;
    author?: string;
    type: 'trend_following' | 'mean_reversion' | 'momentum' | 'volatility' | 'scalping' | 'custom';
    timeframes: Array<'1m' | '3m' | '5m' | '15m' | '30m' | '1h' | '2h' | '4h' | '6h' | '12h' | '1d' | '1w'>;
    parameters: Array<ParameterDefinition>;
};

export type ParameterDefinition = {
    name: string;
    type: 'number' | 'integer' | 'boolean' | 'select';
    default?: unknown;
    min?: number;
    max?: number;
    step?: number;
    options?: Array<unknown>;
    description?: string;
};

export type AgentRecommendation = {
    action: 'buy' | 'sell' | 'hold' | 'close' | 'reduce' | 'increase';
    symbol: string;
    confidence: number;
    reason: string;
    suggestedSize?: number;
    stopLoss?: number;
    takeProfit?: number;
    priority: number;
};

export type AllocationRecommendation = {
    id: number;
    portfolioId: number;
    workflowRunId: number | null;
    generatedAt: string | null;
    status: 'pending' | 'approved' | 'rejected' | 'modified' | 'expired' | null;
    allocations?: unknown;
    rationale: string | null;
    riskWarnings: Array<string> | null;
    reviewedBy: string | null;
    reviewedAt: string | null;
    reviewNotes: string | null;
};

export type StrategyRunBenchmark = {
    symbol: string;
    exchange: string;
    defaulted: boolean;
    source?: string;
    stats: {
        status: 'computed' | 'absent';
        reasonCode: 'no_benchmark_resolved' | 'no_benchmark_series' | 'insufficient_overlap' | 'degenerate_benchmark_variance' | 'no_strategy_returns' | null;
        observations: number;
        periodsPerYear: number;
        strategyReturn: number | null;
        benchmarkReturn: number | null;
        excessReturn: number | null;
        trackingError: number | null;
        informationRatio: number | null;
        alpha: number | null;
        beta: number | null;
        upCapture: number | null;
        downCapture: number | null;
    };
    universeBuyHoldReturn?: number | null;
};

export type StrategyRunSeriesPoint = {
    /**
     * Unix epoch seconds, UTC.
     */
    time: number;
    value: number;
};

export type StrategyTemplateMarketDataReadiness = {
    status: 'ready' | 'research_only' | 'blocked';
    symbol: string;
    exchange: string;
    timeframe: string;
    windowStart: string;
    windowEnd: string;
    rowCount: number;
    expectedBars: number | null;
    missingIntervalCount: number;
    missingIntervals: Array<{
        previousTime: string;
        nextTime: string;
        skippedIntervals: number;
    }>;
    firstBar: string | null;
    lastBar: string | null;
    windowStartCovered: boolean;
    windowEndCovered: boolean;
    staleLastBar: boolean;
    pointInTime: 'verified' | 'unverified';
    providerUnlockIds: Array<string>;
    reasons: Array<{
        code: string;
        severity: 'blocker' | 'warning';
        message: string;
    }>;
    lineage?: {
        coverage: 'full' | 'partial' | 'none';
        providerRefs: Array<string>;
        adjustmentPolicies: Array<string>;
        availabilityViolations: number;
        pitSafeProvider: boolean;
    } | null;
};

export type StrategyTemplateRealtimeMarketDataReadiness = {
    status: 'ready' | 'research_only' | 'blocked';
    symbol: string;
    exchange: string;
    timeframe: string;
    evaluatedAt: string;
    lastBarTime: string | null;
    lastBarAgeMs: number | null;
    stalenessBudgetMs: number | null;
    barFresh: boolean;
    provider: {
        providerRef: string | null;
        realtimeCapable: boolean;
        streamTypes: Array<string>;
    };
    feed: {
        running: boolean | null;
        channels: {
            [key: string]: boolean;
        };
        source: 'server_aggregator' | 'unknown';
    };
    realtimeCertified: false;
    providerUnlockIds: Array<string>;
    reasons: Array<{
        code: string;
        severity: 'blocker' | 'warning';
        message: string;
    }>;
};

export type FinanceResearchDaemonLink = {
    slug: string;
    name: string;
    enabled: boolean;
    requiresApproval: boolean;
};

export type FinanceResearchRunSummary = ({
    kind: 'indicator';
} & FinanceResearchRunSummaryIndicator) | ({
    kind: 'strategy';
} & FinanceResearchRunSummaryStrategy) | ({
    kind: 'planner';
} & FinanceResearchRunSummaryPlanner) | ({
    kind: 'composer';
} & FinanceResearchRunSummaryComposer) | ({
    kind: 'degradation';
} & FinanceResearchRunSummaryDegradation);

export type FinanceResearchRunSummaryIndicator = {
    kind: 'indicator';
    runtimeAvailable?: boolean;
    librariesProbed?: number;
    librariesAvailable?: number;
    candidates?: {
        draftValidatable: number;
        researchOnly: number;
        blocked: number;
    };
    registration?: {
        created: number;
        metadataUpdated: number;
        versionAdded: number;
        alreadyRegistered: number;
        rejected: number;
    };
    validation?: {
        ran: number;
        passed: number;
    };
    proposals?: {
        proposed: number;
        alreadyProposed: number;
        rejected: number;
        skipped: number;
    };
    pendingDecisionIds?: Array<string>;
};

export type FinanceResearchRunSummaryStrategy = {
    kind: 'strategy';
    registration?: {
        created: number;
        metadataUpdated: number;
        versionAdded: number;
        alreadyRegistered: number;
        rejected: number;
        batches?: number;
        templatesCreated?: number;
        versionsAppended?: number;
    };
    compilation?: {
        compiledCandidates: number;
        alreadyCompiled: number;
        requiresHumanReview: number;
    };
    humanReviewCount?: number;
    warningsCount?: number;
};

export type FinanceResearchRunSummaryPlanner = {
    kind: 'planner';
    planner?: {
        candidatesEvaluated: number;
        enqueuedCount: number;
        skippedCount: number;
        dedupHits: number;
        budgetMax: number;
        budgetUsed: number;
        runRequestsBlocked: number;
        topEnqueued: Array<{
            definitionId: number;
            requestId: string;
            scope: string;
            wtn: number;
        }>;
    };
};

export type FinanceResearchRunSummaryComposer = {
    kind: 'composer';
    composer?: {
        candidatesEvaluated: number;
        composedCount: number;
        dedupHits: number;
        budgetMax: number;
        budgetUsed: number;
        runRequestsBlocked: number;
        skippedCount: number;
        topComposed: Array<{
            bucketId: string;
            bucketHash: string;
            mode: string;
            componentCount: number;
            allocationMethod: string;
            persistStatus: string;
            runRequestStatus: string | null;
            evaluationRecorded: boolean;
        }>;
    };
};

export type FinanceResearchRunSummaryDegradation = {
    kind: 'degradation';
    degradation?: {
        bucketsScanned: number;
        bucketsSkipped: number;
        signalsCount: number;
        observationsCreated: number;
        pendingDecisionsCreated: number;
        decisionsDeduped: number;
        unsupportedActionsCount: number;
        evalRefreshCount: number;
        runRequestsBlocked: number;
        topSignals: Array<{
            bucketId: string;
            signal: string;
            severity: string;
            componentDefinitionId: number | null;
        }>;
        knowledge: {
            hypothesesCreated: number;
            hypothesesDeduped: number;
            edgesCreated: number;
            replaceDecisionsCreated: number;
            artifactCreated: boolean;
        } | null;
    };
};

export type FinanceResearchLastRun = {
    workflowRunId: string;
    status: string;
    triggeredBy: string | null;
    startedAt: string | null;
    completedAt: string | null;
    error: string | null;
    summary: FinanceResearchRunSummary;
};

export type FinancePlannerAdvancedComponents = {
    muHat: number;
    sigmaHat: number;
    gateThreshold: number;
    expectedImprovement: number;
    gateProx: number;
    ucbBonus: number;
    kappa: number;
    eventRel: number;
    bucketNeed: number;
    normCost: number;
    drs: number;
    redundancyPenalty: number;
    nonStationarityDiscount: number;
    numerator: number;
};

export type FinancePlannerPendingRequest = {
    requestId: string;
    status: string;
    scope: string;
};

export type FinanceBucketEvaluation = {
    evaluationId: string;
    scope: string;
    verdict: string;
    recommendation: string;
    recommendationReason: string;
    overallScore: number | null;
    evaluatedAt: string | null;
    runRef: string | null;
    evaluatorRef: string | null;
    allocationMethod?: string;
    allocationFallbackReason?: string;
    correlationPairsWithEvidence?: number;
    correlationPairsMissingEvidence?: number;
    correlationMaxAbsCorrelation?: number;
    correlationRejectedCount?: number;
    warnings: Array<string>;
    blockers: Array<string>;
    simulation?: FinanceBucketSimulation;
    allocationEvidence?: FinanceBucketAllocationEvidence;
};

export type FinanceBucketSimulation = {
    status: 'simulated' | 'evidence_only' | 'blocked';
    basis: 'portfolio_return_simulation' | 'component_evidence_only';
    allocationMethod?: 'bucket_definition' | 'equal_weight' | 'inverse_volatility';
    allocationFallbackReason?: string;
    windowStart?: string;
    windowEnd?: string;
    observedBars?: number;
    periodsPerYear?: number;
    componentCount: number;
    observedComponents: number;
    missingComponents: number;
    excludedPausedComponents: number;
    annualizedReturn?: number;
    annualizedVolatility?: number;
    sharpe?: number;
    maxDrawdown?: number;
    correlation?: {
        pairCount: number;
        observedPairs: number;
        avgAbsPairwise?: number;
        maxAbsPairwise?: number;
    };
    hrpStatus?: 'applied' | 'unavailable';
    hrpReason?: string;
    topDiagnostics?: Array<string>;
    warningsCount?: number;
};

export type FinanceBucketAllocationEvidence = {
    basis: 'return_series' | 'persisted_scalar' | 'none';
    observedComponents: number;
    missingComponents: number;
    windowStart?: string;
    windowEnd?: string;
    observedBars?: number;
    periodsPerYear?: number;
    correlation?: {
        pairCount: number;
        observedPairs: number;
        avgAbsPairwise?: number;
        maxAbsPairwise?: number;
    };
    hrpStatus: 'applied' | 'unavailable';
    hrpReason?: string;
    topDiagnostics?: Array<string>;
};

export type FinanceBucketRunRequest = {
    requestId: string;
    status: string;
    scope: string;
    dataReadiness: string;
    blockedReasons: Array<string>;
    createdAt: string;
};

export type FinanceBucketRun = {
    runId: string;
    verdict: string | null;
    recommendation: string | null;
    passed: boolean | null;
    researchOnly: boolean;
    finishedAt: string | null;
};

export type FinanceBucketScore = {
    value: number;
    uncertainty: number;
    computedAt: string;
};

export type FinanceDegradationReplacement = {
    definitionId: number;
    skillValue: number;
};

export type FinanceDegradationLastScan = {
    scannedAt: string | null;
    signals: Array<FinanceDegradationSignal>;
    unsupportedActions: Array<string>;
};

export type FinanceDegradationSignal = {
    signal: 'component_sqs_drift' | 'bucket_score_deterioration' | 'bucket_eval_missing' | 'bucket_eval_stale' | 'component_run_failed' | 'component_request_blocked' | 'correlation_breach' | 'degrades_after_event_edge';
    severity: 'info' | 'low' | 'medium' | 'high' | 'critical';
    componentDefinitionId: number | null;
    detail: string;
};

export type FinanceIndicatorDecisionVerdict = {
    recommendation: 'buy' | 'hold' | 'sell' | 'needs_more_data' | null;
    latestSignal: {
        state: 'triggered' | 'not_triggered' | 'unknown';
        side: 'long' | 'short' | null;
        signalId: string | null;
        lastSignalAt: string | null;
        lastBarAt: string | null;
        trueCount: number | null;
    } | null;
    coverage: {
        rowCount: number | null;
        warmupNullCount: number | null;
        outputNullCounts?: {
            [key: string]: number;
        };
        firstBarAt: string | null;
        lastBarAt: string | null;
        expectedBars: number | null;
    } | null;
    confidence: 'low' | 'medium' | 'high' | null;
    warnings: Array<string>;
    blockers: Array<string>;
};

export type StrategyDecisionLatestSignal = {
    state: 'active' | 'unknown';
    lastBarAt: string | null;
    entryTriggeredOnLastBar: boolean;
    exitTriggeredOnLastBar: boolean;
};

export type StrategyDecisionRunSummary = {
    runId: string;
    runStatus: string;
    verdict: string | null;
    recommendation: string | null;
    researchOnly: boolean;
    finishedAt: string | null;
    windowStart: string | null;
    windowEnd: string | null;
    scope: string;
    runMode: string;
};

export type StrategyDecisionRequestSummary = {
    requestId: string;
    status: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled';
    dataReadiness: 'unknown' | 'ready' | 'research_only' | 'blocked';
    blockedReasons: Array<string>;
    requestedAt: string;
};

export type StrategyDecisionScoreSummary = {
    value: number;
    uncertainty: number;
    skillProb: number | null;
    pboPassed: boolean | null;
    computedAt: string;
};

export type StrategyDecisionDataReadinessSummary = {
    status: string;
    pointInTime: boolean;
    missingIntervalCount: number;
    staleLastBar: boolean;
};

export type FinanceOpsIndicatorDecisionVerdict = {
    recommendation: 'buy' | 'hold' | 'sell' | 'needs_more_data' | null;
    latestSignal: {
        state: 'triggered' | 'not_triggered' | 'unknown';
        side: 'long' | 'short' | null;
        signalId: string | null;
        lastSignalAt: string | null;
        lastBarAt: string | null;
        trueCount: number | null;
    } | null;
    coverage: {
        rowCount: number | null;
        warmupNullCount: number | null;
        outputNullCounts?: {
            [key: string]: number;
        };
        firstBarAt: string | null;
        lastBarAt: string | null;
        expectedBars: number | null;
    } | null;
    confidence: 'low' | 'medium' | 'high' | null;
    warnings: Array<string>;
    blockers: Array<string>;
};

export type IndicatorImportPersistedArtifact = {
    id: string;
    title: string;
};

export type ModelLineageTemplateProvenance = {
    strategyTemplateId: string | null;
    strategyTemplateVersionId: string | null;
    templateRef: string | null;
    templateVersion: number | null;
    linkSource: 'fk' | 'inferred' | 'none';
};

export type KgRegimeScoreEntry = {
    regime: string;
    scope: string;
    value: number;
    uncertainty: number;
    components: {
        [key: string]: unknown;
    } | null;
    computed_at: string;
};

export type KgNodeSummary = {
    id: string;
    node_type: string;
    canonical_key: string;
    label: string;
    status: 'active' | 'merged' | 'retired';
};

export type ShadowCertCounters = {
    ticks: number;
    proposals: number;
    fencedAttempts: number;
    capitalFacingAttempts: number;
    approvedProposals: number;
    rejectedProposals: number;
    errors: number;
};

export type ShadowCertThresholds = {
    minTicks: number;
    minApprovedProposals: number;
    maxRejectedProposalRate: number;
    maxErrorRate: number;
};

export type CodeWorkspace = {
    id: number;
    organizationId: number;
    projectId: number;
    provider: 'local_git' | 'github' | 'gitlab' | 'gitea' | 'forgejo' | 'gerrit' | 'confluent_hosted';
    providerInstallationId: string | null;
    providerAccountId: string | null;
    providerRepositoryId: string | null;
    credentialRef: string | null;
    repositoryConnectionId: number | null;
    repoOwner: string | null;
    repoName: string | null;
    repoUrl: string | null;
    providerHtmlUrl: string | null;
    defaultBranch: string;
    branchPrefix: string | null;
    isolationTier: 'org_default' | 'project' | 'byo';
    status: 'provisioning' | 'active' | 'out_of_sync' | 'blocked' | 'archived';
    statusReason: string | null;
    defaultHeadSha: string | null;
    lastObservedDefaultHeadSha: string | null;
    latestCheckpointId: number | null;
    latestReconciledAt: string | null;
    buildStatus: string | null;
    testStatus: string | null;
    lintStatus: string | null;
    migrationStatus: string | null;
    securityStatus: string | null;
    qualityStatus: string | null;
    permissionSnapshot: {
        [key: string]: unknown;
    };
    protectionSnapshot: {
        [key: string]: unknown;
    };
    lastWebhookDeliveryId: string | null;
    metadata: {
        [key: string]: unknown;
    };
    createdAt: string;
    updatedAt: string;
};

export type CodeWorkspaceOperation = {
    id: number;
    organizationId: number;
    workspaceId: number;
    projectId: number;
    projectChangeId: number | null;
    revisionId: number | null;
    checkpointId: number | null;
    operationType: 'prepare_workspace' | 'sync_provider' | 'create_branch' | 'apply_revision' | 'commit_revision' | 'open_pull_request' | 'merge_pull_request' | 'create_checkpoint' | 'revert_commit' | 'cleanup_workspace';
    status: 'pending' | 'running' | 'succeeded' | 'failed' | 'blocked' | 'cancelled';
    idempotencyKey: string | null;
    attemptCount: number;
    expectedBranch: string | null;
    expectedHeadSha: string | null;
    actualHeadSha: string | null;
    resultCommitSha: string | null;
    resultCheckpointId: number | null;
    providerRef: string | null;
    providerUrl: string | null;
    workerRunId: number | null;
    daemonRunId: number | null;
    sourceEventId: number | null;
    blockerId: number | null;
    leaseExpiresAt: string | null;
    lockedByActorType: string | null;
    lockedByActorId: string | null;
    lastHeartbeatAt: string | null;
    requestPayload: {
        [key: string]: unknown;
    };
    resultPayload: {
        [key: string]: unknown;
    };
    errorCode: string | null;
    errorMessage: string | null;
    startedAt: string | null;
    completedAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type CodeClientDatabase = {
    id: number;
    organizationId: number;
    projectId: number | null;
    workspaceId: number | null;
    scope: 'organization' | 'project';
    provider: 'managed_postgres' | 'byo_postgres';
    isolationTier: 'org_default' | 'project' | 'byo';
    status: 'provisioning' | 'active' | 'failed' | 'disabled' | 'archived';
    statusReason: string | null;
    connectionConfigured: boolean;
    connectionSecretProvider: 'external_ref' | 'aws_secrets_manager' | 'gcp_secret_manager' | 'vault' | 'local_file' | 'env' | null;
    connectionFingerprint: string | null;
    databaseName: string | null;
    schemaName: string;
    appRoleName: string | null;
    migrationRoleName: string | null;
    runtimeUrlEnvVar: string;
    migrationUrlEnvVar: string;
    writePolicy?: {
        mode?: 'migrations_only' | 'table_writes';
        allowSchemaChanges?: boolean;
        requireReviewGate?: boolean;
        conflictPolicy?: 'do_nothing' | 'upsert';
        maxRowsPerPart?: number;
        allowedSchemas?: Array<string>;
        allowedTables?: Array<string>;
    };
    provisioningMetadata?: {
        providerTargetRef?: string;
        connectionRedacted?: string;
        secretProvider?: 'external_ref' | 'aws_secrets_manager' | 'gcp_secret_manager' | 'vault' | 'local_file' | 'env';
        provisioner?: string;
        configuredBy?: 'server' | 'engine' | 'system';
        configuredAt?: string;
        connectionParsedAt?: string;
        notes?: string;
    };
    latestMigrationId: number | null;
    latestSnapshotId: number | null;
    provisionedAt: string | null;
    validatedAt: string | null;
    latestMigrationAt: string | null;
    disabledAt: string | null;
    metadata?: {
        displayName?: string;
        environment?: string;
        notes?: string;
        tags?: Array<string>;
    };
    createdAt: string;
    updatedAt: string;
};

export type CodeTuningConversation = {
    id: number;
    organizationId: number;
    userId: number;
    topic: string;
    kind: 'user-agent' | 'agent-agent' | 'team' | 'assistant-ui';
    templateSlug: string;
    subjectType: string | null;
    subjectId: string | null;
    status: 'active' | 'idle' | 'completed' | 'errored';
    projectId: number | null;
    parentConversationId: number | null;
    lastActivityAt: string;
    createdAt: string;
    updatedAt: string;
};

export type CodeTuningVersion = CodeTuningVersionSummary & {
    parts: Array<CodeTuningOutputPart>;
    preview: {
        surface: {
            title: string;
            route: string;
            kind: 'ui' | 'api' | 'workflow' | 'schema';
        };
        runtime: {
            adapter: 'webcontainer' | 'sandpack' | 'docker' | 'external_link';
            previewUrl?: string;
            status: 'booting' | 'ready' | 'blocked' | 'disposed';
            mode: 'mock' | 'real' | 'mixed';
        };
        scenarios: Array<{
            key: string;
            label: string;
            status: 'ready' | 'blocked';
        }>;
        selectedScenario?: string;
    } | null;
    patch: {
        baseCommitSha: string;
        patch: string;
        patchHash: string;
        fileChanges: Array<{
            path: string;
            changeType: 'added' | 'modified' | 'deleted' | 'renamed';
        }>;
        notes?: string;
    } | null;
    manifest: {
        stack: {
            framework: string;
            language: string;
            packageManager?: string;
        };
        surfaces: Array<{
            title: string;
            route?: string;
            files: Array<string>;
            scenarios?: Array<string>;
        }>;
        contracts: {
            mockProviders?: Array<string>;
            apiRoutes?: Array<string>;
            dataModels?: Array<string>;
        };
        dependencies?: Array<{
            name: string;
            version: string;
            reason?: string;
        }>;
    } | null;
    validationReport: {
        status: 'passing' | 'warning' | 'blocked';
        checks: Array<{
            name: 'typecheck' | 'build' | 'lint' | 'test' | 'security' | 'quality' | 'preview';
            status: 'passing' | 'warning' | 'blocked' | 'not_run';
            summary?: string;
            logRef?: string;
        }>;
        blockingIssues?: Array<{
            title: string;
            severity: 'low' | 'medium' | 'high' | 'critical';
            recommendation: string;
        }>;
    } | null;
};

export type CodeTuningWorkOutput = {
    id: number;
    organizationId: number;
    sourceType: 'workstream';
    sourceId: string;
    workflowRunId: number | null;
    workflowId: number | null;
    stepId: string | null;
    taskId: number | null;
    workerRunId: number | null;
    projectId: number | null;
    projectThreadId: number | null;
    projectChangeId: number | null;
    title: string;
    summary: string | null;
    status: 'ready' | 'blocked' | 'pending' | 'superseded';
    rawPayload?: unknown;
    metadata?: unknown;
    createdAt: string;
    updatedAt: string;
};

export type CodeTuningOutputPart = {
    id: number;
    workOutputId: number;
    kind: 'code_preview' | 'code_patch' | 'code_manifest' | 'code_validation_report';
    key: string;
    title: string;
    portType: string | null;
    payload?: unknown;
    payloadUrl: string | null;
    mimeType: string | null;
    sizeBytes: number | null;
    visibility: string | null;
    source: string | null;
    schema?: unknown;
    metadata?: unknown;
    ttlHours: number | null;
    parsed: {
        kind: 'code_preview';
        payload: {
            surface: {
                title: string;
                route: string;
                kind: 'ui' | 'api' | 'workflow' | 'schema';
            };
            runtime: {
                adapter: 'webcontainer' | 'sandpack' | 'docker' | 'external_link';
                previewUrl?: string;
                status: 'booting' | 'ready' | 'blocked' | 'disposed';
                mode: 'mock' | 'real' | 'mixed';
            };
            scenarios: Array<{
                key: string;
                label: string;
                status: 'ready' | 'blocked';
            }>;
            selectedScenario?: string;
        };
    } | {
        kind: 'code_patch';
        payload: {
            baseCommitSha: string;
            patch: string;
            patchHash: string;
            fileChanges: Array<{
                path: string;
                changeType: 'added' | 'modified' | 'deleted' | 'renamed';
            }>;
            notes?: string;
        };
    } | {
        kind: 'code_manifest';
        payload: {
            stack: {
                framework: string;
                language: string;
                packageManager?: string;
            };
            surfaces: Array<{
                title: string;
                route?: string;
                files: Array<string>;
                scenarios?: Array<string>;
            }>;
            contracts: {
                mockProviders?: Array<string>;
                apiRoutes?: Array<string>;
                dataModels?: Array<string>;
            };
            dependencies?: Array<{
                name: string;
                version: string;
                reason?: string;
            }>;
        };
    } | {
        kind: 'code_validation_report';
        payload: {
            status: 'passing' | 'warning' | 'blocked';
            checks: Array<{
                name: 'typecheck' | 'build' | 'lint' | 'test' | 'security' | 'quality' | 'preview';
                status: 'passing' | 'warning' | 'blocked' | 'not_run';
                summary?: string;
                logRef?: string;
            }>;
            blockingIssues?: Array<{
                title: string;
                severity: 'low' | 'medium' | 'high' | 'critical';
                recommendation: string;
            }>;
        };
    } | null;
    validationErrors: Array<string>;
    createdAt: string;
    updatedAt: string;
};

export type CodeTuningVersionSummary = {
    output: CodeTuningWorkOutput;
    partKinds: Array<'code_preview' | 'code_patch' | 'code_manifest' | 'code_validation_report'>;
    hasPatch: boolean;
    previewStatus: 'booting' | 'ready' | 'blocked' | 'disposed' | null;
    validationStatus: 'passing' | 'warning' | 'blocked' | null;
    reviewRequest: {
        id: number;
        gateType: 'codegen_review' | 'plan' | 'ui' | 'database' | 'backend' | 'integration' | 'launch' | 'catalog_promotion' | 'platform_change';
        actionType: 'codegen:promote';
        status: 'pending' | 'approved' | 'rejected' | 'request_changes' | 'expired' | 'superseded';
        workOutputId: number;
        subjectKind: string;
        subjectId: string;
        subjectVersionHash: string | null;
        requestedByUserId: number;
        requestedAt: string;
        expiresAt: string | null;
        reviewer: {
            actorPlane: 'system_daemon' | 'workforce_member' | 'human_user' | 'service_account';
            actorKey: string | null;
            resolvedUserId: number | null;
            delegatedFromUserId: number | null;
            label: string | null;
        };
        decision: {
            action: 'approve' | 'reject' | 'request_changes' | 'accept_risk';
            decidedByUserId: number;
            decidedAt: string;
            rationale: string | null;
            reasonCode: string | null;
            riskAcceptedUntil: string | null;
        } | null;
        versionSnapshot: {
            title: string;
            summary: string | null;
            validationStatus: 'passing' | 'warning' | 'blocked' | null;
            patchHash: string | null;
            previewRoute: string | null;
            outputUpdatedAt: string | null;
        };
        createdRevisionId: number | null;
    } | null;
};

export type SystemHealth = {
    status: 'healthy' | 'degraded';
    timestamp: string;
    /**
     * Process uptime in seconds
     */
    uptime: number;
    environment: string;
    /**
     * The release this server runs (its image's CONFLUI_VERSION; local outside an image)
     */
    version: string;
    checks: {
        database: SystemHealthCheck;
        redis: SystemHealthCheck;
        engine: SystemEngineCheck;
    };
};

export type SystemHealthCheck = {
    status: 'healthy' | 'unhealthy';
    latency_ms?: number;
};

export type SystemEngineCheck = {
    /**
     * missing = no engine heartbeat in this environment for 90 s
     */
    status: 'healthy' | 'missing';
    /**
     * The release the engine runs
     */
    version?: string;
    instanceId?: string;
    /**
     * Seconds since the engine last wrote its heartbeat
     */
    lastSeenSeconds?: number;
};

export type SignupResult = {
    success: boolean;
    message: string;
    user: User;
};

export type User = {
    id: number;
    email: string;
    username: string | null;
    fullName: string | null;
    status: string;
    organizationId?: number | null;
    organizationName?: string | null;
    organizationPlan?: string | null;
    settings?: UserSettings | null;
    isVerified?: boolean;
    createdAt?: string;
    permissions?: Array<string>;
};

export type AuthSignupCreate = {
    email: string;
    password: string;
    username?: string;
    fullName?: string;
    invitationToken?: string;
};

export type AuthToken = {
    success: boolean;
    token: string;
    user: User;
};

export type AuthLoginCreate = {
    email: string;
    password: string;
};

export type UserProfileUpdate = {
    username?: string;
    fullName?: string;
    settings?: {
        theme?: 'dark' | 'light';
        notifications?: boolean;
        defaultExchange?: string;
        defaultLeverage?: number;
        timezone?: string;
        uiMode?: 'simple' | 'detailed';
        activeModuleId?: string;
    };
};

export type ActionSuccess = {
    success: boolean;
    message: string;
};

export type TokenRefresh = {
    token: string;
};

export type VerifyEmailRequest = {
    token: string;
};

export type ResetPasswordRequest = {
    token: string;
    password: string;
};

export type LinkedAccount = {
    userId: number;
    email: string;
    fullName: string | null;
    organizationName: string;
    organizationSlug: string;
};

export type AccountSwitchRequest = {
    targetUserId: number;
};

export type LinkedAccountActionSuccess = {
    success: boolean;
    message: string;
};

export type AccountLinkRequest = {
    userId: number;
    linkedUserId: number;
};

export type InvitationPreview = {
    email: string;
    orgName: string;
    role: 'org_admin' | 'trader' | 'analyst' | 'viewer';
    inviterName: string;
    expiresAt: string;
};

export type Invitation = {
    id: number;
    email: string;
    orgId: number;
    role: 'org_admin' | 'trader' | 'analyst' | 'viewer';
    invitedBy: number;
    status: 'pending' | 'accepted' | 'expired' | 'revoked';
    acceptedBy: number | null;
    acceptedAt: string | null;
    expiresAt: string;
    message: string | null;
    createdAt: string;
    updatedAt: string;
    token: string | null;
};

export type AdminUser = {
    id: number;
    email: string;
    username: string | null;
    fullName: string | null;
    avatarUrl: string | null;
    phone: string | null;
    bio: string | null;
    timezone: string | null;
    jobTitle: string | null;
    department: string | null;
    location: string | null;
    linkedinUrl: string | null;
    notes: string | null;
    status: 'pending' | 'approved' | 'rejected';
    active: boolean;
    verified: boolean;
    approvedBy: number | null;
    approvedAt: string | null;
    createdAt: string;
    updatedAt: string;
    lastLoginAt: string | null;
    roles?: Array<AdminUserRole>;
    organization?: AdminUserOrganization | null;
    auditLog?: Array<AdminUserAuditEntry>;
};

export type AdminUserRole = {
    id: number;
    roleId: number;
    roleName: string;
    scope: 'global' | 'org' | 'team';
    grantedBy: number | null;
    grantedAt: string;
};

export type AdminUserAuditEntry = {
    id: number;
    actorId: number;
    actorName: string | null;
    action: string;
    details: {
        [key: string]: unknown;
    };
    createdAt: string;
};

export type UserBulkStatusResult = {
    updatedCount: number;
    updatedIds: Array<number>;
};

export type UserBulkStatusRequest = {
    ids: Array<number>;
    status: 'approved' | 'rejected';
};

export type AdminUserUpdate = {
    username?: string;
    fullName?: string;
    phone?: string;
    bio?: string;
    timezone?: string;
    jobTitle?: string;
    department?: string;
    location?: string;
    linkedinUrl?: string;
    notes?: string;
    status?: 'pending' | 'approved' | 'rejected';
    active?: boolean;
};

export type AdminActionSuccess = {
    success: boolean;
    message: string;
};

export type UserRoleAssign = {
    role: 'org_admin' | 'trader' | 'analyst' | 'code_reviewer' | 'viewer';
    orgId: number;
};

export type AdminUserAuditList = {
    data: Array<AdminUserAuditEntry>;
};

export type ExchangeCredential = {
    id: number;
    exchange: string;
    label: string | null;
    permissions: {
        trade: boolean;
        withdraw: boolean;
    } | null;
    isActive: boolean | null;
    isTestnet: boolean | null;
    createdAt: string;
    lastUsedAt: string | null;
};

export type ExchangeCredentialCreate = {
    exchange: string;
    label?: string;
    apiKey: string;
    apiSecret: string;
    permissions?: {
        trade: boolean;
        withdraw: boolean;
    };
    isTestnet?: boolean;
};

export type NotificationConfig = {
    telegram?: {
        /**
         * The bot token, masked: only its last 4 characters
         */
        botToken?: string;
        chatId: string;
        enabled: boolean;
    };
    discord?: {
        /**
         * The webhook URL, masked: only its last 4 characters
         */
        webhookUrl?: string;
        enabled: boolean;
    };
    slack?: {
        /**
         * The webhook URL, masked: only its last 4 characters
         */
        webhookUrl?: string;
        channel?: string;
        enabled: boolean;
    };
    email?: {
        host: string;
        port: number;
        secure: boolean;
        user: string;
        /**
         * The mail password, masked: only its last 4 characters
         */
        pass?: string;
        from: string;
        recipients: Array<string>;
        enabled: boolean;
    };
    webhook?: {
        /**
         * The URL, masked: only its last 4 characters
         */
        url?: string;
        enabled: boolean;
    };
};

export type NotificationConfigUpdate = {
    telegram?: {
        /**
         * The bot token. Write-only: leave it out to keep the stored one.
         */
        botToken?: string;
        chatId: string;
        enabled: boolean;
    };
    discord?: {
        /**
         * The webhook URL. Write-only: leave it out to keep the stored one.
         */
        webhookUrl?: string;
        enabled: boolean;
    };
    slack?: {
        /**
         * The webhook URL. Write-only: leave it out to keep the stored one.
         */
        webhookUrl?: string;
        channel?: string;
        enabled: boolean;
    };
    email?: {
        host: string;
        port: number;
        secure: boolean;
        user: string;
        /**
         * The mail password. Write-only: leave it out to keep the stored one.
         */
        pass?: string;
        from: string;
        recipients: Array<string>;
        enabled: boolean;
    };
    webhook?: {
        /**
         * The URL. Write-only: leave it out to keep the stored one.
         */
        url?: string;
        /**
         * Headers sent with each post. Write-only: leave them out to keep the stored ones.
         */
        headers?: {
            [key: string]: string;
        };
        enabled: boolean;
    };
};

export type NotificationResult = {
    channel: 'telegram' | 'discord' | 'slack' | 'email' | 'webhook';
    success: boolean;
    messageId?: string;
    error?: string;
    timestamp: string | string;
};

export type NotificationSendCreate = {
    type: 'trade_opened' | 'trade_closed' | 'signal_generated' | 'stop_loss_hit' | 'take_profit_hit' | 'risk_alert' | 'system_alert' | 'price_alert' | 'pattern_detected';
    priority: 'low' | 'medium' | 'high' | 'critical';
    title: string;
    message: string;
    symbol?: string;
    data?: {
        [key: string]: unknown;
    };
};

export type NotificationTestCreate = {
    channel?: 'telegram' | 'discord' | 'slack' | 'email' | 'webhook';
};

export type AgentSummary = {
    id: string;
    name: string;
    role: string;
    model: string;
    status: string;
    healthScore: number;
    totalCostUSD: number;
    tasksCompleted: number;
    tasksFailed: number;
    spawnedAt: string;
    lastHeartbeat: string | null;
};

export type AgentSpawnResult = {
    id: string;
    name: string;
    role: string;
    status: string;
};

export type AgentSpawnRequest = {
    templateSlug: string;
    context?: {
        [key: string]: unknown;
    };
};

export type AgentTerminateRequest = {
    reason?: string;
};

export type AgentExecuteResult = {
    requestId: string;
    status: string;
};

export type AgentExecuteRequest = {
    input?: unknown;
    context?: {
        [key: string]: unknown;
    };
};

export type AgentHealthReport = {
    totalAgents: number;
    healthyCount: number;
    degradedCount: number;
    unhealthyCount: number;
    byStatus: {
        [key: string]: number;
    };
    agents: Array<{
        id: string;
        name: string;
        status: string;
        healthScore: number;
        lastHeartbeat: string | null;
    }>;
};

export type DecisionRequest = {
    id: string;
    workflowRunId: number;
    gateName: string;
    memo: InvestmentMemo;
    expiresAt: string | string;
    priority: 'low' | 'medium' | 'high' | 'urgent';
    createdAt: string | string;
    status: 'pending' | 'decided' | 'expired';
};

export type InvestmentMemo = {
    summary: string;
    tradeCandidates: Array<TradeCandidate>;
    supportingSignals: Array<DecisionAgentSignal>;
    riskReport?: RiskReport;
    dissentingViews: Array<string>;
    confidenceBreakdown: {
        [key: string]: number;
    };
    suggestedSizing?: Array<PositionSizeSuggestion>;
};

export type TradeCandidate = {
    ticker: string;
    action: 'buy' | 'sell' | 'hold' | 'close';
    suggestedWeightPct?: number;
    conviction: number;
    rationale: string;
    risks: Array<string>;
    targetPrice?: number;
    stopLoss?: number;
};

export type DecisionAgentSignal = {
    templateSlug: string;
    agentId: string;
    signal: string;
    confidence: number;
    data?: unknown;
};

export type RiskReport = {
    portfolioVaR: number;
    maxDrawdown: number;
    correlationRisk: string;
    sectorConcentration: {
        [key: string]: number;
    };
};

export type PositionSizeSuggestion = {
    ticker: string;
    currentWeightPct: number;
    suggestedWeightPct: number;
    deltaShares: number;
    rationale: string;
};

export type DecisionStats = {
    total: number;
    pending: number;
    approved: number;
    rejected: number;
    modified: number;
};

export type DecisionApproveRequest = {
    notes?: string;
};

export type DecisionRejectRequest = {
    notes?: string;
};

export type DecisionModifyRequest = {
    modifications?: unknown;
    notes?: string;
};

export type ExecuteStepStreamRequest = {
    templateSlug: string;
    input?: unknown;
    config?: {
        [key: string]: unknown;
    };
    systemPromptOverride?: string;
    userPromptTemplate?: string;
    freshSession?: boolean;
    noTools?: boolean;
    upstreamOutputs?: {
        [key: string]: unknown;
    };
    inputMapping?: {
        type: 'static' | 'ref' | 'merge' | 'template';
        value?: unknown;
        stepId?: string;
        refs?: Array<{
            stepId: string;
            outputKey: string;
        }> | {
            [key: string]: string;
        };
        template?: string;
    };
    contextSpec?: {
        [key: string]: unknown;
    };
};

export type AgentStreamError = {
    error?: string;
    code?: string;
    message?: string;
};

export type FollowUpMessageRequest = {
    message: string;
};

export type OptimizePromptResult = {
    requestId: string;
    status: 'queued';
};

export type OptimizePromptRequest = {
    input: string;
};

export type PromptTemplateSummary = {
    id: string;
    label: string;
    description: string;
    requiredParams: Array<string>;
    suggestedTemplate?: string;
    category: string;
};

export type FillTemplateResult = {
    template: string;
    prompt: string;
    suggestedTemplate?: string;
    suggestedWorkflow?: string;
};

export type FillTemplateRequest = {
    params?: {
        [key: string]: string;
    };
};

export type ToolGapAnalysis = {
    totalGaps: number;
    critical: number;
    degraded: number;
    gaps: Array<ToolGap>;
};

export type ToolGap = {
    skill: string;
    severity: 'critical' | 'degraded';
    reason: string;
};

export type AgentTemplateSearchResult = {
    id: number;
    slug: string;
    name: string;
    description: string | null;
    departmentId: string | null;
    platform: string | null;
    category: string | null;
    tags: Array<string> | null;
    usageCount: number | null;
    avgQualityScore: string | null;
    score: number;
    matchType: 'keyword' | 'semantic' | 'hybrid';
};

export type AgentTemplateVersion = {
    id: number;
    templateId: number;
    version: number;
    status: 'draft' | 'active' | 'retired';
    configSnapshot: {
        goal: string | null;
        backstory: string | null;
        instructions: string | null;
        constraints: string | null;
        variables: Array<TemplateVariableConfig> | null;
        permissionTier: string | null;
        spawnPolicy: SpawnPolicyConfig | null;
        taskProfile: TaskProfileConfig | null;
        disableModelInvocation: boolean | null;
        routingRules: Array<{
            match: string;
            targetTemplate: string;
            context?: string;
        }> | null;
        maxToolIterations: number | null;
        defaultSubscriptions: Array<string>;
        heartbeatConfig: HeartbeatConfig | null;
        tools: Array<string>;
    };
    systemPromptHash: string | null;
    changeSummary: string | null;
    createdBy: number | null;
    organizationId: number;
    promotedAt: string | string | null;
    retiredAt: string | string | null;
    createdAt: string | string;
    updatedAt: string | string;
};

export type AgentTemplateVersionCreate = {
    configSnapshot: {
        goal?: string | null;
        backstory?: string | null;
        instructions?: string | null;
        constraints?: string | null;
        variables?: Array<TemplateVariableConfig> | null;
        permissionTier?: string | null;
        spawnPolicy?: SpawnPolicyConfig | null;
        taskProfile?: TaskProfileConfig | null;
        disableModelInvocation?: boolean | null;
        routingRules?: Array<{
            match: string;
            targetTemplate: string;
            context?: string;
        }> | null;
        maxToolIterations?: number | null;
        defaultSubscriptions?: Array<string>;
        heartbeatConfig?: HeartbeatConfig | null;
        tools?: Array<string>;
    };
    changeSummary?: string;
};

export type AgentTemplateVersionDiff = {
    versionA: number;
    versionB: number;
    diff: TemplateCompatibilityDiff;
    baseline: TemplateVersionRef;
    candidate: TemplateVersionRef;
};

export type TemplateCompatibilityDiff = {
    status: 'compatible' | 'needs_review' | 'needs_repair' | 'blocked';
    changes: Array<TemplateCompatibilityChange>;
    riskLevel: 'low' | 'medium' | 'high' | 'critical';
    repairRequired: boolean;
};

export type TemplateCompatibilityChange = {
    field: string;
    severity: 'info' | 'warning' | 'error' | 'critical';
    baseline?: unknown;
    candidate?: unknown;
    message: string;
    repairHint?: string;
};

export type TemplateVersionRef = {
    templateId: number;
    templateName: string;
    versionId: number | null;
    version: number | null;
};

export type AgentTemplateVersionTestResult = {
    status: 'queued';
    versionId: number;
};

export type AgentTemplateVersionCompareResult = {
    status: 'queued' | 'no_dataset';
    templateId: number;
    versionIds: Array<number>;
    samples: number;
    compareJobId: string | null;
    expectedRuns: number;
};

export type AgentTemplateVersionCompareRequest = {
    versionIds: Array<number>;
    samples?: number;
};

export type AgentTemplateVersionComparison = {
    compareJobId: string;
    complete: boolean;
    expected: number;
    completed: number;
    versions: Array<{
        versionId: number;
        avgScore: number;
        sampleCount: number;
        verdicts: {
            [key: string]: number;
        };
        rank: number;
        deltaFromBest: number;
    }>;
};

export type TemplateUpgradePreflightResult = {
    diff: TemplateCompatibilityDiff;
    baseline: TemplateVersionRef;
    candidate: TemplateVersionRef;
    affectedConsumers: Array<TemplateConsumerImpact>;
    repairDrafts: Array<TemplateRepairDraft>;
};

export type TemplateConsumerImpact = {
    kind: 'workflow_step' | 'task' | 'workforce_member' | 'daemon_assignment' | 'marketplace_listing' | 'entity_relationship';
    id: string;
    name: string;
    parentId?: string;
    parentName?: string;
    url?: string;
    pinnedVersionId?: number | null;
    pinnedVersionStatus: 'matches_baseline' | 'pinned_other' | 'unpinned';
    metadata?: {
        [key: string]: unknown;
    };
};

export type TemplateRepairDraft = {
    outcome: 'workflow_version' | 'task' | 'workforce_route' | 'log_only';
    label: string;
    consumerKind?: 'workflow_step' | 'task' | 'workforce_member' | 'daemon_assignment' | 'marketplace_listing' | 'entity_relationship';
    consumerId?: string;
    payload: {
        [key: string]: unknown;
    };
    instructions: string;
};

export type TemplateUpgradePreflightRequest = {
    baselineTemplateId: number;
    candidateTemplateId: number;
    baselineVersionId?: number | null;
    candidateVersionId?: number | null;
    rollbackVersionId?: number | null;
};

export type TemplateUpgradeProposalResult = {
    candidate: UpgradeCandidate;
    evaluationRun: TemplateUpgradeEvaluation | null;
    actionRequestId: number | null;
    created: boolean;
    duplicateSuppressed: boolean;
    evidence: TemplateUpgradeEvidence;
};

export type UpgradeCandidate = {
    id: number;
    organizationId: number;
    entityType: 'agent_template' | 'workflow' | 'task' | 'workforce_member' | 'daemon' | 'strategy' | 'tool' | 'skill' | 'code_artifact' | 'custom';
    baselineEntityId: number;
    baselineVersionId: number | null;
    candidateEntityId: number;
    candidateVersionId: number | null;
    rollbackVersionId: number | null;
    status: 'discovered' | 'evaluating' | 'needs_repair' | 'ready_for_review' | 'proposed' | 'approved' | 'rejected' | 'superseded';
    summary: string | null;
    idempotencyKey: string;
    proposedByType: string;
    proposedById: string | null;
    proposedByName: string | null;
    baselineScores: TemplateUpgradeScoreSet;
    candidateScores: TemplateUpgradeScoreSet;
    comparison: TemplateUpgradeComparison;
    affectedConsumers: Array<{
        [key: string]: unknown;
    }>;
    compatibilityDiff: {
        [key: string]: unknown;
    };
    repairDrafts: Array<{
        [key: string]: unknown;
    }>;
    evidenceLinks: Array<{
        label: string;
        url?: string;
        type?: string;
        entityId?: string;
    }>;
    metadata: {
        [key: string]: unknown;
    };
    proposalInterventionId: number | null;
    createdBy: number | null;
    proposedAt: string | string | null;
    createdAt: string | string;
    updatedAt: string | string;
};

export type TemplateUpgradeScoreSet = {
    quality?: number;
    safety?: number;
    contract?: number;
    cost?: number;
    latency?: number;
    overall?: number;
    [key: string]: unknown;
};

export type TemplateUpgradeComparison = {
    decision: 'better' | 'worse' | 'neutral' | 'inconclusive';
    confidence: number;
    regressionRisks?: Array<string>;
    changedBehavior?: Array<string>;
    rationale?: string;
    [key: string]: unknown;
};

export type TemplateUpgradeEvidence = {
    templateUpgrade: {
        summary: string;
        candidateId?: number;
        evaluationRunId?: number | null;
        baseline: TemplateVersionRef;
        candidate: TemplateVersionRef;
        tests: {
            total: number;
            passed: number;
            failed: number;
            status: string;
        };
        scores: {
            baseline: TemplateUpgradeScoreSet;
            candidate: TemplateUpgradeScoreSet;
            deltas: {
                [key: string]: unknown;
            };
        };
        affectedConsumers: Array<TemplateConsumerImpact>;
        compatibilityDiff: TemplateCompatibilityDiff;
        repairDrafts: Array<TemplateRepairDraft>;
        decisionContext: {
            recommendation: string;
            comparison: TemplateUpgradeComparison;
            rollbackVersionId: number | null;
            highRisk: boolean;
        };
        evidenceLinks: Array<{
            label: string;
            url?: string;
            type?: string;
            entityId?: string;
        }>;
    };
};

export type TemplateUpgradeProposalRequest = TemplateUpgradePreflightRequest & {
    summary?: string;
    idempotencyKey?: string;
    proposedByType?: string;
    proposedById?: string;
    proposedByName?: string;
    baselineScores?: TemplateUpgradeScoreSet;
    candidateScores?: TemplateUpgradeScoreSet;
    comparison?: TemplateUpgradeComparison;
    replayInputs?: Array<{
        [key: string]: unknown;
    }>;
    testResults?: Array<{
        [key: string]: unknown;
    }>;
    scoreDeltas?: {
        [key: string]: unknown;
    };
    traces?: Array<{
        [key: string]: unknown;
    }>;
    costSummary?: {
        [key: string]: unknown;
    };
    latencySummary?: {
        [key: string]: unknown;
    };
    safetyFindings?: Array<{
        [key: string]: unknown;
    }>;
    evidenceLinks?: Array<{
        label: string;
        url?: string;
        type?: string;
        entityId?: string;
    }>;
    metadata?: {
        [key: string]: unknown;
    };
};

export type AgentTemplateSummary = {
    id: number;
    slug: string;
    title: string;
    departmentId: string | null;
    goal: string | null;
    tools: Array<string> | null;
    workflowCount?: number;
    spawnPolicy: SpawnPolicyConfig | null;
    platform?: string | null;
    source?: string | null;
    status?: string | null;
    disabled: boolean;
    disabledReason?: string | null;
    version?: number | null;
    avgQualityScore?: string | null;
    sourceRepoUrl?: string | null;
    sourceFilePath?: string | null;
};

export type AgentTemplate = {
    id: number;
    slug: string;
    title: string;
    description?: string | null;
    departmentId: string | null;
    goal: string | null;
    backstory: string | null;
    tools: Array<string> | null;
    workflows?: Array<AgentTemplateWorkflowSummary>;
    spawnPolicy: SpawnPolicyConfig | null;
    instructions: string | null;
    constraints?: string | null;
    permissionTier: string | null;
    platform?: string | null;
    category?: string | null;
    tags?: Array<string> | null;
    source?: string | null;
    status?: string | null;
    autoUpgrade?: boolean | null;
    version?: number | null;
    avgQualityScore?: string | null;
    usageCount?: number | null;
    lastUsedAt?: string | string | null;
    sourceRepoUrl?: string | null;
    sourceFilePath?: string | null;
    taskProfile?: TaskProfileConfig | null;
    variables?: Array<TemplateVariableConfig> | null;
    defaultSubscriptions?: Array<string>;
    heartbeatConfig?: HeartbeatConfig | null;
    applicability?: Array<TemplateApplicability>;
    compatibility?: TemplateCompatibility;
    examples?: Array<TemplateExample>;
    evaluationHistory?: TemplateEvaluationHistory;
    versionHistory?: Array<TemplateVersionHistoryItem>;
    usageImpact?: TemplateUsageImpact;
    disabled: boolean;
    disabledReason?: string | null;
    disableModelInvocation?: boolean | null;
    routingRules?: Array<{
        match: string;
        targetTemplate: string;
        context?: string;
    }> | null;
};

export type AgentTemplateWorkflowSummary = {
    id: number;
    name: string;
    status: string;
};

export type TemplateApplicability = {
    source: 'conversation' | 'task' | 'workflow_step' | 'workforce' | 'daemon' | 'subagent';
    status: 'supported' | 'review_required' | 'not_recommended';
    reason: string;
};

export type TemplateCompatibility = {
    modelCapabilities: Array<string>;
    minContextWindow: number | null;
    latencyClass: string | null;
    preferredCost: string | null;
    permissionTier: string | null;
    tools: Array<{
        name: string;
        required: boolean;
    }>;
    mcpConnections: Array<string>;
    outputContracts: Array<{
        source: string;
        status: string;
        description: string;
    }>;
};

export type TemplateExample = {
    title: string;
    input: {
        [key: string]: unknown;
    };
    expectedOutput: Array<string>;
};

export type TemplateEvaluationHistory = {
    promptEvaluations: Array<{
        id: number;
        workflowRunId: number | null;
        stepId: string | null;
        agentStatus: string | null;
        contractPassed: boolean | null;
        promptScore: string | null;
        humanVerdict: string | null;
        createdAt: string | string;
    }>;
    qualitySnapshots: Array<{
        id: number;
        qualityScore: string | null;
        executionCount: number | null;
        successRate: string | null;
        avgDurationMs: number | null;
        avgConfidence: string | null;
        periodStart: string | string;
        periodEnd: string | string;
    }>;
    evaluationRuns: Array<{
        id: number;
        datasetId: number;
        datasetName: string;
        status: string | null;
        totalCases: number | null;
        passedCases: number | null;
        failedCases: number | null;
        avgScore: string | null;
        completedAt: string | string | null;
    }>;
};

export type TemplateVersionHistoryItem = {
    id: number;
    version: number;
    status: string;
    changeSummary: string | null;
    systemPromptHash: string | null;
    promotedAt: string | string | null;
    retiredAt: string | string | null;
    createdAt: string | string;
};

export type TemplateUsageImpact = {
    workflowCount: number;
    workflowStepCount: number;
    taskCount: number;
    workforceAgentCount: number;
    daemonCount: number;
    activeWorkflowCount: number;
    activeDaemonCount: number;
};

export type AgentTemplateCreate = AgentTemplateUpsert & {
    slug: string;
};

export type AgentTemplateUpsert = {
    title?: string;
    departmentId?: string;
    goal?: string;
    backstory?: string;
    instructions?: string;
    constraints?: string;
    tools?: Array<string>;
    permissionTier?: string;
    platform?: string | null;
    variables?: Array<{
        name: string;
        description: string;
        default?: string;
    }>;
    spawnPolicy?: {
        type: string;
        min?: number;
        max?: number;
    };
    defaultSubscriptions?: Array<string>;
    heartbeatConfig?: {
        every_n_calls?: number;
        every_t_seconds?: number;
    };
    autoUpgrade?: boolean;
    disableModelInvocation?: boolean;
    routingRules?: Array<{
        match: string;
        targetTemplate: string;
        context?: string;
    }>;
};

export type SetAgentTemplateStatusResult = {
    success: boolean;
    templateSlug: string;
    status: string;
    dependentWorkflows: Array<AgentTemplateWorkflowSummary>;
};

export type AgentTemplateStatusUpdate = {
    status: 'active' | 'disabled';
    reason?: string;
};

export type SetAgentTemplateAutoUpgradeResult = {
    success: boolean;
    templateSlug: string;
    autoUpgrade: boolean;
};

export type AgentTemplateAutoUpgradeUpdate = {
    autoUpgrade: boolean;
};

export type SkillSummary = {
    id: number;
    slug: string;
    name: string;
    description: string | null;
    moduleId: string;
    enabled: boolean;
    category: string;
    invocationDescription: string | null;
    priority: number;
    contentHash: string | null;
    securityStatus: string;
    qualityStatus: string;
    versionId: number;
    version: number;
    versionState: 'draft' | 'locked';
    usedByCount: number;
};

export type Skill = SkillSummary & {
    body: string;
    frontmatter: {
        name?: string;
        description?: string;
        version?: string;
        author?: string;
        platforms?: Array<string>;
        applicableWhen?: {
            [key: string]: unknown;
        };
        tags?: Array<string>;
        [key: string]: unknown;
    };
    examples: Array<{
        title?: string;
        input?: unknown;
        expected?: unknown;
        notes?: string;
    }>;
    verificationCriteria: Array<string>;
    risks: Array<string>;
};

export type SkillLibrary = {
    id: number;
    name: string;
    description: string | null;
    sourceType: 'git' | 'local' | 'url';
    repoUrl: string | null;
    localPath: string | null;
    branch: string | null;
    subdirectory: string | null;
    enabled: boolean;
    autoSync: boolean;
    skillCount: number | null;
    lastSyncedAt: string | null;
    lastError: string | null;
    createdAt: string;
    updatedAt: string;
};

export type SkillLibraryCreate = {
    name: string;
    description?: string;
    sourceType: 'git' | 'local' | 'url';
    repoUrl?: string;
    localPath?: string;
    branch?: string;
    subdirectory?: string;
    enabled?: boolean;
    autoSync?: boolean;
};

export type SkillLibraryActionResult = {
    message: string;
};

export type SkillLibrarySyncResult = {
    skillCount: number;
    skills: Array<{
        name: string;
        description: string;
    }>;
    message: string;
};

export type SkillLibraryTool = {
    id: number;
    name: string;
    description: string | null;
    category: string | null;
    status: string | null;
    qualityScore: string | null;
    executionCount: number | null;
};

export type ToolSummary = {
    name: string;
    version: string | null;
    description: string | null;
    category: string | null;
    inputSchema?: unknown;
    outputSchema?: unknown;
    deprecated: boolean;
    templateCount: number;
    source: string | null;
    sourceLabel: string;
    sourceReference: string | null;
    supportedModels: Array<string>;
};

export type Tool = {
    entityId: number;
    name: string;
    version: string | null;
    description: string | null;
    category: string | null;
    inputSchema?: unknown;
    outputSchema?: unknown;
    deprecated: boolean;
    templates: Array<ToolDependentTemplate>;
    source: string | null;
    sourceLabel: string;
    sourceReference: string | null;
    supportedModels: Array<string>;
};

export type ToolDependentTemplate = {
    id: number;
    slug: string;
    name: string;
};

export type ToolUpsert = {
    version?: string;
    description?: string;
    category?: string;
    inputSchema?: unknown;
    outputSchema?: unknown;
};

export type ToolCreate = ToolUpsert & {
    name: string;
};

export type SetToolStatusResult = {
    success: boolean;
    name: string;
    status: string;
    dependentWorkflows: Array<AgentTemplateWorkflowSummary>;
};

export type ToolStatusUpdate = {
    status: 'approved' | 'deprecated';
};

export type WorkflowSummary = {
    id: string;
    name: string;
    version: string;
    description?: string;
    stepCount: number;
    schedule?: string | null;
    hasHumanGate: boolean;
};

export type WorkflowTriggerResult = {
    runId: string;
    workflowId: string;
    status: string;
    startedAt: string;
};

export type WorkflowTriggerRequest = {
    context?: {
        [key: string]: unknown;
    };
};

export type WorkflowRun = {
    id: string;
    workflowId: string;
    status: string;
    triggeredBy: string;
    startedAt: string;
    completedAt?: string | null;
    totalCostUSD?: number;
    error?: string | null;
};

export type WorkflowRunDebuggerPayload = {
    detail: 'summary' | 'debug' | 'full';
    generatedAt: string;
    run: {
        id: string;
        engineRunId: string | null;
        workflowId: string | null;
        workflowName: string;
        workflowVersion: number | null;
        status: string;
        triggeredBy: string;
        startedAt: string | null;
        completedAt: string | null;
        durationMs: number | null;
        totalCostUsd: string;
        error: string | null;
        versionEvidence?: {
            definitionUpdatedAt: string | null;
            templateId: string | null;
        };
    };
    graph: {
        steps: Array<{
            id: string;
            stepId: string;
            stepName: string;
            kind: string;
            status: string;
            startedAt: string | null;
            completedAt: string | null;
            durationMs: number | null;
            retryCount: number;
            template: {
                id: string;
                name: string | null;
                slug: string | null;
                permissionTier: string | null;
            } | null;
            verification: {
                status: string;
                issueCount: number;
                issues?: unknown;
            };
            contract: {
                compatible: boolean;
                addedFields: Array<string>;
                removedFields: Array<string>;
                changedTypes: Array<{
                    path: string;
                    contractType: string;
                    observedType: string;
                }>;
            };
            outputSummary: string;
            evidence?: unknown;
            fullIo?: {
                input?: unknown;
                output?: unknown;
                fullText: string | null;
            };
            error: string | null;
            fanOut?: {
                counts: {
                    pending: number;
                    running: number;
                    succeeded: number;
                    failed: number;
                    skipped: number;
                    retried: number;
                };
                units: Array<{
                    unitId: string;
                    unitIndex: number;
                    unitType: string;
                    personaSlug: string;
                    status: 'pending' | 'running' | 'succeeded' | 'failed' | 'skipped';
                    retryCount: number;
                    startedAt: string | null;
                    completedAt: string | null;
                    errorSummary: string | null;
                    confidence: number | null;
                    evidenceRefs: Array<string>;
                    agentRunId: string | null;
                    output: {
                        summary: string | null;
                        nextActions: Array<string>;
                        artifactRefs: Array<string>;
                    } | null;
                }>;
            };
            sourceBundles?: Array<{
                bundleId: string;
                unitId: string;
                agentRunId: string | null;
                fileCount: number;
                totalBytes: number;
                digestPrefix: string;
            }>;
            dynamicFanOut?: {
                considered: boolean;
                applied: boolean;
                mode: 'off' | 'auto' | 'on';
                decision: 'execute_single' | 'execute_fanout' | 'blocked' | 'fallback_single';
                reasonCodes: Array<string>;
                effectiveLimits: {
                    maxUnits: number;
                    maxConcurrency: number;
                };
                policySlug: string | null;
                unitCount: number | null;
            };
        }>;
        statusCounts: {
            [key: string]: number;
        };
    };
    timeline: Array<{
        at: string;
        type: string;
        kind: string;
        label: string;
        severity: string;
        stepId: string | null;
        refId: string | null;
    }>;
    linkedEntities: {
        projects: Array<{
            id: string;
            name: string;
            slug: string | null;
            status: string;
        }>;
        tasks: Array<{
            id: string;
            title: string;
            status: string;
            originLabel: string | null;
            assigneeLabel: string | null;
            projectId: string | null;
        }>;
        workforce: Array<{
            id: string;
            name: string;
            department: string | null;
            status: string;
        }>;
        templates: Array<{
            id: string;
            name: string | null;
            slug: string | null;
            permissionTier: string | null;
        }>;
        artifacts: Array<{
            id: string;
            title: string | null;
            kind: string;
            scope: string;
            subjectType: string | null;
        }>;
        decisions: Array<{
            id: string;
            title: string;
            decisionType: string;
            conversationId: string;
            approvedAt: string | null;
            rationale: string | null;
        }>;
    };
    actionAvailability: {
        [key: string]: boolean;
    };
    llmCalls?: {
        totalCount: number;
        cappedAt: number;
        calls: Array<{
            id: string;
            kind: 'llm_call';
            provider: string;
            model: string;
            modelVersion: string | null;
            stepId: string | null;
            agentId: string | null;
            temperature: string | null;
            maxTokens: number | null;
            promptTokens: number | null;
            completionTokens: number | null;
            costUsd: string | null;
            finishReason: string | null;
            durationMs: number | null;
            startedAt: string | null;
            traceId: string | null;
            systemPromptRef: string | null;
            messagesRef: string | null;
            responseRef: string | null;
        }>;
    };
    audit: Array<{
        id: string;
        eventType: string;
        severity: string;
        stepId: string | null;
        createdAt: string | null;
        payload?: unknown;
    }>;
};

export type WorkflowRunActionResult = {
    action: string;
    status: string;
    message?: string;
    engineRunId?: string;
    run?: {
        id: string;
        status: string;
        workflowId: string;
    };
    taskDraftUrl?: string;
    interventionUrl?: string;
    intervention?: {
        id: number;
        organizationId: number;
        type: 'fix' | 'improve' | 'investigate' | 'decision' | 'contract_repair' | 'version_change' | 'worker_unavailable' | 'policy_blocker';
        severity: 'info' | 'warning' | 'error' | 'critical';
        status: 'open' | 'reviewing' | 'routed' | 'resolved' | 'rejected';
        requestedOutcome: 'task' | 'decision' | 'workflow_draft' | 'workflow_version' | 'workforce_route' | 'workstream_link' | 'log_only' | null;
        title: string;
        reason: string;
        instructions: string | null;
        sourceType: 'workflow' | 'workflow_run' | 'workflow_step' | 'task' | 'template' | 'project' | 'artifact' | 'workforce' | 'daemon' | 'catalog_item' | 'catalog_version' | 'decision';
        sourceId: string;
        sourceName: string;
        sourceUrl: string | null;
        assignedToType: string | null;
        assignedToId: string | null;
        assignedToName: string | null;
        failureTaxonomy: 'execution_failure' | 'contract_failure' | 'quality_failure' | 'policy_failure' | null;
        evidence: {
            [key: string]: unknown;
        } | null;
        recommendedOutcomes: Array<{
            [key: string]: unknown;
        }>;
        linkedOutcomes: Array<{
            [key: string]: unknown;
        }>;
        resolvedAt: string | string | null;
        resolvedBy: number | null;
        createdBy: number;
        createdAt: string | string;
        updatedAt: string | string;
    };
};

export type WorkflowRunActionRequest = {
    action: 'cancel' | 'retry_run' | 'retry_failed_step' | 'retry_from_step' | 'create_task_from_failure' | 'route_to_workforce' | 'escalate_decision' | 'repair_contract' | 'fork_version';
    stepId?: string;
    reason?: string;
    instructions?: string;
    outcomePayload?: {
        [key: string]: unknown;
    };
};

export type LlmCallOutlierList = {
    data: Array<LlmCallOutlierRow>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type LlmCallOutlierRow = {
    id: string;
    provider: string;
    model: string;
    modelVersion: string | null;
    runId: string | null;
    stepId: string | null;
    agentId: string | null;
    promptTokens: number | null;
    completionTokens: number | null;
    costUsd: string | null;
    durationMs: number | null;
    finishReason: string | null;
    startedAt: string | null;
    traceId: string | null;
};

export type RunHealthAggregates = {
    window: {
        since: string;
        until: string;
    };
    llmCalls: {
        totalCalls: number;
        errorCalls: number;
        nonStopFinishes: number;
        avgDurationMs: number | null;
        p50DurationMs: number | null;
        totalCostUsd: string;
        avgCostUsd: string | null;
    };
};

export type ModelSummary = {
    id: number;
    slug: string;
    provider: string;
    modelName: string;
    displayName: string;
    description: string | null;
    strengths: Array<string>;
    costTier: string;
    maxTokens: number;
    maxOutputTokens: number | null;
    maxConcurrentRequests: number | null;
    supportsVision: boolean;
    supportsTools: boolean;
    supportsStructuredOutput: boolean;
    supportsReasoning: boolean;
    supportsStreaming: boolean;
    supportsMultimodal: boolean;
    supportsRealtime: boolean;
    supportsProviderTools: boolean;
    supportsPromptCaching: boolean;
    supportsFiles: boolean;
    supportsWebSearch: boolean;
    dataRetentionTier: string;
    capabilities: {
        [key: string]: unknown;
    };
    enabled: boolean;
    findingCount: number;
};

export type Model = ModelSummary & {
    findings: Array<{
        id: number;
        severity: string;
        title: string;
        description: string | null;
        recommendation: string | null;
        reviewStatus: string | null;
        createdAt: string;
    }>;
};

export type ModelRuntimePolicy = {
    id: number;
    organizationId: number | null;
    scope: 'system' | 'org';
    slug: string;
    name: string;
    description: string | null;
    version: number;
    status: 'draft' | 'active' | 'archived';
    purpose: 'interactive' | 'background' | 'evaluation' | 'daemon' | 'workflow' | 'debug' | 'bulk';
    riskTier: 'low' | 'medium' | 'high' | 'privileged';
    latencyClass: 'realtime' | 'interactive' | 'batch';
    costTier: 'free' | 'low' | 'medium' | 'high';
    permissionTier: 'observer' | 'contributor' | 'operator';
    tags: Array<string>;
    models: Array<RuntimePolicyModel>;
    fallbackPolicyId: number | null;
    thinking: 'model_default' | 'on' | 'off';
    wallClockTimeoutMs: number;
    providerRequestTimeoutMs: number;
    idleTimeoutMs: number | null;
    maxInputTokens: number | null;
    maxOutputTokens: number;
    maxSystemPromptChars: number | null;
    maxConcurrentRequests: number | null;
    maxToolCalls: number;
    maxTurns: number;
    retryMax: number;
    retryBackoffMs: number;
    retryBackoffMultiplier: number;
    retryJitter: boolean;
    spendCapUsd: number | null;
    permissionMode: 'provider_default' | 'read_only' | 'workspace_write' | 'full_auto' | 'bypass_permissions';
    allowedProviderTools: Array<string>;
    streamingEnabled: boolean;
    sessionMode: 'provider_default' | 'stateless' | 'reuse_session';
    promptCachingEnabled: boolean;
    providerExtensions: {
        claudeCli?: {
            [key: string]: unknown;
        };
        geminiCli?: {
            [key: string]: unknown;
        };
        codexCli?: {
            [key: string]: unknown;
        };
        anthropic?: {
            [key: string]: unknown;
        };
        openai?: {
            [key: string]: unknown;
        };
        ollama?: {
            [key: string]: unknown;
        };
        custom?: {
            [key: string]: unknown;
        };
        [key: string]: unknown;
    };
    createdAt: string;
    updatedAt: string;
};

export type RuntimePolicyModel = {
    id: number;
    slug: string;
    displayName: string;
    provider: string;
    enabled: boolean;
};

export type ModelRuntimePolicyResolveRequest = {
    surface: 'conversation' | 'workforce' | 'workflow' | 'analysis' | 'evaluation' | 'judge' | 'codegen' | 'system' | 'research';
    policyId?: number;
};

export type ModelRuntimePolicyUpsert = {
    scope?: 'system' | 'org';
    slug: string;
    name: string;
    description?: string | null;
    status?: 'draft' | 'active' | 'archived';
    purpose: 'interactive' | 'background' | 'evaluation' | 'daemon' | 'workflow' | 'debug' | 'bulk';
    riskTier: 'low' | 'medium' | 'high' | 'privileged';
    latencyClass: 'realtime' | 'interactive' | 'batch';
    costTier: 'free' | 'low' | 'medium' | 'high';
    permissionTier: 'observer' | 'contributor' | 'operator';
    tags?: Array<string>;
    modelIds: Array<number>;
    fallbackPolicyId?: number | null;
    thinking?: 'model_default' | 'on' | 'off';
    wallClockTimeoutMs: number;
    providerRequestTimeoutMs: number;
    idleTimeoutMs?: number | null;
    maxInputTokens?: number | null;
    maxOutputTokens: number;
    maxSystemPromptChars?: number | null;
    maxConcurrentRequests?: number | null;
    maxToolCalls: number;
    maxTurns: number;
    retryMax: number;
    retryBackoffMs: number;
    retryBackoffMultiplier: number;
    retryJitter?: boolean;
    spendCapUsd?: number | null;
    permissionMode: 'provider_default' | 'read_only' | 'workspace_write' | 'full_auto' | 'bypass_permissions';
    allowedProviderTools?: Array<string>;
    streamingEnabled?: boolean;
    sessionMode: 'provider_default' | 'stateless' | 'reuse_session';
    promptCachingEnabled?: boolean;
    providerExtensions?: {
        claudeCli?: {
            [key: string]: unknown;
        };
        geminiCli?: {
            [key: string]: unknown;
        };
        codexCli?: {
            [key: string]: unknown;
        };
        anthropic?: {
            [key: string]: unknown;
        };
        openai?: {
            [key: string]: unknown;
        };
        ollama?: {
            [key: string]: unknown;
        };
        custom?: {
            [key: string]: unknown;
        };
        [key: string]: unknown;
    };
};

export type RuntimePolicyOption = {
    id: number;
    name: string;
    description: string | null;
    isDefault: boolean;
    models: Array<RuntimePolicyModel>;
};

export type RuntimePolicySurfaceRuleWrite = {
    defaultPolicyId: number;
    allowedPolicyIds: Array<number>;
};

export type DynamicFanOutPolicy = {
    id: number | null;
    organizationId: number | null;
    scope: 'system' | 'org' | 'workflow' | 'step';
    slug: string;
    name: string;
    description: string | null;
    version: number;
    status: 'draft' | 'active' | 'archived';
    workflowMatch: string | null;
    stepMatch: string | null;
    mode: 'off' | 'auto' | 'on';
    fallbackBehavior: 'fallback_single' | 'block';
    maxUnits: number;
    maxConcurrency: number;
    personaResolutionMode: 'inherit_step' | 'same_department' | 'explicit_allowlist';
    toolResolutionMode: 'none' | 'inherit_step_tools' | 'explicit_allowlist';
    allowedPersonaSlugs: Array<string>;
    allowedPersonaClasses: Array<string>;
    allowedToolClasses: Array<string>;
    sourcePassthroughEnabled: boolean;
    createdAt: string;
    updatedAt: string;
};

export type DynamicFanOutPolicyResolveRequest = {
    workflowName?: string;
    stepName?: string;
    templateSlug?: string;
};

export type DynamicFanOutPolicyUpsert = {
    scope?: 'system' | 'org' | 'workflow' | 'step';
    slug: string;
    name: string;
    description?: string | null;
    version?: number;
    status?: 'draft' | 'active' | 'archived';
    workflowMatch?: string | null;
    stepMatch?: string | null;
    mode: 'off' | 'auto' | 'on';
    fallbackBehavior: 'fallback_single' | 'block';
    maxUnits: number;
    maxConcurrency: number;
    personaResolutionMode?: 'inherit_step' | 'same_department' | 'explicit_allowlist';
    toolResolutionMode?: 'none' | 'inherit_step_tools' | 'explicit_allowlist';
    allowedPersonaSlugs?: Array<string>;
    allowedPersonaClasses?: Array<string>;
    allowedToolClasses?: Array<string>;
    sourcePassthroughEnabled?: boolean;
};

export type AiWorkerMcpResponse = {
    jsonrpc: '2.0';
    id: string | number;
    result: {
        _meta?: {
            progressToken?: string | number;
            'io.modelcontextprotocol/related-task'?: {
                taskId: string;
            };
            [key: string]: unknown;
        };
        [key: string]: unknown;
    };
} | {
    jsonrpc: '2.0';
    id?: string | number;
    error: {
        code: number;
        message: string;
        data?: unknown;
    };
};

export type AiWorkerMcpRequest = {
    jsonrpc: '2.0';
    id: string | number;
    method: string;
    params?: {
        _meta?: {
            progressToken?: string | number;
            'io.modelcontextprotocol/related-task'?: {
                taskId: string;
            };
            [key: string]: unknown;
        };
        [key: string]: unknown;
    };
} | {
    jsonrpc: '2.0';
    method: string;
    params?: {
        _meta?: {
            progressToken?: string | number;
            'io.modelcontextprotocol/related-task'?: {
                taskId: string;
            };
            [key: string]: unknown;
        };
        [key: string]: unknown;
    };
};

export type HostMetricsExportResult = {
    partialSuccess?: {
        [key: string]: unknown;
    };
};

export type Snapshot = {
    id: number;
    runId: number;
    templateId: number;
    stepId: string;
    stepName: string | null;
    status: string;
    output?: unknown;
    fullText: string | null;
    outputJson?: unknown;
    outputParts?: unknown;
    input?: unknown;
    model: string | null;
    costUsd: string | null;
    durationMs: number | null;
    label: string | null;
    pinned: boolean | null;
    contractHash: string | null;
    createdAt: string;
};

export type OrgRequiredError = {
    error: {
        code: 'ORG_REQUIRED';
        message: string;
    };
};

export type SnapshotCreate = {
    templateId: number;
    stepId: string;
    stepName?: string;
    output?: unknown;
    fullText?: string;
    outputParts?: unknown;
    input?: unknown;
    model?: string;
    costUsd?: string;
    durationMs?: number;
    label?: string;
    contract?: unknown;
};

export type SnapshotPurgeRequest = {
    templateId: number;
    olderThanDays?: number;
    unpinnedOnly?: boolean;
};

export type SnapshotList = {
    data: Array<Snapshot>;
    paging: {
        hasMore: boolean;
    };
};

export type SnapshotUpdate = {
    label?: string;
    pinned?: boolean;
};

export type SnapshotActionResult = {
    message: string;
};

export type EvaluationDataset = {
    id: number;
    name: string;
    description: string | null;
    targetType: 'agent_template' | 'skill' | 'workflow' | 'tool' | 'model';
    targetId: string;
    organizationId: number;
    createdBy: number | null;
    caseCount: number | null;
    createdAt: string | string;
    updatedAt: string | string;
};

export type EvaluationDatasetCreate = {
    name: string;
    description?: string;
    targetType: 'agent_template' | 'skill' | 'workflow' | 'tool';
    targetId: string;
};

export type EvaluationActionResult = {
    message: string;
};

export type EvaluationCase = {
    id: number;
    datasetId: number;
    name: string;
    input?: unknown;
    expected?: unknown;
    tags: Array<string> | null;
    metadata: {
        [key: string]: unknown;
    } | null;
    createdAt: string | string;
    updatedAt: string | string;
};

export type EvaluationCaseCreate = {
    name: string;
    input: {
        [key: string]: unknown;
    };
    expected?: {
        [key: string]: unknown;
    };
    tags?: Array<string>;
    metadata?: {
        [key: string]: unknown;
    };
};

export type EvaluationDatasetRunResult = {
    status: 'queued';
    datasetId: number;
};

export type EvaluationRun = {
    id: number;
    datasetId: number;
    organizationId: number;
    status: 'pending' | 'running' | 'completed' | 'failed' | 'skipped' | null;
    totalCases: number | null;
    passedCases: number | null;
    failedCases: number | null;
    avgScore: string | null;
    results?: unknown;
    startedAt: string | string | null;
    completedAt: string | string | null;
    createdAt: string | string;
    updatedAt: string | string;
};

export type ReasoningEvaluationList = {
    data: Array<ReasoningEvaluation>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        schedule: string;
        rules: Array<ReasoningEvaluationRule>;
    };
};

export type ReasoningEvaluation = {
    id: number;
    title: string;
    createdAt: string;
    intelSourceId: number | null;
    handle: string | null;
    versionId: string | null;
    split: string | null;
    ranAt: string | null;
    policyId: string | null;
    surface: string | null;
    report: {
        asked: number;
        answered: number;
        failed: number;
        directionFidelity: {
            n: number;
            matches: number;
            share: number | null;
            majorityDirection?: string | null;
            majorityShare?: number | null;
        };
        noCallShare: number | null;
        readingF1: {
            n: number;
            mean: number | null;
        };
        kindF1: {
            n: number;
            mean: number | null;
        };
        outcome: {
            n: number;
            personaHitRate: number | null;
            baselineHitRate: number | null;
            personaMeanSignedReturn?: number | null;
            baselineMeanSignedReturn?: number | null;
            signedReturnN?: number;
        };
        factValidity: {
            relied: number;
            contradicted: number;
            share: number | null;
        };
        unfoundQuotes: number;
    } | null;
    checks: Array<ReasoningEvaluationCheck>;
    failedChecks: number;
};

export type ReasoningEvaluationCheck = {
    key: 'answered' | 'direction' | 'noCall' | 'readings' | 'facts' | 'quotes' | 'outcome';
    label: string;
    rule: string;
    reason: string;
    value: number | null;
    n: number;
    status: 'pass' | 'fail' | 'insufficient' | 'reported';
};

export type ReasoningEvaluationRule = {
    key: 'answered' | 'direction' | 'noCall' | 'readings' | 'facts' | 'quotes' | 'outcome';
    label: string;
    rule: string;
    reason: string;
    minN: number;
};

export type ReasoningCallSummary = {
    sources: Array<ReasoningCallFunnel>;
    meta: {
        serverTime: string;
    };
};

export type ReasoningCallFunnel = {
    intelSourceId: number;
    handle: string;
    itemsAnalysed: number;
    itemsFailed: number;
    itemsByContract: {
        [key: string]: number;
    };
    calls: number;
    callsDismissed: number;
    callsWithoutSubject: number;
    callsHorizonStated: number;
    callsConditional: number;
    reasons: number;
    reasonsStated: number;
    reasonsCued: number;
    reasonChecks: {
        [key: string]: number;
    };
    outcomes: {
        [key: string]: number;
    };
    undecided: Array<{
        reason: string;
        count: number;
    }>;
};

export type ReasoningPrincipleSummary = {
    sources: Array<ReasoningPrincipleFunnel>;
    meta: {
        serverTime: string;
    };
};

export type ReasoningPrincipleFunnel = {
    intelSourceId: number;
    handle: string;
    principles: number;
    typed: number;
    byClass: {
        [key: string]: number;
    };
    rejected: number;
    untyped: number;
    held: number;
    checked: number;
    checks: {
        [key: string]: number;
    };
    inSample: {
        [key: string]: number;
    };
    outOfSample: {
        [key: string]: number;
    };
    module: {
        routed: number;
        hypotheses: {
            [key: string]: number;
        };
        validated: {
            calls: {
                held: number;
                broke: number;
            };
            principles: {
                held: number;
                broke: number;
            };
        };
        drafted: number;
        backtested: number;
        admitted: number;
    } | null;
};

export type EvaluationTemplateWithVersions = EvaluationTemplate & {
    versions: Array<EvaluationTemplateVersion>;
};

export type EvaluationTemplateCreate = {
    templateRef: string;
    name: string;
    description?: string | null;
    subjectKind: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
    templateKind?: 'leaf' | 'group';
    visibility?: 'private' | 'org';
    spec: {
        [key: string]: unknown;
    };
};

export type EvaluationTemplateList = {
    data: Array<EvaluationTemplate>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type EvaluationTemplateUpdate = {
    name?: string;
    description?: string | null;
    status?: 'draft' | 'active' | 'deprecated' | 'retired';
    visibility?: 'private' | 'org';
    templateKind?: 'leaf' | 'group';
};

export type EvaluationTemplateVersionCreate = {
    spec: {
        [key: string]: unknown;
    };
};

export type EvaluationAssignment = {
    id: number;
    templateVersionId: number;
};

export type EvaluationTemplateApplyRequest = {
    subjectKind: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
    subjectId: string;
    targetTransition: string;
};

export type SubjectEvaluations = {
    subjectKind: string;
    subjectId: string;
    assignments: Array<SubjectEvaluationRow>;
};

export type SubjectEvaluationRow = {
    assignment: EvaluationAssignment & {
        targetTransition: string;
    };
    template: EvaluationTemplate | null;
    version: EvaluationTemplateVersion | null;
    promotionVerdict: {
        hasPlan: boolean;
        satisfied: boolean;
        reason: 'no_active_assignments' | 'not_evaluated' | 'unsatisfied' | 'satisfied';
        gateId?: number;
        satisfaction?: {
            satisfied: boolean;
            requiredKeys: Array<string>;
            passedKeys: Array<string>;
            missingKeys: Array<string>;
            failingKeys: Array<string>;
        };
    };
};

export type CatalogSourceList = {
    data: Array<CatalogSourceWithIntegrity>;
};

export type CatalogSourceWithIntegrity = CatalogSource & {
    fragments: Array<CatalogSourceFragmentSummary>;
    integrity: {
        total: number;
        blocked: number;
        warnings: number;
        latest: CatalogIntegrityCheckSummary | null;
    };
};

export type CatalogErrorResult = {
    error: {
        code: string;
        message: string;
    };
};

export type CatalogCandidateList = {
    data: Array<CatalogCandidateListItem>;
};

export type CatalogCandidateListItem = CatalogCandidate & {
    source: CatalogSource | null;
    discoveredByDaemonName: string | null;
    discoveredRunStatus: string | null;
    discoveredRunStartedAt: string | string | null;
    discoveredRunCompletedAt: string | string | null;
    evidenceLinks: {
        sourceId: number;
        sourceUrl: string | null;
        sourceRepoUrl: string | null;
        sourcePath: string | null;
        sourceRef: string | null;
        canonicalKey: string | null;
        sourceFragment: CatalogSourceFragmentSummary | null;
    };
    integrityChecks: Array<CatalogIntegrityCheckSummary>;
};

export type CatalogCandidateDecisionResult = {
    data: CatalogCandidateDecision;
};

export type CatalogCandidateDecision = CatalogCandidate & {
    source?: CatalogSource | null;
    reviewStages: Array<{
        daemonId: number | null;
        daemonName: string;
        eventType: string | null;
        status: string;
        queueStatus: string | null;
        lastError: string | null;
        updatedAt: string | string | null;
        runIds: Array<number>;
        findings: Array<CatalogFindingSummary>;
    }>;
    evidenceLinks: {
        sourceId: number;
        sourceUrl: string | null;
        sourceRepoUrl: string | null;
        sourcePath: string | null;
        sourceRef: string | null;
        canonicalKey: string | null;
        sourceFragment: CatalogSourceFragmentSummary | null;
        discoveryRun: CatalogRunLink | null;
        securityReviewRun: CatalogRunLink | null;
        qualityReviewRun: CatalogRunLink | null;
    };
    integrityChecks: Array<CatalogIntegrityCheckSummary>;
    discoveryFinding: CatalogFindingSummary | null;
};

export type CatalogReviewQueueList = {
    data: Array<CatalogReviewQueueItem>;
};

export type CatalogReviewQueueItem = {
    id: number;
    organizationId: number;
    eventType: string;
    candidateId: number;
    targetEntityId: number | null;
    targetDaemonName: string;
    sourceEntityId: number | null;
    sourceDaemonRunId: number | null;
    sourceFindingId: number | null;
    sourceReportId: number | null;
    payload: {
        [key: string]: unknown;
    };
    status: 'pending' | 'locked' | 'blocked' | 'completed' | 'failed' | 'cancelled';
    priority: number;
    attempts: number;
    maxAttempts: number;
    availableAt: string | string;
    lockedAt: string | string | null;
    lockOwner: string | null;
    completedAt: string | string | null;
    failedAt: string | string | null;
    lastError: string | null;
    idempotencyKey: string;
    createdAt: string | string;
    updatedAt: string | string;
    targetDaemonId: number | null;
    targetDaemonEnabled: boolean | null;
    targetDaemonStatus: string | null;
    candidateTargetType: string | null;
    candidateStatus: string | null;
    candidateSummary: string | null;
    blocker: {
        type: string;
        title: string;
        message: string;
        action: string;
    } | null;
};

export type CatalogProcessResult = {
    data: {
        processed: boolean;
    };
};

export type CatalogAdoptionResult = {
    data: CatalogAdoption;
};

export type CatalogAdoption = {
    consumerKey: string;
    consumerType: 'daemon_skill' | 'template_skill' | 'entity_acquisition' | 'entity_relationship_source' | 'entity_relationship_target';
    consumerId: number;
    ownerType: 'daemon' | 'template' | 'entity_acquisition' | 'entity_relationship';
    ownerId: number;
    label: string;
    targetType: string;
    targetId: number;
    adoptedVersionId: number | null;
    adoptedVersion: number | null;
    latestVersionId: number | null;
    latestVersion: number | null;
    latestMaterializedTargetId: number | null;
    previousVersionId: number | null;
    previousVersion: number | null;
    previousMaterializedTargetId: number | null;
    status: 'current' | 'stale' | 'adoptable' | 'untracked';
    canUpgrade: boolean;
    canRevert: boolean;
    proposalRequired?: boolean;
    proposalInterventionId?: number | null;
};

export type CatalogRequeueResult = {
    data: {
        requeued: number;
    };
};

export type CatalogItemVersionList = {
    data: Array<CatalogItemVersionWithAdoption>;
};

export type CatalogItemVersionWithAdoption = CatalogItemVersion & {
    adoption: {
        isLatest: boolean;
        latestVersion: number;
        latestVersionId: number;
        newerVersionAvailable: boolean;
    };
};

export type CatalogItemVersion = {
    id: number;
    organizationId: number;
    moduleId: string;
    sourceId: number;
    candidateId: number | null;
    targetType: string;
    targetId: number;
    version: number;
    versionHash: string;
    payloadSnapshot: {
        [key: string]: unknown;
    };
    diffSummary: string | null;
    status: 'active' | 'superseded' | 'restored';
    restoredFromVersionId: number | null;
    supersededByVersionId: number | null;
    promotedBy: string | null;
    promotedAt: string | string;
    metadata: {
        [key: string]: unknown;
    };
    createdAt: string | string;
    updatedAt: string | string;
};

export type CatalogAdoptionList = {
    data: Array<CatalogAdoption>;
};

export type CatalogPromotionResponse = {
    data: CatalogPromotionResult;
};

export type CatalogPromotionResult = {
    candidate: CatalogCandidate | null;
    version: CatalogItemVersion;
    materializedTarget: {
        type: string;
        id: number;
        version: number;
        label: string;
    };
    warnings: Array<string>;
    marketplaceEligible: boolean;
};

export type CatalogCandidateResult = {
    data: CatalogCandidate;
};

export type CatalogRetryReviewResult = {
    data: {
        processed: boolean;
        queueItemId: number;
        targetDaemonName: string;
    };
};

export type WorkflowOutputWidgetDefinition = {
    id: number;
    name: string;
    type: string;
    description?: string | null;
    defaultConfig: {
        [key: string]: unknown;
    };
    category?: string | null;
    isSystem?: boolean;
    createdAt: string;
    updatedAt: string;
};

export type WorkflowOutputWidgetDefinitionCreate = {
    name: string;
    type: string;
    description?: string;
    defaultConfig: {
        [key: string]: unknown;
    };
    category?: string;
};

export type DashboardWidgetLegacy = {
    id: number;
    dashboardId: number;
    widgetDefinitionId: number;
    position: number;
    config?: {
        [key: string]: unknown;
    } | null;
    createdAt: string;
    updatedAt: string;
    definition?: WorkflowOutputWidgetDefinition;
};

export type PinWidgetBody = {
    dashboardId: number;
    widgetDefinitionId: number;
    position: number;
    config?: {
        [key: string]: unknown;
    };
};

export type UpdateDashboardWidgetBody = {
    position?: number;
    config?: {
        [key: string]: unknown;
    };
};

export type OutputPartKind = {
    name: string;
    displayName: string;
    icon: string;
};

export type OutputMetricPoint = {
    time: string;
    value: number;
    metadata?: {
        [key: string]: unknown;
    } | null;
};

export type PortTypeColorMap = {
    [key: string]: string;
};

export type PortCompatibilityResult = {
    compatible: boolean;
    reason?: string;
};

export type PortTypeDefinition = {
    name: string;
    displayName?: string;
    category: 'primitive' | 'collection' | 'json' | 'domain';
    color: string;
    description?: string;
    compatibleWith?: Array<string>;
};

export type WorkflowDocument = {
    id: number;
    workflowDefinitionId: string | null;
    fileName: string;
    mimeType: string;
    sizeBytes?: number;
    uploadedBy: string;
    createdAt: string;
};

export type WorkflowDocumentUpload = {
    fileName: string;
    content: string;
    mimeType: string;
};

export type RuntimePolicyAssignment = {
    runtimePolicyId: number;
};

export type InstructionExportResult = {
    content: string;
    fileName: string;
};

export type InstructionExportBody = {
    workflowId?: string;
    stepIds?: Array<string>;
    scope: 'full' | 'selected' | 'blank';
    includeRoles?: boolean;
    includeOutputSchemas?: boolean;
};

export type WorkflowDefinitionList = {
    data: Array<WorkflowDefinitionSummary>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        has_more: boolean;
        next: string | null;
    };
    meta: {
        server_time: string;
        total?: number;
    };
};

export type WorkflowDefinitionSummary = {
    id: number;
    name: string;
    description: string | null;
    category: string | null;
    version: number | null;
    status: 'draft' | 'active' | 'archived' | null;
    schedule?: unknown;
    humanGates?: unknown;
    tags: Array<string> | null;
    organizationId: number;
    moduleId: string;
    runtimePolicyId: number | null;
    sourceConversationId: number | null;
    sourceMessageId: number | null;
    initialSeed?: unknown;
    createdAt: string | string;
    updatedAt: string | string;
    stepCount: number;
};

export type WorkflowTemplateResult = {
    template: WorkflowDefinition;
};

export type WorkflowDefinition = {
    id: number;
    name: string;
    description: string | null;
    category: string | null;
    version: number | null;
    status: 'draft' | 'active' | 'archived' | null;
    schedule?: unknown;
    humanGates?: unknown;
    tags: Array<string> | null;
    organizationId: number;
    moduleId: string;
    runtimePolicyId: number | null;
    sourceConversationId: number | null;
    sourceMessageId: number | null;
    initialSeed?: unknown;
    createdAt: string | string;
    updatedAt: string | string;
    steps: Array<WorkflowStep>;
    edges?: Array<WorkflowEdge>;
    [key: string]: unknown;
};

export type WorkflowStep = {
    id: number;
    versionId: number;
    name: string;
    description: string | null;
    templateId: number | null;
    subWorkflowDefinitionId: number | null;
    executionMode: 'sequential' | 'parallel' | 'conditional' | 'race' | null;
    parallelGroup: string | null;
    order: number;
    optional: boolean;
    timeoutMs: number | null;
    retryMax: number | null;
    retryBackoffMs: number | null;
    retryBackoffMultiplier: string | null;
    systemPromptOverride: string | null;
    additionalInstructions: string | null;
    toolSelectionMode: 'manual' | 'auto' | 'hybrid' | null;
    outputConfig?: unknown;
    fanOutConfig?: {
        planSourceStep: string;
        allowedPersonaSlugs: Array<string>;
        allowedPersonaClasses?: Array<string>;
        allowedToolClasses?: Array<string>;
        maxUnits: number;
        maxConcurrency: number;
        unitTimeoutMs?: number;
        defaultFailurePolicy?: 'fail_all' | 'allow_partial';
        defaultRetryMax?: number;
    } | null;
    safeOutputs?: {
        [key: string]: SafeOutputConstraint;
    } | null;
    outputPortType: string | null;
    outputContract?: unknown;
    inputContracts?: unknown;
    contractNegotiationStatus: 'pending' | 'negotiated' | 'overridden' | 'error' | null;
    contractVersion: number | null;
    conditionField: string | null;
    conditionOperator: string | null;
    conditionValue?: unknown;
    approvalStatus: 'pending' | 'approved' | 'rejected' | null;
    approvedBy: number | null;
    templateSlug?: string | null;
    templateName?: string | null;
    pinnedTools?: Array<string>;
    createdAt: string | string;
    updatedAt: string | string;
};

export type WorkflowEdge = {
    id: number;
    versionId: number;
    sourceStepId: number;
    targetStepId: number;
    kind: 'data' | 'control';
    label: {
        text: string;
    } | null;
    createdAt: string | string;
    updatedAt: string | string;
};

export type WorkflowCreate = {
    name: string;
    description?: string;
    category?: string;
    schedule?: {
        [key: string]: unknown;
    } | null;
    humanGates?: Array<unknown>;
    tags?: Array<string>;
    steps?: Array<WorkflowStepPayload>;
    runtimePolicyId?: number;
};

export type WorkflowStepPayload = {
    fanOutConfig?: {
        planSourceStep: string;
        allowedPersonaSlugs: Array<string>;
        allowedPersonaClasses?: Array<string>;
        allowedToolClasses?: Array<string>;
        maxUnits: number;
        maxConcurrency: number;
        unitTimeoutMs?: number;
        defaultFailurePolicy?: 'fail_all' | 'allow_partial';
        defaultRetryMax?: number;
    } | null;
    [key: string]: unknown;
};

export type WorkflowValidationResult = {
    valid: boolean;
    warnings: Array<string>;
    errors: Array<string>;
};

export type StepReorderBody = {
    stepIds: Array<number>;
};

export type WorkflowStepInput = {
    versionId?: number;
    name?: string;
    description?: string | null;
    templateId?: number | null;
    subWorkflowDefinitionId?: number | null;
    executionMode?: 'sequential' | 'parallel' | 'conditional' | 'race' | null;
    parallelGroup?: string | null;
    order?: number;
    optional?: boolean;
    timeoutMs?: number | null;
    retryMax?: number | null;
    retryBackoffMs?: number | null;
    retryBackoffMultiplier?: string | null;
    systemPromptOverride?: string | null;
    additionalInstructions?: string | null;
    toolSelectionMode?: 'manual' | 'auto' | 'hybrid' | null;
    outputConfig?: unknown;
    fanOutConfig?: {
        planSourceStep: string;
        allowedPersonaSlugs: Array<string>;
        allowedPersonaClasses?: Array<string>;
        allowedToolClasses?: Array<string>;
        maxUnits: number;
        maxConcurrency: number;
        unitTimeoutMs?: number;
        defaultFailurePolicy?: 'fail_all' | 'allow_partial';
        defaultRetryMax?: number;
    } | null;
    safeOutputs?: {
        [key: string]: SafeOutputConstraint;
    } | null;
    outputPortType?: string | null;
    outputContract?: unknown;
    inputContracts?: unknown;
    contractNegotiationStatus?: 'pending' | 'negotiated' | 'overridden' | 'error' | null;
    contractVersion?: number | null;
    conditionField?: string | null;
    conditionOperator?: string | null;
    conditionValue?: unknown;
    approvalStatus?: 'pending' | 'approved' | 'rejected' | null;
    approvedBy?: number | null;
    templateSlug?: string | null;
    templateName?: string | null;
    pinnedTools?: Array<string>;
};

export type WorkflowScheduleBody = {
    [key: string]: unknown;
} | null;

export type WorkflowExecutionObservationList = {
    workflowId: number;
    generatedAt: string;
    steps: Array<WorkflowExecutionObservation>;
};

export type WorkflowExecutionObservation = {
    stepId: string;
    stepName: string;
    observedSchema: JsonObject | null;
    contractSchema: JsonObject | null;
    diff: WorkflowExecutionObservationSchemaDiff;
    sampleCount: number;
    latestRunId: number | null;
    latestCompletedAt: string | null;
    verification: {
        passed: number;
        failed: number;
        warning: number;
        unknown: number;
        issues: Array<unknown>;
    };
    samples: Array<{
        runId: number;
        completedAt: string | null;
        status: string;
        preview?: unknown;
    }>;
};

export type WorkflowExecutionObservationSchemaDiff = {
    compatible: boolean;
    addedFields: Array<string>;
    removedFields: Array<string>;
    changedTypes: Array<{
        path: string;
        contractType: string;
        observedType: string;
    }>;
};

export type WorkflowRunList = {
    data: Array<WorkflowRunSummary>;
};

export type WorkflowRunSummary = {
    id: number;
    templateId: number | null;
    status: string;
    triggeredBy: string | null;
    startedAt: string | string | null;
    completedAt: string | string | null;
    error: string | null;
    totalCostUsd: string | null;
    trajectoryScore: string | null;
    organizationId: number;
    teamId: number | null;
};

export type WorkflowDefinitionTriggerResult = {
    run: {
        id: string;
        status: 'pending';
        workflowId: string;
    };
};

export type WorkflowVersionList = {
    versions: Array<WorkflowVersion>;
};

export type WorkflowVersion = {
    id: number;
    workflowDefinitionId: number;
    version: number;
    category: string | null;
    state: 'draft' | 'locked';
    humanGates?: unknown;
    tags: Array<string> | null;
    steps?: unknown;
    changeSummary?: string | null;
    createdAt: string | string;
    [key: string]: unknown;
};

export type WorkflowVersionResult = {
    version: WorkflowVersion;
};

export type WorkflowVersionDiffResult = {
    version_a: number;
    version_b: number;
    changes: Array<WorkflowVersionDiffChange>;
};

export type WorkflowVersionDiffChange = {
    stepId: string;
    stepName: string;
    type: 'added' | 'removed' | 'modified';
    before?: unknown;
    after?: unknown;
};

export type WorkflowGraphSave = {
    steps: Array<{
        clientId: number;
        diagramPosition?: {
            x: number;
            y: number;
        } | null;
        name?: string;
        description?: string | null;
        executionMode?: 'sequential' | 'parallel' | 'conditional' | 'race' | null;
        optional?: boolean;
    }>;
    edges: Array<{
        sourceClientId: number;
        targetClientId: number;
        kind?: 'data' | 'control';
        label?: {
            text: string;
        } | null;
    }>;
    version?: number;
};

export type WorkflowCloseSummary = {
    summary: string | null;
};

export type WorkflowUpdate = {
    name?: string;
    description?: string;
    category?: string;
    status?: string;
    schedule?: {
        [key: string]: unknown;
    } | null;
    humanGates?: Array<unknown>;
    tags?: Array<string>;
    version?: number;
    steps?: Array<WorkflowStepPayload>;
};

export type WorkflowInstanceList = {
    data: Array<WorkflowInstance>;
};

export type WorkflowInstance = {
    id: number;
    definitionId: number;
    organizationId: number;
    teamId: number | null;
    name: string | null;
    lifecycleStatus: 'active' | 'paused' | 'blocked' | 'archived';
    status: string | null;
    triggeredBy: string | null;
    triggerType: string | null;
    schedule: WorkflowScheduleConfig | null;
    scheduleEnabled: boolean;
    nextRunAt: string | null;
    lastRunAt: string | null;
    runCount: number;
    consecutiveFailures: number;
    blockedUntil: string | null;
    lastErrorCode: string | null;
    input: {
        [key: string]: unknown;
    };
    parameters: {
        [key: string]: unknown;
    };
    createdAt: string;
    updatedAt: string;
};

export type WorkflowInstanceResult = {
    instance: WorkflowInstance;
};

export type WorkflowInstanceCreate = {
    definitionId: number;
    name?: string;
    teamId?: number | null;
    lifecycleStatus?: 'active' | 'paused' | 'blocked' | 'archived';
    schedule?: WorkflowScheduleConfig | null;
    scheduleEnabled?: boolean;
    input?: {
        [key: string]: unknown;
    };
    parameters?: {
        [key: string]: unknown;
    };
};

export type WorkflowInstanceUpdate = {
    name?: string;
    lifecycleStatus?: 'active' | 'paused' | 'blocked' | 'archived';
    schedule?: WorkflowScheduleConfig | null;
    scheduleEnabled?: boolean;
    input?: {
        [key: string]: unknown;
    };
    parameters?: {
        [key: string]: unknown;
    };
};

export type WorkflowInstanceTriggerResult = {
    run: {
        id: string;
        status: string;
        workflowId: string;
    };
};

export type WorkflowDefinitionSearchResult = {
    id: number;
    name: string;
    description: string | null;
    category: string | null;
    status: string | null;
    tags: Array<string> | null;
    visibility: string | null;
    installCount: number | null;
    score: number;
    matchType: 'keyword' | 'semantic' | 'hybrid';
    source: 'local' | 'builtin' | 'marketplace';
};

export type Organization = {
    id: number;
    name: string;
    slug: string;
    logoUrl: string | null;
    plan: string;
    status: string;
    createdAt: string;
    features: {
        [key: string]: boolean;
    };
    modules: Array<string>;
    memberCount: number;
    teamCount: number;
    ownerName: string | null;
    ownerId: number | null;
};

export type OrganizationCreate = {
    name: string;
    slug: string;
    plan?: 'free' | 'standard' | 'enterprise';
    founderEmail: string;
    founderRole?: 'org_admin';
};

export type UserOrg = {
    id: number;
    name: string;
    slug: string;
    plan: string | null;
    role: string;
    settings?: {
        [key: string]: unknown;
    } | null;
};

export type OrganizationUpdate = {
    name?: string;
    logoUrl?: string | null;
    plan?: 'free' | 'standard' | 'enterprise';
    status?: 'active' | 'suspended' | 'archived';
    features?: {
        [key: string]: boolean;
    };
    modules?: Array<string>;
};

export type OrgMemberSummary = {
    id: number;
    email: string;
    username: string | null;
    fullName: string | null;
    status: string;
    isActive: boolean | null;
    createdAt: string | string;
};

export type OrgMember = {
    userId: number;
    role?: string | null;
    joinedAt?: string | string;
};

export type AddMemberBody = {
    userId: number;
    role?: string;
};

export type RegulatoryAckResult = {
    ok: boolean;
    remainingAcks: Array<{
        kind: string;
        documentRef: string;
    }>;
};

export type RegulatoryAckRequest = {
    kind: 'baa' | 'dpa' | 'fedramp' | 'state_coverage';
    documentVersion: string;
    expiresAt?: string;
};

export type Team = {
    id: number;
    organizationId: number;
    name: string;
    brief?: string | null;
    createdAt: string | string;
};

export type UserOrgTeam = {
    id: number;
    name: string;
    description: string | null;
    role: 'lead' | 'contributor';
};

export type TeamCreate = {
    name: string;
    description?: string;
};

export type TeamMember = {
    memberType: 'user' | 'agent_instance' | 'workforce_member';
    memberId: number;
    role?: 'lead' | 'contributor' | null;
    joinedAt?: string | string | null;
};

export type InvitationCreate = {
    email: string;
    role: 'org_admin' | 'trader' | 'analyst' | 'viewer';
    message?: string;
};

export type IntelAnalysisTemplateList = {
    data: Array<IntelAnalysisTemplate>;
};

export type IntelAnalysisTemplate = {
    id: number;
    slug: string | null;
    name: string | null;
    description: string | null;
    organizationId: number;
    moduleId: string;
    scope: 'system' | 'org';
    status: 'active' | 'disabled';
    disabledReason: string | null;
    loggingEnabled: boolean;
    createdAt: string | string;
    updatedAt: string | string;
    version: number;
    activeVersionId: number | null;
    extendsId: number | null;
    goal: string | null;
    backstory: string | null;
    instructions: string | null;
    constraints: string | null;
    variables: Array<{
        name: string;
        description: string;
        default?: string;
    }> | null;
    permissionTier: string | null;
    spawnPolicy: {
        type: string;
        min?: number;
        max?: number;
    } | null;
    taskProfile: {
        primaryCapability: 'reasoning' | 'vision' | 'fast' | 'code' | 'long-context';
        secondaryCapabilities: Array<'reasoning' | 'vision' | 'fast' | 'code' | 'long-context'>;
        latencyClass: 'realtime' | 'interactive' | 'batch';
        requiresToolCalling: boolean;
        requiresVision: boolean;
        preferredCost: 'free' | 'low' | 'medium' | 'high';
        minContextWindow: number;
        requiresStructuredOutput: boolean;
    } | null;
    disableModelInvocation: boolean | null;
    routingRules: Array<{
        match: string;
        targetTemplate: string;
        context?: string;
    }> | null;
    maxToolIterations: number | null;
    defaultSubscriptions: Array<string>;
    heartbeatConfig: {
        every_n_calls?: number;
        every_t_seconds?: number;
    } | null;
    departmentId: string | null;
    platform: 'twitter' | 'youtube' | 'substack' | 'podcast' | 'telegram' | 'discord' | 'tradingview' | 'reddit' | 'medium' | 'wallet' | 'smart_money' | 'exchange_wallet' | 'dao_treasury' | 'lending' | 'dex' | 'perp_dex' | 'options' | 'yield_aggregator' | 'governance' | 'etf' | 'hedge_fund' | 'market_maker' | 'vc' | 'research_firm' | 'analytics' | 'data_aggregator' | 'cex' | 'prediction_market' | 'news_wire' | 'rss' | null;
    category: 'social' | 'on_chain' | 'institutional' | 'research' | 'defi' | 'market_infra' | null;
    tags: Array<string> | null;
    source: string | null;
    sourceRepoUrl: string | null;
    sourceFilePath: string | null;
    autoUpgrade: boolean;
    embedding: Array<number> | null;
};

export type IntelAnalysisTemplateCreate = {
    platform: string;
    category: string;
    name: string;
    description?: string;
    promptTemplate: string;
    suggestedRoleId?: string;
    tags?: Array<string>;
};

export type IntelAnalysisTemplateUpdate = {
    platform?: string;
    category?: string;
    name?: string;
    description?: string;
    promptTemplate?: string;
    suggestedRoleId?: string;
    tags?: Array<string>;
};

export type IntelAnalysisTemplateActionResult = {
    message: string;
};

export type IntelPlatformList = {
    data: Array<IntelPlatform>;
};

export type IntelPlatform = {
    slug: string;
    name: string;
    category: 'social' | 'on_chain' | 'institutional' | 'research' | 'defi' | 'market_infra';
    config: {
        api_key_env?: string;
        rate_limit_per_minute?: number;
        rate_limit_per_day?: number;
        batch_size?: number;
        requires_auth?: boolean;
        base_url?: string;
        [key: string]: unknown;
    } | null;
    description: string | null;
    icon: string | null;
    enabled: boolean;
    harvestSchedule: string | null;
    defaultLookbackDays: number | null;
    createdAt: string | string;
    updatedAt: string | string;
};

export type IntelPlatformCreate = {
    slug: string;
    name: string;
    category: 'social' | 'on_chain' | 'defi' | 'institutional' | 'research' | 'market_infra';
    config?: {
        api_key_env?: string;
        rate_limit_per_minute?: number;
        rate_limit_per_day?: number;
        batch_size?: number;
        requires_auth?: boolean;
        base_url?: string;
        [key: string]: unknown;
    };
    description?: string;
};

export type IntelPlatformTestResult = {
    platform: string;
    status: 'connected' | 'partial' | 'disconnected';
    hasApiKey: boolean;
    apiKeyEnv: string | null;
    fetcherAvailable: boolean;
};

export type IntelPlatformUsageResult = {
    platform: string;
    dailyQuota: number | null;
    rateLimitPerMinute: number | null;
    usage: {
        daily_used: number;
        minute_used: number;
    };
};

export type IntelPlatformUpdate = {
    config?: {
        api_key_env?: string;
        rate_limit_per_minute?: number;
        rate_limit_per_day?: number;
        batch_size?: number;
        requires_auth?: boolean;
        base_url?: string;
        [key: string]: unknown;
    };
    enabled?: boolean;
    harvestSchedule?: string;
    defaultLookbackDays?: number;
};

export type IntelSource = {
    id: number;
    platform: string;
    handle: string;
    name: string | null;
    description: string | null;
    category: 'social' | 'on_chain' | 'institutional' | 'research' | 'defi' | 'market_infra';
    active: boolean;
    externalId: string | null;
    chain: string | null;
    profileUrl: string | null;
    avatarUrl: string | null;
    dataSourceUrl: string | null;
    organizationId: number;
    moduleId: string;
    private: boolean;
    typeMetadata: {
        type: 'social';
        channel_id?: string;
        uploads_playlist_id?: string;
        subscriber_count?: number;
        video_count?: number;
        avg_views?: number;
        country?: string;
        topics?: Array<string>;
        verified?: boolean;
        bio?: string;
        karma?: number;
        subreddit?: string;
        member_count?: number;
        reputation?: number;
        ideas_count?: number;
    } | {
        type: 'on_chain';
        address: string;
        chain: string;
        label?: string;
        tags?: Array<string>;
        estimated_balance_usd?: number;
        tx_count?: number;
        first_seen_at?: string;
        last_tx_at?: string;
        tracked_tokens?: Array<string>;
        pnl_usd?: number;
    } | {
        type: 'institutional';
        legal_name?: string;
        ticker?: string;
        aum_usd?: number;
        headquarters?: string;
        sec_cik?: string;
        filing_type?: string;
        fund_type?: string;
        known_wallets?: Array<string>;
        inception_date?: string;
    } | {
        type: 'research';
        specialization?: Array<string>;
        data_products?: Array<string>;
        api_endpoint?: string;
        report_frequency?: string;
        free_tier?: boolean;
        coverage?: Array<string>;
    } | {
        type: 'defi';
        protocol_name: string;
        tvl_usd?: number;
        contract_addresses?: {
            [key: string]: string;
        };
        governance_token?: string;
        launch_date?: string;
        audited?: boolean;
        supported_chains?: Array<string>;
    } | {
        type: 'market_infra';
        exchange_name?: string;
        market_type?: string;
        api_endpoint?: string;
        supported_assets?: Array<string>;
        data_types?: Array<string>;
    } | null;
    discoveredAt: string;
    discoveredVia: number | null;
    discoveryDepth: number | null;
    followerCount: number | null;
    followingCount: number | null;
    postCount: number | null;
    engagementRate: string | null;
    influenceScore: string | null;
    signalQuality: string | null;
    contentDepth: string | null;
    botProbability: string | null;
    overallScore: string | null;
    primaryTopics: Array<string> | null;
    totalSignals: number | null;
    correctSignals: number | null;
    totalContentHarvested: number | null;
    totalStrategiesExtracted: number | null;
    strategiesApproved: number | null;
    approvalStatus: 'seeded' | 'approved' | 'candidate' | 'rejected';
    seed: boolean;
    lastContentAt: string | null;
    lastAnalyzedAt: string | null;
    metadata: {
        [key: string]: unknown;
    } | null;
    consent?: {
        kind: 'none' | 'creator_licence' | 'platform_permission';
        reference: string | null;
        recordedBy: number | null;
        recordedAt: string;
        line: string;
    } | null;
    createdAt: string;
    updatedAt: string;
};

export type IntelSourceDiscoverRequest = {
    platform: string;
    url?: string;
    handle?: string;
};

export type IntelSourceError = {
    error: {
        code: string;
        message: string;
    };
};

export type IntelSourceCreate = {
    platform: string;
    handle: string;
    name?: string;
    description?: string;
    category?: 'social' | 'on_chain' | 'institutional' | 'research' | 'defi' | 'market_infra';
    externalId?: string;
    chain?: string;
    typeMetadata?: {
        type: 'social';
        channel_id?: string;
        uploads_playlist_id?: string;
        subscriber_count?: number;
        video_count?: number;
        avg_views?: number;
        country?: string;
        topics?: Array<string>;
        verified?: boolean;
        bio?: string;
        karma?: number;
        subreddit?: string;
        member_count?: number;
        reputation?: number;
        ideas_count?: number;
    } | {
        type: 'on_chain';
        address: string;
        chain: string;
        label?: string;
        tags?: Array<string>;
        estimated_balance_usd?: number;
        tx_count?: number;
        first_seen_at?: string;
        last_tx_at?: string;
        tracked_tokens?: Array<string>;
        pnl_usd?: number;
    } | {
        type: 'institutional';
        legal_name?: string;
        ticker?: string;
        aum_usd?: number;
        headquarters?: string;
        sec_cik?: string;
        filing_type?: string;
        fund_type?: string;
        known_wallets?: Array<string>;
        inception_date?: string;
    } | {
        type: 'research';
        specialization?: Array<string>;
        data_products?: Array<string>;
        api_endpoint?: string;
        report_frequency?: string;
        free_tier?: boolean;
        coverage?: Array<string>;
    } | {
        type: 'defi';
        protocol_name: string;
        tvl_usd?: number;
        contract_addresses?: {
            [key: string]: string;
        };
        governance_token?: string;
        launch_date?: string;
        audited?: boolean;
        supported_chains?: Array<string>;
    } | {
        type: 'market_infra';
        exchange_name?: string;
        market_type?: string;
        api_endpoint?: string;
        supported_assets?: Array<string>;
        data_types?: Array<string>;
    };
    profileUrl?: string;
    avatarUrl?: string;
};

export type IntelSourceBatchFetchResult = {
    queued: Array<{
        intelSourceId: number;
        requestId: string;
    }>;
    skipped: Array<{
        intelSourceId: number;
        reason: string;
    }>;
};

export type IntelSourceBatchFetchRequest = {
    ids: Array<number>;
};

export type IntelSourceUpdate = {
    platform?: string;
    handle?: string;
    name?: string;
    description?: string;
    category?: 'social' | 'on_chain' | 'institutional' | 'research' | 'defi' | 'market_infra';
    externalId?: string;
    chain?: string;
    typeMetadata?: {
        type: 'social';
        channel_id?: string;
        uploads_playlist_id?: string;
        subscriber_count?: number;
        video_count?: number;
        avg_views?: number;
        country?: string;
        topics?: Array<string>;
        verified?: boolean;
        bio?: string;
        karma?: number;
        subreddit?: string;
        member_count?: number;
        reputation?: number;
        ideas_count?: number;
    } | {
        type: 'on_chain';
        address: string;
        chain: string;
        label?: string;
        tags?: Array<string>;
        estimated_balance_usd?: number;
        tx_count?: number;
        first_seen_at?: string;
        last_tx_at?: string;
        tracked_tokens?: Array<string>;
        pnl_usd?: number;
    } | {
        type: 'institutional';
        legal_name?: string;
        ticker?: string;
        aum_usd?: number;
        headquarters?: string;
        sec_cik?: string;
        filing_type?: string;
        fund_type?: string;
        known_wallets?: Array<string>;
        inception_date?: string;
    } | {
        type: 'research';
        specialization?: Array<string>;
        data_products?: Array<string>;
        api_endpoint?: string;
        report_frequency?: string;
        free_tier?: boolean;
        coverage?: Array<string>;
    } | {
        type: 'defi';
        protocol_name: string;
        tvl_usd?: number;
        contract_addresses?: {
            [key: string]: string;
        };
        governance_token?: string;
        launch_date?: string;
        audited?: boolean;
        supported_chains?: Array<string>;
    } | {
        type: 'market_infra';
        exchange_name?: string;
        market_type?: string;
        api_endpoint?: string;
        supported_assets?: Array<string>;
        data_types?: Array<string>;
    };
    profileUrl?: string;
    avatarUrl?: string;
    active?: boolean;
};

export type IntelSourceSubscriptionEnqueueResult = {
    queued: true;
    requestId: string;
};

export type IntelSourceFetchRequest = {
    limit?: number;
    since?: string;
};

export type IntelSourceData = {
    id: number;
    intelSourceId: number;
    workflowRunId: number | null;
    dataType: 'content' | 'event' | 'metric' | 'signal_raw';
    platform: string;
    asset: string | null;
    occurredAt: string | string;
    title: string | null;
    body: string | null;
    payload: {
        type: 'content';
        transcript_segments?: Array<{
            text: string;
            start: number;
            end: number;
        }>;
        chart_images?: Array<{
            url: string;
            analyzed?: boolean;
        }>;
        duration_seconds?: number;
        media_analysis?: {
            status: 'completed' | 'retrying' | 'fell_back_to_excerpt';
            attempts?: number;
            model?: string;
            framesUsed?: Array<number>;
            reportArtifactId?: number;
            analysisTemplateId?: number | null;
            analyzedAt?: string;
            errorCode?: string;
            errorMessage?: string;
            failedAt?: string;
        };
        [key: string]: unknown;
    } | {
        type: 'event';
        tx_hash?: string;
        from?: string;
        to?: string;
        value_usd?: number;
        token_symbol?: string;
        method_id?: string;
        function_name?: string;
        chain?: string;
        [key: string]: unknown;
    } | {
        type: 'metric';
        metric_name: string;
        value: number;
        previous_value?: number;
        change_pct?: number;
        protocol?: string;
        chain?: string;
        [key: string]: unknown;
    } | {
        type: 'signal_raw';
        direction?: string;
        target_price?: number;
        stop_price?: number;
        timeframe?: string;
        [key: string]: unknown;
    };
    sourceUrl: string | null;
    externalId: string | null;
    contentHash: string | null;
    provenance: {
        fetchRunId?: number;
        workerId: string;
        capability: string;
        tool: 'youtube_api' | 'youtube_rss' | 'innertube_timedtext' | 'ytdlp_subs' | 'ytdlp_media_stt' | 'ytdlp_metadata' | 'x_api' | 'rss_feed' | 'discord_bot' | 'web_page' | 'github_api' | 'ytdlp_search' | 'legacy_server_fetcher' | 'content_harvester';
        fetchedAt: string;
        metadataTool?: 'youtube_api' | 'ytdlp_metadata';
        egressIdentity?: string;
    } | null;
    transcriptLanguage: string | null;
    transcriptKind: 'manual' | 'auto' | null;
    transcriptSource: 'timedtext' | 'package' | 'ytdlp' | 'stt' | null;
    engagement: {
        [key: string]: number;
    } | null;
    sentiment: 'bullish' | 'bearish' | 'neutral' | null;
    confidence: string | null;
    mentionedAssets: Array<string> | null;
    mentionedIndicators: Array<string> | null;
    embedding: Array<number> | null;
    processed: boolean;
    processingStatus: 'pending' | 'harvested' | 'extracting' | 'extracted' | 'completed' | 'failed' | 'actionable' | 'explored' | 'dismissed' | 'style_extracted' | 'style_skipped';
    createdAt: string | string;
};

export type IntelSourceSubscription = {
    id: number;
    intelSourceId: number;
    organizationId: number;
    status: 'active' | 'paused' | 'blocked' | 'pending_approval' | 'archived';
    cadence: string;
    nextDueAt: string | null;
    priority: number;
    consecutiveFailures: number;
    blockedUntil: string | null;
    lastErrorCode: string | null;
    transcriptEnabled: boolean;
    expansionEnabled: boolean;
    maxDepth: number;
    autoFollow: boolean;
    rawCaptureEnabled: boolean;
    dailyQuotaBudget: number | null;
    monthlyReadBudget: number | null;
    readsSpentMonth: number;
    lastRunAt: string | null;
    requestedByUserId: number | null;
    createdAt: string;
    updatedAt: string;
};

export type IntelSourceSubscriptionCreate = {
    cadence?: '@hourly' | '@4h' | '@daily' | '@weekly';
    transcriptEnabled?: boolean;
    expansionEnabled?: boolean;
    maxDepth?: number;
    autoFollow?: boolean;
    priority?: number;
    rawCaptureEnabled?: boolean;
    dailyQuotaBudget?: number | null;
    monthlyReadBudget?: number | null;
};

export type IntelSourceApprovalResult = {
    source: {
        id: number;
        approvalStatus: 'seeded' | 'approved' | 'candidate' | 'rejected';
        platform: string;
        handle: string;
        name: string | null;
    };
    workflowInstanceId: number | null;
};

export type IntelSourceApprovalRequest = {
    action: 'approve' | 'reject';
    createMonitor?: boolean;
    cadence?: '@hourly' | '@4h' | '@daily' | '@weekly';
    transcriptEnabled?: boolean;
};

export type IntelSourceConsent = {
    intelSourceId: number;
    consent: {
        kind: 'none' | 'creator_licence' | 'platform_permission';
        reference: string | null;
        recordedBy: number | null;
        recordedAt: string;
    };
    line: string;
};

export type IntelSourceConsentRequest = {
    kind: 'none' | 'creator_licence' | 'platform_permission';
    reference?: string | null;
};

export type IntelSourceMonitor = {
    workflowInstanceId: number;
    workflowDefinitionId: number;
    organizationId: number;
    intelSourceId: number;
    source: {
        id: number;
        handle: string;
        name: string | null;
        platform: string;
        avatarUrl: string | null;
    } | null;
    name: string | null;
    lifecycleStatus: 'active' | 'paused' | 'blocked' | 'archived';
    scheduleEnabled: boolean;
    cadence: string;
    nextRunAt: string | null;
    lastRunAt: string | null;
    runCount: number;
    consecutiveFailures: number;
    blockedUntil: string | null;
    lastErrorCode: string | null;
    transcriptEnabled: boolean;
    rawCaptureEnabled: boolean;
    expansionEnabled: boolean;
    maxDepth: number;
    maxNewSourcesPerRun: number;
    autoFollow: boolean;
    mediaEnabled: boolean;
    analysisTemplateId: number | null;
    mediaCapable: boolean;
    latestRunId: number | null;
    dailyQuotaBudget: number | null;
    monthlyReadBudget: number | null;
    requestedByUserId: number | null;
    createdAt: string;
    updatedAt: string;
};

export type IntelSourceMonitorCreate = {
    cadence?: string;
    transcriptEnabled?: boolean;
    expansionEnabled?: boolean;
    maxDepth?: number;
    maxNewSourcesPerRun?: number;
    autoFollow?: boolean;
    rawCaptureEnabled?: boolean;
    mediaEnabled?: boolean;
    analysisTemplateId?: number | null;
    dailyQuotaBudget?: number | null;
    monthlyReadBudget?: number | null;
    name?: string;
};

export type IntelSourceItemInsight = {
    id: number;
    contentId: number;
    intelSourceId: number;
    moduleId: string;
    kind: string;
    payload: {
        [key: string]: unknown;
    };
    status: string;
    routedArtifactType: string | null;
    routedArtifactId: number | null;
    createdAt: string;
};

export type IntelSourceSubscriptionWithSource = IntelSourceSubscription & {
    source: {
        id: number;
        handle: string;
        name: string | null;
        platform: string;
        avatarUrl: string | null;
    };
};

export type IntelSourceSubscriptionUpdate = {
    status?: 'active' | 'paused' | 'archived';
    cadence?: '@hourly' | '@4h' | '@daily' | '@weekly';
    transcriptEnabled?: boolean;
    expansionEnabled?: boolean;
    maxDepth?: number;
    autoFollow?: boolean;
    priority?: number;
    rawCaptureEnabled?: boolean;
    dailyQuotaBudget?: number | null;
    monthlyReadBudget?: number | null;
};

export type IntelSourceFetchRun = {
    id: number;
    subscriptionId: number | null;
    intelSourceId: number;
    organizationId: number;
    workflowRunId: number | null;
    workflowInstanceId: number | null;
    workflowDefinitionId: number | null;
    trigger: 'schedule' | 'manual' | 'backfill' | 'graph_expansion';
    status: 'queued' | 'dispatched' | 'running' | 'succeeded' | 'partial' | 'failed' | 'cancelled' | 'skipped';
    requestId: string | null;
    itemsListed: number;
    itemsNew: number;
    itemsDuplicate: number;
    transcriptsFetched: number;
    quotaUnitsUsed: number;
    errorCode: string | null;
    errorDetail: string | null;
    startedAt: string | null;
    finishedAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type IntelSourceMonitorUpdate = {
    lifecycleStatus?: 'active' | 'paused' | 'blocked' | 'archived';
    scheduleEnabled?: boolean;
    cadence?: string;
    transcriptEnabled?: boolean;
    expansionEnabled?: boolean;
    maxDepth?: number;
    maxNewSourcesPerRun?: number;
    autoFollow?: boolean;
    rawCaptureEnabled?: boolean;
    mediaEnabled?: boolean;
    analysisTemplateId?: number | null;
    dailyQuotaBudget?: number | null;
    monthlyReadBudget?: number | null;
};

export type IntelSourceMonitorFetchResult = {
    triggered: true;
    requestId: string;
    workflowId: string;
};

export type Dashboard = {
    id: number;
    name: string;
    description: string | null;
    ownerType: 'user' | 'team' | 'org' | 'system';
    ownerId: number;
    createdBy: number;
    createdAt: string | string;
    updatedAt: string | string;
    moduleId: string;
    createdByAgent: boolean;
    sourceConversationId: number | null;
    pinned?: boolean;
};

export type DashboardCreate = {
    name: string;
    description?: string | null;
    ownerType?: 'user' | 'team' | 'org';
    ownerId?: number;
};

export type DashboardWithWidgets = Dashboard & {
    widgets: Array<DashboardWidget>;
};

export type DashboardWidget = {
    id: number;
    dashboardId: number;
    widgetDefinitionId: number;
    position: number;
    config: {
        [key: string]: unknown;
    } | null;
    createdAt: string | string;
    updatedAt: string | string;
    definition?: WidgetDefinition;
};

export type WidgetDefinition = {
    id: number;
    name: string;
    type: string;
    description: string | null;
    defaultConfig: {
        [key: string]: unknown;
    } | null;
    category: string | null;
    isSystem: boolean;
};

export type DashboardUpdate = {
    name?: string;
    description?: string | null;
};

export type WidgetAdd = {
    widgetDefinitionId: number;
    position: number;
    config?: {
        [key: string]: unknown;
    } | null;
};

export type WidgetReorder = {
    widgets: Array<{
        id: number;
        position: number;
    }>;
};

export type WidgetUpdate = {
    position?: number;
    config?: {
        [key: string]: unknown;
    } | null;
};

export type DashboardPinState = {
    dashboardId: number;
    pinned: boolean;
};

export type McpConnection = {
    id: number;
    name: string;
    description: string | null;
    transport: 'stdio' | 'sse' | 'http';
    command: string | null;
    serverUrl: string | null;
    enabled: boolean;
    autoConnect: boolean;
    toolPrefix: string | null;
    permissionLevel: string | null;
    maxCallsPerMinute: number | null;
    timeoutMs: number | null;
    trusted: boolean;
    trustStatus: string;
    toolListHash: string | null;
    toolListSnapshot: Array<{
        [key: string]: unknown;
    }> | null;
    toolListChangedAt: string | null;
    toolPoisoningFindings: Array<{
        [key: string]: unknown;
    }> | null;
    lastSecurityScanAt: string | null;
    connected: boolean;
    toolCount: number | null;
    lastConnectedAt: string | null;
    lastError: string | null;
    createdAt: string;
    updatedAt: string;
};

export type McpConnectionCreate = {
    name: string;
    description?: string;
    transport: 'stdio' | 'sse' | 'http';
    command?: string;
    args?: Array<string>;
    serverUrl?: string;
    env?: {
        [key: string]: string;
    };
    enabled?: boolean;
    autoConnect?: boolean;
    toolPrefix?: string;
    permissionLevel?: string;
    maxCallsPerMinute?: number;
    timeoutMs?: number;
    trusted?: boolean;
};

export type McpActionResult = {
    message: string;
};

export type McpCommandQueued = {
    queued: boolean;
    requestId: string;
};

export type McpTool = {
    id: number;
    name: string | null;
    description: string | null;
    category: string | null;
    status: string | null;
};

export type WorkforceSearchResult = {
    id: number;
    name: string;
    description: string | null;
    department: string | null;
    mandate: string | null;
    type: string | null;
    status: string | null;
    lifecycleStatus: string | null;
    qualityScore: string | null;
    score: number;
    matchType: 'keyword' | 'semantic' | 'hybrid';
    source: 'local' | 'builtin' | 'marketplace';
};

export type WorkforceEventCatalogResult = {
    data: Array<{
        type: string;
        source: string;
        description: string;
    }>;
};

export type WorkforceFleetSummaryResult = {
    totalDaemons: number;
    enabledDaemons: number;
    recentFindings: number;
    pendingReviews: number;
    permissionGrantUsage: WorkforcePermissionGrantUsageResult;
    globallyEnabled: boolean;
    loadBuckets: DaemonLoadBuckets;
};

export type WorkforcePermissionGrantUsageResult = {
    active: number;
    allowAlways: number;
    allowOnce: number;
    usedLast7d: number;
    expiringSoon: number;
    revokedLast7d: number;
    staleUnusedAlways?: number;
};

export type DaemonLoadBuckets = {
    unassigned: number;
    assigned: number;
    at_capacity: number;
    over_capacity: number;
    frozen: number;
};

export type WorkforceAssignmentList = {
    data: Array<WorkforceAssignment>;
};

export type WorkforceAssignment = {
    employeeId: string;
    projectId: string;
    projectName: string;
    projectSlug: string;
    teamId: string;
    teamName: string;
    role: string;
    active: boolean;
    since: string | null;
    endedAt: string | null;
};

export type WorkforceResumeAllResult = {
    resumed: number;
    skipped: Array<{
        id: number;
        name: string;
        missing: Array<string>;
    }>;
    message: string;
};

export type WorkforceTerminateAllResult = {
    killed: number;
    message: string;
};

export type WorkforceRecord = {
    [key: string]: unknown;
};

export type FindingReviewUpdate = {
    reviewStatus: 'pending' | 'approved' | 'rejected' | 'deferred';
};

export type DaemonPermissionGrantList = {
    data: Array<DaemonPermissionGrant>;
};

export type DaemonPermissionGrant = {
    id: number;
    daemonId?: number | null;
    daemonRunId?: number | null;
    organizationId?: number;
    subjectType?: string;
    action?: string;
    resourceType?: string;
    resourceId?: string;
    scopeHash?: string;
    scope?: {
        [key: string]: unknown;
    };
    decision?: 'allow' | 'deny';
    grantMode?: 'once' | 'always';
    reason?: string | null;
    grantedBy?: string | null;
    usedAt?: string | null;
    expiresAt?: string | null;
    revokedAt?: string | null;
    revokedBy?: string | null;
    metadata?: {
        [key: string]: unknown;
    };
    createdAt?: string;
    updatedAt?: string;
    [key: string]: unknown;
};

export type WorkforceItemResult = {
    data: WorkforceRecord;
};

export type WorkforceRunTriggeredResult = {
    message: string;
    daemon_id: number;
    daemon_name: string;
};

export type DaemonRunList = {
    data: Array<DaemonRunRecord>;
};

export type DaemonRunRecord = {
    id: number;
    daemonId?: number;
    workflowDefinitionId?: number | null;
    status?: string;
    triggeredBy?: string;
    startedAt?: string;
    completedAt?: string | null;
    durationMs?: number | null;
    findingsCount?: number | null;
    errorsCount?: number | null;
    qualityScore?: string | null;
    reflection?: {
        quality_rating?: number;
        what_worked?: Array<string>;
        what_failed?: Array<string>;
        next_time?: Array<string>;
        [key: string]: unknown;
    } | null;
    error?: string | null;
    [key: string]: unknown;
};

export type WorkforceSseResult = string;

export type DaemonRunReportList = {
    data: Array<DaemonRunReportRecord>;
};

export type DaemonRunReportRecord = {
    id: number;
    daemonId?: number;
    daemonRunId?: number;
    title: string;
    summary?: string | null;
    source?: unknown;
    toolRuns?: Array<unknown> | null;
    artifactIds?: Array<string> | null;
    findingIds?: Array<number> | null;
    decisionIds?: Array<number> | null;
    metrics?: {
        [key: string]: unknown;
    } | null;
    evidenceHash?: string | null;
    createdAt?: string;
    [key: string]: unknown;
};

export type DaemonRunDecisionList = {
    data: Array<DaemonRunDecisionRecord>;
};

export type DaemonRunDecisionRecord = {
    id: number;
    organizationId?: number;
    daemonId?: number;
    daemonRunId?: number;
    title: string;
    description?: string | null;
    severity?: string;
    recommendation?: string | null;
    actionType?: string;
    actionPayload?: {
        [key: string]: unknown;
    } | null;
    rationale?: string | null;
    reviewStatus?: string;
    reviewedBy?: string | null;
    reviewedAt?: string | null;
    consumedAt?: string | null;
    expiresAt?: string | null;
    createdAt?: string;
    stepIds?: Array<string>;
    llmCallIds?: Array<string>;
    [key: string]: unknown;
};

export type DaemonExecutionEnvelopeList = {
    data: Array<DaemonExecutionEnvelope>;
};

export type DaemonExecutionEnvelope = {
    id: number;
    daemonId?: number;
    daemonRunId?: number;
    organizationId?: number;
    permissionGrantId?: number | null;
    commandName?: string;
    action?: string;
    resourceType?: string;
    resourceId?: string;
    scopeHash?: string;
    envelopeHash?: string;
    status?: 'validated' | 'denied' | 'running' | 'completed' | 'failed';
    risk?: 'low' | 'medium' | 'high';
    decisionReason?: string | null;
    policy?: {
        [key: string]: unknown;
    };
    command?: {
        [key: string]: unknown;
    };
    result?: {
        [key: string]: unknown;
    };
    startedAt?: string | null;
    completedAt?: string | null;
    durationMs?: number | null;
    error?: string | null;
    createdAt?: string;
    updatedAt?: string;
    [key: string]: unknown;
};

export type WorkforceRunAuditResult = {
    data: WorkforceRecord;
};

export type ExecutionPermissionGrantCreate = {
    grantMode: 'once' | 'always';
    reason?: string;
    expiresAt?: string;
};

export type DaemonTriggerList = {
    data: Array<DaemonTriggerRecord>;
};

export type DaemonTriggerRecord = {
    id: number;
    daemonId?: number;
    type?: string;
    cron?: string | null;
    eventPattern?: string | null;
    chainDaemonId?: number | null;
    workflowDefinitionId?: number | null;
    enabled?: boolean;
    priority?: number;
    [key: string]: unknown;
};

export type DaemonTriggerCreate = {
    type: 'cron' | 'event' | 'manual' | 'chained';
    cron?: string;
    eventPattern?: string;
    eventFilter?: {
        [key: string]: unknown;
    };
    chainDaemonId?: number;
    workflowDefinitionId?: number;
    enabled?: boolean;
    priority?: number;
};

export type DaemonTriggerUpdate = {
    cron?: string;
    eventPattern?: string;
    eventFilter?: {
        [key: string]: unknown;
    };
    workflowDefinitionId?: number | null;
    enabled?: boolean;
    priority?: number;
};

export type WorkforceMessageResult = {
    message: string;
};

export type DaemonPaginatedList = {
    data: Array<DaemonRecord>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        has_more: boolean;
        next: string | null;
    };
    meta: {
        server_time: string;
        total?: number;
    };
};

export type DaemonRecord = {
    id: number;
    slug?: string | null;
    name?: string | null;
    description?: string | null;
    type?: string;
    mandate?: string | null;
    department?: string;
    permissionTier?: string | null;
    supervisorDaemonId?: number | null;
    maxRunsPerDay?: number | null;
    capacity?: number | null;
    hiredAt?: string | null;
    probationUntil?: string | null;
    templateId?: number | null;
    runtimePolicyId?: number | null;
    requiresApproval?: boolean | null;
    lifecycleStatus?: string;
    enabled?: boolean | null;
    status?: string | null;
    lastRunAt?: string | null;
    runCount?: number | null;
    qualityScore?: string | null;
    totalFindingsCount?: number | null;
    organizationId?: number;
    moduleId?: string;
    [key: string]: unknown;
};

export type DaemonCreate = {
    slug?: string;
    name: string;
    department: 'research' | 'security' | 'quality' | 'testing' | 'docs' | 'performance' | 'infrastructure' | 'custom';
    type?: 'guardian' | 'sentinel' | 'operative';
    mandate?: string;
    templateId?: number | null;
    permissionTier?: 'observer' | 'contributor' | 'operator';
    requiresApproval?: boolean;
    workflowDefinitionId?: number | null;
    triggers?: Array<{
        type: 'cron' | 'event' | 'chained' | 'manual';
        cron?: string;
        eventPattern?: string;
        eventFilter?: {
            [key: string]: unknown;
        };
        chainDaemonId?: number;
    }>;
    supervisorDaemonId?: number | null;
    probationDays?: number | null;
    lifecycleStatus?: 'draft' | 'active' | 'inactive' | 'archived';
    marketplaceSourceId?: number | null;
    description?: string;
    runtimePolicyId?: number;
};

export type DaemonReadinessResult = {
    data: DaemonReadinessReportResult;
};

export type DaemonReadinessReportResult = {
    ready: boolean;
    activation: {
        ok: boolean;
        missing: Array<string>;
    };
    checks: Array<{
        key: string;
        ok: boolean;
        severity: 'critical' | 'high' | 'medium' | 'low';
        message: string;
    }>;
    blocking: Array<{
        key: string;
        ok: boolean;
        severity: 'critical' | 'high' | 'medium' | 'low';
        message: string;
    }>;
    selfReview: {
        openHighFindings: number;
        lastSecurityRun: {
            [key: string]: unknown;
        } | null;
        lastQualityRun: {
            [key: string]: unknown;
        } | null;
    };
    permissionGrantUsage: WorkforcePermissionGrantUsageResult;
};

export type DaemonUpdate = {
    mandate?: string;
    department?: 'research' | 'security' | 'quality' | 'testing' | 'docs' | 'performance' | 'infrastructure' | 'custom';
    permissionTier?: 'observer' | 'contributor' | 'operator';
    templateId?: number | null;
    supervisorDaemonId?: number | null;
    requiresApproval?: boolean;
    maxRunsPerDay?: number;
    maxRunDurationMs?: number;
    outputChannels?: Array<string>;
    enabled?: boolean;
    lifecycleStatus?: 'draft' | 'active' | 'inactive' | 'archived';
};

export type EmployeeRuntimePolicyWrite = {
    runtimePolicyId: number;
};

export type DaemonReflectionList = {
    data: Array<DaemonReflectionRecord>;
};

export type DaemonReflectionRecord = {
    runId: string;
    timestamp: string;
    duration_ms: number;
    findings_count: number;
    quality_rating: number;
    what_worked: Array<string>;
    what_failed: Array<string>;
    next_time: Array<string>;
    [key: string]: unknown;
};

export type WorkforceTrendResult = {
    avgQuality: number;
    trend: 'improving' | 'stable' | 'declining';
    runCount: number;
};

export type DaemonFindingList = {
    data: Array<DaemonFindingRecord>;
};

export type DaemonFindingRecord = {
    id: number;
    daemonId?: number;
    daemonName?: string;
    category?: string;
    severity?: string;
    title?: string;
    description?: string | null;
    evidence?: unknown;
    recommendation?: string | null;
    reviewStatus?: string | null;
    reviewedBy?: string | null;
    reviewedAt?: string | null;
    affectedFiles?: Array<string> | null;
    createdAt?: string;
    [key: string]: unknown;
};

export type DaemonWorkflowList = {
    data: Array<DaemonWorkflowRecord>;
};

export type DaemonWorkflowRecord = {
    id?: number;
    daemonId?: number;
    workflowDefinitionId?: number;
    workflowCatalogVersionId?: number | null;
    purpose?: string | null;
    executionOrder?: number | null;
    enabled?: boolean | null;
    [key: string]: unknown;
};

export type DaemonWorkflowAssign = {
    workflowDefinitionId: number;
    purpose?: 'primary' | 'review' | 'reporting' | 'remediation';
    executionOrder?: number;
};

export type DaemonDecision = {
    id: number;
    organizationId: number;
    daemonId: number;
    daemonRunId: number;
    title: string;
    description: string | null;
    severity: string;
    actionType: string;
    actionPayload: {
        [key: string]: unknown;
    } | null;
    reviewStatus: 'pending' | 'approved' | 'rejected' | 'deferred' | 'quarantined';
    withdrawn: boolean;
    reviewedByUserId: number | null;
    proposedByUserId: number | null;
    reviewedAt: string | null;
    reviewNotes: string | null;
    consumedAt: string | null;
    expiresAt: string | null;
    createdAt: string;
    raisedBy?: {
        kind: 'person' | 'workforce' | 'agent';
        name: string | null;
    };
    review?: {
        canReview: boolean;
        blockedReason: 'settled' | 'expired' | 'own_request' | 'missing_policy' | null;
        requiredPolicies: Array<string>;
        via: 'daemon_decision' | 'workflow_gate';
    };
    appliesOnApproval?: boolean;
};

export type DaemonDecisionReviewRequest = {
    notes?: string;
};

export type ImprovementProposalList = {
    data: Array<ImprovementProposalSummary>;
    paging: {
        total: number;
        limit: number;
        offset: number;
    };
};

export type ImprovementProposalSummary = {
    id: number;
    organizationId: number;
    moduleId: string;
    title: string;
    summary: string;
    kind: 'finance_bank_entity' | 'platform_code' | 'template_tuning' | 'data_source' | 'process';
    riskClass: 'low' | 'medium' | 'high' | 'critical';
    status: 'idea' | 'specced' | 'implementing' | 'auditing' | 'ready_for_human' | 'approved' | 'rejected' | 'applying' | 'applied' | 'measured' | 'failed' | 'superseded';
    confidence: string | null;
    expectedImpact: string | null;
    sourceArm: string | null;
    trialCount: number;
    costUsd: string | null;
    paidModelCostUsd: string | null;
    parentProposalId: number | null;
    supersededById: number | null;
    lineageRootId: number | null;
    proposedByEntityId: number | null;
    synthesizedRunId: number | null;
    specArtifactRef: {
        workOutputId?: string;
        artifactId?: string;
        path?: string;
    } | null;
    stageAttempts: {
        [key: string]: number;
    } | null;
    decisionRef: {
        daemonDecisionId?: string;
        decidedByUserId?: string;
        decidedAt?: string;
        rationale?: string;
    } | null;
    hasOpenDesignReview?: boolean;
    createdAt: string | string;
    updatedAt: string | string;
};

export type ImprovementProposal = {
    id: number;
    organizationId: number;
    moduleId: string;
    title: string;
    summary: string;
    kind: 'finance_bank_entity' | 'platform_code' | 'template_tuning' | 'data_source' | 'process';
    riskClass: 'low' | 'medium' | 'high' | 'critical';
    status: 'idea' | 'specced' | 'implementing' | 'auditing' | 'ready_for_human' | 'approved' | 'rejected' | 'applying' | 'applied' | 'measured' | 'failed' | 'superseded';
    confidence: string | null;
    expectedImpact: string | null;
    sourceArm: string | null;
    trialCount: number;
    costUsd: string | null;
    paidModelCostUsd: string | null;
    parentProposalId: number | null;
    supersededById: number | null;
    lineageRootId: number | null;
    proposedByEntityId: number | null;
    synthesizedRunId: number | null;
    evidenceRefs: Array<{
        type: 'daemon_finding' | 'intel_insight' | 'intel_content' | 'telemetry' | 'url' | 'prior_proposal';
        id?: string;
        url?: string;
        note?: string;
    }>;
    specArtifactRef: {
        workOutputId?: string;
        artifactId?: string;
        path?: string;
    } | null;
    acceptanceCriteria: Array<{
        id: string;
        description: string;
        checkType: string;
        checkRef?: {
            command?: string;
            datasetId?: string;
            gateKey?: string;
            fixtureSetId?: string;
            instructions?: string;
        };
        blocking: boolean;
    }> | null;
    implementationRefs: {
        catalogCandidateIds?: Array<string>;
        codeReviewGateId?: string;
        workspaceId?: string;
        checkpointIds?: Array<string>;
        prUrl?: string;
        templateVersionId?: string;
        strategyRunRequestIds?: Array<string>;
    } | null;
    auditRefs: {
        evaluationRunIds?: Array<string>;
        reportIds?: Array<string>;
        evidenceHash?: string;
        holdoutDelta?: number;
        disclosedScore?: number;
        holdoutScore?: number;
    } | null;
    decisionRef: {
        daemonDecisionId?: string;
        decidedByUserId?: string;
        decidedAt?: string;
        rationale?: string;
    } | null;
    outcome: {
        verdict?: 'adopted' | 'reverted' | 'inconclusive';
        metrics?: {
            [key: string]: unknown;
        };
        measuredAt?: string;
    } | null;
    stageAttempts: {
        [key: string]: number;
    } | null;
    stageLog: Array<{
        from: string;
        to: string;
        at: string;
        actorType: 'daemon' | 'user' | 'system';
        actorId: string;
        note?: string;
    }>;
    hasOpenDesignReview: boolean;
    createdAt: string | string;
    updatedAt: string | string;
};

export type ImprovementProposalDecision = {
    id: number;
    status: 'idea' | 'specced' | 'implementing' | 'auditing' | 'ready_for_human' | 'approved' | 'rejected' | 'applying' | 'applied' | 'measured' | 'failed' | 'superseded';
    decision: 'approve' | 'reject';
    daemonDecisionId: number | null;
};

export type ImprovementProposalDecisionBody = {
    decision: 'approve' | 'reject';
    rationale?: string;
};

export type ImprovementProposalDesignDecision = {
    id: number;
    status: 'idea' | 'specced' | 'implementing' | 'auditing' | 'ready_for_human' | 'approved' | 'rejected' | 'applying' | 'applied' | 'measured' | 'failed' | 'superseded';
    decision: 'approve' | 'reject';
    accepted: boolean;
};

export type ImprovementProposalDesignDecisionBody = {
    decision: 'approve' | 'reject';
    rationale?: string;
};

export type ImprovementMetrics = {
    pipeline: ImprovementPipelineStatus;
    flow: ImprovementFlowMetrics;
    quality: ImprovementQualityMetrics;
    learning: ImprovementLearningMetrics;
    cost: ImprovementCostMetrics;
    humanLoad: ImprovementHumanLoadMetrics;
    computedAt: string | null;
};

export type ImprovementPipelineStatus = {
    active: boolean;
    pauseReason: string | null;
    tier: 'T0' | 'T1' | 'T2';
    lastConductorRunAt: string | null;
    stragglersCount: number;
};

export type ImprovementFlowMetrics = {
    intakePerDayByLane: {
        [key: string]: number;
    };
    stageLatencyP50Sec: {
        [key: string]: number | null;
    };
    stageLatencyP95Sec: {
        [key: string]: number | null;
    };
    wipPerStage: {
        [key: string]: number;
    };
    expiryRate: number | null;
    timeToDecisionHrsP50: number | null;
};

export type ImprovementQualityMetrics = {
    acceptanceRateOverall: number | null;
    acceptanceRateByLane: {
        [key: string]: number | null;
    };
    acceptanceRateByDaemon: {
        [key: string]: number | null;
    };
    revertRate: number | null;
    auditFirstPassRate: number | null;
    strictVsLooseDelta: number | null;
    integrityViolations30d: number;
};

export type ImprovementLearningMetrics = {
    brierScoreByProposer: {
        [key: string]: number | null;
    };
    banditArmPosterior: {
        [key: string]: number | null;
    };
    lineageFertilityTopN: Array<{
        proposalId: number;
        title: string;
        fertileDescendants: number;
    }>;
};

export type ImprovementCostMetrics = {
    costPerProposalP50Usd: number | null;
    costPerProposalP95Usd: number | null;
    costPerAcceptedProposalP50Usd: number | null;
    localTokenVolumeTotal: number | null;
};

export type ImprovementHumanLoadMetrics = {
    decisionsLast7Days: number;
    medianReviewMinutes: number | null;
    rubberStampDetected: boolean;
    fastReviewFraction: number | null;
};

export type ImprovementTierStatus = Array<ImprovementTierLane>;

export type ImprovementTierLane = {
    lane: 'finance' | 'codegen' | 'template' | 'data' | 'process';
    tier: 'T0' | 'T1' | 'T2';
    expandEligible: boolean;
    nextTier: 'T1' | 'T2' | null;
    failingCriteria?: Array<ImprovementTierFailingCriterion>;
};

export type ImprovementTierFailingCriterion = {
    criterion: string;
    detail: string;
};

export type ImprovementTierExpansion = {
    lane: 'finance' | 'codegen' | 'template' | 'data' | 'process';
    fromTier: 'T0' | 'T1' | 'T2';
    tier: 'T0' | 'T1' | 'T2';
    expanded: boolean;
};

export type ImprovementTierExpandRequest = {
    lane: 'finance' | 'codegen' | 'template' | 'data' | 'process';
    targetTier: 'T1' | 'T2';
};

export type WorkflowGate = {
    id: number;
    organizationId: number;
    runId: string;
    dbRunId: number;
    gateName: string;
    afterStepId: string;
    priority: 'low' | 'medium' | 'high' | 'urgent';
    status: 'pending' | 'approved' | 'rejected' | 'expired';
    gateContext?: unknown;
    decidedByUserId: number | null;
    decidedAt: string | null;
    notes: string | null;
    createdAt: string;
    expiresAt: string;
};

export type WorkflowGateApproveRequest = {
    notes?: string;
};

export type WorkflowGateRejectRequest = {
    notes?: string;
};

export type MarketplaceListing = {
    id: number;
    entityId: number;
    entityType: string;
    organizationId: number;
    moduleId: string;
    contentAccess: string;
    publishedBy: number;
    title: string;
    description: string | null;
    category: string | null;
    tags: Array<string> | null;
    pricingModel: string;
    priceUsd: string | null;
    featured: boolean | null;
    status: string | null;
    publishedAt: string | string | null;
    autoAcquire: boolean;
    createdAt: string | string;
    updatedAt: string | string;
};

export type MarketplaceListingCreate = {
    entityId: number;
    title: string;
    description?: string;
    category?: string;
    tags?: Array<string>;
    pricingModel?: 'free' | 'one_time' | 'subscription';
    priceUsd?: string;
    contentAccess?: 'public' | 'private';
    autoAcquire?: boolean;
};

export type MarketplaceActionResult = {
    message: string;
};

export type Entity = {
    id: number;
    type: string;
    organizationId: number;
    activeVersionId: number | null;
    scope: string;
    visibility: string;
    moduleId: string;
    slug: string | null;
    name: string | null;
    description: string | null;
    enabled: boolean;
    disabledReason: string | null;
    loggingEnabled: boolean;
    createdBy: number | null;
    createdAt: string | string;
    updatedAt: string | string;
};

export type MarketplaceForkedEntity = {
    entity: Entity;
    versionId: number;
    version: number;
};

export type MarketplaceForkRequest = {
    slug: string;
    name: string;
};

export type MarketplaceAcquisition = {
    entityId: number;
    sourceEntityId: number;
    type: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
    name: string;
    slug: string | null;
    moduleId: string;
    held: MarketplaceAcquisitionVersion;
    latest: MarketplaceAcquisitionVersion;
    previous: MarketplaceAcquisitionVersion | null;
    updateAvailable: boolean;
    changes: Array<MarketplaceAcquisitionVersion>;
    versions?: Array<MarketplaceAcquisitionVersion>;
    changedParts?: Array<string> | null;
};

export type MarketplaceUpdateAllResult = {
    updated: Array<MarketplaceAcquisitionMove>;
    failed: Array<{
        entityId: number;
        name: string;
        reason: string;
    }>;
};

export type MarketplaceAcquisitionMove = {
    entityId: number;
    type: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
    name: string;
    slug: string | null;
    from: MarketplaceAcquisitionVersion;
    to: MarketplaceAcquisitionVersion;
};

export type MarketplaceUpdateAllRequest = {
    type?: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
};

export type MarketplaceEntityUpdateRequest = {
    toVersion?: number;
};

export type MarketplaceNeedsSetupEntity = {
    entity: Entity;
    reason: 'direct' | 'dependency';
};

export type BindConnectionRequest = {
    mcpConnectionId: number;
};

export type MarketplaceBundle = {
    id: number;
    slug: string;
    name: string;
    description: string;
    authorOrgSlug?: string;
    version?: string;
    installCount: number;
    entities: Array<MarketplaceBundleEntity>;
    entityCounts: {
        templates: number;
        workflows: number;
        daemons: number;
    };
};

export type MarketplaceBundleEntity = {
    id: number;
    entityId: number;
    entityType: string;
    name: string;
    slug: string | null;
    ordinal: number;
};

export type MarketplaceBundleCreate = {
    slug: string;
    name: string;
    description?: string;
    visibility?: 'public' | 'unlisted';
};

export type MarketplaceBundleAddEntity = {
    entityId: number;
    ordinal?: number;
};

export type EntityVersionList = {
    entity: EntityVersionSubject;
    data: Array<EntityVersion>;
};

export type EntityVersionSubject = {
    entityId: number;
    type: string;
    slug: string | null;
    name: string | null;
    activeVersionId: number | null;
    acquired: boolean;
};

export type EntityVersion = {
    id: number;
    entityId: number;
    version: number;
    state: 'draft' | 'locked';
    lockReason: 'marketplace' | 'live_trading' | 'frozen' | null;
    lockedAt: string | null;
    contentHash: string | null;
    parentVersionId: number | null;
    changeSummary: string | null;
    createdByUserId: number | null;
    createdByWorkflowRunId: number | null;
    createdByDaemonRunId: number | null;
    createdAt: string;
    isActive: boolean;
};

export type EntityDraftCreate = {
    changeSummary?: string;
};

export type MlHealth = {
    status?: string;
    uptime?: string | number;
    [key: string]: unknown;
};

export type MlRegime = {
    regime?: string;
    confidence?: number;
    description?: string;
    [key: string]: unknown;
};

export type MlStrategyScores = {
    strategies?: Array<MlStrategyScore>;
    [key: string]: unknown;
};

export type MlStrategyScore = {
    name: string;
    score?: number;
    allocation?: number;
    [key: string]: unknown;
};

export type WorkerRun = {
    runId: string;
    streamId: string;
    kind: 'agent' | 'llm' | 'workflow';
    templateSlug: string | null;
    workflowSlug: string | null;
    workflowId: number | null;
    status: 'running' | 'completed' | 'failed' | 'cancelled';
    organizationId: number;
    apiKeyId: number;
    startedAt: string;
    completedAt: string | null;
    result: {
        output?: unknown;
        outputContract?: unknown;
        usage: {
            inputTokens: number;
            outputTokens: number;
            modelStamp: string;
        };
    } | null;
    failureReason: {
        code: string;
        message: string;
        retryable: boolean;
        details?: unknown;
    } | null;
    cancelReason: string | null;
};

export type WorkerRunCreate = {
    kind: 'agent' | 'llm' | 'workflow';
    templateSlug?: string;
    workflowSlug?: string;
    workflowId?: number;
    input?: unknown;
    policyId?: number;
    model?: unknown;
    prompt?: string;
    system?: string;
    webhookUrl?: string;
    webhookSecret?: string;
    idempotencyKey?: string;
    timeoutMs?: number;
};

export type WorkerRunPending = {
    runId: string;
    status: 'pending';
};

export type WorkerRunFollowUpRequest = {
    message?: unknown;
    idempotencyKey?: string;
};

export type PlatformMcpResponse = {
    jsonrpc: '2.0';
    id: string | number;
    result: {
        _meta?: {
            progressToken?: string | number;
            'io.modelcontextprotocol/related-task'?: {
                taskId: string;
            };
            [key: string]: unknown;
        };
        [key: string]: unknown;
    };
} | {
    jsonrpc: '2.0';
    id?: string | number;
    error: {
        code: number;
        message: string;
        data?: unknown;
    };
};

export type PlatformMcpRequest = {
    jsonrpc: '2.0';
    id: string | number;
    method: string;
    params?: {
        _meta?: {
            progressToken?: string | number;
            'io.modelcontextprotocol/related-task'?: {
                taskId: string;
            };
            [key: string]: unknown;
        };
        [key: string]: unknown;
    };
} | {
    jsonrpc: '2.0';
    method: string;
    params?: {
        _meta?: {
            progressToken?: string | number;
            'io.modelcontextprotocol/related-task'?: {
                taskId: string;
            };
            [key: string]: unknown;
        };
        [key: string]: unknown;
    };
};

export type IssuedApiKey = {
    apiKey: ApiKey;
    plaintext: string;
};

export type ApiKey = {
    id: number;
    organizationId: number;
    scope: 'worker_sdk' | 'service_account' | 'user' | 'host_reporter';
    userId: number | null;
    name: string;
    keyPrefix: string;
    environmentId: number | null;
    metadata: {
        tier?: 'standard' | 'high' | 'enterprise';
        tokenQuotaDailyOverride?: number;
        allowedTemplateSlugs?: Array<string>;
        wsEnabled?: boolean;
        aiWorkerEnabled?: boolean;
        allowedAiWorkerCapabilities?: Array<string>;
        allowedAiWorkerModelSlugs?: Array<string>;
        dataAccessEnabled?: boolean;
        grants?: Array<string>;
        consultDailyCap?: number;
        consultTimeoutMs?: number;
    } | null;
    expiresAt: string | null;
    revokedAt: string | null;
    lastUsedAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type ApiKeyCreate = {
    name: string;
    scope: 'worker_sdk' | 'service_account' | 'user' | 'host_reporter';
    userId?: number;
    environmentSlug: string;
    environmentId?: number;
    metadata?: {
        tier?: 'standard' | 'high' | 'enterprise';
        tokenQuotaDailyOverride?: number;
        allowedTemplateSlugs?: Array<string>;
        wsEnabled?: boolean;
        aiWorkerEnabled?: boolean;
        allowedAiWorkerCapabilities?: Array<string>;
        allowedAiWorkerModelSlugs?: Array<string>;
        dataAccessEnabled?: boolean;
        grants?: Array<string>;
        consultDailyCap?: number;
        consultTimeoutMs?: number;
    };
    expiresAt?: string;
};

export type ApiKeyGrantablePermissions = {
    data: Array<string>;
};

export type ApiKeyUpdate = {
    name?: string;
    expiresAt?: string | null;
    metadata?: {
        tier?: 'standard' | 'high' | 'enterprise';
        tokenQuotaDailyOverride?: number;
        allowedTemplateSlugs?: Array<string>;
        wsEnabled?: boolean;
        aiWorkerEnabled?: boolean;
        allowedAiWorkerCapabilities?: Array<string>;
        allowedAiWorkerModelSlugs?: Array<string>;
        dataAccessEnabled?: boolean;
        grants?: Array<string>;
        consultDailyCap?: number;
        consultTimeoutMs?: number;
    };
};

export type JourneyList = {
    data: Array<JourneySummary>;
    pageInfo: JourneyPageInfo;
};

export type JourneySummary = {
    id: number;
    organizationId: number;
    actorType: string;
    actorId: string;
    userId: number | null;
    contextType: JourneyContextType;
    contextKey: string;
    directionKey: string | null;
    projectId: number | null;
    projectThreadId: number | null;
    projectChangeId: number | null;
    workstreamId: number | null;
    conversationId: number | null;
    workflowRunId: number | null;
    gateId: number | null;
    codeWorkspaceId: number | null;
    codeWorkspaceOperationId: number | null;
    startedAt: string;
    lastEventAt: string;
    endedAt: string | null;
    sessionInactivityMs: number;
    metadata: {
        contextLabel?: string | null;
        directionKey?: string | null;
        source?: string | null;
        sessionHint?: string | null;
        [key: string]: unknown;
    };
};

export enum JourneyContextType {
    GLOBAL = 'global',
    PROJECT = 'project',
    PROJECT_THREAD = 'project_thread',
    PROJECT_CHANGE = 'project_change',
    WORKSTREAM = 'workstream',
    CONVERSATION = 'conversation',
    WORKFLOW_RUN = 'workflow_run',
    REVIEW_GATE = 'review_gate',
    CODE_WORKSPACE = 'code_workspace',
    CODE_WORKSPACE_OPERATION = 'code_workspace_operation'
}

export type JourneyPageInfo = {
    hasNextPage: boolean;
    endCursor: string | null;
};

export type JourneyEventList = {
    data: Array<JourneyEventSummary>;
    pageInfo: JourneyPageInfo;
};

export type JourneyEventSummary = {
    id: number;
    journeyId: number;
    organizationId: number;
    eventType: string;
    eventName: string;
    actorType: string;
    actorId: string;
    userId: number | null;
    entityType: string | null;
    entityId: string | null;
    correlationId: string | null;
    causationType: string | null;
    causationId: string | null;
    requestId: string | null;
    retentionClass: string;
    containsRawEvidence: boolean;
    redactionSummary: {
        redacted: boolean;
        paths?: Array<string>;
        rules?: Array<string>;
        notes?: Array<string>;
    };
    links: Array<{
        entityType: string;
        entityId: string | number;
        relationship?: string;
        href?: string;
        label?: string;
        metadata?: {
            [key: string]: unknown;
        };
    }>;
    payload: {
        routePattern?: string | null;
        method?: string | null;
        status?: number | null;
        durationMs?: number | null;
        query?: {
            [key: string]: unknown;
        };
        params?: {
            [key: string]: unknown;
        };
        [key: string]: unknown;
    };
    occurredAt: string;
    createdAt: string;
};

export type JourneyRawEventList = {
    data: Array<JourneyEventRaw>;
    pageInfo: JourneyPageInfo;
};

export type JourneyEventRaw = JourneyEventSummary & {
    rawEvidence: {
        [key: string]: unknown;
    };
};

export type Department = {
    id: string;
    moduleId: string;
    slug: string;
    displayName: string;
    sortOrder: number;
    createdAt: string;
};

export type ModuleList = {
    data: Array<Module>;
};

export type Module = {
    id: string;
    displayName: string;
    description: string;
    icon: string;
    navOrder: number;
    status: 'active' | 'beta' | 'deprecated';
    policies: Array<string>;
    nav: Array<ModuleNavItem>;
    dependsOn: Array<string>;
};

export type ModuleNavItem = {
    path: string;
    label: string;
    icon?: string;
    policy?: string;
};

export type WaitingOnMe = {
    count: number;
    items: Array<WaitingOnMeItem>;
};

export type WaitingOnMeItem = {
    id: string;
    kind: 'conversation' | 'decision';
    moduleId: string;
    title: string;
    subtitle: string;
    conversationId?: number;
    decisionId?: number;
    updatedAt: string;
};

export type ConversationGroup = {
    id: string;
    name: string;
    conversationCount: number;
};

export type ConversationGroupCreate = {
    name: string;
};

export type ConversationList = {
    data: Array<Conversation>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type Conversation = {
    id: number;
    organizationId: number;
    userId: number;
    topic: string;
    kind: 'user-agent' | 'agent-agent' | 'team' | 'assistant-ui';
    templateSlug: string;
    subjectType: string | null;
    subjectId: string | null;
    runtimePolicyId: number;
    promptTemplateVersion: string | null;
    status: 'active' | 'idle' | 'completed' | 'errored';
    structuredSummary: {
        schemaVersion: 1;
        goals: Array<string>;
        decisions: Array<{
            text: string;
            turn: number;
            decisionId: string | null;
        }>;
        openQuestions: Array<string>;
        entities: Array<{
            kind: string;
            id: string;
            label: string;
        }>;
        references: Array<{
            kind: 'url' | 'entity' | 'document';
            value: string;
            label: string;
            sourceTurn: number;
        }>;
        userPreferences?: Array<string>;
        attachments?: Array<{
            kind: 'image' | 'document' | 'audio';
            storageRef: string;
            textSummary: string;
        }>;
    } | null;
    summarySchemaHash: string | null;
    summaryModelStamp: string | null;
    summaryUpdatedAt: string | null;
    parentConversationId: number | null;
    rootTaskId: number | null;
    projectId: number | null;
    teamId: number | null;
    moduleId: string;
    needsUser: boolean;
    groupId: number | null;
    pinnedAt: string | null;
    createdAt: string;
    updatedAt: string;
    lastActivityAt: string;
    members?: Array<ConversationMember>;
    attachments?: Array<ConversationAttachment>;
    messageCount?: number;
};

export type ConversationMember = {
    id: number;
    conversationId: number;
    memberType: 'user' | 'persona' | 'workforce_member' | 'external_agent' | 'agent_instance';
    memberId: number;
    role: 'owner' | 'contributor' | 'observer' | 'lead';
    joinedAt: string;
    leftAt: string | null;
    createdAt: string;
    updatedAt: string;
    displayName?: string;
    threadConversationId?: number | null;
};

export type ConversationAttachment = {
    id: string;
    conversationId: string;
    attachedType: 'artifact' | 'memory' | 'task' | 'conversation' | 'project' | 'workflow';
    attachedId: string;
    role: 'context' | 'reference' | 'dependency' | 'handoff-payload';
    attachedAt: string;
    attachedBy: string;
    createdAt: string;
};

export type ConversationCreate = {
    topic: string;
    kind?: 'user-agent' | 'agent-agent' | 'team' | 'assistant-ui';
    entryPoint?: string;
    templateSlug?: string;
    subjectType?: 'daemon-draft' | 'workflow' | 'template' | 'tool' | 'project' | 'project_thread' | 'project_change' | 'workstream' | 'strategy' | 'dashboard' | 'analysis_template' | null;
    subjectId?: string | null;
    contextSpec: {
        [key: string]: unknown;
    };
    runtimePolicyId?: number;
    promptTemplateVersion?: string | null;
    parentConversationId?: string | null;
    projectId?: string | null;
    teamId?: string | null;
};

export type ConversationQuickStartResult = {
    conversation: Conversation;
    message: ConversationMessage;
    intent?: IntentClassification;
    dispatch?: DispatchOutcome;
};

export type ConversationMessage = {
    id: number;
    conversationId: number;
    role: 'user' | 'assistant' | 'system' | 'tool';
    content: string;
    toolCalls?: Array<{
        id: string;
        name: string;
        input: {
            [key: string]: unknown;
        };
        resultId?: string;
    }>;
    parts?: Array<{
        type: 'text';
        content: string;
    } | {
        type: 'section';
        title: string;
        body?: string;
        items?: Array<{
            label: string;
            value: string;
            emphasis?: 'normal' | 'strong' | 'muted' | 'positive' | 'warning' | 'danger';
        }>;
    } | {
        type: 'table';
        title?: string;
        columns: Array<{
            id: string;
            label: string;
            align?: 'left' | 'center' | 'right';
        }>;
        rows?: Array<{
            [key: string]: string | number | boolean | null;
        }>;
    } | {
        type: 'checklist';
        title?: string;
        items: Array<{
            label: string;
            detail?: string;
            status?: 'pending' | 'running' | 'complete' | 'blocked' | 'failed';
        }>;
    } | {
        type: 'proposal';
        title: string;
        summary?: string;
        rationale?: string;
        steps?: Array<{
            title: string;
            detail?: string;
            output?: string;
        }>;
    } | {
        type: 'interaction_request';
        interactionId?: string;
        status?: 'open' | 'submitted' | 'cancelled' | 'expired' | 'superseded';
        request: {
            type: 'conversation.interaction_request';
            version: 1;
            interactionKey: string;
            title: string;
            body?: string;
            targetKind?: 'agent' | 'workflow' | 'task' | 'project' | 'workstream';
            expectedOutput?: string;
            fields?: Array<{
                id: string;
                label: string;
                helpText?: string;
                required?: boolean;
                kind: 'text' | 'textarea' | 'rich_text' | 'url' | 'email' | 'code';
                placeholder?: string;
                defaultValue?: string;
                minLength?: number;
                maxLength?: number;
            } | {
                id: string;
                label: string;
                helpText?: string;
                required?: boolean;
                kind: 'number' | 'currency' | 'percent' | 'slider';
                defaultValue?: number;
                min?: number;
                max?: number;
                step?: number;
            } | {
                id: string;
                label: string;
                helpText?: string;
                required?: boolean;
                kind: 'boolean';
                defaultValue?: boolean;
            } | {
                id: string;
                label: string;
                helpText?: string;
                required?: boolean;
                kind: 'single_choice' | 'multi_choice' | 'select' | 'radio' | 'checkboxes';
                options: Array<{
                    value: string;
                    label: string;
                    description?: string;
                }>;
                defaultValue?: string | Array<string>;
            } | {
                id: string;
                label: string;
                helpText?: string;
                required?: boolean;
                kind: 'combobox';
                options?: Array<{
                    value: string;
                    label: string;
                    description?: string;
                }>;
                placeholder?: string;
                allowCustomValue?: boolean;
            } | {
                id: string;
                label: string;
                helpText?: string;
                required?: boolean;
                kind: 'date' | 'time' | 'date_range';
                defaultValue?: string | {
                    start: string;
                    end: string;
                };
            } | {
                id: string;
                label: string;
                helpText?: string;
                required?: boolean;
                kind: 'entity_picker' | 'artifact_picker' | 'file_picker';
                entityTypes?: Array<string>;
                multiple?: boolean;
            } | {
                id: string;
                label: string;
                helpText?: string;
                required?: boolean;
                kind: 'key_value' | 'repeater' | 'editable_table';
                columns?: Array<{
                    id: string;
                    label: string;
                    kind?: 'text' | 'number' | 'boolean' | 'select';
                    options?: Array<{
                        value: string;
                        label: string;
                        description?: string;
                    }>;
                }>;
                minItems?: number;
                maxItems?: number;
            }>;
            actions?: Array<{
                id: string;
                label: string;
                kind: 'submit' | 'cancel' | 'decline' | 'approve' | 'reject' | 'edit' | 'url' | 'create_task' | 'create_project' | 'create_project_thread' | 'create_project_change' | 'create_workstream' | 'start_workflow' | 'apply_proposal';
                style?: 'primary' | 'secondary' | 'danger' | 'warning';
                payload?: {
                    [key: string]: unknown;
                };
            }>;
            submitLabel?: string;
            why?: string;
        };
        stateRef?: {
            entityType: 'state_event' | 'gate' | 'blocker' | 'handoff' | 'task' | 'project' | 'project_thread' | 'project_change' | 'project_change_revision' | 'workflow_run' | 'conversation_interaction' | 'action_queue_item';
            entityId: string | number;
            projectId?: number;
            statusField?: string;
        };
    } | {
        type: 'artifact_ref';
        artifactId: string | number;
        kind: string;
        title: string;
        summary?: string;
        stateRef?: {
            entityType: 'state_event' | 'gate' | 'blocker' | 'handoff' | 'task' | 'project' | 'project_thread' | 'project_change' | 'project_change_revision' | 'workflow_run' | 'conversation_interaction' | 'action_queue_item';
            entityId: string | number;
            projectId?: number;
            statusField?: string;
        };
    } | {
        type: 'progress';
        label: string;
        status: 'pending' | 'running' | 'complete' | 'blocked' | 'failed';
        detail?: string;
        stateRef?: {
            entityType: 'state_event' | 'gate' | 'blocker' | 'handoff' | 'task' | 'project' | 'project_thread' | 'project_change' | 'project_change_revision' | 'workflow_run' | 'conversation_interaction' | 'action_queue_item';
            entityId: string | number;
            projectId?: number;
            statusField?: string;
        };
    } | {
        type: 'warning';
        severity: 'info' | 'warning' | 'error';
        message: string;
        recommendation?: string;
        stateRef?: {
            entityType: 'state_event' | 'gate' | 'blocker' | 'handoff' | 'task' | 'project' | 'project_thread' | 'project_change' | 'project_change_revision' | 'workflow_run' | 'conversation_interaction' | 'action_queue_item';
            entityId: string | number;
            projectId?: number;
            statusField?: string;
        };
    } | {
        type: 'card';
        card: {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'status_summary';
            asOf: string;
            stats: Array<{
                key: string;
                value: number | string;
                label: string;
                sub?: string;
                tone?: 'ok' | 'warn' | 'bad' | 'accent' | 'neutral';
            }>;
            suggestions?: Array<{
                label: string;
                message: string;
            }>;
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'entity_list';
            entity: string;
            title: string;
            total: number;
            items: Array<{
                id: string | number;
                title: string;
                subtitle?: string;
                status?: {
                    label: string;
                    tone?: 'ok' | 'warn' | 'bad' | 'accent' | 'neutral';
                };
                meta?: Array<{
                    label: string;
                    value: string;
                    tone?: 'ok' | 'warn' | 'bad' | 'accent' | 'neutral';
                }>;
                message?: string;
            }>;
            actions?: Array<{
                label: string;
                message: string;
                primary?: boolean;
                requiresApproval?: boolean;
            }>;
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'entity_detail';
            entity: string;
            entityId: string | number;
            title: string;
            subtitle?: string;
            status?: {
                label: string;
                tone?: 'ok' | 'warn' | 'bad' | 'accent' | 'neutral';
            };
            fields: Array<{
                label: string;
                value: string;
                tone?: 'ok' | 'warn' | 'bad' | 'accent' | 'neutral';
            }>;
            sections?: Array<{
                title: string;
                items: Array<{
                    label: string;
                    value: string;
                    tone?: 'ok' | 'warn' | 'bad' | 'accent' | 'neutral';
                }>;
            }>;
            recommendation?: {
                text: string;
                reason: string;
            };
            actions?: Array<{
                label: string;
                message: string;
                primary?: boolean;
                requiresApproval?: boolean;
            }>;
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'strategy_list';
            total: number;
            items: Array<{
                id: string | number;
                name: string;
                asset: string;
                timeframe: string;
                owner: string;
                stage: 'draft' | 'backtested' | 'paper' | 'live' | 'evaluating';
                sharpe?: number | null;
                maxDrawdownPct?: number | null;
                attention?: 'blocked' | 'approval' | null;
                message?: string;
            }>;
            suggestions?: Array<{
                label: string;
                message: string;
            }>;
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'strategy_detail';
            strategyId: string | number;
            name: string;
            asset: string;
            timeframe: string;
            stage: 'draft' | 'backtested' | 'paper' | 'live' | 'evaluating';
            summary: string;
            verdict: 'pass' | 'needs_work' | 'blocked';
            metrics: {
                sharpe: number | null;
                maxDrawdownPct: number | null;
                winRatePct: number | null;
                profitFactor: number | null;
                cagrPct: number | null;
                trades: number | null;
                since: string | null;
            };
            equityCurve?: Array<number>;
            benchmarkCurve?: Array<number>;
            recommendation: {
                text: string;
                reason: string;
            };
            actions: Array<{
                label: string;
                message: string;
                primary?: boolean;
                requiresApproval?: boolean;
            }>;
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'work_progress';
            title: string;
            steps: Array<{
                label: string;
                owner?: string;
                state: 'pending' | 'running' | 'done' | 'failed';
            }>;
            runIds: Array<string | number>;
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'approval_request';
            decisionRef: {
                kind: 'daemon_decision';
                decisionId: number;
            } | {
                kind: 'finance_artifact';
                artifactId: number;
            };
            title: string;
            action: string;
            proposedBy: {
                userId: number | null;
                via: string;
            };
            requiredPolicy: string;
            eligibleApprovers: Array<{
                userId: number;
                name: string;
                department?: string;
            }>;
            riskCheck: {
                passed: boolean | null;
                notes: string;
            };
            explanation: string;
            state: 'draft' | 'pending' | 'approved' | 'rejected' | 'cancelled';
            actions?: Array<{
                label: string;
                message: string;
                primary?: boolean;
                requiresApproval?: boolean;
            }>;
            runtimePolicy?: {
                id: number;
                name: string;
                surface: 'conversation' | 'workforce' | 'workflow' | 'analysis' | 'evaluation' | 'judge' | 'codegen' | 'system' | 'research';
                changeable: boolean;
            };
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'clarification';
            question: string;
            options: Array<{
                label: string;
                message: string;
            }>;
            allowFreeText: true;
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'comparison';
            window: {
                from: string;
                to: string;
            };
            columns: Array<{
                strategyId: string | number;
                name: string;
            }>;
            rows: Array<{
                metric: string;
                values: Array<number | string>;
            }>;
            read: string;
            actions?: Array<{
                label: string;
                message: string;
                primary?: boolean;
                requiresApproval?: boolean;
            }>;
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'proactive_prompt';
            context: {
                entity: string;
                id?: string | number;
            };
            text: string;
            options: Array<{
                label: string;
                message: string;
                skill?: string;
                requiresApproval?: boolean;
            }>;
            dismissible: true;
        } | {
            id: string;
            moduleId: string;
            disclosure?: {
                label: 'AI simulation';
                text: string;
                handle: string;
                platform: string;
                evaluated: boolean;
            };
            type: 'connection_setup';
            provider: string;
            transport: 'mcp' | 'oauth' | 'apikey';
            scopes: Array<string>;
            usedFor: string;
            state: 'proposed' | 'authorized' | 'failed';
            actions?: Array<{
                label: string;
                message: string;
                primary?: boolean;
                requiresApproval?: boolean;
            }>;
        };
        stateRef?: {
            entityType: 'state_event' | 'gate' | 'blocker' | 'handoff' | 'task' | 'project' | 'project_thread' | 'project_change' | 'project_change_revision' | 'workflow_run' | 'conversation_interaction' | 'action_queue_item';
            entityId: string | number;
            projectId?: number;
            statusField?: string;
        };
    } | {
        type: 'behind_the_scenes';
        items: Array<string>;
    } | {
        type: 'suggestions';
        items: Array<{
            label: string;
            message: string;
        }>;
    } | {
        type: 'disclosure';
        disclosure: {
            label: 'AI simulation';
            text: string;
            handle: string;
            platform: string;
            evaluated: boolean;
        };
        personaName: string;
    } | {
        type: 'agent_suggestion';
        personaId: number;
        name: string;
        reason: string;
    }>;
    tokenCounts?: Array<{
        provider: string;
        model: string;
        count: number;
    }>;
    attachments: Array<MessageAttachment>;
    author: {
        id: number;
        memberType: 'user' | 'persona' | 'workforce_member' | 'external_agent' | 'agent_instance';
        memberId: number;
        name: string;
        role: 'owner' | 'contributor' | 'observer' | 'lead';
    } | null;
    to: Array<{
        id: number;
        memberType: 'user' | 'persona' | 'workforce_member' | 'external_agent' | 'agent_instance';
        memberId: number;
        name: string;
        role: 'owner' | 'contributor' | 'observer' | 'lead';
        status: 'pending' | 'running' | 'answered' | 'read' | 'failed';
        replyNeeded: boolean;
        reason: string | null;
    }>;
    createdAt: string;
    updatedAt: string;
};

export type MessageAttachment = {
    uploadId: number;
    kind: 'image' | 'document';
    name: string;
    mediaType: 'image/png' | 'image/jpeg' | 'image/webp' | 'image/gif' | 'application/pdf' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'text/markdown' | 'text/plain';
    sizeBytes: number;
};

export type IntentClassification = {
    kind: ConversationIntentKind;
    confidence: number;
    rationale: string;
    alternatives: Array<{
        kind: ConversationIntentKind;
        confidence: number;
        suggestedLabel: string;
    }>;
    seed: IntentSeed;
};

export type IntentSeed = {
    kind: 'direct_answer';
} | {
    kind: 'workflow';
    suggestedSchedule?: string;
    suggestedSteps?: Array<string>;
} | {
    kind: 'task';
    suggestedTemplateSlug?: string;
    budgetHint?: {
        tokens?: number;
        usd?: number;
        deadlineHours?: number;
    };
} | {
    kind: 'project';
    suggestedName?: string;
    suggestedWorkstreams?: Array<string>;
    suggestedTemplates?: Array<string>;
} | {
    kind: 'marketplace';
    query: string;
    suggestedTemplateIds?: Array<string>;
} | {
    kind: 'ambiguous';
    clarificationPrompt: string;
};

export type DispatchOutcome = {
    dispatched: 'direct_answer';
} | {
    dispatched: 'workflow';
    workflowDraftId: number;
} | {
    dispatched: 'task';
    taskId: number;
} | {
    dispatched: 'project';
    projectId: number;
    workstreamId: number;
} | {
    dispatched: 'marketplace';
    recommendationId: number;
} | {
    dispatched: 'ambiguous';
    disambiguationMessageId: number;
};

export type ConversationQuickStart = {
    message: string;
    attachments?: Array<number>;
    projectId?: string | null;
    teamId?: string | null;
    parentConversationId?: string | null;
    subjectType?: 'daemon-draft' | 'workflow' | 'template' | 'tool' | 'project' | 'project_thread' | 'project_change' | 'workstream' | 'strategy' | null;
    subjectId?: string | null;
    templateSlug?: string;
    entryPoint?: string;
    runtimePolicyId?: number;
    topic?: string;
    moduleId?: string;
    surface?: 'simple' | 'detailed';
    commandContext?: {
        version: 1;
        source: 'conversation_composer';
        activeCommand?: string;
        references?: Array<{
            type: string;
            id: string;
            label: string;
            moduleId: string;
            metadata?: {
                [key: string]: string | number | boolean;
            };
        }>;
        researchPrompt?: string;
        routingHints?: {
            moduleId?: string;
            preferredPersonaSlug?: string;
            preferredIntent?: string;
            artifactKinds?: Array<string>;
            workflowRequested?: boolean;
        };
        promptContextSections?: Array<{
            title: string;
            content: string;
        }>;
    };
    contextSpec?: {
        [key: string]: unknown;
    };
};

export type ConversationUpdate = {
    topic?: string;
    status?: 'active' | 'idle' | 'completed' | 'errored';
    templateSlug?: string;
    groupId?: string | null;
    pinned?: boolean;
};

export type ConversationActionResult = {
    message: string;
};

export type ConversationInviteRequest = {
    memberType: 'user' | 'persona' | 'workforce_member' | 'external_agent';
    memberId: number;
    role?: 'contributor' | 'observer';
};

export type ConversationMemberActionResult = {
    message: string;
};

export type ConversationEntity = {
    entity: string;
    id: string;
    title: string;
    subtitle?: string;
    lastReferencedAt: string;
};

export type ConversationAttachRequest = {
    attachedType: 'artifact' | 'memory' | 'task' | 'conversation' | 'project' | 'workflow';
    attachedId: number;
    role?: 'context' | 'reference' | 'dependency' | 'handoff-payload';
};

export type ConversationAttachmentActionResult = {
    message: string;
};

export type IntentList = {
    data: Array<IntentClassificationDecisionPayload>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
    };
};

export type IntentClassificationDecisionPayload = {
    decisionId: number;
    approvedAt: string;
    conversationId: number;
    messageId: number;
    classification: IntentClassification;
    inputHash: string;
    disambiguatedFromDecisionId: number | null;
    modelStamp: string;
    latencyMs: number;
};

export type ConversationIntentDisambiguateResult = {
    decision: IntentClassificationDecisionPayload;
    dispatch: DispatchOutcome;
};

export type ConversationIntentDisambiguateRequest = {
    kind: ConversationIntentKind;
};

export type ConversationIntentSettings = {
    id: string;
    intentClassificationDisabled: boolean;
    lastIntentKind: ConversationIntentKind | null;
};

export type ConversationReply = {
    message: ConversationMessage;
    intent?: IntentClassification;
    dispatch?: DispatchOutcome;
};

export type ConversationReplyRequest = {
    content: string;
    role: 'user' | 'assistant';
    toolCalls?: Array<{
        id: string;
        name: string;
        input: {
            [key: string]: unknown;
        };
        resultId?: string;
    }>;
    contextSpec?: {
        [key: string]: unknown;
    };
    commandContext?: {
        version: 1;
        source: 'conversation_composer';
        activeCommand?: string;
        references?: Array<{
            type: string;
            id: string;
            label: string;
            moduleId: string;
            metadata?: {
                [key: string]: string | number | boolean;
            };
        }>;
        researchPrompt?: string;
        routingHints?: {
            moduleId?: string;
            preferredPersonaSlug?: string;
            preferredIntent?: string;
            artifactKinds?: Array<string>;
            workflowRequested?: boolean;
        };
        promptContextSections?: Array<{
            title: string;
            content: string;
        }>;
    };
    surface?: 'simple' | 'detailed';
    interactionResponse?: {
        sourceMessageId: string;
        interactionId: string;
        values?: {
            [key: string]: unknown;
        };
        freeText?: string;
    };
    to?: Array<number>;
    answers?: number;
    attachments?: Array<number>;
};

export type ConversationInteractionSubmitRequest = {
    action?: 'submit' | 'cancel' | 'decline' | 'approve' | 'reject' | 'edit' | 'url' | 'create_task' | 'create_project' | 'create_project_thread' | 'create_project_change' | 'create_workstream' | 'start_workflow' | 'apply_proposal';
    values?: {
        [key: string]: unknown;
    };
    displayText?: string;
    idempotencyKey: string;
    surface?: 'simple' | 'detailed';
};

export type ConversationMessageList = {
    data: Array<ConversationMessage>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type ConversationClosePanelRequest = {
    summary: string;
};

export type ConversationTypingRequest = {
    typing: boolean;
};

export type ConversationRuntimePolicyWrite = {
    runtimePolicyId: number;
};

export type ConversationSettingsPatchResult = {
    ok: boolean;
};

export type ConversationSettingsPatch = {
    [key: string]: unknown;
};

export type ConversationContextResult = {
    lastContextPackPublicView: {
        schemaVersion: 1;
        conversationId: number;
        organizationId: number;
        template: {
            slug: string;
            name: string;
            planMode?: boolean;
            subAgents?: Array<string>;
        };
        skills: Array<{
            id: number;
            slug: string;
            kind: 'skill';
            name: string;
            description?: string | null;
            category?: string;
            priority: number;
            versionId?: number;
            invocationDescription?: string | null;
        }>;
        tools: Array<{
            id: number;
            name: string;
            description?: string;
            invocationDescription?: string | null;
            inputSchema?: unknown;
            visibility?: 'private' | 'org' | 'public' | 'marketplace' | 'system';
            host?: 'engine' | 'worker' | 'mcp' | 'provider';
        }>;
        slashCommands: Array<{
            id: number;
            slug: string;
            kind: 'slash_command';
            name: string;
            description: string;
            handlerLocation: 'client' | 'server' | 'engine';
            argSchemaJson?: unknown;
        }>;
        outputContracts: Array<{
            id: number;
            slug: string;
            kind: 'output_contract';
            name: string;
            visibility: 'system' | 'public' | 'organization' | 'org' | 'private' | 'marketplace';
            wireFormat: 'json' | 'tool-call';
            discriminator?: string;
            discriminatorValue: string;
            payloadSchemaJson?: unknown;
            promptInstruction: string;
            applicabilityRule: string;
        }>;
        settings: {
            [key: string]: unknown;
        };
        assembledAt: string;
    } | null;
    lastContextPackHash: string | null;
};

export type ArtifactList = {
    data: Array<Artifact>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type Artifact = {
    id: string;
    organizationId: string;
    scope: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
    subjectType: string;
    subjectId: string;
    kind: 'decision' | 'plan' | 'draft' | 'report' | 'code' | 'spec' | 'design' | 'custom';
    title: string;
    content: string;
    metadata: {
        version?: string;
        tags?: Array<string>;
        references?: Array<string>;
        custom?: {
            [key: string]: unknown;
        };
    } | null;
    authoredBy: string | null;
    /**
     * A locked artifact: it can no longer be edited.
     */
    immutable: boolean;
    /**
     * The author's display name; null when there is no author or the user is gone.
     */
    authorName: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
};

export type ArtifactSummaryList = {
    data: Array<ArtifactSummary>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type ArtifactSummary = {
    id: string;
    organizationId: string;
    scope: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
    subjectType: string;
    subjectId: string;
    kind: 'decision' | 'plan' | 'draft' | 'report' | 'code' | 'spec' | 'design' | 'custom';
    title: string;
    metadata: {
        version?: string;
        tags?: Array<string>;
        references?: Array<string>;
        custom?: {
            [key: string]: unknown;
        };
    } | null;
    authoredBy: string | null;
    /**
     * A locked artifact: it can no longer be edited.
     */
    immutable: boolean;
    /**
     * The author's display name; null when there is no author or the user is gone.
     */
    authorName: string | null;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
};

export type UploadPresignResult = {
    uploadId: number;
    uploadUrl: string;
    expiresAt: string;
};

export type UploadPresignRequest = {
    fileName: string;
    mediaType: string;
    sizeBytes: number;
};

export type Upload = {
    id: number;
    kind: 'image' | 'document';
    name: string;
    mediaType: 'image/png' | 'image/jpeg' | 'image/webp' | 'image/gif' | 'application/pdf' | 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' | 'text/markdown' | 'text/plain';
    sizeBytes: number;
    status: 'pending' | 'ready' | 'failed';
};

export type MemoryList = {
    data: Array<Memory>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type Memory = {
    id: string;
    organizationId: string;
    scope: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
    subjectType: string;
    subjectId: string;
    factText: string;
    sourceConversationId: string | null;
    promotedFrom: string | null;
    createdAt: string;
    createdBy: string;
    deletedAt: string | null;
};

export type MemoryCreate = {
    scope: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
    subjectType: 'conversation_id' | 'team_id' | 'task_id' | 'project_id' | 'agent_template_id' | 'daemon_id' | 'organization_id';
    subjectId: string;
    factText: string;
};

export type MemoryUpdate = {
    factText: string;
};

export type MemoryActionResult = {
    message: string;
};

export type MemoryPromoteRequest = {
    targetScope: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
    newSubjectId: string;
    newSubjectType?: 'conversation_id' | 'team_id' | 'task_id' | 'project_id' | 'agent_template_id' | 'daemon_id' | 'organization_id';
};

export type ArtifactCreate = {
    scope: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
    subjectType: string;
    subjectId: string;
    kind: 'decision' | 'plan' | 'draft' | 'report' | 'code' | 'spec' | 'design' | 'custom';
    title: string;
    content: string;
};

export type ArtifactUpdate = {
    title?: string;
    content?: string;
    kind?: 'decision' | 'plan' | 'draft' | 'report' | 'code' | 'spec' | 'design' | 'custom';
};

export type ArtifactActionResult = {
    message: string;
};

export type ProjectTeamMember = {
    id: number;
    teamId: number;
    memberType: 'user' | 'agent_instance' | 'workforce_member';
    memberId: number;
    role: 'lead' | 'contributor';
    joinedAt: string;
    leftAt: string | null;
    warnings?: Array<string>;
};

export type TeamMemberAddRequest = {
    memberType: 'user' | 'agent_instance' | 'workforce_member';
    memberId: number;
    role?: 'lead' | 'contributor';
};

export type TeamMemberUpdateRoleRequest = {
    role: 'lead' | 'contributor';
};

export type ProjectTeam = {
    id: number;
    organizationId: number;
    projectId: number | null;
    name: string;
    slug: string;
    brief: string | null;
    kind: 'user' | 'agent_squad' | 'mixed';
    visibility: 'public' | 'private';
    createdBy: number | null;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
};

export type ProjectTeamCreate = {
    name: string;
    slug: string;
    brief?: string;
    kind?: 'user' | 'agent_squad' | 'mixed';
    visibility?: 'public' | 'private';
};

export type ProjectTeamUpdate = {
    name?: string;
    brief?: string | null;
    kind?: 'user' | 'agent_squad' | 'mixed';
    visibility?: 'public' | 'private';
};

export type ProjectMember = {
    id: number;
    projectId: number;
    memberType: 'user' | 'agent_instance' | 'workforce_member';
    memberId: number;
    /**
     * The member's name (a person, an employee or an agent); 'Removed member' when its row is gone.
     */
    displayName: string;
    role: 'owner' | 'manager' | 'contributor' | 'observer';
    autoJoined: boolean;
    joinedAt: string;
    leftAt: string | null;
    invitedBy: number | null;
    requiresMemberApproval: boolean;
};

export type ProjectMemberAddRequest = {
    memberId: number;
    memberType: 'user' | 'agent_instance' | 'workforce_member';
    role?: 'contributor' | 'observer';
};

export type ProjectMemberUpdateRoleRequest = {
    role: 'manager' | 'contributor' | 'observer';
};

export type ProjectState = {
    gates: Array<CoordinationGate>;
    blockers: Array<CoordinationBlocker>;
    handoffs: Array<CoordinationHandoff>;
    actionQueue: Array<CoordinationActionQueueItem>;
    recentEvents: Array<CoordinationStateEvent>;
    meta: {
        serverTime: string;
    };
};

export type CoordinationGate = {
    id: number;
    organizationId: number;
    projectId: number | null;
    workstreamId: number | null;
    gateKind: string;
    actionType: string;
    status: 'pending' | 'approved' | 'rejected' | 'request_changes' | 'expired' | 'superseded' | 'cancelled';
    subject: {
        type: string;
        id: string;
        versionHash?: string | null;
    };
    requestedTransition: {
        machine: 'project' | 'project_thread' | 'project_change' | 'project_change_revision' | 'task' | 'workflow_run' | 'gate' | 'blocker' | 'handoff' | 'conversation_interaction' | 'action_queue_item' | 'improvement_proposal' | null;
        event: string | null;
        fromStatus: string | null;
        toStatus: string | null;
    };
    requiredDecider: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
        class: string | null;
        capabilityKeys: Array<string>;
    };
    openedBy: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
    };
    assignedActor: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
    } | null;
    sourceEventId: number | null;
    correlationId: string | null;
    dedupeKey: string | null;
    expiresAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type CoordinationBlocker = {
    id: number;
    organizationId: number;
    projectId: number | null;
    blockerType: 'missing_input' | 'approval_required' | 'security_gate' | 'quality_gate' | 'validation_failed' | 'tool_permission' | 'dependency_failed' | 'handoff_pending' | 'agent_unavailable' | 'budget_limit' | 'external_service' | 'conflict' | 'unknown';
    reasonCode: string | null;
    severity: 'info' | 'low' | 'medium' | 'high' | 'critical';
    priority: 'low' | 'medium' | 'high' | 'urgent';
    status: 'open' | 'acknowledged' | 'assigned' | 'waiting' | 'resolved' | 'dismissed' | 'superseded';
    title: string;
    summary: string | null;
    requiredAction: string | null;
    blockedEntity: {
        type: string;
        id: string;
        versionHash?: string | null;
    };
    owner: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
    } | null;
    reportedBy: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
    } | null;
    blockingOn: {
        type: string;
        id: string;
        versionHash?: string | null;
    } | null;
    sourceEventId: number | null;
    resolutionEventId: number | null;
    correlationId: string | null;
    dedupeKey: string | null;
    createdAt: string;
    updatedAt: string;
    resolvedAt: string | null;
};

export type CoordinationHandoff = {
    id: number;
    organizationId: number;
    projectId: number | null;
    subject: {
        type: string;
        id: string;
        versionHash?: string | null;
    };
    handoffKind: string;
    intent: string | null;
    status: 'requested' | 'accepted' | 'in_progress' | 'blocked' | 'returned' | 'completed' | 'failed' | 'cancelled' | 'expired' | 'superseded';
    sourceActor: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
    };
    targetActor: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
    };
    targetActorClass: string | null;
    targetTemplateSlug: string | null;
    sourceConversationId: number | null;
    targetConversationId: number | null;
    blockerId: number | null;
    gateId: number | null;
    sourceEventId: number | null;
    completedEventId: number | null;
    correlationId: string | null;
    dedupeKey: string | null;
    expiresAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type CoordinationActionQueueItem = {
    id: number;
    organizationId: number;
    projectId: number | null;
    itemType: string;
    status: 'open' | 'claimed' | 'waiting' | 'resolved' | 'cancelled' | 'expired';
    subject: {
        type: string;
        id: string;
        versionHash?: string | null;
    };
    targetActor: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
    } | null;
    targetActorClass: string | null;
    requiredCapabilityKeys: Array<string>;
    priority: 'low' | 'medium' | 'high' | 'urgent';
    availableAt: string;
    dueAt: string | null;
    leaseExpiresAt: string | null;
    claimedBy: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
    } | null;
    dedupeKey: string | null;
    payload: {
        [key: string]: unknown;
    };
    sourceEventId: number | null;
    resolvedEventId: number | null;
    resolvedAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type CoordinationStateEvent = {
    id: number;
    organizationId: number;
    machineKey: 'project' | 'project_thread' | 'project_change' | 'project_change_revision' | 'task' | 'workflow_run' | 'gate' | 'blocker' | 'handoff' | 'conversation_interaction' | 'action_queue_item' | 'improvement_proposal' | null;
    entityType: string;
    entityId: string;
    eventType: string;
    transitionEvent: string | null;
    fromStatus: string | null;
    toStatus: string | null;
    actorType: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
    actorId: string | null;
    causationType: string | null;
    causationId: string | null;
    correlationId: string | null;
    traceId: string | null;
    idempotencyKey: string | null;
    payload: {
        [key: string]: unknown;
    };
    occurredAt: string;
};

export type StateEventList = {
    data: Array<CoordinationStateEvent>;
};

export type ProjectList = {
    data: Array<Project>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type Project = {
    id: number;
    organizationId: number;
    moduleId: string;
    name: string;
    slug: string;
    brief: string | null;
    icon: string | null;
    color: string | null;
    status: 'active' | 'on_hold' | 'archived' | 'closed';
    archivedAt: string | null;
    closedAt: string | null;
    deletedAt: string | null;
    createdBy: number | null;
    createdAt: string;
    updatedAt: string;
};

export type ProjectCommandCenter = {
    project: Project;
    threads: Array<ProjectThread>;
    activeThreads: Array<ProjectThread>;
    changes: Array<ProjectChange>;
    activeChanges: Array<ProjectChange>;
    resources: Array<ProjectThreadResource>;
    resourceCounts: {
        conversation?: number;
        artifact?: number;
        task?: number;
        workstream?: number;
        workflow_run?: number;
        workforce_member?: number;
        decision?: number;
        gate?: number;
        blocker?: number;
        handoff?: number;
        state_event?: number;
        code_workspace?: number;
        code_checkpoint?: number;
    };
    readinessChecks: Array<ProjectChangeReadinessCheck>;
    lifecycle: Array<ProjectLifecyclePhase>;
    workModeTemplates: Array<ProjectWorkModeTemplate>;
    nextActions: Array<ProjectNextAction>;
    attentionQueue: Array<AttentionQueueItem>;
    agentHealth: AgentHealth;
    mostRecentThread: {
        id: number;
        title: string;
        updatedAt: string;
        isBlocked: boolean;
    } | null;
    counts: ProjectCounts;
    activity: Array<ProjectActivityItem>;
    blockers: Array<{
        changeId: number;
        title: string;
        reason: string;
    }>;
    threadOwners: Array<ProjectThreadOwner>;
    meta: {
        serverTime: string;
    };
};

export type ProjectThread = {
    id: number;
    organizationId: number;
    projectId: number;
    rootConversationId: number | null;
    title: string;
    summary: string | null;
    status: 'active' | 'paused' | 'completed' | 'archived';
    currentWorkMode: 'brainstorm' | 'discovery' | 'design' | 'implementation' | 'review' | 'launch' | 'support' | 'expansion' | 'refactor' | 'fix';
    primaryChangeId: number | null;
    createdBy: number | null;
    createdAt: string;
    updatedAt: string;
};

export type ProjectChange = {
    id: number;
    organizationId: number;
    projectId: number;
    projectThreadId: number;
    number: number;
    title: string;
    target: string | null;
    summary: string | null;
    status: 'draft' | 'planned' | 'implementing' | 'checking' | 'reviewing' | 'ready_to_merge' | 'merged' | 'blocked' | 'abandoned';
    workMode: 'brainstorm' | 'discovery' | 'design' | 'implementation' | 'review' | 'launch' | 'support' | 'expansion' | 'refactor' | 'fix';
    backend: 'none' | 'local_git' | 'github' | 'gitlab' | 'gitea' | 'forgejo' | 'gerrit';
    baseRef: string | null;
    branchName: string | null;
    workspaceId: number | null;
    providerRef: string | null;
    reviewUrl: string | null;
    latestCheckStatus: string | null;
    blockedReason: string | null;
    currentRevisionId: number | null;
    createdBy: number | null;
    createdAt: string;
    updatedAt: string;
};

export type ProjectThreadResource = {
    id: number;
    organizationId: number;
    projectId: number;
    projectThreadId: number;
    projectChangeId: number | null;
    resourceType: 'conversation' | 'artifact' | 'task' | 'workstream' | 'workflow_run' | 'workforce_member' | 'decision' | 'gate' | 'blocker' | 'handoff' | 'state_event' | 'code_workspace' | 'code_checkpoint';
    resourceId: string;
    role: string | null;
    metadata: {
        [key: string]: unknown;
    } | null;
    createdAt: string;
};

export type ProjectChangeReadinessCheck = {
    changeId: number;
    check: 'scope' | 'branch' | 'validation' | 'review' | 'blockers';
    status: 'pass' | 'warning' | 'block';
    label: string;
    detail: string;
};

export type ProjectLifecyclePhase = {
    id: 'plan' | 'build' | 'review' | 'ship' | 'operate';
    label: string;
    status: 'ready' | 'active' | 'blocked' | 'empty';
    detail: string;
    workModes: Array<'brainstorm' | 'discovery' | 'design' | 'implementation' | 'review' | 'launch' | 'support' | 'expansion' | 'refactor' | 'fix'>;
    blockerCount: number;
    warningCount: number;
    outputCount: number;
    chips: Array<{
        label: string;
        tone: 'blue' | 'green' | 'red' | 'yellow' | '';
    }>;
};

export type ProjectWorkModeTemplate = {
    mode: 'brainstorm' | 'discovery' | 'design' | 'implementation' | 'review' | 'launch' | 'support' | 'expansion' | 'refactor' | 'fix';
    phase: 'plan' | 'build' | 'review' | 'ship' | 'operate';
    label: string;
    description: string;
    expectedOutputs: Array<string>;
    assistantPrompt: string;
    source: 'platform_default' | 'project_template' | 'module_override' | 'project_override';
    sourceRef?: string;
    sortOrder: number;
};

export type ProjectNextAction = {
    id: string;
    kind: 'assistant' | 'navigation';
    priority: number;
    label: string;
    description: string;
    prompt: string;
    tab?: string;
};

export type AttentionQueueItem = {
    id: string;
    kind: 'blocker' | 'approval' | 'failed-gate' | 'gate' | 'stalled-agent' | 'artifact' | 'stale';
    severity: 'r' | 'y' | 'b' | 'g' | 'n';
    title: string;
    ownerInitials: string;
    ownerIsAgent: boolean;
    threadId: number | null;
    threadTitle: string | null;
    changeId: number | null;
    ageLabel: string;
};

export type AgentHealth = {
    running: number;
    idle: number;
    doneToday: number;
    failed: number;
    stalled: Array<{
        role: string;
        threadId: number;
        count: number;
    }>;
};

export type ProjectCounts = {
    threads: number;
    changes: number;
    blockedChanges: number;
    artifacts: number;
    tasks: number;
    awaitingTasks: number;
    workforce: number;
};

export type ProjectActivityItem = {
    id: string;
    type: 'thread' | 'change' | 'resource';
    title: string;
    description: string;
    timestamp: string;
    projectThreadId?: number;
    projectChangeId?: number;
    resourceType?: 'conversation' | 'artifact' | 'task' | 'workstream' | 'workflow_run' | 'workforce_member' | 'decision' | 'gate' | 'blocker' | 'handoff' | 'state_event' | 'code_workspace' | 'code_checkpoint';
    resourceId?: string;
};

export type ProjectThreadOwner = {
    threadId: number;
    initials: string;
    label: string;
    isAgent: boolean;
};

export type ProjectWorkModeTemplateInput = {
    mode: 'brainstorm' | 'discovery' | 'design' | 'implementation' | 'review' | 'launch' | 'support' | 'expansion' | 'refactor' | 'fix';
    phase: 'plan' | 'build' | 'review' | 'ship' | 'operate';
    label: string;
    description: string;
    expectedOutputs: Array<string>;
    assistantPrompt: string;
    source?: 'platform_default' | 'project_template' | 'module_override' | 'project_override';
    sourceRef?: string | null;
    sortOrder?: number;
    enabled?: boolean;
};

export type ProjectThreadCreate = {
    title: string;
    summary?: string;
    rootConversationId?: number;
    currentWorkMode?: 'brainstorm' | 'discovery' | 'design' | 'implementation' | 'review' | 'launch' | 'support' | 'expansion' | 'refactor' | 'fix';
};

export type ProjectThreadUpdate = {
    title?: string;
    summary?: string | null;
    status?: 'active' | 'paused' | 'completed' | 'archived';
    currentWorkMode?: 'brainstorm' | 'discovery' | 'design' | 'implementation' | 'review' | 'launch' | 'support' | 'expansion' | 'refactor' | 'fix';
    primaryChangeId?: number | null;
};

export type ProjectChangesResult = {
    stats: {
        total: number;
        blocked: number;
        inReview: number;
        inFlight: number;
        merged: number;
    };
    branches: Array<{
        name: string;
        count: number;
    }>;
    changes: Array<ProjectChangeView>;
};

export type ProjectChangeView = ProjectChange & {
    displayStatus: 'draft' | 'open' | 'review' | 'blocked' | 'merged' | 'stalled' | 'closed';
    author: {
        initials: string;
        name: string;
        isAgent: boolean;
    };
    branch: {
        id: number;
        name: string;
        href: string | null;
    };
    gates: {
        passed: number;
        total: number;
        segments: Array<'ok' | 'bad' | 'pending'>;
    };
    diff: {
        added: number;
        removed: number;
        files: number;
    } | null;
    reviewers: Array<{
        initials: string;
        name: string;
        isAgent: boolean;
        state: 'pending' | 'approved' | 'changes-requested' | 'requested';
    }>;
    gateChecks?: Array<ProjectChangeGate>;
    revisions?: Array<ProjectChangeRevision>;
    resources?: Array<ProjectThreadResource>;
    activity?: Array<ProjectActivityItem>;
    thread?: {
        id: number;
        title: string;
        rootConversationId: number | null;
    };
};

export type ProjectChangeGate = {
    id: number;
    gateType: string;
    actionType: string;
    status: string;
    blockingMode: string;
    reviewer: {
        initials: string;
        name: string;
        isAgent: boolean;
    } | null;
    reviewerLabel: string | null;
    decisionAction: string | null;
    decisionReason: string | null;
    decidedAt: string | null;
    createdAt: string;
};

export type ProjectChangeRevision = {
    id: number;
    organizationId: number;
    projectChangeId: number;
    sequence: number;
    status: 'draft' | 'generated' | 'validating' | 'validated' | 'failed' | 'superseded';
    summary: string | null;
    patchArtifactId: number | null;
    validationReportArtifactId: number | null;
    sourceConversationId: number | null;
    sourceWorkflowRunId: number | null;
    sourceTaskIds: Array<number> | null;
    baseCommitSha: string | null;
    commitSha: string | null;
    patchHash: string | null;
    linesAdded: number | null;
    linesRemoved: number | null;
    filesChanged: number | null;
    metadata: {
        [key: string]: unknown;
    } | null;
    createdBy: number | null;
    createdAt: string;
    updatedAt: string;
};

export type ProjectLogResult = {
    project: {
        id: number;
        name: string;
        status: 'active' | 'on_hold' | 'archived' | 'closed';
    };
    range: {
        start: string;
        end: string;
        ticks: Array<{
            label: string;
            isoDate: string;
            isPast: boolean;
            isToday: boolean;
            isWeekend: boolean;
        }>;
    };
    threads: Array<ProjectLogLane>;
    decisions: Array<ProjectLogDecisionCard>;
};

export type ProjectLogLane = {
    id: number;
    name: string;
    status: 'active' | 'paused' | 'completed' | 'archived';
    ownerInitials: string;
    ownerLabel: string;
    ownerIsAgent: boolean;
    changeCount: number;
    idleLabel?: string;
    phase: string;
    endStatus?: string;
    commits: Array<ProjectLogCommit>;
    threadHref: string;
};

export type ProjectLogCommit = {
    id: number;
    kind: 'change' | 'decision' | 'artifact' | 'workflow' | 'gate';
    tone: 'g' | 'b' | 'y' | 'r' | 'n';
    number?: number;
    label: string;
    subLabel?: string;
    timestamp: string;
    href: string | null;
    changeId?: number;
    leftPct: number;
};

export type ProjectLogDecisionCard = {
    id: string;
    kind: 'blocker' | 'gate' | 'next-action';
    severity: 'r' | 'y' | 'b' | 'g' | 'n';
    title: string;
    ageLabel: string;
    threadId: number | null;
    threadTitle: string | null;
};

export type ProjectChangeCreate = {
    projectThreadId: number;
    title: string;
    target?: string;
    summary?: string;
    status?: 'draft' | 'planned' | 'implementing' | 'checking' | 'reviewing' | 'ready_to_merge' | 'merged' | 'blocked' | 'abandoned';
    workMode?: 'brainstorm' | 'discovery' | 'design' | 'implementation' | 'review' | 'launch' | 'support' | 'expansion' | 'refactor' | 'fix';
    backend?: 'none' | 'local_git' | 'github' | 'gitlab' | 'gitea' | 'forgejo' | 'gerrit';
    baseRef?: string;
    branchName?: string;
};

export type ProjectChangeUpdate = {
    title?: string;
    target?: string | null;
    summary?: string | null;
    status?: 'draft' | 'planned' | 'implementing' | 'checking' | 'reviewing' | 'ready_to_merge' | 'merged' | 'blocked' | 'abandoned';
    workMode?: 'brainstorm' | 'discovery' | 'design' | 'implementation' | 'review' | 'launch' | 'support' | 'expansion' | 'refactor' | 'fix';
    backend?: 'none' | 'local_git' | 'github' | 'gitlab' | 'gitea' | 'forgejo' | 'gerrit';
    baseRef?: string | null;
    branchName?: string | null;
    providerRef?: string | null;
    reviewUrl?: string | null;
    latestCheckStatus?: string | null;
    blockedReason?: string | null;
};

export type ProjectChangeRevisionCreate = {
    status?: 'draft' | 'generated' | 'validating' | 'validated' | 'failed' | 'superseded';
    summary?: string;
    patchArtifactId?: number;
    validationReportArtifactId?: number;
    sourceConversationId?: number;
    sourceWorkflowRunId?: number;
    sourceTaskIds?: Array<number>;
    baseCommitSha?: string;
    commitSha?: string;
    patchHash?: string;
    metadata?: {
        [key: string]: unknown;
    };
};

export type ProjectThreadResourceCreate = {
    projectThreadId: number;
    projectChangeId?: number;
    resourceType: 'conversation' | 'artifact' | 'task' | 'workstream' | 'workflow_run' | 'workforce_member' | 'decision' | 'gate' | 'blocker' | 'handoff' | 'state_event' | 'code_workspace' | 'code_checkpoint';
    resourceId: string;
    role?: string;
    metadata?: {
        [key: string]: unknown;
    };
};

export type ProjectCreate = {
    name: string;
    slug: string;
    moduleId: string;
    brief?: string;
    icon?: string;
    color?: string;
};

export type ProjectUpdate = {
    name?: string;
    slug?: string;
    brief?: string | null;
    icon?: string | null;
    color?: string | null;
};

export type ProjectCloseRequest = {
    reason?: string;
};

export type ProjectSummary = {
    project: Project;
    memberCount: number;
    membersByRole: {
        owner: number;
        manager: number;
        contributor: number;
        observer: number;
    };
    threadCount: number;
    changeCount: number;
    conversationCount: number;
    taskCount: number;
    teamCount: number;
    workstreamCount: number;
    memoryCount: number;
    artifactCount: number;
    meta: {
        serverTime: string;
    };
};

export type ActionQueueList = {
    data: Array<CoordinationActionQueueItem>;
};

export type ActionQueueClaimInput = {
    leaseMs?: number;
    correlationId?: string | null;
};

export type ActionQueueResolveInput = {
    correlationId?: string | null;
};

export type GateDecisionInput = {
    action: 'approve' | 'reject' | 'request_changes' | 'accept_risk' | 'cancel' | 'expire';
    rationale?: string | null;
    reasonCode?: string | null;
    riskAcceptanceUntil?: string | null;
    payload?: {
        [key: string]: unknown;
    };
};

export type BlockerTransitionInput = {
    status: 'open' | 'acknowledged' | 'assigned' | 'waiting' | 'resolved' | 'dismissed' | 'superseded';
    reason?: string | null;
    ownerActor?: {
        type: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        id?: string | null;
    } | null;
    payload?: {
        [key: string]: unknown;
    };
};

export type HandoffTransitionInput = {
    status: 'requested' | 'accepted' | 'in_progress' | 'blocked' | 'returned' | 'completed' | 'failed' | 'cancelled' | 'expired' | 'superseded';
    resultSummary?: string | null;
    resultArtifactId?: number | null;
    blockerId?: number | null;
    payload?: {
        [key: string]: unknown;
    };
};

export type TaskDecision = {
    id: number;
    organizationId: number;
    conversationId: number;
    decisionType: string;
    payload: {
        [key: string]: unknown;
    };
    approvedBy: number;
    approvedAt: string;
    sourceMessageId: number | null;
    rationale: string | null;
};

export type Task = {
    id: number;
    organizationId: number;
    createdBy: number;
    createdByType: 'user' | 'agent_instance';
    originType: 'manual' | 'conversation' | 'project' | 'workflow_step' | 'daemon_finding' | 'artifact' | 'api' | 'decision';
    originId: string | null;
    originLabel: string | null;
    originMetadata: {
        [key: string]: unknown;
    } | null;
    assigneeType: 'user' | 'workforce_member' | 'daemon' | 'template' | 'tool' | 'workflow';
    assigneeId: string | null;
    assigneeLabel: string | null;
    projectId: number | null;
    teamId: number | null;
    parentTaskId: number | null;
    rootTaskId: number | null;
    title: string;
    goal: string;
    status: 'pending' | 'in_progress' | 'awaiting_approval' | 'awaiting_user' | 'completed' | 'failed' | 'cancelled';
    baseTemplateId: number;
    sessionId: number | null;
    deadlineAt: string | null;
    tokenBudget: number | null;
    spendBudgetUsd: string | null;
    tokensUsed: number;
    spendUsd: string;
    softStopFired: boolean;
    requiredTools: Array<string> | null;
    inputContract: WorkflowContract | null;
    outputContract: WorkflowContract | null;
    executionContract: WorkflowContract | null;
    resultContract: WorkflowContract | null;
    inputContext: {
        [key: string]: unknown;
    } | null;
    approvalRequired: Array<string>;
    approvalTimeoutHours: number | null;
    awaitingApprovalSince: string | null;
    autoCompleteOnAgentDone: boolean;
    result: {
        [key: string]: unknown;
    } | null;
    resultSummary: string | null;
    resultArtifactId: number | null;
    failureReason: 'budget_exhausted_tokens' | 'budget_exhausted_spend' | 'deadline' | 'approval_rejected' | 'approval_timeout' | 'fatal_error' | null;
    completedAt: string | null;
    completedBy: number | null;
    retryCount: number;
    lastRetriedAt: string | null;
    relations: {
        parentTask: {
            id: number;
            title: string;
            status: string;
        } | null;
        childTasks: Array<{
            id: number;
            title: string;
            status: string;
            assigneeLabel: string | null;
            resultSummary: string | null;
        }>;
        executionConversation: {
            id: number;
            topic: string;
            status: string;
            lastActivityAt: string | null;
            summary?: unknown;
        } | null;
        project: {
            id: number;
            name: string;
            slug: string;
        } | null;
        team: {
            id: number;
            name: string;
            slug: string;
        } | null;
        template: {
            id: number;
            name: string;
            slug: string;
        } | null;
        resultArtifact: {
            id: number;
            title: string;
            kind: string;
        } | null;
        boundaryGuidance: {
            childTasksAreAccountabilityOnly: boolean;
            workflowRecommended: boolean;
            reason: string | null;
        };
    } | null;
    createdAt: string;
    updatedAt: string;
};

export type TaskApproveActionRequest = {
    decisionId: string;
};

export type TaskRejectActionRequest = {
    decisionId: string;
    reason?: string;
};

export type TaskCompleteRequest = {
    promotedMemoryIds?: Array<string>;
    result?: {
        [key: string]: unknown;
    } | null;
    resultSummary?: string | null;
    createResultArtifact?: boolean;
    resultArtifactTitle?: string | null;
    resultArtifactKind?: 'decision' | 'plan' | 'draft' | 'report' | 'code' | 'spec' | 'design' | 'custom';
};

export type TaskReassignRequest = {
    assigneeType: 'user' | 'workforce_member' | 'daemon' | 'template' | 'tool' | 'workflow';
    assigneeId?: string | null;
    assigneeLabel?: string | null;
    baseTemplateId?: number;
    teamId?: number | null;
};

export type TaskTransferTeamRequest = {
    toTeamId: number;
};

export type TaskList = {
    data: Array<Task>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type TaskCreate = {
    title: string;
    goal: string;
    baseTemplateId: number;
    projectId?: number | null;
    teamId?: number | null;
    parentTaskId?: number | null;
    deadlineAt?: string | null;
    tokenBudget?: number | null;
    spendBudgetUsd?: string | null;
    requiredTools?: Array<string> | null;
    inputContract?: WorkflowContract | null;
    outputContract?: WorkflowContract | null;
    executionContract?: WorkflowContract | null;
    resultContract?: WorkflowContract | null;
    inputContext?: {
        [key: string]: unknown;
    } | null;
    approvalRequired?: Array<string>;
    approvalTimeoutHours?: number | null;
    autoCompleteOnAgentDone?: boolean;
    originType?: 'manual' | 'conversation' | 'project' | 'workflow_step' | 'daemon_finding' | 'artifact' | 'api';
    originId?: string | null;
    originLabel?: string | null;
    originMetadata?: {
        [key: string]: unknown;
    } | null;
    assigneeType?: 'user' | 'workforce_member' | 'daemon' | 'template' | 'tool' | 'workflow';
    assigneeId?: string | null;
    assigneeLabel?: string | null;
};

export type TaskUpdate = {
    title?: string;
    goal?: string;
    deadlineAt?: string | null;
    tokenBudget?: number | null;
    spendBudgetUsd?: string | null;
    requiredTools?: Array<string> | null;
    inputContract?: WorkflowContract | null;
    outputContract?: WorkflowContract | null;
    executionContract?: WorkflowContract | null;
    resultContract?: WorkflowContract | null;
    inputContext?: {
        [key: string]: unknown;
    } | null;
    approvalRequired?: Array<string>;
    approvalTimeoutHours?: number | null;
    autoCompleteOnAgentDone?: boolean;
    originType?: 'manual' | 'conversation' | 'project' | 'workflow_step' | 'daemon_finding' | 'artifact' | 'api';
    originId?: string | null;
    originLabel?: string | null;
    originMetadata?: {
        [key: string]: unknown;
    } | null;
    assigneeType?: 'user' | 'workforce_member' | 'daemon' | 'template' | 'tool' | 'workflow';
    assigneeId?: string | null;
    assigneeLabel?: string | null;
};

export type Intervention = {
    id: number;
    organizationId: number;
    type: 'fix' | 'improve' | 'investigate' | 'decision' | 'contract_repair' | 'version_change' | 'worker_unavailable' | 'policy_blocker';
    severity: 'info' | 'warning' | 'error' | 'critical';
    status: 'open' | 'reviewing' | 'routed' | 'resolved' | 'rejected';
    requestedOutcome: 'task' | 'decision' | 'workflow_draft' | 'workflow_version' | 'workforce_route' | 'workstream_link' | 'log_only' | null;
    title: string;
    reason: string;
    instructions: string | null;
    sourceType: 'workflow' | 'workflow_run' | 'workflow_step' | 'task' | 'template' | 'project' | 'artifact' | 'workforce' | 'daemon' | 'catalog_item' | 'catalog_version' | 'decision';
    sourceId: string;
    sourceName: string;
    sourceUrl: string | null;
    assignedToType: string | null;
    assignedToId: string | null;
    assignedToName: string | null;
    failureTaxonomy: string | null;
    evidence: {
        [key: string]: unknown;
    } | null;
    recommendedOutcomes: Array<{
        [key: string]: unknown;
    }>;
    linkedOutcomes: Array<{
        [key: string]: unknown;
    }>;
    resolvedAt: string | null;
    resolvedBy: number | null;
    createdBy: number;
    createdAt: string;
    updatedAt: string;
};

export type InterventionCreate = {
    type: 'fix' | 'improve' | 'investigate' | 'decision' | 'contract_repair' | 'version_change' | 'worker_unavailable' | 'policy_blocker';
    severity?: 'info' | 'warning' | 'error' | 'critical';
    requestedOutcome?: 'task' | 'decision' | 'workflow_draft' | 'workflow_version' | 'workforce_route' | 'workstream_link' | 'log_only' | null;
    title: string;
    reason: string;
    instructions?: string | null;
    sourceType: 'workflow' | 'workflow_run' | 'workflow_step' | 'task' | 'template' | 'project' | 'artifact' | 'workforce' | 'daemon' | 'catalog_item' | 'catalog_version' | 'decision';
    sourceId: string;
    sourceName?: string | null;
    sourceUrl?: string | null;
    assignedToType?: string | null;
    assignedToId?: string | null;
    assignedToName?: string | null;
    failureTaxonomy?: 'execution_failure' | 'contract_failure' | 'quality_failure' | 'policy_failure';
    evidence?: {
        [key: string]: unknown;
    } | null;
    recommendedOutcomes?: Array<{
        [key: string]: unknown;
    }>;
};

export type InterventionEvent = {
    id: number;
    interventionId: number;
    organizationId: number;
    actorUserId: number | null;
    eventType: string;
    fromStatus: 'open' | 'reviewing' | 'routed' | 'resolved' | 'rejected' | null;
    toStatus: 'open' | 'reviewing' | 'routed' | 'resolved' | 'rejected' | null;
    message: string | null;
    payload: {
        [key: string]: unknown;
    } | null;
    createdAt: string;
};

export type InterventionRouteRequest = {
    outcome: 'task' | 'decision' | 'workflow_draft' | 'workflow_version' | 'workforce_route' | 'workstream_link' | 'log_only';
    instructions?: string | null;
    payload?: {
        [key: string]: unknown;
    };
};

export type InterventionResolveRequest = {
    message?: string;
    payload?: {
        [key: string]: unknown;
    };
};

export type InterventionRejectRequest = {
    reason: string;
};

export type WorkstreamMember = {
    id: number;
    workstreamId: number;
    memberType: 'user' | 'agent_instance' | 'workforce_member';
    memberId: number;
    /**
     * The member's name (a person, an employee or an agent); 'Removed member' when its row is gone.
     */
    displayName: string;
    role: 'owner' | 'contributor' | 'observer';
    joinedAt: string;
    leftAt: string | null;
};

export type WorkstreamMemberAdd = {
    memberType: 'user' | 'agent_instance' | 'workforce_member';
    memberId: number;
    role?: 'owner' | 'contributor' | 'observer';
};

export type DecisionList = {
    data: Array<WorkstreamDecision>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type WorkstreamDecision = {
    id: number;
    organizationId: number;
    conversationId: number;
    decisionType: string;
    payload: {
        [key: string]: unknown;
    };
    approvedBy: number;
    approvedAt: string;
    sourceMessageId: number | null;
    rationale: string | null;
};

export type WorkstreamList = {
    data: Array<Workstream>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        hasMore: boolean;
        next: string | null;
    };
    meta: {
        serverTime: string;
        total?: number;
    };
};

export type Workstream = {
    id: number;
    organizationId: number;
    projectId: number;
    projectChangeId: number;
    name: string;
    description: string | null;
    focus: 'feature' | 'marketing' | 'research' | 'ops' | 'support' | 'general';
    status: 'active' | 'paused' | 'archived' | 'completed';
    managerAgentId: number | null;
    createdBy: number | null;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
};

export type WorkstreamCreate = {
    projectId: number;
    projectChangeId: number;
    name: string;
    description?: string;
    focus?: 'feature' | 'marketing' | 'research' | 'ops' | 'support' | 'general';
};

export type WorkstreamUpdate = {
    name?: string;
    description?: string | null;
    focus?: 'feature' | 'marketing' | 'research' | 'ops' | 'support' | 'general';
    status?: 'active' | 'paused' | 'archived' | 'completed';
};

export type ApproverDelegation = {
    id: number;
    organizationId: number;
    delegatorUserId: number;
    delegateUserId: number;
    approvalPattern: string;
    expiresAt: string;
    grantedAt: string;
    revokedAt: string | null;
    grantedBy: number | null;
};

export type ApproverDelegationCreate = {
    delegateUserId: number;
    approvalPattern: string;
    expiresAt: string;
};

export type PromotionCandidate = {
    id: number;
    status: 'pending' | 'approved' | 'rejected' | 'deferred';
    createdAt: string;
    reviewedAt: string | null;
    reviewedBy: string | null;
    templateId: string | null;
    recommendedModule: string | null;
    eventTypes: Array<string>;
    promotionCount: number;
    projectCount: number;
};

export type PromotionAcceptResult = {
    candidate: PromotionCandidate;
    patch: {
        filePath: string;
        fileExists: boolean;
        addedEventTypes: Array<string>;
        patch: string;
    };
};

export type DaemonFinding = {
    id: number;
    daemonId: number;
    daemonName: string;
    workflowRunId: number | null;
    category: 'vulnerability' | 'quality-issue' | 'optimization' | 'insight' | 'alert' | 'template-ecosystem' | 'promotion_candidate' | 'intent_classification_review' | 'edge_decay' | 'survivorship_bias_report';
    severity: 'info' | 'low' | 'medium' | 'high' | 'critical';
    title: string;
    description: string | null;
    evidence: {
        [key: string]: unknown;
    } | null;
    recommendation: string | null;
    autoFixAvailable: boolean | null;
    autoFixApplied: boolean | null;
    reviewStatus: 'pending' | 'approved' | 'rejected' | 'deferred' | 'quarantined' | null;
    reviewedBy: string | null;
    reviewedAt: string | null;
    tags: Array<string> | null;
    affectedFiles: Array<string> | null;
    affectedSymbols: Array<string> | null;
    createdAt: string;
};

export type DeadLetterEntryList = {
    data: Array<DeadLetterEntry>;
    total: number;
};

export type DeadLetterEntry = {
    id: number;
    organizationId: number | null;
    stream: string;
    consumerGroup: string;
    consumerName: string | null;
    messageId: string;
    idempotencyKey: string | null;
    failureReason: 'parse_error' | 'validation_error' | 'no_payload' | 'poison_max_deliveries' | 'handler_drop';
    deliveryCount: number;
    errorMessage: string | null;
    payload: {
        [key: string]: unknown;
    } | null;
    rawPayload: string | null;
    status: 'quarantined' | 'replaying' | 'replayed' | 'discarded';
    replayedAt: string | null;
    replayedByUserId: number | null;
    createdAt: string;
};

export type RuntimeFlagList = {
    data: Array<RuntimeFlag>;
};

export type RuntimeFlag = {
    key: 'platform.server_runs_schedulers' | 'platform.server_runs_market_data_aggregator' | 'platform.finance_pynecore_validation_enabled' | 'platform.finance_signal_aggregation_enabled' | 'platform.finance_signal_outcome_scoring_enabled' | 'platform.finance_strategy_runner_enabled' | 'platform.tool_scout_enabled' | 'finance.live_trading_enabled' | 'marketplace.auto_upgrade_acquisitions';
    label: string;
    description: string;
    scope: 'platform' | 'organization';
    defaultValue: boolean;
    risk: 'safe' | 'caution' | 'dangerous';
    appliesAt: 'immediate' | 'next-tick' | 'restart';
    envVar: string | null;
    value: boolean;
    source: 'db' | 'env' | 'default';
    organizationId: number | null;
};

export type RuntimeFlagUpdate = {
    value: boolean;
};

export type SystemOverview = {
    store: {
        configured: boolean;
        reachable: boolean;
        message: string | null;
    };
    generatedAt: string;
    hosts: Array<SystemHostSummary>;
    databases: Array<SystemDatabaseSummary>;
    findings: Array<SystemFinding>;
    engineJobs: Array<SystemEngineJob>;
    dataFreshness: Array<SystemDataFreshness>;
};

export type SystemHostSummary = {
    id: string;
    role: string | null;
    online: boolean;
    lastSeenAt: string | null;
    cpuCount: number | null;
    cpuBusy: number | null;
    memoryUsed: number | null;
    memoryTotalBytes: number | null;
    diskUsedMax: number | null;
    loadPerCpu: number | null;
    uptimeSeconds: number | null;
    gpuBusy: number | null;
    temperatureMax: number | null;
    cpuTrend: Array<number>;
    memoryTrend: Array<number>;
};

export type SystemDatabaseSummary = {
    id: 'app' | 'market';
    hostId: string | null;
    sizeBytes: number | null;
    growthBytesPerDay: number | null;
    connections: number | null;
    maxConnections: number | null;
    cacheHit: number | null;
    transactionsPerSecond: number | null;
    xidAge: number | null;
};

export type SystemFinding = {
    code: string;
    severity: 'warning' | 'danger';
    scope: 'host' | 'database' | 'engine' | 'data';
    target: string;
    message: string;
    value: number;
};

export type SystemEngineJob = {
    name: string;
    schedule: string;
    enabled: boolean;
    runningSeconds: number | null;
    lastStartedAt: string | null;
    lastFinishedAt: string | null;
    lastDurationMs: number | null;
    longestRecentMs: number | null;
    typicalMs: number | null;
    lastOutcome: 'succeeded' | 'failed' | null;
    lastError: string | null;
    runs: number;
    failures: number;
    skippedLastDay: {
        still_running: number;
        other_replica: number;
        egress_hold: number;
    };
    updatedAt: string;
};

export type SystemDataFreshness = {
    source: string;
    part: string | null;
    newestAt: string | null;
    ageSeconds: number | null;
    series: number;
    staleAfterSeconds: number | null;
    checkedAt: string | null;
};

export type SystemHost = SystemHostSummary & {
    kernel: string | null;
    architecture: string | null;
    filesystems: Array<{
        mountpoint: string;
        sizeBytes: number | null;
        availBytes: number | null;
        usedRatio: number | null;
    }>;
    hasGpu: boolean;
};

export type MetricSeriesSet = {
    range: '1h' | '6h' | '24h' | '7d' | '30d' | '90d' | '1y';
    stepSeconds: number;
    start: string;
    end: string;
    unit: 'ratio' | 'bytes' | 'bytes_per_second' | 'per_second' | 'count' | 'seconds' | 'celsius' | 'watts' | 'cores';
    series: Array<{
        key: string;
        label: string;
        stat: 'avg' | 'max' | 'min';
        points: Array<{
            t: number;
            v: number;
        }>;
    }>;
};

export type SystemDatabase = SystemDatabaseSummary & {
    connectionsByState: Array<{
        state: string;
        count: number;
    }>;
    longestTransactionSeconds: number | null;
    longestQuerySeconds: number | null;
    schemas: Array<{
        name: string;
        bytes: number;
    }>;
    relations: Array<{
        name: string;
        bytes: number;
        kind: string;
        growthBytesPerDay: number | null;
    }>;
    compression: Array<{
        name: string;
        beforeBytes: number;
        afterBytes: number;
        chunks: {
            compressed: number;
            partial: number;
            uncompressed: number;
        } | null;
        dueChunks: number;
    }>;
    deadTuples: Array<{
        name: string;
        count: number;
    }>;
    unusedIndexes: Array<{
        name: string;
        bytes: number;
    }>;
    jobs: Array<{
        name: string;
        relation: string;
        failures: number;
        lastOk: boolean;
        overdueSeconds: number;
        scheduled: boolean;
    }>;
    statementsCollected: boolean;
    statementTable: {
        entries: number;
        max: number;
        evictions: number;
        textBytes: number;
    } | null;
};

export type SystemStatement = {
    queryId: string;
    query: string;
    calls: number;
    totalMs: number;
    meanMs: number;
    rows: number;
    blocksRead: number;
    tempBlocksWritten: number;
};

export type SystemRedis = {
    servers: Array<{
        hostId: string;
        usedMemoryBytes: number | null;
        peakMemoryBytes: number | null;
        fragmentationRatio: number | null;
        clients: number | null;
        blockedClients: number | null;
        commandsPerSecond: number | null;
        hitRatio: number | null;
        evictedLastHour: number | null;
        keys: number | null;
    }>;
    streams: Array<{
        name: string;
        length: number;
        groups: Array<{
            name: string;
            pending: number;
            lag: number | null;
        }>;
    }>;
};

export type Order = {
    id: number;
    clientOrderId: string | null;
    exchangeOrderId: string | null;
    symbol: string;
    side: 'buy' | 'sell';
    type: string;
    quantity: string | number;
    filledQuantity?: string | number;
    price: string | number | null;
    avgFillPrice?: string | number | null;
    status: string;
    createdAt: string;
    updatedAt: string;
};

export type OrderCreate = {
    symbol: string;
    side: 'buy' | 'sell';
    type: 'market' | 'limit' | 'stop_market' | 'stop_limit' | 'trailing_stop';
    quantity: number;
    price?: number;
    stopPrice?: number;
    stopLoss?: number;
    takeProfit?: number;
    leverage?: number;
    reduceOnly?: boolean;
    postOnly?: boolean;
    strategyId?: number;
    timeInForce?: 'GTC' | 'IOC' | 'FOK';
    idempotency_key?: string;
};

export type Trade = {
    id: number;
    symbol: string;
    side: string;
    entryPrice: string | null;
    exitPrice: string | null;
    quantity: string;
    netPnl: string | null;
    pnlPercent: string | null;
    entryTime: string;
    exitTime: string | null;
    exitReason: string | null;
};

export type Position = {
    id: number;
    symbol: string;
    side: string;
    quantity: string;
    entryPrice: string;
    currentPrice: string | null;
    unrealizedPnl: string | null;
    unrealizedPnlPercent: string | null;
    leverage: number | null;
    stopLoss: string | null;
    takeProfit: string | null;
    openedAt: string | null;
};

export type PositionCloseRequest = {
    quantity?: number;
};

export type RiskLimitList = {
    data: Array<RiskLimit>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        has_more: boolean;
        next: string | null;
    };
    meta: {
        server_time: string;
    };
};

export type RiskLimit = {
    id: number;
    organization_id: number;
    scope: 'org' | 'account' | 'strategy';
    scope_id: string | null;
    metric: 'max_leverage' | 'max_open_positions' | 'position_size_pct' | 'gross_exposure_pct' | 'net_exposure_pct' | 'daily_loss_pct' | 'max_drawdown_pct' | 'max_consecutive_losses' | 'single_name_concentration_pct' | 'requires_stop_loss';
    threshold_soft: string | null;
    threshold_hard: string | null;
    action: 'alert' | 'block' | 'halt';
    enabled: boolean;
    description: string | null;
    created_by_user_id: number | null;
    created_at: string | null;
    updated_at: string | null;
};

export type RiskLimitCreate = {
    scope: 'org' | 'account' | 'strategy';
    scope_id?: string | null;
    metric: 'max_leverage' | 'max_open_positions' | 'position_size_pct' | 'gross_exposure_pct' | 'net_exposure_pct' | 'daily_loss_pct' | 'max_drawdown_pct' | 'max_consecutive_losses' | 'single_name_concentration_pct' | 'requires_stop_loss';
    threshold_soft?: string | null;
    threshold_hard?: string | null;
    action?: 'alert' | 'block' | 'halt';
    enabled?: boolean;
    description?: string | null;
};

export type RiskLimitUpdate = {
    threshold_soft?: string | null;
    threshold_hard?: string | null;
    action?: 'alert' | 'block' | 'halt';
    enabled?: boolean;
    description?: string | null;
};

export type RiskBreachList = {
    data: Array<RiskBreach>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        has_more: boolean;
        next: string | null;
    };
    meta: {
        server_time: string;
    };
};

export type RiskBreach = {
    id: number;
    organization_id: number;
    risk_limit_id: number;
    scope: 'org' | 'account' | 'strategy';
    scope_id: string | null;
    metric: 'max_leverage' | 'max_open_positions' | 'position_size_pct' | 'gross_exposure_pct' | 'net_exposure_pct' | 'daily_loss_pct' | 'max_drawdown_pct' | 'max_consecutive_losses' | 'single_name_concentration_pct' | 'requires_stop_loss';
    observed_value: string;
    severity: 'info' | 'low' | 'medium' | 'high' | 'critical';
    status: 'open' | 'alerted' | 'escalated' | 'accepted' | 'resolved';
    halted: boolean;
    opened_at: string | null;
    resolved_at: string | null;
    accepted_by_user_id: number | null;
    escalation_decision_id: number | null;
    created_at: string | null;
    updated_at: string | null;
};

export type RiskBreachEscalate = {
    decision_id: number;
};

export type RiskHaltList = {
    data: Array<RiskBreachForHalt>;
    paging: {
        cursors: {
            before: string | null;
            after: string | null;
        };
        has_more: boolean;
        next: string | null;
    };
    meta: {
        server_time: string;
    };
};

export type RiskBreachForHalt = {
    id: number;
    organization_id: number;
    risk_limit_id: number;
    scope: 'org' | 'account' | 'strategy';
    scope_id: string | null;
    metric: 'max_leverage' | 'max_open_positions' | 'position_size_pct' | 'gross_exposure_pct' | 'net_exposure_pct' | 'daily_loss_pct' | 'max_drawdown_pct' | 'max_consecutive_losses' | 'single_name_concentration_pct' | 'requires_stop_loss';
    observed_value: string;
    severity: 'info' | 'low' | 'medium' | 'high' | 'critical';
    status: 'open' | 'alerted' | 'escalated' | 'accepted' | 'resolved';
    halted: boolean;
    opened_at: string | null;
    resolved_at: string | null;
    accepted_by_user_id: number | null;
    escalation_decision_id: number | null;
    created_at: string | null;
    updated_at: string | null;
};

export type RiskHaltActivate = {
    breach_id: number;
    decision_id?: number;
};

export type RiskStatus = {
    halted: boolean;
    open_breach_count: number;
    halted_breach_count: number;
};

export type ActiveStrategy = {
    id: string;
    name: string;
    symbols: Array<string>;
    timeframes: Array<string>;
    isActive: boolean;
    lifecycleState?: string;
    deployMode?: 'live' | 'paper' | 'alert_only' | null;
    deployedAt?: string | null;
    currentSharpe?: string | null;
    currentWinRate?: string | null;
    totalSignals?: number | null;
    totalPnl?: string | null;
    parameters?: {
        [key: string]: number | string | boolean;
    };
    config?: ActiveStrategyConfig;
    state?: StrategyState;
    info?: Strategy | null;
};

export type ActiveStrategyConfig = {
    id: number;
    userId: number | null;
    name: string;
    version: string | null;
    description: string | null;
    type: 'trend_following' | 'mean_reversion' | 'momentum' | 'volatility_breakout' | 'scalping' | 'swing' | 'arbitrage' | 'custom';
    parameters: {
        [key: string]: number | string | boolean;
    };
    symbols: Array<string>;
    timeframes: Array<string>;
    exchanges: Array<string> | null;
    riskPerTrade: string | null;
    maxPositions: number | null;
    maxDailyTrades: number | null;
    isActive: boolean | null;
    isPaperTrading: boolean | null;
    cachedMetrics?: {
        totalTrades?: number;
        winRate?: number;
        profitFactor?: number;
        sharpeRatio?: number;
        maxDrawdown?: number;
        netProfitPercent?: number;
    } | null;
    status: 'development' | 'paper_trading' | 'paper_trading_completed' | 'retired' | 'live' | null;
    deployMode: 'live' | 'paper' | 'alert_only' | null;
    isDeployed: boolean | null;
    lifecycleState: 'candidate' | 'research_brief' | 'backtest_pending' | 'backtest_done_pass' | 'backtest_done_fail' | 'risk_pending' | 'risk_cleared' | 'risk_rejected' | 'paper_trading' | 'paper_trading_completed' | 'pending_live_approval' | 'live_trading' | 'retired' | 'archived' | 'watchlist';
    paperTradeStartedAt: string | null;
    liveTradeStartedAt: string | null;
    source: string | null;
    sourceUrl: string | null;
    thesis: string | null;
    marketConditions: Array<string> | null;
    assetClasses: Array<string> | null;
    logicDoc?: unknown;
    signalDoc?: unknown;
    sourceDoc?: unknown;
    runtimeState: {
        [key: string]: unknown;
    } | null;
    parentVersionId: number | null;
    baselineSharpe: string | null;
    baselineWinRate: string | null;
    currentSharpe: string | null;
    currentWinRate: string | null;
    totalSignals: number | null;
    totalTrades: number | null;
    totalPnl: string | null;
    deployedAt: string | null;
    retiredAt: string | null;
    lastOptimizationAt: string | null;
    organizationId: number;
    teamId: number | null;
    visibility: string | null;
    pricingModel: string | null;
    priceUsd: string | null;
    createdAt: string;
    updatedAt: string;
    lastSignalAt: string | null;
};

export type StrategyState = {
    isActive: boolean;
    currentPosition: 'long' | 'short' | 'flat';
    entryPrice?: number;
    entryTime?: string;
    indicators: {
        [key: string]: number;
    };
    lastSignal?: StrategySignal;
};

export type StrategySignal = {
    type: 'long' | 'short' | 'close_long' | 'close_short' | 'none';
    symbol: string;
    timeframe: '1m' | '3m' | '5m' | '15m' | '30m' | '1h' | '2h' | '4h' | '6h' | '12h' | '1d' | '1w';
    timestamp: string;
    price: number;
    confidence: number;
    stopLoss?: number;
    takeProfit?: number;
    quantity?: number;
    strategyId: string;
    strategyName: string;
    strategyVersion: string;
    reason?: string;
    indicators?: {
        [key: string]: number;
    };
};

export type ActiveStrategyCreate = {
    name: string;
    symbols: Array<string>;
    timeframes: Array<string>;
    parameters?: {
        [key: string]: number | string | boolean;
    };
    riskPerTrade?: number;
    maxPositions?: number;
};

export type ActiveStrategyParametersUpdate = {
    parameters: {
        [key: string]: number | string | boolean;
    };
};

export type StrategyDeploymentActionResult = {
    strategy: ActiveStrategyConfig;
    message: string;
};

export type StrategyDeployCreate = {
    mode?: 'paper' | 'live' | 'alert_only';
};

export type StrategyDeploymentStatus = {
    id: number;
    name: string;
    status: 'development' | 'paper_trading' | 'paper_trading_completed' | 'retired' | 'live' | null;
    isDeployed: boolean | null;
    deployMode: 'live' | 'paper' | 'alert_only' | null;
    currentSharpe: string | null;
    currentWinRate: string | null;
    totalSignals: number | null;
    totalTrades: number | null;
    totalPnl: string | null;
    deployedAt: string | null;
    organizationId: number;
};

export type StrategyDocsResult = {
    logicDoc: StrategyLogicDoc;
    signalDoc: SignalGenerationDoc;
    sourceDoc: SourceReferenceDoc;
};

export type StrategyLogicDoc = {
    thesis: string;
    investmentRationale: string;
    entryRules: Array<{
        condition: string;
        indicator?: string;
        parameters?: {
            [key: string]: number;
        };
        description: string;
    }>;
    exitRules: Array<{
        condition: string;
        indicator?: string;
        parameters?: {
            [key: string]: number;
        };
        description: string;
    }>;
    riskManagement: {
        stopLossType: string;
        stopLossParams: {
            [key: string]: number;
        };
        takeProfitType: string;
        takeProfitParams: {
            [key: string]: number;
        };
        positionSizing: string;
        maxDrawdownLimit: number;
    };
    marketConditions: {
        idealRegimes: Array<string>;
        avoidRegimes: Array<string>;
        idealVolatility: 'low' | 'medium' | 'high' | 'any';
    };
    assetClasses: Array<string>;
    timeframes: Array<string>;
    theoreticalBasis?: string;
    academicReferences?: Array<string>;
};

export type SignalGenerationDoc = {
    dataSources: Array<{
        type: 'candles' | 'onchain' | 'sentiment' | 'macro' | 'options' | 'orderflow';
        required: boolean;
        description: string;
    }>;
    indicators: Array<{
        name: string;
        parameters: {
            [key: string]: number;
        };
        calculation: string;
        purpose: string;
    }>;
    signalTypes: Array<{
        type: 'long' | 'short' | 'close_long' | 'close_short';
        conditions: Array<string>;
        confidenceModel: string;
    }>;
    tunableParameters: Array<{
        name: string;
        currentValue: number;
        range: {
            min: number;
            max: number;
            step: number;
        };
        sensitivity: 'low' | 'medium' | 'high';
        description: string;
    }>;
    expectedPerformance: {
        winRate: number;
        sharpeRatio: number;
        signalFrequency: string;
        avgHoldingPeriod: string;
    };
    computeRequirements: {
        minCandles: number;
        updateFrequency: string;
        latencySensitive: boolean;
    };
};

export type SourceReferenceDoc = {
    origin: 'ai_discovered' | 'quant_research' | 'user_provided' | 'system_builtin' | 'imported' | 'github' | 'tradingview';
    sourceUrl?: string;
    sourceAgent?: string;
    sourceWorkflow?: string;
    discoveredAt?: string;
    validationHistory: Array<{
        stage: 'backtest' | 'walk_forward' | 'paper' | 'live';
        date: string;
        result: 'pass' | 'fail';
        metrics?: {
            [key: string]: number;
        };
        notes?: string;
    }>;
    versionChangelog: Array<{
        version: string;
        date: string;
        changedBy: string;
        changeType: 'params' | 'rules' | 'deployment' | 'retirement';
        description: string;
    }>;
    performanceEvolution: Array<{
        date: string;
        sharpe: number;
        winRate: number;
        drawdown: number;
    }>;
};

export type StrategyDeploymentReadinessResult = {
    ready: boolean;
    issues: Array<string>;
};

export type BacktestRunResult = {
    success: boolean;
    result: {
        metrics: BacktestMetrics;
        tradesCount: number;
        trades: Array<BacktestTrade>;
        equityCurve: Array<{
            date: string;
            equity: number;
        }>;
        monthlyReturns?: Array<{
            month: string;
            return: number;
        }>;
    };
};

export type BacktestMetrics = {
    totalTrades: number;
    winningTrades: number;
    losingTrades: number;
    winRate: number;
    avgWin: number;
    avgLoss: number;
    profitFactor: number;
    sharpeRatio: number;
    sortinoRatio?: number;
    maxDrawdown: number;
    maxDrawdownPercent: number;
    netProfit: number;
    netProfitPercent: number;
    avgTradeDuration?: number;
    expectancy?: number;
};

export type BacktestTrade = {
    id: string;
    symbol: string;
    side: 'long' | 'short';
    entryDate: string;
    entryPrice: number;
    exitDate: string;
    exitPrice: number;
    quantity: number;
    pnl: number;
    pnlPercent: number;
    commission: number;
    exitReason: 'signal' | 'stop_loss' | 'take_profit' | 'trailing_stop' | 'end_of_test';
    mae?: number;
    mfe?: number;
};

export type BacktestCreate = {
    strategyName: string;
    symbol: string;
    timeframe: string;
    startDate: string;
    endDate: string;
    initialCapital?: number;
    commission?: number;
    slippage?: number;
    parameters?: {
        [key: string]: number | string | boolean;
    };
    riskPerTrade?: number;
};

export type IngestionJob = {
    id: number;
    name: string;
    definitionId: number;
    definitionName: string;
    description: string | null;
    tags: Array<string>;
    scheduleEnabled: boolean;
    schedule: {
        [key: string]: unknown;
    } | null;
    lifecycleStatus: 'active' | 'paused' | 'blocked' | 'archived';
    lastRunAt: string | null;
    nextRunAt: string | null;
    runCount: number;
    consecutiveFailures: number;
    blockedUntil: string | null;
    lastErrorCode: string | null;
    run?: IngestionJobRunHandle;
};

export type IngestionJobRunHandle = {
    id: string;
    status: string;
    workflowId: string;
};

export type IngestionJobRunRequest = {
    context?: {
        [key: string]: unknown;
    };
};

export type Candle = {
    time: string;
    open: number;
    high: number;
    low: number;
    close: number;
    volume: number;
};

export type OrderBookResult = {
    symbol: string;
    exchange: string;
    timestamp: string;
    bids: Array<OrderBookLevel>;
    asks: Array<OrderBookLevel>;
    bestBid: number;
    bestAsk: number;
    spread: number;
    midPrice: number;
};

export type OrderBookLevel = {
    price: number;
    quantity: number;
};

export type BackfillCreate = {
    symbol: string;
    timeframe: '1m' | '3m' | '5m' | '15m' | '30m' | '1h' | '2h' | '4h' | '6h' | '12h' | '1d' | '1w';
    startDate: string;
    endDate?: string;
};

export type MarketDataAvailabilityResult = {
    symbol: string;
    timeframe: string;
    requestedRange: {
        start: string;
        end: string;
    };
    hasData: boolean;
    count: number;
    firstCandle: string | null;
    lastCandle: string | null;
};

export type EconomicCalendar = {
    events: Array<EconomicEvent>;
    degraded?: boolean;
};

export type EconomicEvent = {
    releaseId: string;
    releaseName: string;
    date: string;
};

export type AnalysisAgentRunResult = {
    success: boolean;
    result: {
        timestamp: string;
        symbol: string;
        consensusAction: 'buy' | 'sell' | 'hold' | 'close' | null;
        consensusConfidence: number;
        conflictingSignals: boolean;
        finalRecommendation: AgentRecommendation | null;
        agentResults: Array<AnalysisAgentResult>;
    };
};

export type AnalysisAgentResult = {
    agent: string;
    type: string;
    confidence: number;
    reasoning: string;
    recommendations: Array<AgentRecommendation>;
    executionTimeMs: number;
};

export type AnalysisAgentRunCreate = {
    symbol: string;
    timeframe: string;
    prices: Array<number>;
    volumes?: Array<number>;
    indicators?: {
        [key: string]: number;
    };
    regime?: string;
    equity?: number;
};

export type AnalysisAgentStatusResult = {
    agentCount: number;
    enabledCount: number;
    agents: Array<AnalysisAgentStatus>;
};

export type AnalysisAgentStatus = {
    name: string;
    type: string;
    enabled: boolean;
    priority: number;
};

export type AnalysisAgentEnabledUpdate = {
    enabled: boolean;
};

export type CurrentSession = {
    timestamp: string;
    currentSessions: Array<SessionName>;
    isOverlapPeriod: boolean;
    sessionInfo: Array<SessionInfo>;
};

export enum SessionName {
    ASIA = 'asia',
    EUROPE = 'europe',
    US = 'us',
    OVERLAP_ASIA_EUROPE = 'overlap_asia_europe',
    OVERLAP_EUROPE_US = 'overlap_europe_us'
}

export type SessionInfo = {
    name: SessionName;
    startHour: number;
    endHour: number;
    description: string;
};

export type SessionTimesResult = {
    asia: SessionInfo;
    europe: SessionInfo;
    us: SessionInfo;
    overlap_asia_europe: SessionInfo;
    overlap_europe_us: SessionInfo;
};

export type OpeningRangeResult = {
    success: boolean;
    openingRange: {
        [key: string]: unknown;
    };
    currentPrice: number;
    breakoutSignal: {
        [key: string]: unknown;
    };
};

export type SessionAnalysisCreate = {
    symbol: string;
    candles: Array<SessionCandle>;
    session: SessionName;
    rangeMinutes?: number;
};

export type SessionCandle = {
    time: string;
    open: number;
    high: number;
    low: number;
    close: number;
    volume: number;
};

export type SessionStatsResult = {
    success: boolean;
    session: SessionName;
    statistics: {
        [key: string]: unknown;
    };
    patterns: Array<{
        [key: string]: unknown;
    }>;
};

export type OrderBookAnalysis = {
    symbol: string;
    timestamp: string;
    imbalance: {
        ratio: number;
        direction: 'buy_pressure' | 'sell_pressure' | 'neutral';
        strength: number;
    };
    liquidityLevels: Array<{
        price: number;
        volume: number;
        significance: 'major' | 'minor';
        type: 'support' | 'resistance';
        distance: number;
    }>;
    bidWall?: {
        price: number;
        volume: number;
    };
    askWall?: {
        price: number;
        volume: number;
    };
    depthScore: number;
    spreadQuality: string;
};

export type OrderBookAnalyzeCreate = {
    symbol: string;
    bids: Array<Array<number>>;
    asks: Array<Array<number>>;
};

export type OrderBookHeatmapCreate = {
    symbol: string;
    bids: Array<Array<number>>;
    asks: Array<Array<number>>;
    priceRange?: number;
};

export type ConfluenceAnalysisResult = {
    success: boolean;
    analysis: {
        symbol: string;
        timeframe: string;
        timestamp: string | string;
        sources: Array<ConfluenceSource>;
        overallSignal: ConfluenceSignalDirection;
        overallStrength: number;
        overallConfidence: number;
        agreementRatio: number;
        conflictLevel: 'none' | 'low' | 'medium' | 'high';
        recommendation: 'strong_buy' | 'buy' | 'neutral' | 'sell' | 'strong_sell';
        confluenceScore: number;
        meetsMinimumConfluence?: boolean;
        [key: string]: unknown;
    };
};

export type ConfluenceSource = {
    name: string;
    type: ConfluenceSourceType;
    signal: ConfluenceSignalDirection;
    strength: number;
    confidence: number;
    weight?: number;
};

export enum ConfluenceSourceType {
    STRATEGY = 'strategy',
    INDICATOR = 'indicator',
    PATTERN = 'pattern',
    ML = 'ml',
    AGENT = 'agent'
}

export enum ConfluenceSignalDirection {
    LONG = 'long',
    SHORT = 'short',
    CLOSE_LONG = 'close_long',
    CLOSE_SHORT = 'close_short',
    NONE = 'none'
}

export type ConfluenceAnalyzeCreate = {
    symbol: string;
    timeframe: string;
    sources: Array<ConfluenceSource>;
};

export type ConfluenceFromSignalsCreate = {
    symbol: string;
    timeframe: string;
    signals?: Array<{
        strategy: string;
        signal: string;
        confidence: number;
    }>;
    mlPrediction?: {
        model?: string;
        direction: string;
        confidence: number;
    };
    patterns?: Array<{
        type: string;
        confidence: number;
        bullish: boolean;
    }>;
};

export type DiscoverySummaryResult = {
    stats: {
        contributors: number;
        content: number;
        strategies: number;
        approvedStrategies: number;
        signals: number;
    };
    topContributors: Array<{
        intelSourceId: string;
        handle: string;
        platform: string;
        strategiesDiscovered: number;
        strategiesApproved: number;
        avgSharpe: number;
    }>;
    recentActivity: Array<{
        date: string;
        harvested: number;
        extracted: number;
        organizationId: number;
    }>;
};

export type DiscoveryRunNowResult = {
    workflowName: string;
    run: {
        id: string;
        status: string;
        workflowId: string;
    };
};

export type DiscoveryRunNowRequest = {
    workflowName?: string;
    context?: {
        [key: string]: unknown;
    };
};

export type StrategyDefinitionValidateResult = {
    valid: boolean;
    errors: Array<string>;
    definitionHash?: string;
    readiness?: {
        [key: string]: unknown;
    };
    extensionIssues?: Array<{
        [key: string]: unknown;
    }>;
    evaluation?: {
        [key: string]: unknown;
    };
    adapterResolution?: {
        [key: string]: unknown;
    };
};

export type StrategyDefinitionInput = {
    [key: string]: unknown;
};

export type StrategyDefinitionPersistResult = {
    data: DiscoveryRecord;
    definitionHash: string;
};

export type DiscoveryRecord = {
    [key: string]: unknown;
};

export type DiscoveryCreatedResult = {
    data: DiscoveryRecord;
};

export type StrategyDefinitionValidationRunInput = {
    [key: string]: unknown;
};

export type StrategyCorpusIngestionResult = {
    [key: string]: unknown;
};

export type StrategyCorpusIngestionInput = {
    [key: string]: unknown;
};

export type DiscoveryPaginatedList = {
    data: Array<DiscoveryRecord>;
    total: number;
    limit: number;
    offset: number;
};

export type StrategyDefinitionEvaluationInput = {
    [key: string]: unknown;
};

export type StrategyBucketDefinitionInput = {
    [key: string]: unknown;
};

export type StrategyBucketPersistResult = {
    data: DiscoveryRecord;
    bucketHash: string;
};

export type StrategyBucketPatchInput = {
    [key: string]: unknown;
};

export type StrategyBucketBacktestResult = {
    requestId: string;
    status: string;
    persistStatus: string;
};

export type StrategyBucketBacktestInput = {
    initialCapital?: number;
};

export type StrategyBucketEvaluationInput = {
    [key: string]: unknown;
};

export type StrategyExtensionDescriptorInput = {
    [key: string]: unknown;
};

export type StrategyAdapterResolutionRequestInput = {
    [key: string]: unknown;
};

export type StrategyAdapterResolutionInput = {
    [key: string]: unknown;
};

export type DataBlockerInput = {
    [key: string]: unknown;
};

export type DiscoveryList = {
    data: Array<DiscoveryRecord>;
};

export type ContributorCreate = {
    platform: 'twitter' | 'youtube' | 'substack' | 'podcast' | 'telegram' | 'discord' | 'tradingview';
    handle: string;
    name?: string;
    profileUrl?: string;
    seed?: boolean;
};

export type DiscoverySourceDetailResult = {
    contributor: DiscoveryRecord;
    strategies: Array<DiscoveryRecord>;
    signals: Array<DiscoveryRecord>;
    accuracy?: unknown;
};

export type DiscoveryContentStatsResult = {
    byPlatform: Array<DiscoveryRecord>;
    recentActivity: Array<DiscoveryRecord>;
};

export type DiscoveryContentDetailResult = {
    content: DiscoveryRecord;
    strategies: Array<DiscoveryRecord>;
};

export type DiscoveryStrategyStatsResult = {
    byCategory: Array<{
        category: string;
        total: number;
        approved: number;
        avgSharpe: number;
    }>;
    topContributors: Array<{
        intelSourceId: string;
        handle: string;
        platform: string;
        strategiesDiscovered: number;
        strategiesApproved: number;
        avgSharpe: number;
    }>;
    recentDiscoveries: Array<{
        date: string;
        discovered: number;
        approved: number;
    }>;
};

export type DiscoveredStrategyStatusUpdate = {
    status: 'approved' | 'rejected' | 'integrated';
    rejectionReason?: string;
};

export type AssetSentimentResult = {
    data: {
        asset: string;
        bullishSignals: number;
        bearishSignals: number;
        neutralSignals: number;
        weightedSentiment: number;
        intelSources: number;
    };
};

export type SignalAccuracyList = {
    data: Array<{
        asset: string;
        total: number;
        correct24h: number;
        accuracy24h: number;
    }>;
};

export type SignalActivityList = {
    data: Array<{
        date: string;
        signals: number;
        bullish: number;
        bearish: number;
    }>;
};

export type SignalList = {
    data: Array<IntelSourceSignal>;
};

export type IntelSourceSignal = {
    id: number;
    intelSourceId: number;
    dataId: number | null;
    sourceType: 'content' | 'event' | null;
    derivationMethod: 'explicit' | 'implicit' | null;
    asset: string;
    signalType: 'buy' | 'sell' | 'hold' | 'bullish' | 'bearish' | 'neutral';
    sentiment: 'bullish' | 'bearish' | 'neutral' | null;
    confidence: string | null;
    reasoning: string | null;
    targetPrice: string | null;
    stopPrice: string | null;
    timeframe: string | null;
    priceAtSignal: string | null;
    price1hLater: string | null;
    price4hLater: string | null;
    price24hLater: string | null;
    price7dLater: string | null;
    wasCorrect1h: boolean | null;
    wasCorrect4h: boolean | null;
    wasCorrect24h: boolean | null;
    wasCorrect7d: boolean | null;
    change1h: string | null;
    change4h: string | null;
    change24h: string | null;
    change7d: string | null;
    targetHit: boolean | null;
    targetHitAt: string | null;
    stopHit: boolean | null;
    stopHitAt: string | null;
    signalScore: string | null;
    rawSignalText: string | null;
    metadata: {
        [key: string]: unknown;
    } | null;
    signalAt: string;
    lastPriceUpdateAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type TradingViewWebhookResult = {
    success: boolean;
    alertId?: string;
    action?: string;
    symbol?: string;
    message?: string;
};

export type PineScriptCreate = {
    webhookUrl: string;
    secretKey: string;
    strategy: string;
};

export type TradingViewConfig = {
    allowedIps: Array<string>;
    secretConfigured: boolean;
};

export type TradingViewTokenResult = {
    token: string;
    webhookUrl: string;
};

export type WatchlistEntry = {
    id: number;
    ticker: string;
    companyName: string | null;
    addedAt: string | null;
    addedByRunId: number | null;
    addedByUserId: string | null;
    status: 'active' | 'archived' | 'under-review' | null;
    latestAnalysisId: number | null;
    latestRecommendation: 'STRONG_BUY' | 'BUY' | 'HOLD' | 'SELL' | 'STRONG_SELL' | null;
    latestCompositeScore: string | null;
    analysisCount: number | null;
    tags: Array<string> | null;
    notes: string | null;
    organizationId: number;
    teamId: number | null;
};

export type WatchlistAdd = {
    ticker: string;
    companyName?: string;
    tags?: Array<string>;
};

export type WatchlistAnalysis = {
    id: number;
    ticker: string;
    analyzedAt: string;
    workflowRunId: number | null;
    recommendation: 'STRONG_BUY' | 'BUY' | 'HOLD' | 'SELL' | 'STRONG_SELL' | null;
    targetPriceUsd: string | null;
    confidenceScore: string | null;
    compositeScore: string | null;
    scoreFundamental: string | null;
    scoreTechnical: string | null;
    scoreGrowth: string | null;
    scoreRisk: string | null;
    scoreMomentum: string | null;
    fullReport?: unknown;
    bullCase: string | null;
    bearCase: string | null;
    researchPoints?: unknown;
    organizationId: number;
    teamId: number | null;
    createdAt: string | null;
};

export type PortfolioComparison = {
    portfolio: Portfolio;
    holdingsCount: number;
    metrics: PerformanceMetrics;
};

export type Portfolio = {
    id: number;
    name: string;
    description: string | null;
    ownerType: 'organization' | 'user';
    ownerId: string;
    ownerName: string | null;
    portfolioType: 'testing' | 'production';
    riskProfileTier: 'conservative' | 'balanced' | 'growth' | 'aggressive';
    riskProfileConfig?: unknown;
    status: 'active' | 'paused' | 'archived' | null;
    currency: string | null;
    managedByAgent: boolean | null;
    lastAgentReviewAt: string | null;
    agentRecommendationPending: boolean | null;
    organizationId: number;
    teamId: number | null;
    createdAt: string;
    updatedAt: string;
};

export type PerformanceMetrics = {
    totalReturn?: number;
    annualizedReturn?: number;
    volatility?: number;
    sharpeRatio?: number;
    maxDrawdown?: number;
};

export type RiskProfile = {
    name: string;
    description?: string;
};

export type PortfolioCreate = {
    name: string;
    ownerType?: 'organization' | 'user';
    portfolioType?: 'testing' | 'production';
    riskTier?: 'conservative' | 'balanced' | 'growth' | 'aggressive';
};

export type Holding = {
    id: number;
    portfolioId: number;
    ticker: string;
    companyName: string | null;
    shares: string;
    averageCostUsd: string | null;
    targetWeightPct: string | null;
    latestAnalysisId: number | null;
    addedAt: string | null;
    updatedAt: string | null;
};

export type PortfolioUpdate = {
    name?: string;
    description?: string;
    status?: 'active' | 'paused' | 'archived';
    riskTier?: 'conservative' | 'balanced' | 'growth' | 'aggressive';
};

export type PortfolioSnapshot = {
    id?: number;
    portfolioId: number;
    triggerType: 'scheduled' | 'rebalance' | 'manual' | 'market-close' | null;
    totalValueUsd: string | null;
    cashValueUsd: string | null;
    equityValueUsd: string | null;
    dayPnlUsd: string | null;
    dayPnlPct: string | null;
    totalPnlUsd: string | null;
    totalPnlPct: string | null;
    annualizedReturn: string | null;
    volatilityAnnual: string | null;
    sharpeRatio: string | null;
    maxDrawdownPct: string | null;
    currentDrawdown: string | null;
    holdingsSnapshot?: unknown;
    sectorBreakdown?: unknown;
    topHoldings?: unknown;
    snapshotAt: string;
};

export type RecommendationAction = {
    recommendationId: number;
    decidedBy?: string;
    notes?: string;
};

export type HoldingCreate = {
    ticker: string;
    quantity: number;
    avgCostBasis?: number;
};

export type HoldingUpdate = {
    quantity?: number;
    avgCostBasis?: number;
};

export type ContractEventList = {
    events: Array<ContractEvent>;
};

export type ContractEvent = {
    id: number;
    runId: number;
    stepId: string;
    eventType: string;
    severity: 'info' | 'warning' | 'error' | 'critical';
    details?: unknown;
    createdAt: string | string;
};

export type ContractHealth = {
    health: {
        totalEdges: number;
        compatible: number;
        mismatches: number;
        disputes: number;
        unknown: number;
        healthRatio: number;
        edges: Array<ContractEdgeHealth>;
        recentViolations: {
            [key: string]: number;
        };
        recentEvents: Array<ContractEvent>;
    };
};

export type ContractEdgeHealth = {
    sourceStepId: string;
    sourceStepName: string;
    targetStepId: string;
    targetStepName: string;
    status: 'compatible' | 'mismatch' | 'unknown' | 'resolved' | 'dispute';
    missingFields: Array<string>;
    suggestions?: Array<ContractSuggestion>;
};

export type ContractSuggestion = {
    type: string;
    processorType?: string;
    missingFields?: Array<string>;
    mappings?: Array<{
        source: string;
        target: string;
    }>;
    autoApplicable?: boolean;
};

export type ContractApplyRequest = {
    workflowId: number;
    sourceStepId: number;
    mappings: Array<{
        source: string;
        target: string;
    }>;
};

export type AlertCheckResult = {
    success: boolean;
    triggered: Array<{
        id: string;
        condition: AlertCondition;
        targetPrice: number;
    }>;
};

export enum AlertCondition {
    CROSSES_ABOVE = 'crosses_above',
    CROSSES_BELOW = 'crosses_below',
    GREATER_THAN = 'greater_than',
    LESS_THAN = 'less_than',
    PERCENT_CHANGE_UP = 'percent_change_up',
    PERCENT_CHANGE_DOWN = 'percent_change_down'
}

export type AlertCheckCreate = {
    symbol: string;
    price: number;
};

export type PriceAlert = {
    id: string;
    symbol: string;
    condition: AlertCondition;
    price: number;
    percentChange?: number;
    message?: string;
    channels?: Array<AlertChannel>;
    enabled: boolean;
    triggered: boolean;
};

export enum AlertChannel {
    TELEGRAM = 'telegram',
    DISCORD = 'discord',
    EMAIL = 'email',
    WEBHOOK = 'webhook'
}

export type AlertStats = {
    total: number;
    enabled: number;
    triggered: number;
    bySymbol?: {
        [key: string]: number;
    };
};

export type PriceAlertCreate = {
    symbol: string;
    condition: AlertCondition;
    price: number;
    percentChange?: number;
    message?: string;
    channels?: Array<AlertChannel>;
};

export type AlertEnabledUpdate = {
    enabled: boolean;
};

export type AlertRule = {
    id: string;
    kind: AlertRuleKind;
    symbol: string | null;
    exchange: string | null;
    timeframe: string | null;
    params: AlertRuleParams;
    channels: Array<AlertRuleChannel>;
    cooldownSeconds: number;
    enabled: boolean;
    lastValue: number | null;
    lastFiredAt: string | null;
    createdAt: string;
    updatedAt: string;
    description: string;
};

export enum AlertRuleKind {
    PRICE_CROSS = 'price_cross',
    PRICE_CHANGE_PCT = 'price_change_pct',
    FUNDING_THRESHOLD = 'funding_threshold',
    OPEN_INTEREST_CHANGE_PCT = 'open_interest_change_pct',
    REGIME_TRANSITION = 'regime_transition',
    INSIGHT_FROM_SOURCE = 'insight_from_source',
    WALLET_ACTIVITY = 'wallet_activity'
}

export type AlertRuleParams = {
    [key: string]: unknown;
};

export enum AlertRuleChannel {
    TELEGRAM = 'telegram',
    DISCORD = 'discord',
    SLACK = 'slack',
    EMAIL = 'email',
    WEBHOOK = 'webhook'
}

export type AlertRuleCreate = {
    kind: AlertRuleKind;
    symbol?: string | null;
    exchange?: string | null;
    timeframe?: string | null;
    params: AlertRuleParams;
    channels?: Array<AlertRuleChannel>;
    cooldownSeconds?: number;
    enabled?: boolean;
};

export type AlertRuleUpdate = {
    symbol?: string | null;
    exchange?: string | null;
    timeframe?: string | null;
    params?: AlertRuleParams;
    channels?: Array<AlertRuleChannel>;
    cooldownSeconds?: number;
    enabled?: boolean;
};

export type MarketEventReactionType = {
    id: MarketEventReactionId;
    title: string;
    summary: string;
    threshold: {
        meaning: string;
        default: number;
        min: number;
        max: number;
    };
    defaultSymbol: string | null;
    needsSymbol: boolean;
    playbookName: string;
    steps: Array<string>;
};

export enum MarketEventReactionId {
    FLASH_CRASH = 'flash_crash',
    WHALE_DUMP = 'whale_dump',
    FUNDING_SPIKE = 'funding_spike',
    REGULATORY_NEWS = 'regulatory_news',
    CIRCUIT_BREAKER = 'circuit_breaker',
    BLACK_SWAN = 'black_swan',
    WALLET_MOVE = 'wallet_move'
}

export type MarketEventReaction = {
    id: number;
    reaction: MarketEventReactionId;
    title: string;
    symbol: string | null;
    ruleId: number;
    playbookEntityId: number;
    playbookName: string;
    enabled: boolean;
    lastFiredAt: string | null;
};

export type MarketEventReactionCreate = {
    reaction: MarketEventReactionId;
    symbol?: string;
    threshold?: number;
};

export type WalletWatch = {
    id: number;
    chain: string;
    address: string;
    label: string | null;
    reason: string | null;
    source: 'user' | 'workflow' | 'reaction';
    sourceRef: string | null;
    followed: boolean;
    createdAt: string;
    removedAt: string | null;
    lastActivityAt: string | null;
    rules: Array<WalletRuleSummary>;
};

export type WalletRuleSummary = {
    id: number;
    description: string;
    enabled: boolean;
};

export type WalletWatchCreate = {
    chain: 'ethereum' | 'base' | 'optimism' | 'arbitrum' | 'polygon' | 'solana' | 'hyperliquid' | 'polymarket';
    address: string;
    label?: string;
    reason?: string;
};

export type WalletWatchDetail = {
    watch: WalletWatch;
    moves: Array<WalletMove>;
    movesUnavailable: boolean;
};

export type WalletMove = {
    at: string;
    activity: 'transfer_in' | 'transfer_out' | 'exchange_deposit' | 'exchange_withdrawal' | 'fill';
    asset: string;
    symbol: string | null;
    amount: number;
    amountUsd: number | null;
    counterparty: string | null;
    counterpartyLabel: string | null;
    reference: string;
    backfill: boolean;
    firedRuleIds: Array<number>;
};

export type StrategyRunPersistResult = {
    status: 'created' | 'updated' | 'existing';
    data: StrategyRunRecord;
};

export type StrategyRunRecord = {
    id: number;
    organizationId: number;
    definitionId: number | null;
    bucketDefinitionId: number | null;
    adapterResolutionId: number | null;
    createdByWorkflowRunId: number | null;
    workOutputId: number | null;
    outputPartId: number | null;
    runId: string;
    schemaVersion: string;
    scope: string;
    runMode: 'research' | 'backtest' | 'walk_forward' | 'cross_validation' | 'monte_carlo' | 'paper' | 'shadow' | 'canary' | 'live';
    runStatus: 'scheduled' | 'running' | 'finished' | 'failed' | 'killed';
    researchOnly: boolean;
    passed: boolean | null;
    verdict: string | null;
    recommendation: string | null;
    strategyEntityId: number | null;
    bucketEntityId: number | null;
    effectiveFingerprint: string | null;
    paramSetHash: string | null;
    dataSnapshotId: string | null;
    costModelId: string | null;
    randomSeed: number | null;
    codeVersion: string | null;
    windowStart: string | null;
    windowEnd: string | null;
    dataFrequency: string | null;
    nObservations: number | null;
    statisticBasis: string | null;
    sharpe: string | null;
    sortino: string | null;
    maxDrawdown: string | null;
    cagr: string | null;
    totalReturn: string | null;
    totalFeesPaid: string | null;
    maxGrossExposure: string | null;
    winRate: string | null;
    profitFactor: string | null;
    totalTrades: number | null;
    fillRate: string | null;
    probabilisticSharpe: string | null;
    deflatedSharpe: string | null;
    pbo: string | null;
    walkForwardEfficiency: string | null;
    multipleTestingPvalue: string | null;
    errorRateControl: string | null;
    trialsCount: number | null;
    totalCostBps: string | null;
    marketImpactBps: string | null;
    feeBps: string | null;
    borrowCostBps: string | null;
    slippageModelKind: string | null;
    feeModelKind: string | null;
    fillModelKind: string | null;
    fillTiming: string | null;
    assumedFeeTier: string | null;
    costAssumptionSource: string | null;
    benchmarkSymbol: string | null;
    benchmarkExchange: string | null;
    benchmarkRelativeStatus: 'computed' | 'absent' | null;
    excessReturn: string | null;
    trackingError: string | null;
    informationRatio: string | null;
    benchmarkAlpha: string | null;
    benchmarkBeta: string | null;
    upCapture: string | null;
    downCapture: string | null;
    evaluationId: string | null;
    sourcePayload: {
        [key: string]: unknown;
    };
    artifactRefs: Array<{
        artifactId: string;
        kind: 'equity_curve' | 'returns_series' | 'trades_ledger' | 'orders_ledger' | 'fills_log' | 'positions_timeline' | 'drawdown_episodes' | 'signal_table' | 'exposure_series' | 'drawdown_series' | 'buy_hold_equity' | 'oos_returns_series' | 'per_trial_returns_matrix' | 'cpcv_paths' | 'tearsheet' | 'dataset_snapshot' | 'model_blob' | 'config_blob' | string;
        uri: string;
        contentDigest: string;
        rowCount?: number;
        timeAxisRef?: string;
        format?: 'parquet' | 'csv' | 'json' | string;
    }>;
    dataProvenance: Array<{
        requirementId: string;
        domain: 'ohlcv' | 'corporate_actions' | 'fundamentals' | 'estimates' | 'macro' | 'rates' | 'fx_forwards' | 'futures_chain' | 'options_chain' | 'options_greeks' | 'borrow' | 'l2_orderbook' | 'trades' | 'funding' | 'open_interest' | 'on_chain' | 'sentiment' | 'news' | 'constituents' | 'benchmark' | 'calendar' | 'custom' | string;
        vendor?: string;
        dataAdapterRef?: string;
        dataVintageId?: string;
        asOfTransactionTime?: string;
        coverageStart?: string;
        coverageEnd?: string;
        frequency?: string;
        contentHash?: string;
        pointInTimeCorrect?: boolean;
        survivorshipBiasFree?: boolean;
        delistingReturnsIncluded?: boolean;
        productionReady?: boolean;
        asOfPolicy?: {
            validTimeField?: string;
            transactionTimeField?: string;
            asOfTimestamp?: string;
            joinDirection?: 'backward' | 'forward' | 'nearest' | string;
            maxStaleness?: string;
        };
        dataVintage?: {
            dataVintageId?: string;
            vintageDate?: string;
            realtimeStart?: string;
            realtimeEnd?: string;
            dataRevisionPolicy?: 'as_originally_reported' | 'as_of_vintage' | 'latest_restated' | string;
        };
        availability?: {
            periodEndDate?: string;
            availabilityDate?: string;
            availabilityLagDays?: number;
            availabilityMode?: 'point_in_time_release_date' | 'fixed_lag' | string;
        };
        adjustmentPolicy?: {
            priceSeries?: 'raw' | 'split_adjusted' | 'split_dividend_adjusted' | 'total_return' | 'scaled_raw' | string;
            adjustmentAsOf?: 'decision_date' | 'dataset_vintage' | 'latest' | string;
            returnSeriesType?: 'price_return' | 'total_return' | string;
        };
        warmupBars?: number;
        warmupBarsRead?: number;
        firstSignalBar?: string;
        universe?: {
            key: string;
            pointInTime: boolean;
            survivorshipFree: boolean;
            asOf: string;
            declared?: boolean;
            missingMembers?: Array<string>;
            memberCount?: number;
            ranking?: {
                by: 'dollar_volume';
                limit: number;
                lookbackBars: number;
                rebalance: 'weekly' | 'monthly' | 'quarterly';
            };
            memberVendors?: {
                [key: string]: string;
            };
        };
    }>;
    sourceIds: Array<string>;
    evidenceIds: Array<string>;
    startedAt: string | null;
    finishedAt: string | null;
    evaluatedAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type StrategyRunInput = {
    [key: string]: unknown;
};

export type StrategyRunRequestPersistResult = {
    status: 'created' | 'updated' | 'existing';
    data: StrategyRunRequestRecord;
};

export type StrategyRunRequestRecord = {
    id: number;
    organizationId: number;
    definitionId: number | null;
    bucketDefinitionId: number | null;
    createdByWorkflowRunId: number | null;
    createdByUserId: number | null;
    experimentId: number | null;
    requestId: string;
    idempotencyKey: string | null;
    status: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled' | 'awaiting_preregistration';
    targetKind: 'bucket' | 'indicator' | 'definition';
    scope: string;
    runMode: 'research' | 'backtest' | 'walk_forward' | 'cross_validation' | 'monte_carlo' | 'paper' | 'shadow' | 'canary' | 'live';
    requestedEngine: string;
    requestedAdapterRef: string | null;
    workerTemplateSlug: string | null;
    workflowDefinitionId: number | null;
    workerTimeoutMs: number | null;
    priority: string;
    researchOnly: boolean;
    dataReadiness: 'unknown' | 'ready' | 'research_only' | 'blocked';
    providerUnlockIds: Array<string>;
    blockedReasons: Array<string>;
    requiredCapabilities: Array<string>;
    symbols: Array<string>;
    timeframe: string | null;
    runConfig: {
        [key: string]: unknown;
    };
    sourcePayload: {
        [key: string]: unknown;
    };
    sourceHash: string;
    dispatchedWorkflowRunId: number | null;
    dispatchedWorkerRunId: string | null;
    requestedAt: string;
    dispatchedAt: string | null;
    completedAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type StrategyRunRequestInput = {
    [key: string]: unknown;
};

export type StrategyRunList = {
    data: Array<StrategyRunRecord>;
    total: number;
    limit: number;
    offset: number;
};

export type StrategyRunRequestList = {
    data: Array<StrategyRunRequestRecord>;
    total: number;
    limit: number;
    offset: number;
};

export type StrategyRunResultResult = {
    header: StrategyRunListItem & {
        definitionId: string | null;
        bucketDefinitionId: string | null;
        schemaVersion: string;
        recommendation: string | null;
        definitionHash: string | null;
        paramSetHash: string | null;
        codeVersion: string | null;
        nObservations: number | null;
        statisticBasis: string | null;
        evaluatedAt: string | null;
    };
    summary: {
        portfolioStatistics: StrategyRunPortfolioStatistics;
        tradeStatistics: StrategyRunTradeStatistics;
        executionRealism: {
            [key: string]: unknown;
        };
        executionFeasibility: {
            [key: string]: unknown;
        };
        searchProvenance: {
            [key: string]: unknown;
        };
        robustness: Array<unknown>;
        runConfig: {
            [key: string]: unknown;
        };
        costAssumptionsApplied: {
            [key: string]: unknown;
        } | null;
        dataProvenance: Array<unknown>;
        benchmark: StrategyRunBenchmark | null;
        warnings: Array<string>;
        blockers: Array<string>;
        researchOnlyReasons: Array<string>;
    };
    artifacts: Array<StrategyRunArtifactIndexEntry>;
};

export type StrategyRunListItem = {
    id: string;
    runId: string;
    scope: string;
    runMode: string;
    runStatus: 'scheduled' | 'running' | 'finished' | 'failed' | 'killed';
    definitionVersion: number | null;
    researchOnly: boolean;
    passed: boolean | null;
    verdict: string | null;
    sharpe: number | null;
    maxDrawdown: number | null;
    totalReturn: number | null;
    totalTrades: number | null;
    windowStart: string | null;
    windowEnd: string | null;
    dataFrequency: string | null;
    ownParameters: boolean;
    startedAt: string | null;
    finishedAt: string | null;
    createdAt: string;
};

export type StrategyRunPortfolioStatistics = {
    startEquity?: string | number;
    endEquity?: string | number;
    totalReturn?: string | number;
    totalNetProfit?: string | number;
    compoundingAnnualReturn?: string | number;
    annualStandardDeviation?: string | number;
    annualVariance?: string | number;
    sharpeRatio?: string | number;
    probabilisticSharpeRatio?: string | number;
    deflatedSharpeRatio?: string | number;
    sortinoRatio?: string | number;
    annualizationFactor?: string | number;
    calmarRatio?: string | number;
    informationRatio?: string | number;
    trackingError?: string | number;
    alpha?: string | number;
    beta?: string | number;
    upCapture?: string | number;
    downCapture?: string | number;
    drawdown?: string | number;
    maxDrawdown?: string | number;
    drawdownRecovery?: string | number;
    portfolioTurnover?: string | number;
    valueAtRisk95?: string | number;
    valueAtRisk99?: string | number;
    winRate?: string | number;
    lossRate?: string | number;
    profitLossRatio?: string | number;
    totalFeesPaid?: string | number;
    returnsSkewness?: string | number;
    returnsKurtosis?: string | number;
    numReturnObservations?: number;
    probabilisticSharpeRatioDaily?: string | number;
    deflatedSharpeRatioDaily?: string | number;
    carryApplied?: boolean;
    carryTotalFrac?: string | number;
    [key: string]: unknown;
};

export type StrategyRunTradeStatistics = {
    profitFactor?: string | number;
    winLossRatio?: string | number;
    winRate?: string | number;
    totalTrades?: number;
    totalWinningTrades?: number;
    totalLosingTrades?: number;
    maxConsecutiveWinningTrades?: number;
    maxConsecutiveLosingTrades?: number;
    maximumClosedTradeDrawdown?: string | number;
    maximumIntraTradeDrawdown?: string | number;
    maximumEndTradeDrawdown?: string | number;
    averageEndTradeDrawdown?: string | number;
    averageMAE?: string | number;
    averageMFE?: string | number;
    largestMAE?: string | number;
    largestMFE?: string | number;
    totalFees?: string | number;
    totalCommission?: string | number;
    averageTrade?: string | number;
    averageWinningTrade?: string | number;
    averageLosingTrade?: string | number;
    largestWinningTrade?: string | number;
    largestLosingTrade?: string | number;
    grossProfit?: string | number;
    grossLoss?: string | number;
    netProfit?: string | number;
    longTrades?: number;
    shortTrades?: number;
    longNetProfit?: string | number;
    shortNetProfit?: string | number;
    maxRunUp?: string | number;
    fillGroupingMethod?: 'fill_to_fill' | 'flat_to_flat' | 'flat_to_reduced' | string;
    fillMatchingMethod?: 'fifo' | 'lifo' | string;
    rebalanceCount?: number;
    [key: string]: unknown;
};

export type StrategyRunArtifactIndexEntry = {
    kind: string;
    artifactId: string | null;
    artifactKey: string;
    rowCount: number | null;
    format: string;
    contentDigest: string;
};

export type StrategyRunArtifactResult = {
    runId: string;
    kind: string;
    format: string;
    mode: 'series' | 'table' | 'raw';
    artifactId: string | null;
    totalRows: number | null;
    points: Array<StrategyRunSeriesPoint> | null;
    downsampled: boolean | null;
    resolution: number | null;
    columns: Array<string> | null;
    rows: Array<{
        [key: string]: unknown;
    }> | null;
    offset: number | null;
    limit: number | null;
    payload?: unknown;
};

export type StrategyRunAnalytics = {
    schemaVersion: 'finance-run-analytics/v1';
    runId: string;
    initialCapital: number;
    periodsPerYear: number | null;
    bars: number;
    firstBar: string | null;
    lastBar: string | null;
    keyStats: {
        netProfit: number;
        netProfitPct: number | null;
        maxDrawdown: number;
        maxDrawdownPct: number;
        closedTrades: number;
        openTrades: number;
        profitableTrades: number;
        profitablePct: number | null;
        profitFactor: number | null;
    };
    returns: {
        totalReturn: number | null;
        cagr: number | null;
        sharpe: number | null;
        sortino: number | null;
        volatilityAnnual: number | null;
    };
    periodical: {
        daily?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
        weekly?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
        monthly?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
        quarterly?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
        yearly?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
    };
    benchmarking: {
        buyHoldReturn: number;
        outperformance: number;
        monthlyCorrelation: number | null;
        monthly: Array<{
            period: string;
            strategy: number | null;
            buyHold: number | null;
        }>;
    } | null;
    exposure: {
        average: number;
        max: number;
        timeInMarket: number;
    } | null;
    growthAndDecline: {
        runUps: {
            count: number;
            averageBars: number | null;
            maxAmount: number | null;
            maxPct: number | null;
            averageAmount: number | null;
            averagePct: number | null;
            currentAmount: number | null;
            currentPct: number | null;
        };
        drawdowns: {
            count: number;
            averageBars: number | null;
            maxAmount: number | null;
            maxPct: number | null;
            averageAmount: number | null;
            averagePct: number | null;
            currentAmount: number | null;
            currentPct: number | null;
        };
        maxDrawdownPctOfInitial: number;
        episodes: Array<{
            kind: 'run_up' | 'drawdown';
            start: string;
            end: string;
            amount: number;
            pct: number;
            bars: number;
            current: boolean;
        }>;
    };
    profitsAndLosses: {
        long: {
            trades: number;
            netProfit: number;
            grossProfit: number;
            grossLoss: number;
            winners: number;
        };
        short: {
            trades: number;
            netProfit: number;
            grossProfit: number;
            grossLoss: number;
            winners: number;
        };
        commission: number;
        bySignal: Array<{
            key: string;
            label: string;
            trades: number;
            winners: number;
            losers: number;
            netProfit: number;
        }>;
    };
    trades: {
        list: Array<{
            tradeNo: number;
            symbol: string | null;
            side: 'long' | 'short';
            status: 'closed' | 'open';
            entryTime: string | null;
            exitTime: string | null;
            entryPrice: number | null;
            exitPrice: number | null;
            size: number | null;
            pnl: number;
            returnPct: number;
            cumulativePnl: number | null;
            runUp: number | null;
            drawdown: number | null;
            barsHeld: number | null;
            fees: number;
            exitReason: string | null;
            entrySignals: Array<string>;
        }>;
        distribution: {
            bins: Array<{
                from: number;
                to: number;
                count: number;
            }>;
            winners: number;
            losers: number;
            breakEvens: number;
            expectancy: number | null;
            averageWin: number | null;
            averageLoss: number | null;
            largestProfit: number | null;
            largestLoss: number | null;
            outliersPnl: number;
            outliers: number;
        };
        streaks: {
            longestWin: number;
            longestLoss: number;
            averageWin: number | null;
            averageLoss: number | null;
            series: Array<{
                tradeNo: number;
                streak: number;
                amount: number;
            }>;
        };
        timePatterns: {
            byEntryHour: Array<{
                key: string;
                label: string;
                trades: number;
                winners: number;
                losers: number;
                netProfit: number;
            }>;
            byEntryWeekday: Array<{
                key: string;
                label: string;
                trades: number;
                winners: number;
                losers: number;
                netProfit: number;
            }>;
            byEntryMonth: Array<{
                key: string;
                label: string;
                trades: number;
                winners: number;
                losers: number;
                netProfit: number;
            }>;
            averageBarsHeld: number | null;
            averageBarsHeldWinners: number | null;
            averageBarsHeldLosers: number | null;
        };
    };
};

export type StrategyDefinitionGroupList = {
    groups: Array<StrategyDefinitionGroup>;
    /**
     * Base strategies the filters keep in all
     */
    total: number;
    /**
     * Base strategies left out because every variant is weak
     */
    hiddenGroups: number;
};

export type StrategyDefinitionGroup = {
    /**
     * `template:<ref>` or `strategy:<id>`: the `base` filter of its variants
     */
    key: string;
    name: string;
    /**
     * Variants the filters keep, weak ones included
     */
    variants: number;
    weak: number;
    grades: {
        A: number;
        B: number;
        C: number;
        D: number;
        F: number;
        unscored: number;
    };
    best: StrategyDefinitionSummary;
};

export type StrategyDefinitionSummary = {
    definitionId: string;
    /**
     * Its base strategy (`template:<ref>` or `strategy:<id>`): the group it is a variant of
     */
    base: string;
    name: string;
    category: string | null;
    assetClasses: Array<string>;
    symbols: Array<string>;
    timeframe: string | null;
    lifecycle: string | null;
    /**
     * The strategy's score (the version's current `strategy_score`), null before one is written
     */
    score: {
        /**
         * 0–100
         */
        value: number;
        grade: 'A' | 'B' | 'C' | 'D' | 'F';
        /**
         * A term had no evidence; its weight went to the others
         */
        partial: boolean;
        missing: Array<string>;
        parts: Array<{
            part: 'profitability' | 'riskAdjusted' | 'reliability' | 'drawdown';
            weight: number;
            points: number | null;
        }>;
        period: {
            days: number;
            from: string;
            to: string;
        } | null;
        evidenceRunId: string | null;
        computedAt: string;
    } | null;
    tier: {
        worksNow: boolean;
        provenRegimes: Array<string>;
    } | null;
    latestRun: {
        id: string;
        runMode: string;
        finishedAt: string | null;
        sharpe: number | null;
        maxDrawdown: number | null;
        totalReturn: number | null;
        totalTrades: number | null;
    } | null;
};

export type StrategyDefinitionRunList = {
    data: Array<StrategyRunListItem>;
    limit: number;
    offset: number;
};

export type CreateStrategyDefinitionRunResult = {
    runRequestId: string;
    requestId: string;
    status: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled';
    dataReadiness: 'unknown' | 'ready' | 'research_only' | 'blocked';
    researchOnly: boolean;
    blockedReasons: Array<string>;
    paramSet: StrategyDefinitionParamSet;
    paramSetHash: string | null;
};

export type StrategyDefinitionParamSet = {
    [key: string]: number | string | boolean;
};

export type StrategyDefinitionRunErrorResult = {
    error: {
        code: string;
        message: string;
        violations?: Array<StrategyParamSetViolation>;
    };
};

export type StrategyParamSetViolation = {
    key: string;
    code: 'unknown_parameter' | 'type_mismatch' | 'out_of_range' | 'not_allowed_value';
    message: string;
};

export type CreateStrategyDefinitionRunRequest = {
    paramSet?: StrategyDefinitionParamSet;
    window?: {
        start: string;
        end: string;
    };
    dataFrequency?: string;
    initialCapital?: number;
    symbols?: Array<string>;
    runMode: 'research' | 'backtest';
    costs?: {
        commissionBpsPerSide: number;
        halfSpreadBps: number;
    };
};

export type AmendStrategyDefinitionParametersResult = {
    strategyDefinitionId: string;
    definitionVersion: number;
    name: string;
    created: boolean;
    parameters: Array<{
        name: string;
        type: string;
        default: number | string | boolean;
        min?: number;
        max?: number;
        step?: number;
        unit?: string;
        description?: string;
        source: string;
    }>;
};

export type AmendStrategyDefinitionParametersRequest = {
    parameters: Array<StrategyParameterPatch>;
};

export type StrategyParameterPatch = {
    name: string;
    default?: number | string | boolean;
    min?: number;
    max?: number;
    step?: number;
    optimizationGrid?: Array<number | string | boolean>;
    unit?: string;
    description?: string;
};

export type ForkStrategyDefinitionResult = {
    strategyDefinitionId: string;
    sourceCandidateId: string;
    definitionVersion: number;
    name: string;
    indicatorRowCount: number;
};

export type StrategyTemplateList = {
    data: Array<StrategyTemplateRecord>;
};

export type StrategyTemplateRecord = {
    id: number;
    entityId: number;
    organizationId: number;
    version: number;
    templateRef: string;
    name: string;
    description: string | null;
    status: string;
    family: string;
    requiredIndicatorFamilies: Array<'price' | 'volume' | 'volatility' | 'momentum' | 'trend' | 'breadth' | 'fundamental' | 'macro' | 'options' | 'on_chain' | 'sentiment' | 'custom' | string>;
    parameterSchema: {
        [key: string]: {
            type?: string;
            default?: unknown;
            min?: number;
            max?: number;
            description?: string;
            optimizationHints?: {
                [key: string]: unknown;
            };
            [key: string]: unknown;
        };
    };
    indicators: Array<{
        [key: string]: unknown;
    }>;
    entryRuleSkeletons: Array<{
        [key: string]: unknown;
    }>;
    exitRuleSkeletons: Array<{
        [key: string]: unknown;
    }>;
    marketSupport: {
        assetClasses?: Array<'equity' | 'etf' | 'future' | 'forex' | 'crypto_spot' | 'crypto_perp' | 'option' | 'index' | 'rate' | 'commodity' | 'multi_asset' | 'synthetic' | string>;
        timeframes?: Array<string>;
    };
    knownFailureModes: Array<{
        code: string;
        description: string;
        mitigation?: string;
    }>;
    mutationHooks: Array<{
        hookId: string;
        recipeRef?: string;
        description: string;
        params?: {
            [key: string]: unknown;
        };
    }>;
    scoringObjectiveDefaults: {
        [key: string]: unknown;
    };
    provenance: {
        sourceIds?: Array<string>;
        evidenceIds?: Array<string>;
        extractor?: string;
        extractionHash?: string;
        confidence?: number;
    };
};

export type StrategyTemplateGetResult = {
    data: StrategyTemplateRecord;
};

export type StrategyTemplatePreviewResult = {
    data: {
        definition: {
            [key: string]: unknown;
        };
        indicatorBindings: Array<{
            alias: string;
            source?: 'inline' | 'catalog';
            indicatorDefinitionRef?: string;
            indicatorDefinitionId?: number;
            indicatorImplementationRef?: string;
            indicatorImplementationId?: number;
            parameterValues?: {
                [key: string]: unknown;
            };
            inputBinding?: {
                [key: string]: {
                    field?: string;
                    symbol?: string;
                    timeframe?: string;
                    window?: number;
                    lag?: number;
                    transform?: string;
                    value?: unknown;
                    path?: string;
                    [key: string]: unknown;
                };
            };
            outputAliases?: {
                [key: string]: string;
            };
            liveness?: {
                ttlMs: number;
                certified: boolean;
                certifiedBy?: string;
                certifiedAt?: string;
            };
            timeframe?: string;
            barSource?: 'ohlc' | 'heikin_ashi';
            readiness?: {
                status?: 'ready' | 'missing_implementation' | 'disabled_implementation' | 'research_only';
                reasons?: Array<string>;
            };
        }>;
        mergedParameters: {
            [key: string]: unknown;
        };
        provenance: {
            templateRef: string;
            version: number;
            extractor: string;
        };
        featureBindings: Array<StrategyTemplateFeatureBindingReadiness>;
        marketDataReadiness: StrategyTemplateMarketDataReadiness | null;
        realtimeMarketDataReadiness: StrategyTemplateRealtimeMarketDataReadiness | null;
    };
};

export type StrategyTemplateFeatureBindingReadiness = {
    alias: string;
    canonicalRef: string | null;
    sourceTier: 'in_adapter' | 'precomputed_frame' | 'unknown';
    readiness: 'ready' | 'missing_implementation' | 'disabled_implementation' | 'research_only';
    reasons: Array<string>;
    researchOnly: boolean;
    liveness: {
        ttlMs: number;
        certified: boolean;
    } | null;
    /**
     * Effective scope/regime selection for precomputed_frame features; null for in_adapter or when variant parse failed.
     */
    variant: {
        scope: string | null;
        regime: string;
    } | null;
};

export type StrategyTemplatePreviewRequest = {
    templateId?: number;
    templateRef?: string;
    version?: number;
    overrides?: {
        [key: string]: unknown;
    };
    symbols?: Array<string>;
    assetClass?: string;
    timeframe?: string;
    windowStart?: string;
    windowEnd?: string;
    name?: string;
    description?: string;
    testIntent?: string;
    exchange?: string;
    require_realtime_data?: boolean;
};

export type StrategyTemplateEnqueueResult = {
    data: {
        strategyDefinitionId: number;
        runRequestId: number;
        requestId: string;
        status: string;
        indicatorBindingCount: number;
    };
};

export type StrategyTemplateEnqueueRequest = {
    templateId?: number;
    templateRef?: string;
    version?: number;
    overrides?: {
        [key: string]: unknown;
    };
    symbols?: Array<string>;
    assetClass?: string;
    timeframe?: string;
    name?: string;
    description?: string;
    testIntent?: string;
    scope?: 'backtest' | 'validation' | 'smoke' | 'in_sample' | 'out_of_sample' | 'walk_forward' | 'cross_validation' | 'parameter_sweep' | 'forward_test' | 'monte_carlo' | 'robustness';
    runMode?: 'research' | 'backtest';
    windowStart?: string;
    windowEnd?: string;
    exchange?: string;
    require_realtime_data?: boolean;
};

export type FinanceProviderUnlockPromptList = {
    data: Array<FinanceProviderUnlockPromptRecord>;
    total: number;
    limit: number;
    offset: number;
};

export type FinanceProviderUnlockPromptRecord = {
    id: number;
    organizationId: number;
    unlockId: string;
    status: string;
    need: string;
    userPrompt: string;
    scopeKeys: Array<string>;
    assetClasses: Array<string>;
    unlocksScopes: Array<string>;
    requiredSecrets: Array<string>;
    requiredData: Array<string>;
    providerOptions: {
        free: Array<string>;
        paid: Array<string>;
    };
    risks: Array<string>;
    recommendedSafeDefault: string;
    biasIfMissing: string;
    sourcePayload: {
        unlockId: string;
        need: string;
        unlocksScopes: Array<string>;
        userPrompt: string;
        requiredSecrets?: Array<string>;
        requiredData?: Array<string>;
        providerOptions: {
            free?: Array<string>;
            paid?: Array<string>;
        };
        risks?: Array<string>;
        recommendedSafeDefault: string;
        biasIfMissing: string;
    };
    sourceHash: string;
    createdAt: string;
    updatedAt: string;
};

export type FinanceProviderUnlockPromptDetailResult = {
    data: FinanceProviderUnlockPromptRecord;
};

export type FinanceStrategyCostModelPersistResult = {
    data: FinanceStrategyCostModelRecord;
    status: 'created' | 'existing';
};

export type FinanceStrategyCostModelRecord = {
    id: number;
    organizationId: number;
    createdByWorkflowRunId: number | null;
    costModelId: string;
    version: string;
    name: string | null;
    modelHash: string | null;
    realismLevel: string | null;
    brokerageModel: string | null;
    slippageModelKind: string | null;
    feeModelKind: string | null;
    fillModelKind: string | null;
    fillTiming: string | null;
    costAssumptionSource: string | null;
    model: {
        type?: 'strategy_cost_model';
        schemaVersion?: 'finance-strategy-cost-model/v1';
        costModelId: string;
        version: string;
        name?: string;
        realismLevel?: 'none' | 'default_broker' | 'custom';
        brokerageModel?: string;
        slippageModel?: {
            kind?: 'none' | 'fixed_basis_points' | 'constant_percent' | 'fixed_spread' | 'spread_fraction' | 'proportional_price' | 'volume_share' | 'square_root_impact' | 'almgren_chriss' | 'custom' | string;
            config?: {
                [key: string]: unknown;
            };
            costAssumptionSource?: 'none' | 'measured' | 'vendor_feed' | 'static_assumption' | 'heuristic';
            applyOnOpen?: boolean;
            allowFillBeyondLimit?: boolean;
        } | null;
        feeModel?: {
            kind?: 'none' | 'per_share' | 'per_trade' | 'per_dollar' | 'per_contract' | 'maker_taker' | 'tiered' | 'proportional_plus_fixed' | 'brokerage_named' | 'custom' | string;
            config?: {
                [key: string]: unknown;
            };
            currency?: string;
            regulatoryFees?: {
                side?: 'buy' | 'sell' | 'both' | string;
                secFeeBps?: number;
                finraTafPerShare?: number;
                exchangeFeePerShare?: number;
                clearingFeePerTrade?: number;
            };
            costAssumptionSource?: 'none' | 'measured' | 'vendor_feed' | 'static_assumption' | 'heuristic';
        } | null;
        latencyModel?: {
            kind?: 'zero' | 'fixed_ms' | 'uniform_ms' | 'normal_ms' | 'distribution' | 'custom' | string;
            config?: {
                [key: string]: unknown;
            };
            fixedLatencyMs?: number;
            latencyMeanMs?: number;
            latencyStdMs?: number;
            adverseSelectionBps?: number;
            costAssumptionSource?: 'none' | 'measured' | 'vendor_feed' | 'static_assumption' | 'heuristic';
        } | null;
        fillModel?: {
            kind?: 'immediate' | 'equity' | 'future' | 'future_option' | 'best_price' | 'parametric' | 'size_aware' | 'partial' | 'volume_sensitive' | 'session_aware' | 'competition_aware' | 'custom' | string;
            fillTiming?: 'same_bar_close' | 'next_bar_open' | 'next_bar_vwap' | 'mid' | 'worst_of_bar' | 'quote_cross' | string;
            idealizedFills?: boolean;
            config?: {
                [key: string]: unknown;
            };
            queue?: {
                [key: string]: unknown;
            };
        } | null;
        borrowCostModel?: {
            [key: string]: unknown;
        };
        financingCostModel?: {
            [key: string]: unknown;
        };
        settlementModel?: {
            [key: string]: unknown;
        };
        sourceIds?: Array<string>;
        evidenceIds?: Array<string>;
    };
    sourceIds: Array<string>;
    evidenceIds: Array<string>;
    createdAt: string;
    updatedAt: string;
};

export type FinanceStrategyCostModelList = {
    data: Array<FinanceStrategyCostModelRecord>;
    total: number;
    limit: number;
    offset: number;
};

export type FinanceStrategyCostModelDetailResult = {
    data: FinanceStrategyCostModelRecord;
};

export type FinanceStrategyLifecycleTransitionCreateResult = {
    data: FinanceStrategyLifecycleTransitionRecord;
};

export type FinanceStrategyLifecycleTransitionRecord = {
    id: number;
    organizationId: number;
    definitionId: number | null;
    bucketDefinitionId: number | null;
    fromState: 'candidate' | 'research_brief' | 'backtest_pending' | 'backtest_done_pass' | 'backtest_done_fail' | 'risk_pending' | 'risk_cleared' | 'risk_rejected' | 'paper_trading' | 'paper_trading_completed' | 'pending_live_approval' | 'live_trading' | 'retired' | 'archived' | 'watchlist' | null;
    toState: 'candidate' | 'research_brief' | 'backtest_pending' | 'backtest_done_pass' | 'backtest_done_fail' | 'risk_pending' | 'risk_cleared' | 'risk_rejected' | 'paper_trading' | 'paper_trading_completed' | 'pending_live_approval' | 'live_trading' | 'retired' | 'archived' | 'watchlist';
    fromScope: string | null;
    toScope: string | null;
    transitionType: string;
    gateResult: {
        gateName: string;
        requirement: string;
        observedValue?: string | number | boolean | string;
        statistic?: 'mean' | 'median' | 'p5' | 'p95' | 'min' | 'max' | 'std' | 'latest' | 'all' | string;
        comparator?: '>=' | '>' | '<=' | '<' | '==' | '!=' | 'in' | 'all_pass' | string;
        threshold?: string | number | boolean | string;
        passed: boolean;
        sourceRunIds?: Array<string>;
        evaluatedAt?: string;
        details?: {
            [key: string]: unknown;
        };
    } | null;
    sourceRunIds: Array<string>;
    actorId: number | null;
    reason: string;
    occurredAt: string;
    transitionAuthority: 'approved_writer' | 'research_auto' | 'route_human' | 'system' | 'legacy_backfill' | null;
    actorKind: 'human' | 'daemon' | 'system' | null;
    approvalDecisionId: number | null;
    approvedBy: number | null;
    approvedAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type FinanceStrategyLifecycleTransitionCreateInput = {
    definitionId?: number;
    bucketDefinitionId?: number;
    fromState?: 'candidate' | 'research_brief' | 'backtest_pending' | 'backtest_done_pass' | 'backtest_done_fail' | 'risk_pending' | 'risk_cleared' | 'risk_rejected' | 'paper_trading' | 'paper_trading_completed' | 'pending_live_approval' | 'live_trading' | 'retired' | 'archived' | 'watchlist';
    toState: 'candidate' | 'research_brief' | 'backtest_pending' | 'backtest_done_pass' | 'backtest_done_fail' | 'risk_pending' | 'risk_cleared' | 'risk_rejected' | 'paper_trading' | 'paper_trading_completed' | 'pending_live_approval' | 'live_trading' | 'retired' | 'archived' | 'watchlist';
    fromScope?: string;
    toScope?: string;
    transitionType: string;
    gateResult?: {
        gateName: string;
        requirement: string;
        observedValue?: string | number | boolean | string;
        statistic?: 'mean' | 'median' | 'p5' | 'p95' | 'min' | 'max' | 'std' | 'latest' | 'all' | string;
        comparator?: '>=' | '>' | '<=' | '<' | '==' | '!=' | 'in' | 'all_pass' | string;
        threshold?: string | number | boolean | string;
        passed: boolean;
        sourceRunIds?: Array<string>;
        evaluatedAt?: string;
        details?: {
            [key: string]: unknown;
        };
    };
    sourceRunIds?: Array<string>;
    reason: string;
    occurredAt?: string;
};

export type FinanceStrategyLifecycleTransitionList = {
    data: Array<FinanceStrategyLifecycleTransitionRecord>;
    total: number;
    limit: number;
    offset: number;
};

export type FinanceStrategyLifecycleCommitInput = {
    approvalDecisionId: number;
    definitionId?: number;
    bucketDefinitionId?: number;
    toState: 'paper_trading' | 'pending_live_approval' | 'live_trading';
    fromState?: 'candidate' | 'research_brief' | 'backtest_pending' | 'backtest_done_pass' | 'backtest_done_fail' | 'risk_pending' | 'risk_cleared' | 'risk_rejected' | 'paper_trading' | 'paper_trading_completed' | 'pending_live_approval' | 'live_trading' | 'retired' | 'archived' | 'watchlist';
    fromScope?: string;
    toScope?: string;
    sourceRunIds?: Array<string>;
    reason: string;
};

export type FinanceArtifactPreviewResult = {
    previewKind: string;
    type: string;
    subtype?: string;
    title: string;
    fields: {
        [key: string]: unknown;
    };
    warnings: Array<string>;
    supported: true;
    blockedReasons: Array<string>;
    allowedActions: Array<string>;
};

export type FinanceArtifactUnsupportedPreviewResult = {
    previewKind: 'unsupported';
    type: string | null;
    reason: 'unsupported_finance_type' | 'invalid_payload' | 'not_finance';
    message: string;
    supported: false;
};

export type FinanceResearchWorkflowList = {
    data: Array<FinanceResearchWorkflowEntry>;
};

export type FinanceResearchWorkflowEntry = {
    id: number;
    name: string;
    status: string;
    category: string | null;
    lastRunAt: string | null;
    daemon: FinanceResearchDaemonLink | null;
    linkEnabled: boolean | null;
    lastRun: FinanceResearchLastRun | null;
};

export type FinanceResearchRunStartResult = {
    data: {
        requestId: string;
        workflowDefinitionId: number;
        status: 'pending';
        startedAt: string;
        daemonRunId: unknown;
    };
};

export type FinancePlannerRecommendationsResult = {
    data: {
        generatedAt: string;
        modelVersion: string;
        totals: {
            scored: number;
            enqueueEligible: number;
            excludedPending: number;
            blocked: number;
        };
        candidates: Array<FinancePlannerCandidate>;
    };
};

export type FinancePlannerCandidate = {
    definitionId: number;
    definitionName: string;
    lifecycleState: string;
    sourceCandidateId: string | null;
    wtn: number;
    action: 'enqueue_next_scope' | 'retest_stale' | 'improve_params' | 'combine' | 'paper_trade_approval' | 'await_pending_run' | 'needs_data' | 'needs_adapter' | 'reject_low_score' | 'hold_fresh_evidence';
    nextScope: string | null;
    advancedScope: string | null;
    selectionMode: 'exploit' | 'explore' | null;
    components: FinancePlannerWtnComponents;
    advancedComponents: FinancePlannerAdvancedComponents | null;
    reasons: Array<string>;
    evidence: FinancePlannerEvidence;
    pendingRequest: FinancePlannerPendingRequest | null;
    blockedReasons: Array<string>;
};

export type FinancePlannerWtnComponents = {
    decayedScore: number;
    uncertaintyTerm: number;
    stalenessTerm: number;
    ladderTerm: number;
    redundancyPenalty: number;
    readinessFactor: number;
    ageDays: number;
    halfLifeDays: number;
};

export type FinancePlannerEvidence = {
    scoreId: number;
    scoreValue: number;
    scoreUncertainty: number;
    scoreComputedAt: string;
    sourceRunIds: Array<string>;
    familyCumulativeTrials: number;
};

export type FinanceBucketCompositionResult = {
    data: {
        buckets: Array<FinanceBucketEntry>;
        totals: {
            buckets: number;
            withQueuedEval: number;
            withCompletedEval: number;
            blocked: number;
        };
        degradationTotals: FinanceDegradationTotals;
    };
};

export type FinanceBucketEntry = {
    id: string;
    bucketId: string;
    slug: string;
    name: string;
    mode: string;
    lifecycleState: string;
    validationStatus: string;
    definitionVersion: number;
    bucketHash: string;
    components: Array<FinanceBucketComponent>;
    compositionEvaluation: FinanceBucketEvaluation | null;
    latestBucketEval: FinanceBucketEvaluation | null;
    latestRunRequest: FinanceBucketRunRequest | null;
    latestRun: FinanceBucketRun | null;
    bucketLevelScore: FinanceBucketScore | null;
    degradation: FinanceBucketDegradation;
    createdAt: string;
    updatedAt: string;
};

export type FinanceBucketComponent = {
    componentId: string;
    role: string;
    definitionId: number;
    weight: number;
    allocationMethod: string;
    status: 'active' | 'paused';
    statusReason?: string;
    name?: string;
    skillValue?: number;
    skillComputedAt?: string;
};

export type FinanceBucketDegradation = {
    pendingDecisions: Array<FinanceDegradationDecision>;
    recentResolvedDecisions: Array<FinanceDegradationDecision>;
    hypotheses: Array<FinanceDegradationHypothesis>;
    lastScan: FinanceDegradationLastScan | null;
};

export type FinanceDegradationDecision = {
    id: string;
    actionType: 'reweight_bucket' | 'replace_component' | 'pause_component';
    severity: 'info' | 'low' | 'medium' | 'high' | 'critical';
    reviewStatus: 'pending' | 'approved' | 'rejected' | 'deferred';
    title: string;
    createdAt: string;
    expiresAt: string | null;
    reviewedAt: string | null;
    consumedAt: string | null;
    componentDefinitionId: number | null;
    sqsDelta: number | null;
    basisHash: string | null;
    reasonCodes: Array<string>;
    replacement: FinanceDegradationReplacement | null;
    rationale: string | null;
};

export type FinanceDegradationHypothesis = {
    id: string;
    hypothesisType: string;
    statement: string;
    priorBelief: number;
    posteriorBelief: number | null;
    status: string;
    openedAt: string;
};

export type FinanceDegradationTotals = {
    pendingDecisions: number;
    bucketsWithPendingDecisions: number;
    openHypotheses: number;
    lastScanAt: string | null;
    lastScanDiagnostics: Array<string>;
    unsupportedActionsCount: number;
};

export type FinanceBucketDecisionApplyResult = {
    decisionId: string;
    actionType: 'reweight_bucket' | 'replace_component' | 'pause_component';
    bucketDefinitionId: string;
    bucketId: string;
    newDefinitionVersion: number;
    consumedAt: string;
};

export type FinanceProposeReweightResult = {
    decisionId: string;
    bucketDefinitionId: string;
    bucketId: string;
    basisHash: string;
    reviewStatus: 'pending';
    deduped: boolean;
};

export type FinanceProposeReweightBody = {
    bucketDefinitionId: number;
    weights: Array<{
        definitionId: number;
        weight: number;
    }>;
    rationale?: string;
};

export type FinanceIndicatorDecisionEnqueueResult = {
    data: FinanceIndicatorDecisionStatus;
};

export type FinanceIndicatorDecisionStatus = {
    requestId: string;
    runRequestId: number;
    status: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled';
    dataReadiness: 'unknown' | 'ready' | 'research_only' | 'blocked';
    blockedReasons: Array<string>;
};

export type FinanceIndicatorDecisionList = {
    data: Array<FinanceIndicatorDecisionSummary>;
};

export type FinanceIndicatorDecisionSummary = {
    requestId: string;
    status: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled';
    dataReadiness: 'unknown' | 'ready' | 'research_only' | 'blocked';
    blockedReasons: Array<string>;
    symbol: string;
    exchange: string | null;
    timeframe: string | null;
    windowStart: string | null;
    windowEnd: string | null;
    indicatorCanonicalKey: string | null;
    requestedAt: string;
    completedAt: string | null;
    decision: FinanceIndicatorDecisionVerdict | null;
    runVerdict: string | null;
};

export type FinanceIndicatorDecisionGetResult = {
    data: FinanceIndicatorDecisionSummary;
};

export type StrategyDecisionList = {
    data: Array<StrategyDecision>;
    totals: {
        definitions: number;
        withCompletedRun: number;
        needsMoreData: number;
    };
};

export type StrategyDecision = {
    definitionId: number;
    definitionName: string;
    lifecycleState: string;
    recommendation: 'buy' | 'hold' | 'sell' | 'avoid' | 'needs_more_data';
    reasons: Array<string>;
    confidence: 'low' | 'medium';
    latestSignal: StrategyDecisionLatestSignal | null;
    run: StrategyDecisionRunSummary | null;
    runRequest: StrategyDecisionRequestSummary | null;
    score: StrategyDecisionScoreSummary | null;
    dataReadiness: StrategyDecisionDataReadinessSummary | null;
    signalDiagnosticsSummary: Array<StrategyDecisionSignalDiagnosticSummary>;
    riskFlags: Array<string>;
    blockers: Array<string>;
    limitations: Array<string>;
    nonExecuting: true;
};

export type StrategyDecisionSignalDiagnosticSummary = {
    signalId: string;
    scope: 'entry' | 'exit';
    trueCount: number;
    computed: boolean;
};

export type FinanceStrategyDecisionGetResult = {
    data: StrategyDecision;
};

export type StrategyDecisionEvaluateResult = {
    requestId: string;
    status: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled';
    dataReadiness: 'unknown' | 'ready' | 'research_only' | 'blocked';
    blockedReasons: Array<string>;
};

export type StrategyDecisionEvaluateRequest = {
    symbols: Array<string>;
    timeframe: string;
    windowStart: string;
    windowEnd: string;
    exchange?: string;
    paramSet?: {
        [key: string]: number | string | boolean;
    };
};

export type StrategyEvaluationRunResult = {
    status: 'no_assignments' | 'evaluated';
    gateId?: number;
    satisfaction?: StrategyEvaluationSatisfaction;
};

export type StrategyEvaluationSatisfaction = {
    satisfied: boolean;
    requiredKeys: Array<string>;
    passedKeys: Array<string>;
    missingKeys: Array<string>;
    failingKeys: Array<string>;
};

export type StrategyEvaluationRunRequest = {
    targetTransition: string;
};

export type FinanceOperationsSummaryResult = {
    data: {
        generatedAt: string;
        nonExecuting: true;
        research: {
            items: Array<FinanceOpsResearchArtifactRow>;
            error?: string;
        };
        indicatorDecisions: {
            items: Array<FinanceOpsIndicatorDecisionRow>;
            error?: string;
        };
        strategyDecisions: {
            items: Array<FinanceOpsStrategyDecisionRow>;
            totals: {
                definitions: number;
                withCompletedRun: number;
                needsMoreData: number;
            };
            error?: string;
        };
        templateTesting: {
            items: Array<FinanceOpsTemplateTestingRunRow>;
            totals: {
                queued: number;
                running: number;
                blocked: number;
                completed: number;
                failed: number;
            };
            error?: string;
        };
        marketData: {
            items: Array<FinanceOpsMarketDataUnlockRow>;
            dataBlockersCount: number;
            error?: string;
        };
        planner: {
            totals: {
                scored: number;
                enqueueEligible: number;
                excludedPending: number;
                blocked: number;
            };
            candidates: Array<FinanceOpsPlannerCandidateRow>;
            error?: string;
        };
        buckets: {
            totals: {
                buckets: number;
                withQueuedEval: number;
                withCompletedEval: number;
                blocked: number;
            };
            degradationTotals: {
                pendingDecisions: number;
                bucketsWithPendingDecisions: number;
                openHypotheses: number;
            };
            items: Array<FinanceOpsBucketRow>;
            error?: string;
        };
        approvals: {
            count: number;
            items: Array<FinanceOpsApprovalRow>;
            error?: string;
        };
        researchWorkflows: {
            items: Array<FinanceOpsResearchWorkflowRow>;
            error?: string;
        };
        contentIngestion: {
            subscriptionHealth: {
                active: number;
                paused: number;
                blocked: number;
                pendingApproval: number;
                archived: number;
            };
            fetchRuns24h: {
                succeeded: number;
                partial: number;
                failed: number;
                queuedOrRunning: number;
                totalReadsBilled: number;
                totalEstimatedCostUsd: number;
                totalQuotaUnitsUsed: number;
            };
            blockedSources: Array<FinanceOpsContentBlockedSourceRow>;
            transcriptFailures24h: number;
            expansionCandidates: {
                count: number;
                items: Array<FinanceOpsContentExpansionCandidateRow>;
            };
            insightsBacklog: number;
            error?: string;
        };
        sectionErrors: Array<string>;
    };
};

export type FinanceOpsResearchArtifactRow = {
    artifactId: number;
    type: string;
    subtype: string | null;
    title: string;
    recommendationAction: string | null;
    confidence: string | null;
    horizon: string | null;
    sourceCount: number;
    blockerCount: number;
    observedAt: string | null;
    createdAt: string;
};

export type FinanceOpsIndicatorDecisionRow = {
    requestId: string;
    status: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled';
    dataReadiness: 'unknown' | 'ready' | 'research_only' | 'blocked';
    blockedReasons: Array<string>;
    symbol: string;
    exchange: string | null;
    timeframe: string | null;
    windowStart: string | null;
    windowEnd: string | null;
    indicatorCanonicalKey: string | null;
    requestedAt: string | string;
    completedAt: string | string | null;
    decision: FinanceOpsIndicatorDecisionVerdict | null;
    runVerdict: string | null;
};

export type FinanceOpsStrategyDecisionRow = {
    definitionId: number;
    definitionName: string;
    lifecycleState: string;
    recommendation: 'buy' | 'hold' | 'sell' | 'avoid' | 'needs_more_data';
    reasons: Array<string>;
    confidence: 'low' | 'medium' | 'high';
    latestSignal: {
        state: string;
        lastBarAt: string | null;
        entryTriggeredOnLastBar: boolean;
        exitTriggeredOnLastBar: boolean;
    } | null;
    run: {
        runId: string;
        runStatus: string;
        verdict: string | null;
        recommendation: string | null;
        researchOnly: boolean;
        finishedAt: string | null;
        windowStart: string | null;
        windowEnd: string | null;
        scope: string;
        runMode: string;
    } | null;
    runRequest: {
        requestId: string;
        status: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled';
        dataReadiness: 'unknown' | 'ready' | 'research_only' | 'blocked';
        blockedReasons: Array<string>;
        requestedAt: string;
    } | null;
    score: {
        value: number;
        uncertainty: number;
        skillProb: number | null;
        pboPassed: boolean | null;
        computedAt: string;
    } | null;
    dataReadiness: {
        status: string;
        pointInTime: boolean;
        missingIntervalCount: number;
        staleLastBar: boolean;
    } | null;
    signalDiagnosticsSummary: Array<{
        signalId: string;
        scope: string;
        trueCount: number;
        computed: boolean;
    }>;
    riskFlags: Array<string>;
    blockers: Array<string>;
    limitations: Array<string>;
    nonExecuting: true;
};

export type FinanceOpsTemplateTestingRunRow = {
    requestId: string;
    status: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled';
    dataReadiness: 'unknown' | 'ready' | 'research_only' | 'blocked';
    scope: string;
    runMode: string;
    symbols: Array<string>;
    timeframe: string | null;
    requestedAt: string;
    blockedReasonCount: number;
};

export type FinanceOpsMarketDataUnlockRow = {
    unlockId: string;
    status: string;
    scope: Array<string>;
    assetClass: Array<string>;
    requiredSecretCount: number;
};

export type FinanceOpsPlannerCandidateRow = {
    definitionId: number;
    definitionName: string;
    action: string;
    wtn: number;
    nextScope: string | null;
    blockedReasons: Array<string>;
};

export type FinanceOpsBucketRow = {
    bucketId: string;
    name: string;
    lifecycleState: string;
    validationStatus: string;
    latestEvalVerdict: string | null;
    latestEvalRecommendation: string | null;
    bucketLevelScoreValue: number | null;
    pendingDecisionCount: number;
};

export type FinanceOpsApprovalRow = {
    id: string;
    title: string;
    severity: string;
    actionType: string;
    createdAt: string;
    expiresAt: string | null;
    reviewStatus: 'pending' | 'approved';
};

export type FinanceOpsResearchWorkflowRow = {
    id: number;
    name: string;
    status: string;
    lastRunAt: string | null;
    lastRunStatus: string | null;
    lastRunSummaryKind: string | null;
    pendingDecisionCount: number;
};

export type FinanceOpsContentBlockedSourceRow = {
    intelSourceId: string;
    handle: string;
    lastErrorCode: string | null;
    blockedUntil: string | null;
    consecutiveFailures: number;
};

export type FinanceOpsContentExpansionCandidateRow = {
    id: string;
    handle: string;
    platform: string;
    discoveryDepth: number | null;
};

export type FinanceCommandLookupResult = {
    data: {
        command: 'indicator' | 'strategy' | 'ticker' | 'research' | 'timeframe';
        options: Array<FinanceCommandLookupOption>;
        truncated: boolean;
    };
};

export type FinanceCommandLookupOption = {
    type: 'indicator' | 'strategy' | 'ticker' | 'research' | 'timeframe';
    id: string;
    label: string;
    description?: string;
    source: string;
    installed: boolean;
    metadata: {
        [key: string]: string | number | boolean;
    };
};

export type FinanceConversationPersona = {
    slug: string;
    label: string;
    description: string;
    iconHint: string;
    seedMessage: string;
    artifactTypesProduced: Array<string>;
};

export type IndicatorImportPreviewResult = {
    data: {
        candidate: IndicatorCandidate;
        analysis: PineScriptAnalysis;
        warnings: Array<string>;
        source: PineImportSource;
        catalogMatches: Array<PineCatalogMatch>;
        artifact: IndicatorImportPersistedArtifact | null;
    };
};

export type IndicatorCandidate = {
    type: 'finance.indicator_candidate';
    schemaVersion: 1;
    alias: string;
    requestedName: string;
    canonicalKeyGuess?: string;
    category?: string;
    formula?: string;
    pseudocode?: string;
    lookbackWindow?: string;
    dataRequirements: Array<string>;
    providerRequirements: Array<string>;
    parameters: Array<CandidateParameter>;
    resolution: 'exact_catalog_match' | 'compatible_existing' | 'new_definition' | 'new_definition_and_implementation' | 'unsupported';
    lookaheadPolicy: 'research_only' | 'production_ready';
    status: 'proposed' | 'needs_review' | 'rejected';
    executable: false;
    rationale?: string;
    provenance: {
        producedBy: 'llm' | 'user' | 'system';
        untrusted: boolean;
        notes?: string;
    };
    sourceMessageIds: Array<string | number>;
};

export type CandidateParameter = {
    name: string;
    type: 'integer' | 'float' | 'boolean' | 'string';
    default?: string | number | boolean;
    min?: number;
    max?: number;
};

export type PineScriptAnalysis = {
    pineVersion: number | null;
    declarationKind: 'indicator' | 'strategy' | 'library' | 'unknown';
    title: string | null;
    inputs: Array<PineInput>;
    plots: Array<string>;
    signals: Array<string>;
    timeframeAssumptions: Array<string>;
    dataRequirements: Array<string>;
    repaintingWarnings: Array<string>;
    unsupportedFeatures: Array<string>;
    warnings: Array<string>;
};

export type PineInput = {
    name: string;
    inputType: string;
    defaultValue: string | null;
};

export type PineImportSource = {
    kind: 'pasted' | 'url';
    host?: string;
    bytes: number;
};

export type PineCatalogMatch = {
    pineFunction: string;
    canonicalKey: string;
    name: string;
    status: string;
    installed: boolean;
    matchedOn: string;
};

export type IndicatorImportPreviewBody = {
    source?: string;
    url?: string;
    alias?: string;
    persist?: boolean;
};

export type IndicatorImportTranspileResult = {
    data: {
        definition: TranspileDefinitionSummary;
        implementation: TranspileImplementationSummary;
        artifact: IndicatorImportPersistedArtifact;
        transpileNotes?: string;
        crossCheck: TranspileCrossCheck;
    };
};

export type TranspileDefinitionSummary = {
    id: string;
    canonicalKey: string;
    name: string;
    status: string;
};

export type TranspileImplementationSummary = {
    id: string;
    implementationKey: string;
    status: string;
    parityTestStatus: string;
};

export type TranspileCrossCheck = {
    inputsMatched: number;
    outputsDeclared: number;
};

export type IndicatorImportTranspileBody = {
    source?: string;
    url?: string;
    alias?: string;
};

export type IndicatorCatalogList = {
    data: {
        entries: Array<IndicatorCatalogEntry>;
        truncated: boolean;
    };
};

export type IndicatorCatalogEntry = {
    id: string;
    kind: 'definition' | 'candidate';
    canonicalKey: string;
    name: string;
    shortName: string | null;
    category: string;
    status: string;
    visibility: string;
    installed: boolean;
    implementations: Array<IndicatorImplementationEntry>;
    artifactId?: string;
};

export type IndicatorImplementationEntry = {
    id: string;
    implementationKey: string;
    runtime: string;
    adapterRef: string | null;
    status: string;
    parityTestStatus: string;
    pitSafety: string;
    transpiled: boolean;
};

export type FinanceIndicatorPromotionApplyResult = {
    decisionId: string;
    implementationKey: string;
    definitionCanonicalKey: string;
    promotedAt: string;
};

export type TickerResearchNote = {
    /**
     * ID of the persisted research note artifact
     */
    artifactId: number;
    /**
     * Artifact title
     */
    title: string;
    /**
     * Number of ticker mention insights included
     */
    mentionCount: number;
    /**
     * Number of distinct subscribed sources that mentioned the ticker
     */
    corroboratingSources: number;
};

export type TickerResearchNoteCreate = {
    /**
     * Ticker symbol (uppercased)
     */
    symbol: string;
    /**
     * Look-back window in days (default 7, max 30)
     */
    sinceDays?: number;
};

export type VarEstimate = {
    id: number;
    organizationId: number;
    manifest: {
        subjectScope: 'account' | 'portfolio' | 'strategy';
        subjectId: number;
        estimatorVersion: string;
        asOf: string;
        estimationStart: string;
        assetCount: number;
        barCount: number;
        status: 'ready' | 'research_only' | 'blocked';
        navBase: string | null;
        factorModelId: number | null;
        contentDigest: string;
        diagnostics: Array<{
            code: 'insufficient_bars' | 'insufficient_assets' | 'no_factor_model_parametric_dropped' | 'no_nav_dollar_var_omitted' | 'short_history_research_only' | 'zero_weight_subject' | 'unmodelled_symbols_partial';
            severity: 'blocker' | 'warning' | 'info';
            message: string;
        }>;
    };
    method: 'parametric' | 'historical' | 'monte_carlo';
    confidence: '0.95' | '0.99';
    horizon: '1d' | '5d' | '10d' | '20d';
    result: {
        method: 'parametric' | 'historical' | 'monte_carlo';
        confidence: '0.95' | '0.99';
        horizon: '1d' | '5d' | '10d' | '20d';
        varFraction: number;
        cvarFraction: number;
        varAmountBase: number | null;
        cvarAmountBase: number | null;
        components: Array<{
            componentKind: 'name' | 'factor';
            symbol?: string;
            exchange?: string;
            factorBlock?: 'beta_market' | 'size' | 'sector' | 'volatility' | 'liquidity' | 'funding' | 'momentum' | 'value' | 'quality';
            factorName?: string;
            weight: number | null;
            marginalVar: number;
            componentVar: number;
            componentVarShare: number;
        }>;
    };
};

export type VarBacktest = {
    subjectScope: 'account' | 'portfolio' | 'strategy';
    subjectId: number;
    method: 'parametric' | 'historical' | 'monte_carlo';
    confidence: '0.95' | '0.99';
    horizon: '1d' | '5d' | '10d' | '20d';
    test: 'kupiec_pof' | 'christoffersen_independence';
    observations: number;
    exceptions: number;
    expectedExceptions: number;
    testStatistic: number | null;
    pValue: number | null;
    trafficLight: 'green' | 'yellow' | 'red' | null;
    payload: {
        exceptionTimestamps: Array<string>;
        transitionCounts: {
            n00: number;
            n01: number;
            n10: number;
            n11: number;
        } | null;
    };
};

export type VarComponentRow = {
    componentKind: 'name' | 'factor';
    symbol?: string;
    exchange?: string;
    factorBlock?: 'beta_market' | 'size' | 'sector' | 'volatility' | 'liquidity' | 'funding' | 'momentum' | 'value' | 'quality';
    factorName?: string;
    weight: number | null;
    marginalVar: number;
    componentVar: number;
    componentVarShare: number;
};

export type StressScenarioSpec = {
    kind: 'historical_episode' | 'correlation_to_one' | 'factor_shock' | 'sector_shock' | 'rate_twist' | 'idiosyncratic';
    episodeStart: string | null;
    episodeEnd: string | null;
    targetCorrelation?: number;
    shocks?: Array<{
        target: 'symbol' | 'sector' | 'factor' | 'rate' | 'all';
        ref?: string;
        shock: number;
        sigmaUnits?: boolean;
    }>;
    rateMoveBp?: number;
    sourceExchange?: string;
    sourceTimeframe?: string;
};

export type StressResultContract = {
    organizationId: number;
    scenarioKey: string;
    kind: 'historical_episode' | 'correlation_to_one' | 'factor_shock' | 'sector_shock' | 'rate_twist' | 'idiosyncratic';
    asOf: string;
    status: 'ready' | 'degraded' | 'blocked';
    lossPct: number;
    payload: {
        scenarioKey: string;
        kind: 'historical_episode' | 'correlation_to_one' | 'factor_shock' | 'sector_shock' | 'rate_twist' | 'idiosyncratic';
        status: 'ready' | 'degraded' | 'blocked';
        lossPct: number;
        lossNotional: number | null;
        stressedVol: number | null;
        baselineVol: number | null;
        contributions: Array<{
            symbol: string;
            exchange: string;
            weight: number;
            shockedReturn: number;
            pnlContribution: number;
            unmodelled: boolean;
        }>;
        riskByBlock: {
            [key: string]: number;
        } | null;
        diagnostics: Array<{
            code: 'no_factor_model_bound' | 'no_holdings' | 'no_panel_for_episode' | 'unmodelled_symbols' | 'sector_metadata_missing' | 'factor_not_in_model' | 'partial_episode_coverage';
            severity: 'blocker' | 'warning' | 'info';
            message: string;
        }>;
    };
    contentDigest: string;
    computedAt: string;
};

export type AttributionRun = {
    id: number;
    organizationId: number;
    manifest: {
        subjectKind: 'portfolio' | 'strategy_run';
        benchmarkSymbol: string;
        methods: Array<'brinson' | 'factor'>;
        estimatorVersion: string;
        asOf: string;
        windowStart: string;
        periodCount: number;
        groupCount: number;
        portfolioReturn: number;
        benchmarkReturn: number;
        activeReturn: number;
        reconciliationResidual: number;
        contentDigest: string;
        diagnostics: Array<{
            code: 'no_benchmark_resolved' | 'benchmark_candles_missing' | 'no_group_weights' | 'factor_model_missing' | 'sector_metadata_missing' | 'reconciliation_residual_exceeds_tolerance' | 'insufficient_periods';
            severity: 'blocker' | 'warning' | 'info';
            message: string;
        }>;
    };
    effects: Array<{
        method: 'brinson' | 'factor';
        effectKind: 'allocation' | 'selection' | 'interaction' | 'factor_return' | 'specific' | 'total';
        groupDimension: 'sector' | 'asset_class' | 'custom' | 'factor';
        groupKey: string;
        groupLabel: string | null;
        periodIndex: number;
        effectReturn: number;
        portfolioWeight: number | null;
        benchmarkWeight: number | null;
        portfolioGroupReturn: number | null;
        benchmarkGroupReturn: number | null;
    }>;
};

export type AttributionEffectRow = {
    method: 'brinson' | 'factor';
    effectKind: 'allocation' | 'selection' | 'interaction' | 'factor_return' | 'specific' | 'total';
    groupDimension: 'sector' | 'asset_class' | 'custom' | 'factor';
    groupKey: string;
    groupLabel: string | null;
    periodIndex: number;
    effectReturn: number;
    portfolioWeight: number | null;
    benchmarkWeight: number | null;
    portfolioGroupReturn: number | null;
    benchmarkGroupReturn: number | null;
};

export type TcaScorecard = {
    id: number;
    organizationId: number;
    subjectKind: string;
    subjectId: number;
    /**
     * tca:all | tca:venue:<exchange> | tca:symbol:<symbol>
     */
    scope: string;
    regime: string;
    normalizedValue: number;
    sampleSize: number;
    modelVersion: string;
    computedAt: string;
    inputsHash: string;
    components: TcaScorecardComponents;
    classification: 'within_model' | 'degraded' | 'breached' | 'insufficient_data';
};

export type TcaScorecardComponents = {
    realizedTotalCostBps: number | null;
    realizedSlippageBps: number | null;
    realizedFeeBps: number | null;
    realizedSpreadCostBps: number | null;
    realizedOpportunityCostBps: number | null;
    avgDelayCostBps: number | null;
    avgExecutionCostBps: number | null;
    modeledTotalCostBps: number | null;
    modeledSource: string | null;
    normalizedCostRatio: number;
    normalizedCostDenominator: number;
    within_model: boolean;
    classification: 'within_model' | 'degraded' | 'breached' | 'insufficient_data';
    toleranceFraction: number;
    orderCount: number;
    fillCount: number;
    ordersWithArrival: number;
    ordersWithClose: number;
    windowStart: string | null;
    windowEnd: string | null;
    scorerVersion: string;
};

export type CrowdingScore = {
    id: number;
    organizationId: number;
    /**
     * 'factor' | 'symbol' | 'strategy_definition' | 'sector'
     */
    subjectKind: string;
    subjectId: number;
    /**
     * e.g. 'crowding:factor:momentum' | 'crowding:symbol:AAPL'
     */
    scope: string;
    /**
     * RegimePosterior.regimeId or PIT market_regimes label; '' = global
     */
    regime: string;
    /**
     * MSCI-style standardized composite; null when unrankable
     */
    compositeZ: number | null;
    /**
     * DSR skill probability (null until the crowding-skill run scores it)
     */
    skillProb: number | null;
    /**
     * PBO < 0.5 gate (null until scored)
     */
    pboPassed: boolean | null;
    sampleSize: number;
    modelVersion: string;
    computedAt: string;
    /**
     * full crowding decomposition (ownershipDepth/activeArb/deLeverProximity/breakdown/…)
     */
    components: Array<{
        key: 'valuation_spread' | 'short_interest_utilization' | 'factor_momentum' | 'intra_quintile_correlation' | 'factor_volatility' | 'comomentum_winner' | 'comomentum_loser' | 'absorption_ratio' | 'vpin' | 'order_flow_imbalance' | 'private_slippage_drift' | 'name_overlap_public_basket' | 'crowd_claims_prior';
        z: number | null;
        raw: number | null;
        available: boolean;
        note?: string;
    }>;
};

export type CapitalAllocationDigest = {
    contentDigest: string;
    poolKey: string;
    latestComputedAt: string;
};

export type CapitalAllocationProposal = {
    id?: number;
    organizationId?: number;
    status: 'proposed' | 'submitted' | 'approved' | 'rejected' | 'superseded';
    manifest: {
        poolKey: string;
        poolCapitalBase: number;
        baseCurrency: string;
        allocatorVersion: string;
        asOf: string;
        constraints: {
            maxSleeveWeight?: number;
            maxTurnover?: number;
            longOnly?: boolean;
            riskAversion?: number;
            minSleeveWeight?: number;
        };
        objective: 'marginal_utility';
        solverPath: 'constrained_qp' | 'inverse_vol_fallback';
        contentDigest: string;
        diagnostics: Array<{
            code: 'no_eligible_sleeves' | 'capacity_curve_missing' | 'capacity_curve_research_only' | 'score_stale' | 'covariance_unavailable' | 'solver_unavailable_used_fallback' | 'capacity_cap_binding' | 'pool_undersubscribed' | 'turnover_band_binding';
            severity: 'blocker' | 'warning' | 'info';
            message: string;
        }>;
    };
    sleeves: Array<{
        sleeveKind: 'bucket' | 'strategy' | 'external';
        sleeveRef: string;
        weight: number;
        allocatedNotionalBase: number;
        priorNotionalBase: number;
        standaloneSharpe: number | null;
        marginalSharpeAtAlloc: number | null;
        sqsValue: number | null;
        uncertainty: number | null;
        capacityBinding: boolean;
        capacityCurveId: number | null;
        sourceScoreId: number | null;
    }>;
};

export type CapitalAllocationSleeve = {
    sleeveKind: 'bucket' | 'strategy' | 'external';
    sleeveRef: string;
    weight: number;
    allocatedNotionalBase: number;
    priorNotionalBase: number;
    standaloneSharpe: number | null;
    marginalSharpeAtAlloc: number | null;
    sqsValue: number | null;
    uncertainty: number | null;
    capacityBinding: boolean;
    capacityCurveId: number | null;
    sourceScoreId: number | null;
};

export type CapitalAllocationSubmitResult = {
    decisionId: number;
    outcome: 'created' | 'existing';
    reviewStatus: 'pending' | 'approved' | 'rejected' | 'deferred' | 'consumed';
};

export type CapacityCurve = {
    id: number;
    organizationId: number;
    manifest: {
        sleeveKind: 'bucket' | 'strategy' | 'external';
        sleeveRef: string;
        kind: 'impact_sqrt' | 'config_prior' | 'flat';
        estimatorVersion: string;
        asOf: string;
        sharpe0: number;
        impactCoefficient: number;
        advNotional: number | null;
        notionalCap: number;
        sharpeFloor: number;
        status: 'ready' | 'research_only' | 'blocked';
        contentDigest: string;
        diagnostics: Array<{
            code: 'insufficient_runs' | 'no_slippage_used_prior' | 'no_adv_input' | 'short_history_research_only';
            severity: 'blocker' | 'warning' | 'info';
            message: string;
        }>;
    };
};

export type TradingAccount = {
    id: number;
    organization_id: number;
    name: string;
    account_type: string;
    status: string;
    base_currency: string;
    cash_balance_base: string;
    net_liquidation: NetLiquidation;
};

export type NetLiquidation = {
    account_id: number;
    base_currency: string;
    cash_base: string;
    positions_mark_base: string;
    net_liquidation_base: string;
    unrealized_pnl_base: string;
    realized_pnl_base: string;
    marks_valued_at: string | null;
};

export type CashMovementResult = {
    applied: boolean;
};

export type AccountFxCash = {
    account_id: number;
    base_currency: string;
    as_of: string;
    legs: Array<FxCashLeg>;
    total_base: string | null;
    all_translated: boolean;
};

export type FxCashLeg = {
    currency: string;
    amount: string;
    rate: string | null;
    amount_base: string | null;
    source: string;
    unavailable: boolean;
    reason_code: string | null;
};

export type PositionLot = {
    id: number;
    account_id: number;
    symbol: string;
    exchange: string;
    side: 'long' | 'short';
    original_quantity: string;
    remaining_quantity: string;
    cost_basis_per_unit: string;
    acquisition_fee: string;
    currency: string;
    acquired_at: string;
    status: 'open' | 'closed';
};

export type LotDisposal = {
    id: number;
    lot_id: number;
    disposed_quantity: string;
    proceeds_per_unit: string;
    cost_basis_per_unit: string;
    realized_pnl: string;
    holding_term: 'short' | 'long';
    holding_days: number;
    acquired_at: string;
    disposed_at: string;
};

export type BookSnapshot = {
    id: number;
    account_id: number;
    symbol: string;
    side: 'long' | 'short';
    currency: string;
    snapshot_type: 'sod' | 'eod';
    as_of: string;
    open_lot_count: number;
    total_quantity: string;
    total_cost_basis: string;
    mark_price: string | null;
    unrealized_pnl: string | null;
    struck_at: string;
};

export type DtiKillSwitchResult = {
    forwardRunId: string;
    status: 'paused' | 'active';
};

export type DtiKillSwitchRequest = {
    reason?: string;
};

export type DtiResumeRequest = {
    reason?: string;
};

export type CreateDiscretionaryRunResult = {
    forwardRunId: string;
    scope: string;
    status: 'active';
    personaTemplateId: number;
    agentId: number;
};

export type CreateDiscretionaryRunRequest = {
    personaSlug: string;
    primarySymbol: string;
    exchange?: string;
    baseTimeframe?: string;
    timeframeStack?: Array<string>;
    minConviction?: number;
    minConfluenceScore?: number;
    calibratedSetups?: Array<string>;
    calibratedRegimes?: Array<string>;
    maxPositionFrac?: number;
    minRiskReward?: number;
    governanceCeilingNAV?: number;
    monitor: {
        backtestMeanReturn: number;
        backtestVolatility: number;
        deflatedSharpeRatio: number;
        annualizationFactor: number;
        sourceExchange: string;
        sourceTimeframe: string;
        validatedRegimes?: Array<string>;
        sprtAlpha?: number;
        sprtBeta?: number;
        sprtDeltaSR?: number;
        cusumHOverride?: number;
    };
    daemonSlug?: string;
    personaVersion?: string;
    styleVersion?: string;
    initialCash?: number;
};

export type IntelSourceStyleProfileResult = {
    data: {
        [key: string]: unknown;
    };
    meta: {
        intelSourceId: string;
        version: number;
        builtAt: string | null;
        insightCount: number;
    };
};

export type IntelSourceViewConfirmationResponse = {
    data: {
        horizons: Array<IntelSourceViewConfirmationHorizon>;
        agreement: IntelSourceViewConfirmationAgreement;
        pending: IntelSourceViewConfirmationPending;
    };
};

export type IntelSourceViewConfirmationHorizon = {
    horizonDays: number;
    matched: number;
    missed: number;
    neutralBand: number;
    hitRate: number | null;
    sampleSize: number;
};

export type IntelSourceViewConfirmationAgreement = {
    meanAgreement: number | null;
    sampleSize: number;
};

export type IntelSourceViewConfirmationPending = {
    count: number;
    nextDueAt: string | null;
};

export type AuditLedgerEntryList = {
    entries: Array<AuditLedgerEntry>;
    next_cursor_seq: number | null;
};

export type AuditLedgerEntry = {
    id: string;
    organization_id: number;
    chain_seq: number;
    prev_hash: string | null;
    row_hash: string;
    entry_kind: string;
    severity: string;
    subject_kind: string;
    order_id: number | null;
    position_id: number | null;
    daemon_decision_id: number | null;
    strategy_definition_id: number | null;
    portfolio_id: number | null;
    actor_kind: string;
    actor_user_id: number | null;
    actor_daemon_id: number | null;
    actor_label: string | null;
    payload: {
        [key: string]: unknown;
    };
    effective_at: string;
    recorded_at: string;
    clock_source: string;
};

export type AuditLedgerHead = {
    organization_id: number;
    head_seq: number;
    head_hash: string;
    entry_count: number;
    created_at: string | null;
    updated_at: string | null;
};

export type AuditLedgerChainVerificationResult = {
    valid: boolean;
    entries_checked: number;
    first_broken_seq: number | null;
    reason: string | null;
};

export type ExecutionDeployment = {
    id: number;
    run_id: string;
    organization_id: number;
    definition_id: number | null;
    bucket_definition_id: number | null;
    scope: string;
    run_mode: string;
    run_status: string | null;
    requested_adapter_ref: string | null;
    venue: string | null;
    notional_budget: number | null;
    order_count: number;
    placed_count: number;
    blocked_reasons: Array<string>;
    created_at: string;
    finished_at: string | null;
};

export type ExecutionDeploymentCreate = {
    definition_id?: number;
    bucket_definition_id?: number;
    venue: 'paper' | 'live';
    notional_budget?: number;
};

export type ExecutionDeploymentList = {
    data: Array<ExecutionDeployment>;
    total: number;
    limit: number;
    offset: number;
};

export type ExecutionDeploymentRun = {
    run: ExecutionDeployment;
    orders: Array<ExecutionDeploymentOrder>;
};

export type ExecutionDeploymentOrder = {
    id: number;
    strategy_run_id: number | null;
    client_order_id: string;
    symbol: string;
    exchange: string;
    side: string;
    type: string;
    quantity: string;
    filled_quantity: string | null;
    avg_fill_price: string | null;
    status: string | null;
    reject_reason: string | null;
    submitted_at: string | null;
    filled_at: string | null;
    fills: Array<{
        id: number;
        price: string;
        quantity: string;
        commission: string | null;
        commission_asset: string | null;
        filled_at: string | null;
    }>;
};

export type PortfolioValuationResult = {
    portfolioId: number;
    asOf: string;
    equityValueUsd: number;
    markedCount: number;
    staleCount: number;
    unmarkedCount: number;
    marks: Array<MarkResult>;
};

export type MarkResult = {
    scope: 'position' | 'holding' | 'symbol';
    scopeId: number | null;
    symbol: string;
    exchange: string;
    asOf: string;
    status: 'marked' | 'stale' | 'unmarked';
    source: 'candle_close' | 'candle_close_stale' | 'manual_override' | 'unmarked';
    markPriceUsd: number | null;
    marketValueUsd: number | null;
    quantity: number;
    barTime: string | null;
    providerRef: string | null;
    dataAvailableAt: string | null;
    adjustmentPolicy: string;
    pointInTime: 'verified' | 'unverified';
    reasonCode: string | null;
};

export type ModelLineageRecordList = {
    records: Array<ModelLineageRecord>;
    total: number;
};

export type ModelLineageRecord = {
    subjectKind: 'strategy_definition' | 'strategy_bucket_definition';
    subjectId: string;
    definitionVersion: number;
    slug: string;
    name: string;
    category: string | null;
    definitionHash: string;
    paramSetHashes: Array<string>;
    lifecycleState: string;
    validationStatus: string;
    transitionCount: number;
    lastApprovalDecisionId: string | null;
    lastTransitionAt: string | null;
    authoring: ModelLineageAuthoring;
    templateProvenance: ModelLineageTemplateProvenance | null;
    dataVintage: ModelLineageDataVintage;
    codeVersions: Array<string>;
    randomSeeds: Array<number>;
    adapterRefs: Array<string>;
    runCount: number;
    lastRunId: string | null;
    lastRunFinishedAt: string | null;
    scoreSummary: ModelLineageScoreSummary;
    executionFootprint: ModelLineageExecutionFootprint;
    lineageHash: string;
    computedAt: string;
};

export type ModelLineageAuthoring = {
    workflowRunId: string | null;
    authoringModel: string | null;
    authoringStepId: string | null;
    authoringAgentId: string | null;
    daemonRunId: string | null;
    daemonId: string | null;
    daemonName: string | null;
    authoringCostUsd: string | null;
    authoringQualityScore: string | null;
    workOutputId: string | null;
    outputPartId: string | null;
};

export type ModelLineageDataVintage = {
    vintages: Array<ModelLineageDataVintageRef>;
    hasMultipleVintages: boolean;
    costModelIds: Array<string>;
};

export type ModelLineageDataVintageRef = {
    dataSnapshotId: string;
    providers: Array<string>;
    pointInTimeCorrect: boolean | null;
    survivorshipBiasFree: boolean | null;
    runCount: number;
};

export type ModelLineageScoreSummary = {
    scores: Array<ModelLineageScoreEntry>;
};

export type ModelLineageScoreEntry = {
    scoreType: string;
    scope: string;
    regime: string;
    value: number;
    uncertainty: number;
    skillProb: number | null;
    skillProbSource: 'dsr' | 'psr' | null;
    pboPassed: boolean | null;
    sourceRunIds: Array<string>;
    computedAt: string;
};

export type ModelLineageExecutionFootprint = {
    executionIntentCount: number;
    orderCount: number;
    fillCount: number;
    everTraded: boolean;
    lastFillAt?: string | null;
};

export type ModelLineageGraph = {
    record: ModelLineageRecord;
    edges: Array<ModelLineageEdge>;
};

export type ModelLineageEdge = {
    edgeKind: 'authored_by' | 'compiled_from' | 'evaluated_by' | 'used_data_vintage' | 'used_adapter' | 'scored_by' | 'derived_edge' | 'lifecycle_transition' | 'approved_by' | 'executed_as' | 'filled_by' | 'audited_by';
    srcKind: string;
    srcId: string;
    dstKind: string;
    dstId: string | null;
    dstRef: string | null;
    attributes: {
        [key: string]: string | number | boolean | null;
    };
    ordinal: number;
};

export type KgRegimeProfile = {
    subject_kind: string;
    subject_id: number;
    by_score_type: Array<KgScoreTypeRegimeProfile>;
    has_regime_conditional_scores: boolean;
};

export type KgScoreTypeRegimeProfile = {
    score_type: string;
    scope: string;
    global: KgRegimeScoreEntry | null;
    by_regime: Array<KgRegimeScoreEntry>;
    is_regime_conditional: boolean;
};

export type KgNodeEdges = {
    node: KgNodeSummary;
    edges: Array<KgEdgeEntry>;
    total: number;
};

export type KgEdgeEntry = {
    id: string;
    edge_type: string;
    src_kind: string;
    src_id: string;
    dst_kind: string;
    dst_id: string;
    directed: boolean;
    strength: number | null;
    confidence: number | null;
    evidence_count: number;
    regime: string | null;
    valid_from: string | null;
    valid_until: string | null;
    last_evidence_at: string | null;
    status: 'active' | 'contradicted' | 'retired' | 'superseded';
    linked_node: KgNodeSummary | null;
};

export type KgSearchResultList = {
    results: Array<KgSearchResult>;
};

export type KgSearchResult = {
    id: string;
    node_type: string;
    canonical_key: string;
    label: string;
    status: 'active' | 'merged' | 'retired';
    score: number;
    match_type: 'keyword' | 'semantic' | 'hybrid';
};

export type BrokerCredential = {
    id: string;
    provider: 'alpaca' | 'binance' | 'paper' | 'bybit' | 'ibkr' | 'hyperliquid';
    environment: 'paper' | 'live';
    venue_kind: 'cash_equity' | 'crypto_spot' | 'crypto_perp' | 'paper';
    label: string | null;
    api_key_tail: string;
    base_url: string | null;
    is_enabled: boolean;
    asset_classes: Array<'equity' | 'etf' | 'index' | 'crypto' | 'fx' | 'commodity'>;
    last_verified_at: string | null;
    created_at: string;
    updated_at: string;
};

export type BrokerCredentialCreate = {
    provider: 'alpaca' | 'binance' | 'paper' | 'bybit' | 'ibkr' | 'hyperliquid';
    environment: 'paper' | 'live';
    venue_kind: 'cash_equity' | 'crypto_spot' | 'crypto_perp' | 'paper';
    label?: string;
    api_key: string;
    api_secret: string;
    base_url?: string;
    asset_classes: Array<'equity' | 'etf' | 'index' | 'crypto' | 'fx' | 'commodity'>;
};

export type BrokerCredentialList = {
    data: Array<BrokerCredential>;
};

export type BrokerCredentialUpdate = {
    label?: string;
    is_enabled?: boolean;
    api_key?: string;
    api_secret?: string;
    base_url?: string;
    asset_classes?: Array<'equity' | 'etf' | 'index' | 'crypto' | 'fx' | 'commodity'>;
};

export type BrokerCredentialVerifyResult = {
    ok: boolean;
    error: string | null;
};

export type ExecutionAlgo = {
    id: string;
    organization_id: string;
    user_id: string;
    strategy_run_id: string | null;
    symbol: string;
    side: 'buy' | 'sell';
    asset_class: string;
    total_quantity: string;
    algo_type: 'twap' | 'vwap' | 'market_making';
    params: {
        type: 'execution_algo_params';
        schemaVersion: 'finance-execution-algo/v1';
        startAt: string;
        endAt: string;
        sliceIntervalSeconds: number;
        orderTypePolicy?: 'marketable_limit' | 'market';
        slippageCapBps?: number;
        participationCapPct?: number;
        minClip: number;
        maxClip: number;
        timeJitterPct?: number;
        sizeJitterPct?: number;
        volumeProfile?: Array<number>;
        arrivalPrice?: number;
        degradedReason?: string;
        hedgeContext?: {
            policy: 'delta' | 'whalley_wilmott' | 'learned_ntb';
            greek: 'delta' | 'gamma' | 'vega';
            regimeAtDecision: string;
            policyVersion: string;
            decisionId: string;
        };
        quotePolicy?: {
            policyVersion: string;
            quoteMode: 'post_only_ladder' | 'styled_paper_rest';
            regimeAtDecision: string;
            decisionId: string;
            baselineIsNoSkew: boolean;
        };
    };
    status: 'working' | 'completed' | 'cancelled' | 'expired' | 'failed' | 'paused';
    next_slice_due_at: string | null;
    slices_submitted: number;
    last_error: string | null;
    created_at: string;
    updated_at: string;
    completed_at: string | null;
};

export type ExecutionAlgoCreate = {
    symbol: string;
    side: 'buy' | 'sell';
    asset_class: 'crypto' | 'equity';
    total_quantity: number;
    algo_type: 'twap' | 'vwap' | 'market_making';
    params: {
        type: 'execution_algo_params';
        schemaVersion: 'finance-execution-algo/v1';
        startAt: string;
        endAt: string;
        sliceIntervalSeconds: number;
        orderTypePolicy?: 'marketable_limit' | 'market';
        slippageCapBps?: number;
        participationCapPct?: number;
        minClip: number;
        maxClip: number;
        timeJitterPct?: number;
        sizeJitterPct?: number;
        volumeProfile?: Array<number>;
        arrivalPrice?: number;
        degradedReason?: string;
        hedgeContext?: {
            policy: 'delta' | 'whalley_wilmott' | 'learned_ntb';
            greek: 'delta' | 'gamma' | 'vega';
            regimeAtDecision: string;
            policyVersion: string;
            decisionId: string;
        };
        quotePolicy?: {
            policyVersion: string;
            quoteMode: 'post_only_ladder' | 'styled_paper_rest';
            regimeAtDecision: string;
            decisionId: string;
            baselineIsNoSkew: boolean;
        };
    };
};

export type ExecutionAlgoList = {
    data: Array<ExecutionAlgo>;
};

export type ExecutionAlgoWithSummary = ExecutionAlgo & {
    worked_quantity: number;
    in_flight_count: number;
};

export type ForwardRunCreateResult = {
    forwardRunId: string;
    created: boolean;
};

export type CreateForwardRunBody = {
    definitionId: string;
    symbols: Array<string>;
    exchange: string;
    timeframe: string;
    initialCapital?: number;
    participationCap?: number;
    costModel?: {
        [key: string]: unknown;
    };
    runConfig?: {
        [key: string]: unknown;
    };
};

export type CreateBucketForwardRunBody = {
    bucketDefinitionId: string;
    componentSymbols: {
        [key: string]: Array<string>;
    };
    componentRunConfigs?: {
        [key: string]: {
            [key: string]: unknown;
        };
    };
    exchange: string;
    timeframe: string;
    initialCapital?: number;
    participationCap?: number;
    costModel?: {
        [key: string]: unknown;
    };
    maxDroppedWeightFrac?: number;
    runConfig?: {
        [key: string]: unknown;
    };
};

export type ForwardRunList = {
    data: Array<ForwardRunListItem>;
    limit: number;
    offset: number;
};

export type ForwardRunListItem = {
    id: string;
    definitionId: string | null;
    bucketDefinitionId: string | null;
    scope: string;
    status: 'warming_up' | 'active' | 'paused' | 'stopped';
    requestId: string;
    baseRunId: string | null;
    initialCash: number | null;
    cash: number | null;
    equity: number | null;
    startedAt: string | null;
    watermarkBar: string | null;
    createdAt: string;
    updatedAt: string;
};

export type ForwardRun = ForwardRunListItem & {
    positions: {
        [key: string]: number;
    };
    honestyManifest: {
        [key: string]: unknown;
    } | null;
    config: {
        [key: string]: unknown;
    };
};

export type ShadowDaemonCertList = {
    data: Array<ShadowDaemonCert>;
};

export type ShadowDaemonCert = {
    daemonId: number;
    daemonSlug: string;
    certStatus: 'off' | 'collecting' | 'eligible' | 'certified' | 'blocked';
    mode: 'off' | 'collecting' | 'certified';
    counters: ShadowCertCounters | null;
    thresholds: ShadowCertThresholds | null;
    updatedAt: string | null;
    certDecisionId: number | null;
};

export type ShadowDaemonCertData = {
    data: ShadowDaemonCert;
};

export type ShadowDaemonEnrollUpdate = {
    mode: 'off' | 'collecting';
};

export type ProjectCodeOperationalMetrics = {
    reviewRequestCount: number;
    pendingReviewCount: number;
    oldestPendingReviewAgeMs: number | null;
    averageDecisionLatencyMs: number | null;
    riskAcceptanceExpiringCount: number;
    nextRiskAcceptanceExpiresAt: string | null;
    daemonEvidenceAverageLatencyMs: number | null;
    requestChangesLoopCount: number;
    sourceSyncPendingCount: number;
    sourceSyncAverageLatencyMs: number | null;
};

export type CodeWorkspaceState = {
    workspace: CodeWorkspace | null;
};

export type CodeRepositoryConnectionList = {
    data: Array<CodeRepositoryConnection>;
};

export type CodeRepositoryConnection = {
    id: number;
    organizationId: number;
    projectId: number | null;
    provider: 'local_git' | 'github' | 'gitlab' | 'gitea' | 'forgejo' | 'gerrit' | 'confluent_hosted';
    status: 'active' | 'disabled' | 'archived';
    providerInstallationId: string | null;
    providerAccountId: string | null;
    providerRepositoryId: string | null;
    repoOwner: string | null;
    repoName: string | null;
    repoUrl: string | null;
    providerHtmlUrl: string | null;
    defaultBranch: string;
    localPath: string | null;
    metadata: {
        [key: string]: unknown;
    };
    createdAt: string;
    updatedAt: string;
};

export type CodeRepositoryConnectionCreateInput = {
    provider: 'local_git' | 'github' | 'gitlab' | 'gitea' | 'forgejo' | 'gerrit' | 'confluent_hosted';
    defaultBranch?: string;
    providerInstallationId?: string | null;
    providerAccountId?: string | null;
    providerRepositoryId?: string | null;
    repoOwner?: string | null;
    repoName?: string | null;
    repoUrl?: string | null;
    providerHtmlUrl?: string | null;
    localPath?: string | null;
    metadata?: {
        [key: string]: unknown;
    };
};

export type CodeWorkspaceEnableResult = {
    workspace: CodeWorkspace;
    operation: CodeWorkspaceOperation | null;
    created: boolean;
};

export type CodeWorkspaceEnableInput = {
    provider: 'local_git' | 'github' | 'gitlab' | 'gitea' | 'forgejo' | 'gerrit' | 'confluent_hosted';
    repositoryConnectionId: number;
    branchPrefix?: string | null;
    isolationTier?: 'org_default' | 'project' | 'byo';
    metadata?: {
        [key: string]: unknown;
    };
};

export type CodeWorkspaceCheckpointsList = {
    data: Array<CodeCheckpoint>;
    pageInfo: {
        hasNextPage: boolean;
        endCursor: string | null;
    };
};

export type CodeCheckpoint = {
    id: number;
    organizationId: number;
    workspaceId: number | null;
    projectId: number;
    projectChangeId: number | null;
    revisionId: number | null;
    checkpointType: 'baseline' | 'generated' | 'approved' | 'merged' | 'rollback';
    status: 'valid' | 'superseded' | 'failed' | 'blocked';
    label: string | null;
    branchName: string;
    baseCommitSha: string | null;
    commitSha: string;
    treeSha: string | null;
    patchArtifactId: number | null;
    migrationArtifactId: number | null;
    validationReportArtifactId: number | null;
    statusSnapshot: {
        [key: string]: unknown;
    };
    rollbackOfCheckpointId: number | null;
    providerRef: string | null;
    providerUrl: string | null;
    createdByActorType: string;
    createdByActorId: string | null;
    metadata: {
        [key: string]: unknown;
    };
    createdAt: string;
    updatedAt: string;
};

export type CodeWorkspaceOperationsList = {
    data: Array<CodeWorkspaceOperation>;
    pageInfo: {
        hasNextPage: boolean;
        endCursor: string | null;
    };
};

export type CodeWorkspaceOperationResult = {
    operation: CodeWorkspaceOperation;
};

export type CodeWorkspaceMaterializeInput = {
    revisionId: number;
    expectedHeadSha?: string | null;
    branchName?: string;
};

export type CodeWorkspaceOpenReviewInput = {
    expectedHeadSha?: string | null;
    title?: string;
    body?: string;
};

export type CodeWorkspaceRollbackInput = {
    reason?: string;
    expectedHeadSha?: string | null;
};

export type CodeClientDatabaseState = {
    database: CodeClientDatabase | null;
    migrations: Array<CodeClientDatabaseMigration>;
    migrationsPageInfo: {
        limit: number;
        nextCursor: string | null;
        hasMore: boolean;
    };
    snapshots: Array<CodeClientDatabaseSnapshot>;
    snapshotsPageInfo: {
        limit: number;
        nextCursor: string | null;
        hasMore: boolean;
    };
};

export type CodeClientDatabaseMigration = {
    id: number;
    organizationId: number;
    clientDatabaseId: number;
    projectId: number | null;
    workspaceId: number | null;
    projectChangeId: number | null;
    revisionId: number | null;
    outputDeliveryId: number | null;
    outputPartId: number | null;
    migrationKind: 'schema' | 'seed' | 'table_write' | 'sync_payload';
    status: 'pending' | 'applied' | 'failed' | 'skipped';
    migrationName: string | null;
    migrationHash: string | null;
    migrationFilePath: string | null;
    migrationFileHash: string | null;
    idempotencyKey: string | null;
    sourcePartKind: string | null;
    schemaName: string | null;
    tableName: string | null;
    statementCount: number | null;
    rowCount: number | null;
    requestPayload?: {
        partKind?: string;
        partKey?: string;
        targetId?: number;
        deliveryId?: number;
        processorType?: string;
        tableName?: string | null;
        schemaName?: string | null;
        migrationFilePath?: string | null;
        migrationFileHash?: string | null;
        decisionMode?: string;
        decision?: {
            action?: 'configured' | 'enabled' | 'disabled' | 'archived' | 'secret_rotated';
            reason?: string;
            mode?: 'missing_scope' | 'needs_target' | 'row_limit_exceeded' | 'byo_payload' | 'target_not_active' | 'unsupported_or_policy_blocked' | 'review_gate_required' | 'queued_table_write' | 'migration_payload' | 'applied' | 'failed' | 'pending' | 'skipped';
            targetId?: number;
            migrationKind?: 'schema' | 'seed' | 'table_write' | 'sync_payload';
            schemaName?: string;
            tableName?: string;
            rowCount?: number;
            maxRows?: number;
            isolationTier?: 'org_default' | 'project' | 'byo';
            scope?: 'organization' | 'project';
            provider?: 'managed_postgres' | 'byo_postgres';
            status?: 'provisioning' | 'active' | 'failed' | 'disabled' | 'archived';
            projectId?: number;
            secretMode?: 'stored_external_ref' | 'provided_external_ref' | 'managed_provisioning' | 'existing_secret_ref';
            writePolicy?: {
                mode?: 'migrations_only' | 'table_writes';
                allowSchemaChanges?: boolean;
                requireReviewGate?: boolean;
                conflictPolicy?: 'do_nothing' | 'upsert';
                maxRowsPerPart?: number;
                allowedSchemas?: Array<string>;
                allowedTables?: Array<string>;
            } | null;
        };
        mode?: string;
        rowCount?: number;
    };
    resultPayload?: {
        partKind?: string;
        partKey?: string;
        targetId?: number;
        deliveryId?: number;
        processorType?: string;
        tableName?: string | null;
        schemaName?: string | null;
        migrationFilePath?: string | null;
        migrationFileHash?: string | null;
        decisionMode?: string;
        decision?: {
            action?: 'configured' | 'enabled' | 'disabled' | 'archived' | 'secret_rotated';
            reason?: string;
            mode?: 'missing_scope' | 'needs_target' | 'row_limit_exceeded' | 'byo_payload' | 'target_not_active' | 'unsupported_or_policy_blocked' | 'review_gate_required' | 'queued_table_write' | 'migration_payload' | 'applied' | 'failed' | 'pending' | 'skipped';
            targetId?: number;
            migrationKind?: 'schema' | 'seed' | 'table_write' | 'sync_payload';
            schemaName?: string;
            tableName?: string;
            rowCount?: number;
            maxRows?: number;
            isolationTier?: 'org_default' | 'project' | 'byo';
            scope?: 'organization' | 'project';
            provider?: 'managed_postgres' | 'byo_postgres';
            status?: 'provisioning' | 'active' | 'failed' | 'disabled' | 'archived';
            projectId?: number;
            secretMode?: 'stored_external_ref' | 'provided_external_ref' | 'managed_provisioning' | 'existing_secret_ref';
            writePolicy?: {
                mode?: 'migrations_only' | 'table_writes';
                allowSchemaChanges?: boolean;
                requireReviewGate?: boolean;
                conflictPolicy?: 'do_nothing' | 'upsert';
                maxRowsPerPart?: number;
                allowedSchemas?: Array<string>;
                allowedTables?: Array<string>;
            } | null;
        };
        mode?: string;
        rowCount?: number;
    };
    errorMessage: string | null;
    startedAt: string | null;
    completedAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type CodeClientDatabaseSnapshot = {
    id: number;
    organizationId: number;
    clientDatabaseId: number;
    projectId: number | null;
    workspaceId: number | null;
    codeCheckpointId: number | null;
    migrationId: number | null;
    snapshotType: 'schema_marker' | 'logical_export' | 'manual_marker' | 'config_marker';
    status: 'pending' | 'available' | 'failed' | 'expired';
    schemaHash: string | null;
    migrationVersion: string | null;
    artifactId: number | null;
    payloadUrl: string | null;
    metadata?: {
        source?: 'client_db_processor' | 'manual' | 'launch' | 'rollback';
        codeCheckpointId?: number;
        migrationId?: number;
        outputDeliveryId?: number;
        outputPartId?: number;
        projectChangeId?: number | null;
        migrationFilePath?: string | null;
        migrationFileHash?: string | null;
        decision?: {
            action?: 'configured' | 'enabled' | 'disabled' | 'archived' | 'secret_rotated';
            reason?: string;
            mode?: 'missing_scope' | 'needs_target' | 'row_limit_exceeded' | 'byo_payload' | 'target_not_active' | 'unsupported_or_policy_blocked' | 'review_gate_required' | 'queued_table_write' | 'migration_payload' | 'applied' | 'failed' | 'pending' | 'skipped';
            targetId?: number;
            migrationKind?: 'schema' | 'seed' | 'table_write' | 'sync_payload';
            schemaName?: string;
            tableName?: string;
            rowCount?: number;
            maxRows?: number;
            isolationTier?: 'org_default' | 'project' | 'byo';
            scope?: 'organization' | 'project';
            provider?: 'managed_postgres' | 'byo_postgres';
            status?: 'provisioning' | 'active' | 'failed' | 'disabled' | 'archived';
            projectId?: number;
            secretMode?: 'stored_external_ref' | 'provided_external_ref' | 'managed_provisioning' | 'existing_secret_ref';
            writePolicy?: {
                mode?: 'migrations_only' | 'table_writes';
                allowSchemaChanges?: boolean;
                requireReviewGate?: boolean;
                conflictPolicy?: 'do_nothing' | 'upsert';
                maxRowsPerPart?: number;
                allowedSchemas?: Array<string>;
                allowedTables?: Array<string>;
            } | null;
        };
        migrationStatus?: 'pending' | 'applied' | 'failed' | 'skipped';
        errorMessage?: string;
        rowCount?: number;
        isolationTier?: 'org_default' | 'project' | 'byo';
        status?: 'provisioning' | 'active' | 'failed' | 'disabled' | 'archived';
        note?: string;
    };
    createdByActorType: 'server' | 'engine' | 'human_user' | 'agent' | 'system';
    createdByActorId: string | null;
    capturedAt: string | null;
    expiresAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export type CodeClientDatabaseConfigureInput = {
    isolationTier?: 'org_default' | 'project' | 'byo';
    connectionString?: string;
    connectionSecretRef?: string;
    connectionSecretProvider?: 'external_ref' | 'aws_secrets_manager' | 'gcp_secret_manager' | 'vault' | 'local_file' | 'env';
    connectionFingerprint?: string;
    databaseName?: string;
    schemaName?: string;
    appRoleName?: string;
    migrationRoleName?: string;
    runtimeUrlEnvVar?: string;
    migrationUrlEnvVar?: string;
    writePolicy?: {
        mode?: 'migrations_only' | 'table_writes';
        allowSchemaChanges?: boolean;
        requireReviewGate?: boolean;
        conflictPolicy?: 'do_nothing' | 'upsert';
        maxRowsPerPart?: number;
        allowedSchemas?: Array<string>;
        allowedTables?: Array<string>;
    };
    metadata?: {
        displayName?: string;
        environment?: string;
        notes?: string;
        tags?: Array<string>;
    };
};

export type CodeTuningView = {
    projectId: number;
    workstream: CodeTuningWorkstream;
    conversation: CodeTuningConversation | null;
    messages: Array<CodeTuningMessage>;
    latestVersion: CodeTuningVersion;
    versions: Array<CodeTuningVersionSummary>;
    changeRevisions: Array<CodeTuningProjectChangeRevision>;
    meta: {
        serverTime: string;
    };
};

export type CodeTuningWorkstream = {
    id: number;
    organizationId: number;
    projectId: number;
    projectChangeId: number;
    name: string;
    description: string | null;
    focus: 'feature' | 'marketing' | 'research' | 'ops' | 'support' | 'general';
    status: 'active' | 'paused' | 'archived' | 'completed';
    managerAgentId: number | null;
    createdBy: number | null;
    createdAt: string;
    updatedAt: string;
    deletedAt: string | null;
};

export type CodeTuningMessage = {
    id: number;
    conversationId: number;
    role: 'system' | 'user' | 'assistant' | 'tool';
    content: string;
    contentForReplay: string | null;
    parts: Array<unknown>;
    createdAt: string;
};

export type CodeTuningProjectChangeRevision = {
    id: number;
    organizationId: number;
    projectChangeId: number;
    sequence: number;
    status: 'draft' | 'generated' | 'validating' | 'validated' | 'failed' | 'superseded';
    summary: string | null;
    patchArtifactId: number | null;
    validationReportArtifactId: number | null;
    sourceConversationId: number | null;
    sourceWorkflowRunId: number | null;
    sourceTaskIds: Array<number> | null;
    baseCommitSha: string | null;
    commitSha: string | null;
    patchHash: string | null;
    metadata: {
        [key: string]: unknown;
    } | null;
    createdBy: number | null;
    createdAt: string;
    updatedAt: string;
};

export type CodeWorkforceEnable = {
    projectId: number;
    workstreamId: number;
    pmAgentId: number;
    pmMemberId: number;
    created: boolean;
    activityResourceId: number | null;
    activityCreated: boolean;
};

export type CodeGenerationRunQueued = {
    runId: string;
    workflowId: string;
    status: 'pending';
    projectId: number;
    workstreamId: number;
    projectChangeId: number;
    projectThreadId: number;
};

export type CodeGenerationRunCreateInput = {
    codegenConfig: {
        manifest: {
            id: string;
            displayName: string;
            description?: string;
            icon?: string;
            navOrder?: number;
            status: 'active' | 'preview' | 'archived';
            policies?: Array<string>;
            nav?: Array<unknown>;
            dependsOn?: Array<string>;
        };
        entities: Array<{
            id: string;
            displayName: string;
            kind: 'list' | 'transactional' | 'enum';
            description?: string;
        }>;
        tables: Array<{
            name: string;
            schema?: string;
            columns: Array<{
                name: string;
                type: 'text' | 'integer' | 'bigint' | 'boolean' | 'timestamp' | 'jsonb' | 'numeric' | 'pgEnum';
                nullable?: boolean;
                defaultValue?: string;
                sensitivity?: 'pii' | 'phi' | 'privileged' | 'restricted';
                pgEnumValues?: Array<string>;
                references?: {
                    table: string;
                    column: string;
                    onDelete?: 'cascade' | 'set null' | 'restrict';
                };
                primaryKey?: boolean;
                unique?: boolean;
            }>;
            indexes?: Array<{
                name: string;
                columns: Array<string>;
                unique?: boolean;
            }>;
            rls?: {
                orgScoped: boolean;
            };
        }>;
        routes: Array<{
            entityId: string;
            operation: 'list' | 'get' | 'create' | 'update' | 'delete' | 'action';
            path: string;
            method: 'GET' | 'POST' | 'PATCH' | 'DELETE';
            operationId: string;
            policy: string;
            actionName?: string;
        }>;
        pages: Array<{
            entityId: string;
            type: 'list' | 'detail' | 'new';
            fields: Array<{
                name: string;
                label: string;
                helpText?: string;
            }>;
        }>;
        stack?: {
            frontend: string;
            backend: string;
            database: string;
            runtime: string;
            packageManager?: string;
            repoShape?: string;
        };
        mockData?: {
            [key: string]: Array<{
                [key: string]: unknown;
            }>;
        };
    };
    sourceArtifacts: Array<{
        kind: 'code_idea_brief' | 'code_requirements_pack' | 'code_ux_plan' | 'code_architecture_plan' | 'code_data_model' | 'code_module_selection_plan' | 'codegen_manifest' | 'code_ui_plan' | 'code_ui_source' | 'code_ui_runtime_source' | 'code_ui_dashboard_source' | 'code_ui_bootstrap_source' | 'code_ui_app_source' | 'code_ui_styles_source' | 'code_backend_plan' | 'code_backend_source' | 'code_backend_api_source' | 'code_backend_data_source' | 'code_backend_runtime_source' | 'code_migration_plan' | 'code_database_pass' | 'code_ui_pass' | 'code_backend_pass' | 'code_integration_report' | 'code_validation_report' | 'code_security_review_report' | 'code_quality_review_report' | 'code_review_gate_decision' | 'code_approval_request' | 'code_approval_decision' | 'code_remediation_plan' | 'code_launch_report' | 'code_incident_report';
        status?: 'draft' | 'ready' | 'blocked' | 'superseded';
        title: string;
        artifactId?: number;
        workOutputId?: number;
        outputPartId?: number;
        workflowRunId?: number;
        taskId?: number;
        summary?: string;
        producedBy?: string;
    }>;
    title?: string;
    summary?: string;
    mode?: 'mock' | 'real' | 'mixed';
    emitSchemaLayer?: boolean;
    emitServerLayer?: boolean;
    emitFrontend?: boolean;
    targetRepo?: string;
    baseCommitSha?: string;
};

export type CodeReviewRequestList = {
    data: Array<CodeReviewRequestSummary>;
    pageInfo: {
        hasNextPage: boolean;
        endCursor: string | null;
    };
};

export type CodeReviewRequestSummary = {
    id: number;
    gateType: 'codegen_review' | 'plan' | 'ui' | 'database' | 'backend' | 'integration' | 'launch' | 'catalog_promotion' | 'platform_change';
    actionType: 'codegen:promote';
    status: 'pending' | 'approved' | 'rejected' | 'request_changes' | 'expired' | 'superseded';
    workOutputId: number;
    subjectKind: string;
    subjectId: string;
    subjectVersionHash: string | null;
    requestedByUserId: number;
    requestedAt: string;
    expiresAt: string | null;
    reviewer: {
        actorPlane: 'system_daemon' | 'workforce_member' | 'human_user' | 'service_account';
        actorKey: string | null;
        resolvedUserId: number | null;
        delegatedFromUserId: number | null;
        label: string | null;
    };
    decision: {
        action: 'approve' | 'reject' | 'request_changes' | 'accept_risk';
        decidedByUserId: number;
        decidedAt: string;
        rationale: string | null;
        reasonCode: string | null;
        riskAcceptedUntil: string | null;
    } | null;
    versionSnapshot: {
        title: string;
        summary: string | null;
        validationStatus: 'passing' | 'warning' | 'blocked' | null;
        patchHash: string | null;
        previewRoute: string | null;
        outputUpdatedAt: string | null;
    };
    createdRevisionId: number | null;
};

export type CodeReviewRequest = {
    id: number;
    gateType: 'codegen_review' | 'plan' | 'ui' | 'database' | 'backend' | 'integration' | 'launch' | 'catalog_promotion' | 'platform_change';
    actionType: 'codegen:promote';
    status: 'pending' | 'approved' | 'rejected' | 'request_changes' | 'expired' | 'superseded';
    workOutputId: number;
    subjectKind: string;
    subjectId: string;
    subjectVersionHash: string | null;
    requestedByUserId: number;
    requestedAt: string;
    expiresAt: string | null;
    reviewer: {
        actorPlane: 'system_daemon' | 'workforce_member' | 'human_user' | 'service_account';
        actorKey: string | null;
        resolvedUserId: number | null;
        delegatedFromUserId: number | null;
        label: string | null;
    };
    decision: {
        action: 'approve' | 'reject' | 'request_changes' | 'accept_risk';
        decidedByUserId: number;
        decidedAt: string;
        rationale: string | null;
        reasonCode: string | null;
        riskAcceptedUntil: string | null;
    } | null;
    versionSnapshot: {
        title: string;
        summary: string | null;
        validationStatus: 'passing' | 'warning' | 'blocked' | null;
        patchHash: string | null;
        previewRoute: string | null;
        outputUpdatedAt: string | null;
    };
    createdRevisionId: number | null;
    organizationId: number;
    projectId: number;
    workstreamId: number;
    projectChangeId: number;
    projectThreadId: number | null;
    requiredReviewerClass: string | null;
    separationOfDutiesKey: string | null;
    blockedReasons: Array<string>;
    evidence: Array<{
        id: number;
        reviewRequestId: number;
        sourceType: 'daemon_run' | 'daemon_finding' | 'work_output' | 'output_part' | 'workflow_run' | 'artifact' | 'task' | 'project_change_revision' | 'manual_note';
        sourceId: string;
        evidenceKind: string;
        actorPlane: 'system_daemon' | 'workforce_member' | 'human_user' | 'service_account';
        actorKey: string | null;
        actorSlug: string | null;
        actorProfileSlug: string | null;
        trustScope: 'system' | 'org' | 'project';
        subjectKind: string;
        subjectId: string;
        subjectVersionHash: string | null;
        status: string | null;
        severity: 'info' | 'low' | 'medium' | 'high' | 'critical' | null;
        summary: string | null;
        reviewSummary: {
            [key: string]: unknown;
        } | null;
        rawEvidenceAvailable: boolean;
        createdAt: string;
    }>;
    createdAt: string;
    updatedAt: string;
};

export type CodeReviewGateConflict = {
    code: 'PROJECT_CODE_REVIEW_ALREADY_PENDING' | 'PROJECT_CODE_REVIEW_REQUIRED' | 'PROJECT_CODE_REVIEW_NOT_PENDING' | 'PROJECT_CODE_REVIEW_EXPIRED' | 'PROJECT_CODE_REVIEW_PERSONA_MISSING';
    message: string;
    field?: string;
};

export type CodeReviewRequestCreate = {
    reviewerUserId: number;
    note?: string | null;
    expiresAt?: string | null;
};

export type CodeReviewRequestDecisionInput = {
    action: 'approve' | 'reject' | 'request_changes' | 'accept_risk';
    rationale?: string | null;
    reasonCode?: string | null;
    riskAcceptedUntil?: string | null;
};

export type CodePreviewSession = {
    sessionId: string;
    projectId: number;
    workstreamId: number;
    versionId: number;
    mode: 'mock' | 'real' | 'mixed';
    status: 'booting' | 'rehydrating' | 'ready' | 'blocked' | 'expired';
    previewUrl: string;
    eventsUrl: string;
    heartbeatUrl: string;
    expiresAt: string;
    capabilities: CodePreviewSessionCapabilities;
};

export type CodePreviewSessionCapabilities = {
    hotReload: boolean;
    reconnectable: boolean;
    backendPreview: boolean;
};

export type RateLimitExceeded = {
    error: {
        code: 'RATE_LIMIT_EXCEEDED';
        message: string;
    };
};

export type CodePreviewSessionCreateBody = {
    versionId?: number;
    mode?: 'mock' | 'real' | 'mixed';
};

export type CodePreviewSessionDispose = {
    sessionId: string;
    status: 'expired';
};

export type CodeWorkspaceWebhookResult = {
    accepted: boolean;
    ignored: boolean;
    queuedOperationId: number | null;
};

export type ApiDecisionList = {
    data: Array<ApiDecision>;
    paging: ApiPaging;
    meta: ApiMeta;
};

export type ApiDecision = {
    id: string;
    title: string | null;
    actionType: string;
    raisedByMe?: boolean;
    eligibleApprovers?: Array<{
        userId: string;
        name: string | null;
        department: string | null;
    }>;
    status?: string;
    decidedAt?: string | null;
    applied?: unknown;
    [key: string]: unknown;
};

export type ApiPaging = {
    cursors: {
        before: string | null;
        after: string | null;
    };
    hasMore: boolean;
    next: string | null;
};

export type ApiMeta = {
    serverTime: string;
    total?: number;
    [key: string]: unknown;
};

export type ApiError = {
    code: string;
    message: string;
    field?: string;
};

export type ApiDecisionReviewResult = {
    data: ApiDecisionReview;
    meta: ApiMeta;
};

export type ApiDecisionReview = {
    decisionId: string;
    title?: string | null;
    state: 'approved' | 'rejected' | 'already_decided' | 'refused';
    status?: string;
    appliedSummary?: string;
    createdIds?: {
        [key: string]: unknown;
    };
    applyFailed?: string;
    reason?: string;
    [key: string]: unknown;
};

export type ApiDecisionApproveRequest = {
    note?: string;
};

export type ApiDecisionRejectRequest = {
    reason: string;
};

export type ApiOutputPartResult = {
    data: ApiOutputPart;
    meta: ApiMeta;
};

export type ApiOutputPart = {
    part: {
        id: string;
        kind: string;
        title: string | null;
        runId: string | null;
        workflowId: string | null;
        mimeType: string | null;
        payloadUrl: string | null;
        sizeBytes: number;
        createdAt: string;
        [key: string]: unknown;
    };
    payload?: unknown;
    excerpt?: unknown;
    artifactId?: string | null;
    [key: string]: unknown;
};

export type ApiDashboardResult = {
    data: ApiDashboard;
    meta: ApiMeta;
};

export type ApiDashboard = {
    id: string;
    name: string;
    url: string;
    widgetCount: number;
    widgets: Array<{
        id: string;
        position: number;
        title: string | null;
        type: string;
        kind: string | null;
        config: {
            [key: string]: unknown;
        };
        data?: unknown;
        [key: string]: unknown;
    }>;
    [key: string]: unknown;
};

export type ApiIntelSourceList = {
    data: Array<ApiIntelSourceSummary>;
    paging: ApiPaging;
    meta: ApiMeta;
};

export type ApiIntelSourceSummary = {
    id: string;
    name: string;
    platform: string | null;
    following: boolean;
    [key: string]: unknown;
};

export type ApiIntelSourceItemList = {
    data: Array<ApiIntelSourceItem>;
    paging: ApiPaging;
    meta: ApiMeta;
};

export type ApiIntelSourceItem = {
    id: string;
    title: string;
    publishedAt: string;
    analyzed: boolean;
    insights: number;
    [key: string]: unknown;
};

export type ApiDecisionCancelResult = {
    data: ApiDecisionCancel;
    meta: ApiMeta;
};

export type ApiDecisionCancel = {
    decisionId: string;
    cancelled: true;
};

export type ApiStrategyList = {
    data: Array<ApiStrategySummary>;
    paging: ApiPaging;
    meta: ApiMeta;
};

export type ApiStrategySummary = {
    id: string;
    name: string;
    stage: string;
    [key: string]: unknown;
};

export type ApiStrategyResult = {
    data: ApiStrategy;
    meta: ApiMeta;
};

export type ApiStrategy = {
    strategy: ApiStrategySummary;
    metrics: {
        [key: string]: unknown;
    };
    regimes: Array<unknown>;
    robustAcrossRegimes: boolean | null;
    robustness?: string;
    template?: unknown;
    parameters?: Array<unknown>;
    definition?: unknown;
    readiness?: unknown;
    verdict: string;
    [key: string]: unknown;
};

export type ApiStrategyBucketList = {
    data: Array<ApiStrategyBucketSummary>;
    paging: ApiPaging;
    meta: ApiMeta;
};

export type ApiStrategyBucketSummary = {
    id: string;
    name: string;
    legs: number;
    [key: string]: unknown;
};

export type ApiStrategyBucketResult = {
    data: ApiStrategyBucket;
    meta: ApiMeta;
};

export type ApiStrategyBucket = {
    bucket: {
        id: string;
        name: string;
        mode: string | null;
        [key: string]: unknown;
    };
    legs: number;
    legDetails: Array<{
        strategyId: string;
        name: string;
        role: string | null;
        direction: string | null;
        weight: number | null;
        status: string | null;
        bestRegime: string | null;
        latestBacktest: {
            runId: string | number | null;
            sharpe: number | null;
            maxDrawdownPct: number | null;
            trades: number | null;
            [key: string]: unknown;
        } | null;
        [key: string]: unknown;
    }>;
    [key: string]: unknown;
};

export type ApiBacktestComparisonResult = {
    data: ApiBacktestComparison;
    meta: ApiMeta;
};

export type ApiBacktestComparison = {
    items: Array<{
        id: string;
        found: boolean;
        strategy: string | null;
        status: string | null;
        mode: string | null;
        timeframe: string | null;
        window: {
            from: string | null;
            to: string | null;
        } | null;
        metrics: {
            sharpe: number | null;
            maxDrawdownPct: number | null;
            trades: number | null;
            winRatePct?: number | null;
            [key: string]: unknown;
        } | null;
        stats: {
            sortino: number | null;
            totalReturnPct: number | null;
            probabilisticSharpe: number | null;
            deflatedSharpe: number | null;
            pbo: number | null;
            walkForwardEfficiency: number | null;
            researchOnly: boolean | null;
            verdict: string | null;
            [key: string]: unknown;
        } | null;
        series: {
            [key: string]: number;
        };
        [key: string]: unknown;
    }>;
    leaders: {
        [key: string]: string | null;
    };
    [key: string]: unknown;
};

export type ApiMarketRegimeList = {
    data: Array<ApiMarketRegime>;
    paging: ApiPaging;
    meta: ApiMeta;
};

export type ApiMarketRegime = {
    symbol: string;
    exchange: string;
    timeframe: string;
    axis: string;
    regime: string;
    confidence: number | null;
    asOf: string;
    features: {
        [key: string]: unknown;
    } | null;
    [key: string]: unknown;
};

export type ApiBacktestList = {
    data: Array<ApiBacktestSummary>;
    paging: ApiPaging;
    meta: ApiMeta;
};

export type ApiBacktestSummary = {
    id: string;
    title: string;
    strategy: string;
    status: string;
    mode: string;
    scope: string;
    usingDbCandles: boolean | null;
    ranAt: string | null;
    sharpe: number | null;
    maxDrawdownPct: number | null;
    trades: number | null;
    [key: string]: unknown;
};

export type ApiBacktestRunResult = {
    data: ApiBacktestRun;
    meta: ApiMeta;
};

export type ApiBacktestRun = {
    queued: boolean;
    reused?: boolean;
    run?: {
        id: string;
        finishedAt?: string | null;
        sharpe?: number | null;
        maxDrawdown?: number | null;
        [key: string]: unknown;
    };
    status?: string;
    mode?: string;
    requestId?: string;
    window?: {
        from: string;
        to: string;
        [key: string]: unknown;
    };
    timeframe?: string;
    symbols?: Array<string>;
    exchange?: string;
    [key: string]: unknown;
};

export type ApiBacktestCreate = {
    mode?: 'backtest' | 'walk_forward' | 'parameter_sweep' | 'robustness';
    symbols?: Array<string>;
    universe?: 'nasdaq100' | 'sp500' | 'crypto_top';
    timeframe?: string;
    from?: string;
    to?: string;
    exchange?: string;
    searchSpace?: {
        [key: string]: {
            low?: number;
            high?: number;
            type?: 'int' | 'float';
            choices?: Array<string | number>;
        };
    };
    maxTrials?: number;
    variants?: number;
    paramSet?: {
        [key: string]: number | string | boolean;
    };
    strategyId: string;
};

export type ApiBacktestResult = {
    data: ApiBacktest;
    meta: ApiMeta;
};

export type ApiBacktest = {
    backtest: {
        id: string;
        status: string;
        mode: string;
        scope: string;
        usingDbCandles: boolean | null;
        window: {
            from: string | null;
            to: string | null;
        };
        timeframe: string;
        metrics: {
            sharpe: number | null;
            maxDrawdownPct: number | null;
            trades: number | null;
            winRatePct?: number | null;
            [key: string]: unknown;
        };
        stats: {
            sortino: number | null;
            totalReturnPct: number | null;
            probabilisticSharpe: number | null;
            deflatedSharpe: number | null;
            pbo: number | null;
            walkForwardEfficiency: number | null;
            researchOnly: boolean | null;
            verdict: string | null;
            [key: string]: unknown;
        } | null;
        benchmark: {
            symbol: string;
            defaulted: boolean;
            strategyReturn: number | null;
            benchmarkReturn: number | null;
            excessReturn: number | null;
            universeBuyHoldReturn: number | null;
            [key: string]: unknown;
        } | null;
        [key: string]: unknown;
    };
    scores: Array<{
        scoreType: string;
        regime: string;
        value: number;
        uncertainty: number;
        skillProb: number | null;
        skillProbSource: string | null;
        pboPassed: boolean | null;
        sampleSize: number | null;
        status: string;
        computedAt: string;
        [key: string]: unknown;
    }>;
    series: {
        [key: string]: number;
    };
    [key: string]: unknown;
};

export type ApiBacktestSeriesPage = {
    data: Array<unknown>;
    paging: ApiPaging;
    meta: ApiMeta;
};

export type ApiBacktestAnalyticsResult = {
    data: ApiBacktestAnalytics;
    meta: ApiMeta;
};

export type ApiBacktestAnalytics = {
    schemaVersion: 'finance-run-analytics/v1';
    runId: string;
    initialCapital: number;
    periodsPerYear: number | null;
    bars: number;
    firstBar: string | null;
    lastBar: string | null;
    keyStats: {
        netProfit: number;
        netProfitPct: number | null;
        maxDrawdown: number;
        maxDrawdownPct: number;
        closedTrades: number;
        openTrades: number;
        profitableTrades: number;
        profitablePct: number | null;
        profitFactor: number | null;
    };
    returns: {
        totalReturn: number | null;
        cagr: number | null;
        sharpe: number | null;
        sortino: number | null;
        volatilityAnnual: number | null;
    };
    periodical: {
        daily?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
        weekly?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
        monthly?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
        quarterly?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
        yearly?: Array<{
            period: string;
            start: string;
            pnl: number;
            returnPct: number | null;
        }>;
    };
    benchmarking: {
        buyHoldReturn: number;
        outperformance: number;
        monthlyCorrelation: number | null;
        monthly: Array<{
            period: string;
            strategy: number | null;
            buyHold: number | null;
        }>;
    } | null;
    exposure: {
        average: number;
        max: number;
        timeInMarket: number;
    } | null;
    growthAndDecline: {
        runUps: {
            count: number;
            averageBars: number | null;
            maxAmount: number | null;
            maxPct: number | null;
            averageAmount: number | null;
            averagePct: number | null;
            currentAmount: number | null;
            currentPct: number | null;
        };
        drawdowns: {
            count: number;
            averageBars: number | null;
            maxAmount: number | null;
            maxPct: number | null;
            averageAmount: number | null;
            averagePct: number | null;
            currentAmount: number | null;
            currentPct: number | null;
        };
        maxDrawdownPctOfInitial: number;
        episodes: Array<{
            kind: 'run_up' | 'drawdown';
            start: string;
            end: string;
            amount: number;
            pct: number;
            bars: number;
            current: boolean;
        }>;
    };
    profitsAndLosses: {
        long: {
            trades: number;
            netProfit: number;
            grossProfit: number;
            grossLoss: number;
            winners: number;
        };
        short: {
            trades: number;
            netProfit: number;
            grossProfit: number;
            grossLoss: number;
            winners: number;
        };
        commission: number;
        bySignal: Array<{
            key: string;
            label: string;
            trades: number;
            winners: number;
            losers: number;
            netProfit: number;
        }>;
    };
    trades: {
        list: Array<{
            tradeNo: number;
            symbol: string | null;
            side: 'long' | 'short';
            status: 'closed' | 'open';
            entryTime: string | null;
            exitTime: string | null;
            entryPrice: number | null;
            exitPrice: number | null;
            size: number | null;
            pnl: number;
            returnPct: number;
            cumulativePnl: number | null;
            runUp: number | null;
            drawdown: number | null;
            barsHeld: number | null;
            fees: number;
            exitReason: string | null;
            entrySignals: Array<string>;
        }>;
        distribution: {
            bins: Array<{
                from: number;
                to: number;
                count: number;
            }>;
            winners: number;
            losers: number;
            breakEvens: number;
            expectancy: number | null;
            averageWin: number | null;
            averageLoss: number | null;
            largestProfit: number | null;
            largestLoss: number | null;
            outliersPnl: number;
            outliers: number;
        };
        streaks: {
            longestWin: number;
            longestLoss: number;
            averageWin: number | null;
            averageLoss: number | null;
            series: Array<{
                tradeNo: number;
                streak: number;
                amount: number;
            }>;
        };
        timePatterns: {
            byEntryHour: Array<{
                key: string;
                label: string;
                trades: number;
                winners: number;
                losers: number;
                netProfit: number;
            }>;
            byEntryWeekday: Array<{
                key: string;
                label: string;
                trades: number;
                winners: number;
                losers: number;
                netProfit: number;
            }>;
            byEntryMonth: Array<{
                key: string;
                label: string;
                trades: number;
                winners: number;
                losers: number;
                netProfit: number;
            }>;
            averageBarsHeld: number | null;
            averageBarsHeldWinners: number | null;
            averageBarsHeldLosers: number | null;
        };
    };
};

export type ApiCandleWindow = {
    data: Array<ApiCandle> | ApiCandleColumns;
    paging: ApiPaging;
    meta: ApiMeta;
};

export type ApiCandle = {
    time: string;
    open: number;
    high: number;
    low: number;
    close: number;
    volume: number;
};

export type ApiCandleColumns = {
    s: 'ok' | 'no_data';
    t: Array<number>;
    o: Array<number>;
    h: Array<number>;
    l: Array<number>;
    c: Array<number>;
    v: Array<number>;
    nextTime: number | null;
};

export type ApiRunEvent = {
    status: string;
    progress: number | null;
    done: boolean;
    data: {
        [key: string]: unknown;
    };
};

export type GetSystemHealthData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/health';
};

export type GetSystemHealthErrors = {
    /**
     * Degraded
     */
    503: SystemHealth;
};

export type GetSystemHealthError = GetSystemHealthErrors[keyof GetSystemHealthErrors];

export type GetSystemHealthResponses = {
    /**
     * Ready to serve traffic
     */
    200: SystemHealth;
};

export type GetSystemHealthResponse = GetSystemHealthResponses[keyof GetSystemHealthResponses];

export type CreateSignupData = {
    body?: AuthSignupCreate;
    path?: never;
    query?: never;
    url: '/api/v1/auth/signup';
};

export type CreateSignupErrors = {
    /**
     * Email already registered
     */
    400: unknown;
    /**
     * Sign-up is by invitation only: no valid invitation for this email
     */
    403: unknown;
    /**
     * No organization exists
     */
    500: unknown;
};

export type CreateSignupResponses = {
    /**
     * Account created: approved into the inviting organization (or pending, with AUTH_OPEN_SIGNUP)
     */
    201: SignupResult;
};

export type CreateSignupResponse = CreateSignupResponses[keyof CreateSignupResponses];

export type CreateLoginData = {
    body?: AuthLoginCreate;
    path?: never;
    query?: never;
    url: '/api/v1/auth/login';
};

export type CreateLoginErrors = {
    /**
     * Invalid credentials
     */
    401: unknown;
    /**
     * Account disabled or pending
     */
    403: unknown;
};

export type CreateLoginResponses = {
    /**
     * Login successful
     */
    200: AuthToken;
};

export type CreateLoginResponse = CreateLoginResponses[keyof CreateLoginResponses];

export type GetMeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/me';
};

export type GetMeErrors = {
    /**
     * User not found
     */
    404: unknown;
};

export type GetMeResponses = {
    /**
     * Current user with active org feature flags
     */
    200: {
        user: User;
        /**
         * Map of feature key → enabled for the active org. Only enabled features appear.
         */
        features: {
            [key: string]: boolean;
        };
    };
};

export type GetMeResponse = GetMeResponses[keyof GetMeResponses];

export type UpdateMeData = {
    body?: UserProfileUpdate;
    path?: never;
    query?: never;
    url: '/api/v1/auth/me';
};

export type UpdateMeErrors = {
    /**
     * User not found
     */
    404: unknown;
};

export type UpdateMeResponses = {
    /**
     * Profile updated
     */
    200: {
        success: boolean;
        user: User;
    };
};

export type UpdateMeResponse = UpdateMeResponses[keyof UpdateMeResponses];

export type CreateLogoutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/logout';
};

export type CreateLogoutResponses = {
    /**
     * Logged out — the refresh token is revoked and its cookie cleared
     */
    200: ActionSuccess;
};

export type CreateLogoutResponse = CreateLogoutResponses[keyof CreateLogoutResponses];

export type RefreshTokenData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/refresh';
};

export type RefreshTokenErrors = {
    /**
     * Invalid, expired, or revoked refresh token
     */
    401: unknown;
};

export type RefreshTokenResponses = {
    /**
     * New access token; the rotated refresh token is set in the httpOnly `cf_refresh` cookie
     */
    200: TokenRefresh;
};

export type RefreshTokenResponse = RefreshTokenResponses[keyof RefreshTokenResponses];

export type VerifyEmailData = {
    body?: VerifyEmailRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/verify-email';
};

export type VerifyEmailResponses = {
    /**
     * Email verified
     */
    200: ActionSuccess;
};

export type VerifyEmailResponse = VerifyEmailResponses[keyof VerifyEmailResponses];

export type ResetPasswordData = {
    body?: ResetPasswordRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/reset-password';
};

export type ResetPasswordResponses = {
    /**
     * Password updated
     */
    200: ActionSuccess;
};

export type ResetPasswordResponse = ResetPasswordResponses[keyof ResetPasswordResponses];

export type UnlinkAccountData = {
    body?: AccountLinkRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/linked-accounts';
};

export type UnlinkAccountResponses = {
    /**
     * Accounts unlinked
     */
    200: LinkedAccountActionSuccess;
};

export type UnlinkAccountResponse = UnlinkAccountResponses[keyof UnlinkAccountResponses];

export type ListLinkedAccountsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/linked-accounts';
};

export type ListLinkedAccountsResponses = {
    /**
     * Linked accounts
     */
    200: Array<LinkedAccount>;
};

export type ListLinkedAccountsResponse = ListLinkedAccountsResponses[keyof ListLinkedAccountsResponses];

export type LinkAccountData = {
    body?: AccountLinkRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/linked-accounts';
};

export type LinkAccountErrors = {
    /**
     * Cannot link a user to themselves
     */
    400: unknown;
};

export type LinkAccountResponses = {
    /**
     * Accounts linked
     */
    201: LinkedAccountActionSuccess;
};

export type LinkAccountResponse = LinkAccountResponses[keyof LinkAccountResponses];

export type SwitchAccountData = {
    body?: AccountSwitchRequest;
    path?: never;
    query?: never;
    url: '/api/v1/auth/switch-account';
};

export type SwitchAccountErrors = {
    /**
     * No link exists between accounts
     */
    403: unknown;
    /**
     * Target user not found
     */
    404: unknown;
};

export type SwitchAccountResponses = {
    /**
     * Switched account
     */
    200: {
        success: boolean;
        token: string;
        user: {
            id: number;
            email: string;
            username: string | null;
            fullName: string | null;
            status: string;
            organizationId?: number | null;
            organizationName?: string | null;
            organizationPlan?: string | null;
            settings?: {
                theme: 'dark' | 'light';
                notifications: boolean;
                defaultExchange: string;
                defaultLeverage: number;
                timezone: string;
                uiMode?: 'simple' | 'detailed';
                activeModuleId?: string;
            } | null;
            isVerified?: boolean;
            createdAt?: string;
            permissions?: Array<string>;
        };
    };
};

export type SwitchAccountResponse = SwitchAccountResponses[keyof SwitchAccountResponses];

export type PreviewInvitationData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/api/v1/invitations/{token}/preview';
};

export type PreviewInvitationErrors = {
    /**
     * Not found or expired
     */
    404: unknown;
};

export type PreviewInvitationResponses = {
    /**
     * Invitation preview
     */
    200: InvitationPreview;
};

export type PreviewInvitationResponse = PreviewInvitationResponses[keyof PreviewInvitationResponses];

export type AcceptInvitationData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/api/v1/invitations/{token}/accept';
};

export type AcceptInvitationErrors = {
    /**
     * Expired or revoked
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Already accepted
     */
    409: unknown;
};

export type AcceptInvitationResponses = {
    /**
     * Accepted
     */
    200: Invitation;
};

export type AcceptInvitationResponse = AcceptInvitationResponses[keyof AcceptInvitationResponses];

export type ResendInvitationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/invitations/{id}/resend';
};

export type ResendInvitationErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ResendInvitationResponses = {
    /**
     * Resent
     */
    200: Invitation;
};

export type ResendInvitationResponse = ResendInvitationResponses[keyof ResendInvitationResponses];

export type RevokeInvitationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/invitations/{id}/revoke';
};

export type RevokeInvitationErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RevokeInvitationResponses = {
    /**
     * Revoked
     */
    200: Invitation;
};

export type RevokeInvitationResponse = RevokeInvitationResponses[keyof RevokeInvitationResponses];

export type ListAdminUsersData = {
    body?: never;
    path?: never;
    query?: {
        search?: string;
        status?: 'pending' | 'approved' | 'rejected';
        orgId?: number | null;
        role?: 'superadmin' | 'user' | 'org_admin' | 'trader' | 'analyst' | 'code_reviewer' | 'viewer';
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/admin/users';
};

export type ListAdminUsersResponses = {
    /**
     * Paginated user list
     */
    200: {
        data: Array<AdminUser>;
        paging: {
            total: number;
            limit: number;
            offset: number;
        };
    };
};

export type ListAdminUsersResponse = ListAdminUsersResponses[keyof ListAdminUsersResponses];

export type BulkUpdateUserStatusData = {
    body?: UserBulkStatusRequest;
    path?: never;
    query?: never;
    url: '/api/v1/admin/users/bulk-status';
};

export type BulkUpdateUserStatusErrors = {
    /**
     * User not found
     */
    404: unknown;
};

export type BulkUpdateUserStatusResponses = {
    /**
     * Bulk status update result
     */
    200: UserBulkStatusResult;
};

export type BulkUpdateUserStatusResponse = BulkUpdateUserStatusResponses[keyof BulkUpdateUserStatusResponses];

export type GetAdminUserData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}';
};

export type GetAdminUserErrors = {
    /**
     * User not found
     */
    404: unknown;
};

export type GetAdminUserResponses = {
    /**
     * User detail
     */
    200: AdminUser;
};

export type GetAdminUserResponse = GetAdminUserResponses[keyof GetAdminUserResponses];

export type UpdateAdminUserData = {
    body?: AdminUserUpdate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}';
};

export type UpdateAdminUserErrors = {
    /**
     * User not found
     */
    404: unknown;
};

export type UpdateAdminUserResponses = {
    /**
     * User updated
     */
    200: AdminUser;
};

export type UpdateAdminUserResponse = UpdateAdminUserResponses[keyof UpdateAdminUserResponses];

export type ResetUserPasswordData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}/reset-password';
};

export type ResetUserPasswordErrors = {
    /**
     * User not found
     */
    404: unknown;
};

export type ResetUserPasswordResponses = {
    /**
     * Password reset email sent
     */
    200: AdminActionSuccess;
};

export type ResetUserPasswordResponse = ResetUserPasswordResponses[keyof ResetUserPasswordResponses];

export type VerifyUserData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}/verify';
};

export type VerifyUserErrors = {
    /**
     * User not found
     */
    404: unknown;
};

export type VerifyUserResponses = {
    /**
     * Verification email sent
     */
    200: AdminActionSuccess;
};

export type VerifyUserResponse = VerifyUserResponses[keyof VerifyUserResponses];

export type AssignUserRoleData = {
    body?: UserRoleAssign;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}/roles';
};

export type AssignUserRoleErrors = {
    /**
     * User not found
     */
    404: unknown;
};

export type AssignUserRoleResponses = {
    /**
     * Role assigned
     */
    200: AdminActionSuccess;
};

export type AssignUserRoleResponse = AssignUserRoleResponses[keyof AssignUserRoleResponses];

export type RemoveUserRoleData = {
    body?: never;
    path: {
        id: number;
        roleId: number;
    };
    query?: never;
    url: '/api/v1/admin/users/{id}/roles/{roleId}';
};

export type RemoveUserRoleErrors = {
    /**
     * Role assignment not found
     */
    404: unknown;
};

export type RemoveUserRoleResponses = {
    /**
     * Role removed
     */
    200: AdminActionSuccess;
};

export type RemoveUserRoleResponse = RemoveUserRoleResponses[keyof RemoveUserRoleResponses];

export type GetUserAuditLogData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/admin/users/{id}/audit';
};

export type GetUserAuditLogErrors = {
    /**
     * User not found
     */
    404: unknown;
};

export type GetUserAuditLogResponses = {
    /**
     * Audit log entries
     */
    200: AdminUserAuditList;
};

export type GetUserAuditLogResponse = GetUserAuditLogResponses[keyof GetUserAuditLogResponses];

export type ListExchangeCredentialsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/keys';
};

export type ListExchangeCredentialsResponses = {
    /**
     * Exchange credentials
     */
    200: {
        data: Array<ExchangeCredential>;
    };
};

export type ListExchangeCredentialsResponse = ListExchangeCredentialsResponses[keyof ListExchangeCredentialsResponses];

export type CreateExchangeCredentialData = {
    body?: ExchangeCredentialCreate;
    path?: never;
    query?: never;
    url: '/api/v1/auth/keys';
};

export type CreateExchangeCredentialResponses = {
    /**
     * Created
     */
    201: {
        success: boolean;
        key: ExchangeCredential;
    };
};

export type CreateExchangeCredentialResponse = CreateExchangeCredentialResponses[keyof CreateExchangeCredentialResponses];

export type DeleteExchangeCredentialData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/auth/keys/{id}';
};

export type DeleteExchangeCredentialErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteExchangeCredentialResponses = {
    /**
     * Deleted
     */
    200: {
        success: boolean;
    };
};

export type DeleteExchangeCredentialResponse = DeleteExchangeCredentialResponses[keyof DeleteExchangeCredentialResponses];

export type GetNotificationConfigData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/webhooks/notifications/config';
};

export type GetNotificationConfigResponses = {
    /**
     * Current config (secrets masked)
     */
    200: {
        success: boolean;
        config: NotificationConfig;
    };
};

export type GetNotificationConfigResponse = GetNotificationConfigResponses[keyof GetNotificationConfigResponses];

export type UpdateNotificationConfigData = {
    body?: NotificationConfigUpdate;
    path?: never;
    query?: never;
    url: '/api/v1/webhooks/notifications/config';
};

export type UpdateNotificationConfigResponses = {
    /**
     * Updated
     */
    200: {
        success: boolean;
        message: string;
    };
};

export type UpdateNotificationConfigResponse = UpdateNotificationConfigResponses[keyof UpdateNotificationConfigResponses];

export type SendNotificationData = {
    body?: NotificationSendCreate;
    path?: never;
    query?: never;
    url: '/api/v1/webhooks/notifications/send';
};

export type SendNotificationResponses = {
    /**
     * Sent
     */
    200: {
        success: boolean;
        results: Array<NotificationResult>;
    };
};

export type SendNotificationResponse = SendNotificationResponses[keyof SendNotificationResponses];

export type TestNotificationData = {
    body?: NotificationTestCreate;
    path?: never;
    query?: never;
    url: '/api/v1/webhooks/notifications/test';
};

export type TestNotificationResponses = {
    /**
     * Test sent
     */
    200: {
        success: boolean;
        results: NotificationResult | Array<NotificationResult>;
    };
};

export type TestNotificationResponse = TestNotificationResponses[keyof TestNotificationResponses];

export type ListActiveAgentsData = {
    body?: never;
    path?: never;
    query?: {
        status?: string;
    };
    url: '/api/v1/agents/instances';
};

export type ListActiveAgentsResponses = {
    /**
     * List of active agents
     */
    200: {
        data: Array<AgentSummary>;
        total: number;
    };
};

export type ListActiveAgentsResponse = ListActiveAgentsResponses[keyof ListActiveAgentsResponses];

export type SpawnAgentData = {
    body?: AgentSpawnRequest;
    path?: never;
    query?: never;
    url: '/api/v1/agents/instances/spawn';
};

export type SpawnAgentErrors = {
    /**
     * Missing templateSlug
     */
    400: unknown;
};

export type SpawnAgentResponses = {
    /**
     * Agent spawned
     */
    200: AgentSpawnResult;
};

export type SpawnAgentResponse = SpawnAgentResponses[keyof SpawnAgentResponses];

export type TerminateAgentData = {
    body?: AgentTerminateRequest;
    path: {
        agentId: string;
    };
    query?: never;
    url: '/api/v1/agents/instances/{agentId}/terminate';
};

export type TerminateAgentErrors = {
    /**
     * Agent not found
     */
    404: unknown;
};

export type TerminateAgentResponses = {
    /**
     * Agent terminated
     */
    200: {
        success: boolean;
    };
};

export type TerminateAgentResponse = TerminateAgentResponses[keyof TerminateAgentResponses];

export type ExecuteAgentData = {
    body?: AgentExecuteRequest;
    path: {
        agentId: string;
    };
    query?: never;
    url: '/api/v1/agents/instances/{agentId}/execute';
};

export type ExecuteAgentErrors = {
    /**
     * Agent not found
     */
    404: unknown;
};

export type ExecuteAgentResponses = {
    /**
     * Execution result
     */
    200: {
        result: AgentExecuteResult;
    };
};

export type ExecuteAgentResponse = ExecuteAgentResponses[keyof ExecuteAgentResponses];

export type GetAgentHealthData = {
    body?: never;
    path?: never;
    query?: {
        includeDeprecated?: string;
    };
    url: '/api/v1/agents/instances/health';
};

export type GetAgentHealthResponses = {
    /**
     * Agent health report
     */
    200: {
        report: AgentHealthReport;
    };
};

export type GetAgentHealthResponse = GetAgentHealthResponses[keyof GetAgentHealthResponses];

export type ListPendingDecisionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/decisions/pending';
};

export type ListPendingDecisionsResponses = {
    /**
     * Pending decisions
     */
    200: {
        data: Array<DecisionRequest>;
        total: number;
    };
};

export type ListPendingDecisionsResponse = ListPendingDecisionsResponses[keyof ListPendingDecisionsResponses];

export type GetDecisionStatsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/decisions/stats';
};

export type GetDecisionStatsResponses = {
    /**
     * Decision statistics
     */
    200: DecisionStats;
};

export type GetDecisionStatsResponse = GetDecisionStatsResponses[keyof GetDecisionStatsResponses];

export type GetDecisionData = {
    body?: never;
    path: {
        requestId: string;
    };
    query?: never;
    url: '/api/v1/agents/decisions/{requestId}';
};

export type GetDecisionErrors = {
    /**
     * Decision request not found
     */
    404: unknown;
};

export type GetDecisionResponses = {
    /**
     * Decision details
     */
    200: {
        request: DecisionRequest;
        decision: Decision | null;
    };
};

export type GetDecisionResponse = GetDecisionResponses[keyof GetDecisionResponses];

export type ApproveDecisionData = {
    body?: DecisionApproveRequest;
    path: {
        requestId: string;
    };
    query?: never;
    url: '/api/v1/agents/decisions/{requestId}/approve';
};

export type ApproveDecisionResponses = {
    /**
     * Decision approved
     */
    200: {
        decision: Decision;
    };
};

export type ApproveDecisionResponse = ApproveDecisionResponses[keyof ApproveDecisionResponses];

export type RejectDecisionData = {
    body?: DecisionRejectRequest;
    path: {
        requestId: string;
    };
    query?: never;
    url: '/api/v1/agents/decisions/{requestId}/reject';
};

export type RejectDecisionResponses = {
    /**
     * Decision rejected
     */
    200: {
        decision: Decision;
    };
};

export type RejectDecisionResponse = RejectDecisionResponses[keyof RejectDecisionResponses];

export type ModifyDecisionData = {
    body?: DecisionModifyRequest;
    path: {
        requestId: string;
    };
    query?: never;
    url: '/api/v1/agents/decisions/{requestId}/modify';
};

export type ModifyDecisionResponses = {
    /**
     * Decision modified
     */
    200: {
        decision: Decision;
    };
};

export type ModifyDecisionResponse = ModifyDecisionResponses[keyof ModifyDecisionResponses];

export type GetRecentMessagesData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
    };
    url: '/api/v1/agents/execution/messages/recent';
};

export type GetRecentMessagesResponses = {
    /**
     * Recent agent messages
     */
    200: {
        messages: Array<unknown>;
    };
};

export type GetRecentMessagesResponse = GetRecentMessagesResponses[keyof GetRecentMessagesResponses];

export type PreviewPromptData = {
    body?: {
        templateSlug?: string | null;
        templateId?: number | null;
        name?: string | null;
        description?: string | null;
        systemPromptOverride?: string | null;
        additionalInstructions?: string | null;
        userPromptTemplate?: string | null;
        userPromptFreetext?: string | null;
        promptMode?: 'template' | 'freetext' | null;
        config?: {
            [key: string]: unknown;
        } | null;
        outputConfig?: unknown;
        outputContract?: WorkflowContract | null;
        inputContracts?: InputContractMap | null;
        upstreamOutputs?: {
            [key: string]: unknown;
        } | null;
        inputMapping?: unknown;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/preview-prompt';
};

export type PreviewPromptErrors = {
    /**
     * templateSlug required
     */
    400: unknown;
};

export type PreviewPromptResponses = {
    /**
     * Assembled prompt preview
     */
    200: {
        role: {
            id: string;
            title: string;
            department: string;
            model: string;
            responsibilities: Array<string>;
            skills: Array<string>;
        };
        systemPrompt: string;
        defaultSystemPrompt: string;
        userPrompt: string;
        agentInput: string;
        estimatedTokens: number;
    };
};

export type PreviewPromptResponse = PreviewPromptResponses[keyof PreviewPromptResponses];

export type ExecuteStepData = {
    body?: {
        templateSlug: string;
        input?: unknown;
        config?: {
            [key: string]: unknown;
        };
        systemPromptOverride?: string;
        userPromptTemplate?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/execute-step';
};

export type ExecuteStepResponses = {
    /**
     * Step execution dispatched
     */
    200: {
        result: {
            status: string;
            requestId: string;
        };
        agentId: string;
        agentName: string;
        model: string;
        executionTimeMs: number;
        cost: number;
    };
};

export type ExecuteStepResponse = ExecuteStepResponses[keyof ExecuteStepResponses];

export type ExecuteStepStreamData = {
    body?: ExecuteStepStreamRequest;
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/execute-step-stream';
};

export type ExecuteStepStreamErrors = {
    /**
     * templateSlug required
     */
    400: unknown;
};

export type ExecuteStepStreamResponses = {
    /**
     * SSE stream of execution events
     */
    200: string;
};

export type ExecuteStepStreamResponse = ExecuteStepStreamResponses[keyof ExecuteStepStreamResponses];

export type ReconnectToRunData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/v1/agents/execution/runs/{runId}/stream';
};

export type ReconnectToRunErrors = {
    /**
     * Run not found
     */
    404: AgentStreamError;
};

export type ReconnectToRunError = ReconnectToRunErrors[keyof ReconnectToRunErrors];

export type ReconnectToRunResponses = {
    /**
     * SSE stream reconnection
     */
    200: string;
};

export type ReconnectToRunResponse = ReconnectToRunResponses[keyof ReconnectToRunResponses];

export type SendFollowUpMessageData = {
    body?: FollowUpMessageRequest;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/v1/agents/execution/runs/{runId}/message';
};

export type SendFollowUpMessageErrors = {
    /**
     * message required
     */
    400: AgentStreamError;
    /**
     * Previous run not found
     */
    404: AgentStreamError;
};

export type SendFollowUpMessageError = SendFollowUpMessageErrors[keyof SendFollowUpMessageErrors];

export type SendFollowUpMessageResponses = {
    /**
     * SSE stream for follow-up
     */
    200: string;
};

export type SendFollowUpMessageResponse = SendFollowUpMessageResponses[keyof SendFollowUpMessageResponses];

export type GetActiveRunData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/active-run';
};

export type GetActiveRunResponses = {
    /**
     * Active run info
     */
    200: {
        active: boolean;
        runId?: string;
        templateSlug?: string;
        status?: string;
        textLen?: number;
        eventCount?: number;
    };
};

export type GetActiveRunResponse = GetActiveRunResponses[keyof GetActiveRunResponses];

export type ListRunsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/runs';
};

export type ListRunsResponses = {
    /**
     * All runs
     */
    200: {
        data: Array<{
            runId: string;
            templateSlug: string;
            status: string;
            textLen?: number;
            eventCount?: number;
        }>;
    };
};

export type ListRunsResponse = ListRunsResponses[keyof ListRunsResponses];

export type StopExecutionData = {
    body?: {
        runId?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/stop';
};

export type StopExecutionErrors = {
    /**
     * Run not found or not owned by the caller org
     */
    404: unknown;
};

export type StopExecutionResponses = {
    /**
     * Execution stopped
     */
    200: {
        stopped: boolean;
    };
};

export type StopExecutionResponse = StopExecutionResponses[keyof StopExecutionResponses];

export type PauseExecutionData = {
    body?: {
        runId?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/pause';
};

export type PauseExecutionErrors = {
    /**
     * Run not found or not owned by the caller org
     */
    404: unknown;
};

export type PauseExecutionResponses = {
    /**
     * Execution paused
     */
    200: {
        paused: boolean;
    };
};

export type PauseExecutionResponse = PauseExecutionResponses[keyof PauseExecutionResponses];

export type ResumeExecutionData = {
    body?: {
        runId?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/resume';
};

export type ResumeExecutionErrors = {
    /**
     * Run not found or not owned by the caller org
     */
    404: unknown;
};

export type ResumeExecutionResponses = {
    /**
     * Execution resumed
     */
    200: {
        resumed: boolean;
    };
};

export type ResumeExecutionResponse = ResumeExecutionResponses[keyof ResumeExecutionResponses];

export type GetExecutionStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/status';
};

export type GetExecutionStatusResponses = {
    /**
     * Execution status
     */
    200: {
        running: boolean;
        sessions: number;
        activeRun: {
            runId: string;
            templateSlug: string;
            textLen: number;
        } | null;
    };
};

export type GetExecutionStatusResponse = GetExecutionStatusResponses[keyof GetExecutionStatusResponses];

export type SaveDebugStepOutputData = {
    body?: {
        templateId: number;
        stepId?: string;
        stepName: string;
        input?: unknown;
        output: string;
        extractedJson?: unknown;
        agentId?: string;
        model?: string;
        durationMs?: number;
        cost?: number;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/debug-step-output';
};

export type SaveDebugStepOutputErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type SaveDebugStepOutputResponses = {
    /**
     * Debug output saved
     */
    200: {
        run: {
            id: number;
            templateId: number | null;
            status: string;
            triggeredBy: string | null;
            startedAt: string | string | null;
            completedAt: string | string | null;
            context: {
                [key: string]: unknown;
            } | null;
            error: string | null;
            organizationId: number;
        };
        step: {
            id: number;
            runId: number;
            stepId: string;
            stepName: string | null;
            agentId: number | null;
            status: string;
            startedAt: string | string | null;
            completedAt: string | string | null;
            input?: unknown;
            output?: unknown;
            error: string | null;
            model: string | null;
            costUsd: string | null;
            durationMs: number | null;
        };
    };
};

export type SaveDebugStepOutputResponse = SaveDebugStepOutputResponses[keyof SaveDebugStepOutputResponses];

export type GetDebugStepOutputsData = {
    body?: never;
    path: {
        templateId: string;
    };
    query?: never;
    url: '/api/v1/agents/execution/debug-step-outputs/{templateId}';
};

export type GetDebugStepOutputsResponses = {
    /**
     * Debug step outputs
     */
    200: {
        outputs: {
            [key: string]: unknown;
        };
    };
};

export type GetDebugStepOutputsResponse = GetDebugStepOutputsResponses[keyof GetDebugStepOutputsResponses];

export type GetStepBuilderContextData = {
    body?: never;
    path?: never;
    query?: {
        steps?: string;
    };
    url: '/api/v1/agents/execution/step-builder/context';
};

export type GetStepBuilderContextErrors = {
    /**
     * Invalid steps JSON
     */
    400: unknown;
};

export type GetStepBuilderContextResponses = {
    /**
     * Step builder context
     */
    200: {
        systemPrompt: string;
        portTypes: Array<{
            name: string;
            description: string;
        }>;
        stepTypes: Array<string>;
    };
};

export type GetStepBuilderContextResponse = GetStepBuilderContextResponses[keyof GetStepBuilderContextResponses];

export type ValidateStepData = {
    body?: {
        name?: string;
        templateSlug?: string;
        templateId?: number;
        processorType?: string;
        executionMode?: string;
        optional?: boolean;
        timeoutMs?: number;
        retryMax?: number;
        outputPortType?: string;
        inputPorts?: Array<{
            name: string;
            type: string;
        }>;
        [key: string]: unknown;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/step-builder/validate';
};

export type ValidateStepResponses = {
    /**
     * Validation result
     */
    200: {
        valid: boolean;
        errors: Array<string>;
    };
};

export type ValidateStepResponse = ValidateStepResponses[keyof ValidateStepResponses];

export type SuggestConnectionsData = {
    body?: {
        inputPorts?: Array<{
            name: string;
            type: string;
        }>;
        existingSteps?: Array<{
            id: string;
            name: string;
            outputPorts?: Array<{
                name: string;
                type: string;
            }>;
        }>;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/step-builder/suggest-connections';
};

export type SuggestConnectionsResponses = {
    /**
     * Compatible connections between the new step inputs and existing step outputs
     */
    200: {
        suggestions: Array<{
            inputPort: string;
            sourceStepId: string;
            sourceStepName: string;
            sourcePort: string;
            method: string;
        }>;
    };
};

export type SuggestConnectionsResponse = SuggestConnectionsResponses[keyof SuggestConnectionsResponses];

export type OptimizePromptData = {
    body?: OptimizePromptRequest;
    path?: never;
    query?: never;
    url: '/api/v1/agents/prompts/optimize';
};

export type OptimizePromptErrors = {
    /**
     * Missing input string
     */
    400: unknown;
};

export type OptimizePromptResponses = {
    /**
     * Optimized prompt queued
     */
    202: OptimizePromptResult;
};

export type OptimizePromptResponse = OptimizePromptResponses[keyof OptimizePromptResponses];

export type ListPromptTemplatesData = {
    body?: never;
    path?: never;
    query?: {
        category?: string;
    };
    url: '/api/v1/agents/prompts/templates';
};

export type ListPromptTemplatesResponses = {
    /**
     * Prompt template list (optionally filtered by category)
     */
    200: Array<PromptTemplateSummary>;
};

export type ListPromptTemplatesResponse = ListPromptTemplatesResponses[keyof ListPromptTemplatesResponses];

export type FillTemplateData = {
    body?: FillTemplateRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/prompts/templates/{id}/fill';
};

export type FillTemplateErrors = {
    /**
     * Missing required parameters
     */
    400: unknown;
    /**
     * Template not found
     */
    404: unknown;
};

export type FillTemplateResponses = {
    /**
     * Filled template
     */
    200: FillTemplateResult;
};

export type FillTemplateResponse = FillTemplateResponses[keyof FillTemplateResponses];

export type GetToolGapsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/prompts/tools/gaps';
};

export type GetToolGapsResponses = {
    /**
     * Skill gap analysis
     */
    200: ToolGapAnalysis;
};

export type GetToolGapsResponse = GetToolGapsResponses[keyof GetToolGapsResponses];

export type SearchAgentTemplatesData = {
    body?: never;
    path?: never;
    query: {
        q: string;
        limit?: number;
    };
    url: '/api/v1/agents/templates/search';
};

export type SearchAgentTemplatesResponses = {
    /**
     * Results
     */
    200: {
        data: Array<AgentTemplateSearchResult>;
        query: string;
        total: number;
        searchType: 'keyword' | 'semantic' | 'hybrid';
    };
};

export type SearchAgentTemplatesResponse = SearchAgentTemplatesResponses[keyof SearchAgentTemplatesResponses];

export type RecommendAgentTemplatesData = {
    body?: never;
    path?: never;
    query: {
        stepDescription: string;
        workflowCategory?: string;
        limit?: number;
    };
    url: '/api/v1/agents/templates/recommend';
};

export type RecommendAgentTemplatesResponses = {
    /**
     * Recommendations
     */
    200: {
        data: Array<AgentTemplateSearchResult>;
        total: number;
    };
};

export type RecommendAgentTemplatesResponse = RecommendAgentTemplatesResponses[keyof RecommendAgentTemplatesResponses];

export type ListAgentTemplateVersionsData = {
    body?: never;
    path: {
        templateId: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateId}/versions';
};

export type ListAgentTemplateVersionsResponses = {
    /**
     * Versions
     */
    200: {
        data: Array<AgentTemplateVersion>;
    };
};

export type ListAgentTemplateVersionsResponse = ListAgentTemplateVersionsResponses[keyof ListAgentTemplateVersionsResponses];

export type CreateAgentTemplateVersionData = {
    body?: AgentTemplateVersionCreate;
    path: {
        templateId: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateId}/versions';
};

export type CreateAgentTemplateVersionResponses = {
    /**
     * Noop — content unchanged; existing draft/active version returned
     */
    200: AgentTemplateVersion;
    /**
     * Created
     */
    201: AgentTemplateVersion;
};

export type CreateAgentTemplateVersionResponse = CreateAgentTemplateVersionResponses[keyof CreateAgentTemplateVersionResponses];

export type PromoteAgentTemplateVersionData = {
    body?: never;
    path: {
        templateId: string;
        versionId: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateId}/versions/{versionId}/promote';
};

export type PromoteAgentTemplateVersionErrors = {
    /**
     * Bad request
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Evaluation gate not satisfied
     */
    409: unknown;
};

export type PromoteAgentTemplateVersionResponses = {
    /**
     * Promoted
     */
    200: AgentTemplateVersion;
};

export type PromoteAgentTemplateVersionResponse = PromoteAgentTemplateVersionResponses[keyof PromoteAgentTemplateVersionResponses];

export type RollbackAgentTemplateVersionData = {
    body?: never;
    path: {
        templateId: string;
        versionId: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateId}/versions/{versionId}/rollback';
};

export type RollbackAgentTemplateVersionErrors = {
    /**
     * Bad request
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type RollbackAgentTemplateVersionResponses = {
    /**
     * Rolled back
     */
    200: AgentTemplateVersion;
};

export type RollbackAgentTemplateVersionResponse = RollbackAgentTemplateVersionResponses[keyof RollbackAgentTemplateVersionResponses];

export type DiffAgentTemplateVersionsData = {
    body?: never;
    path: {
        templateId: string;
        versionA: number;
        versionB: number;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateId}/versions/{versionA}/diff/{versionB}';
};

export type DiffAgentTemplateVersionsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DiffAgentTemplateVersionsResponses = {
    /**
     * Agent template version diff
     */
    200: AgentTemplateVersionDiff;
};

export type DiffAgentTemplateVersionsResponse = DiffAgentTemplateVersionsResponses[keyof DiffAgentTemplateVersionsResponses];

export type TestAgentTemplateVersionData = {
    body?: never;
    path: {
        templateId: string;
        versionId: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateId}/versions/{versionId}/test';
};

export type TestAgentTemplateVersionErrors = {
    /**
     * Version is not in draft status
     */
    400: unknown;
    /**
     * Version not found or not in this organization
     */
    404: unknown;
};

export type TestAgentTemplateVersionResponses = {
    /**
     * Eval-gate run queued
     */
    202: AgentTemplateVersionTestResult;
};

export type TestAgentTemplateVersionResponse = TestAgentTemplateVersionResponses[keyof TestAgentTemplateVersionResponses];

export type CompareAgentTemplateVersionsData = {
    body?: AgentTemplateVersionCompareRequest;
    path: {
        templateId: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateId}/versions/compare';
};

export type CompareAgentTemplateVersionsErrors = {
    /**
     * Bad request
     */
    400: unknown;
    /**
     * One or more versions not found for this template/org
     */
    404: unknown;
};

export type CompareAgentTemplateVersionsResponses = {
    /**
     * Comparison enqueued (status=queued) or short-circuited (status=no_dataset)
     */
    200: AgentTemplateVersionCompareResult;
};

export type CompareAgentTemplateVersionsResponse = CompareAgentTemplateVersionsResponses[keyof CompareAgentTemplateVersionsResponses];

export type GetAgentTemplateVersionComparisonData = {
    body?: never;
    path: {
        templateId: string;
        compareJobId: string;
    };
    query?: {
        versionIds?: string;
        samples?: number | null;
    };
    url: '/api/v1/agents/templates/{templateId}/versions/compare/{compareJobId}';
};

export type GetAgentTemplateVersionComparisonErrors = {
    /**
     * Bad request
     */
    400: unknown;
};

export type GetAgentTemplateVersionComparisonResponses = {
    /**
     * Aggregated, ranked comparison result
     */
    200: AgentTemplateVersionComparison;
};

export type GetAgentTemplateVersionComparisonResponse = GetAgentTemplateVersionComparisonResponses[keyof GetAgentTemplateVersionComparisonResponses];

export type PreflightTemplateUpgradeData = {
    body?: TemplateUpgradePreflightRequest;
    path?: never;
    query?: never;
    url: '/api/v1/agents/templates/upgrades/preflight';
};

export type PreflightTemplateUpgradeErrors = {
    /**
     * Invalid request
     */
    400: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Template or version not found
     */
    404: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type PreflightTemplateUpgradeError = PreflightTemplateUpgradeErrors[keyof PreflightTemplateUpgradeErrors];

export type PreflightTemplateUpgradeResponses = {
    /**
     * Template upgrade impact and compatibility preflight
     */
    200: {
        data: TemplateUpgradePreflightResult;
    };
};

export type PreflightTemplateUpgradeResponse = PreflightTemplateUpgradeResponses[keyof PreflightTemplateUpgradeResponses];

export type CreateTemplateUpgradeProposalData = {
    body?: TemplateUpgradeProposalRequest;
    path?: never;
    query?: never;
    url: '/api/v1/agents/templates/upgrades/proposals';
};

export type CreateTemplateUpgradeProposalErrors = {
    /**
     * Invalid request
     */
    400: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Template or version not found
     */
    404: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type CreateTemplateUpgradeProposalError = CreateTemplateUpgradeProposalErrors[keyof CreateTemplateUpgradeProposalErrors];

export type CreateTemplateUpgradeProposalResponses = {
    /**
     * Duplicate proposal suppressed
     */
    200: {
        data: TemplateUpgradeProposalResult;
    };
    /**
     * Template upgrade Action Request proposal
     */
    201: {
        data: TemplateUpgradeProposalResult;
    };
};

export type CreateTemplateUpgradeProposalResponse = CreateTemplateUpgradeProposalResponses[keyof CreateTemplateUpgradeProposalResponses];

export type ListTemplatesData = {
    body?: never;
    path?: never;
    query?: {
        includeDisabled?: boolean | null;
        departmentId?: string;
        limit?: number;
        before?: string;
        after?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'name';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
        q?: string;
    };
    url: '/api/v1/agents/templates';
};

export type ListTemplatesResponses = {
    /**
     * Template list (paginated)
     */
    200: {
        data: Array<AgentTemplateSummary>;
    };
};

export type ListTemplatesResponse = ListTemplatesResponses[keyof ListTemplatesResponses];

export type CreateTemplateData = {
    body?: AgentTemplateCreate;
    path?: never;
    query?: never;
    url: '/api/v1/agents/templates';
};

export type CreateTemplateErrors = {
    /**
     * The tool list names a tool this organization does not own; nothing was saved
     */
    400: unknown;
    /**
     * A template with this slug already exists in the organization (error.field is "slug")
     */
    409: unknown;
};

export type CreateTemplateResponses = {
    /**
     * Created
     */
    201: {
        template: AgentTemplate;
    };
};

export type CreateTemplateResponse = CreateTemplateResponses[keyof CreateTemplateResponses];

export type DeleteTemplateData = {
    body?: never;
    path: {
        templateSlug: string;
    };
    query?: {
        force?: string;
    };
    url: '/api/v1/agents/templates/{templateSlug}';
};

export type DeleteTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * In use by workflows — pass ?force=true to delete anyway
     */
    409: {
        error: string;
        dependentWorkflows: Array<AgentTemplateWorkflowSummary>;
    };
};

export type DeleteTemplateError = DeleteTemplateErrors[keyof DeleteTemplateErrors];

export type DeleteTemplateResponses = {
    /**
     * Deleted
     */
    200: {
        success: boolean;
    };
};

export type DeleteTemplateResponse = DeleteTemplateResponses[keyof DeleteTemplateResponses];

export type GetTemplateData = {
    body?: never;
    path: {
        templateSlug: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateSlug}';
};

export type GetTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetTemplateResponses = {
    /**
     * Template detail
     */
    200: {
        template: AgentTemplate;
    };
};

export type GetTemplateResponse = GetTemplateResponses[keyof GetTemplateResponses];

export type CreateOrUpdateTemplateData = {
    body?: AgentTemplateUpsert;
    path: {
        templateSlug: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateSlug}';
};

export type CreateOrUpdateTemplateErrors = {
    /**
     * The tool list names a tool this organization does not own; nothing was saved
     */
    400: unknown;
};

export type CreateOrUpdateTemplateResponses = {
    /**
     * Upserted
     */
    200: {
        template: AgentTemplate;
    };
};

export type CreateOrUpdateTemplateResponse = CreateOrUpdateTemplateResponses[keyof CreateOrUpdateTemplateResponses];

export type SetTemplateStatusData = {
    body?: AgentTemplateStatusUpdate;
    path: {
        templateSlug: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateSlug}/status';
};

export type SetTemplateStatusErrors = {
    /**
     * Bad request
     */
    400: unknown;
};

export type SetTemplateStatusResponses = {
    /**
     * Status updated
     */
    200: SetAgentTemplateStatusResult;
};

export type SetTemplateStatusResponse = SetTemplateStatusResponses[keyof SetTemplateStatusResponses];

export type SetTemplateAutoUpgradeData = {
    body?: AgentTemplateAutoUpgradeUpdate;
    path: {
        templateSlug: string;
    };
    query?: never;
    url: '/api/v1/agents/templates/{templateSlug}/auto-upgrade';
};

export type SetTemplateAutoUpgradeErrors = {
    /**
     * Bad request
     */
    400: unknown;
};

export type SetTemplateAutoUpgradeResponses = {
    /**
     * Auto-upgrade updated
     */
    200: SetAgentTemplateAutoUpgradeResult;
};

export type SetTemplateAutoUpgradeResponse = SetTemplateAutoUpgradeResponses[keyof SetTemplateAutoUpgradeResponses];

export type ListSkillsData = {
    body?: never;
    path?: never;
    query?: {
        search?: string;
        category?: string;
        includeDisabled?: boolean | null;
        limit?: number | null;
    };
    url: '/api/v1/agents/skills';
};

export type ListSkillsResponses = {
    /**
     * Skill list
     */
    200: {
        data: Array<SkillSummary>;
    };
};

export type ListSkillsResponse = ListSkillsResponses[keyof ListSkillsResponses];

export type GetSkillData = {
    body?: never;
    path: {
        slug: string;
    };
    query?: never;
    url: '/api/v1/agents/skills/{slug}';
};

export type GetSkillErrors = {
    /**
     * Skill not found
     */
    404: unknown;
};

export type GetSkillResponses = {
    /**
     * Skill detail
     */
    200: {
        skill: Skill;
    };
};

export type GetSkillResponse = GetSkillResponses[keyof GetSkillResponses];

export type ListToolLibrariesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/tools/libraries';
};

export type ListToolLibrariesResponses = {
    /**
     * Skill library list
     */
    200: {
        data: Array<SkillLibrary>;
    };
};

export type ListToolLibrariesResponse = ListToolLibrariesResponses[keyof ListToolLibrariesResponses];

export type CreateToolLibraryData = {
    body?: SkillLibraryCreate;
    path?: never;
    query?: never;
    url: '/api/v1/agents/tools/libraries';
};

export type CreateToolLibraryErrors = {
    /**
     * Missing org
     */
    400: unknown;
};

export type CreateToolLibraryResponses = {
    /**
     * Created
     */
    201: SkillLibrary;
};

export type CreateToolLibraryResponse = CreateToolLibraryResponses[keyof CreateToolLibraryResponses];

export type DeleteToolLibraryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/tools/libraries/{id}';
};

export type DeleteToolLibraryErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteToolLibraryResponses = {
    /**
     * Deleted
     */
    200: SkillLibraryActionResult;
};

export type DeleteToolLibraryResponse = DeleteToolLibraryResponses[keyof DeleteToolLibraryResponses];

export type GetToolLibraryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/tools/libraries/{id}';
};

export type GetToolLibraryErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetToolLibraryResponses = {
    /**
     * Library detail
     */
    200: SkillLibrary;
};

export type GetToolLibraryResponse = GetToolLibraryResponses[keyof GetToolLibraryResponses];

export type UpdateToolLibraryData = {
    body?: {
        name?: string;
        description?: string;
        sourceType?: 'git' | 'local' | 'url';
        repoUrl?: string;
        localPath?: string;
        branch?: string;
        subdirectory?: string;
        enabled?: boolean;
        autoSync?: boolean;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/tools/libraries/{id}';
};

export type UpdateToolLibraryErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateToolLibraryResponses = {
    /**
     * Updated
     */
    200: SkillLibrary;
};

export type UpdateToolLibraryResponse = UpdateToolLibraryResponses[keyof UpdateToolLibraryResponses];

export type SyncToolLibraryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/tools/libraries/{id}/sync';
};

export type SyncToolLibraryErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type SyncToolLibraryResponses = {
    /**
     * Sync requested
     */
    200: SkillLibrarySyncResult;
};

export type SyncToolLibraryResponse = SyncToolLibraryResponses[keyof SyncToolLibraryResponses];

export type ListToolLibraryToolsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/tools/libraries/{id}/tools';
};

export type ListToolLibraryToolsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListToolLibraryToolsResponses = {
    /**
     * Skills in library
     */
    200: {
        data: Array<SkillLibraryTool>;
    };
};

export type ListToolLibraryToolsResponse = ListToolLibraryToolsResponses[keyof ListToolLibraryToolsResponses];

export type ListToolsData = {
    body?: never;
    path?: never;
    query?: {
        includeDeprecated?: string;
    };
    url: '/api/v1/agents/tools';
};

export type ListToolsResponses = {
    /**
     * Tool list
     */
    200: {
        data: Array<ToolSummary>;
    };
};

export type ListToolsResponse = ListToolsResponses[keyof ListToolsResponses];

export type CreateToolData = {
    body?: ToolCreate;
    path?: never;
    query?: never;
    url: '/api/v1/agents/tools';
};

export type CreateToolErrors = {
    /**
     * A tool with this name already exists in the organization (error.field is "name")
     */
    409: unknown;
};

export type CreateToolResponses = {
    /**
     * Tool created
     */
    201: {
        tool: {
            name: string;
            description?: string;
            category?: string;
        };
    };
};

export type CreateToolResponse = CreateToolResponses[keyof CreateToolResponses];

export type DeleteToolData = {
    body?: never;
    path: {
        name: string;
    };
    query?: {
        force?: string;
    };
    url: '/api/v1/agents/tools/{name}';
};

export type DeleteToolErrors = {
    /**
     * Tool not found
     */
    404: unknown;
    /**
     * In use — pass ?force=true to delete anyway
     */
    409: {
        error: string;
        dependentTemplates: Array<ToolDependentTemplate>;
        dependentWorkflows: Array<AgentTemplateWorkflowSummary>;
    };
};

export type DeleteToolError = DeleteToolErrors[keyof DeleteToolErrors];

export type DeleteToolResponses = {
    /**
     * Tool deleted
     */
    200: {
        success: boolean;
    };
};

export type DeleteToolResponse = DeleteToolResponses[keyof DeleteToolResponses];

export type GetToolData = {
    body?: never;
    path: {
        name: string;
    };
    query?: never;
    url: '/api/v1/agents/tools/{name}';
};

export type GetToolErrors = {
    /**
     * Tool not found
     */
    404: unknown;
};

export type GetToolResponses = {
    /**
     * Tool detail
     */
    200: {
        tool: Tool;
    };
};

export type GetToolResponse = GetToolResponses[keyof GetToolResponses];

export type CreateOrUpdateToolData = {
    body?: ToolUpsert;
    path: {
        name: string;
    };
    query?: never;
    url: '/api/v1/agents/tools/{name}';
};

export type CreateOrUpdateToolResponses = {
    /**
     * Tool created or updated
     */
    200: {
        tool: {
            name: string;
            description?: string;
            category?: string;
        };
    };
};

export type CreateOrUpdateToolResponse = CreateOrUpdateToolResponses[keyof CreateOrUpdateToolResponses];

export type SetToolStatusData = {
    body?: ToolStatusUpdate;
    path: {
        name: string;
    };
    query?: never;
    url: '/api/v1/agents/tools/{name}/status';
};

export type SetToolStatusErrors = {
    /**
     * Invalid status value
     */
    400: unknown;
    /**
     * Tool not found
     */
    404: unknown;
};

export type SetToolStatusResponses = {
    /**
     * Tool status updated
     */
    200: SetToolStatusResult;
};

export type SetToolStatusResponse = SetToolStatusResponses[keyof SetToolStatusResponses];

export type ListAgentWorkflowsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/workflows';
};

export type ListAgentWorkflowsResponses = {
    /**
     * Workflows
     */
    200: {
        data: Array<WorkflowSummary>;
    };
};

export type ListAgentWorkflowsResponse = ListAgentWorkflowsResponses[keyof ListAgentWorkflowsResponses];

export type TriggerAgentWorkflowData = {
    body?: WorkflowTriggerRequest;
    path: {
        workflowId: string;
    };
    query?: never;
    url: '/api/v1/agents/workflows/{workflowId}/trigger';
};

export type TriggerAgentWorkflowErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type TriggerAgentWorkflowResponses = {
    /**
     * Triggered
     */
    200: WorkflowTriggerResult;
};

export type TriggerAgentWorkflowResponse = TriggerAgentWorkflowResponses[keyof TriggerAgentWorkflowResponses];

export type GetAgentWorkflowRunData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/v1/agents/workflows/runs/{runId}';
};

export type GetAgentWorkflowRunErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetAgentWorkflowRunResponses = {
    /**
     * Run detail
     */
    200: {
        run: WorkflowRun;
    };
};

export type GetAgentWorkflowRunResponse = GetAgentWorkflowRunResponses[keyof GetAgentWorkflowRunResponses];

export type GetAgentWorkflowRunDebuggerData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: {
        detail?: 'summary' | 'debug' | 'full';
    };
    url: '/api/v1/agents/workflows/runs/{runId}/debug';
};

export type GetAgentWorkflowRunDebuggerErrors = {
    /**
     * Full I/O requires workflow management permission
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetAgentWorkflowRunDebuggerResponses = {
    /**
     * Workflow run debugger cockpit payload
     */
    200: WorkflowRunDebuggerPayload;
};

export type GetAgentWorkflowRunDebuggerResponse = GetAgentWorkflowRunDebuggerResponses[keyof GetAgentWorkflowRunDebuggerResponses];

export type RunAgentWorkflowRunActionData = {
    body?: WorkflowRunActionRequest;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/v1/agents/workflows/runs/{runId}/actions';
};

export type RunAgentWorkflowRunActionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RunAgentWorkflowRunActionResponses = {
    /**
     * Workflow run action accepted or recorded
     */
    200: WorkflowRunActionResult;
};

export type RunAgentWorkflowRunActionResponse = RunAgentWorkflowRunActionResponses[keyof RunAgentWorkflowRunActionResponses];

export type ListAgentWorkflowRunsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/workflows/runs';
};

export type ListAgentWorkflowRunsResponses = {
    /**
     * All runs
     */
    200: {
        data: Array<WorkflowRun>;
    };
};

export type ListAgentWorkflowRunsResponse = ListAgentWorkflowRunsResponses[keyof ListAgentWorkflowRunsResponses];

export type ListLlmCallCostOutliersData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        after?: string;
        since?: string;
        until?: string;
    };
    url: '/api/v1/agents/monitoring/outliers/cost';
};

export type ListLlmCallCostOutliersResponses = {
    /**
     * Top-N LLM calls by cost_usd (cursor-paginated, org-scoped)
     */
    200: LlmCallOutlierList;
};

export type ListLlmCallCostOutliersResponse = ListLlmCallCostOutliersResponses[keyof ListLlmCallCostOutliersResponses];

export type ListLlmCallLatencyOutliersData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        after?: string;
        since?: string;
        until?: string;
    };
    url: '/api/v1/agents/monitoring/outliers/latency';
};

export type ListLlmCallLatencyOutliersResponses = {
    /**
     * Top-N LLM calls by duration_ms (cursor-paginated, org-scoped)
     */
    200: LlmCallOutlierList;
};

export type ListLlmCallLatencyOutliersResponse = ListLlmCallLatencyOutliersResponses[keyof ListLlmCallLatencyOutliersResponses];

export type GetRunHealthAggregatesData = {
    body?: never;
    path?: never;
    query?: {
        since?: string;
        until?: string;
    };
    url: '/api/v1/agents/monitoring/health';
};

export type GetRunHealthAggregatesResponses = {
    /**
     * Aggregate LLM call health metrics (error rates, cost, latency) for a time window
     */
    200: RunHealthAggregates;
};

export type GetRunHealthAggregatesResponse = GetRunHealthAggregatesResponses[keyof GetRunHealthAggregatesResponses];

export type ListModelsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/models';
};

export type ListModelsResponses = {
    /**
     * Model capability catalog
     */
    200: {
        data: Array<ModelSummary>;
    };
};

export type ListModelsResponse = ListModelsResponses[keyof ListModelsResponses];

export type GetModelData = {
    body?: never;
    path: {
        slug: string;
    };
    query?: never;
    url: '/api/v1/models/{slug}';
};

export type GetModelErrors = {
    /**
     * Model not found
     */
    404: unknown;
};

export type GetModelResponses = {
    /**
     * Model capability detail
     */
    200: {
        data: Model;
    };
};

export type GetModelResponse = GetModelResponses[keyof GetModelResponses];

export type ListModelRuntimePoliciesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/model-runtime-policies';
};

export type ListModelRuntimePoliciesResponses = {
    /**
     * The runtime policies the organization sees: the system ones and its own
     */
    200: {
        data: Array<ModelRuntimePolicy>;
    };
};

export type ListModelRuntimePoliciesResponse = ListModelRuntimePoliciesResponses[keyof ListModelRuntimePoliciesResponses];

export type CreateModelRuntimePolicyData = {
    body?: ModelRuntimePolicyUpsert;
    path?: never;
    query?: never;
    url: '/api/v1/model-runtime-policies';
};

export type CreateModelRuntimePolicyErrors = {
    /**
     * Invalid models or fallback, or an organization policy without an organization context
     */
    400: unknown;
    /**
     * Policy slug already exists in this scope
     */
    409: unknown;
};

export type CreateModelRuntimePolicyResponses = {
    /**
     * Created model runtime policy
     */
    201: {
        data: ModelRuntimePolicy;
    };
};

export type CreateModelRuntimePolicyResponse = CreateModelRuntimePolicyResponses[keyof CreateModelRuntimePolicyResponses];

export type ResolveModelRuntimePolicyData = {
    body?: ModelRuntimePolicyResolveRequest;
    path?: never;
    query?: never;
    url: '/api/v1/model-runtime-policies/resolve';
};

export type ResolveModelRuntimePolicyErrors = {
    /**
     * The carried policy is not allowed for this kind of work
     */
    400: unknown;
};

export type ResolveModelRuntimePolicyResponses = {
    /**
     * The policy a piece of work of this kind runs under (its carried policy when allowed, else the default)
     */
    200: {
        data: ModelRuntimePolicy;
    };
};

export type ResolveModelRuntimePolicyResponse = ResolveModelRuntimePolicyResponses[keyof ResolveModelRuntimePolicyResponses];

export type GetModelRuntimePolicyData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/model-runtime-policies/{id}';
};

export type GetModelRuntimePolicyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetModelRuntimePolicyResponses = {
    /**
     * Model runtime policy
     */
    200: {
        data: ModelRuntimePolicy;
    };
};

export type GetModelRuntimePolicyResponse = GetModelRuntimePolicyResponses[keyof GetModelRuntimePolicyResponses];

export type UpdateModelRuntimePolicyData = {
    body?: ModelRuntimePolicyUpsert;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/model-runtime-policies/{id}';
};

export type UpdateModelRuntimePolicyErrors = {
    /**
     * Invalid models or fallback, or the policy is still a surface default
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Policy slug already exists in this scope
     */
    409: unknown;
};

export type UpdateModelRuntimePolicyResponses = {
    /**
     * Updated model runtime policy. Archiving or drafting it retires it: what moved to the surface defaults is counted.
     */
    200: {
        data: ModelRuntimePolicy;
        retired: RuntimePolicyRetireCounts | null;
    };
};

export type UpdateModelRuntimePolicyResponse = UpdateModelRuntimePolicyResponses[keyof UpdateModelRuntimePolicyResponses];

export type ListRuntimePolicySurfaceRulesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/runtime-policy-surfaces';
};

export type ListRuntimePolicySurfaceRulesResponses = {
    /**
     * The rule of every surface the organization runs under
     */
    200: {
        data: Array<RuntimePolicySurfaceRule>;
    };
};

export type ListRuntimePolicySurfaceRulesResponse = ListRuntimePolicySurfaceRulesResponses[keyof ListRuntimePolicySurfaceRulesResponses];

export type ListRuntimePolicyOptionsData = {
    body?: never;
    path: {
        surface: RuntimePolicySurface;
    };
    query?: never;
    url: '/api/v1/runtime-policy-surfaces/{surface}/options';
};

export type ListRuntimePolicyOptionsResponses = {
    /**
     * The policies a person may pick for this kind of work, the default first
     */
    200: {
        data: Array<RuntimePolicyOption>;
    };
};

export type ListRuntimePolicyOptionsResponse = ListRuntimePolicyOptionsResponses[keyof ListRuntimePolicyOptionsResponses];

export type SetSystemRuntimePolicySurfaceRuleData = {
    body?: RuntimePolicySurfaceRuleWrite;
    path: {
        surface: RuntimePolicySurface;
    };
    query?: never;
    url: '/api/v1/runtime-policy-surfaces/{surface}';
};

export type SetSystemRuntimePolicySurfaceRuleErrors = {
    /**
     * A policy is not an active system policy
     */
    400: unknown;
};

export type SetSystemRuntimePolicySurfaceRuleResponses = {
    /**
     * The system's rule for this kind of work
     */
    200: {
        data: RuntimePolicySurfaceRule;
    };
};

export type SetSystemRuntimePolicySurfaceRuleResponse = SetSystemRuntimePolicySurfaceRuleResponses[keyof SetSystemRuntimePolicySurfaceRuleResponses];

export type ClearOrganizationRuntimePolicySurfaceRuleData = {
    body?: never;
    path: {
        surface: RuntimePolicySurface;
    };
    query?: never;
    url: '/api/v1/runtime-policy-surfaces/{surface}/organization';
};

export type ClearOrganizationRuntimePolicySurfaceRuleResponses = {
    /**
     * The rule that applies now: the system's
     */
    200: {
        data: RuntimePolicySurfaceRule | null;
    };
};

export type ClearOrganizationRuntimePolicySurfaceRuleResponse = ClearOrganizationRuntimePolicySurfaceRuleResponses[keyof ClearOrganizationRuntimePolicySurfaceRuleResponses];

export type SetOrganizationRuntimePolicySurfaceRuleData = {
    body?: RuntimePolicySurfaceRuleWrite;
    path: {
        surface: RuntimePolicySurface;
    };
    query?: never;
    url: '/api/v1/runtime-policy-surfaces/{surface}/organization';
};

export type SetOrganizationRuntimePolicySurfaceRuleErrors = {
    /**
     * A policy is not an active policy of the system or this organization
     */
    400: unknown;
};

export type SetOrganizationRuntimePolicySurfaceRuleResponses = {
    /**
     * The organization's own rule for this kind of work (it replaces the system's)
     */
    200: {
        data: RuntimePolicySurfaceRule;
    };
};

export type SetOrganizationRuntimePolicySurfaceRuleResponse = SetOrganizationRuntimePolicySurfaceRuleResponses[keyof SetOrganizationRuntimePolicySurfaceRuleResponses];

export type ListDynamicFanOutPoliciesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/dynamic-fanout-policies';
};

export type ListDynamicFanOutPoliciesResponses = {
    /**
     * Dynamic fan-out policy templates
     */
    200: {
        data: Array<DynamicFanOutPolicy>;
    };
};

export type ListDynamicFanOutPoliciesResponse = ListDynamicFanOutPoliciesResponses[keyof ListDynamicFanOutPoliciesResponses];

export type CreateDynamicFanOutPolicyData = {
    body?: DynamicFanOutPolicyUpsert;
    path?: never;
    query?: never;
    url: '/api/v1/dynamic-fanout-policies';
};

export type CreateDynamicFanOutPolicyErrors = {
    /**
     * Organization scope requires an active organization context
     */
    400: unknown;
    /**
     * Policy slug already exists in this scope
     */
    409: unknown;
};

export type CreateDynamicFanOutPolicyResponses = {
    /**
     * Created dynamic fan-out policy
     */
    201: {
        data: DynamicFanOutPolicy;
    };
};

export type CreateDynamicFanOutPolicyResponse = CreateDynamicFanOutPolicyResponses[keyof CreateDynamicFanOutPolicyResponses];

export type ResolveDynamicFanOutPolicyData = {
    body?: DynamicFanOutPolicyResolveRequest;
    path?: never;
    query?: never;
    url: '/api/v1/dynamic-fanout-policies/resolve';
};

export type ResolveDynamicFanOutPolicyErrors = {
    /**
     * Resolved policy row was not found in the active tenant scope
     */
    404: unknown;
};

export type ResolveDynamicFanOutPolicyResponses = {
    /**
     * Resolved dynamic fan-out policy preview
     */
    200: {
        data: DynamicFanOutPolicy;
    };
};

export type ResolveDynamicFanOutPolicyResponse = ResolveDynamicFanOutPolicyResponses[keyof ResolveDynamicFanOutPolicyResponses];

export type GetDynamicFanOutPolicyData = {
    body?: never;
    path: {
        slug: string;
    };
    query?: never;
    url: '/api/v1/dynamic-fanout-policies/{slug}';
};

export type GetDynamicFanOutPolicyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetDynamicFanOutPolicyResponses = {
    /**
     * Dynamic fan-out policy
     */
    200: {
        data: DynamicFanOutPolicy;
    };
};

export type GetDynamicFanOutPolicyResponse = GetDynamicFanOutPolicyResponses[keyof GetDynamicFanOutPolicyResponses];

export type UpdateDynamicFanOutPolicyData = {
    body?: DynamicFanOutPolicyUpsert;
    path: {
        slug: string;
    };
    query?: never;
    url: '/api/v1/dynamic-fanout-policies/{slug}';
};

export type UpdateDynamicFanOutPolicyErrors = {
    /**
     * Organization scope requires an active organization context
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Policy slug already exists in this scope
     */
    409: unknown;
};

export type UpdateDynamicFanOutPolicyResponses = {
    /**
     * Updated dynamic fan-out policy
     */
    200: {
        data: DynamicFanOutPolicy;
    };
};

export type UpdateDynamicFanOutPolicyResponse = UpdateDynamicFanOutPolicyResponses[keyof UpdateDynamicFanOutPolicyResponses];

export type CallAiWorkerMcpData = {
    body?: AiWorkerMcpRequest;
    path: {
        workerId: string;
    };
    query?: never;
    url: '/api/v1/ai-workers/{workerId}/mcp';
};

export type CallAiWorkerMcpErrors = {
    /**
     * Invalid worker session
     */
    401: unknown;
    /**
     * Only POST is supported on this endpoint
     */
    405: unknown;
};

export type CallAiWorkerMcpResponses = {
    /**
     * MCP JSON-RPC response
     */
    200: AiWorkerMcpResponse;
};

export type CallAiWorkerMcpResponse = CallAiWorkerMcpResponses[keyof CallAiWorkerMcpResponses];

export type QueryAiWorkerDataData = {
    body?: {
        sql: string;
        params?: {
            [key: string]: unknown;
        };
        asOf?: string;
        maxRows?: number;
    };
    path: {
        workerId: string;
    };
    query?: never;
    url: '/api/v1/ai-workers/{workerId}/data/query';
};

export type QueryAiWorkerDataErrors = {
    /**
     * The query was refused by the gate
     */
    400: unknown;
    /**
     * Invalid worker session
     */
    401: unknown;
    /**
     * This key may not read data
     */
    403: unknown;
};

export type QueryAiWorkerDataResponses = {
    /**
     * Arrow IPC stream.
     */
    200: Blob | File;
};

export type QueryAiWorkerDataResponse = QueryAiWorkerDataResponses[keyof QueryAiWorkerDataResponses];

export type RunAiWorkerDatasetData = {
    body?: {
        name: string;
        params?: {
            [key: string]: unknown;
        };
        asOf?: string;
        maxRows?: number;
    };
    path: {
        workerId: string;
    };
    query?: never;
    url: '/api/v1/ai-workers/{workerId}/data/dataset';
};

export type RunAiWorkerDatasetErrors = {
    /**
     * The query was refused by the gate
     */
    400: unknown;
    /**
     * Invalid worker session
     */
    401: unknown;
    /**
     * This key may not read data
     */
    403: unknown;
};

export type RunAiWorkerDatasetResponses = {
    /**
     * Arrow IPC stream.
     */
    200: Blob | File;
};

export type RunAiWorkerDatasetResponse = RunAiWorkerDatasetResponses[keyof RunAiWorkerDatasetResponses];

export type FetchAiWorkerDataResultData = {
    body?: never;
    path: {
        workerId: string;
        handle: string;
    };
    query?: never;
    url: '/api/v1/ai-workers/{workerId}/data/result/{handle}';
};

export type FetchAiWorkerDataResultErrors = {
    /**
     * Invalid worker session
     */
    401: unknown;
    /**
     * No result for that handle
     */
    404: unknown;
};

export type FetchAiWorkerDataResultResponses = {
    /**
     * Arrow IPC stream.
     */
    200: Blob | File;
};

export type FetchAiWorkerDataResultResponse = FetchAiWorkerDataResultResponses[keyof FetchAiWorkerDataResultResponses];

export type RegisterAiWorkerData = {
    body?: {
        workerId: string;
        displayName?: string;
        capabilities: Array<string>;
        models?: Array<{
            id?: number;
            slug: string;
            provider: string;
            providerModel: string;
            strengths?: Array<string>;
            capabilities?: Array<string>;
            load?: {
                limit: number | null;
                running: number;
                waiting: number;
                server?: {
                    running: number;
                    waiting: number;
                };
            };
            costTier: string;
            maxTokens: number;
        }>;
        network?: {
            privateAddresses: Array<string>;
            lanAddresses: Array<string>;
            publicEgress?: string;
            engineBoxReachable: boolean | null;
            probedAt: string;
        };
    };
    path?: never;
    query?: never;
    url: '/api/v1/ai-workers/register';
};

export type RegisterAiWorkerErrors = {
    /**
     * Invalid API key
     */
    401: unknown;
    /**
     * API key is not authorized to register workers
     */
    403: unknown;
};

export type RegisterAiWorkerResponses = {
    /**
     * AI worker registered
     */
    200: {
        workerId: string;
        sessionToken: string;
        heartbeatIntervalMs: number;
        commandCursor: string;
        models: Array<{
            id?: number;
            slug: string;
            provider: string;
            modelName: string;
            displayName: string;
            strengths: Array<string>;
            costTier: 'free' | 'low' | 'medium' | 'high';
            maxTokens: number;
            maxOutputTokens: number | null;
            maxConcurrentRequests?: number | null;
            supportsVision: boolean;
            supportsTools: boolean;
            supportsStructuredOutput: boolean;
            supportsReasoning: boolean;
            supportsStreaming: boolean;
            supportsMultimodal: boolean;
            supportsRealtime: boolean;
            supportsProviderTools: boolean;
            supportsPromptCaching: boolean;
            supportsFiles: boolean;
            supportsWebSearch: boolean;
            dataRetentionTier: string;
            capabilities: {
                [key: string]: unknown;
            };
            enabled: boolean;
        }>;
    };
};

export type RegisterAiWorkerResponse = RegisterAiWorkerResponses[keyof RegisterAiWorkerResponses];

export type HeartbeatAiWorkerData = {
    body?: {
        capabilities: Array<string>;
        models?: Array<{
            id?: number;
            slug: string;
            provider: string;
            providerModel: string;
            strengths?: Array<string>;
            capabilities?: Array<string>;
            load?: {
                limit: number | null;
                running: number;
                waiting: number;
                server?: {
                    running: number;
                    waiting: number;
                };
            };
            costTier: string;
            maxTokens: number;
        }>;
        network?: {
            privateAddresses: Array<string>;
            lanAddresses: Array<string>;
            publicEgress?: string;
            engineBoxReachable: boolean | null;
            probedAt: string;
        };
        inFlight?: Array<string>;
        version?: string;
    };
    path: {
        workerId: string;
    };
    query?: never;
    url: '/api/v1/ai-workers/{workerId}/heartbeat';
};

export type HeartbeatAiWorkerErrors = {
    /**
     * Invalid worker session
     */
    401: unknown;
};

export type HeartbeatAiWorkerResponses = {
    /**
     * Heartbeat accepted
     */
    204: void;
};

export type HeartbeatAiWorkerResponse = HeartbeatAiWorkerResponses[keyof HeartbeatAiWorkerResponses];

export type PollAiWorkerCommandsData = {
    body?: {
        blockMs?: number;
        maxCommands?: number;
    };
    path: {
        workerId: string;
    };
    query?: never;
    url: '/api/v1/ai-workers/{workerId}/poll';
};

export type PollAiWorkerCommandsErrors = {
    /**
     * Invalid worker session
     */
    401: unknown;
};

export type PollAiWorkerCommandsResponses = {
    /**
     * Pending commands
     */
    200: {
        cursor: string;
        commands: Array<{
            id: string;
            command: {
                enqueuedAt?: string;
                expiresAt?: string;
                type: 'ai:complete';
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                model: string;
                modelId?: number;
                surface?: 'conversation' | 'workforce' | 'workflow' | 'analysis' | 'evaluation' | 'judge' | 'codegen' | 'system' | 'research';
                messages: Array<{
                    role: 'system' | 'user' | 'assistant' | 'tool';
                    content?: unknown;
                    toolCalls?: Array<unknown>;
                    toolCallId?: string;
                    toolName?: string;
                    isError?: boolean;
                }>;
                maxTokens?: number;
                temperature?: number;
                responseFormat?: 'text' | 'json';
                responseSchema?: {
                    [key: string]: unknown;
                };
                thinking?: boolean;
                tools?: Array<{
                    name: string;
                    description: string;
                    inputSchema: {
                        [key: string]: unknown;
                    };
                }>;
                toolExecutionContext?: {
                    [key: string]: unknown;
                };
                stream?: boolean;
                runtimePolicy?: {
                    id: number | null;
                    organizationId: number | null;
                    slug: string;
                    name: string;
                    version: number;
                    purpose: 'interactive' | 'background' | 'evaluation' | 'daemon' | 'workflow' | 'debug' | 'bulk';
                    riskTier: 'low' | 'medium' | 'high' | 'privileged';
                    latencyClass: 'realtime' | 'interactive' | 'batch';
                    costTier: 'free' | 'low' | 'medium' | 'high';
                    permissionTier: 'observer' | 'contributor' | 'operator';
                    tags: Array<string>;
                    wallClockTimeoutMs: number;
                    providerRequestTimeoutMs: number;
                    idleTimeoutMs: number | null;
                    maxInputTokens: number | null;
                    maxOutputTokens: number;
                    maxSystemPromptChars: number | null;
                    maxConcurrentRequests?: number | null;
                    maxToolCalls: number;
                    maxTurns: number;
                    retryMax: number;
                    retryBackoffMs: number;
                    retryBackoffMultiplier: number;
                    retryJitter: boolean;
                    spendCapUsd: number | null;
                    permissionMode: 'provider_default' | 'read_only' | 'workspace_write' | 'full_auto' | 'bypass_permissions';
                    allowedProviderTools: Array<string>;
                    streamingEnabled: boolean;
                    sessionMode: 'provider_default' | 'stateless' | 'reuse_session';
                    promptCachingEnabled: boolean;
                    providerExtensions: {
                        [key: string]: unknown;
                    };
                    models?: Array<{
                        id: number;
                        slug: string;
                    }>;
                    fallbackPolicyId?: number | null;
                    thinking?: 'model_default' | 'on' | 'off';
                };
                traceparent?: string;
                tracestate?: string;
                workflowRunId?: string;
                stepId?: string;
                workspace?: {
                    workspaceId: string;
                    patchChain: {
                        links: Array<{
                            commitSha: string;
                            baseCommitSha: string | null;
                            patch: string;
                            message: string;
                            authoredAt: string;
                            patchHash: string;
                        }>;
                    };
                    commitMessage: string;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                type: 'ai:embed';
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                model: string;
                inputs: Array<string>;
                normalize?: boolean;
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                type: 'ai:rerank';
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                model: string;
                query: string;
                documents: Array<string>;
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                type: 'ai:finetune';
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                baseModel: string;
                datasetArtifactId: number;
                dataset: {
                    encoding: 'jsonl+gzip+base64';
                    sha256: string;
                    examples: number;
                    platforms: Array<string>;
                    payload: string;
                };
                adapterName: string;
                hyper: {
                    rank: number;
                    alpha: number;
                    lr: number;
                    epochs: number;
                    seqLen: number;
                    seed?: number;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:sandbox.run';
                snapshot?: {
                    repo?: string;
                    ref?: string;
                    commitSha?: string;
                    sparsePaths?: Array<string>;
                    workspaceId?: string;
                    patchChain?: {
                        links: Array<{
                            commitSha: string;
                            baseCommitSha: string | null;
                            patch: string;
                            message: string;
                            authoredAt: string;
                            patchHash: string;
                        }>;
                    };
                };
                command: {
                    name: string;
                    command: Array<string>;
                    cwd?: string;
                    env?: {
                        [key: string]: string;
                    };
                    profile: {
                        image?: string;
                        network: 'none' | 'vuln-db' | 'external-research';
                        readOnly: boolean;
                        timeoutMs?: number;
                        memoryMb?: number;
                        cpuCount?: number;
                        allowedEnv?: Array<string>;
                    };
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:repoSnapshot.read';
                request: {
                    snapshot: {
                        repo: string;
                        ref?: string;
                        commitSha: string;
                        sparsePaths?: Array<string>;
                    };
                    paths: Array<string>;
                    maxBytesPerFile?: number;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.prepare';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    repoUrl?: string;
                    ref?: string;
                    commitSha?: string;
                    patchChain?: {
                        links: Array<{
                            commitSha: string;
                            baseCommitSha: string | null;
                            patch: string;
                            message: string;
                            authoredAt: string;
                            patchHash: string;
                        }>;
                    };
                    auth?: {
                        username: string;
                        password: string;
                    };
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.listFiles';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    maxFiles?: number;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.readFiles';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    paths: Array<string>;
                    maxBytesPerFile?: number;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.writeBatch';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    files?: Array<{
                        path: string;
                        contentBase64: string;
                        executable?: boolean;
                    }>;
                    deletePaths?: Array<string>;
                    expectedHeadSha?: string | null;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.applyPatch';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    patch: string;
                    expectedHeadSha?: string | null;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.diff';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    baseRef?: string;
                    paths?: Array<string>;
                    maxBytes?: number;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.commit';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    message: string;
                    expectedHeadSha?: string | null;
                    authorName?: string;
                    authorEmail?: string;
                    captureLink?: boolean;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.revert';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    commitSha: string;
                    expectedHeadSha?: string | null;
                    message?: string;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.runCommand';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    command: Array<string>;
                    cwd?: string;
                    env?: {
                        [key: string]: string;
                    };
                    timeoutMs?: number;
                    maxOutputBytes?: number;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.push';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    branch: string;
                    remote?: string;
                    auth?: {
                        username: string;
                        password: string;
                    };
                    timeoutMs?: number;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.cleanup';
                request: {
                    workspaceId: string;
                    directPath?: string;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:workspace.compactChain';
                request: {
                    workspaceId: string;
                    directPath?: string;
                    patchChain: {
                        links: Array<{
                            commitSha: string;
                            baseCommitSha: string | null;
                            patch: string;
                            message: string;
                            authoredAt: string;
                            patchHash: string;
                        }>;
                    };
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:codePreview.start';
                request: {
                    organizationId: number;
                    projectId: number;
                    workstreamId: number;
                    versionId: number;
                    sessionId: string;
                    mode: 'mock' | 'real' | 'mixed';
                    workspaceId: string;
                    patchChain: {
                        links: Array<{
                            commitSha: string;
                            baseCommitSha: string | null;
                            patch: string;
                            message: string;
                            authoredAt: string;
                            patchHash: string;
                        }>;
                    };
                    launch: {
                        image: string;
                        install?: Array<string>;
                        start: Array<string>;
                        port?: number;
                        workdir?: string;
                        env?: {
                            [key: string]: string;
                        };
                        readinessPath?: string;
                        readinessTimeoutMs?: number;
                    };
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:codePreview.stop';
                request: {
                    sessionId: string;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:codePreview.proxy';
                request: {
                    sessionId: string;
                    target: {
                        kind: 'worker_local_http';
                        baseUrl: string;
                    };
                    method: 'GET' | 'HEAD' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS';
                    path: string;
                    search?: string;
                    headers?: {
                        [key: string]: string;
                    };
                    bodyBase64?: string;
                    maxResponseBytes?: number;
                    timeoutMs?: number;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:content.discoverSource';
                request: {
                    platform: 'youtube' | 'x' | 'rss' | 'discord' | 'web' | 'github';
                    identifier: string;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:content.listItems';
                request: {
                    platform: 'youtube' | 'x' | 'rss' | 'discord' | 'web' | 'github';
                    sourceRef: {
                        externalId?: string;
                        handle?: string;
                        uploadsPlaylistId?: string;
                    };
                    mode: 'rss' | 'api';
                    cursor?: string;
                    since?: string;
                    limit?: number;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:content.fetchItem';
                request: {
                    platform: 'youtube' | 'x' | 'rss' | 'discord' | 'web' | 'github';
                    itemRef: {
                        externalId: string;
                    };
                    want: Array<'metadata' | 'transcript' | 'text'>;
                    languages?: Array<string>;
                    rawCapture?: boolean;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:content.analyzeMedia';
                request: {
                    platform: 'youtube';
                    itemRef: {
                        externalId: string;
                    };
                    languages?: Array<string>;
                    limits: {
                        maxBytes?: number;
                        maxDurationSeconds?: number;
                        maxFrames?: number;
                    };
                    analysis: {
                        model?: string;
                        systemPrompt: string;
                        userPrompt: string;
                        responseSchema: {
                            [key: string]: unknown;
                        };
                        runtimePolicy: {
                            id: number | null;
                            organizationId: number | null;
                            slug: string;
                            name: string;
                            version: number;
                            purpose: 'interactive' | 'background' | 'evaluation' | 'daemon' | 'workflow' | 'debug' | 'bulk';
                            riskTier: 'low' | 'medium' | 'high' | 'privileged';
                            latencyClass: 'realtime' | 'interactive' | 'batch';
                            costTier: 'free' | 'low' | 'medium' | 'high';
                            permissionTier: 'observer' | 'contributor' | 'operator';
                            tags: Array<string>;
                            wallClockTimeoutMs: number;
                            providerRequestTimeoutMs: number;
                            idleTimeoutMs: number | null;
                            maxInputTokens: number | null;
                            maxOutputTokens: number;
                            maxSystemPromptChars: number | null;
                            maxConcurrentRequests?: number | null;
                            maxToolCalls: number;
                            maxTurns: number;
                            retryMax: number;
                            retryBackoffMs: number;
                            retryBackoffMultiplier: number;
                            retryJitter: boolean;
                            spendCapUsd: number | null;
                            permissionMode: 'provider_default' | 'read_only' | 'workspace_write' | 'full_auto' | 'bypass_permissions';
                            allowedProviderTools: Array<string>;
                            streamingEnabled: boolean;
                            sessionMode: 'provider_default' | 'stateless' | 'reuse_session';
                            promptCachingEnabled: boolean;
                            providerExtensions: {
                                [key: string]: unknown;
                            };
                            models?: Array<{
                                id: number;
                                slug: string;
                            }>;
                            fallbackPolicyId?: number | null;
                            thinking?: 'model_default' | 'on' | 'off';
                        };
                        maxTokens?: number;
                    };
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:content.search';
                request: {
                    platform: 'youtube' | 'github';
                    query: string;
                    limit?: number;
                    since?: string;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: string;
                request?: unknown;
            };
        }>;
    };
};

export type PollAiWorkerCommandsResponse = PollAiWorkerCommandsResponses[keyof PollAiWorkerCommandsResponses];

export type PollAiWorkerControlCommandsData = {
    body?: {
        blockMs?: number;
        maxCommands?: number;
    };
    path: {
        workerId: string;
    };
    query?: never;
    url: '/api/v1/ai-workers/{workerId}/control';
};

export type PollAiWorkerControlCommandsErrors = {
    /**
     * Invalid worker session
     */
    401: unknown;
};

export type PollAiWorkerControlCommandsResponses = {
    /**
     * Cancels for commands this worker already holds
     */
    200: {
        commands: Array<{
            id: string;
            command: {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'worker:content.cancel';
                request: {
                    requestId: string;
                };
            } | {
                enqueuedAt?: string;
                expiresAt?: string;
                requestId: string;
                source: 'engine' | 'server';
                organizationId?: number;
                trustScope: 'system' | 'org';
                requiredCapabilities?: Array<string>;
                type: 'ai:cancel';
                request: {
                    requestId: string;
                };
            };
        }>;
    };
};

export type PollAiWorkerControlCommandsResponse = PollAiWorkerControlCommandsResponses[keyof PollAiWorkerControlCommandsResponses];

export type PublishAiWorkerEventsData = {
    body?: {
        events: Array<{
            type: 'ai.embedded';
            requestId: string;
            vectors: Array<Array<number>>;
            model: string;
            dims: number;
        } | {
            type: 'ai.reranked';
            requestId: string;
            scores: Array<number>;
        } | {
            type: 'ai.finetune.progress';
            requestId: string;
            phase: 'preparing' | 'loading' | 'training' | 'saving';
            step?: number;
            totalSteps?: number;
            epoch?: number;
            loss?: number;
            tokensPerSecond?: number;
        } | {
            type: 'ai.finetuned';
            requestId: string;
            adapterSlug: string;
            metrics: {
                trainLoss: number | null;
                steps: number;
                epochs: number;
                trainTokens: number;
                runtimeSeconds: number;
                tokensPerSecond: number;
                peakMemoryGiB: number | null;
            };
            modelCard: {
                contract: 'adapter-model-card-v1';
                adapterSlug: string;
                baseModel: string;
                servedBasePath: string;
                baseRevision: string | null;
                trainingBasePath: string;
                datasetArtifactId: number;
                datasetSha256: string;
                examples: number;
                examplesByKind: {
                    [key: string]: number;
                };
                platforms: Array<string>;
                hyper: {
                    rank: number;
                    alpha: number;
                    lr: number;
                    epochs: number;
                    seqLen: number;
                    seed?: number;
                };
                targetModules: Array<string>;
                method: 'qlora-4bit' | 'lora-bf16';
                runtime: {
                    [key: string]: string;
                };
                metrics: {
                    trainLoss: number | null;
                    steps: number;
                    epochs: number;
                    trainTokens: number;
                    runtimeSeconds: number;
                    tokensPerSecond: number;
                    peakMemoryGiB: number | null;
                };
                evalScores: {
                    [key: string]: number;
                };
                createdAt: string;
            };
        } | {
            type: 'ai.started';
            requestId: string;
            workerId: string;
            model: string;
        } | {
            type: 'ai.delta';
            requestId: string;
            delta: string;
            index: number;
        } | {
            type: 'ai.completed';
            requestId: string;
            content: string;
            model: string;
            modelSlug?: string;
            usage?: {
                promptTokens: number;
                completionTokens: number;
                totalTokens: number;
            };
            toolCalls?: Array<unknown>;
            finishReason?: string;
            traceId?: string;
            spanId?: string;
            workspace?: {
                changed: boolean;
                link: {
                    commitSha: string;
                    baseCommitSha: string | null;
                    patch: string;
                    message: string;
                    authoredAt: string;
                    patchHash: string;
                } | null;
                changedFiles: Array<string>;
            };
        } | {
            type: 'ai.error';
            requestId: string;
            code: string;
            message: string;
            retryable: boolean;
        } | {
            type: 'ai.end';
            requestId: string;
        } | {
            type: 'worker.started';
            requestId: string;
            workerId: string;
            commandType: string;
        } | {
            type: 'worker.sandbox.completed';
            requestId: string;
            result: {
                name: string;
                command: Array<string>;
                exitCode: number;
                stdout: string;
                stderr: string;
                durationMs: number;
                timedOut: boolean;
            };
            workspaceId: string;
            commitSha?: string;
        } | {
            type: 'worker.repoSnapshot.completed';
            requestId: string;
            result: {
                repo: string;
                ref?: string | null;
                commitSha?: string;
                workspaceId: string;
                files: Array<{
                    path: string;
                    content: string;
                    sizeBytes: number;
                    truncated: boolean;
                }>;
                errors: Array<{
                    path: string;
                    error: string;
                }>;
                audit: {
                    worker: 'system';
                    operation: 'repo-snapshot-read';
                    requestedPaths: Array<string>;
                    returnedFiles: number;
                    maxBytesPerFile: number;
                };
            };
        } | {
            type: 'worker.workspace.completed';
            requestId: string;
            result: {
                workspaceId: string;
                operation: 'worker:workspace.prepare' | 'worker:workspace.listFiles' | 'worker:workspace.readFiles' | 'worker:workspace.writeBatch' | 'worker:workspace.applyPatch' | 'worker:workspace.diff' | 'worker:workspace.commit' | 'worker:workspace.revert' | 'worker:workspace.runCommand' | 'worker:workspace.push' | 'worker:workspace.cleanup' | 'worker:workspace.compactChain';
                changedFiles?: Array<string>;
                changedBytes?: number;
                baseCommitSha?: string | null;
                headCommitSha?: string | null;
                patchHash?: string | null;
                link?: {
                    commitSha: string;
                    baseCommitSha: string | null;
                    patch: string;
                    message: string;
                    authoredAt: string;
                    patchHash: string;
                };
                compaction?: {
                    links: Array<{
                        link: {
                            commitSha: string;
                            baseCommitSha: string | null;
                            patch: string;
                            message: string;
                            authoredAt: string;
                            patchHash: string;
                        };
                        changedFiles: Array<string>;
                    }>;
                    previousHeadSha: string | null;
                    previousTreeSha: string;
                    treeSha: string;
                    fileCount: number;
                };
                files?: Array<{
                    path: string;
                    contentBase64?: string;
                    sizeBytes: number;
                    truncated?: boolean;
                    mode?: '100644' | '100755';
                }>;
                diff?: string;
                stdout?: string;
                stderr?: string;
                exitCode?: number;
                timedOut?: boolean;
                audit: {
                    worker: string;
                    operation: 'worker:workspace.prepare' | 'worker:workspace.listFiles' | 'worker:workspace.readFiles' | 'worker:workspace.writeBatch' | 'worker:workspace.applyPatch' | 'worker:workspace.diff' | 'worker:workspace.commit' | 'worker:workspace.revert' | 'worker:workspace.runCommand' | 'worker:workspace.push' | 'worker:workspace.cleanup' | 'worker:workspace.compactChain';
                    directPath: boolean;
                };
            };
        } | {
            type: 'preview.target.ready';
            requestId: string;
            workerId: string;
            organizationId: number;
            projectId: number;
            workstreamId: number;
            versionId: number;
            sessionId: string;
            mode: 'mock' | 'real' | 'mixed';
            target: {
                kind: 'worker_local_http';
                baseUrl: string;
            };
        } | {
            type: 'preview.stopped';
            requestId: string;
            workerId: string;
            sessionId: string;
        } | {
            type: 'preview.proxy.completed';
            requestId: string;
            response: {
                status: number;
                statusText: string;
                headers?: {
                    [key: string]: string;
                };
                bodyBase64: string;
            };
        } | {
            type: 'worker.error';
            requestId: string;
            code: string;
            message: string;
            retryable: boolean;
        } | {
            type: 'worker.end';
            requestId: string;
        } | {
            type: 'worker.content.completed';
            requestId: string;
            result: {
                operation: 'discoverSource';
                outcome: {
                    status: 'ok';
                    identity: {
                        platform: 'youtube' | 'x' | 'rss' | 'discord' | 'web' | 'github';
                        externalId: string;
                        handle?: string;
                        displayName: string;
                        description?: string;
                        profileUrl?: string;
                        avatarUrl?: string;
                        uploadsPlaylistId?: string;
                        followerCount?: number;
                        postCount?: number;
                        country?: string;
                        topics?: Array<string>;
                    };
                } | {
                    status: 'error';
                    error: {
                        code: 'quota_exhausted' | 'rate_limited' | 'ip_blocked' | 'po_token_required' | 'not_found' | 'captions_unavailable' | 'budget_exceeded' | 'credentials_missing' | 'upstream_error' | 'media_too_large' | 'media_unavailable' | 'stt_failed' | 'provider_unsupported' | 'account_locked' | 'session_expired' | 'cursor_invalid';
                        message: string;
                        retryAfterSeconds?: number;
                    };
                } | {
                    status: 'cancelled';
                };
            } | {
                operation: 'listItems';
                outcome: {
                    status: 'ok';
                    items: Array<{
                        externalId: string;
                        title: string;
                        url: string;
                        publishedAt: string;
                        durationSeconds?: number;
                        text?: string;
                        language?: string;
                        stats?: {
                            views?: number;
                            likes?: number;
                            comments?: number;
                            reposts?: number;
                            replies?: number;
                            quotes?: number;
                        };
                        author?: {
                            id: string;
                            name: string;
                        };
                        replyToId?: string;
                        attachments?: Array<{
                            kind: 'image' | 'video' | 'link';
                            url: string;
                        }>;
                    }>;
                    nextCursor: string | null;
                    reachedSince?: boolean;
                } | {
                    status: 'error';
                    error: {
                        code: 'quota_exhausted' | 'rate_limited' | 'ip_blocked' | 'po_token_required' | 'not_found' | 'captions_unavailable' | 'budget_exceeded' | 'credentials_missing' | 'upstream_error' | 'media_too_large' | 'media_unavailable' | 'stt_failed' | 'provider_unsupported' | 'account_locked' | 'session_expired' | 'cursor_invalid';
                        message: string;
                        retryAfterSeconds?: number;
                    };
                } | {
                    status: 'cancelled';
                };
            } | {
                operation: 'fetchItem';
                outcome: {
                    status: 'ok';
                    item: {
                        externalId: string;
                        title: string;
                        url: string;
                        publishedAt: string;
                        durationSeconds?: number;
                        text?: string;
                        language?: string;
                        stats?: {
                            views?: number;
                            likes?: number;
                            comments?: number;
                            reposts?: number;
                            replies?: number;
                            quotes?: number;
                        };
                        author?: {
                            id: string;
                            name: string;
                        };
                        replyToId?: string;
                        attachments?: Array<{
                            kind: 'image' | 'video' | 'link';
                            url: string;
                        }>;
                        description?: string;
                        tags?: Array<string>;
                        code?: {
                            language: string;
                            source: string;
                            license?: string;
                        };
                    };
                    transcript?: {
                        language: string;
                        kind: 'manual' | 'auto';
                        source: 'timedtext' | 'package' | 'ytdlp' | 'stt';
                        segments: Array<{
                            text: string;
                            start: number;
                            end: number;
                        }>;
                    };
                    raw?: unknown;
                } | {
                    status: 'error';
                    error: {
                        code: 'quota_exhausted' | 'rate_limited' | 'ip_blocked' | 'po_token_required' | 'not_found' | 'captions_unavailable' | 'budget_exceeded' | 'credentials_missing' | 'upstream_error' | 'media_too_large' | 'media_unavailable' | 'stt_failed' | 'provider_unsupported' | 'account_locked' | 'session_expired' | 'cursor_invalid';
                        message: string;
                        retryAfterSeconds?: number;
                    };
                } | {
                    status: 'cancelled';
                };
            } | {
                operation: 'analyzeMedia';
                outcome: {
                    status: 'ok';
                    item: {
                        externalId: string;
                        title: string;
                        url: string;
                        publishedAt: string;
                        durationSeconds?: number;
                        text?: string;
                        language?: string;
                        stats?: {
                            views?: number;
                            likes?: number;
                            comments?: number;
                            reposts?: number;
                            replies?: number;
                            quotes?: number;
                        };
                        author?: {
                            id: string;
                            name: string;
                        };
                        replyToId?: string;
                        attachments?: Array<{
                            kind: 'image' | 'video' | 'link';
                            url: string;
                        }>;
                        description?: string;
                        tags?: Array<string>;
                        code?: {
                            language: string;
                            source: string;
                            license?: string;
                        };
                    };
                    transcript: {
                        language: string;
                        kind: 'manual' | 'auto';
                        source: 'timedtext' | 'package' | 'ytdlp' | 'stt';
                        segments: Array<{
                            text: string;
                            start: number;
                            end: number;
                        }>;
                    };
                    analysis: {
                        model: string;
                        mode?: 'workspace_files' | 'transcript_inline';
                        framesUsed: Array<number>;
                        usage?: {
                            promptTokens: number;
                            completionTokens: number;
                        };
                        provider?: string;
                        result?: unknown;
                    };
                } | {
                    status: 'error';
                    error: {
                        code: 'quota_exhausted' | 'rate_limited' | 'ip_blocked' | 'po_token_required' | 'not_found' | 'captions_unavailable' | 'budget_exceeded' | 'credentials_missing' | 'upstream_error' | 'media_too_large' | 'media_unavailable' | 'stt_failed' | 'provider_unsupported' | 'account_locked' | 'session_expired' | 'cursor_invalid';
                        message: string;
                        retryAfterSeconds?: number;
                    };
                } | {
                    status: 'cancelled';
                };
            } | {
                operation: 'search';
                outcome: {
                    status: 'ok';
                    hits: Array<{
                        externalId: string;
                        title: string;
                        url: string;
                        publishedAt?: string;
                        text?: string;
                        durationSeconds?: number;
                        stats?: {
                            views?: number;
                            likes?: number;
                            forks?: number;
                        };
                        owner?: {
                            externalId: string;
                            name: string;
                            url?: string;
                        };
                    }>;
                } | {
                    status: 'error';
                    error: {
                        code: 'quota_exhausted' | 'rate_limited' | 'ip_blocked' | 'po_token_required' | 'not_found' | 'captions_unavailable' | 'budget_exceeded' | 'credentials_missing' | 'upstream_error' | 'media_too_large' | 'media_unavailable' | 'stt_failed' | 'provider_unsupported' | 'account_locked' | 'session_expired' | 'cursor_invalid';
                        message: string;
                        retryAfterSeconds?: number;
                    };
                } | {
                    status: 'cancelled';
                };
            };
            audit: {
                worker: string;
                capability: string;
                platform: 'youtube' | 'x' | 'rss' | 'discord' | 'web' | 'github';
                endpointClass: string;
                requestCount: number;
                quotaUnitsUsed?: number;
                readsBilled?: number;
                egressIdentity: string;
                durationMs: number;
            };
        } | {
            type: string;
            requestId: string;
            result?: unknown;
            audit?: unknown;
        }>;
    };
    path: {
        workerId: string;
    };
    query?: never;
    url: '/api/v1/ai-workers/{workerId}/events';
};

export type PublishAiWorkerEventsErrors = {
    /**
     * Invalid worker session
     */
    401: unknown;
    /**
     * Worker is not assigned to one or more request ids
     */
    403: unknown;
};

export type PublishAiWorkerEventsResponses = {
    /**
     * Events accepted
     */
    204: void;
};

export type PublishAiWorkerEventsResponse = PublishAiWorkerEventsResponses[keyof PublishAiWorkerEventsResponses];

export type CreateHostMetricsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/system/host-metrics';
};

export type CreateHostMetricsErrors = {
    /**
     * Not an OTLP JSON batch
     */
    400: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Missing or invalid key
     */
    401: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Not a platform box key
     */
    403: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Batch too large
     */
    413: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Too many batches for this key
     */
    429: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Metrics hub unavailable; retry
     */
    503: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type CreateHostMetricsError = CreateHostMetricsErrors[keyof CreateHostMetricsErrors];

export type CreateHostMetricsResponses = {
    /**
     * Accepted and forwarded to the metrics hub
     */
    200: HostMetricsExportResult;
};

export type CreateHostMetricsResponse = CreateHostMetricsResponses[keyof CreateHostMetricsResponses];

export type ListSnapshotsData = {
    body?: never;
    path?: never;
    query: {
        templateId: number;
        stepId?: string;
        limit?: number;
        before?: number | null;
    };
    url: '/api/v1/agents/execution/snapshots';
};

export type ListSnapshotsErrors = {
    /**
     * Organization context is required
     */
    400: OrgRequiredError;
};

export type ListSnapshotsError = ListSnapshotsErrors[keyof ListSnapshotsErrors];

export type ListSnapshotsResponses = {
    /**
     * List of snapshots
     */
    200: SnapshotList;
};

export type ListSnapshotsResponse = ListSnapshotsResponses[keyof ListSnapshotsResponses];

export type CreateSnapshotData = {
    body?: SnapshotCreate;
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/snapshots';
};

export type CreateSnapshotErrors = {
    /**
     * Organization context is required
     */
    400: OrgRequiredError;
};

export type CreateSnapshotError = CreateSnapshotErrors[keyof CreateSnapshotErrors];

export type CreateSnapshotResponses = {
    /**
     * Snapshot created
     */
    201: Snapshot;
};

export type CreateSnapshotResponse = CreateSnapshotResponses[keyof CreateSnapshotResponses];

export type PurgeSnapshotsData = {
    body?: SnapshotPurgeRequest;
    path?: never;
    query?: never;
    url: '/api/v1/agents/execution/snapshots/purge';
};

export type PurgeSnapshotsErrors = {
    /**
     * Organization context is required
     */
    400: OrgRequiredError;
};

export type PurgeSnapshotsError = PurgeSnapshotsErrors[keyof PurgeSnapshotsErrors];

export type PurgeSnapshotsResponses = {
    /**
     * Purge result
     */
    200: {
        deletedCount: number;
    };
};

export type PurgeSnapshotsResponse = PurgeSnapshotsResponses[keyof PurgeSnapshotsResponses];

export type DeleteSnapshotData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/execution/snapshots/{id}';
};

export type DeleteSnapshotErrors = {
    /**
     * Organization context is required
     */
    400: OrgRequiredError;
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteSnapshotError = DeleteSnapshotErrors[keyof DeleteSnapshotErrors];

export type DeleteSnapshotResponses = {
    /**
     * Deleted
     */
    200: SnapshotActionResult;
};

export type DeleteSnapshotResponse = DeleteSnapshotResponses[keyof DeleteSnapshotResponses];

export type GetSnapshotData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/execution/snapshots/{id}';
};

export type GetSnapshotErrors = {
    /**
     * Organization context is required
     */
    400: OrgRequiredError;
    /**
     * Not found
     */
    404: unknown;
};

export type GetSnapshotError = GetSnapshotErrors[keyof GetSnapshotErrors];

export type GetSnapshotResponses = {
    /**
     * Snapshot detail
     */
    200: Snapshot;
};

export type GetSnapshotResponse = GetSnapshotResponses[keyof GetSnapshotResponses];

export type UpdateSnapshotData = {
    body?: SnapshotUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/execution/snapshots/{id}';
};

export type UpdateSnapshotErrors = {
    /**
     * Organization context is required
     */
    400: OrgRequiredError;
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateSnapshotError = UpdateSnapshotErrors[keyof UpdateSnapshotErrors];

export type UpdateSnapshotResponses = {
    /**
     * Updated snapshot
     */
    200: Snapshot;
};

export type UpdateSnapshotResponse = UpdateSnapshotResponses[keyof UpdateSnapshotResponses];

export type ListEvaluationDatasetsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/evaluations/datasets';
};

export type ListEvaluationDatasetsResponses = {
    /**
     * Dataset list
     */
    200: {
        data: Array<EvaluationDataset>;
    };
};

export type ListEvaluationDatasetsResponse = ListEvaluationDatasetsResponses[keyof ListEvaluationDatasetsResponses];

export type CreateEvaluationDatasetData = {
    body?: EvaluationDatasetCreate;
    path?: never;
    query?: never;
    url: '/api/v1/agents/evaluations/datasets';
};

export type CreateEvaluationDatasetResponses = {
    /**
     * Created
     */
    201: EvaluationDataset;
};

export type CreateEvaluationDatasetResponse = CreateEvaluationDatasetResponses[keyof CreateEvaluationDatasetResponses];

export type DeleteEvaluationDatasetData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/evaluations/datasets/{id}';
};

export type DeleteEvaluationDatasetErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteEvaluationDatasetResponses = {
    /**
     * Deleted
     */
    200: EvaluationActionResult;
};

export type DeleteEvaluationDatasetResponse = DeleteEvaluationDatasetResponses[keyof DeleteEvaluationDatasetResponses];

export type ListEvaluationCasesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/evaluations/datasets/{id}/cases';
};

export type ListEvaluationCasesErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEvaluationCasesResponses = {
    /**
     * Case list
     */
    200: {
        data: Array<EvaluationCase>;
    };
};

export type ListEvaluationCasesResponse = ListEvaluationCasesResponses[keyof ListEvaluationCasesResponses];

export type CreateEvaluationCaseData = {
    body?: EvaluationCaseCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/evaluations/datasets/{id}/cases';
};

export type CreateEvaluationCaseErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type CreateEvaluationCaseResponses = {
    /**
     * Created
     */
    201: EvaluationCase;
};

export type CreateEvaluationCaseResponse = CreateEvaluationCaseResponses[keyof CreateEvaluationCaseResponses];

export type DeleteEvaluationCaseData = {
    body?: never;
    path: {
        id: string;
        caseId: string;
    };
    query?: never;
    url: '/api/v1/agents/evaluations/datasets/{id}/cases/{caseId}';
};

export type DeleteEvaluationCaseErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteEvaluationCaseResponses = {
    /**
     * Deleted
     */
    200: EvaluationActionResult;
};

export type DeleteEvaluationCaseResponse = DeleteEvaluationCaseResponses[keyof DeleteEvaluationCaseResponses];

export type RunEvaluationDatasetData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/evaluations/datasets/{id}/run';
};

export type RunEvaluationDatasetErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Nothing to run: not an agent template dataset, or its template has no active version
     */
    409: unknown;
};

export type RunEvaluationDatasetResponses = {
    /**
     * Run queued in the engine; its result is an evaluation run of this dataset when it ends
     */
    202: EvaluationDatasetRunResult;
};

export type RunEvaluationDatasetResponse = RunEvaluationDatasetResponses[keyof RunEvaluationDatasetResponses];

export type GetEvaluationRunData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/v1/agents/evaluations/runs/{runId}';
};

export type GetEvaluationRunErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetEvaluationRunResponses = {
    /**
     * Run details
     */
    200: EvaluationRun;
};

export type GetEvaluationRunResponse = GetEvaluationRunResponses[keyof GetEvaluationRunResponses];

export type ListReasoningEvaluationsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        after?: string;
    };
    url: '/api/v1/agents/reasoning-evaluations';
};

export type ListReasoningEvaluationsResponses = {
    /**
     * Reasoning evaluation runs, newest first, with their checks
     */
    200: ReasoningEvaluationList;
};

export type ListReasoningEvaluationsResponse = ListReasoningEvaluationsResponses[keyof ListReasoningEvaluationsResponses];

export type GetReasoningCallSummaryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/reasoning-evaluations/calls/summary';
};

export type GetReasoningCallSummaryResponses = {
    /**
     * The call funnel of each followed source: where calls and reasons are dropped
     */
    200: ReasoningCallSummary;
};

export type GetReasoningCallSummaryResponse = GetReasoningCallSummaryResponses[keyof GetReasoningCallSummaryResponses];

export type GetReasoningPrincipleSummaryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/reasoning-evaluations/principles/summary';
};

export type GetReasoningPrincipleSummaryResponses = {
    /**
     * The principle funnel of each followed source, and its findings on their way to strategies: validated, drafted, measured, admitted
     */
    200: ReasoningPrincipleSummary;
};

export type GetReasoningPrincipleSummaryResponse = GetReasoningPrincipleSummaryResponses[keyof GetReasoningPrincipleSummaryResponses];

export type ListEvaluationTemplatesData = {
    body?: never;
    path?: never;
    query?: {
        subjectKind?: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
        status?: 'draft' | 'active' | 'deprecated' | 'retired';
        visibility?: 'private' | 'org';
        limit?: number;
        after?: string;
        before?: string;
    };
    url: '/api/v1/evaluation-templates';
};

export type ListEvaluationTemplatesResponses = {
    /**
     * Paginated list of evaluation templates
     */
    200: EvaluationTemplateList;
};

export type ListEvaluationTemplatesResponse = ListEvaluationTemplatesResponses[keyof ListEvaluationTemplatesResponses];

export type CreateEvaluationTemplateData = {
    body?: EvaluationTemplateCreate;
    path?: never;
    query?: never;
    url: '/api/v1/evaluation-templates';
};

export type CreateEvaluationTemplateErrors = {
    /**
     * Validation error (invalid spec, subjectKind mismatch)
     */
    400: unknown;
    /**
     * Template ref already exists for this org
     */
    409: unknown;
};

export type CreateEvaluationTemplateResponses = {
    /**
     * Created evaluation template with initial version
     */
    201: {
        data: EvaluationTemplateWithVersions;
    };
};

export type CreateEvaluationTemplateResponse = CreateEvaluationTemplateResponses[keyof CreateEvaluationTemplateResponses];

export type GetEvaluationTemplateData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/evaluation-templates/{id}';
};

export type GetEvaluationTemplateErrors = {
    /**
     * Template not found
     */
    404: unknown;
};

export type GetEvaluationTemplateResponses = {
    /**
     * Evaluation template with all versions
     */
    200: {
        data: EvaluationTemplateWithVersions;
    };
};

export type GetEvaluationTemplateResponse = GetEvaluationTemplateResponses[keyof GetEvaluationTemplateResponses];

export type UpdateEvaluationTemplateData = {
    body?: EvaluationTemplateUpdate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/evaluation-templates/{id}';
};

export type UpdateEvaluationTemplateErrors = {
    /**
     * Template not found
     */
    404: unknown;
};

export type UpdateEvaluationTemplateResponses = {
    /**
     * Updated evaluation template
     */
    200: {
        data: EvaluationTemplate;
    };
};

export type UpdateEvaluationTemplateResponse = UpdateEvaluationTemplateResponses[keyof UpdateEvaluationTemplateResponses];

export type AddEvaluationTemplateVersionData = {
    body?: EvaluationTemplateVersionCreate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/evaluation-templates/{id}/versions';
};

export type AddEvaluationTemplateVersionErrors = {
    /**
     * Validation error (subjectKind mismatch or bad spec)
     */
    400: unknown;
    /**
     * Template not found
     */
    404: unknown;
    /**
     * Template already has a draft version in flight — publish it first
     */
    409: unknown;
};

export type AddEvaluationTemplateVersionResponses = {
    /**
     * New draft version created
     */
    201: {
        data: EvaluationTemplateVersion;
    };
};

export type AddEvaluationTemplateVersionResponse = AddEvaluationTemplateVersionResponses[keyof AddEvaluationTemplateVersionResponses];

export type PublishEvaluationTemplateVersionData = {
    body?: never;
    path: {
        id: number;
        versionId: number;
    };
    query?: never;
    url: '/api/v1/evaluation-templates/{id}/versions/{versionId}/publish';
};

export type PublishEvaluationTemplateVersionErrors = {
    /**
     * Template or version not found
     */
    404: unknown;
    /**
     * Version is already the active version
     */
    409: unknown;
};

export type PublishEvaluationTemplateVersionResponses = {
    /**
     * Version published (activated + locked)
     */
    200: {
        data: EvaluationTemplateVersion;
    };
};

export type PublishEvaluationTemplateVersionResponse = PublishEvaluationTemplateVersionResponses[keyof PublishEvaluationTemplateVersionResponses];

export type ApplyEvaluationTemplateData = {
    body?: EvaluationTemplateApplyRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/evaluation-templates/{id}/apply';
};

export type ApplyEvaluationTemplateErrors = {
    /**
     * Validation error (subjectKind mismatch, subject not found in this org)
     */
    400: unknown;
    /**
     * Template not found
     */
    404: unknown;
};

export type ApplyEvaluationTemplateResponses = {
    /**
     * Template applied to subject (entity_links row written on the active version)
     */
    200: {
        data: EvaluationAssignment;
    };
};

export type ApplyEvaluationTemplateResponse = ApplyEvaluationTemplateResponses[keyof ApplyEvaluationTemplateResponses];

export type GetSubjectEvaluationsData = {
    body?: never;
    path: {
        kind: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
        subjectId: string;
    };
    query?: never;
    url: '/api/v1/subjects/{kind}/{subjectId}/evaluations';
};

export type GetSubjectEvaluationsResponses = {
    /**
     * All evaluation assignments for this subject with per-assignment verdict
     */
    200: {
        data: SubjectEvaluations;
    };
};

export type GetSubjectEvaluationsResponse = GetSubjectEvaluationsResponses[keyof GetSubjectEvaluationsResponses];

export type ListCatalogSourcesData = {
    body?: never;
    path?: never;
    query?: {
        status?: string;
        statuses?: string;
        targetType?: string;
        targetTypes?: string;
        sourceType?: string;
        limit?: string;
    };
    url: '/api/v1/agents/catalog/sources';
};

export type ListCatalogSourcesErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
};

export type ListCatalogSourcesError = ListCatalogSourcesErrors[keyof ListCatalogSourcesErrors];

export type ListCatalogSourcesResponses = {
    /**
     * Catalog sources
     */
    200: CatalogSourceList;
};

export type ListCatalogSourcesResponse = ListCatalogSourcesResponses[keyof ListCatalogSourcesResponses];

export type ListCatalogCandidatesData = {
    body?: never;
    path?: never;
    query?: {
        status?: string;
        statuses?: string;
        targetType?: string;
        targetTypes?: string;
        sourceType?: string;
        limit?: string;
    };
    url: '/api/v1/agents/catalog/candidates';
};

export type ListCatalogCandidatesErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
};

export type ListCatalogCandidatesError = ListCatalogCandidatesErrors[keyof ListCatalogCandidatesErrors];

export type ListCatalogCandidatesResponses = {
    /**
     * Catalog candidates
     */
    200: CatalogCandidateList;
};

export type ListCatalogCandidatesResponse = ListCatalogCandidatesResponses[keyof ListCatalogCandidatesResponses];

export type GetCatalogCandidateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/catalog/candidates/{id}';
};

export type GetCatalogCandidateErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
    /**
     * Not found
     */
    404: CatalogErrorResult;
};

export type GetCatalogCandidateError = GetCatalogCandidateErrors[keyof GetCatalogCandidateErrors];

export type GetCatalogCandidateResponses = {
    /**
     * Catalog candidate
     */
    200: CatalogCandidateDecisionResult;
};

export type GetCatalogCandidateResponse = GetCatalogCandidateResponses[keyof GetCatalogCandidateResponses];

export type ListCatalogReviewQueueData = {
    body?: never;
    path?: never;
    query?: {
        status?: string;
        statuses?: string;
        targetType?: string;
        targetTypes?: string;
        sourceType?: string;
        limit?: string;
    };
    url: '/api/v1/agents/catalog/review-queue';
};

export type ListCatalogReviewQueueErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
};

export type ListCatalogReviewQueueError = ListCatalogReviewQueueErrors[keyof ListCatalogReviewQueueErrors];

export type ListCatalogReviewQueueResponses = {
    /**
     * Catalog review queue
     */
    200: CatalogReviewQueueList;
};

export type ListCatalogReviewQueueResponse = ListCatalogReviewQueueResponses[keyof ListCatalogReviewQueueResponses];

export type ProcessCatalogReviewQueueData = {
    body?: {
        targetDaemonName?: string;
        status?: 'blocked' | 'failed' | 'pending';
        processNow?: boolean;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/catalog/review-queue/process';
};

export type ProcessCatalogReviewQueueErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
};

export type ProcessCatalogReviewQueueError = ProcessCatalogReviewQueueErrors[keyof ProcessCatalogReviewQueueErrors];

export type ProcessCatalogReviewQueueResponses = {
    /**
     * Review queue processing triggered
     */
    200: CatalogProcessResult;
};

export type ProcessCatalogReviewQueueResponse = ProcessCatalogReviewQueueResponses[keyof ProcessCatalogReviewQueueResponses];

export type RevertCatalogVersionAdoptionData = {
    body?: {
        consumerKey: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/catalog/adoptions/revert';
};

export type RevertCatalogVersionAdoptionErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
    /**
     * Not found
     */
    404: CatalogErrorResult;
};

export type RevertCatalogVersionAdoptionError = RevertCatalogVersionAdoptionErrors[keyof RevertCatalogVersionAdoptionErrors];

export type RevertCatalogVersionAdoptionResponses = {
    /**
     * Catalog version adoption reverted
     */
    200: CatalogAdoptionResult;
};

export type RevertCatalogVersionAdoptionResponse = RevertCatalogVersionAdoptionResponses[keyof RevertCatalogVersionAdoptionResponses];

export type RetryCatalogReviewQueueData = {
    body?: {
        targetDaemonName?: string;
        status?: 'blocked' | 'failed' | 'pending';
        processNow?: boolean;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/catalog/review-queue/retry';
};

export type RetryCatalogReviewQueueErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
};

export type RetryCatalogReviewQueueError = RetryCatalogReviewQueueErrors[keyof RetryCatalogReviewQueueErrors];

export type RetryCatalogReviewQueueResponses = {
    /**
     * Review queue items requeued
     */
    200: CatalogRequeueResult;
};

export type RetryCatalogReviewQueueResponse = RetryCatalogReviewQueueResponses[keyof RetryCatalogReviewQueueResponses];

export type RetryCatalogReviewQueueItemData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/catalog/review-queue/{id}/retry';
};

export type RetryCatalogReviewQueueItemErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
    /**
     * Not found
     */
    404: CatalogErrorResult;
};

export type RetryCatalogReviewQueueItemError = RetryCatalogReviewQueueItemErrors[keyof RetryCatalogReviewQueueItemErrors];

export type RetryCatalogReviewQueueItemResponses = {
    /**
     * Review queue item requeued
     */
    200: CatalogProcessResult;
};

export type RetryCatalogReviewQueueItemResponse = RetryCatalogReviewQueueItemResponses[keyof RetryCatalogReviewQueueItemResponses];

export type ListCatalogItemVersionsData = {
    body?: never;
    path?: never;
    query?: {
        status?: string;
        statuses?: string;
        targetType?: string;
        targetTypes?: string;
        sourceType?: string;
        limit?: string;
    };
    url: '/api/v1/agents/catalog/versions';
};

export type ListCatalogItemVersionsErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
};

export type ListCatalogItemVersionsError = ListCatalogItemVersionsErrors[keyof ListCatalogItemVersionsErrors];

export type ListCatalogItemVersionsResponses = {
    /**
     * Catalog item versions
     */
    200: CatalogItemVersionList;
};

export type ListCatalogItemVersionsResponse = ListCatalogItemVersionsResponses[keyof ListCatalogItemVersionsResponses];

export type ListCatalogVersionAdoptionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/agents/catalog/adoptions';
};

export type ListCatalogVersionAdoptionsErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
};

export type ListCatalogVersionAdoptionsError = ListCatalogVersionAdoptionsErrors[keyof ListCatalogVersionAdoptionsErrors];

export type ListCatalogVersionAdoptionsResponses = {
    /**
     * Catalog version adoptions
     */
    200: CatalogAdoptionList;
};

export type ListCatalogVersionAdoptionsResponse = ListCatalogVersionAdoptionsResponses[keyof ListCatalogVersionAdoptionsResponses];

export type UpgradeCatalogVersionAdoptionData = {
    body?: {
        consumerKey: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/agents/catalog/adoptions/upgrade';
};

export type UpgradeCatalogVersionAdoptionErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
    /**
     * Not found
     */
    404: CatalogErrorResult;
};

export type UpgradeCatalogVersionAdoptionError = UpgradeCatalogVersionAdoptionErrors[keyof UpgradeCatalogVersionAdoptionErrors];

export type UpgradeCatalogVersionAdoptionResponses = {
    /**
     * Catalog version adoption upgraded
     */
    200: CatalogAdoptionResult;
};

export type UpgradeCatalogVersionAdoptionResponse = UpgradeCatalogVersionAdoptionResponses[keyof UpgradeCatalogVersionAdoptionResponses];

export type RestoreCatalogItemVersionData = {
    body?: {
        reason?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/catalog/versions/{id}/restore';
};

export type RestoreCatalogItemVersionErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
    /**
     * Not found
     */
    404: CatalogErrorResult;
};

export type RestoreCatalogItemVersionError = RestoreCatalogItemVersionErrors[keyof RestoreCatalogItemVersionErrors];

export type RestoreCatalogItemVersionResponses = {
    /**
     * Catalog version restored
     */
    200: CatalogPromotionResponse;
};

export type RestoreCatalogItemVersionResponse = RestoreCatalogItemVersionResponses[keyof RestoreCatalogItemVersionResponses];

export type RejectCatalogCandidateData = {
    body?: {
        reason?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/catalog/candidates/{id}/reject';
};

export type RejectCatalogCandidateErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
    /**
     * Not found
     */
    404: CatalogErrorResult;
};

export type RejectCatalogCandidateError = RejectCatalogCandidateErrors[keyof RejectCatalogCandidateErrors];

export type RejectCatalogCandidateResponses = {
    /**
     * Rejected
     */
    200: CatalogCandidateResult;
};

export type RejectCatalogCandidateResponse = RejectCatalogCandidateResponses[keyof RejectCatalogCandidateResponses];

export type DeferCatalogCandidateData = {
    body?: {
        reason?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/catalog/candidates/{id}/defer';
};

export type DeferCatalogCandidateErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
    /**
     * Not found
     */
    404: CatalogErrorResult;
};

export type DeferCatalogCandidateError = DeferCatalogCandidateErrors[keyof DeferCatalogCandidateErrors];

export type DeferCatalogCandidateResponses = {
    /**
     * Deferred
     */
    200: CatalogCandidateResult;
};

export type DeferCatalogCandidateResponse = DeferCatalogCandidateResponses[keyof DeferCatalogCandidateResponses];

export type RetryCatalogCandidateReviewData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/catalog/candidates/{id}/retry-review';
};

export type RetryCatalogCandidateReviewErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
    /**
     * Not found
     */
    404: CatalogErrorResult;
};

export type RetryCatalogCandidateReviewError = RetryCatalogCandidateReviewErrors[keyof RetryCatalogCandidateReviewErrors];

export type RetryCatalogCandidateReviewResponses = {
    /**
     * Candidate review retried
     */
    200: CatalogRetryReviewResult;
};

export type RetryCatalogCandidateReviewResponse = RetryCatalogCandidateReviewResponses[keyof RetryCatalogCandidateReviewResponses];

export type PromoteCatalogCandidateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/agents/catalog/candidates/{id}/promote';
};

export type PromoteCatalogCandidateErrors = {
    /**
     * Bad request
     */
    400: CatalogErrorResult;
    /**
     * Policy not satisfied
     */
    403: CatalogErrorResult;
    /**
     * Not found
     */
    404: CatalogErrorResult;
};

export type PromoteCatalogCandidateError = PromoteCatalogCandidateErrors[keyof PromoteCatalogCandidateErrors];

export type PromoteCatalogCandidateResponses = {
    /**
     * Promoted
     */
    200: CatalogPromotionResponse;
};

export type PromoteCatalogCandidateResponse = PromoteCatalogCandidateResponses[keyof PromoteCatalogCandidateResponses];

export type ListWidgetsData = {
    body?: never;
    path?: never;
    query?: {
        category?: string;
        type?: string;
    };
    url: '/api/v1/workflows/outputs/widgets';
};

export type ListWidgetsResponses = {
    /**
     * Widget definitions
     */
    200: {
        data: Array<WorkflowOutputWidgetDefinition>;
    };
};

export type ListWidgetsResponse = ListWidgetsResponses[keyof ListWidgetsResponses];

export type CreateWidgetData = {
    body?: WorkflowOutputWidgetDefinitionCreate;
    path?: never;
    query?: never;
    url: '/api/v1/workflows/outputs/widgets';
};

export type CreateWidgetResponses = {
    /**
     * Widget created
     */
    201: {
        widget: WorkflowOutputWidgetDefinition;
    };
};

export type CreateWidgetResponse = CreateWidgetResponses[keyof CreateWidgetResponses];

export type GetWidgetData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/outputs/widgets/{id}';
};

export type GetWidgetErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetWidgetResponses = {
    /**
     * Widget definition
     */
    200: {
        widget: WorkflowOutputWidgetDefinition;
    };
};

export type GetWidgetResponse = GetWidgetResponses[keyof GetWidgetResponses];

export type ListPinnedWidgetsData = {
    body?: never;
    path?: never;
    query: {
        dashboardId: string;
    };
    url: '/api/v1/workflows/outputs/pinned-widgets';
};

export type ListPinnedWidgetsErrors = {
    /**
     * dashboardId required
     */
    400: unknown;
};

export type ListPinnedWidgetsResponses = {
    /**
     * Dashboard widgets
     */
    200: {
        data: Array<DashboardWidgetLegacy>;
    };
};

export type ListPinnedWidgetsResponse = ListPinnedWidgetsResponses[keyof ListPinnedWidgetsResponses];

export type PinWidgetData = {
    body?: PinWidgetBody;
    path?: never;
    query?: never;
    url: '/api/v1/workflows/outputs/pinned-widgets';
};

export type PinWidgetErrors = {
    /**
     * Dashboard not found in the caller organization
     */
    404: {
        error: {
            code: 'NOT_FOUND';
            message: string;
        };
    };
};

export type PinWidgetError = PinWidgetErrors[keyof PinWidgetErrors];

export type PinWidgetResponses = {
    /**
     * Widget pinned
     */
    201: {
        widget: DashboardWidgetLegacy;
    };
};

export type PinWidgetResponse = PinWidgetResponses[keyof PinWidgetResponses];

export type UnpinWidgetData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/outputs/pinned-widgets/{id}';
};

export type UnpinWidgetErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UnpinWidgetResponses = {
    /**
     * Widget unpinned
     */
    200: {
        success: boolean;
    };
};

export type UnpinWidgetResponse = UnpinWidgetResponses[keyof UnpinWidgetResponses];

export type UpdatePinnedWidgetData = {
    body?: UpdateDashboardWidgetBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/outputs/pinned-widgets/{id}';
};

export type UpdatePinnedWidgetErrors = {
    /**
     * No fields provided
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type UpdatePinnedWidgetResponses = {
    /**
     * Widget updated
     */
    200: {
        widget: DashboardWidgetLegacy;
    };
};

export type UpdatePinnedWidgetResponse = UpdatePinnedWidgetResponses[keyof UpdatePinnedWidgetResponses];

export type ListOutputPartKindsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/workflows/outputs/part-kinds';
};

export type ListOutputPartKindsResponses = {
    /**
     * Available output part kinds
     */
    200: {
        data: Array<OutputPartKind>;
    };
};

export type ListOutputPartKindsResponse = ListOutputPartKindsResponses[keyof ListOutputPartKindsResponses];

export type QueryOutputsData = {
    body?: never;
    path?: never;
    query?: {
        runId?: string;
        workflowId?: string;
        stepId?: string;
        kind?: string;
        title?: string;
        portType?: string;
        visibility?: string;
        sourceType?: string;
        projectId?: string;
        limit?: string;
    };
    url: '/api/v1/workflows/outputs';
};

export type QueryOutputsResponses = {
    /**
     * Filtered output parts
     */
    200: {
        data: Array<WorkOutputPart>;
    };
};

export type QueryOutputsResponse = QueryOutputsResponses[keyof QueryOutputsResponses];

export type GetLatestOutputData = {
    body?: never;
    path?: never;
    query?: {
        workflowId?: string;
        stepId?: string;
        kind?: string;
        portType?: string;
        projectId?: string;
    };
    url: '/api/v1/workflows/outputs/latest';
};

export type GetLatestOutputResponses = {
    /**
     * Latest output part
     */
    200: {
        output: WorkOutputPart | null;
    };
};

export type GetLatestOutputResponse = GetLatestOutputResponses[keyof GetLatestOutputResponses];

export type GetOutputMetricsData = {
    body?: never;
    path?: never;
    query?: {
        workflowId?: string;
        metricName?: string;
        from?: string;
        to?: string;
        limit?: string;
    };
    url: '/api/v1/workflows/outputs/metrics';
};

export type GetOutputMetricsResponses = {
    /**
     * Time-series metrics
     */
    200: {
        data: Array<OutputMetricPoint>;
    };
};

export type GetOutputMetricsResponse = GetOutputMetricsResponses[keyof GetOutputMetricsResponses];

export type GetOutputData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/outputs/{id}';
};

export type GetOutputErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetOutputResponses = {
    /**
     * Output part detail
     */
    200: {
        output: WorkOutputPart;
    };
};

export type GetOutputResponse = GetOutputResponses[keyof GetOutputResponses];

export type DownloadOutputData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/outputs/{id}/download';
};

export type DownloadOutputErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DownloadOutputResponses = {
    /**
     * File content, JSON payload, or redirect
     */
    200: {
        [key: string]: unknown;
    };
};

export type DownloadOutputResponse = DownloadOutputResponses[keyof DownloadOutputResponses];

export type GetPortTypeColorsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/workflows/port-types/colors';
};

export type GetPortTypeColorsResponses = {
    /**
     * Color map
     */
    200: PortTypeColorMap;
};

export type GetPortTypeColorsResponse = GetPortTypeColorsResponses[keyof GetPortTypeColorsResponses];

export type CheckPortCompatibilityData = {
    body?: never;
    path?: never;
    query: {
        source: string;
        target: string;
    };
    url: '/api/v1/workflows/port-types/compatibility/check';
};

export type CheckPortCompatibilityErrors = {
    /**
     * Missing params
     */
    400: unknown;
    /**
     * Unknown type
     */
    404: unknown;
};

export type CheckPortCompatibilityResponses = {
    /**
     * Compatibility result
     */
    200: PortCompatibilityResult;
};

export type CheckPortCompatibilityResponse = CheckPortCompatibilityResponses[keyof CheckPortCompatibilityResponses];

export type ListPortTypesData = {
    body?: never;
    path?: never;
    query?: {
        category?: 'primitive' | 'collection' | 'json' | 'domain';
    };
    url: '/api/v1/workflows/port-types';
};

export type ListPortTypesErrors = {
    /**
     * Invalid category
     */
    400: unknown;
};

export type ListPortTypesResponses = {
    /**
     * Port type list
     */
    200: Array<PortTypeDefinition>;
};

export type ListPortTypesResponse = ListPortTypesResponses[keyof ListPortTypesResponses];

export type GetPortTypeData = {
    body?: never;
    path: {
        name: string;
    };
    query?: never;
    url: '/api/v1/workflows/port-types/{name}';
};

export type GetPortTypeErrors = {
    /**
     * Type not found
     */
    404: unknown;
};

export type GetPortTypeResponses = {
    /**
     * Port type detail
     */
    200: PortTypeDefinition;
};

export type GetPortTypeResponse = GetPortTypeResponses[keyof GetPortTypeResponses];

export type ListDocumentsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/documents';
};

export type ListDocumentsResponses = {
    /**
     * Document list
     */
    200: {
        data: Array<WorkflowDocument>;
    };
};

export type ListDocumentsResponse = ListDocumentsResponses[keyof ListDocumentsResponses];

export type UploadDocumentData = {
    body?: WorkflowDocumentUpload;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/documents';
};

export type UploadDocumentResponses = {
    /**
     * Document uploaded
     */
    201: {
        document: WorkflowDocument;
    };
};

export type UploadDocumentResponse = UploadDocumentResponses[keyof UploadDocumentResponses];

export type DeleteDocumentData = {
    body?: never;
    path: {
        id: string;
        docId: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/documents/{docId}';
};

export type DeleteDocumentResponses = {
    /**
     * Document deleted
     */
    200: {
        success: boolean;
    };
};

export type DeleteDocumentResponse = DeleteDocumentResponses[keyof DeleteDocumentResponses];

export type GetDocumentData = {
    body?: never;
    path: {
        id: string;
        docId: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/documents/{docId}';
};

export type GetDocumentResponses = {
    /**
     * Document detail
     */
    200: {
        document: WorkflowDocument;
    };
};

export type GetDocumentResponse = GetDocumentResponses[keyof GetDocumentResponses];

export type SetWorkflowRuntimePolicyData = {
    body?: RuntimePolicyAssignment;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/runtime-policy';
};

export type SetWorkflowRuntimePolicyErrors = {
    /**
     * The workflow surface does not allow this policy
     */
    400: unknown;
    /**
     * No such workflow in this organization
     */
    404: unknown;
};

export type SetWorkflowRuntimePolicyResponses = {
    /**
     * The policy the workflow’s steps run under, set
     */
    200: RuntimePolicyAssignment;
};

export type SetWorkflowRuntimePolicyResponse = SetWorkflowRuntimePolicyResponses[keyof SetWorkflowRuntimePolicyResponses];

export type ExportInstructionsData = {
    body?: InstructionExportBody;
    path?: never;
    query?: never;
    url: '/api/v1/workflows/instructions/export';
};

export type ExportInstructionsResponses = {
    /**
     * Exported instructions
     */
    200: InstructionExportResult;
};

export type ExportInstructionsResponse = ExportInstructionsResponses[keyof ExportInstructionsResponses];

export type ListWorkflowsData = {
    body?: never;
    path?: never;
    query?: {
        category?: string;
        status?: string;
        limit?: number;
        before?: string;
        after?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'name';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
    };
    url: '/api/v1/workflows';
};

export type ListWorkflowsResponses = {
    /**
     * Workflow list (paginated)
     */
    200: WorkflowDefinitionList;
};

export type ListWorkflowsResponse = ListWorkflowsResponses[keyof ListWorkflowsResponses];

export type CreateWorkflowData = {
    body?: WorkflowCreate;
    path?: never;
    query?: never;
    url: '/api/v1/workflows';
};

export type CreateWorkflowResponses = {
    /**
     * Workflow created
     */
    201: WorkflowTemplateResult;
};

export type CreateWorkflowResponse = CreateWorkflowResponses[keyof CreateWorkflowResponses];

export type ExportWorkflowInstructionsData = {
    body?: {
        stepIds?: Array<string>;
        scope: 'full' | 'selected' | 'blank';
        includeRoles?: boolean;
        includeOutputSchemas?: boolean;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/instructions/export';
};

export type ExportWorkflowInstructionsResponses = {
    /**
     * Exported workflow instructions
     */
    200: InstructionExportResult;
};

export type ExportWorkflowInstructionsResponse = ExportWorkflowInstructionsResponses[keyof ExportWorkflowInstructionsResponses];

export type RestoreWorkflowData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/restore';
};

export type RestoreWorkflowErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RestoreWorkflowResponses = {
    /**
     * Workflow restored
     */
    200: WorkflowTemplateResult;
};

export type RestoreWorkflowResponse = RestoreWorkflowResponses[keyof RestoreWorkflowResponses];

export type ValidateWorkflowData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/validate';
};

export type ValidateWorkflowErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ValidateWorkflowResponses = {
    /**
     * Validation result
     */
    200: WorkflowValidationResult;
};

export type ValidateWorkflowResponse = ValidateWorkflowResponses[keyof ValidateWorkflowResponses];

export type ReorderWorkflowStepsData = {
    body?: StepReorderBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/steps/reorder';
};

export type ReorderWorkflowStepsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ReorderWorkflowStepsResponses = {
    /**
     * Steps reordered
     */
    200: WorkflowTemplateResult;
};

export type ReorderWorkflowStepsResponse = ReorderWorkflowStepsResponses[keyof ReorderWorkflowStepsResponses];

export type AddWorkflowStepData = {
    body?: WorkflowStepInput;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/steps';
};

export type AddWorkflowStepErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type AddWorkflowStepResponses = {
    /**
     * Step added
     */
    200: {
        template: {
            steps: Array<WorkflowStep>;
            [key: string]: unknown;
        };
    };
};

export type AddWorkflowStepResponse = AddWorkflowStepResponses[keyof AddWorkflowStepResponses];

export type RemoveWorkflowStepData = {
    body?: never;
    path: {
        id: string;
        stepId: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/steps/{stepId}';
};

export type RemoveWorkflowStepErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RemoveWorkflowStepResponses = {
    /**
     * Step removed
     */
    200: WorkflowTemplateResult;
};

export type RemoveWorkflowStepResponse = RemoveWorkflowStepResponses[keyof RemoveWorkflowStepResponses];

export type UpdateWorkflowStepData = {
    body?: WorkflowStepInput;
    path: {
        id: string;
        stepId: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/steps/{stepId}';
};

export type UpdateWorkflowStepErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateWorkflowStepResponses = {
    /**
     * Step updated
     */
    200: WorkflowTemplateResult;
};

export type UpdateWorkflowStepResponse = UpdateWorkflowStepResponses[keyof UpdateWorkflowStepResponses];

export type SetWorkflowScheduleData = {
    body?: WorkflowScheduleBody;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/schedule';
};

export type SetWorkflowScheduleResponses = {
    /**
     * Schedule updated
     */
    200: WorkflowTemplateResult;
};

export type SetWorkflowScheduleResponse = SetWorkflowScheduleResponses[keyof SetWorkflowScheduleResponses];

export type ListWorkflowExecutionObservationsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        stepId?: string;
        limit?: number;
    };
    url: '/api/v1/workflows/{id}/execution-observations';
};

export type ListWorkflowExecutionObservationsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListWorkflowExecutionObservationsResponses = {
    /**
     * Execution-derived schema observations
     */
    200: WorkflowExecutionObservationList;
};

export type ListWorkflowExecutionObservationsResponse = ListWorkflowExecutionObservationsResponses[keyof ListWorkflowExecutionObservationsResponses];

export type ListWorkflowRunsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/runs';
};

export type ListWorkflowRunsResponses = {
    /**
     * Run history
     */
    200: WorkflowRunList;
};

export type ListWorkflowRunsResponse = ListWorkflowRunsResponses[keyof ListWorkflowRunsResponses];

export type TriggerWorkflowData = {
    body?: {
        context?: {
            [key: string]: unknown;
        };
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/trigger';
};

export type TriggerWorkflowErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type TriggerWorkflowResponses = {
    /**
     * Workflow triggered
     */
    200: WorkflowDefinitionTriggerResult;
};

export type TriggerWorkflowResponse = TriggerWorkflowResponses[keyof TriggerWorkflowResponses];

export type ListWorkflowVersionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: number;
    };
    url: '/api/v1/workflows/{id}/versions';
};

export type ListWorkflowVersionsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListWorkflowVersionsResponses = {
    /**
     * Workflow version history
     */
    200: WorkflowVersionList;
};

export type ListWorkflowVersionsResponse = ListWorkflowVersionsResponses[keyof ListWorkflowVersionsResponses];

export type GetWorkflowVersionData = {
    body?: never;
    path: {
        id: string;
        version: number;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/versions/{version}';
};

export type GetWorkflowVersionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetWorkflowVersionResponses = {
    /**
     * Workflow version snapshot
     */
    200: WorkflowVersionResult;
};

export type GetWorkflowVersionResponse = GetWorkflowVersionResponses[keyof GetWorkflowVersionResponses];

export type DiffWorkflowVersionsData = {
    body?: never;
    path: {
        id: string;
        versionA: number;
        versionB: number;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/versions/{versionA}/diff/{versionB}';
};

export type DiffWorkflowVersionsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DiffWorkflowVersionsResponses = {
    /**
     * Workflow version diff
     */
    200: WorkflowVersionDiffResult;
};

export type DiffWorkflowVersionsResponse = DiffWorkflowVersionsResponses[keyof DiffWorkflowVersionsResponses];

export type RestoreWorkflowVersionData = {
    body?: never;
    path: {
        id: string;
        version: number;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/versions/{version}/restore';
};

export type RestoreWorkflowVersionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RestoreWorkflowVersionResponses = {
    /**
     * Workflow restored from version
     */
    200: WorkflowTemplateResult;
};

export type RestoreWorkflowVersionResponse = RestoreWorkflowVersionResponses[keyof RestoreWorkflowVersionResponses];

export type SaveWorkflowDefinitionGraphData = {
    body?: WorkflowGraphSave;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/graph';
};

export type SaveWorkflowDefinitionGraphErrors = {
    /**
     * Cycle or invalid edge endpoint detected
     */
    400: unknown;
    /**
     * Workflow not found
     */
    404: unknown;
    /**
     * Version conflict
     */
    409: unknown;
};

export type SaveWorkflowDefinitionGraphResponses = {
    /**
     * Graph saved — returns the full workflow definition with updated steps and edges
     */
    200: WorkflowTemplateResult;
};

export type SaveWorkflowDefinitionGraphResponse = SaveWorkflowDefinitionGraphResponses[keyof SaveWorkflowDefinitionGraphResponses];

export type ArchiveWorkflowData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}';
};

export type ArchiveWorkflowResponses = {
    /**
     * Workflow archived
     */
    200: {
        success: boolean;
    };
};

export type ArchiveWorkflowResponse = ArchiveWorkflowResponses[keyof ArchiveWorkflowResponses];

export type GetWorkflowData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}';
};

export type GetWorkflowErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetWorkflowResponses = {
    /**
     * Workflow detail
     */
    200: WorkflowTemplateResult;
};

export type GetWorkflowResponse = GetWorkflowResponses[keyof GetWorkflowResponses];

export type UpdateWorkflowData = {
    body?: WorkflowUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}';
};

export type UpdateWorkflowErrors = {
    /**
     * Conflict
     */
    409: unknown;
};

export type UpdateWorkflowResponses = {
    /**
     * Workflow updated
     */
    200: WorkflowTemplateResult;
};

export type UpdateWorkflowResponse = UpdateWorkflowResponses[keyof UpdateWorkflowResponses];

export type GetWorkflowCloseSummaryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/close-summary';
};

export type GetWorkflowCloseSummaryErrors = {
    /**
     * Workflow not found
     */
    404: unknown;
};

export type GetWorkflowCloseSummaryResponses = {
    /**
     * Close summary markdown (null when workflow is not conversation-sourced)
     */
    200: WorkflowCloseSummary;
};

export type GetWorkflowCloseSummaryResponse = GetWorkflowCloseSummaryResponses[keyof GetWorkflowCloseSummaryResponses];

export type ListWorkflowInstancesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/workflow-instances';
};

export type ListWorkflowInstancesResponses = {
    /**
     * Workflow instances for the org
     */
    200: WorkflowInstanceList;
};

export type ListWorkflowInstancesResponse = ListWorkflowInstancesResponses[keyof ListWorkflowInstancesResponses];

export type CreateWorkflowInstanceData = {
    body?: WorkflowInstanceCreate;
    path?: never;
    query?: never;
    url: '/api/v1/workflow-instances';
};

export type CreateWorkflowInstanceResponses = {
    /**
     * Workflow instance created
     */
    201: WorkflowInstanceResult;
};

export type CreateWorkflowInstanceResponse = CreateWorkflowInstanceResponses[keyof CreateWorkflowInstanceResponses];

export type GetWorkflowInstanceData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/workflow-instances/{id}';
};

export type GetWorkflowInstanceErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetWorkflowInstanceResponses = {
    /**
     * Workflow instance
     */
    200: WorkflowInstanceResult;
};

export type GetWorkflowInstanceResponse = GetWorkflowInstanceResponses[keyof GetWorkflowInstanceResponses];

export type UpdateWorkflowInstanceData = {
    body?: WorkflowInstanceUpdate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/workflow-instances/{id}';
};

export type UpdateWorkflowInstanceErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateWorkflowInstanceResponses = {
    /**
     * Workflow instance updated
     */
    200: WorkflowInstanceResult;
};

export type UpdateWorkflowInstanceResponse = UpdateWorkflowInstanceResponses[keyof UpdateWorkflowInstanceResponses];

export type TriggerWorkflowInstanceData = {
    body?: {
        context?: {
            [key: string]: unknown;
        };
    };
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/workflow-instances/{id}/trigger';
};

export type TriggerWorkflowInstanceErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type TriggerWorkflowInstanceResponses = {
    /**
     * Run triggered
     */
    200: WorkflowInstanceTriggerResult;
};

export type TriggerWorkflowInstanceResponse = TriggerWorkflowInstanceResponses[keyof TriggerWorkflowInstanceResponses];

export type SearchWorkflowDefinitionsData = {
    body?: never;
    path?: never;
    query: {
        q: string;
        limit?: number;
    };
    url: '/api/v1/workflow-definitions/search';
};

export type SearchWorkflowDefinitionsResponses = {
    /**
     * Ranked workflow definition search results
     */
    200: {
        data: Array<WorkflowDefinitionSearchResult>;
        query: string;
        total: number;
        searchType: 'keyword' | 'semantic' | 'hybrid';
    };
};

export type SearchWorkflowDefinitionsResponse = SearchWorkflowDefinitionsResponses[keyof SearchWorkflowDefinitionsResponses];

export type RecommendWorkflowDefinitionsData = {
    body?: never;
    path?: never;
    query: {
        stepDescription: string;
        workflowCategory?: string;
        limit?: number;
    };
    url: '/api/v1/workflow-definitions/recommend';
};

export type RecommendWorkflowDefinitionsResponses = {
    /**
     * Recommended workflow definitions for a given step description
     */
    200: {
        data: Array<WorkflowDefinitionSearchResult>;
        total: number;
    };
};

export type RecommendWorkflowDefinitionsResponse = RecommendWorkflowDefinitionsResponses[keyof RecommendWorkflowDefinitionsResponses];

export type ListOrganizationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/organizations';
};

export type ListOrganizationsResponses = {
    /**
     * User organizations
     */
    200: {
        success: boolean;
        organizations: Array<Organization>;
    };
};

export type ListOrganizationsResponse = ListOrganizationsResponses[keyof ListOrganizationsResponses];

export type CreateOrganizationData = {
    body?: OrganizationCreate;
    path?: never;
    query?: never;
    url: '/api/v1/organizations';
};

export type CreateOrganizationErrors = {
    /**
     * Slug already exists
     */
    409: unknown;
};

export type CreateOrganizationResponses = {
    /**
     * Organization created with founder invitation
     */
    201: {
        success: boolean;
        organization: Organization;
        invitationToken: string;
    };
};

export type CreateOrganizationResponse = CreateOrganizationResponses[keyof CreateOrganizationResponses];

export type GetMyOrganizationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/organizations/me';
};

export type GetMyOrganizationsResponses = {
    /**
     * Organizations the current user belongs to
     */
    200: {
        data: Array<UserOrg>;
    };
};

export type GetMyOrganizationsResponse = GetMyOrganizationsResponses[keyof GetMyOrganizationsResponses];

export type GetOrganizationData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/organizations/{id}';
};

export type GetOrganizationErrors = {
    /**
     * Access denied — not a member of this organization
     */
    403: unknown;
    /**
     * Organization not found
     */
    404: unknown;
};

export type GetOrganizationResponses = {
    /**
     * Organization detail — full graph including features, modules, and counts
     */
    200: {
        success: boolean;
        organization: Organization;
    };
};

export type GetOrganizationResponse = GetOrganizationResponses[keyof GetOrganizationResponses];

export type UpdateOrganizationData = {
    body?: OrganizationUpdate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/organizations/{id}';
};

export type UpdateOrganizationErrors = {
    /**
     * Unknown feature key or module slug
     */
    400: unknown;
    /**
     * Organization not found
     */
    404: unknown;
};

export type UpdateOrganizationResponses = {
    /**
     * Organization updated
     */
    200: {
        success: boolean;
        organization: Organization;
    };
};

export type UpdateOrganizationResponse = UpdateOrganizationResponses[keyof UpdateOrganizationResponses];

export type ListOrgMembersData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/members';
};

export type ListOrgMembersErrors = {
    /**
     * Access denied — not a member of this organization
     */
    403: unknown;
};

export type ListOrgMembersResponses = {
    /**
     * Organization members
     */
    200: {
        success: boolean;
        members: Array<OrgMemberSummary>;
    };
};

export type ListOrgMembersResponse = ListOrgMembersResponses[keyof ListOrgMembersResponses];

export type AddOrgMemberData = {
    body?: AddMemberBody;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/members';
};

export type AddOrgMemberErrors = {
    /**
     * Missing userId
     */
    400: unknown;
    /**
     * Access denied — not a member of this organization
     */
    403: unknown;
    /**
     * Organization not found
     */
    404: unknown;
};

export type AddOrgMemberResponses = {
    /**
     * Member added
     */
    201: {
        success: boolean;
        member: OrgMember;
    };
};

export type AddOrgMemberResponse = AddOrgMemberResponses[keyof AddOrgMemberResponses];

export type AcknowledgeOrgModuleData = {
    body?: RegulatoryAckRequest;
    path: {
        id: number;
        moduleId: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/modules/{moduleId}/acknowledge';
};

export type AcknowledgeOrgModuleErrors = {
    /**
     * Module does not require an ack of this kind
     */
    400: unknown;
    /**
     * Module not found
     */
    404: unknown;
};

export type AcknowledgeOrgModuleResponses = {
    /**
     * Acknowledgement recorded; returns any acks still outstanding for this module
     */
    200: RegulatoryAckResult;
};

export type AcknowledgeOrgModuleResponse = AcknowledgeOrgModuleResponses[keyof AcknowledgeOrgModuleResponses];

export type ListTeamsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/teams';
};

export type ListTeamsResponses = {
    /**
     * Team list
     */
    200: {
        success: boolean;
        teams: Array<Team>;
    };
};

export type ListTeamsResponse = ListTeamsResponses[keyof ListTeamsResponses];

export type CreateTeamData = {
    body?: TeamCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/organizations/{id}/teams';
};

export type CreateTeamErrors = {
    /**
     * Missing name
     */
    400: unknown;
    /**
     * Access denied — not a member of this organization
     */
    403: unknown;
    /**
     * Org not found
     */
    404: unknown;
};

export type CreateTeamResponses = {
    /**
     * Team created
     */
    201: {
        success: boolean;
        team: Team;
    };
};

export type CreateTeamResponse = CreateTeamResponses[keyof CreateTeamResponses];

export type GetMyTeamsInOrgData = {
    body?: never;
    path: {
        orgId: string;
    };
    query?: never;
    url: '/api/v1/organizations/{orgId}/teams/@me';
};

export type GetMyTeamsInOrgResponses = {
    /**
     * Current user teams in org
     */
    200: {
        data: Array<UserOrgTeam>;
    };
};

export type GetMyTeamsInOrgResponse = GetMyTeamsInOrgResponses[keyof GetMyTeamsInOrgResponses];

export type ListTeamMembersData = {
    body?: never;
    path: {
        teamId: string;
    };
    query?: never;
    url: '/api/v1/organizations/teams/{teamId}/members';
};

export type ListTeamMembersErrors = {
    /**
     * Team not found
     */
    404: unknown;
};

export type ListTeamMembersResponses = {
    /**
     * Team members
     */
    200: {
        success: boolean;
        members: Array<TeamMember>;
    };
};

export type ListTeamMembersResponse = ListTeamMembersResponses[keyof ListTeamMembersResponses];

export type AddTeamMemberData = {
    body?: {
        userId: number;
        role?: string;
    };
    path: {
        teamId: string;
    };
    query?: never;
    url: '/api/v1/organizations/teams/{teamId}/members';
};

export type AddTeamMemberErrors = {
    /**
     * Missing userId
     */
    400: unknown;
    /**
     * Team not found
     */
    404: unknown;
};

export type AddTeamMemberResponses = {
    /**
     * Member added
     */
    201: {
        success: boolean;
        member: TeamMember;
    };
};

export type AddTeamMemberResponse = AddTeamMemberResponses[keyof AddTeamMemberResponses];

export type RemoveTeamMemberData = {
    body?: never;
    path: {
        teamId: string;
        userId: string;
    };
    query?: never;
    url: '/api/v1/organizations/teams/{teamId}/members/{userId}';
};

export type RemoveTeamMemberErrors = {
    /**
     * Team not found
     */
    404: unknown;
};

export type RemoveTeamMemberResponses = {
    /**
     * Member removed
     */
    200: {
        success: boolean;
        message: string;
    };
};

export type RemoveTeamMemberResponse = RemoveTeamMemberResponses[keyof RemoveTeamMemberResponses];

export type ListOrgInvitationsData = {
    body?: never;
    path: {
        orgId: string;
    };
    query?: never;
    url: '/api/v1/organizations/{orgId}/invitations';
};

export type ListOrgInvitationsErrors = {
    /**
     * Forbidden — caller may only list their own organization's invitations
     */
    403: unknown;
};

export type ListOrgInvitationsResponses = {
    /**
     * Org invitations
     */
    200: {
        data: Array<Invitation>;
    };
};

export type ListOrgInvitationsResponse = ListOrgInvitationsResponses[keyof ListOrgInvitationsResponses];

export type CreateInvitationData = {
    body?: InvitationCreate;
    path: {
        orgId: string;
    };
    query?: never;
    url: '/api/v1/organizations/{orgId}/invitations';
};

export type CreateInvitationErrors = {
    /**
     * Invalid role
     */
    400: unknown;
    /**
     * Forbidden — caller may only invite into their own organization
     */
    403: unknown;
    /**
     * Duplicate or already member
     */
    409: unknown;
};

export type CreateInvitationResponses = {
    /**
     * Invitation created
     */
    201: Invitation;
};

export type CreateInvitationResponse = CreateInvitationResponses[keyof CreateInvitationResponses];

export type ListAnalysisTemplatesData = {
    body?: never;
    path?: never;
    query?: {
        platform?: string;
        category?: string;
    };
    url: '/api/v1/intel/analysis/templates';
};

export type ListAnalysisTemplatesResponses = {
    /**
     * Template list
     */
    200: IntelAnalysisTemplateList;
};

export type ListAnalysisTemplatesResponse = ListAnalysisTemplatesResponses[keyof ListAnalysisTemplatesResponses];

export type CreateAnalysisTemplateData = {
    body?: IntelAnalysisTemplateCreate;
    path?: never;
    query?: never;
    url: '/api/v1/intel/analysis/templates';
};

export type CreateAnalysisTemplateErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type CreateAnalysisTemplateResponses = {
    /**
     * Created
     */
    201: IntelAnalysisTemplate;
};

export type CreateAnalysisTemplateResponse = CreateAnalysisTemplateResponses[keyof CreateAnalysisTemplateResponses];

export type DeleteAnalysisTemplateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/intel/analysis/templates/{id}';
};

export type DeleteAnalysisTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * System template
     */
    409: unknown;
};

export type DeleteAnalysisTemplateResponses = {
    /**
     * Deleted
     */
    200: IntelAnalysisTemplateActionResult;
};

export type DeleteAnalysisTemplateResponse = DeleteAnalysisTemplateResponses[keyof DeleteAnalysisTemplateResponses];

export type GetAnalysisTemplateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/intel/analysis/templates/{id}';
};

export type GetAnalysisTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetAnalysisTemplateResponses = {
    /**
     * Template detail
     */
    200: IntelAnalysisTemplate;
};

export type GetAnalysisTemplateResponse = GetAnalysisTemplateResponses[keyof GetAnalysisTemplateResponses];

export type UpdateAnalysisTemplateData = {
    body?: IntelAnalysisTemplateUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/intel/analysis/templates/{id}';
};

export type UpdateAnalysisTemplateErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateAnalysisTemplateResponses = {
    /**
     * Updated
     */
    200: IntelAnalysisTemplate;
};

export type UpdateAnalysisTemplateResponse = UpdateAnalysisTemplateResponses[keyof UpdateAnalysisTemplateResponses];

export type CloneAnalysisTemplateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/intel/analysis/templates/{id}/clone';
};

export type CloneAnalysisTemplateErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type CloneAnalysisTemplateResponses = {
    /**
     * Cloned
     */
    201: IntelAnalysisTemplate;
};

export type CloneAnalysisTemplateResponse = CloneAnalysisTemplateResponses[keyof CloneAnalysisTemplateResponses];

export type ListIntelPlatformsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/intel/sources/platforms';
};

export type ListIntelPlatformsResponses = {
    /**
     * Platform list
     */
    200: IntelPlatformList;
};

export type ListIntelPlatformsResponse = ListIntelPlatformsResponses[keyof ListIntelPlatformsResponses];

export type CreateIntelPlatformData = {
    body?: IntelPlatformCreate;
    path?: never;
    query?: never;
    url: '/api/v1/intel/sources/platforms';
};

export type CreateIntelPlatformResponses = {
    /**
     * Created
     */
    201: IntelPlatform;
};

export type CreateIntelPlatformResponse = CreateIntelPlatformResponses[keyof CreateIntelPlatformResponses];

export type TestIntelPlatformData = {
    body?: never;
    path: {
        slug: string;
    };
    query?: never;
    url: '/api/v1/intel/sources/platforms/{slug}/test';
};

export type TestIntelPlatformErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type TestIntelPlatformResponses = {
    /**
     * Connection test result
     */
    200: IntelPlatformTestResult;
};

export type TestIntelPlatformResponse = TestIntelPlatformResponses[keyof TestIntelPlatformResponses];

export type GetIntelPlatformUsageData = {
    body?: never;
    path: {
        slug: string;
    };
    query?: never;
    url: '/api/v1/intel/sources/platforms/{slug}/usage';
};

export type GetIntelPlatformUsageErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetIntelPlatformUsageResponses = {
    /**
     * Usage stats
     */
    200: IntelPlatformUsageResult;
};

export type GetIntelPlatformUsageResponse = GetIntelPlatformUsageResponses[keyof GetIntelPlatformUsageResponses];

export type UpdateIntelPlatformData = {
    body?: IntelPlatformUpdate;
    path: {
        slug: string;
    };
    query?: never;
    url: '/api/v1/intel/sources/platforms/{slug}';
};

export type UpdateIntelPlatformErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateIntelPlatformResponses = {
    /**
     * Updated
     */
    200: IntelPlatform;
};

export type UpdateIntelPlatformResponse = UpdateIntelPlatformResponses[keyof UpdateIntelPlatformResponses];

export type ListIntelSourcesData = {
    body?: never;
    path?: never;
    query?: {
        platform?: string;
        category?: string;
        active?: boolean | null;
        approvalStatus?: 'seeded' | 'approved' | 'candidate' | 'rejected';
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/intel/sources';
};

export type ListIntelSourcesResponses = {
    /**
     * Intel source list
     */
    200: {
        data: Array<IntelSource>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListIntelSourcesResponse = ListIntelSourcesResponses[keyof ListIntelSourcesResponses];

export type CreateIntelSourceData = {
    body?: IntelSourceCreate;
    path?: never;
    query?: never;
    url: '/api/v1/intel/sources';
};

export type CreateIntelSourceErrors = {
    /**
     * Organization context is required
     */
    400: IntelSourceError;
    /**
     * Already exists
     */
    409: unknown;
};

export type CreateIntelSourceError = CreateIntelSourceErrors[keyof CreateIntelSourceErrors];

export type CreateIntelSourceResponses = {
    /**
     * Created
     */
    201: IntelSource;
};

export type CreateIntelSourceResponse = CreateIntelSourceResponses[keyof CreateIntelSourceResponses];

export type DiscoverIntelSourceData = {
    body?: IntelSourceDiscoverRequest;
    path?: never;
    query?: never;
    url: '/api/v1/intel/sources/discover';
};

export type DiscoverIntelSourceResponses = {
    /**
     * Discovery result
     */
    200: {
        found: boolean;
        queued?: boolean;
        requestId?: string;
        error?: string;
    };
};

export type DiscoverIntelSourceResponse = DiscoverIntelSourceResponses[keyof DiscoverIntelSourceResponses];

export type BulkCreateIntelSourcesData = {
    body?: {
        items: Array<IntelSourceCreate>;
    };
    path?: never;
    query?: never;
    url: '/api/v1/intel/sources/bulk';
};

export type BulkCreateIntelSourcesErrors = {
    /**
     * Organization context is required
     */
    400: IntelSourceError;
};

export type BulkCreateIntelSourcesError = BulkCreateIntelSourcesErrors[keyof BulkCreateIntelSourcesErrors];

export type BulkCreateIntelSourcesResponses = {
    /**
     * Bulk create result
     */
    201: {
        created: Array<IntelSource>;
        errors: Array<{
            handle: string;
            error: string;
        }>;
    };
};

export type BulkCreateIntelSourcesResponse = BulkCreateIntelSourcesResponses[keyof BulkCreateIntelSourcesResponses];

export type BatchFetchIntelSourcesData = {
    body?: IntelSourceBatchFetchRequest;
    path?: never;
    query?: never;
    url: '/api/v1/intel/sources/batch-fetch';
};

export type BatchFetchIntelSourcesResponses = {
    /**
     * Batch enqueue results
     */
    202: IntelSourceBatchFetchResult;
};

export type BatchFetchIntelSourcesResponse = BatchFetchIntelSourcesResponses[keyof BatchFetchIntelSourcesResponses];

export type BatchDeactivateIntelSourcesData = {
    body?: {
        ids: Array<number>;
    };
    path?: never;
    query?: never;
    url: '/api/v1/intel/sources/batch-deactivate';
};

export type BatchDeactivateIntelSourcesResponses = {
    /**
     * Batch deactivate result
     */
    200: {
        updated_count: number;
    };
};

export type BatchDeactivateIntelSourcesResponse = BatchDeactivateIntelSourcesResponses[keyof BatchDeactivateIntelSourcesResponses];

export type DeleteIntelSourceData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/sources/{id}';
};

export type DeleteIntelSourceErrors = {
    /**
     * Not found
     */
    404: IntelSourceError;
};

export type DeleteIntelSourceError = DeleteIntelSourceErrors[keyof DeleteIntelSourceErrors];

export type DeleteIntelSourceResponses = {
    /**
     * Deleted
     */
    200: {
        message: string;
    };
};

export type DeleteIntelSourceResponse = DeleteIntelSourceResponses[keyof DeleteIntelSourceResponses];

export type GetIntelSourceData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/sources/{id}';
};

export type GetIntelSourceErrors = {
    /**
     * Not found
     */
    404: IntelSourceError;
};

export type GetIntelSourceError = GetIntelSourceErrors[keyof GetIntelSourceErrors];

export type GetIntelSourceResponses = {
    /**
     * Intel source
     */
    200: IntelSource;
};

export type GetIntelSourceResponse = GetIntelSourceResponses[keyof GetIntelSourceResponses];

export type UpdateIntelSourceData = {
    body?: IntelSourceUpdate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/sources/{id}';
};

export type UpdateIntelSourceErrors = {
    /**
     * Not found
     */
    404: IntelSourceError;
};

export type UpdateIntelSourceError = UpdateIntelSourceErrors[keyof UpdateIntelSourceErrors];

export type UpdateIntelSourceResponses = {
    /**
     * Updated
     */
    200: IntelSource;
};

export type UpdateIntelSourceResponse = UpdateIntelSourceResponses[keyof UpdateIntelSourceResponses];

export type FetchIntelSourceData = {
    body?: IntelSourceFetchRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/sources/{id}/fetch';
};

export type FetchIntelSourceErrors = {
    /**
     * Not found or no subscription
     */
    404: unknown;
    /**
     * Fetch already in progress
     */
    409: unknown;
};

export type FetchIntelSourceResponses = {
    /**
     * Fetch enqueued
     */
    202: IntelSourceSubscriptionEnqueueResult;
};

export type FetchIntelSourceResponse = FetchIntelSourceResponses[keyof FetchIntelSourceResponses];

export type GetIntelSourceHarvestedData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        limit?: number;
        data_type?: 'content' | 'event' | 'metric' | 'signal_raw';
    };
    url: '/api/v1/intel/sources/{id}/harvested';
};

export type GetIntelSourceHarvestedErrors = {
    /**
     * Not found
     */
    404: IntelSourceError;
};

export type GetIntelSourceHarvestedError = GetIntelSourceHarvestedErrors[keyof GetIntelSourceHarvestedErrors];

export type GetIntelSourceHarvestedResponses = {
    /**
     * Intel source data
     */
    200: {
        data: Array<IntelSourceData>;
        total: number;
    };
};

export type GetIntelSourceHarvestedResponse = GetIntelSourceHarvestedResponses[keyof GetIntelSourceHarvestedResponses];

export type CreateIntelSourceSubscriptionData = {
    body?: IntelSourceSubscriptionCreate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/sources/{id}/subscriptions';
};

export type CreateIntelSourceSubscriptionErrors = {
    /**
     * Intel source not found
     */
    404: unknown;
    /**
     * Subscription already exists
     */
    409: unknown;
};

export type CreateIntelSourceSubscriptionResponses = {
    /**
     * Subscription created
     */
    201: IntelSourceSubscription;
};

export type CreateIntelSourceSubscriptionResponse = CreateIntelSourceSubscriptionResponses[keyof CreateIntelSourceSubscriptionResponses];

export type ReviewIntelSourceApprovalData = {
    body?: IntelSourceApprovalRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/sources/{id}/approval';
};

export type ReviewIntelSourceApprovalErrors = {
    /**
     * Intel source not found
     */
    404: unknown;
    /**
     * Source is not in candidate status
     */
    409: unknown;
};

export type ReviewIntelSourceApprovalResponses = {
    /**
     * Approval decision recorded
     */
    200: IntelSourceApprovalResult;
};

export type ReviewIntelSourceApprovalResponse = ReviewIntelSourceApprovalResponses[keyof ReviewIntelSourceApprovalResponses];

export type RecordIntelSourceConsentData = {
    body?: IntelSourceConsentRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/sources/{id}/consent';
};

export type RecordIntelSourceConsentErrors = {
    /**
     * A licence or permission without its reference
     */
    400: unknown;
    /**
     * Intel source not found
     */
    404: unknown;
};

export type RecordIntelSourceConsentResponses = {
    /**
     * Consent recorded
     */
    200: IntelSourceConsent;
};

export type RecordIntelSourceConsentResponse = RecordIntelSourceConsentResponses[keyof RecordIntelSourceConsentResponses];

export type CreateIntelSourceMonitorData = {
    body?: IntelSourceMonitorCreate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/sources/{id}/monitors';
};

export type CreateIntelSourceMonitorErrors = {
    /**
     * Invalid request / policy
     */
    400: unknown;
    /**
     * Intel source not found
     */
    404: unknown;
};

export type CreateIntelSourceMonitorResponses = {
    /**
     * Monitor created
     */
    201: IntelSourceMonitor;
};

export type CreateIntelSourceMonitorResponse = CreateIntelSourceMonitorResponses[keyof CreateIntelSourceMonitorResponses];

export type ListIntelSourceItemInsightsData = {
    body?: never;
    path: {
        id: number;
        dataId: number;
    };
    query?: never;
    url: '/api/v1/intel/sources/{id}/data/{dataId}/insights';
};

export type ListIntelSourceItemInsightsErrors = {
    /**
     * Source or item not found
     */
    404: unknown;
};

export type ListIntelSourceItemInsightsResponses = {
    /**
     * Insights extracted from one collected item
     */
    200: {
        data: Array<IntelSourceItemInsight>;
    };
};

export type ListIntelSourceItemInsightsResponse = ListIntelSourceItemInsightsResponses[keyof ListIntelSourceItemInsightsResponses];

export type ListIntelSourceSubscriptionsData = {
    body?: never;
    path?: never;
    query?: {
        intelSourceId?: number;
        status?: 'active' | 'paused' | 'blocked' | 'pending_approval' | 'archived';
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/intel/source-subscriptions';
};

export type ListIntelSourceSubscriptionsResponses = {
    /**
     * Subscription list
     */
    200: {
        data: Array<IntelSourceSubscriptionWithSource>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListIntelSourceSubscriptionsResponse = ListIntelSourceSubscriptionsResponses[keyof ListIntelSourceSubscriptionsResponses];

export type UpdateIntelSourceSubscriptionData = {
    body?: IntelSourceSubscriptionUpdate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/source-subscriptions/{id}';
};

export type UpdateIntelSourceSubscriptionErrors = {
    /**
     * Invalid status or field value
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateIntelSourceSubscriptionResponses = {
    /**
     * Updated subscription
     */
    200: IntelSourceSubscription;
};

export type UpdateIntelSourceSubscriptionResponse = UpdateIntelSourceSubscriptionResponses[keyof UpdateIntelSourceSubscriptionResponses];

export type ListIntelSourceFetchRunsData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/intel/source-subscriptions/{id}/fetch-runs';
};

export type ListIntelSourceFetchRunsErrors = {
    /**
     * Subscription not found
     */
    404: unknown;
};

export type ListIntelSourceFetchRunsResponses = {
    /**
     * Fetch run list
     */
    200: {
        data: Array<IntelSourceFetchRun>;
        total: number;
    };
};

export type ListIntelSourceFetchRunsResponse = ListIntelSourceFetchRunsResponses[keyof ListIntelSourceFetchRunsResponses];

export type BackfillIntelSourceSubscriptionData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/intel/source-subscriptions/{id}/backfill';
};

export type BackfillIntelSourceSubscriptionErrors = {
    /**
     * Subscription not found
     */
    404: unknown;
    /**
     * Fetch run already in progress
     */
    409: unknown;
};

export type BackfillIntelSourceSubscriptionResponses = {
    /**
     * Backfill enqueued
     */
    202: IntelSourceSubscriptionEnqueueResult;
};

export type BackfillIntelSourceSubscriptionResponse = BackfillIntelSourceSubscriptionResponses[keyof BackfillIntelSourceSubscriptionResponses];

export type ListIntelSourceMonitorsData = {
    body?: never;
    path?: never;
    query?: {
        intelSourceId?: number;
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/intel/source-monitors';
};

export type ListIntelSourceMonitorsResponses = {
    /**
     * Monitor list
     */
    200: {
        data: Array<IntelSourceMonitor>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListIntelSourceMonitorsResponse = ListIntelSourceMonitorsResponses[keyof ListIntelSourceMonitorsResponses];

export type UpdateIntelSourceMonitorData = {
    body?: IntelSourceMonitorUpdate;
    path: {
        workflowInstanceId: number;
    };
    query?: never;
    url: '/api/v1/intel/source-monitors/{workflowInstanceId}';
};

export type UpdateIntelSourceMonitorErrors = {
    /**
     * Invalid request / policy
     */
    400: unknown;
    /**
     * Monitor not found
     */
    404: unknown;
};

export type UpdateIntelSourceMonitorResponses = {
    /**
     * Monitor updated
     */
    200: IntelSourceMonitor;
};

export type UpdateIntelSourceMonitorResponse = UpdateIntelSourceMonitorResponses[keyof UpdateIntelSourceMonitorResponses];

export type FetchIntelSourceMonitorData = {
    body?: never;
    path: {
        workflowInstanceId: number;
    };
    query?: never;
    url: '/api/v1/intel/source-monitors/{workflowInstanceId}/fetch';
};

export type FetchIntelSourceMonitorErrors = {
    /**
     * Monitor not found
     */
    404: unknown;
};

export type FetchIntelSourceMonitorResponses = {
    /**
     * Fetch triggered
     */
    202: IntelSourceMonitorFetchResult;
};

export type FetchIntelSourceMonitorResponse = FetchIntelSourceMonitorResponses[keyof FetchIntelSourceMonitorResponses];

export type ListIntelSourceMonitorFetchRunsData = {
    body?: never;
    path: {
        workflowInstanceId: number;
    };
    query?: {
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/intel/source-monitors/{workflowInstanceId}/fetch-runs';
};

export type ListIntelSourceMonitorFetchRunsErrors = {
    /**
     * Monitor not found
     */
    404: unknown;
};

export type ListIntelSourceMonitorFetchRunsResponses = {
    /**
     * Fetch run list
     */
    200: {
        data: Array<IntelSourceFetchRun>;
        total: number;
    };
};

export type ListIntelSourceMonitorFetchRunsResponse = ListIntelSourceMonitorFetchRunsResponses[keyof ListIntelSourceMonitorFetchRunsResponses];

export type ListDashboardsData = {
    body?: never;
    path?: never;
    query?: {
        moduleId?: string;
        pinned?: boolean | null;
    };
    url: '/api/v1/dashboards';
};

export type ListDashboardsResponses = {
    /**
     * Dashboards
     */
    200: {
        data: Array<Dashboard>;
    };
};

export type ListDashboardsResponse = ListDashboardsResponses[keyof ListDashboardsResponses];

export type CreateDashboardData = {
    body?: DashboardCreate;
    path?: never;
    query?: never;
    url: '/api/v1/dashboards';
};

export type CreateDashboardErrors = {
    /**
     * Missing org
     */
    400: unknown;
};

export type CreateDashboardResponses = {
    /**
     * Created
     */
    201: {
        dashboard: Dashboard;
    };
};

export type CreateDashboardResponse = CreateDashboardResponses[keyof CreateDashboardResponses];

export type DeleteDashboardData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}';
};

export type DeleteDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteDashboardResponses = {
    /**
     * Deleted
     */
    200: {
        success: boolean;
    };
};

export type DeleteDashboardResponse = DeleteDashboardResponses[keyof DeleteDashboardResponses];

export type GetDashboardData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}';
};

export type GetDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetDashboardResponses = {
    /**
     * Dashboard with widgets
     */
    200: {
        dashboard: DashboardWithWidgets;
    };
};

export type GetDashboardResponse = GetDashboardResponses[keyof GetDashboardResponses];

export type UpdateDashboardData = {
    body?: DashboardUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}';
};

export type UpdateDashboardErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateDashboardResponses = {
    /**
     * Updated
     */
    200: {
        dashboard: Dashboard;
    };
};

export type UpdateDashboardResponse = UpdateDashboardResponses[keyof UpdateDashboardResponses];

export type AddWidgetData = {
    body?: WidgetAdd;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}/widgets';
};

export type AddWidgetErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type AddWidgetResponses = {
    /**
     * Widget added
     */
    201: {
        widget: DashboardWidget;
    };
};

export type AddWidgetResponse = AddWidgetResponses[keyof AddWidgetResponses];

export type ReorderWidgetsData = {
    body?: WidgetReorder;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}/widgets/reorder';
};

export type ReorderWidgetsResponses = {
    /**
     * Widgets reordered
     */
    200: {
        data: Array<DashboardWidget>;
    };
};

export type ReorderWidgetsResponse = ReorderWidgetsResponses[keyof ReorderWidgetsResponses];

export type RemoveWidgetData = {
    body?: never;
    path: {
        id: string;
        widgetId: string;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}/widgets/{widgetId}';
};

export type RemoveWidgetErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RemoveWidgetResponses = {
    /**
     * Widget removed
     */
    200: {
        success: boolean;
    };
};

export type RemoveWidgetResponse = RemoveWidgetResponses[keyof RemoveWidgetResponses];

export type UpdateWidgetData = {
    body?: WidgetUpdate;
    path: {
        id: string;
        widgetId: string;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}/widgets/{widgetId}';
};

export type UpdateWidgetErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateWidgetResponses = {
    /**
     * Widget updated
     */
    200: {
        widget: DashboardWidget;
    };
};

export type UpdateWidgetResponse = UpdateWidgetResponses[keyof UpdateWidgetResponses];

export type UnpinDashboardData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}/pin';
};

export type UnpinDashboardErrors = {
    /**
     * Dashboard not found
     */
    404: unknown;
};

export type UnpinDashboardResponses = {
    /**
     * Dashboard unpinned
     */
    200: DashboardPinState;
};

export type UnpinDashboardResponse = UnpinDashboardResponses[keyof UnpinDashboardResponses];

export type PinDashboardData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}/pin';
};

export type PinDashboardErrors = {
    /**
     * Dashboard not found
     */
    404: unknown;
};

export type PinDashboardResponses = {
    /**
     * Dashboard pinned
     */
    201: DashboardPinState;
};

export type PinDashboardResponse = PinDashboardResponses[keyof PinDashboardResponses];

export type ListMcpConnectionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/mcp/connections';
};

export type ListMcpConnectionsResponses = {
    /**
     * MCP connection list
     */
    200: {
        data: Array<McpConnection>;
    };
};

export type ListMcpConnectionsResponse = ListMcpConnectionsResponses[keyof ListMcpConnectionsResponses];

export type CreateMcpConnectionData = {
    body?: McpConnectionCreate;
    path?: never;
    query?: never;
    url: '/api/v1/mcp/connections';
};

export type CreateMcpConnectionErrors = {
    /**
     * Missing org
     */
    400: unknown;
};

export type CreateMcpConnectionResponses = {
    /**
     * Created
     */
    201: McpConnection;
};

export type CreateMcpConnectionResponse = CreateMcpConnectionResponses[keyof CreateMcpConnectionResponses];

export type DeleteMcpConnectionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/mcp/connections/{id}';
};

export type DeleteMcpConnectionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteMcpConnectionResponses = {
    /**
     * Deleted
     */
    200: McpActionResult;
};

export type DeleteMcpConnectionResponse = DeleteMcpConnectionResponses[keyof DeleteMcpConnectionResponses];

export type GetMcpConnectionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/mcp/connections/{id}';
};

export type GetMcpConnectionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetMcpConnectionResponses = {
    /**
     * Connection detail
     */
    200: McpConnection;
};

export type GetMcpConnectionResponse = GetMcpConnectionResponses[keyof GetMcpConnectionResponses];

export type UpdateMcpConnectionData = {
    body?: {
        name?: string;
        description?: string;
        transport?: 'stdio' | 'sse' | 'http';
        command?: string;
        args?: Array<string>;
        serverUrl?: string;
        env?: {
            [key: string]: string;
        };
        enabled?: boolean;
        autoConnect?: boolean;
        toolPrefix?: string;
        permissionLevel?: string;
        maxCallsPerMinute?: number;
        timeoutMs?: number;
        trusted?: boolean;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/mcp/connections/{id}';
};

export type UpdateMcpConnectionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateMcpConnectionResponses = {
    /**
     * Updated
     */
    200: McpConnection;
};

export type UpdateMcpConnectionResponse = UpdateMcpConnectionResponses[keyof UpdateMcpConnectionResponses];

export type ConnectMcpConnectionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/mcp/connections/{id}/connect';
};

export type ConnectMcpConnectionErrors = {
    /**
     * Disabled
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type ConnectMcpConnectionResponses = {
    /**
     * Connect command queued
     */
    200: McpCommandQueued;
};

export type ConnectMcpConnectionResponse = ConnectMcpConnectionResponses[keyof ConnectMcpConnectionResponses];

export type DisconnectMcpConnectionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/mcp/connections/{id}/disconnect';
};

export type DisconnectMcpConnectionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DisconnectMcpConnectionResponses = {
    /**
     * Disconnect command queued
     */
    200: McpCommandQueued;
};

export type DisconnectMcpConnectionResponse = DisconnectMcpConnectionResponses[keyof DisconnectMcpConnectionResponses];

export type ListMcpConnectionToolsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/mcp/connections/{id}/tools';
};

export type ListMcpConnectionToolsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListMcpConnectionToolsResponses = {
    /**
     * Tools from this connection
     */
    200: {
        data: Array<McpTool>;
    };
};

export type ListMcpConnectionToolsResponse = ListMcpConnectionToolsResponses[keyof ListMcpConnectionToolsResponses];

export type TestMcpConnectionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/mcp/connections/{id}/test';
};

export type TestMcpConnectionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type TestMcpConnectionResponses = {
    /**
     * Test command queued
     */
    200: McpCommandQueued;
};

export type TestMcpConnectionResponse = TestMcpConnectionResponses[keyof TestMcpConnectionResponses];

export type SearchDaemonsData = {
    body?: never;
    path?: never;
    query: {
        q: string;
        limit?: number;
    };
    url: '/api/v1/admin/daemons/search';
};

export type SearchDaemonsResponses = {
    /**
     * Ranked workforce (daemon) search results
     */
    200: {
        data: Array<WorkforceSearchResult>;
        query: string;
        total: number;
        searchType: 'keyword' | 'semantic' | 'hybrid';
    };
};

export type SearchDaemonsResponse = SearchDaemonsResponses[keyof SearchDaemonsResponses];

export type RecommendDaemonsData = {
    body?: never;
    path?: never;
    query: {
        mandate: string;
        department?: string;
        limit?: number;
    };
    url: '/api/v1/admin/daemons/recommend';
};

export type RecommendDaemonsResponses = {
    /**
     * Recommended daemons matching a mandate description
     */
    200: {
        data: Array<WorkforceSearchResult>;
        total: number;
    };
};

export type RecommendDaemonsResponse = RecommendDaemonsResponses[keyof RecommendDaemonsResponses];

export type SearchWorkforceData = {
    body?: never;
    path?: never;
    query: {
        q: string;
        limit?: number;
    };
    url: '/api/v1/workforce/search';
};

export type SearchWorkforceResponses = {
    /**
     * Ranked workforce (daemon) search results
     */
    200: {
        data: Array<WorkforceSearchResult>;
        query: string;
        total: number;
        searchType: 'keyword' | 'semantic' | 'hybrid';
    };
};

export type SearchWorkforceResponse = SearchWorkforceResponses[keyof SearchWorkforceResponses];

export type RecommendWorkforceData = {
    body?: never;
    path?: never;
    query: {
        mandate: string;
        department?: string;
        limit?: number;
    };
    url: '/api/v1/workforce/recommend';
};

export type RecommendWorkforceResponses = {
    /**
     * Recommended daemons matching a mandate description
     */
    200: {
        data: Array<WorkforceSearchResult>;
        total: number;
    };
};

export type RecommendWorkforceResponse = RecommendWorkforceResponses[keyof RecommendWorkforceResponses];

export type ListDaemonsEventCatalogData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/daemons/events/catalog';
};

export type ListDaemonsEventCatalogResponses = {
    /**
     * Event catalog
     */
    200: WorkforceEventCatalogResult;
};

export type ListDaemonsEventCatalogResponse = ListDaemonsEventCatalogResponses[keyof ListDaemonsEventCatalogResponses];

export type GetDaemonsSummaryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/daemons/summary';
};

export type GetDaemonsSummaryResponses = {
    /**
     * Fleet summary
     */
    200: WorkforceFleetSummaryResult;
};

export type GetDaemonsSummaryResponse = GetDaemonsSummaryResponses[keyof GetDaemonsSummaryResponses];

export type ListDaemonsAssignmentsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/daemons/assignments';
};

export type ListDaemonsAssignmentsResponses = {
    /**
     * Workforce member project assignments
     */
    200: WorkforceAssignmentList;
};

export type ListDaemonsAssignmentsResponse = ListDaemonsAssignmentsResponses[keyof ListDaemonsAssignmentsResponses];

export type ResumeAllDaemonsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/daemons/resume-all';
};

export type ResumeAllDaemonsResponses = {
    /**
     * Resumed
     */
    200: WorkforceResumeAllResult;
};

export type ResumeAllDaemonsResponse = ResumeAllDaemonsResponses[keyof ResumeAllDaemonsResponses];

export type TerminateAllDaemonsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/daemons/terminate-all';
};

export type TerminateAllDaemonsResponses = {
    /**
     * All daemons killed
     */
    200: WorkforceTerminateAllResult;
};

export type TerminateAllDaemonsResponse = TerminateAllDaemonsResponses[keyof TerminateAllDaemonsResponses];

export type ReviewDaemonsFindingData = {
    body?: FindingReviewUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/findings/{id}/review';
};

export type ReviewDaemonsFindingErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ReviewDaemonsFindingResponses = {
    /**
     * Finding reviewed
     */
    200: WorkforceRecord;
};

export type ReviewDaemonsFindingResponse = ReviewDaemonsFindingResponses[keyof ReviewDaemonsFindingResponses];

export type ListDaemonPermissionGrantsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        status?: 'active' | 'revoked' | 'expired' | 'all';
        grantMode?: 'once' | 'always';
        limit?: string;
    };
    url: '/api/v1/admin/daemons/{id}/permission-grants';
};

export type ListDaemonPermissionGrantsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListDaemonPermissionGrantsResponses = {
    /**
     * Permission grants
     */
    200: DaemonPermissionGrantList;
};

export type ListDaemonPermissionGrantsResponse = ListDaemonPermissionGrantsResponses[keyof ListDaemonPermissionGrantsResponses];

export type RevokeDaemonPermissionGrantData = {
    body?: {
        reason?: string;
    };
    path: {
        id: string;
        grantId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/permission-grants/{grantId}/revoke';
};

export type RevokeDaemonPermissionGrantErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RevokeDaemonPermissionGrantResponses = {
    /**
     * Permission grant revoked
     */
    200: WorkforceItemResult;
};

export type RevokeDaemonPermissionGrantResponse = RevokeDaemonPermissionGrantResponses[keyof RevokeDaemonPermissionGrantResponses];

export type RunDaemonData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/run';
};

export type RunDaemonErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RunDaemonResponses = {
    /**
     * Run triggered
     */
    202: WorkforceRunTriggeredResult;
};

export type RunDaemonResponse = RunDaemonResponses[keyof RunDaemonResponses];

export type ListDaemonRunsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: string;
        status?: 'pending' | 'running' | 'completed' | 'failed' | 'skipped';
    };
    url: '/api/v1/admin/daemons/{id}/runs';
};

export type ListDaemonRunsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListDaemonRunsResponses = {
    /**
     * Run history
     */
    200: DaemonRunList;
};

export type ListDaemonRunsResponse = ListDaemonRunsResponses[keyof ListDaemonRunsResponses];

export type StreamDaemonRunsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/runs/stream';
};

export type StreamDaemonRunsResponses = {
    /**
     * SSE stream
     */
    200: WorkforceSseResult;
};

export type StreamDaemonRunsResponse = StreamDaemonRunsResponses[keyof StreamDaemonRunsResponses];

export type GetDaemonRunData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/runs/{runId}';
};

export type GetDaemonRunErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetDaemonRunResponses = {
    /**
     * Single run
     */
    200: WorkforceRecord;
};

export type GetDaemonRunResponse = GetDaemonRunResponses[keyof GetDaemonRunResponses];

export type ListDaemonRunReportsData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/reports';
};

export type ListDaemonRunReportsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListDaemonRunReportsResponses = {
    /**
     * Run reports
     */
    200: DaemonRunReportList;
};

export type ListDaemonRunReportsResponse = ListDaemonRunReportsResponses[keyof ListDaemonRunReportsResponses];

export type ListDaemonRunDecisionsData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/decisions';
};

export type ListDaemonRunDecisionsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListDaemonRunDecisionsResponses = {
    /**
     * Run decisions
     */
    200: DaemonRunDecisionList;
};

export type ListDaemonRunDecisionsResponse = ListDaemonRunDecisionsResponses[keyof ListDaemonRunDecisionsResponses];

export type ListDaemonRunExecutionEnvelopesData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/execution-envelopes';
};

export type ListDaemonRunExecutionEnvelopesErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListDaemonRunExecutionEnvelopesResponses = {
    /**
     * Run execution envelopes
     */
    200: DaemonExecutionEnvelopeList;
};

export type ListDaemonRunExecutionEnvelopesResponse = ListDaemonRunExecutionEnvelopesResponses[keyof ListDaemonRunExecutionEnvelopesResponses];

export type GetDaemonRunAuditData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/audit';
};

export type GetDaemonRunAuditErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetDaemonRunAuditResponses = {
    /**
     * Full daemon run audit
     */
    200: WorkforceRunAuditResult;
};

export type GetDaemonRunAuditResponse = GetDaemonRunAuditResponses[keyof GetDaemonRunAuditResponses];

export type GrantDaemonRunExecutionEnvelopePermissionData = {
    body?: ExecutionPermissionGrantCreate;
    path: {
        id: string;
        runId: string;
        envelopeId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/runs/{runId}/execution-envelopes/{envelopeId}/grant';
};

export type GrantDaemonRunExecutionEnvelopePermissionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GrantDaemonRunExecutionEnvelopePermissionResponses = {
    /**
     * Permission grant created
     */
    201: WorkforceItemResult;
};

export type GrantDaemonRunExecutionEnvelopePermissionResponse = GrantDaemonRunExecutionEnvelopePermissionResponses[keyof GrantDaemonRunExecutionEnvelopePermissionResponses];

export type ListDaemonTriggersData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/triggers';
};

export type ListDaemonTriggersErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListDaemonTriggersResponses = {
    /**
     * Trigger list
     */
    200: DaemonTriggerList;
};

export type ListDaemonTriggersResponse = ListDaemonTriggersResponses[keyof ListDaemonTriggersResponses];

export type CreateDaemonTriggerData = {
    body?: DaemonTriggerCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/triggers';
};

export type CreateDaemonTriggerErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type CreateDaemonTriggerResponses = {
    /**
     * Created
     */
    201: WorkforceRecord;
};

export type CreateDaemonTriggerResponse = CreateDaemonTriggerResponses[keyof CreateDaemonTriggerResponses];

export type DeleteDaemonTriggerData = {
    body?: never;
    path: {
        id: string;
        triggerId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/triggers/{triggerId}';
};

export type DeleteDaemonTriggerErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteDaemonTriggerResponses = {
    /**
     * Deleted
     */
    200: WorkforceMessageResult;
};

export type DeleteDaemonTriggerResponse = DeleteDaemonTriggerResponses[keyof DeleteDaemonTriggerResponses];

export type UpdateDaemonTriggerData = {
    body?: DaemonTriggerUpdate;
    path: {
        id: string;
        triggerId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/triggers/{triggerId}';
};

export type UpdateDaemonTriggerErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateDaemonTriggerResponses = {
    /**
     * Updated
     */
    200: WorkforceRecord;
};

export type UpdateDaemonTriggerResponse = UpdateDaemonTriggerResponses[keyof UpdateDaemonTriggerResponses];

export type ListDaemonsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        before?: string;
        after?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'name';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
        status?: 'idle' | 'running' | 'waiting' | 'error' | 'paused' | 'terminated';
        department?: 'research' | 'security' | 'quality' | 'testing' | 'docs' | 'performance' | 'infrastructure' | 'custom';
        enabled?: boolean | null;
        q?: string;
    };
    url: '/api/v1/admin/daemons';
};

export type ListDaemonsResponses = {
    /**
     * Daemon list
     */
    200: DaemonPaginatedList;
};

export type ListDaemonsResponse = ListDaemonsResponses[keyof ListDaemonsResponses];

export type CreateDaemonData = {
    body?: DaemonCreate;
    path?: never;
    query?: never;
    url: '/api/v1/admin/daemons';
};

export type CreateDaemonErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type CreateDaemonResponses = {
    /**
     * Created
     */
    201: DaemonRecord;
};

export type CreateDaemonResponse = CreateDaemonResponses[keyof CreateDaemonResponses];

export type GetDaemonReadinessData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/readiness';
};

export type GetDaemonReadinessErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetDaemonReadinessResponses = {
    /**
     * Daemon readiness report
     */
    200: DaemonReadinessResult;
};

export type GetDaemonReadinessResponse = GetDaemonReadinessResponses[keyof GetDaemonReadinessResponses];

export type DeleteDaemonData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}';
};

export type DeleteDaemonErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteDaemonResponses = {
    /**
     * Deleted
     */
    200: WorkforceMessageResult;
};

export type DeleteDaemonResponse = DeleteDaemonResponses[keyof DeleteDaemonResponses];

export type GetDaemonData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}';
};

export type GetDaemonErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetDaemonResponses = {
    /**
     * Daemon
     */
    200: DaemonRecord;
};

export type GetDaemonResponse = GetDaemonResponses[keyof GetDaemonResponses];

export type UpdateDaemonData = {
    body?: DaemonUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}';
};

export type UpdateDaemonErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateDaemonResponses = {
    /**
     * Updated
     */
    200: DaemonRecord;
};

export type UpdateDaemonResponse = UpdateDaemonResponses[keyof UpdateDaemonResponses];

export type EnableDaemonData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/enable';
};

export type EnableDaemonErrors = {
    /**
     * Global kill switch active
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type EnableDaemonResponses = {
    /**
     * Enabled
     */
    200: DaemonRecord;
};

export type EnableDaemonResponse = EnableDaemonResponses[keyof EnableDaemonResponses];

export type DisableDaemonData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/disable';
};

export type DisableDaemonErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DisableDaemonResponses = {
    /**
     * Disabled
     */
    200: DaemonRecord;
};

export type DisableDaemonResponse = DisableDaemonResponses[keyof DisableDaemonResponses];

export type ResetDaemonGovernanceData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/governance/reset';
};

export type ResetDaemonGovernanceErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ResetDaemonGovernanceResponses = {
    /**
     * Governance circuit reset
     */
    200: DaemonRecord;
};

export type ResetDaemonGovernanceResponse = ResetDaemonGovernanceResponses[keyof ResetDaemonGovernanceResponses];

export type SetDaemonRuntimePolicyData = {
    body?: EmployeeRuntimePolicyWrite;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/runtime-policy';
};

export type SetDaemonRuntimePolicyErrors = {
    /**
     * The workforce surface does not allow this policy
     */
    400: unknown;
    /**
     * No such employee in this organization
     */
    404: unknown;
};

export type SetDaemonRuntimePolicyResponses = {
    /**
     * The policy the employee runs under, set
     */
    200: EmployeeRuntimePolicyWrite;
};

export type SetDaemonRuntimePolicyResponse = SetDaemonRuntimePolicyResponses[keyof SetDaemonRuntimePolicyResponses];

export type ListDaemonReflectionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/reflections';
};

export type ListDaemonReflectionsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListDaemonReflectionsResponses = {
    /**
     * Reflection log
     */
    200: DaemonReflectionList;
};

export type ListDaemonReflectionsResponse = ListDaemonReflectionsResponses[keyof ListDaemonReflectionsResponses];

export type GetDaemonTrendData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/trend';
};

export type GetDaemonTrendErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetDaemonTrendResponses = {
    /**
     * Quality trend
     */
    200: WorkforceTrendResult;
};

export type GetDaemonTrendResponse = GetDaemonTrendResponses[keyof GetDaemonTrendResponses];

export type ListDaemonFindingsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        severity?: string;
        reviewStatus?: string;
        limit?: string;
    };
    url: '/api/v1/admin/daemons/{id}/findings';
};

export type ListDaemonFindingsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListDaemonFindingsResponses = {
    /**
     * Findings list
     */
    200: DaemonFindingList;
};

export type ListDaemonFindingsResponse = ListDaemonFindingsResponses[keyof ListDaemonFindingsResponses];

export type ListDaemonWorkflowsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/workflows';
};

export type ListDaemonWorkflowsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListDaemonWorkflowsResponses = {
    /**
     * Workflow assignments
     */
    200: DaemonWorkflowList;
};

export type ListDaemonWorkflowsResponse = ListDaemonWorkflowsResponses[keyof ListDaemonWorkflowsResponses];

export type AssignDaemonWorkflowData = {
    body?: DaemonWorkflowAssign;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/workflows';
};

export type AssignDaemonWorkflowErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type AssignDaemonWorkflowResponses = {
    /**
     * Assigned
     */
    201: WorkforceRecord;
};

export type AssignDaemonWorkflowResponse = AssignDaemonWorkflowResponses[keyof AssignDaemonWorkflowResponses];

export type RemoveDaemonWorkflowData = {
    body?: never;
    path: {
        id: string;
        workflowId: string;
    };
    query?: never;
    url: '/api/v1/admin/daemons/{id}/workflows/{workflowId}';
};

export type RemoveDaemonWorkflowErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RemoveDaemonWorkflowResponses = {
    /**
     * Removed
     */
    200: WorkforceMessageResult;
};

export type RemoveDaemonWorkflowResponse = RemoveDaemonWorkflowResponses[keyof RemoveDaemonWorkflowResponses];

export type ListWorkforceEventCatalogData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/workforce/events/catalog';
};

export type ListWorkforceEventCatalogResponses = {
    /**
     * Event catalog
     */
    200: WorkforceEventCatalogResult;
};

export type ListWorkforceEventCatalogResponse = ListWorkforceEventCatalogResponses[keyof ListWorkforceEventCatalogResponses];

export type GetWorkforceSummaryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/workforce/summary';
};

export type GetWorkforceSummaryResponses = {
    /**
     * Fleet summary
     */
    200: WorkforceFleetSummaryResult;
};

export type GetWorkforceSummaryResponse = GetWorkforceSummaryResponses[keyof GetWorkforceSummaryResponses];

export type ListWorkforceAssignmentsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/workforce/assignments';
};

export type ListWorkforceAssignmentsResponses = {
    /**
     * Workforce member project assignments
     */
    200: WorkforceAssignmentList;
};

export type ListWorkforceAssignmentsResponse = ListWorkforceAssignmentsResponses[keyof ListWorkforceAssignmentsResponses];

export type ResumeAllEmployeesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/workforce/employees/resume-all';
};

export type ResumeAllEmployeesResponses = {
    /**
     * Resumed
     */
    200: WorkforceResumeAllResult;
};

export type ResumeAllEmployeesResponse = ResumeAllEmployeesResponses[keyof ResumeAllEmployeesResponses];

export type TerminateAllEmployeesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/workforce/employees/terminate-all';
};

export type TerminateAllEmployeesResponses = {
    /**
     * All daemons killed
     */
    200: WorkforceTerminateAllResult;
};

export type TerminateAllEmployeesResponse = TerminateAllEmployeesResponses[keyof TerminateAllEmployeesResponses];

export type ReviewWorkforceFindingData = {
    body?: FindingReviewUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/findings/{id}/review';
};

export type ReviewWorkforceFindingErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ReviewWorkforceFindingResponses = {
    /**
     * Finding reviewed
     */
    200: WorkforceRecord;
};

export type ReviewWorkforceFindingResponse = ReviewWorkforceFindingResponses[keyof ReviewWorkforceFindingResponses];

export type ListEmployeePermissionGrantsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        status?: 'active' | 'revoked' | 'expired' | 'all';
        grantMode?: 'once' | 'always';
        limit?: string;
    };
    url: '/api/v1/workforce/employees/{id}/permission-grants';
};

export type ListEmployeePermissionGrantsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEmployeePermissionGrantsResponses = {
    /**
     * Permission grants
     */
    200: DaemonPermissionGrantList;
};

export type ListEmployeePermissionGrantsResponse = ListEmployeePermissionGrantsResponses[keyof ListEmployeePermissionGrantsResponses];

export type RevokeEmployeePermissionGrantData = {
    body?: {
        reason?: string;
    };
    path: {
        id: string;
        grantId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/permission-grants/{grantId}/revoke';
};

export type RevokeEmployeePermissionGrantErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RevokeEmployeePermissionGrantResponses = {
    /**
     * Permission grant revoked
     */
    200: WorkforceItemResult;
};

export type RevokeEmployeePermissionGrantResponse = RevokeEmployeePermissionGrantResponses[keyof RevokeEmployeePermissionGrantResponses];

export type RunEmployeeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/run';
};

export type RunEmployeeErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RunEmployeeResponses = {
    /**
     * Run triggered
     */
    202: WorkforceRunTriggeredResult;
};

export type RunEmployeeResponse = RunEmployeeResponses[keyof RunEmployeeResponses];

export type ListEmployeeRunsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: string;
        status?: 'pending' | 'running' | 'completed' | 'failed' | 'skipped';
    };
    url: '/api/v1/workforce/employees/{id}/runs';
};

export type ListEmployeeRunsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEmployeeRunsResponses = {
    /**
     * Run history
     */
    200: DaemonRunList;
};

export type ListEmployeeRunsResponse = ListEmployeeRunsResponses[keyof ListEmployeeRunsResponses];

export type StreamEmployeeRunsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/runs/stream';
};

export type StreamEmployeeRunsResponses = {
    /**
     * SSE stream
     */
    200: WorkforceSseResult;
};

export type StreamEmployeeRunsResponse = StreamEmployeeRunsResponses[keyof StreamEmployeeRunsResponses];

export type GetEmployeeRunData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/runs/{runId}';
};

export type GetEmployeeRunErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetEmployeeRunResponses = {
    /**
     * Single run
     */
    200: WorkforceRecord;
};

export type GetEmployeeRunResponse = GetEmployeeRunResponses[keyof GetEmployeeRunResponses];

export type ListEmployeeRunReportsData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/reports';
};

export type ListEmployeeRunReportsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEmployeeRunReportsResponses = {
    /**
     * Run reports
     */
    200: DaemonRunReportList;
};

export type ListEmployeeRunReportsResponse = ListEmployeeRunReportsResponses[keyof ListEmployeeRunReportsResponses];

export type ListEmployeeRunDecisionsData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/decisions';
};

export type ListEmployeeRunDecisionsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEmployeeRunDecisionsResponses = {
    /**
     * Run decisions
     */
    200: DaemonRunDecisionList;
};

export type ListEmployeeRunDecisionsResponse = ListEmployeeRunDecisionsResponses[keyof ListEmployeeRunDecisionsResponses];

export type ListEmployeeRunExecutionEnvelopesData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/execution-envelopes';
};

export type ListEmployeeRunExecutionEnvelopesErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEmployeeRunExecutionEnvelopesResponses = {
    /**
     * Run execution envelopes
     */
    200: DaemonExecutionEnvelopeList;
};

export type ListEmployeeRunExecutionEnvelopesResponse = ListEmployeeRunExecutionEnvelopesResponses[keyof ListEmployeeRunExecutionEnvelopesResponses];

export type GetEmployeeRunAuditData = {
    body?: never;
    path: {
        id: string;
        runId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/audit';
};

export type GetEmployeeRunAuditErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetEmployeeRunAuditResponses = {
    /**
     * Full daemon run audit
     */
    200: WorkforceRunAuditResult;
};

export type GetEmployeeRunAuditResponse = GetEmployeeRunAuditResponses[keyof GetEmployeeRunAuditResponses];

export type GrantEmployeeRunExecutionEnvelopePermissionData = {
    body?: ExecutionPermissionGrantCreate;
    path: {
        id: string;
        runId: string;
        envelopeId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/runs/{runId}/execution-envelopes/{envelopeId}/grant';
};

export type GrantEmployeeRunExecutionEnvelopePermissionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GrantEmployeeRunExecutionEnvelopePermissionResponses = {
    /**
     * Permission grant created
     */
    201: WorkforceItemResult;
};

export type GrantEmployeeRunExecutionEnvelopePermissionResponse = GrantEmployeeRunExecutionEnvelopePermissionResponses[keyof GrantEmployeeRunExecutionEnvelopePermissionResponses];

export type ListEmployeeTriggersData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/triggers';
};

export type ListEmployeeTriggersErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEmployeeTriggersResponses = {
    /**
     * Trigger list
     */
    200: DaemonTriggerList;
};

export type ListEmployeeTriggersResponse = ListEmployeeTriggersResponses[keyof ListEmployeeTriggersResponses];

export type CreateEmployeeTriggerData = {
    body?: DaemonTriggerCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/triggers';
};

export type CreateEmployeeTriggerErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type CreateEmployeeTriggerResponses = {
    /**
     * Created
     */
    201: WorkforceRecord;
};

export type CreateEmployeeTriggerResponse = CreateEmployeeTriggerResponses[keyof CreateEmployeeTriggerResponses];

export type DeleteEmployeeTriggerData = {
    body?: never;
    path: {
        id: string;
        triggerId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/triggers/{triggerId}';
};

export type DeleteEmployeeTriggerErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteEmployeeTriggerResponses = {
    /**
     * Deleted
     */
    200: WorkforceMessageResult;
};

export type DeleteEmployeeTriggerResponse = DeleteEmployeeTriggerResponses[keyof DeleteEmployeeTriggerResponses];

export type UpdateEmployeeTriggerData = {
    body?: DaemonTriggerUpdate;
    path: {
        id: string;
        triggerId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/triggers/{triggerId}';
};

export type UpdateEmployeeTriggerErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateEmployeeTriggerResponses = {
    /**
     * Updated
     */
    200: WorkforceRecord;
};

export type UpdateEmployeeTriggerResponse = UpdateEmployeeTriggerResponses[keyof UpdateEmployeeTriggerResponses];

export type ListEmployeesData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        before?: string;
        after?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'name';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
        status?: 'idle' | 'running' | 'waiting' | 'error' | 'paused' | 'terminated';
        department?: 'research' | 'security' | 'quality' | 'testing' | 'docs' | 'performance' | 'infrastructure' | 'custom';
        enabled?: boolean | null;
        q?: string;
    };
    url: '/api/v1/workforce/employees';
};

export type ListEmployeesResponses = {
    /**
     * Daemon list
     */
    200: DaemonPaginatedList;
};

export type ListEmployeesResponse = ListEmployeesResponses[keyof ListEmployeesResponses];

export type CreateEmployeeData = {
    body?: DaemonCreate;
    path?: never;
    query?: never;
    url: '/api/v1/workforce/employees';
};

export type CreateEmployeeErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type CreateEmployeeResponses = {
    /**
     * Created
     */
    201: DaemonRecord;
};

export type CreateEmployeeResponse = CreateEmployeeResponses[keyof CreateEmployeeResponses];

export type GetEmployeeReadinessData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/readiness';
};

export type GetEmployeeReadinessErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetEmployeeReadinessResponses = {
    /**
     * Daemon readiness report
     */
    200: DaemonReadinessResult;
};

export type GetEmployeeReadinessResponse = GetEmployeeReadinessResponses[keyof GetEmployeeReadinessResponses];

export type DeleteEmployeeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}';
};

export type DeleteEmployeeErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteEmployeeResponses = {
    /**
     * Deleted
     */
    200: WorkforceMessageResult;
};

export type DeleteEmployeeResponse = DeleteEmployeeResponses[keyof DeleteEmployeeResponses];

export type GetEmployeeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}';
};

export type GetEmployeeErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetEmployeeResponses = {
    /**
     * Daemon
     */
    200: DaemonRecord;
};

export type GetEmployeeResponse = GetEmployeeResponses[keyof GetEmployeeResponses];

export type UpdateEmployeeData = {
    body?: DaemonUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}';
};

export type UpdateEmployeeErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateEmployeeResponses = {
    /**
     * Updated
     */
    200: DaemonRecord;
};

export type UpdateEmployeeResponse = UpdateEmployeeResponses[keyof UpdateEmployeeResponses];

export type EnableEmployeeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/enable';
};

export type EnableEmployeeErrors = {
    /**
     * Global kill switch active
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type EnableEmployeeResponses = {
    /**
     * Enabled
     */
    200: DaemonRecord;
};

export type EnableEmployeeResponse = EnableEmployeeResponses[keyof EnableEmployeeResponses];

export type DisableEmployeeData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/disable';
};

export type DisableEmployeeErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DisableEmployeeResponses = {
    /**
     * Disabled
     */
    200: DaemonRecord;
};

export type DisableEmployeeResponse = DisableEmployeeResponses[keyof DisableEmployeeResponses];

export type ResetEmployeeGovernanceData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/governance/reset';
};

export type ResetEmployeeGovernanceErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ResetEmployeeGovernanceResponses = {
    /**
     * Governance circuit reset
     */
    200: DaemonRecord;
};

export type ResetEmployeeGovernanceResponse = ResetEmployeeGovernanceResponses[keyof ResetEmployeeGovernanceResponses];

export type SetEmployeeRuntimePolicyData = {
    body?: EmployeeRuntimePolicyWrite;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/runtime-policy';
};

export type SetEmployeeRuntimePolicyErrors = {
    /**
     * The workforce surface does not allow this policy
     */
    400: unknown;
    /**
     * No such employee in this organization
     */
    404: unknown;
};

export type SetEmployeeRuntimePolicyResponses = {
    /**
     * The policy the employee runs under, set
     */
    200: EmployeeRuntimePolicyWrite;
};

export type SetEmployeeRuntimePolicyResponse = SetEmployeeRuntimePolicyResponses[keyof SetEmployeeRuntimePolicyResponses];

export type ListEmployeeReflectionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/reflections';
};

export type ListEmployeeReflectionsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEmployeeReflectionsResponses = {
    /**
     * Reflection log
     */
    200: DaemonReflectionList;
};

export type ListEmployeeReflectionsResponse = ListEmployeeReflectionsResponses[keyof ListEmployeeReflectionsResponses];

export type GetEmployeeTrendData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/trend';
};

export type GetEmployeeTrendErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetEmployeeTrendResponses = {
    /**
     * Quality trend
     */
    200: WorkforceTrendResult;
};

export type GetEmployeeTrendResponse = GetEmployeeTrendResponses[keyof GetEmployeeTrendResponses];

export type ListEmployeeFindingsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        severity?: string;
        reviewStatus?: string;
        limit?: string;
    };
    url: '/api/v1/workforce/employees/{id}/findings';
};

export type ListEmployeeFindingsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEmployeeFindingsResponses = {
    /**
     * Findings list
     */
    200: DaemonFindingList;
};

export type ListEmployeeFindingsResponse = ListEmployeeFindingsResponses[keyof ListEmployeeFindingsResponses];

export type ListEmployeeWorkflowsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/workflows';
};

export type ListEmployeeWorkflowsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListEmployeeWorkflowsResponses = {
    /**
     * Workflow assignments
     */
    200: DaemonWorkflowList;
};

export type ListEmployeeWorkflowsResponse = ListEmployeeWorkflowsResponses[keyof ListEmployeeWorkflowsResponses];

export type AssignEmployeeWorkflowData = {
    body?: DaemonWorkflowAssign;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/workflows';
};

export type AssignEmployeeWorkflowErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type AssignEmployeeWorkflowResponses = {
    /**
     * Assigned
     */
    201: WorkforceRecord;
};

export type AssignEmployeeWorkflowResponse = AssignEmployeeWorkflowResponses[keyof AssignEmployeeWorkflowResponses];

export type RemoveEmployeeWorkflowData = {
    body?: never;
    path: {
        id: string;
        workflowId: string;
    };
    query?: never;
    url: '/api/v1/workforce/employees/{id}/workflows/{workflowId}';
};

export type RemoveEmployeeWorkflowErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RemoveEmployeeWorkflowResponses = {
    /**
     * Removed
     */
    200: WorkforceMessageResult;
};

export type RemoveEmployeeWorkflowResponse = RemoveEmployeeWorkflowResponses[keyof RemoveEmployeeWorkflowResponses];

export type SetDecisionRuntimePolicyData = {
    body?: RuntimePolicyAssignment;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/daemon-decisions/{id}/runtime-policy';
};

export type SetDecisionRuntimePolicyErrors = {
    /**
     * Not pending, not changeable, or the surface does not allow this policy
     */
    400: unknown;
    /**
     * Only the request’s proposer changes it
     */
    403: unknown;
    /**
     * No such request in this organization
     */
    404: unknown;
};

export type SetDecisionRuntimePolicyResponses = {
    /**
     * The request’s runtime policy, changed
     */
    200: {
        runtimePolicy: {
            id: number;
            name: string;
            surface: 'conversation' | 'workforce' | 'workflow' | 'analysis' | 'evaluation' | 'judge' | 'codegen' | 'system' | 'research';
            changeable: boolean;
        };
    };
};

export type SetDecisionRuntimePolicyResponse = SetDecisionRuntimePolicyResponses[keyof SetDecisionRuntimePolicyResponses];

export type GetDaemonDecisionData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/daemon-decisions/{id}';
};

export type GetDaemonDecisionErrors = {
    /**
     * Daemon decision not found
     */
    404: unknown;
};

export type GetDaemonDecisionResponses = {
    /**
     * Daemon decision
     */
    200: DaemonDecision;
};

export type GetDaemonDecisionResponse = GetDaemonDecisionResponses[keyof GetDaemonDecisionResponses];

export type ApproveDaemonDecisionData = {
    body?: DaemonDecisionReviewRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/daemon-decisions/{id}/approve';
};

export type ApproveDaemonDecisionErrors = {
    /**
     * Organization or reviewer context required, expired, invalid action payload, or self-approval
     */
    400: unknown;
    /**
     * The reviewer does not hold a policy this decision asks of its reviewer
     */
    403: unknown;
    /**
     * Daemon decision not found
     */
    404: unknown;
    /**
     * Daemon decision is not pending
     */
    409: unknown;
};

export type ApproveDaemonDecisionResponses = {
    /**
     * Updated daemon decision
     */
    200: DaemonDecision;
};

export type ApproveDaemonDecisionResponse = ApproveDaemonDecisionResponses[keyof ApproveDaemonDecisionResponses];

export type RejectDaemonDecisionData = {
    body?: DaemonDecisionReviewRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/daemon-decisions/{id}/reject';
};

export type RejectDaemonDecisionErrors = {
    /**
     * Organization or reviewer context required, expired, invalid action payload, or self-approval
     */
    400: unknown;
    /**
     * The reviewer does not hold a policy this decision asks of its reviewer
     */
    403: unknown;
    /**
     * Daemon decision not found
     */
    404: unknown;
    /**
     * Daemon decision is not pending
     */
    409: unknown;
};

export type RejectDaemonDecisionResponses = {
    /**
     * Updated daemon decision
     */
    200: DaemonDecision;
};

export type RejectDaemonDecisionResponse = RejectDaemonDecisionResponses[keyof RejectDaemonDecisionResponses];

export type DeferDaemonDecisionData = {
    body?: DaemonDecisionReviewRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/daemon-decisions/{id}/defer';
};

export type DeferDaemonDecisionErrors = {
    /**
     * Organization or reviewer context required, expired, invalid action payload, or self-approval
     */
    400: unknown;
    /**
     * The reviewer does not hold a policy this decision asks of its reviewer
     */
    403: unknown;
    /**
     * Daemon decision not found
     */
    404: unknown;
    /**
     * Daemon decision is not pending
     */
    409: unknown;
};

export type DeferDaemonDecisionResponses = {
    /**
     * Updated daemon decision
     */
    200: DaemonDecision;
};

export type DeferDaemonDecisionResponse = DeferDaemonDecisionResponses[keyof DeferDaemonDecisionResponses];

export type ListImprovementProposalsData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'idea' | 'specced' | 'implementing' | 'auditing' | 'ready_for_human' | 'approved' | 'rejected' | 'applying' | 'applied' | 'measured' | 'failed' | 'superseded';
        kind?: 'finance_bank_entity' | 'platform_code' | 'template_tuning' | 'data_source' | 'process';
        riskClass?: 'low' | 'medium' | 'high' | 'critical';
        pendingDesignReview?: 'true' | 'false';
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/improvements/proposals';
};

export type ListImprovementProposalsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListImprovementProposalsResponses = {
    /**
     * Improvement proposals
     */
    200: ImprovementProposalList;
};

export type ListImprovementProposalsResponse = ListImprovementProposalsResponses[keyof ListImprovementProposalsResponses];

export type GetImprovementProposalData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/improvements/proposals/{id}';
};

export type GetImprovementProposalErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetImprovementProposalResponses = {
    /**
     * Improvement proposal
     */
    200: ImprovementProposal;
};

export type GetImprovementProposalResponse = GetImprovementProposalResponses[keyof GetImprovementProposalResponses];

export type DecideImprovementProposalData = {
    body?: ImprovementProposalDecisionBody;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/improvements/proposals/{id}/decision';
};

export type DecideImprovementProposalErrors = {
    /**
     * Organization or reviewer context required, or rationale missing on reject
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Proposal is not awaiting a human decision
     */
    409: unknown;
};

export type DecideImprovementProposalResponses = {
    /**
     * Decision recorded
     */
    200: ImprovementProposalDecision;
};

export type DecideImprovementProposalResponse = DecideImprovementProposalResponses[keyof DecideImprovementProposalResponses];

export type DecideImprovementProposalDesignData = {
    body?: ImprovementProposalDesignDecisionBody;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/improvements/proposals/{id}/design-decision';
};

export type DecideImprovementProposalDesignErrors = {
    /**
     * Organization or reviewer context required, or rationale missing on reject
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Proposal is not specced or has no open design review
     */
    409: unknown;
};

export type DecideImprovementProposalDesignResponses = {
    /**
     * Design decision accepted (engine resolves the checkpoint on consumption)
     */
    200: ImprovementProposalDesignDecision;
};

export type DecideImprovementProposalDesignResponse = DecideImprovementProposalDesignResponses[keyof DecideImprovementProposalDesignResponses];

export type GetImprovementMetricsData = {
    body?: never;
    path?: never;
    query?: {
        windowDays?: number;
    };
    url: '/api/v1/improvements/metrics';
};

export type GetImprovementMetricsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type GetImprovementMetricsResponses = {
    /**
     * Computed self-improvement metrics
     */
    200: ImprovementMetrics;
};

export type GetImprovementMetricsResponse = GetImprovementMetricsResponses[keyof GetImprovementMetricsResponses];

export type GetImprovementTierStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/improvements/tier';
};

export type GetImprovementTierStatusErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type GetImprovementTierStatusResponses = {
    /**
     * Per-lane tier status
     */
    200: ImprovementTierStatus;
};

export type GetImprovementTierStatusResponse = GetImprovementTierStatusResponses[keyof GetImprovementTierStatusResponses];

export type ExpandImprovementTierData = {
    body?: ImprovementTierExpandRequest;
    path?: never;
    query?: never;
    url: '/api/v1/improvements/tier/expand';
};

export type ExpandImprovementTierErrors = {
    /**
     * Organization or reviewer context required, or targetTier is not exactly the next tier
     */
    400: unknown;
    /**
     * Superadmin only
     */
    403: unknown;
    /**
     * Entry criteria no longer met at apply-time (stale eligibility)
     */
    409: unknown;
};

export type ExpandImprovementTierResponses = {
    /**
     * Tier expanded
     */
    200: ImprovementTierExpansion;
};

export type ExpandImprovementTierResponse = ExpandImprovementTierResponses[keyof ExpandImprovementTierResponses];

export type ListWorkflowGatesData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'pending' | 'approved' | 'rejected';
        limit?: number;
    };
    url: '/api/v1/workflow-gates';
};

export type ListWorkflowGatesErrors = {
    /**
     * Organization or reviewer context required, gate expired, or self-approval attempt
     */
    400: unknown;
    /**
     * Policy not satisfied
     */
    403: unknown;
};

export type ListWorkflowGatesResponses = {
    /**
     * Workflow gate list
     */
    200: Array<WorkflowGate>;
};

export type ListWorkflowGatesResponse = ListWorkflowGatesResponses[keyof ListWorkflowGatesResponses];

export type GetWorkflowGateData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/workflow-gates/{id}';
};

export type GetWorkflowGateErrors = {
    /**
     * Organization or reviewer context required, gate expired, or self-approval attempt
     */
    400: unknown;
    /**
     * Policy not satisfied
     */
    403: unknown;
    /**
     * Workflow gate not found
     */
    404: unknown;
};

export type GetWorkflowGateResponses = {
    /**
     * Workflow gate
     */
    200: WorkflowGate;
};

export type GetWorkflowGateResponse = GetWorkflowGateResponses[keyof GetWorkflowGateResponses];

export type ApproveWorkflowGateData = {
    body?: WorkflowGateApproveRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/workflow-gates/{id}/approve';
};

export type ApproveWorkflowGateErrors = {
    /**
     * Organization or reviewer context required, gate expired, or self-approval attempt
     */
    400: unknown;
    /**
     * Policy not satisfied
     */
    403: unknown;
    /**
     * Workflow gate not found
     */
    404: unknown;
    /**
     * Gate is not pending (already resolved or expired)
     */
    409: unknown;
};

export type ApproveWorkflowGateResponses = {
    /**
     * Workflow gate
     */
    200: WorkflowGate;
};

export type ApproveWorkflowGateResponse = ApproveWorkflowGateResponses[keyof ApproveWorkflowGateResponses];

export type RejectWorkflowGateData = {
    body?: WorkflowGateRejectRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/workflow-gates/{id}/reject';
};

export type RejectWorkflowGateErrors = {
    /**
     * Organization or reviewer context required, gate expired, or self-approval attempt
     */
    400: unknown;
    /**
     * Policy not satisfied
     */
    403: unknown;
    /**
     * Workflow gate not found
     */
    404: unknown;
    /**
     * Gate is not pending (already resolved or expired)
     */
    409: unknown;
};

export type RejectWorkflowGateResponses = {
    /**
     * Workflow gate
     */
    200: WorkflowGate;
};

export type RejectWorkflowGateResponse = RejectWorkflowGateResponses[keyof RejectWorkflowGateResponses];

export type ListMarketplaceListingsData = {
    body?: never;
    path?: never;
    query?: {
        type?: string;
        category?: string;
        search?: string;
        pricing?: 'free' | 'paid';
        limit?: number;
    };
    url: '/api/v1/marketplace/listings';
};

export type ListMarketplaceListingsResponses = {
    /**
     * Published listings
     */
    200: {
        data: Array<MarketplaceListing>;
    };
};

export type ListMarketplaceListingsResponse = ListMarketplaceListingsResponses[keyof ListMarketplaceListingsResponses];

export type PublishMarketplaceListingData = {
    body?: MarketplaceListingCreate;
    path?: never;
    query?: never;
    url: '/api/v1/marketplace/listings';
};

export type PublishMarketplaceListingErrors = {
    /**
     * Duplicate or missing org, or autoAcquire from an organization other than System
     */
    400: unknown;
};

export type PublishMarketplaceListingResponses = {
    /**
     * Published
     */
    201: MarketplaceListing;
};

export type PublishMarketplaceListingResponse = PublishMarketplaceListingResponses[keyof PublishMarketplaceListingResponses];

export type DeleteMarketplaceListingData = {
    body?: never;
    path?: {
        id?: number | null;
    };
    query?: never;
    url: '/api/v1/marketplace/listings/{id}';
};

export type DeleteMarketplaceListingErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteMarketplaceListingResponses = {
    /**
     * Removed
     */
    200: MarketplaceActionResult;
};

export type DeleteMarketplaceListingResponse = DeleteMarketplaceListingResponses[keyof DeleteMarketplaceListingResponses];

export type InstallMarketplaceListingData = {
    body?: never;
    path?: {
        id?: number | null;
    };
    query?: never;
    url: '/api/v1/marketplace/listings/{id}/install';
};

export type InstallMarketplaceListingErrors = {
    /**
     * Missing org
     */
    400: unknown;
    /**
     * Listing not found
     */
    404: unknown;
};

export type InstallMarketplaceListingResponses = {
    /**
     * Acquired
     */
    201: Entity;
};

export type InstallMarketplaceListingResponse = InstallMarketplaceListingResponses[keyof InstallMarketplaceListingResponses];

export type ForkMarketplaceListingData = {
    body?: MarketplaceForkRequest;
    path?: {
        id?: number | null;
    };
    query?: never;
    url: '/api/v1/marketplace/listings/{id}/fork';
};

export type ForkMarketplaceListingErrors = {
    /**
     * Listing is private — only public listings may be forked
     */
    403: unknown;
    /**
     * Listing not found
     */
    404: unknown;
};

export type ForkMarketplaceListingResponses = {
    /**
     * Forked
     */
    201: MarketplaceForkedEntity;
};

export type ForkMarketplaceListingResponse = ForkMarketplaceListingResponses[keyof ForkMarketplaceListingResponses];

export type ListMarketplaceInstallationsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/marketplace/installations';
};

export type ListMarketplaceInstallationsResponses = {
    /**
     * Entities this organization acquired
     */
    200: {
        data: Array<Entity>;
    };
};

export type ListMarketplaceInstallationsResponse = ListMarketplaceInstallationsResponses[keyof ListMarketplaceInstallationsResponses];

export type ListMarketplaceUpdatesData = {
    body?: never;
    path?: never;
    query?: {
        type?: 'tool' | 'skill' | 'agent_template' | 'strategy' | 'bucket' | 'indicator' | 'workflow' | 'workforce' | 'strategy_template' | 'mutation_recipe' | 'evaluation_template';
    };
    url: '/api/v1/marketplace/updates';
};

export type ListMarketplaceUpdatesErrors = {
    /**
     * Missing org
     */
    400: unknown;
};

export type ListMarketplaceUpdatesResponses = {
    /**
     * Acquired entities whose source has published different content since
     */
    200: {
        data: Array<MarketplaceAcquisition>;
    };
};

export type ListMarketplaceUpdatesResponse = ListMarketplaceUpdatesResponses[keyof ListMarketplaceUpdatesResponses];

export type ApplyMarketplaceUpdatesData = {
    body?: MarketplaceUpdateAllRequest;
    path?: never;
    query?: never;
    url: '/api/v1/marketplace/updates/apply';
};

export type ApplyMarketplaceUpdatesErrors = {
    /**
     * Missing org
     */
    400: unknown;
};

export type ApplyMarketplaceUpdatesResponses = {
    /**
     * Every acquired entity with an update moved to its newest version
     */
    200: MarketplaceUpdateAllResult;
};

export type ApplyMarketplaceUpdatesResponse = ApplyMarketplaceUpdatesResponses[keyof ApplyMarketplaceUpdatesResponses];

export type GetMarketplaceEntityVersionsData = {
    body?: never;
    path: {
        entityId: number;
    };
    query?: never;
    url: '/api/v1/marketplace/entities/{entityId}/versions';
};

export type GetMarketplaceEntityVersionsErrors = {
    /**
     * Missing org
     */
    400: unknown;
    /**
     * Not an entity this organization acquired
     */
    404: unknown;
};

export type GetMarketplaceEntityVersionsResponses = {
    /**
     * One acquired entity with every version its source published
     */
    200: MarketplaceAcquisition;
};

export type GetMarketplaceEntityVersionsResponse = GetMarketplaceEntityVersionsResponses[keyof GetMarketplaceEntityVersionsResponses];

export type UpdateMarketplaceEntityData = {
    body?: MarketplaceEntityUpdateRequest;
    path: {
        entityId: number;
    };
    query?: never;
    url: '/api/v1/marketplace/entities/{entityId}/update';
};

export type UpdateMarketplaceEntityErrors = {
    /**
     * Missing org, or the source has no such published version
     */
    400: unknown;
    /**
     * Not an entity this organization acquired
     */
    404: unknown;
    /**
     * Already on that version
     */
    409: unknown;
};

export type UpdateMarketplaceEntityResponses = {
    /**
     * The entity now runs the newest version of its source, or the version named
     */
    200: MarketplaceAcquisitionMove;
};

export type UpdateMarketplaceEntityResponse = UpdateMarketplaceEntityResponses[keyof UpdateMarketplaceEntityResponses];

export type ListMarketplaceNeedsSetupData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/marketplace/needs-setup';
};

export type ListMarketplaceNeedsSetupResponses = {
    /**
     * Held entities that reach an MCP tool, directly or through what they link, and have no binding yet
     */
    200: {
        data: Array<MarketplaceNeedsSetupEntity>;
    };
};

export type ListMarketplaceNeedsSetupResponse = ListMarketplaceNeedsSetupResponses[keyof ListMarketplaceNeedsSetupResponses];

export type UnbindMarketplaceEntityConnectionData = {
    body?: never;
    path?: {
        entityId?: number | null;
    };
    query?: never;
    url: '/api/v1/marketplace/entities/{entityId}/connection';
};

export type UnbindMarketplaceEntityConnectionErrors = {
    /**
     * Entity not found
     */
    404: unknown;
};

export type UnbindMarketplaceEntityConnectionResponses = {
    /**
     * Unbound
     */
    200: MarketplaceActionResult;
};

export type UnbindMarketplaceEntityConnectionResponse = UnbindMarketplaceEntityConnectionResponses[keyof UnbindMarketplaceEntityConnectionResponses];

export type BindMarketplaceEntityConnectionData = {
    body?: BindConnectionRequest;
    path?: {
        entityId?: number | null;
    };
    query?: never;
    url: '/api/v1/marketplace/entities/{entityId}/connection';
};

export type BindMarketplaceEntityConnectionErrors = {
    /**
     * Entity or connection not found
     */
    404: unknown;
};

export type BindMarketplaceEntityConnectionResponses = {
    /**
     * Bound
     */
    200: MarketplaceActionResult;
};

export type BindMarketplaceEntityConnectionResponse = BindMarketplaceEntityConnectionResponses[keyof BindMarketplaceEntityConnectionResponses];

export type GetMarketplaceBundleData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/marketplace/bundles/{id}';
};

export type GetMarketplaceBundleErrors = {
    /**
     * Bundle not found
     */
    404: unknown;
};

export type GetMarketplaceBundleResponses = {
    /**
     * Marketplace bundle detail
     */
    200: MarketplaceBundle;
};

export type GetMarketplaceBundleResponse = GetMarketplaceBundleResponses[keyof GetMarketplaceBundleResponses];

export type CreateMarketplaceBundleData = {
    body?: MarketplaceBundleCreate;
    path?: never;
    query?: never;
    url: '/api/v1/marketplace/bundles';
};

export type CreateMarketplaceBundleResponses = {
    /**
     * Bundle created
     */
    201: MarketplaceBundle;
};

export type CreateMarketplaceBundleResponse = CreateMarketplaceBundleResponses[keyof CreateMarketplaceBundleResponses];

export type AddMarketplaceBundleEntityData = {
    body?: MarketplaceBundleAddEntity;
    path?: {
        id?: number | null;
    };
    query?: never;
    url: '/api/v1/marketplace/bundles/{id}/entities';
};

export type AddMarketplaceBundleEntityErrors = {
    /**
     * Bundle belongs to another organization, or the entity is not held by this one
     */
    403: unknown;
    /**
     * Bundle or entity not found
     */
    404: unknown;
};

export type AddMarketplaceBundleEntityResponses = {
    /**
     * Entity added
     */
    201: MarketplaceActionResult;
};

export type AddMarketplaceBundleEntityResponse = AddMarketplaceBundleEntityResponses[keyof AddMarketplaceBundleEntityResponses];

export type RemoveMarketplaceBundleEntityData = {
    body?: never;
    path?: {
        id?: number | null;
        entityId?: number | null;
    };
    query?: never;
    url: '/api/v1/marketplace/bundles/{id}/entities/{entityId}';
};

export type RemoveMarketplaceBundleEntityErrors = {
    /**
     * Bundle belongs to another organization
     */
    403: unknown;
    /**
     * Bundle not found
     */
    404: unknown;
};

export type RemoveMarketplaceBundleEntityResponses = {
    /**
     * Entity removed
     */
    200: MarketplaceActionResult;
};

export type RemoveMarketplaceBundleEntityResponse = RemoveMarketplaceBundleEntityResponses[keyof RemoveMarketplaceBundleEntityResponses];

export type ListEntityVersionsData = {
    body?: never;
    path: {
        entityId: number;
    };
    query?: never;
    url: '/api/v1/entities/{entityId}/versions';
};

export type ListEntityVersionsErrors = {
    /**
     * Caller may not read this entity type
     */
    403: unknown;
    /**
     * No such entity in this organization
     */
    404: unknown;
};

export type ListEntityVersionsResponses = {
    /**
     * Version history
     */
    200: EntityVersionList;
};

export type ListEntityVersionsResponse = ListEntityVersionsResponses[keyof ListEntityVersionsResponses];

export type CreateEntityVersionDraftData = {
    body?: EntityDraftCreate;
    path: {
        entityId: number;
    };
    query?: never;
    url: '/api/v1/entities/{entityId}/versions';
};

export type CreateEntityVersionDraftErrors = {
    /**
     * Caller may not change this entity type
     */
    403: unknown;
    /**
     * No such entity in this organization
     */
    404: unknown;
    /**
     * The entity already has a draft, or is acquired
     */
    409: unknown;
};

export type CreateEntityVersionDraftResponses = {
    /**
     * Draft opened
     */
    201: EntityVersion;
};

export type CreateEntityVersionDraftResponse = CreateEntityVersionDraftResponses[keyof CreateEntityVersionDraftResponses];

export type ActivateEntityVersionData = {
    body?: never;
    path: {
        entityId: number;
        versionId: number;
    };
    query?: never;
    url: '/api/v1/entities/{entityId}/versions/{versionId}/activate';
};

export type ActivateEntityVersionErrors = {
    /**
     * Caller may not change this entity type
     */
    403: unknown;
    /**
     * No such entity or version in this organization
     */
    404: unknown;
    /**
     * Already active, acquired, or an evaluation gate refused the promotion
     */
    409: unknown;
};

export type ActivateEntityVersionResponses = {
    /**
     * Now the active version
     */
    200: EntityVersion;
};

export type ActivateEntityVersionResponse = ActivateEntityVersionResponses[keyof ActivateEntityVersionResponses];

export type GetMlHealthData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/ml/health';
};

export type GetMlHealthErrors = {
    /**
     * ML service unavailable
     */
    503: unknown;
};

export type GetMlHealthResponses = {
    /**
     * ML service health
     */
    200: MlHealth;
};

export type GetMlHealthResponse = GetMlHealthResponses[keyof GetMlHealthResponses];

export type GetMlRegimeData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/ml/regime';
};

export type GetMlRegimeErrors = {
    /**
     * ML service unavailable
     */
    503: unknown;
};

export type GetMlRegimeResponses = {
    /**
     * Current market regime
     */
    200: MlRegime;
};

export type GetMlRegimeResponse = GetMlRegimeResponses[keyof GetMlRegimeResponses];

export type GetMlStrategyScoresData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/ml/strategy-scores';
};

export type GetMlStrategyScoresErrors = {
    /**
     * ML service unavailable
     */
    503: unknown;
};

export type GetMlStrategyScoresResponses = {
    /**
     * Strategy regime scores
     */
    200: MlStrategyScores;
};

export type GetMlStrategyScoresResponse = GetMlStrategyScoresResponses[keyof GetMlStrategyScoresResponses];

export type CreateWorkerRunData = {
    body?: WorkerRunCreate;
    path?: never;
    query?: never;
    url: '/api/v1/worker/v1/runs';
};

export type CreateWorkerRunErrors = {
    /**
     * Validation error
     */
    400: unknown;
    /**
     * Missing or invalid API key
     */
    401: unknown;
    /**
     * Forbidden (policy denied)
     */
    403: unknown;
    /**
     * Rate limit exceeded
     */
    429: unknown;
};

export type CreateWorkerRunResponses = {
    /**
     * Run accepted
     */
    202: WorkerRun;
};

export type CreateWorkerRunResponse = CreateWorkerRunResponses[keyof CreateWorkerRunResponses];

export type CancelWorkerRunData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: {
        reason?: string;
    };
    url: '/api/v1/worker/v1/runs/{runId}';
};

export type CancelWorkerRunErrors = {
    /**
     * Run already in terminal state
     */
    400: unknown;
    /**
     * Missing or invalid API key
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Run not found
     */
    404: unknown;
    /**
     * Rate limit exceeded
     */
    429: unknown;
};

export type CancelWorkerRunResponses = {
    /**
     * Cancellation enqueued
     */
    204: void;
};

export type CancelWorkerRunResponse = CancelWorkerRunResponses[keyof CancelWorkerRunResponses];

export type GetWorkerRunData = {
    body?: never;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/v1/worker/v1/runs/{runId}';
};

export type GetWorkerRunErrors = {
    /**
     * Missing or invalid API key
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Run not found or belongs to a different org
     */
    404: unknown;
};

export type GetWorkerRunResponses = {
    /**
     * WorkerRun entity (current state)
     */
    200: WorkerRun;
    /**
     * Accepted moments ago and not yet started by the engine: poll again
     */
    202: WorkerRunPending;
};

export type GetWorkerRunResponse = GetWorkerRunResponses[keyof GetWorkerRunResponses];

export type FollowUpWorkerRunData = {
    body?: WorkerRunFollowUpRequest;
    path: {
        runId: string;
    };
    query?: never;
    url: '/api/v1/worker/v1/runs/{runId}/follow-up';
};

export type FollowUpWorkerRunErrors = {
    /**
     * Run not in running state
     */
    400: unknown;
    /**
     * Missing or invalid API key
     */
    401: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Run not found
     */
    404: unknown;
    /**
     * A workflow run (kind 'workflow') takes no follow-up: there is no conversation to append to
     */
    409: unknown;
    /**
     * Rate limit exceeded
     */
    429: unknown;
};

export type FollowUpWorkerRunResponses = {
    /**
     * Follow-up accepted
     */
    202: {
        runId: string;
    };
};

export type FollowUpWorkerRunResponse = FollowUpWorkerRunResponses[keyof FollowUpWorkerRunResponses];

export type CallPlatformMcpData = {
    body?: PlatformMcpRequest;
    path?: never;
    query?: never;
    url: '/api/v1/mcp';
};

export type CallPlatformMcpErrors = {
    /**
     * Missing, invalid or revoked key
     */
    401: unknown;
    /**
     * The key is not a user key holding agent:mcp
     */
    403: unknown;
    /**
     * Only POST is supported on this endpoint
     */
    405: unknown;
    /**
     * Rate limit exceeded
     */
    429: unknown;
};

export type CallPlatformMcpResponses = {
    /**
     * MCP JSON-RPC response
     */
    200: PlatformMcpResponse;
};

export type CallPlatformMcpResponse = CallPlatformMcpResponses[keyof CallPlatformMcpResponses];

export type ListApiKeysData = {
    body?: never;
    path?: never;
    query?: {
        scope?: 'worker_sdk' | 'service_account' | 'user' | 'host_reporter';
    };
    url: '/api/v1/api-keys';
};

export type ListApiKeysErrors = {
    /**
     * Forbidden
     */
    403: unknown;
};

export type ListApiKeysResponses = {
    /**
     * API keys for the org (bare array — bounded list)
     */
    200: Array<ApiKey>;
};

export type ListApiKeysResponse = ListApiKeysResponses[keyof ListApiKeysResponses];

export type CreateApiKeyData = {
    body?: ApiKeyCreate;
    path?: never;
    query?: never;
    url: '/api/v1/api-keys';
};

export type CreateApiKeyErrors = {
    /**
     * Validation error
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
};

export type CreateApiKeyResponses = {
    /**
     * API key created — plaintext returned once
     */
    201: IssuedApiKey;
};

export type CreateApiKeyResponse = CreateApiKeyResponses[keyof CreateApiKeyResponses];

export type ListApiKeyGrantablePermissionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/api-keys/grantable-permissions';
};

export type ListApiKeyGrantablePermissionsErrors = {
    /**
     * Forbidden
     */
    403: unknown;
};

export type ListApiKeyGrantablePermissionsResponses = {
    /**
     * The entity permission keys a user key may be narrowed to (`metadata.grants`) — generated from the entity skills
     */
    200: ApiKeyGrantablePermissions;
};

export type ListApiKeyGrantablePermissionsResponse = ListApiKeyGrantablePermissionsResponses[keyof ListApiKeyGrantablePermissionsResponses];

export type GetApiKeyData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/api-keys/{id}';
};

export type GetApiKeyErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type GetApiKeyResponses = {
    /**
     * API key
     */
    200: ApiKey;
};

export type GetApiKeyResponse = GetApiKeyResponses[keyof GetApiKeyResponses];

export type UpdateApiKeyData = {
    body?: ApiKeyUpdate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/api-keys/{id}';
};

export type UpdateApiKeyErrors = {
    /**
     * Validation error
     */
    400: unknown;
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateApiKeyResponses = {
    /**
     * Updated API key
     */
    200: ApiKey;
};

export type UpdateApiKeyResponse = UpdateApiKeyResponses[keyof UpdateApiKeyResponses];

export type RevokeApiKeyData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/api-keys/{id}/revoke';
};

export type RevokeApiKeyErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type RevokeApiKeyResponses = {
    /**
     * Revoked API key (revokedAt populated)
     */
    200: ApiKey;
};

export type RevokeApiKeyResponse = RevokeApiKeyResponses[keyof RevokeApiKeyResponses];

export type RotateApiKeyData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/api-keys/{id}/rotate';
};

export type RotateApiKeyErrors = {
    /**
     * Forbidden
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type RotateApiKeyResponses = {
    /**
     * Rotated API key — new plaintext returned once
     */
    200: IssuedApiKey;
};

export type RotateApiKeyResponse = RotateApiKeyResponses[keyof RotateApiKeyResponses];

export type ListJourneysData = {
    body?: never;
    path?: never;
    query?: {
        projectId?: number;
        actorId?: string;
        contextType?: JourneyContextType;
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/journeys';
};

export type ListJourneysResponses = {
    /**
     * Granular product/LLM journeys for reconstructing user, workflow, Code, and review flows
     */
    200: JourneyList;
};

export type ListJourneysResponse = ListJourneysResponses[keyof ListJourneysResponses];

export type ListJourneyEventsData = {
    body?: never;
    path: {
        journeyId: string;
    };
    query?: {
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/journeys/{journeyId}/events';
};

export type ListJourneyEventsErrors = {
    /**
     * Journey not found
     */
    404: unknown;
};

export type ListJourneyEventsResponses = {
    /**
     * Journey events with raw evidence omitted
     */
    200: JourneyEventList;
};

export type ListJourneyEventsResponse = ListJourneyEventsResponses[keyof ListJourneyEventsResponses];

export type ListJourneyRawEventsData = {
    body?: never;
    path: {
        journeyId: string;
    };
    query: {
        limit?: number;
        cursor?: string;
        purpose: string;
    };
    url: '/api/v1/journeys/{journeyId}/events/raw';
};

export type ListJourneyRawEventsErrors = {
    /**
     * Journey not found
     */
    404: unknown;
};

export type ListJourneyRawEventsResponses = {
    /**
     * Journey events including raw evidence. Purpose is required and access is itself recorded.
     */
    200: JourneyRawEventList;
};

export type ListJourneyRawEventsResponse = ListJourneyRawEventsResponses[keyof ListJourneyRawEventsResponses];

export type ListDepartmentsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Filter to departments contributed by a specific module (e.g. "finance"). Omit for all departments.
         */
        module_id?: string;
    };
    url: '/api/v1/departments';
};

export type ListDepartmentsResponses = {
    /**
     * Bounded list of departments (bare array, ≤100 rows in practice)
     */
    200: Array<Department>;
};

export type ListDepartmentsResponse = ListDepartmentsResponses[keyof ListDepartmentsResponses];

export type ListMyModulesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/auth/me/modules';
};

export type ListMyModulesErrors = {
    /**
     * Not authenticated
     */
    401: unknown;
};

export type ListMyModulesResponses = {
    /**
     * Enabled modules
     */
    200: ModuleList;
};

export type ListMyModulesResponse = ListMyModulesResponses[keyof ListMyModulesResponses];

export type GetWaitingOnMeData = {
    body?: never;
    path?: never;
    query?: {
        moduleId?: string;
    };
    url: '/api/v1/auth/me/waiting-on-me';
};

export type GetWaitingOnMeErrors = {
    /**
     * Not authenticated
     */
    401: unknown;
};

export type GetWaitingOnMeResponses = {
    /**
     * Waiting-on-me summary
     */
    200: WaitingOnMe;
};

export type GetWaitingOnMeResponse = GetWaitingOnMeResponses[keyof GetWaitingOnMeResponses];

export type ListConversationGroupsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/conversations/groups';
};

export type ListConversationGroupsResponses = {
    /**
     * Conversation groups for this organization
     */
    200: {
        data: Array<ConversationGroup>;
    };
};

export type ListConversationGroupsResponse = ListConversationGroupsResponses[keyof ListConversationGroupsResponses];

export type CreateConversationGroupData = {
    body?: ConversationGroupCreate;
    path?: never;
    query?: never;
    url: '/api/v1/conversations/groups';
};

export type CreateConversationGroupResponses = {
    /**
     * Created (or the existing group of that name)
     */
    201: ConversationGroup;
};

export type CreateConversationGroupResponse = CreateConversationGroupResponses[keyof CreateConversationGroupResponses];

export type DeleteConversationGroupData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/groups/{id}';
};

export type DeleteConversationGroupErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteConversationGroupResponses = {
    /**
     * Deleted
     */
    200: {
        deleted: boolean;
    };
};

export type DeleteConversationGroupResponse = DeleteConversationGroupResponses[keyof DeleteConversationGroupResponses];

export type ListConversationsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        before?: string;
        after?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'lastActivityAt' | 'topic';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
        kind?: 'user-agent' | 'agent-agent' | 'team' | 'assistant-ui';
        include_assistant_ui?: boolean | null;
        projectId?: string;
        teamId?: string;
        parentConversationId?: string;
        status?: 'active' | 'idle' | 'completed' | 'errored';
        moduleId?: string;
        needsUser?: boolean | null;
        q?: string;
        involvesMe?: boolean | null;
        groupId?: string;
        expand?: string;
    };
    url: '/api/v1/conversations';
};

export type ListConversationsResponses = {
    /**
     * Paginated conversation list
     */
    200: ConversationList;
};

export type ListConversationsResponse = ListConversationsResponses[keyof ListConversationsResponses];

export type CreateConversationData = {
    body?: ConversationCreate;
    path?: never;
    query?: never;
    url: '/api/v1/conversations';
};

export type CreateConversationErrors = {
    /**
     * Validation error
     */
    400: unknown;
};

export type CreateConversationResponses = {
    /**
     * Conversation created
     */
    201: Conversation;
};

export type CreateConversationResponse = CreateConversationResponses[keyof CreateConversationResponses];

export type StartConversationFromMessageData = {
    body?: ConversationQuickStart;
    path?: never;
    query?: never;
    url: '/api/v1/conversations/start';
};

export type StartConversationFromMessageErrors = {
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * No AI worker available to run the conversation
     */
    503: unknown;
};

export type StartConversationFromMessageResponses = {
    /**
     * Conversation created from the first user message
     */
    201: ConversationQuickStartResult;
};

export type StartConversationFromMessageResponse = StartConversationFromMessageResponses[keyof StartConversationFromMessageResponses];

export type DeleteConversationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}';
};

export type DeleteConversationErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteConversationResponses = {
    /**
     * Deleted
     */
    200: ConversationActionResult;
};

export type DeleteConversationResponse = DeleteConversationResponses[keyof DeleteConversationResponses];

export type GetConversationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        expand?: string;
    };
    url: '/api/v1/conversations/{id}';
};

export type GetConversationErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetConversationResponses = {
    /**
     * Conversation
     */
    200: Conversation;
};

export type GetConversationResponse = GetConversationResponses[keyof GetConversationResponses];

export type UpdateConversationData = {
    body?: ConversationUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}';
};

export type UpdateConversationErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateConversationResponses = {
    /**
     * Updated conversation
     */
    200: Conversation;
};

export type UpdateConversationResponse = UpdateConversationResponses[keyof UpdateConversationResponses];

export type ListConversationMembersData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        memberType?: 'user' | 'persona' | 'workforce_member' | 'external_agent' | 'agent_instance';
        includeLeft?: boolean | null;
    };
    url: '/api/v1/conversations/{id}/members';
};

export type ListConversationMembersErrors = {
    /**
     * Conversation not found
     */
    404: unknown;
};

export type ListConversationMembersResponses = {
    /**
     * Conversation member list
     */
    200: Array<ConversationMember>;
};

export type ListConversationMembersResponse = ListConversationMembersResponses[keyof ListConversationMembersResponses];

export type InviteToConversationData = {
    body?: ConversationInviteRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/members';
};

export type InviteToConversationErrors = {
    /**
     * The member cannot join this conversation
     */
    400: unknown;
    /**
     * Caller is not a member of this conversation
     */
    403: unknown;
    /**
     * Conversation not found
     */
    404: unknown;
};

export type InviteToConversationResponses = {
    /**
     * Member added
     */
    201: ConversationMember;
};

export type InviteToConversationResponse = InviteToConversationResponses[keyof InviteToConversationResponses];

export type RemoveConversationMemberData = {
    body?: never;
    path: {
        id: string;
        memberId: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/members/{memberId}';
};

export type RemoveConversationMemberErrors = {
    /**
     * Not allowed to remove this member
     */
    403: unknown;
    /**
     * Conversation or member not found
     */
    404: unknown;
};

export type RemoveConversationMemberResponses = {
    /**
     * Member removed
     */
    200: ConversationMemberActionResult;
};

export type RemoveConversationMemberResponse = RemoveConversationMemberResponses[keyof RemoveConversationMemberResponses];

export type SetConversationLeadData = {
    body?: never;
    path: {
        id: string;
        memberId: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/members/{memberId}/lead';
};

export type SetConversationLeadErrors = {
    /**
     * The member cannot lead (a person, an agent, or a persona the organization lacks)
     */
    400: unknown;
    /**
     * Only the owner chooses the lead
     */
    403: unknown;
    /**
     * Conversation or member not found
     */
    404: unknown;
};

export type SetConversationLeadResponses = {
    /**
     * The member now leads
     */
    200: ConversationMember;
};

export type SetConversationLeadResponse = SetConversationLeadResponses[keyof SetConversationLeadResponses];

export type ListConversationEntitiesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/entities';
};

export type ListConversationEntitiesErrors = {
    /**
     * Conversation not found
     */
    404: unknown;
};

export type ListConversationEntitiesResponses = {
    /**
     * The records the conversation works on, newest first (at most 200)
     */
    200: Array<ConversationEntity>;
};

export type ListConversationEntitiesResponse = ListConversationEntitiesResponses[keyof ListConversationEntitiesResponses];

export type ListConversationAttachmentsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        attachedType?: 'artifact' | 'memory' | 'task' | 'conversation' | 'project' | 'workflow';
    };
    url: '/api/v1/conversations/{id}/attachments';
};

export type ListConversationAttachmentsErrors = {
    /**
     * Conversation not found
     */
    404: unknown;
};

export type ListConversationAttachmentsResponses = {
    /**
     * Conversation attachment list
     */
    200: Array<ConversationAttachment>;
};

export type ListConversationAttachmentsResponse = ListConversationAttachmentsResponses[keyof ListConversationAttachmentsResponses];

export type AttachToConversationData = {
    body?: ConversationAttachRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/attachments';
};

export type AttachToConversationErrors = {
    /**
     * Conversation not found
     */
    404: unknown;
};

export type AttachToConversationResponses = {
    /**
     * Attachment created
     */
    201: ConversationAttachment;
};

export type AttachToConversationResponse = AttachToConversationResponses[keyof AttachToConversationResponses];

export type DetachFromConversationData = {
    body?: never;
    path: {
        id: string;
        attachmentId: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/attachments/{attachmentId}';
};

export type DetachFromConversationErrors = {
    /**
     * Not allowed to detach this attachment
     */
    403: unknown;
    /**
     * Conversation or attachment not found
     */
    404: unknown;
};

export type DetachFromConversationResponses = {
    /**
     * Attachment removed
     */
    200: ConversationAttachmentActionResult;
};

export type DetachFromConversationResponse = DetachFromConversationResponses[keyof DetachFromConversationResponses];

export type ListConversationIntentsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: number;
        before?: string;
        after?: string;
        sort_order?: 'asc' | 'desc';
    };
    url: '/api/v1/conversations/{id}/intents';
};

export type ListConversationIntentsErrors = {
    /**
     * Conversation not found
     */
    404: unknown;
};

export type ListConversationIntentsResponses = {
    /**
     * Paginated intent classifications, newest first
     */
    200: IntentList;
};

export type ListConversationIntentsResponse = ListConversationIntentsResponses[keyof ListConversationIntentsResponses];

export type DisambiguateConversationIntentData = {
    body?: ConversationIntentDisambiguateRequest;
    path: {
        id: string;
        decision_id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/intents/{decision_id}/disambiguate';
};

export type DisambiguateConversationIntentErrors = {
    /**
     * Chosen kind is not in the prior alternatives
     */
    400: unknown;
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Conversation or decision not found
     */
    404: unknown;
    /**
     * Prior decision is not ambiguous
     */
    409: unknown;
    /**
     * Drafter for the chosen kind is not available yet
     */
    501: unknown;
};

export type DisambiguateConversationIntentResponses = {
    /**
     * Disambiguation accepted; new decision row created and dispatched
     */
    200: ConversationIntentDisambiguateResult;
};

export type DisambiguateConversationIntentResponse = DisambiguateConversationIntentResponses[keyof DisambiguateConversationIntentResponses];

export type EnableConversationIntentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/intents/disable';
};

export type EnableConversationIntentErrors = {
    /**
     * Conversation not found
     */
    404: unknown;
};

export type EnableConversationIntentResponses = {
    /**
     * Intent classification re-enabled for this conversation
     */
    200: ConversationIntentSettings;
};

export type EnableConversationIntentResponse = EnableConversationIntentResponses[keyof EnableConversationIntentResponses];

export type DisableConversationIntentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/intents/disable';
};

export type DisableConversationIntentErrors = {
    /**
     * Conversation not found
     */
    404: unknown;
};

export type DisableConversationIntentResponses = {
    /**
     * Intent classification disabled for this conversation
     */
    200: ConversationIntentSettings;
};

export type DisableConversationIntentResponse = DisableConversationIntentResponses[keyof DisableConversationIntentResponses];

export type GetConversationMessageByIdData = {
    body?: never;
    path: {
        messageId: string;
    };
    query?: never;
    url: '/api/v1/conversations/messages/{messageId}';
};

export type GetConversationMessageByIdErrors = {
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Message not found
     */
    404: unknown;
};

export type GetConversationMessageByIdResponses = {
    /**
     * Conversation message
     */
    200: ConversationMessage;
};

export type GetConversationMessageByIdResponse = GetConversationMessageByIdResponses[keyof GetConversationMessageByIdResponses];

export type ListConversationMessagesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: number;
        before?: string;
        after?: string;
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
    };
    url: '/api/v1/conversations/{id}/messages';
};

export type ListConversationMessagesErrors = {
    /**
     * Conversation not found
     */
    404: unknown;
};

export type ListConversationMessagesResponses = {
    /**
     * Paginated message list
     */
    200: ConversationMessageList;
};

export type ListConversationMessagesResponse = ListConversationMessagesResponses[keyof ListConversationMessagesResponses];

export type ReplyToConversationData = {
    body?: ConversationReplyRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/messages';
};

export type ReplyToConversationErrors = {
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Finance command context requires research access
     */
    403: unknown;
    /**
     * Conversation not found
     */
    404: unknown;
    /**
     * Drafter for the classified intent kind is not available yet
     */
    501: unknown;
};

export type ReplyToConversationResponses = {
    /**
     * Message created (with intent classification on user messages)
     */
    201: ConversationReply;
};

export type ReplyToConversationResponse = ReplyToConversationResponses[keyof ReplyToConversationResponses];

export type SubmitConversationInteractionData = {
    body?: ConversationInteractionSubmitRequest;
    path: {
        id: string;
        interactionId: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/interactions/{interactionId}/submit';
};

export type SubmitConversationInteractionErrors = {
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Conversation or interaction not found
     */
    404: unknown;
    /**
     * Interaction is already resolved
     */
    409: unknown;
};

export type SubmitConversationInteractionResponses = {
    /**
     * Structured interaction response submitted
     */
    201: ConversationReply;
};

export type SubmitConversationInteractionResponse = SubmitConversationInteractionResponses[keyof SubmitConversationInteractionResponses];

export type CloseContextPanelData = {
    body?: ConversationClosePanelRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/close-panel';
};

export type CloseContextPanelErrors = {
    /**
     * Conversation is not a context-panel child
     */
    400: unknown;
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Conversation not found
     */
    404: unknown;
    /**
     * Close-summary already posted; no new activity to re-summarize
     */
    409: unknown;
};

export type CloseContextPanelResponses = {
    /**
     * Close-summary system message posted to the parent conversation
     */
    200: ConversationReply;
};

export type CloseContextPanelResponse = CloseContextPanelResponses[keyof CloseContextPanelResponses];

export type SubscribeConversationEventsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        /**
         * Opaque resume token from the last SSE `id:` field. Triggers backlog replay.
         */
        last_event_id?: string;
    };
    url: '/api/v1/conversations/{id}/events';
};

export type SubscribeConversationEventsErrors = {
    /**
     * User is not a member of this conversation
     */
    403: unknown;
    /**
     * Conversation not found or feature not enabled
     */
    404: unknown;
};

export type SubscribeConversationEventsResponses = {
    /**
     * SSE stream — text/event-stream. Each frame is a JSON-serialised ConversationEventEnvelope. See Spec 66 §6 for envelope schema.
     */
    200: string;
};

export type SubscribeConversationEventsResponse = SubscribeConversationEventsResponses[keyof SubscribeConversationEventsResponses];

export type SetConversationTypingData = {
    body?: ConversationTypingRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/events/typing';
};

export type SetConversationTypingErrors = {
    /**
     * User is not a member of this conversation
     */
    403: unknown;
    /**
     * Conversation not found
     */
    404: unknown;
};

export type SetConversationTypingResponses = {
    /**
     * Typing indicator updated
     */
    204: void;
};

export type SetConversationTypingResponse = SetConversationTypingResponses[keyof SetConversationTypingResponses];

export type SetConversationRuntimePolicyData = {
    body?: ConversationRuntimePolicyWrite;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/runtime-policy';
};

export type SetConversationRuntimePolicyErrors = {
    /**
     * The conversation surface does not allow this policy
     */
    400: unknown;
    /**
     * Not a member of the conversation
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type SetConversationRuntimePolicyResponses = {
    /**
     * The conversation's policy, set
     */
    200: ConversationRuntimePolicyWrite;
};

export type SetConversationRuntimePolicyResponse = SetConversationRuntimePolicyResponses[keyof SetConversationRuntimePolicyResponses];

export type PatchConversationSettingsData = {
    body?: ConversationSettingsPatch;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/settings';
};

export type PatchConversationSettingsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type PatchConversationSettingsResponses = {
    /**
     * Settings applied
     */
    200: ConversationSettingsPatchResult;
};

export type PatchConversationSettingsResponse = PatchConversationSettingsResponses[keyof PatchConversationSettingsResponses];

export type GetConversationContextData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/conversations/{id}/context';
};

export type GetConversationContextErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetConversationContextResponses = {
    /**
     * Conversation context pack public view and settings
     */
    200: ConversationContextResult;
};

export type GetConversationContextResponse = GetConversationContextResponses[keyof GetConversationContextResponses];

export type ListConversationArtifactsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        kind?: 'decision' | 'plan' | 'draft' | 'report' | 'code' | 'spec' | 'design' | 'custom';
        limit?: number;
        after?: string;
        before?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'title';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
        include_deleted?: boolean | null;
        view?: 'full' | 'summary';
    };
    url: '/api/v1/conversations/{id}/artifacts';
};

export type ListConversationArtifactsErrors = {
    /**
     * Conversation id is not a valid numeric id
     */
    404: unknown;
};

export type ListConversationArtifactsResponses = {
    /**
     * Paginated list of artifacts scoped to this conversation
     */
    200: ArtifactList | ArtifactSummaryList;
};

export type ListConversationArtifactsResponse = ListConversationArtifactsResponses[keyof ListConversationArtifactsResponses];

export type PresignUploadData = {
    body?: UploadPresignRequest;
    path?: never;
    query?: never;
    url: '/api/v1/uploads/presign';
};

export type PresignUploadErrors = {
    /**
     * UPLOAD_TYPE_NOT_ALLOWED or UPLOAD_TOO_LARGE
     */
    400: unknown;
    /**
     * UPLOAD_STORAGE_NOT_CONFIGURED
     */
    503: unknown;
};

export type PresignUploadResponses = {
    /**
     * A pending upload and its PUT URL
     */
    201: UploadPresignResult;
};

export type PresignUploadResponse = PresignUploadResponses[keyof PresignUploadResponses];

export type FinalizeUploadData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/uploads/{id}/finalize';
};

export type FinalizeUploadErrors = {
    /**
     * The file never arrived, arrived incomplete, is not its type, or has no text
     */
    400: unknown;
    /**
     * No such upload of yours
     */
    404: unknown;
};

export type FinalizeUploadResponses = {
    /**
     * The upload, ready
     */
    200: Upload;
};

export type FinalizeUploadResponse = FinalizeUploadResponses[keyof FinalizeUploadResponses];

export type GetUploadContentData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/uploads/{id}/content';
};

export type GetUploadContentErrors = {
    /**
     * No such upload of yours
     */
    404: unknown;
};

export type GetUploadContentResponses = {
    /**
     * The file, to its owner only
     */
    200: Blob | File;
};

export type GetUploadContentResponse = GetUploadContentResponses[keyof GetUploadContentResponses];

export type DeleteUploadData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/uploads/{id}';
};

export type DeleteUploadErrors = {
    /**
     * No such upload of yours
     */
    404: unknown;
    /**
     * UPLOAD_ALREADY_SENT
     */
    409: unknown;
};

export type DeleteUploadResponses = {
    /**
     * Removed
     */
    204: void;
};

export type DeleteUploadResponse = DeleteUploadResponses[keyof DeleteUploadResponses];

export type ListMemoriesData = {
    body?: never;
    path?: never;
    query?: {
        scope?: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
        subjectType?: 'conversation_id' | 'team_id' | 'task_id' | 'project_id' | 'agent_template_id' | 'daemon_id' | 'organization_id';
        subjectId?: string;
        limit?: number;
        after?: string;
        before?: string;
        sort_by?: 'createdAt';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
        include_deleted?: boolean | null;
    };
    url: '/api/v1/memories';
};

export type ListMemoriesResponses = {
    /**
     * Paginated memory list
     */
    200: MemoryList;
};

export type ListMemoriesResponse = ListMemoriesResponses[keyof ListMemoriesResponses];

export type CreateMemoryData = {
    body?: MemoryCreate;
    path?: never;
    query?: never;
    url: '/api/v1/memories';
};

export type CreateMemoryErrors = {
    /**
     * Validation error — invalid scope/subjectType pairing
     */
    400: unknown;
};

export type CreateMemoryResponses = {
    /**
     * Memory created
     */
    201: Memory;
};

export type CreateMemoryResponse = CreateMemoryResponses[keyof CreateMemoryResponses];

export type SearchMemoriesData = {
    body?: never;
    path?: never;
    query: {
        q: string;
        scope?: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
        limit?: number;
        after?: string;
    };
    url: '/api/v1/memories/search';
};

export type SearchMemoriesResponses = {
    /**
     * Full-text search results (paginated)
     */
    200: MemoryList;
};

export type SearchMemoriesResponse = SearchMemoriesResponses[keyof SearchMemoriesResponses];

export type DeleteMemoryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/memories/{id}';
};

export type DeleteMemoryErrors = {
    /**
     * Memory not found
     */
    404: unknown;
};

export type DeleteMemoryResponses = {
    /**
     * Memory soft-deleted
     */
    200: MemoryActionResult;
};

export type DeleteMemoryResponse = DeleteMemoryResponses[keyof DeleteMemoryResponses];

export type GetMemoryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/memories/{id}';
};

export type GetMemoryErrors = {
    /**
     * Memory not found
     */
    404: unknown;
};

export type GetMemoryResponses = {
    /**
     * Memory
     */
    200: Memory;
};

export type GetMemoryResponse = GetMemoryResponses[keyof GetMemoryResponses];

export type UpdateMemoryData = {
    body?: MemoryUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/memories/{id}';
};

export type UpdateMemoryErrors = {
    /**
     * Memory not found
     */
    404: unknown;
};

export type UpdateMemoryResponses = {
    /**
     * Updated memory
     */
    200: Memory;
};

export type UpdateMemoryResponse = UpdateMemoryResponses[keyof UpdateMemoryResponses];

export type PromoteMemoryData = {
    body?: MemoryPromoteRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/memories/{id}/promote';
};

export type PromoteMemoryErrors = {
    /**
     * Invalid promotion target or pairing
     */
    400: unknown;
    /**
     * Memory not found
     */
    404: unknown;
};

export type PromoteMemoryResponses = {
    /**
     * Promoted memory (new row at wider scope)
     */
    200: Memory;
};

export type PromoteMemoryResponse = PromoteMemoryResponses[keyof PromoteMemoryResponses];

export type ListArtifactsData = {
    body?: never;
    path?: never;
    query?: {
        scope?: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
        subjectType?: string;
        subjectId?: string;
        kind?: 'decision' | 'plan' | 'draft' | 'report' | 'code' | 'spec' | 'design' | 'custom';
        limit?: number;
        after?: string;
        before?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'title';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
        include_deleted?: boolean | null;
        view?: 'full' | 'summary';
    };
    url: '/api/v1/artifacts';
};

export type ListArtifactsResponses = {
    /**
     * Paginated artifact list
     */
    200: ArtifactList | ArtifactSummaryList;
};

export type ListArtifactsResponse = ListArtifactsResponses[keyof ListArtifactsResponses];

export type CreateArtifactData = {
    body?: ArtifactCreate;
    path?: never;
    query?: never;
    url: '/api/v1/artifacts';
};

export type CreateArtifactErrors = {
    /**
     * Validation error — invalid scope/subjectType pairing
     */
    400: unknown;
};

export type CreateArtifactResponses = {
    /**
     * Artifact created
     */
    201: Artifact;
};

export type CreateArtifactResponse = CreateArtifactResponses[keyof CreateArtifactResponses];

export type SearchArtifactsData = {
    body?: never;
    path?: never;
    query: {
        q: string;
        scope?: 'conversation' | 'team' | 'task' | 'project' | 'agent' | 'org';
        kind?: 'decision' | 'plan' | 'draft' | 'report' | 'code' | 'spec' | 'design' | 'custom';
        limit?: number;
        after?: string;
        view?: 'full' | 'summary';
    };
    url: '/api/v1/artifacts/search';
};

export type SearchArtifactsResponses = {
    /**
     * Full-text search results (paginated)
     */
    200: ArtifactList | ArtifactSummaryList;
};

export type SearchArtifactsResponse = SearchArtifactsResponses[keyof SearchArtifactsResponses];

export type DeleteArtifactData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/artifacts/{id}';
};

export type DeleteArtifactErrors = {
    /**
     * Artifact not found
     */
    404: unknown;
};

export type DeleteArtifactResponses = {
    /**
     * Artifact soft-deleted
     */
    200: ArtifactActionResult;
};

export type DeleteArtifactResponse = DeleteArtifactResponses[keyof DeleteArtifactResponses];

export type GetArtifactData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/artifacts/{id}';
};

export type GetArtifactErrors = {
    /**
     * Artifact not found
     */
    404: unknown;
};

export type GetArtifactResponses = {
    /**
     * Artifact
     */
    200: Artifact;
};

export type GetArtifactResponse = GetArtifactResponses[keyof GetArtifactResponses];

export type UpdateArtifactData = {
    body?: ArtifactUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/artifacts/{id}';
};

export type UpdateArtifactErrors = {
    /**
     * Artifact not found
     */
    404: unknown;
};

export type UpdateArtifactResponses = {
    /**
     * Updated artifact
     */
    200: Artifact;
};

export type UpdateArtifactResponse = UpdateArtifactResponses[keyof UpdateArtifactResponses];

export type ListProjectTeamMembersData = {
    body?: never;
    path: {
        id: string;
        teamId: string;
    };
    query?: {
        includeInactive?: boolean | null;
    };
    url: '/api/v1/projects/{id}/teams/{teamId}/members';
};

export type ListProjectTeamMembersErrors = {
    /**
     * Project or team not found
     */
    404: unknown;
};

export type ListProjectTeamMembersResponses = {
    /**
     * Team member list
     */
    200: Array<ProjectTeamMember>;
};

export type ListProjectTeamMembersResponse = ListProjectTeamMembersResponses[keyof ListProjectTeamMembersResponses];

export type AddProjectTeamMemberData = {
    body?: TeamMemberAddRequest;
    path: {
        id: string;
        teamId: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/teams/{teamId}/members';
};

export type AddProjectTeamMemberErrors = {
    /**
     * Member type incompatible with team kind
     */
    400: unknown;
    /**
     * Project or team not found
     */
    404: unknown;
    /**
     * Already a member
     */
    409: unknown;
};

export type AddProjectTeamMemberResponses = {
    /**
     * Member added
     */
    201: ProjectTeamMember;
};

export type AddProjectTeamMemberResponse = AddProjectTeamMemberResponses[keyof AddProjectTeamMemberResponses];

export type RemoveProjectTeamMemberData = {
    body?: never;
    path: {
        id: string;
        teamId: string;
        memberId: string;
    };
    query: {
        memberType: 'user' | 'agent_instance' | 'workforce_member';
    };
    url: '/api/v1/projects/{id}/teams/{teamId}/members/{memberId}';
};

export type RemoveProjectTeamMemberErrors = {
    /**
     * Project, team, or member not found
     */
    404: unknown;
};

export type RemoveProjectTeamMemberResponses = {
    /**
     * Member removed
     */
    204: void;
};

export type RemoveProjectTeamMemberResponse = RemoveProjectTeamMemberResponses[keyof RemoveProjectTeamMemberResponses];

export type UpdateProjectTeamMemberData = {
    body?: TeamMemberUpdateRoleRequest;
    path: {
        id: string;
        teamId: string;
        memberId: string;
    };
    query: {
        memberType: 'user' | 'agent_instance' | 'workforce_member';
    };
    url: '/api/v1/projects/{id}/teams/{teamId}/members/{memberId}';
};

export type UpdateProjectTeamMemberErrors = {
    /**
     * Project, team, or member not found
     */
    404: unknown;
};

export type UpdateProjectTeamMemberResponses = {
    /**
     * Member role updated
     */
    200: ProjectTeamMember;
};

export type UpdateProjectTeamMemberResponse = UpdateProjectTeamMemberResponses[keyof UpdateProjectTeamMemberResponses];

export type ListProjectTeamsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/teams';
};

export type ListProjectTeamsErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type ListProjectTeamsResponses = {
    /**
     * Project team list
     */
    200: Array<ProjectTeam>;
};

export type ListProjectTeamsResponse = ListProjectTeamsResponses[keyof ListProjectTeamsResponses];

export type CreateProjectTeamData = {
    body?: ProjectTeamCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/teams';
};

export type CreateProjectTeamErrors = {
    /**
     * Invalid input
     */
    400: unknown;
    /**
     * Project not found
     */
    404: unknown;
    /**
     * Slug already in use
     */
    409: unknown;
};

export type CreateProjectTeamResponses = {
    /**
     * Team created
     */
    201: ProjectTeam;
};

export type CreateProjectTeamResponse = CreateProjectTeamResponses[keyof CreateProjectTeamResponses];

export type DeleteProjectTeamData = {
    body?: never;
    path: {
        id: string;
        teamId: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/teams/{teamId}';
};

export type DeleteProjectTeamErrors = {
    /**
     * Cannot archive default team
     */
    400: unknown;
    /**
     * Project or team not found
     */
    404: unknown;
};

export type DeleteProjectTeamResponses = {
    /**
     * Team archived
     */
    204: void;
};

export type DeleteProjectTeamResponse = DeleteProjectTeamResponses[keyof DeleteProjectTeamResponses];

export type GetProjectTeamData = {
    body?: never;
    path: {
        id: string;
        teamId: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/teams/{teamId}';
};

export type GetProjectTeamErrors = {
    /**
     * Project or team not found
     */
    404: unknown;
};

export type GetProjectTeamResponses = {
    /**
     * Project team
     */
    200: ProjectTeam;
};

export type GetProjectTeamResponse = GetProjectTeamResponses[keyof GetProjectTeamResponses];

export type UpdateProjectTeamData = {
    body?: ProjectTeamUpdate;
    path: {
        id: string;
        teamId: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/teams/{teamId}';
};

export type UpdateProjectTeamErrors = {
    /**
     * Invalid input or default-team kind change
     */
    400: unknown;
    /**
     * Project or team not found
     */
    404: unknown;
};

export type UpdateProjectTeamResponses = {
    /**
     * Team updated
     */
    200: ProjectTeam;
};

export type UpdateProjectTeamResponse = UpdateProjectTeamResponses[keyof UpdateProjectTeamResponses];

export type ListProjectMembersData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        role?: 'owner' | 'manager' | 'contributor' | 'observer';
        memberType?: 'user' | 'agent_instance' | 'workforce_member';
        includeInactive?: boolean | null;
    };
    url: '/api/v1/projects/{id}/members';
};

export type ListProjectMembersErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type ListProjectMembersResponses = {
    /**
     * Project member list
     */
    200: Array<ProjectMember>;
};

export type ListProjectMembersResponse = ListProjectMembersResponses[keyof ListProjectMembersResponses];

export type AddProjectMemberData = {
    body?: ProjectMemberAddRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/members';
};

export type AddProjectMemberErrors = {
    /**
     * Project not found
     */
    404: unknown;
    /**
     * Already a member
     */
    409: unknown;
};

export type AddProjectMemberResponses = {
    /**
     * Member added
     */
    201: ProjectMember;
};

export type AddProjectMemberResponse = AddProjectMemberResponses[keyof AddProjectMemberResponses];

export type RemoveProjectMemberData = {
    body?: never;
    path: {
        id: string;
        memberId: string;
    };
    query: {
        memberType: 'user' | 'agent_instance' | 'workforce_member';
    };
    url: '/api/v1/projects/{id}/members/{memberId}';
};

export type RemoveProjectMemberErrors = {
    /**
     * Cannot remove last owner
     */
    400: unknown;
    /**
     * Project not found
     */
    404: unknown;
};

export type RemoveProjectMemberResponses = {
    /**
     * Member removed
     */
    204: void;
};

export type RemoveProjectMemberResponse = RemoveProjectMemberResponses[keyof RemoveProjectMemberResponses];

export type UpdateProjectMemberRoleData = {
    body?: ProjectMemberUpdateRoleRequest;
    path: {
        id: string;
        memberId: string;
    };
    query: {
        memberType: 'user' | 'agent_instance' | 'workforce_member';
    };
    url: '/api/v1/projects/{id}/members/{memberId}';
};

export type UpdateProjectMemberRoleErrors = {
    /**
     * Invalid role or last-owner violation
     */
    400: unknown;
    /**
     * Project or member not found
     */
    404: unknown;
};

export type UpdateProjectMemberRoleResponses = {
    /**
     * Member role updated
     */
    200: ProjectMember;
};

export type UpdateProjectMemberRoleResponse = UpdateProjectMemberRoleResponses[keyof UpdateProjectMemberRoleResponses];

export type GetProjectStateData = {
    body?: never;
    path: {
        projectId: string;
    };
    query?: never;
    url: '/api/v1/projects/{projectId}/state';
};

export type GetProjectStateErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type GetProjectStateResponses = {
    /**
     * Durable state projections for gates, blockers, handoffs, action queue, and events
     */
    200: ProjectState;
};

export type GetProjectStateResponse = GetProjectStateResponses[keyof GetProjectStateResponses];

export type ListProjectStateEventsData = {
    body?: never;
    path: {
        projectId: string;
    };
    query?: {
        limit?: number;
    };
    url: '/api/v1/projects/{projectId}/events';
};

export type ListProjectStateEventsErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type ListProjectStateEventsResponses = {
    /**
     * Recent durable state events for a project
     */
    200: StateEventList;
};

export type ListProjectStateEventsResponse = ListProjectStateEventsResponses[keyof ListProjectStateEventsResponses];

export type ListProjectsData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'active' | 'on_hold' | 'archived' | 'closed';
        moduleId?: string;
        memberId?: number;
        memberType?: 'user' | 'agent_instance' | 'workforce_member';
        search?: string;
        includeDeleted?: boolean | null;
        limit?: number;
        after?: string;
        before?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'name';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
    };
    url: '/api/v1/projects';
};

export type ListProjectsResponses = {
    /**
     * Paginated project list
     */
    200: ProjectList;
};

export type ListProjectsResponse = ListProjectsResponses[keyof ListProjectsResponses];

export type CreateProjectData = {
    body?: ProjectCreate;
    path?: never;
    query?: never;
    url: '/api/v1/projects';
};

export type CreateProjectErrors = {
    /**
     * Validation error
     */
    400: unknown;
    /**
     * Slug conflict
     */
    409: unknown;
};

export type CreateProjectResponses = {
    /**
     * Project created
     */
    201: Project;
};

export type CreateProjectResponse = CreateProjectResponses[keyof CreateProjectResponses];

export type GetProjectCommandCenterData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/command-center';
};

export type GetProjectCommandCenterErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type GetProjectCommandCenterResponses = {
    /**
     * Project command center
     */
    200: ProjectCommandCenter;
};

export type GetProjectCommandCenterResponse = GetProjectCommandCenterResponses[keyof GetProjectCommandCenterResponses];

export type ListProjectWorkModeTemplatesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/work-mode-templates';
};

export type ListProjectWorkModeTemplatesErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type ListProjectWorkModeTemplatesResponses = {
    /**
     * Project work-mode templates with platform defaults and project overrides merged
     */
    200: Array<ProjectWorkModeTemplate>;
};

export type ListProjectWorkModeTemplatesResponse = ListProjectWorkModeTemplatesResponses[keyof ListProjectWorkModeTemplatesResponses];

export type ReplaceProjectWorkModeTemplatesData = {
    body?: {
        templates: Array<ProjectWorkModeTemplateInput>;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/work-mode-templates';
};

export type ReplaceProjectWorkModeTemplatesErrors = {
    /**
     * Invalid work-mode template payload
     */
    400: unknown;
    /**
     * Project not found
     */
    404: unknown;
};

export type ReplaceProjectWorkModeTemplatesResponses = {
    /**
     * Project work-mode templates after replacing project overrides
     */
    200: Array<ProjectWorkModeTemplate>;
};

export type ReplaceProjectWorkModeTemplatesResponse = ReplaceProjectWorkModeTemplatesResponses[keyof ReplaceProjectWorkModeTemplatesResponses];

export type ListProjectThreadsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/threads';
};

export type ListProjectThreadsResponses = {
    /**
     * Project threads
     */
    200: Array<ProjectThread>;
};

export type ListProjectThreadsResponse = ListProjectThreadsResponses[keyof ListProjectThreadsResponses];

export type CreateProjectThreadData = {
    body?: ProjectThreadCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/threads';
};

export type CreateProjectThreadResponses = {
    /**
     * Project thread created
     */
    201: ProjectThread;
};

export type CreateProjectThreadResponse = CreateProjectThreadResponses[keyof CreateProjectThreadResponses];

export type UpdateProjectThreadData = {
    body?: ProjectThreadUpdate;
    path: {
        id: string;
        threadId: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/threads/{threadId}';
};

export type UpdateProjectThreadResponses = {
    /**
     * Project thread updated
     */
    200: ProjectThread;
};

export type UpdateProjectThreadResponse = UpdateProjectThreadResponses[keyof UpdateProjectThreadResponses];

export type ListProjectChangesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        status?: 'draft' | 'open' | 'review' | 'blocked' | 'merged' | 'stalled' | 'closed';
        branches?: string;
        author?: 'all' | 'human' | 'agent';
        sort?: 'updated' | 'opened' | 'number' | 'status';
        q?: string;
        projectThreadId?: number;
    };
    url: '/api/v1/projects/{id}/changes';
};

export type ListProjectChangesErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type ListProjectChangesResponses = {
    /**
     * Project changes with stats
     */
    200: ProjectChangesResult;
};

export type ListProjectChangesResponse = ListProjectChangesResponses[keyof ListProjectChangesResponses];

export type CreateProjectChangeData = {
    body?: ProjectChangeCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/changes';
};

export type CreateProjectChangeResponses = {
    /**
     * Project change created
     */
    201: ProjectChange;
};

export type CreateProjectChangeResponse = CreateProjectChangeResponses[keyof CreateProjectChangeResponses];

export type GetProjectChangeData = {
    body?: never;
    path: {
        id: string;
        changeId: string;
    };
    query?: {
        expand?: string;
    };
    url: '/api/v1/projects/{id}/changes/{changeId}';
};

export type GetProjectChangeErrors = {
    /**
     * Change not found
     */
    404: unknown;
};

export type GetProjectChangeResponses = {
    /**
     * Change detail with tiered hydration
     */
    200: ProjectChangeView;
};

export type GetProjectChangeResponse = GetProjectChangeResponses[keyof GetProjectChangeResponses];

export type UpdateProjectChangeData = {
    body?: ProjectChangeUpdate;
    path: {
        id: string;
        changeId: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/changes/{changeId}';
};

export type UpdateProjectChangeResponses = {
    /**
     * Project change updated
     */
    200: ProjectChange;
};

export type UpdateProjectChangeResponse = UpdateProjectChangeResponses[keyof UpdateProjectChangeResponses];

export type GetProjectLogData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        range?: '1d' | '7d' | '30d' | '90d' | 'all';
        phase?: string;
        type?: string;
    };
    url: '/api/v1/projects/{id}/log';
};

export type GetProjectLogErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type GetProjectLogResponses = {
    /**
     * Project activity log (swimlane view)
     */
    200: ProjectLogResult;
};

export type GetProjectLogResponse = GetProjectLogResponses[keyof GetProjectLogResponses];

export type CreateProjectChangeRevisionData = {
    body?: ProjectChangeRevisionCreate;
    path: {
        id: string;
        changeId: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/changes/{changeId}/revisions';
};

export type CreateProjectChangeRevisionResponses = {
    /**
     * Project change revision created
     */
    201: ProjectChangeRevision;
};

export type CreateProjectChangeRevisionResponse = CreateProjectChangeRevisionResponses[keyof CreateProjectChangeRevisionResponses];

export type LinkProjectThreadResourceData = {
    body?: ProjectThreadResourceCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/thread-resources';
};

export type LinkProjectThreadResourceResponses = {
    /**
     * Project thread resource linked
     */
    201: ProjectThreadResource;
};

export type LinkProjectThreadResourceResponse = LinkProjectThreadResourceResponses[keyof LinkProjectThreadResourceResponses];

export type SoftDeleteProjectData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}';
};

export type SoftDeleteProjectErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type SoftDeleteProjectResponses = {
    /**
     * Project soft-deleted
     */
    204: void;
};

export type SoftDeleteProjectResponse = SoftDeleteProjectResponses[keyof SoftDeleteProjectResponses];

export type GetProjectData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}';
};

export type GetProjectErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type GetProjectResponses = {
    /**
     * Project
     */
    200: Project;
};

export type GetProjectResponse = GetProjectResponses[keyof GetProjectResponses];

export type UpdateProjectData = {
    body?: ProjectUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}';
};

export type UpdateProjectErrors = {
    /**
     * Project not found
     */
    404: unknown;
    /**
     * Slug conflict
     */
    409: unknown;
};

export type UpdateProjectResponses = {
    /**
     * Updated project
     */
    200: Project;
};

export type UpdateProjectResponse = UpdateProjectResponses[keyof UpdateProjectResponses];

export type ArchiveProjectData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/archive';
};

export type ArchiveProjectErrors = {
    /**
     * Invalid state transition
     */
    400: unknown;
    /**
     * Project not found
     */
    404: unknown;
};

export type ArchiveProjectResponses = {
    /**
     * Project archived
     */
    200: Project;
};

export type ArchiveProjectResponse = ArchiveProjectResponses[keyof ArchiveProjectResponses];

export type ReactivateProjectData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/reactivate';
};

export type ReactivateProjectErrors = {
    /**
     * Invalid state transition
     */
    400: unknown;
    /**
     * Project not found
     */
    404: unknown;
};

export type ReactivateProjectResponses = {
    /**
     * Project reactivated
     */
    200: Project;
};

export type ReactivateProjectResponse = ReactivateProjectResponses[keyof ReactivateProjectResponses];

export type CloseProjectData = {
    body?: ProjectCloseRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/close';
};

export type CloseProjectErrors = {
    /**
     * Invalid state transition
     */
    400: unknown;
    /**
     * Project not found
     */
    404: unknown;
};

export type CloseProjectResponses = {
    /**
     * Project closed
     */
    200: Project;
};

export type CloseProjectResponse = CloseProjectResponses[keyof CloseProjectResponses];

export type GetProjectSummaryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/projects/{id}/summary';
};

export type GetProjectSummaryErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type GetProjectSummaryResponses = {
    /**
     * Project summary with counts
     */
    200: ProjectSummary;
};

export type GetProjectSummaryResponse = GetProjectSummaryResponses[keyof GetProjectSummaryResponses];

export type ListActionQueueData = {
    body?: never;
    path?: never;
    query?: {
        projectId?: number;
        targetActorType?: 'human_user' | 'agent' | 'daemon' | 'system' | 'worker' | 'api' | 'service_account';
        targetActorId?: string;
        targetActorClass?: string;
        statuses?: string;
        limit?: number;
    };
    url: '/api/v1/coordination/action-queue';
};

export type ListActionQueueResponses = {
    /**
     * Open or filtered action queue items visible to the caller capability surface
     */
    200: ActionQueueList;
};

export type ListActionQueueResponse = ListActionQueueResponses[keyof ListActionQueueResponses];

export type ClaimActionQueueItemData = {
    body?: ActionQueueClaimInput;
    path: {
        itemId: string;
    };
    query?: never;
    url: '/api/v1/coordination/action-queue/{itemId}/claim';
};

export type ClaimActionQueueItemErrors = {
    /**
     * Action queue item not found
     */
    404: unknown;
    /**
     * Action queue item is not claimable
     */
    409: unknown;
};

export type ClaimActionQueueItemResponses = {
    /**
     * Action queue item claimed by the current actor
     */
    200: CoordinationActionQueueItem;
};

export type ClaimActionQueueItemResponse = ClaimActionQueueItemResponses[keyof ClaimActionQueueItemResponses];

export type ResolveActionQueueItemData = {
    body?: ActionQueueResolveInput;
    path: {
        itemId: string;
    };
    query?: never;
    url: '/api/v1/coordination/action-queue/{itemId}/resolve';
};

export type ResolveActionQueueItemErrors = {
    /**
     * Action queue item not found
     */
    404: unknown;
};

export type ResolveActionQueueItemResponses = {
    /**
     * Action queue item resolved by the current actor
     */
    200: CoordinationActionQueueItem;
};

export type ResolveActionQueueItemResponse = ResolveActionQueueItemResponses[keyof ResolveActionQueueItemResponses];

export type DecideGateData = {
    body?: GateDecisionInput;
    path: {
        gateId: string;
    };
    query?: never;
    url: '/api/v1/coordination/gates/{gateId}/decisions';
};

export type DecideGateErrors = {
    /**
     * Gate not found
     */
    404: unknown;
    /**
     * Invalid transition or gate already decided
     */
    409: unknown;
};

export type DecideGateResponses = {
    /**
     * Gate decided
     */
    200: CoordinationGate;
};

export type DecideGateResponse = DecideGateResponses[keyof DecideGateResponses];

export type TransitionBlockerData = {
    body?: BlockerTransitionInput;
    path: {
        blockerId: string;
    };
    query?: never;
    url: '/api/v1/coordination/blockers/{blockerId}/transitions';
};

export type TransitionBlockerErrors = {
    /**
     * Blocker not found
     */
    404: unknown;
    /**
     * Invalid transition
     */
    409: unknown;
};

export type TransitionBlockerResponses = {
    /**
     * Blocker transitioned
     */
    200: CoordinationBlocker;
};

export type TransitionBlockerResponse = TransitionBlockerResponses[keyof TransitionBlockerResponses];

export type TransitionHandoffData = {
    body?: HandoffTransitionInput;
    path: {
        handoffId: string;
    };
    query?: never;
    url: '/api/v1/coordination/handoffs/{handoffId}/transitions';
};

export type TransitionHandoffErrors = {
    /**
     * Handoff not found
     */
    404: unknown;
    /**
     * Invalid transition
     */
    409: unknown;
};

export type TransitionHandoffResponses = {
    /**
     * Handoff transitioned
     */
    200: CoordinationHandoff;
};

export type TransitionHandoffResponse = TransitionHandoffResponses[keyof TransitionHandoffResponses];

export type ListTaskDecisionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/decisions';
};

export type ListTaskDecisionsErrors = {
    /**
     * Task not found
     */
    404: unknown;
};

export type ListTaskDecisionsResponses = {
    /**
     * Pending decisions for this task (bounded, typically 0–3)
     */
    200: Array<TaskDecision>;
};

export type ListTaskDecisionsResponse = ListTaskDecisionsResponses[keyof ListTaskDecisionsResponses];

export type StartTaskData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/start';
};

export type StartTaskErrors = {
    /**
     * Task not found
     */
    404: unknown;
    /**
     * Task not in pending state
     */
    409: unknown;
};

export type StartTaskResponses = {
    /**
     * Task started (pending → in_progress)
     */
    200: Task;
};

export type StartTaskResponse = StartTaskResponses[keyof StartTaskResponses];

export type CancelTaskData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/cancel';
};

export type CancelTaskErrors = {
    /**
     * Task not found
     */
    404: unknown;
    /**
     * Task already in a terminal state
     */
    409: unknown;
};

export type CancelTaskResponses = {
    /**
     * Task cancelled
     */
    200: Task;
};

export type CancelTaskResponse = CancelTaskResponses[keyof CancelTaskResponses];

export type ApproveTaskActionData = {
    body?: TaskApproveActionRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/approve-action';
};

export type ApproveTaskActionErrors = {
    /**
     * Task or decision not found
     */
    404: unknown;
    /**
     * Task not in awaiting_approval state
     */
    409: unknown;
};

export type ApproveTaskActionResponses = {
    /**
     * Action approved; task resumes
     */
    200: Task;
};

export type ApproveTaskActionResponse = ApproveTaskActionResponses[keyof ApproveTaskActionResponses];

export type RejectTaskActionData = {
    body?: TaskRejectActionRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/reject-action';
};

export type RejectTaskActionErrors = {
    /**
     * Task or decision not found
     */
    404: unknown;
    /**
     * Task not in awaiting_approval state
     */
    409: unknown;
};

export type RejectTaskActionResponses = {
    /**
     * Action rejected; task transitions to failed
     */
    200: Task;
};

export type RejectTaskActionResponse = RejectTaskActionResponses[keyof RejectTaskActionResponses];

export type ExtendApprovalTimeoutData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/extend-approval';
};

export type ExtendApprovalTimeoutErrors = {
    /**
     * Task not found
     */
    404: unknown;
    /**
     * Task not in awaiting_approval state
     */
    409: unknown;
};

export type ExtendApprovalTimeoutResponses = {
    /**
     * Approval timer reset; task remains in awaiting_approval
     */
    200: Task;
};

export type ExtendApprovalTimeoutResponse = ExtendApprovalTimeoutResponses[keyof ExtendApprovalTimeoutResponses];

export type CompleteTaskData = {
    body?: TaskCompleteRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/complete';
};

export type CompleteTaskErrors = {
    /**
     * Invalid memory IDs
     */
    400: unknown;
    /**
     * Task not found
     */
    404: unknown;
    /**
     * Task not in in_progress state
     */
    409: unknown;
};

export type CompleteTaskResponses = {
    /**
     * Task completed; memories promoted as requested
     */
    200: Task;
};

export type CompleteTaskResponse = CompleteTaskResponses[keyof CompleteTaskResponses];

export type RetryTaskData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/retry';
};

export type RetryTaskErrors = {
    /**
     * Task not found
     */
    404: unknown;
    /**
     * Task not in failed or cancelled state
     */
    409: unknown;
};

export type RetryTaskResponses = {
    /**
     * Task reset for retry
     */
    200: Task;
};

export type RetryTaskResponse = RetryTaskResponses[keyof RetryTaskResponses];

export type ReassignTaskData = {
    body?: TaskReassignRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/reassign';
};

export type ReassignTaskErrors = {
    /**
     * Task not found
     */
    404: unknown;
    /**
     * Task already in terminal state
     */
    409: unknown;
};

export type ReassignTaskResponses = {
    /**
     * Task reassigned
     */
    200: Task;
};

export type ReassignTaskResponse = ReassignTaskResponses[keyof ReassignTaskResponses];

export type TransferTaskTeamData = {
    body?: TaskTransferTeamRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}/transfer-team';
};

export type TransferTaskTeamErrors = {
    /**
     * Task not found
     */
    404: unknown;
    /**
     * Target team not in the same project
     */
    409: unknown;
};

export type TransferTaskTeamResponses = {
    /**
     * Task team transferred
     */
    200: Task;
};

export type TransferTaskTeamResponse = TransferTaskTeamResponses[keyof TransferTaskTeamResponses];

export type ListTasksData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'pending' | 'in_progress' | 'awaiting_approval' | 'awaiting_user' | 'completed' | 'failed' | 'cancelled' | string;
        projectId?: number;
        teamId?: number;
        baseTemplateId?: number;
        createdBy?: number;
        originType?: 'manual' | 'conversation' | 'project' | 'workflow_step' | 'daemon_finding' | 'artifact' | 'api' | 'decision';
        assigneeType?: 'user' | 'workforce_member' | 'daemon' | 'template' | 'tool' | 'workflow';
        limit?: number;
        before?: string;
        after?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'deadlineAt' | 'status';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
    };
    url: '/api/v1/tasks';
};

export type ListTasksResponses = {
    /**
     * Paginated task list
     */
    200: TaskList;
};

export type ListTasksResponse = ListTasksResponses[keyof ListTasksResponses];

export type CreateTaskData = {
    body?: TaskCreate;
    path?: never;
    query?: never;
    url: '/api/v1/tasks';
};

export type CreateTaskErrors = {
    /**
     * Invalid input
     */
    400: unknown;
};

export type CreateTaskResponses = {
    /**
     * Task created
     */
    201: Task;
};

export type CreateTaskResponse = CreateTaskResponses[keyof CreateTaskResponses];

export type DeleteTaskData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}';
};

export type DeleteTaskErrors = {
    /**
     * Task not found
     */
    404: unknown;
    /**
     * Task not in pending state
     */
    409: unknown;
};

export type DeleteTaskResponses = {
    /**
     * Task deleted
     */
    200: {
        message: string;
    };
};

export type DeleteTaskResponse = DeleteTaskResponses[keyof DeleteTaskResponses];

export type GetTaskData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}';
};

export type GetTaskErrors = {
    /**
     * Task not found
     */
    404: unknown;
};

export type GetTaskResponses = {
    /**
     * Task detail
     */
    200: Task;
};

export type GetTaskResponse = GetTaskResponses[keyof GetTaskResponses];

export type UpdateTaskData = {
    body?: TaskUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/tasks/{id}';
};

export type UpdateTaskErrors = {
    /**
     * Invalid input
     */
    400: unknown;
    /**
     * Task not found
     */
    404: unknown;
    /**
     * Task not in pending state
     */
    409: unknown;
};

export type UpdateTaskResponses = {
    /**
     * Task updated
     */
    200: Task;
};

export type UpdateTaskResponse = UpdateTaskResponses[keyof UpdateTaskResponses];

export type ListInterventionsData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'open' | 'reviewing' | 'routed' | 'resolved' | 'rejected';
        type?: 'fix' | 'improve' | 'investigate' | 'decision' | 'contract_repair' | 'version_change' | 'worker_unavailable' | 'policy_blocker';
        severity?: 'info' | 'warning' | 'error' | 'critical';
        requestedOutcome?: 'task' | 'decision' | 'workflow_draft' | 'workflow_version' | 'workforce_route' | 'workstream_link' | 'log_only';
        sourceType?: 'workflow' | 'workflow_run' | 'workflow_step' | 'task' | 'template' | 'project' | 'artifact' | 'workforce' | 'daemon' | 'catalog_item' | 'catalog_version' | 'decision';
        assignedToId?: string;
        limit?: number;
    };
    url: '/api/v1/action-requests';
};

export type ListInterventionsResponses = {
    /**
     * Action Requests
     */
    200: {
        data: Array<Intervention>;
    };
};

export type ListInterventionsResponse = ListInterventionsResponses[keyof ListInterventionsResponses];

export type CreateInterventionData = {
    body?: InterventionCreate;
    path?: never;
    query?: never;
    url: '/api/v1/action-requests';
};

export type CreateInterventionErrors = {
    /**
     * Forbidden
     */
    403: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type CreateInterventionError = CreateInterventionErrors[keyof CreateInterventionErrors];

export type CreateInterventionResponses = {
    /**
     * Created
     */
    201: Intervention;
};

export type CreateInterventionResponse = CreateInterventionResponses[keyof CreateInterventionResponses];

export type GetInterventionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/action-requests/{id}';
};

export type GetInterventionErrors = {
    /**
     * Forbidden
     */
    403: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Not found
     */
    404: unknown;
};

export type GetInterventionError = GetInterventionErrors[keyof GetInterventionErrors];

export type GetInterventionResponses = {
    /**
     * Action Request detail
     */
    200: {
        request: Intervention;
        timeline: Array<InterventionEvent>;
    };
};

export type GetInterventionResponse = GetInterventionResponses[keyof GetInterventionResponses];

export type RouteInterventionData = {
    body?: InterventionRouteRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/action-requests/{id}/route';
};

export type RouteInterventionErrors = {
    /**
     * Forbidden
     */
    403: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Not found
     */
    404: unknown;
};

export type RouteInterventionError = RouteInterventionErrors[keyof RouteInterventionErrors];

export type RouteInterventionResponses = {
    /**
     * Routed
     */
    200: Intervention;
};

export type RouteInterventionResponse = RouteInterventionResponses[keyof RouteInterventionResponses];

export type ResolveInterventionData = {
    body?: InterventionResolveRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/action-requests/{id}/resolve';
};

export type ResolveInterventionErrors = {
    /**
     * Forbidden
     */
    403: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Not found
     */
    404: unknown;
};

export type ResolveInterventionError = ResolveInterventionErrors[keyof ResolveInterventionErrors];

export type ResolveInterventionResponses = {
    /**
     * Resolved
     */
    200: Intervention;
};

export type ResolveInterventionResponse = ResolveInterventionResponses[keyof ResolveInterventionResponses];

export type RejectInterventionData = {
    body?: InterventionRejectRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/action-requests/{id}/reject';
};

export type RejectInterventionErrors = {
    /**
     * Forbidden
     */
    403: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * Not found
     */
    404: unknown;
};

export type RejectInterventionError = RejectInterventionErrors[keyof RejectInterventionErrors];

export type RejectInterventionResponses = {
    /**
     * Rejected
     */
    200: Intervention;
};

export type RejectInterventionResponse = RejectInterventionResponses[keyof RejectInterventionResponses];

export type ListWorkstreamMembersData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workstreams/{id}/members';
};

export type ListWorkstreamMembersErrors = {
    /**
     * Workstream not found
     */
    404: unknown;
};

export type ListWorkstreamMembersResponses = {
    /**
     * Active workstream members (oldest first)
     */
    200: Array<WorkstreamMember>;
};

export type ListWorkstreamMembersResponse = ListWorkstreamMembersResponses[keyof ListWorkstreamMembersResponses];

export type AddWorkstreamMemberData = {
    body?: WorkstreamMemberAdd;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workstreams/{id}/members';
};

export type AddWorkstreamMemberErrors = {
    /**
     * Workstream not found
     */
    404: unknown;
    /**
     * Member already active in this workstream
     */
    409: unknown;
};

export type AddWorkstreamMemberResponses = {
    /**
     * Member added
     */
    201: WorkstreamMember;
};

export type AddWorkstreamMemberResponse = AddWorkstreamMemberResponses[keyof AddWorkstreamMemberResponses];

export type RemoveWorkstreamMemberData = {
    body?: never;
    path: {
        id: string;
        memberId: string;
    };
    query: {
        memberType: 'user' | 'agent_instance' | 'workforce_member';
    };
    url: '/api/v1/workstreams/{id}/members/{memberId}';
};

export type RemoveWorkstreamMemberErrors = {
    /**
     * Workstream or member not found
     */
    404: unknown;
};

export type RemoveWorkstreamMemberResponses = {
    /**
     * Member removed
     */
    200: {
        removed: boolean;
    };
};

export type RemoveWorkstreamMemberResponse = RemoveWorkstreamMemberResponses[keyof RemoveWorkstreamMemberResponses];

export type ListWorkstreamDecisionsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        decisionType?: string;
        limit?: number;
        before?: string;
        after?: string;
        sort_order?: 'asc' | 'desc';
    };
    url: '/api/v1/workstreams/{id}/decisions';
};

export type ListWorkstreamDecisionsErrors = {
    /**
     * Workstream not found
     */
    404: unknown;
};

export type ListWorkstreamDecisionsResponses = {
    /**
     * Paginated decision audit trail
     */
    200: DecisionList;
};

export type ListWorkstreamDecisionsResponse = ListWorkstreamDecisionsResponses[keyof ListWorkstreamDecisionsResponses];

export type ListWorkstreamsData = {
    body?: never;
    path?: never;
    query?: {
        projectId?: number;
        projectChangeId?: number;
        status?: 'active' | 'paused' | 'archived' | 'completed';
        focus?: 'feature' | 'marketing' | 'research' | 'ops' | 'support' | 'general';
        managerAgentId?: number;
        limit?: number;
        before?: string;
        after?: string;
        sort_by?: 'createdAt' | 'updatedAt' | 'name';
        sort_order?: 'asc' | 'desc';
        include_total?: boolean | null;
    };
    url: '/api/v1/workstreams';
};

export type ListWorkstreamsResponses = {
    /**
     * Paginated workstream list
     */
    200: WorkstreamList;
};

export type ListWorkstreamsResponse = ListWorkstreamsResponses[keyof ListWorkstreamsResponses];

export type CreateWorkstreamData = {
    body?: WorkstreamCreate;
    path?: never;
    query?: never;
    url: '/api/v1/workstreams';
};

export type CreateWorkstreamErrors = {
    /**
     * Validation error
     */
    400: unknown;
};

export type CreateWorkstreamResponses = {
    /**
     * Created
     */
    201: Workstream;
};

export type CreateWorkstreamResponse = CreateWorkstreamResponses[keyof CreateWorkstreamResponses];

export type ArchiveWorkstreamData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workstreams/{id}';
};

export type ArchiveWorkstreamErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ArchiveWorkstreamResponses = {
    /**
     * Archived
     */
    200: Workstream;
};

export type ArchiveWorkstreamResponse = ArchiveWorkstreamResponses[keyof ArchiveWorkstreamResponses];

export type GetWorkstreamData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workstreams/{id}';
};

export type GetWorkstreamErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetWorkstreamResponses = {
    /**
     * Workstream
     */
    200: Workstream;
};

export type GetWorkstreamResponse = GetWorkstreamResponses[keyof GetWorkstreamResponses];

export type UpdateWorkstreamData = {
    body?: WorkstreamUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/workstreams/{id}';
};

export type UpdateWorkstreamErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateWorkstreamResponses = {
    /**
     * Updated
     */
    200: Workstream;
};

export type UpdateWorkstreamResponse = UpdateWorkstreamResponses[keyof UpdateWorkstreamResponses];

export type ListApproverDelegationsData = {
    body?: never;
    path?: never;
    query?: {
        activeOnly?: boolean | null;
    };
    url: '/api/v1/approvals/delegations';
};

export type ListApproverDelegationsErrors = {
    /**
     * Authentication required
     */
    401: unknown;
};

export type ListApproverDelegationsResponses = {
    /**
     * Delegations involving the caller (granted or received)
     */
    200: Array<ApproverDelegation>;
};

export type ListApproverDelegationsResponse = ListApproverDelegationsResponses[keyof ListApproverDelegationsResponses];

export type CreateApproverDelegationData = {
    body?: ApproverDelegationCreate;
    path?: never;
    query?: never;
    url: '/api/v1/approvals/delegations';
};

export type CreateApproverDelegationErrors = {
    /**
     * Validation error (self-delegate, past expiry, invalid pattern)
     */
    400: unknown;
    /**
     * Authentication required
     */
    401: unknown;
};

export type CreateApproverDelegationResponses = {
    /**
     * Delegation granted
     */
    201: ApproverDelegation;
};

export type CreateApproverDelegationResponse = CreateApproverDelegationResponses[keyof CreateApproverDelegationResponses];

export type RevokeApproverDelegationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/approvals/delegations/{id}';
};

export type RevokeApproverDelegationErrors = {
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Not a party to this delegation
     */
    403: unknown;
    /**
     * Delegation not found
     */
    404: unknown;
    /**
     * Already revoked
     */
    409: unknown;
};

export type RevokeApproverDelegationResponses = {
    /**
     * Delegation revoked
     */
    200: ApproverDelegation;
};

export type RevokeApproverDelegationResponse = RevokeApproverDelegationResponses[keyof RevokeApproverDelegationResponses];

export type ListPromotionCandidatesData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'pending' | 'all';
        limit?: number;
    };
    url: '/api/v1/admin/promotion-candidates';
};

export type ListPromotionCandidatesResponses = {
    /**
     * Promotion candidates (default: pending only)
     */
    200: Array<PromotionCandidate>;
};

export type ListPromotionCandidatesResponse = ListPromotionCandidatesResponses[keyof ListPromotionCandidatesResponses];

export type GetPromotionCandidateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/promotion-candidates/{id}';
};

export type GetPromotionCandidateErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetPromotionCandidateResponses = {
    /**
     * Candidate
     */
    200: PromotionCandidate;
};

export type GetPromotionCandidateResponse = GetPromotionCandidateResponses[keyof GetPromotionCandidateResponses];

export type AcceptPromotionCandidateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/promotion-candidates/{id}/accept';
};

export type AcceptPromotionCandidateErrors = {
    /**
     * Validation error in candidate payload
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Already reviewed or no changes to apply
     */
    409: unknown;
};

export type AcceptPromotionCandidateResponses = {
    /**
     * Candidate accepted; unified diff returned
     */
    200: PromotionAcceptResult;
};

export type AcceptPromotionCandidateResponse = AcceptPromotionCandidateResponses[keyof AcceptPromotionCandidateResponses];

export type RejectPromotionCandidateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/promotion-candidates/{id}/reject';
};

export type RejectPromotionCandidateErrors = {
    /**
     * Not found
     */
    404: unknown;
    /**
     * Already reviewed
     */
    409: unknown;
};

export type RejectPromotionCandidateResponses = {
    /**
     * Candidate rejected
     */
    200: PromotionCandidate;
};

export type RejectPromotionCandidateResponse = RejectPromotionCandidateResponses[keyof RejectPromotionCandidateResponses];

export type ListAdminDaemonFindingsData = {
    body?: never;
    path?: never;
    query?: {
        category?: 'vulnerability' | 'quality-issue' | 'optimization' | 'insight' | 'alert' | 'template-ecosystem' | 'promotion_candidate' | 'intent_classification_review' | 'edge_decay' | 'survivorship_bias_report';
        severity?: 'info' | 'low' | 'medium' | 'high' | 'critical';
        reviewStatus?: 'pending' | 'approved' | 'rejected' | 'deferred' | 'quarantined';
        limit?: number;
    };
    url: '/api/v1/admin/daemon-findings';
};

export type ListAdminDaemonFindingsResponses = {
    /**
     * Daemon findings for the org
     */
    200: Array<DaemonFinding>;
};

export type ListAdminDaemonFindingsResponse = ListAdminDaemonFindingsResponses[keyof ListAdminDaemonFindingsResponses];

export type ListDeadLetterEntriesData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'quarantined' | 'replaying' | 'replayed' | 'discarded';
        stream?: string;
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/admin/dead-letter-entries';
};

export type ListDeadLetterEntriesResponses = {
    /**
     * Dead-letter entries (filterable by status/stream)
     */
    200: DeadLetterEntryList;
};

export type ListDeadLetterEntriesResponse = ListDeadLetterEntriesResponses[keyof ListDeadLetterEntriesResponses];

export type ReplayDeadLetterEntryData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/dead-letter-entries/{id}/replay';
};

export type ReplayDeadLetterEntryErrors = {
    /**
     * Failure reason is not replayable
     */
    400: unknown;
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Already claimed/replayed/discarded
     */
    409: unknown;
};

export type ReplayDeadLetterEntryResponses = {
    /**
     * Entry replayed onto its origin stream; updated entry returned
     */
    200: DeadLetterEntry;
};

export type ReplayDeadLetterEntryResponse = ReplayDeadLetterEntryResponses[keyof ReplayDeadLetterEntryResponses];

export type ListPlatformRuntimeFlagsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/runtime-flags/platform';
};

export type ListPlatformRuntimeFlagsErrors = {
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Superadmin required
     */
    403: unknown;
};

export type ListPlatformRuntimeFlagsResponses = {
    /**
     * Platform runtime flags with resolved value and source
     */
    200: RuntimeFlagList;
};

export type ListPlatformRuntimeFlagsResponse = ListPlatformRuntimeFlagsResponses[keyof ListPlatformRuntimeFlagsResponses];

export type SetPlatformRuntimeFlagData = {
    body: RuntimeFlagUpdate;
    path: {
        key: 'platform.server_runs_schedulers' | 'platform.server_runs_market_data_aggregator' | 'platform.finance_pynecore_validation_enabled' | 'platform.finance_signal_aggregation_enabled' | 'platform.finance_signal_outcome_scoring_enabled' | 'platform.finance_strategy_runner_enabled' | 'platform.tool_scout_enabled' | 'finance.live_trading_enabled' | 'marketplace.auto_upgrade_acquisitions';
    };
    query?: never;
    url: '/api/v1/admin/runtime-flags/platform/{key}';
};

export type SetPlatformRuntimeFlagErrors = {
    /**
     * Unknown flag key, or the key is organization-scoped
     */
    400: unknown;
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Superadmin required
     */
    403: unknown;
};

export type SetPlatformRuntimeFlagResponses = {
    /**
     * Flag written; resolved state returned
     */
    200: RuntimeFlag;
};

export type SetPlatformRuntimeFlagResponse = SetPlatformRuntimeFlagResponses[keyof SetPlatformRuntimeFlagResponses];

export type ListOrganizationRuntimeFlagsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/runtime-flags/organization';
};

export type ListOrganizationRuntimeFlagsErrors = {
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Organization settings permission required
     */
    403: unknown;
};

export type ListOrganizationRuntimeFlagsResponses = {
    /**
     * Organization runtime flags with resolved value and source
     */
    200: RuntimeFlagList;
};

export type ListOrganizationRuntimeFlagsResponse = ListOrganizationRuntimeFlagsResponses[keyof ListOrganizationRuntimeFlagsResponses];

export type SetOrganizationRuntimeFlagData = {
    body: RuntimeFlagUpdate;
    path: {
        key: 'platform.server_runs_schedulers' | 'platform.server_runs_market_data_aggregator' | 'platform.finance_pynecore_validation_enabled' | 'platform.finance_signal_aggregation_enabled' | 'platform.finance_signal_outcome_scoring_enabled' | 'platform.finance_strategy_runner_enabled' | 'platform.tool_scout_enabled' | 'finance.live_trading_enabled' | 'marketplace.auto_upgrade_acquisitions';
    };
    query?: never;
    url: '/api/v1/admin/runtime-flags/organization/{key}';
};

export type SetOrganizationRuntimeFlagErrors = {
    /**
     * Unknown flag key, or the key is platform-scoped
     */
    400: unknown;
    /**
     * Authentication required
     */
    401: unknown;
    /**
     * Organization settings permission required
     */
    403: unknown;
};

export type SetOrganizationRuntimeFlagResponses = {
    /**
     * Flag written for the caller organization; resolved state returned
     */
    200: RuntimeFlag;
};

export type SetOrganizationRuntimeFlagResponse = SetOrganizationRuntimeFlagResponses[keyof SetOrganizationRuntimeFlagResponses];

export type GetSystemOverviewData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/system/overview';
};

export type GetSystemOverviewResponses = {
    /**
     * Boxes, databases and what needs attention
     */
    200: SystemOverview;
};

export type GetSystemOverviewResponse = GetSystemOverviewResponses[keyof GetSystemOverviewResponses];

export type GetSystemHostData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/admin/system/hosts/{id}';
};

export type GetSystemHostErrors = {
    /**
     * Nothing by that id has reported
     */
    404: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * The metrics hub is not configured or did not answer
     */
    503: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type GetSystemHostError = GetSystemHostErrors[keyof GetSystemHostErrors];

export type GetSystemHostResponses = {
    /**
     * One box now
     */
    200: SystemHost;
};

export type GetSystemHostResponse = GetSystemHostResponses[keyof GetSystemHostResponses];

export type GetSystemHostSeriesData = {
    body?: never;
    path: {
        id: string;
    };
    query: {
        panel: 'cpu' | 'load' | 'memory' | 'pressure' | 'disk-busy' | 'disk-io' | 'filesystems' | 'network' | 'temperature' | 'gpu' | 'gpu-temperature' | 'gpu-power' | 'units-cpu' | 'units-memory';
        range?: '1h' | '6h' | '24h' | '7d' | '30d' | '90d' | '1y';
    };
    url: '/api/v1/admin/system/hosts/{id}/series';
};

export type GetSystemHostSeriesErrors = {
    /**
     * The metrics hub is not configured or did not answer
     */
    503: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type GetSystemHostSeriesError = GetSystemHostSeriesErrors[keyof GetSystemHostSeriesErrors];

export type GetSystemHostSeriesResponses = {
    /**
     * One chart of a box's history
     */
    200: MetricSeriesSet;
};

export type GetSystemHostSeriesResponse = GetSystemHostSeriesResponses[keyof GetSystemHostSeriesResponses];

export type GetSystemDatabaseData = {
    body?: never;
    path: {
        id: 'app' | 'market';
    };
    query?: never;
    url: '/api/v1/admin/system/databases/{id}';
};

export type GetSystemDatabaseErrors = {
    /**
     * Nothing by that id has reported
     */
    404: {
        error: {
            code: string;
            message: string;
        };
    };
    /**
     * The metrics hub is not configured or did not answer
     */
    503: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type GetSystemDatabaseError = GetSystemDatabaseErrors[keyof GetSystemDatabaseErrors];

export type GetSystemDatabaseResponses = {
    /**
     * One database now
     */
    200: SystemDatabase;
};

export type GetSystemDatabaseResponse = GetSystemDatabaseResponses[keyof GetSystemDatabaseResponses];

export type GetSystemDatabaseSeriesData = {
    body?: never;
    path: {
        id: 'app' | 'market';
    };
    query: {
        panel: 'transactions' | 'rows' | 'connections' | 'connections-used' | 'cache-hit' | 'locks' | 'transaction-age' | 'temp' | 'wal' | 'size' | 'xid-age';
        range?: '1h' | '6h' | '24h' | '7d' | '30d' | '90d' | '1y';
    };
    url: '/api/v1/admin/system/databases/{id}/series';
};

export type GetSystemDatabaseSeriesErrors = {
    /**
     * The metrics hub is not configured or did not answer
     */
    503: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type GetSystemDatabaseSeriesError = GetSystemDatabaseSeriesErrors[keyof GetSystemDatabaseSeriesErrors];

export type GetSystemDatabaseSeriesResponses = {
    /**
     * One chart of a database's history
     */
    200: MetricSeriesSet;
};

export type GetSystemDatabaseSeriesResponse = GetSystemDatabaseSeriesResponses[keyof GetSystemDatabaseSeriesResponses];

export type ListSystemDatabaseStatementsData = {
    body?: never;
    path: {
        id: 'app' | 'market';
    };
    query?: {
        range?: '1h' | '6h' | '24h' | '7d' | '30d' | '90d' | '1y';
    };
    url: '/api/v1/admin/system/databases/{id}/statements';
};

export type ListSystemDatabaseStatementsErrors = {
    /**
     * The metrics hub is not configured or did not answer
     */
    503: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type ListSystemDatabaseStatementsError = ListSystemDatabaseStatementsErrors[keyof ListSystemDatabaseStatementsErrors];

export type ListSystemDatabaseStatementsResponses = {
    /**
     * The statements that took the most database time in the range
     */
    200: Array<SystemStatement>;
};

export type ListSystemDatabaseStatementsResponse = ListSystemDatabaseStatementsResponses[keyof ListSystemDatabaseStatementsResponses];

export type GetSystemRedisData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/admin/system/redis';
};

export type GetSystemRedisResponses = {
    /**
     * Redis now and the platform streams' backlog
     */
    200: SystemRedis;
};

export type GetSystemRedisResponse = GetSystemRedisResponses[keyof GetSystemRedisResponses];

export type GetSystemRedisSeriesData = {
    body?: never;
    path?: never;
    query: {
        panel: 'memory' | 'commands' | 'clients';
        range?: '1h' | '6h' | '24h' | '7d' | '30d' | '90d' | '1y';
    };
    url: '/api/v1/admin/system/redis/series';
};

export type GetSystemRedisSeriesErrors = {
    /**
     * The metrics hub is not configured or did not answer
     */
    503: {
        error: {
            code: string;
            message: string;
        };
    };
};

export type GetSystemRedisSeriesError = GetSystemRedisSeriesErrors[keyof GetSystemRedisSeriesErrors];

export type GetSystemRedisSeriesResponses = {
    /**
     * One chart of Redis's history
     */
    200: MetricSeriesSet;
};

export type GetSystemRedisSeriesResponse = GetSystemRedisSeriesResponses[keyof GetSystemRedisSeriesResponses];

export type CancelAllOrdersData = {
    body?: never;
    path?: never;
    query?: {
        symbol?: string;
    };
    url: '/api/v1/finance/trading/orders';
};

export type CancelAllOrdersResponses = {
    /**
     * All orders cancelled
     */
    200: {
        success: boolean;
        cancelled: number;
    };
};

export type CancelAllOrdersResponse = CancelAllOrdersResponses[keyof CancelAllOrdersResponses];

export type ListOrdersData = {
    body?: never;
    path?: never;
    query?: {
        symbol?: string;
        status?: 'open' | 'all';
        limit?: string;
    };
    url: '/api/v1/finance/trading/orders';
};

export type ListOrdersResponses = {
    /**
     * Order list
     */
    200: {
        data: Array<Order>;
        count: number;
    };
};

export type ListOrdersResponse = ListOrdersResponses[keyof ListOrdersResponses];

export type CreateOrderData = {
    body?: OrderCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/trading/orders';
};

export type CreateOrderErrors = {
    /**
     * Validation error
     */
    400: unknown;
};

export type CreateOrderResponses = {
    /**
     * Order created
     */
    201: {
        success: boolean;
        order: Order;
    };
};

export type CreateOrderResponse = CreateOrderResponses[keyof CreateOrderResponses];

export type CancelOrderData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/orders/{id}';
};

export type CancelOrderErrors = {
    /**
     * Order not found
     */
    404: unknown;
};

export type CancelOrderResponses = {
    /**
     * Order cancelled
     */
    200: {
        success: boolean;
        message: string;
    };
};

export type CancelOrderResponse = CancelOrderResponses[keyof CancelOrderResponses];

export type GetOrderData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/orders/{id}';
};

export type GetOrderErrors = {
    /**
     * Order not found
     */
    404: unknown;
};

export type GetOrderResponses = {
    /**
     * Order detail
     */
    200: {
        order: Order;
    };
};

export type GetOrderResponse = GetOrderResponses[keyof GetOrderResponses];

export type ListTradesData = {
    body?: never;
    path?: never;
    query?: {
        symbol?: string;
        strategyId?: string;
        limit?: string;
    };
    url: '/api/v1/finance/trading/trades';
};

export type ListTradesResponses = {
    /**
     * Trade history
     */
    200: {
        data: Array<Trade>;
        count: number;
    };
};

export type ListTradesResponse = ListTradesResponses[keyof ListTradesResponses];

export type GetTradeStatsData = {
    body?: never;
    path?: never;
    query?: {
        days?: string;
    };
    url: '/api/v1/finance/trading/stats';
};

export type GetTradeStatsResponses = {
    /**
     * Trading statistics
     */
    200: {
        period: string;
        stats?: unknown;
    };
};

export type GetTradeStatsResponse = GetTradeStatsResponses[keyof GetTradeStatsResponses];

export type ListPositionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/trading/positions';
};

export type ListPositionsResponses = {
    /**
     * Open positions
     */
    200: {
        data: Array<Position>;
        count: number;
    };
};

export type ListPositionsResponse = ListPositionsResponses[keyof ListPositionsResponses];

export type GetPositionData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/positions/{id}';
};

export type GetPositionErrors = {
    /**
     * Position not found
     */
    404: unknown;
};

export type GetPositionResponses = {
    /**
     * Position details
     */
    200: {
        position: Position;
    };
};

export type GetPositionResponse = GetPositionResponses[keyof GetPositionResponses];

export type ClosePositionData = {
    body?: PositionCloseRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/positions/{id}/close';
};

export type ClosePositionErrors = {
    /**
     * Position not found
     */
    404: unknown;
};

export type ClosePositionResponses = {
    /**
     * Close order submitted
     */
    200: {
        success: boolean;
        message: string;
        order: {
            id: number;
            status: string;
        };
    };
};

export type ClosePositionResponse = ClosePositionResponses[keyof ClosePositionResponses];

export type ListRiskLimitsData = {
    body?: never;
    path?: never;
    query?: {
        scope?: 'org' | 'account' | 'strategy';
        metric?: string;
        scope_id?: string;
        enabled?: string;
        after?: string;
        limit?: string;
    };
    url: '/api/v1/finance/trading/risk/limits';
};

export type ListRiskLimitsResponses = {
    /**
     * Paginated list of risk limits
     */
    200: RiskLimitList;
};

export type ListRiskLimitsResponse = ListRiskLimitsResponses[keyof ListRiskLimitsResponses];

export type CreateRiskLimitData = {
    body?: RiskLimitCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/trading/risk/limits';
};

export type CreateRiskLimitErrors = {
    /**
     * Invalid input
     */
    400: unknown;
};

export type CreateRiskLimitResponses = {
    /**
     * Risk limit created
     */
    201: RiskLimit;
};

export type CreateRiskLimitResponse = CreateRiskLimitResponses[keyof CreateRiskLimitResponses];

export type DeleteRiskLimitData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/risk/limits/{id}';
};

export type DeleteRiskLimitErrors = {
    /**
     * Risk limit not found
     */
    404: unknown;
};

export type DeleteRiskLimitResponses = {
    /**
     * Risk limit disabled (soft delete)
     */
    200: RiskLimit;
};

export type DeleteRiskLimitResponse = DeleteRiskLimitResponses[keyof DeleteRiskLimitResponses];

export type UpdateRiskLimitData = {
    body?: RiskLimitUpdate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/risk/limits/{id}';
};

export type UpdateRiskLimitErrors = {
    /**
     * Risk limit not found
     */
    404: unknown;
};

export type UpdateRiskLimitResponses = {
    /**
     * Risk limit updated
     */
    200: RiskLimit;
};

export type UpdateRiskLimitResponse = UpdateRiskLimitResponses[keyof UpdateRiskLimitResponses];

export type ListRiskBreachesData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'open' | 'alerted' | 'escalated' | 'accepted' | 'resolved';
        scope?: 'org' | 'account' | 'strategy';
        halted?: string;
        after?: string;
        limit?: string;
    };
    url: '/api/v1/finance/trading/risk/breaches';
};

export type ListRiskBreachesResponses = {
    /**
     * Paginated list of risk breaches
     */
    200: RiskBreachList;
};

export type ListRiskBreachesResponse = ListRiskBreachesResponses[keyof ListRiskBreachesResponses];

export type AcceptRiskBreachData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/risk/breaches/{id}/accept';
};

export type AcceptRiskBreachErrors = {
    /**
     * Invalid transition
     */
    400: unknown;
    /**
     * Breach not found
     */
    404: unknown;
};

export type AcceptRiskBreachResponses = {
    /**
     * Breach accepted
     */
    200: RiskBreach;
};

export type AcceptRiskBreachResponse = AcceptRiskBreachResponses[keyof AcceptRiskBreachResponses];

export type ResolveRiskBreachData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/risk/breaches/{id}/resolve';
};

export type ResolveRiskBreachErrors = {
    /**
     * Invalid transition
     */
    400: unknown;
    /**
     * Breach not found
     */
    404: unknown;
};

export type ResolveRiskBreachResponses = {
    /**
     * Breach resolved
     */
    200: RiskBreach;
};

export type ResolveRiskBreachResponse = ResolveRiskBreachResponses[keyof ResolveRiskBreachResponses];

export type EscalateRiskBreachData = {
    body?: RiskBreachEscalate;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/risk/breaches/{id}/escalate';
};

export type EscalateRiskBreachErrors = {
    /**
     * Invalid transition
     */
    400: unknown;
    /**
     * Breach not found
     */
    404: unknown;
};

export type EscalateRiskBreachResponses = {
    /**
     * Breach escalated and linked to the governance decision (the prerequisite for an org/account halt commit)
     */
    200: RiskBreach;
};

export type EscalateRiskBreachResponse = EscalateRiskBreachResponses[keyof EscalateRiskBreachResponses];

export type ListRiskHaltsData = {
    body?: never;
    path?: never;
    query?: {
        after?: string;
        limit?: string;
    };
    url: '/api/v1/finance/trading/risk/halts';
};

export type ListRiskHaltsResponses = {
    /**
     * Paginated list of halted risk breaches
     */
    200: RiskHaltList;
};

export type ListRiskHaltsResponse = ListRiskHaltsResponses[keyof ListRiskHaltsResponses];

export type ActivateRiskHaltData = {
    body?: RiskHaltActivate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/trading/risk/halts';
};

export type ActivateRiskHaltErrors = {
    /**
     * Invalid request or missing decision_id for org/account scope
     */
    400: unknown;
    /**
     * Breach not found
     */
    404: unknown;
};

export type ActivateRiskHaltResponses = {
    /**
     * Halt activated
     */
    200: RiskBreachForHalt;
};

export type ActivateRiskHaltResponse = ActivateRiskHaltResponses[keyof ActivateRiskHaltResponses];

export type ResumeRiskHaltData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/trading/risk/halts/{id}/resume';
};

export type ResumeRiskHaltErrors = {
    /**
     * Breach is not currently halted
     */
    400: unknown;
    /**
     * Breach not found
     */
    404: unknown;
};

export type ResumeRiskHaltResponses = {
    /**
     * Halt resumed
     */
    200: RiskBreachForHalt;
};

export type ResumeRiskHaltResponse = ResumeRiskHaltResponses[keyof ResumeRiskHaltResponses];

export type GetRiskStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/trading/risk/status';
};

export type GetRiskStatusResponses = {
    /**
     * Current risk status for the organization
     */
    200: RiskStatus;
};

export type GetRiskStatusResponse = GetRiskStatusResponses[keyof GetRiskStatusResponses];

export type ListActiveStrategiesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategies/active';
};

export type ListActiveStrategiesResponses = {
    /**
     * Active strategies
     */
    200: {
        data: Array<ActiveStrategy>;
        count: number;
    };
};

export type ListActiveStrategiesResponse = ListActiveStrategiesResponses[keyof ListActiveStrategiesResponses];

export type CreateActiveStrategyData = {
    body?: ActiveStrategyCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategies/active';
};

export type CreateActiveStrategyErrors = {
    /**
     * Strategy not found
     */
    404: unknown;
};

export type CreateActiveStrategyResponses = {
    /**
     * Strategy created and started
     */
    201: {
        success: boolean;
        strategy: ActiveStrategy;
    };
};

export type CreateActiveStrategyResponse = CreateActiveStrategyResponses[keyof CreateActiveStrategyResponses];

export type RemoveActiveStrategyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/active/{id}';
};

export type RemoveActiveStrategyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RemoveActiveStrategyResponses = {
    /**
     * Removed
     */
    200: {
        success: boolean;
        message: string;
    };
};

export type RemoveActiveStrategyResponse = RemoveActiveStrategyResponses[keyof RemoveActiveStrategyResponses];

export type GetActiveStrategyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/active/{id}';
};

export type GetActiveStrategyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetActiveStrategyResponses = {
    /**
     * Active strategy details
     */
    200: ActiveStrategy;
};

export type GetActiveStrategyResponse = GetActiveStrategyResponses[keyof GetActiveStrategyResponses];

export type UpdateStrategyParametersData = {
    body?: ActiveStrategyParametersUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/active/{id}/parameters';
};

export type UpdateStrategyParametersErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateStrategyParametersResponses = {
    /**
     * Parameters updated
     */
    200: {
        success: boolean;
        parameters: {
            [key: string]: number | string | boolean;
        };
    };
};

export type UpdateStrategyParametersResponse = UpdateStrategyParametersResponses[keyof UpdateStrategyParametersResponses];

export type StartStrategyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/active/{id}/start';
};

export type StartStrategyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type StartStrategyResponses = {
    /**
     * Started
     */
    200: {
        success: boolean;
        isActive: boolean;
    };
};

export type StartStrategyResponse = StartStrategyResponses[keyof StartStrategyResponses];

export type StopStrategyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/active/{id}/stop';
};

export type StopStrategyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type StopStrategyResponses = {
    /**
     * Stopped
     */
    200: {
        success: boolean;
        isActive: boolean;
    };
};

export type StopStrategyResponse = StopStrategyResponses[keyof StopStrategyResponses];

export type DeployStrategyData = {
    body?: StrategyDeployCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/{id}/deploy';
};

export type DeployStrategyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeployStrategyResponses = {
    /**
     * Deployed
     */
    200: StrategyDeploymentActionResult;
};

export type DeployStrategyResponse = DeployStrategyResponses[keyof DeployStrategyResponses];

export type UndeployStrategyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/{id}/undeploy';
};

export type UndeployStrategyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UndeployStrategyResponses = {
    /**
     * Undeployed
     */
    200: StrategyDeploymentActionResult;
};

export type UndeployStrategyResponse = UndeployStrategyResponses[keyof UndeployStrategyResponses];

export type GetStrategyDeploymentStatusData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/{id}/status';
};

export type GetStrategyDeploymentStatusErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetStrategyDeploymentStatusResponses = {
    /**
     * Deployment status
     */
    200: StrategyDeploymentStatus;
};

export type GetStrategyDeploymentStatusResponse = GetStrategyDeploymentStatusResponses[keyof GetStrategyDeploymentStatusResponses];

export type GenerateStrategyDocsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/{id}/generate-docs';
};

export type GenerateStrategyDocsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GenerateStrategyDocsResponses = {
    /**
     * Documentation generated
     */
    200: StrategyDocsResult;
};

export type GenerateStrategyDocsResponse = GenerateStrategyDocsResponses[keyof GenerateStrategyDocsResponses];

export type CheckDeploymentReadinessData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/{id}/deployment-readiness';
};

export type CheckDeploymentReadinessErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type CheckDeploymentReadinessResponses = {
    /**
     * Readiness check
     */
    200: StrategyDeploymentReadinessResult;
};

export type CheckDeploymentReadinessResponse = CheckDeploymentReadinessResponses[keyof CheckDeploymentReadinessResponses];

export type ListStrategiesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategies';
};

export type ListStrategiesResponses = {
    /**
     * Available strategies
     */
    200: {
        data: Array<Strategy>;
        count: number;
    };
};

export type ListStrategiesResponse = ListStrategiesResponses[keyof ListStrategiesResponses];

export type RunBacktestData = {
    body?: BacktestCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategies/backtest';
};

export type RunBacktestErrors = {
    /**
     * No data
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type RunBacktestResponses = {
    /**
     * Backtest results
     */
    200: BacktestRunResult;
};

export type RunBacktestResponse = RunBacktestResponses[keyof RunBacktestResponses];

export type GetStrategyData = {
    body?: never;
    path: {
        name: string;
    };
    query?: never;
    url: '/api/v1/finance/strategies/{name}';
};

export type GetStrategyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetStrategyResponses = {
    /**
     * Strategy details
     */
    200: Strategy;
};

export type GetStrategyResponse = GetStrategyResponses[keyof GetStrategyResponses];

export type ListIngestionJobsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/market-data/ingestion-jobs';
};

export type ListIngestionJobsResponses = {
    /**
     * Market-data ingestion jobs configured for the caller's organization
     */
    200: Array<IngestionJob>;
};

export type ListIngestionJobsResponse = ListIngestionJobsResponses[keyof ListIngestionJobsResponses];

export type RunIngestionJobData = {
    body?: IngestionJobRunRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/market-data/ingestion-jobs/{id}/run';
};

export type RunIngestionJobErrors = {
    /**
     * Instance is archived and cannot be run
     */
    400: unknown;
    /**
     * No such ingestion job for this organization
     */
    404: unknown;
};

export type RunIngestionJobResponses = {
    /**
     * Run started on the scheduler rail — the job is returned with `run` populated
     */
    202: IngestionJob;
};

export type RunIngestionJobResponse = RunIngestionJobResponses[keyof RunIngestionJobResponses];

export type ListCandlesData = {
    body?: never;
    path?: never;
    query: {
        symbol: string;
        timeframe: string;
        start?: string;
        end?: string;
        exchange?: string;
        limit?: string;
    };
    url: '/api/v1/finance/market-data/candles';
};

export type ListCandlesResponses = {
    /**
     * Candle data
     */
    200: {
        symbol: string;
        timeframe: string;
        exchange: string;
        count: number;
        candles: Array<Candle>;
    };
};

export type ListCandlesResponse = ListCandlesResponses[keyof ListCandlesResponses];

export type GetPriceData = {
    body?: never;
    path: {
        symbol: string;
    };
    query?: never;
    url: '/api/v1/finance/market-data/price/{symbol}';
};

export type GetPriceErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetPriceResponses = {
    /**
     * Current price
     */
    200: {
        symbol: string;
        price: number;
        timestamp: string;
    };
};

export type GetPriceResponse = GetPriceResponses[keyof GetPriceResponses];

export type ListPricesData = {
    body?: never;
    path?: never;
    query: {
        symbols: string;
    };
    url: '/api/v1/finance/market-data/prices';
};

export type ListPricesErrors = {
    /**
     * symbols required
     */
    400: unknown;
};

export type ListPricesResponses = {
    /**
     * Multiple prices
     */
    200: {
        prices: {
            [key: string]: number | null;
        };
        timestamp: string;
    };
};

export type ListPricesResponse = ListPricesResponses[keyof ListPricesResponses];

export type GetOrderBookData = {
    body?: never;
    path: {
        symbol: string;
    };
    query?: never;
    url: '/api/v1/finance/market-data/orderbook/{symbol}';
};

export type GetOrderBookErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetOrderBookResponses = {
    /**
     * Order book snapshot
     */
    200: OrderBookResult;
};

export type GetOrderBookResponse = GetOrderBookResponses[keyof GetOrderBookResponses];

export type CreateBackfillData = {
    body?: BackfillCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/market-data/backfill';
};

export type CreateBackfillErrors = {
    /**
     * Retired — use POST /market-data/ingestion-jobs/{id}/run
     */
    410: unknown;
};

export type CheckMarketDataData = {
    body?: never;
    path?: never;
    query: {
        symbol: string;
        timeframe: string;
        start: string;
        end: string;
    };
    url: '/api/v1/finance/market-data/check';
};

export type CheckMarketDataResponses = {
    /**
     * Availability check
     */
    200: MarketDataAvailabilityResult;
};

export type CheckMarketDataResponse = CheckMarketDataResponses[keyof CheckMarketDataResponses];

export type GetMarketDataStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/market-data/status';
};

export type GetMarketDataStatusErrors = {
    /**
     * Ingestion is engine-owned; the API process cannot report its status
     */
    410: unknown;
};

export type StartMarketDataData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/market-data/start';
};

export type StartMarketDataErrors = {
    /**
     * Ingestion is engine-owned and cannot be started from the API process
     */
    410: unknown;
};

export type StopMarketDataData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/market-data/stop';
};

export type StopMarketDataErrors = {
    /**
     * Ingestion is engine-owned and cannot be stopped from the API process
     */
    410: unknown;
};

export type ListEconomicEventsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/market-data/economic-calendar';
};

export type ListEconomicEventsResponses = {
    /**
     * Upcoming economic events
     */
    200: EconomicCalendar;
};

export type ListEconomicEventsResponse = ListEconomicEventsResponses[keyof ListEconomicEventsResponses];

export type RunAnalysisAgentsData = {
    body?: AnalysisAgentRunCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/agents/run';
};

export type RunAnalysisAgentsResponses = {
    /**
     * Agent analysis results with consensus
     */
    200: AnalysisAgentRunResult;
};

export type RunAnalysisAgentsResponse = RunAnalysisAgentsResponses[keyof RunAnalysisAgentsResponses];

export type GetAgentStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/agents';
};

export type GetAgentStatusResponses = {
    /**
     * Agent status information
     */
    200: AnalysisAgentStatusResult;
};

export type GetAgentStatusResponse = GetAgentStatusResponses[keyof GetAgentStatusResponses];

export type SetAgentEnabledData = {
    body?: AnalysisAgentEnabledUpdate;
    path: {
        name: string;
    };
    query?: never;
    url: '/api/v1/finance/analysis/agents/{name}/enabled';
};

export type SetAgentEnabledErrors = {
    /**
     * Agent not found
     */
    404: unknown;
};

export type SetAgentEnabledResponses = {
    /**
     * Agent enabled state updated
     */
    200: {
        success: boolean;
        agent: string;
        enabled: boolean;
    };
};

export type SetAgentEnabledResponse = SetAgentEnabledResponses[keyof SetAgentEnabledResponses];

export type GetCurrentSessionData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/session/current';
};

export type GetCurrentSessionResponses = {
    /**
     * Current trading session
     */
    200: CurrentSession;
};

export type GetCurrentSessionResponse = GetCurrentSessionResponses[keyof GetCurrentSessionResponses];

export type GetSessionTimesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/session/times';
};

export type GetSessionTimesResponses = {
    /**
     * All trading session times
     */
    200: SessionTimesResult;
};

export type GetSessionTimesResponse = GetSessionTimesResponses[keyof GetSessionTimesResponses];

export type CalculateOrbData = {
    body?: SessionAnalysisCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/session/orb';
};

export type CalculateOrbErrors = {
    /**
     * Could not calculate opening range
     */
    400: unknown;
};

export type CalculateOrbResponses = {
    /**
     * Opening Range Breakout calculation result
     */
    200: OpeningRangeResult;
};

export type CalculateOrbResponse = CalculateOrbResponses[keyof CalculateOrbResponses];

export type GetSessionStatsData = {
    body?: SessionAnalysisCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/session/stats';
};

export type GetSessionStatsResponses = {
    /**
     * Session statistics and detected patterns
     */
    200: SessionStatsResult;
};

export type GetSessionStatsResponse = GetSessionStatsResponses[keyof GetSessionStatsResponses];

export type AnalyzeOrderBookData = {
    body?: OrderBookAnalyzeCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/orderbook/analyze';
};

export type AnalyzeOrderBookResponses = {
    /**
     * Order book analysis
     */
    200: {
        success: boolean;
        analysis: OrderBookAnalysis;
    };
};

export type AnalyzeOrderBookResponse = AnalyzeOrderBookResponses[keyof AnalyzeOrderBookResponses];

export type GenerateOrderBookHeatmapData = {
    body?: OrderBookHeatmapCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/orderbook/heatmap';
};

export type GenerateOrderBookHeatmapResponses = {
    /**
     * Order book heatmap data
     */
    200: {
        success: boolean;
        symbol: string;
        midPrice: number;
        heatmap: Array<{
            price: number;
            bidVolume: number;
            askVolume: number;
        }>;
    };
};

export type GenerateOrderBookHeatmapResponse = GenerateOrderBookHeatmapResponses[keyof GenerateOrderBookHeatmapResponses];

export type AnalyzeConfluenceData = {
    body?: ConfluenceAnalyzeCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/confluence';
};

export type AnalyzeConfluenceResponses = {
    /**
     * Confluence analysis result
     */
    200: ConfluenceAnalysisResult;
};

export type AnalyzeConfluenceResponse = AnalyzeConfluenceResponses[keyof AnalyzeConfluenceResponses];

export type AnalyzeConfluenceFromSignalsData = {
    body?: ConfluenceFromSignalsCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/analysis/confluence/from-signals';
};

export type AnalyzeConfluenceFromSignalsResponses = {
    /**
     * Confluence analysis built from strategy signals
     */
    200: ConfluenceAnalysisResult;
};

export type AnalyzeConfluenceFromSignalsResponse = AnalyzeConfluenceFromSignalsResponses[keyof AnalyzeConfluenceFromSignalsResponses];

export type GetDiscoverySummaryData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/summary';
};

export type GetDiscoverySummaryResponses = {
    /**
     * Discovery dashboard overview
     */
    200: DiscoverySummaryResult;
};

export type GetDiscoverySummaryResponse = GetDiscoverySummaryResponses[keyof GetDiscoverySummaryResponses];

export type RunStrategyDiscoveryWorkflowData = {
    body?: DiscoveryRunNowRequest;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/workflows/strategy-discovery/run';
};

export type RunStrategyDiscoveryWorkflowErrors = {
    /**
     * Org required
     */
    400: unknown;
    /**
     * Workflow not found
     */
    404: unknown;
    /**
     * Workflow cannot be triggered
     */
    409: unknown;
};

export type RunStrategyDiscoveryWorkflowResponses = {
    /**
     * Strategy discovery workflow trigger accepted
     */
    200: DiscoveryRunNowResult;
};

export type RunStrategyDiscoveryWorkflowResponse = RunStrategyDiscoveryWorkflowResponses[keyof RunStrategyDiscoveryWorkflowResponses];

export type ValidateStrategyDefinitionData = {
    body?: StrategyDefinitionInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-definitions/validate';
};

export type ValidateStrategyDefinitionResponses = {
    /**
     * Strategy definition validation result
     */
    200: StrategyDefinitionValidateResult;
};

export type ValidateStrategyDefinitionResponse = ValidateStrategyDefinitionResponses[keyof ValidateStrategyDefinitionResponses];

export type ListStrategyDefinitionsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/strategy-definitions';
};

export type ListStrategyDefinitionsErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type ListStrategyDefinitionsResponses = {
    /**
     * Strategy definitions
     */
    200: DiscoveryPaginatedList;
};

export type ListStrategyDefinitionsResponse = ListStrategyDefinitionsResponses[keyof ListStrategyDefinitionsResponses];

export type UpsertStrategyDefinitionData = {
    body?: StrategyDefinitionInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-definitions';
};

export type UpsertStrategyDefinitionErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type UpsertStrategyDefinitionResponses = {
    /**
     * Strategy definition persisted
     */
    200: StrategyDefinitionPersistResult;
};

export type UpsertStrategyDefinitionResponse = UpsertStrategyDefinitionResponses[keyof UpsertStrategyDefinitionResponses];

export type CreateStrategyDefinitionValidationRunData = {
    body?: StrategyDefinitionValidationRunInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-definitions/validation-runs';
};

export type CreateStrategyDefinitionValidationRunErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type CreateStrategyDefinitionValidationRunResponses = {
    /**
     * Strategy definition validation evaluation and adapter resolution
     */
    200: DiscoveryCreatedResult;
};

export type CreateStrategyDefinitionValidationRunResponse = CreateStrategyDefinitionValidationRunResponses[keyof CreateStrategyDefinitionValidationRunResponses];

export type ImportFinanceStrategyCorpusData = {
    body?: StrategyCorpusIngestionInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-corpus/import';
};

export type ImportFinanceStrategyCorpusErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type ImportFinanceStrategyCorpusResponses = {
    /**
     * Strategy corpus ingestion dry-run or persistence report
     */
    200: StrategyCorpusIngestionResult;
};

export type ImportFinanceStrategyCorpusResponse = ImportFinanceStrategyCorpusResponses[keyof ImportFinanceStrategyCorpusResponses];

export type GetStrategyDefinitionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/discovery/strategy-definitions/{id}';
};

export type GetStrategyDefinitionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetStrategyDefinitionResponses = {
    /**
     * Strategy definition detail
     */
    200: DiscoveryCreatedResult;
};

export type GetStrategyDefinitionResponse = GetStrategyDefinitionResponses[keyof GetStrategyDefinitionResponses];

export type ListStrategyDefinitionEvaluationsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/strategy-definitions/{id}/evaluations';
};

export type ListStrategyDefinitionEvaluationsErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type ListStrategyDefinitionEvaluationsResponses = {
    /**
     * Strategy definition evaluations
     */
    200: DiscoveryPaginatedList;
};

export type ListStrategyDefinitionEvaluationsResponse = ListStrategyDefinitionEvaluationsResponses[keyof ListStrategyDefinitionEvaluationsResponses];

export type CreateStrategyDefinitionEvaluationData = {
    body?: StrategyDefinitionEvaluationInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-definition-evaluations';
};

export type CreateStrategyDefinitionEvaluationErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type CreateStrategyDefinitionEvaluationResponses = {
    /**
     * Strategy definition evaluation persisted
     */
    200: DiscoveryCreatedResult;
};

export type CreateStrategyDefinitionEvaluationResponse = CreateStrategyDefinitionEvaluationResponses[keyof CreateStrategyDefinitionEvaluationResponses];

export type ValidateStrategyBucketDefinitionData = {
    body?: StrategyBucketDefinitionInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-buckets/validate';
};

export type ValidateStrategyBucketDefinitionResponses = {
    /**
     * Strategy bucket validation result
     */
    200: StrategyDefinitionValidateResult;
};

export type ValidateStrategyBucketDefinitionResponse = ValidateStrategyBucketDefinitionResponses[keyof ValidateStrategyBucketDefinitionResponses];

export type ListStrategyBucketDefinitionsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/strategy-buckets';
};

export type ListStrategyBucketDefinitionsErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type ListStrategyBucketDefinitionsResponses = {
    /**
     * Strategy buckets
     */
    200: DiscoveryPaginatedList;
};

export type ListStrategyBucketDefinitionsResponse = ListStrategyBucketDefinitionsResponses[keyof ListStrategyBucketDefinitionsResponses];

export type UpsertStrategyBucketDefinitionData = {
    body?: StrategyBucketDefinitionInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-buckets';
};

export type UpsertStrategyBucketDefinitionErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type UpsertStrategyBucketDefinitionResponses = {
    /**
     * Strategy bucket persisted
     */
    200: StrategyBucketPersistResult;
};

export type UpsertStrategyBucketDefinitionResponse = UpsertStrategyBucketDefinitionResponses[keyof UpsertStrategyBucketDefinitionResponses];

export type ListStrategyBucketEvaluationsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/strategy-buckets/{id}/evaluations';
};

export type ListStrategyBucketEvaluationsErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type ListStrategyBucketEvaluationsResponses = {
    /**
     * Strategy bucket evaluations
     */
    200: DiscoveryPaginatedList;
};

export type ListStrategyBucketEvaluationsResponse = ListStrategyBucketEvaluationsResponses[keyof ListStrategyBucketEvaluationsResponses];

export type GetStrategyBucketDefinitionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/discovery/strategy-buckets/{id}';
};

export type GetStrategyBucketDefinitionErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetStrategyBucketDefinitionResponses = {
    /**
     * Strategy bucket detail
     */
    200: DiscoveryCreatedResult;
};

export type GetStrategyBucketDefinitionResponse = GetStrategyBucketDefinitionResponses[keyof GetStrategyBucketDefinitionResponses];

export type PatchStrategyBucketDefinitionData = {
    body?: StrategyBucketPatchInput;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/discovery/strategy-buckets/{id}';
};

export type PatchStrategyBucketDefinitionErrors = {
    /**
     * Invalid payload or honesty-gate violation
     */
    400: unknown;
    /**
     * Bucket is capital-facing — route through the governed decision path
     */
    403: unknown;
    /**
     * Not found
     */
    404: unknown;
    /**
     * Concurrent modification
     */
    409: unknown;
};

export type PatchStrategyBucketDefinitionResponses = {
    /**
     * Bucket definition patched
     */
    200: StrategyBucketPersistResult;
};

export type PatchStrategyBucketDefinitionResponse = PatchStrategyBucketDefinitionResponses[keyof PatchStrategyBucketDefinitionResponses];

export type DispatchStrategyBucketBacktestData = {
    body?: StrategyBucketBacktestInput;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/discovery/strategy-buckets/{id}/backtest';
};

export type DispatchStrategyBucketBacktestErrors = {
    /**
     * Org required
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type DispatchStrategyBucketBacktestResponses = {
    /**
     * Combined backtest run request enqueued
     */
    200: StrategyBucketBacktestResult;
};

export type DispatchStrategyBucketBacktestResponse = DispatchStrategyBucketBacktestResponses[keyof DispatchStrategyBucketBacktestResponses];

export type CreateStrategyBucketEvaluationData = {
    body?: StrategyBucketEvaluationInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-bucket-evaluations';
};

export type CreateStrategyBucketEvaluationErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type CreateStrategyBucketEvaluationResponses = {
    /**
     * Strategy bucket evaluation persisted
     */
    200: DiscoveryCreatedResult;
};

export type CreateStrategyBucketEvaluationResponse = CreateStrategyBucketEvaluationResponses[keyof CreateStrategyBucketEvaluationResponses];

export type ValidateStrategyExtensionDescriptorData = {
    body?: StrategyExtensionDescriptorInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-extensions/validate';
};

export type ValidateStrategyExtensionDescriptorResponses = {
    /**
     * Strategy extension descriptor validation result
     */
    200: StrategyDefinitionValidateResult;
};

export type ValidateStrategyExtensionDescriptorResponse = ValidateStrategyExtensionDescriptorResponses[keyof ValidateStrategyExtensionDescriptorResponses];

export type ListStrategyExtensionDescriptorsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/strategy-extensions';
};

export type ListStrategyExtensionDescriptorsErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type ListStrategyExtensionDescriptorsResponses = {
    /**
     * Strategy extension descriptors
     */
    200: DiscoveryPaginatedList;
};

export type ListStrategyExtensionDescriptorsResponse = ListStrategyExtensionDescriptorsResponses[keyof ListStrategyExtensionDescriptorsResponses];

export type UpsertStrategyExtensionDescriptorData = {
    body?: StrategyExtensionDescriptorInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-extensions';
};

export type UpsertStrategyExtensionDescriptorErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type UpsertStrategyExtensionDescriptorResponses = {
    /**
     * Strategy extension descriptor persisted
     */
    200: DiscoveryCreatedResult;
};

export type UpsertStrategyExtensionDescriptorResponse = UpsertStrategyExtensionDescriptorResponses[keyof UpsertStrategyExtensionDescriptorResponses];

export type ResolveStrategyAdaptersData = {
    body?: StrategyAdapterResolutionRequestInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-adapters/resolve';
};

export type ResolveStrategyAdaptersErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type ResolveStrategyAdaptersResponses = {
    /**
     * Strategy adapter resolution result
     */
    200: DiscoveryCreatedResult;
};

export type ResolveStrategyAdaptersResponse = ResolveStrategyAdaptersResponses[keyof ResolveStrategyAdaptersResponses];

export type ListStrategyAdapterResolutionsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/strategy-adapter-resolutions';
};

export type ListStrategyAdapterResolutionsErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type ListStrategyAdapterResolutionsResponses = {
    /**
     * Strategy adapter resolutions
     */
    200: DiscoveryPaginatedList;
};

export type ListStrategyAdapterResolutionsResponse = ListStrategyAdapterResolutionsResponses[keyof ListStrategyAdapterResolutionsResponses];

export type CreateStrategyAdapterResolutionData = {
    body?: StrategyAdapterResolutionInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategy-adapter-resolutions';
};

export type CreateStrategyAdapterResolutionErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type CreateStrategyAdapterResolutionResponses = {
    /**
     * Strategy adapter resolution persisted
     */
    200: DiscoveryCreatedResult;
};

export type CreateStrategyAdapterResolutionResponse = CreateStrategyAdapterResolutionResponses[keyof CreateStrategyAdapterResolutionResponses];

export type ListFinanceDataBlockersData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/data-blockers';
};

export type ListFinanceDataBlockersErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type ListFinanceDataBlockersResponses = {
    /**
     * Data blocker remediations
     */
    200: DiscoveryPaginatedList;
};

export type ListFinanceDataBlockersResponse = ListFinanceDataBlockersResponses[keyof ListFinanceDataBlockersResponses];

export type UpsertFinanceDataBlockerData = {
    body?: DataBlockerInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/data-blockers';
};

export type UpsertFinanceDataBlockerErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
};

export type UpsertFinanceDataBlockerResponses = {
    /**
     * Data blocker remediation persisted
     */
    200: DiscoveryCreatedResult;
};

export type UpsertFinanceDataBlockerResponse = UpsertFinanceDataBlockerResponses[keyof UpsertFinanceDataBlockerResponses];

export type ListTopSourcesData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        by?: string;
    };
    url: '/api/v1/finance/discovery/sources/top';
};

export type ListTopSourcesResponses = {
    /**
     * Top contributors
     */
    200: DiscoveryList;
};

export type ListTopSourcesResponse = ListTopSourcesResponses[keyof ListTopSourcesResponses];

export type ListSourcesData = {
    body?: never;
    path?: never;
    query?: {
        platform?: string;
        active?: string;
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/sources';
};

export type ListSourcesResponses = {
    /**
     * Contributor list
     */
    200: DiscoveryPaginatedList;
};

export type ListSourcesResponse = ListSourcesResponses[keyof ListSourcesResponses];

export type CreateSourceData = {
    body?: ContributorCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/sources';
};

export type CreateSourceErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type CreateSourceResponses = {
    /**
     * Contributor created
     */
    201: DiscoveryCreatedResult;
};

export type CreateSourceResponse = CreateSourceResponses[keyof CreateSourceResponses];

export type GetSourceData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/discovery/sources/{id}';
};

export type GetSourceErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetSourceResponses = {
    /**
     * Contributor details
     */
    200: DiscoverySourceDetailResult;
};

export type GetSourceResponse = GetSourceResponses[keyof GetSourceResponses];

export type GetContentStatsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/content/stats';
};

export type GetContentStatsResponses = {
    /**
     * Content statistics
     */
    200: DiscoveryContentStatsResult;
};

export type GetContentStatsResponse = GetContentStatsResponses[keyof GetContentStatsResponses];

export type ListHarvestedContentData = {
    body?: never;
    path?: never;
    query?: {
        platform?: string;
        status?: 'pending' | 'harvested' | 'extracting' | 'extracted' | 'completed' | 'failed' | 'actionable' | 'explored' | 'dismissed' | 'style_extracted' | 'style_skipped';
        hasTradingContent?: string;
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/content';
};

export type ListHarvestedContentResponses = {
    /**
     * Harvested content list
     */
    200: DiscoveryPaginatedList;
};

export type ListHarvestedContentResponse = ListHarvestedContentResponses[keyof ListHarvestedContentResponses];

export type GetContentDetailsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/discovery/content/{id}';
};

export type GetContentDetailsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetContentDetailsResponses = {
    /**
     * Content details with strategies
     */
    200: DiscoveryContentDetailResult;
};

export type GetContentDetailsResponse = GetContentDetailsResponses[keyof GetContentDetailsResponses];

export type ListApprovedStrategiesData = {
    body?: never;
    path?: never;
    query?: {
        category?: string;
        minSharpe?: string;
        limit?: string;
    };
    url: '/api/v1/finance/discovery/strategies/approved';
};

export type ListApprovedStrategiesResponses = {
    /**
     * Approved strategies
     */
    200: DiscoveryList;
};

export type ListApprovedStrategiesResponse = ListApprovedStrategiesResponses[keyof ListApprovedStrategiesResponses];

export type GetStrategyDiscoveryStatsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/discovery/strategies/stats';
};

export type GetStrategyDiscoveryStatsResponses = {
    /**
     * Strategy discovery statistics
     */
    200: DiscoveryStrategyStatsResult;
};

export type GetStrategyDiscoveryStatsResponse = GetStrategyDiscoveryStatsResponses[keyof GetStrategyDiscoveryStatsResponses];

export type ListDiscoveredStrategiesData = {
    body?: never;
    path?: never;
    query?: {
        status?: string;
        category?: string;
        minCompleteness?: string;
        include?: string;
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/discovery/strategies';
};

export type ListDiscoveredStrategiesResponses = {
    /**
     * Discovered strategy list
     */
    200: DiscoveryPaginatedList;
};

export type ListDiscoveredStrategiesResponse = ListDiscoveredStrategiesResponses[keyof ListDiscoveredStrategiesResponses];

export type GetDiscoveredStrategyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/discovery/strategies/{id}';
};

export type GetDiscoveredStrategyErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetDiscoveredStrategyResponses = {
    /**
     * Strategy details
     */
    200: DiscoveryCreatedResult;
};

export type GetDiscoveredStrategyResponse = GetDiscoveredStrategyResponses[keyof GetDiscoveredStrategyResponses];

export type UpdateDiscoveredStrategyStatusData = {
    body?: DiscoveredStrategyStatusUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/discovery/strategies/{id}/status';
};

export type UpdateDiscoveredStrategyStatusErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateDiscoveredStrategyStatusResponses = {
    /**
     * Status updated
     */
    200: DiscoveryCreatedResult;
};

export type UpdateDiscoveredStrategyStatusResponse = UpdateDiscoveredStrategyStatusResponses[keyof UpdateDiscoveredStrategyStatusResponses];

export type GetAssetSentimentData = {
    body?: never;
    path: {
        asset: string;
    };
    query?: {
        hoursBack?: string;
    };
    url: '/api/v1/finance/discovery/signals/sentiment/{asset}';
};

export type GetAssetSentimentResponses = {
    /**
     * Aggregated sentiment
     */
    200: AssetSentimentResult;
};

export type GetAssetSentimentResponse = GetAssetSentimentResponses[keyof GetAssetSentimentResponses];

export type GetSignalAccuracyData = {
    body?: never;
    path?: never;
    query?: {
        intelSourceId?: string;
    };
    url: '/api/v1/finance/discovery/signals/accuracy';
};

export type GetSignalAccuracyResponses = {
    /**
     * Signal accuracy by asset
     */
    200: SignalAccuracyList;
};

export type GetSignalAccuracyResponse = GetSignalAccuracyResponses[keyof GetSignalAccuracyResponses];

export type GetSignalActivityData = {
    body?: never;
    path?: never;
    query?: {
        days?: string;
    };
    url: '/api/v1/finance/discovery/signals/activity';
};

export type GetSignalActivityResponses = {
    /**
     * Recent signal activity
     */
    200: SignalActivityList;
};

export type GetSignalActivityResponse = GetSignalActivityResponses[keyof GetSignalActivityResponses];

export type ListSignalsData = {
    body?: never;
    path?: never;
    query?: {
        asset?: string;
        intelSourceId?: string;
        limit?: string;
    };
    url: '/api/v1/finance/discovery/signals';
};

export type ListSignalsResponses = {
    /**
     * Signal list
     */
    200: SignalList;
};

export type ListSignalsResponse = ListSignalsResponses[keyof ListSignalsResponses];

export type TestTradingViewWebhookData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/webhooks/tradingview/test';
};

export type TestTradingViewWebhookResponses = {
    /**
     * Test webhook processed (IP whitelist bypassed)
     */
    200: TradingViewWebhookResult & {
        note?: string;
    };
};

export type TestTradingViewWebhookResponse = TestTradingViewWebhookResponses[keyof TestTradingViewWebhookResponses];

export type GeneratePineScriptData = {
    body?: PineScriptCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/webhooks/tradingview/pine-script';
};

export type GeneratePineScriptResponses = {
    /**
     * Pine Script template generated
     */
    200: {
        success: boolean;
        script: string;
    };
};

export type GeneratePineScriptResponse = GeneratePineScriptResponses[keyof GeneratePineScriptResponses];

export type GetTradingViewConfigData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/webhooks/tradingview/config';
};

export type GetTradingViewConfigResponses = {
    /**
     * TradingView webhook config for this org
     */
    200: TradingViewConfig;
};

export type GetTradingViewConfigResponse = GetTradingViewConfigResponses[keyof GetTradingViewConfigResponses];

export type RotateTradingViewTokenData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/webhooks/tradingview/token';
};

export type RotateTradingViewTokenResponses = {
    /**
     * New webhook token (shown once — store it securely)
     */
    200: TradingViewTokenResult;
};

export type RotateTradingViewTokenResponse = RotateTradingViewTokenResponses[keyof RotateTradingViewTokenResponses];

export type ReceiveTradingViewAlertData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/api/v1/finance/webhooks/tradingview/ingest/{token}';
};

export type ReceiveTradingViewAlertErrors = {
    /**
     * Malformed JSON body, or body fails schema validation
     */
    400: unknown;
    /**
     * Invalid or missing token
     */
    401: unknown;
    /**
     * Source IP not allowed
     */
    403: unknown;
    /**
     * Duplicate delivery (replay rejected)
     */
    409: unknown;
    /**
     * Content-Length header missing
     */
    411: unknown;
    /**
     * Request body too large
     */
    413: unknown;
};

export type ReceiveTradingViewAlertResponses = {
    /**
     * Alert received and processed
     */
    200: TradingViewWebhookResult;
};

export type ReceiveTradingViewAlertResponse = ReceiveTradingViewAlertResponses[keyof ReceiveTradingViewAlertResponses];

export type ListWatchlistData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'active' | 'archived' | 'under-review';
    };
    url: '/api/v1/finance/watchlists';
};

export type ListWatchlistResponses = {
    /**
     * Watchlist
     */
    200: {
        data: Array<WatchlistEntry>;
    };
};

export type ListWatchlistResponse = ListWatchlistResponses[keyof ListWatchlistResponses];

export type AddToWatchlistData = {
    body?: WatchlistAdd;
    path?: never;
    query?: never;
    url: '/api/v1/finance/watchlists';
};

export type AddToWatchlistResponses = {
    /**
     * Added
     */
    201: {
        entry: WatchlistEntry;
    };
};

export type AddToWatchlistResponse = AddToWatchlistResponses[keyof AddToWatchlistResponses];

export type RemoveFromWatchlistData = {
    body?: never;
    path: {
        ticker: string;
    };
    query?: never;
    url: '/api/v1/finance/watchlists/{ticker}';
};

export type RemoveFromWatchlistResponses = {
    /**
     * Archived
     */
    200: {
        success: boolean;
    };
};

export type RemoveFromWatchlistResponse = RemoveFromWatchlistResponses[keyof RemoveFromWatchlistResponses];

export type GetWatchlistEntryData = {
    body?: never;
    path: {
        ticker: string;
    };
    query?: never;
    url: '/api/v1/finance/watchlists/{ticker}';
};

export type GetWatchlistEntryErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetWatchlistEntryResponses = {
    /**
     * Entry
     */
    200: {
        entry: WatchlistEntry;
    };
};

export type GetWatchlistEntryResponse = GetWatchlistEntryResponses[keyof GetWatchlistEntryResponses];

export type ListAnalysesData = {
    body?: never;
    path: {
        ticker: string;
    };
    query?: {
        limit?: string;
    };
    url: '/api/v1/finance/watchlists/{ticker}/analyses';
};

export type ListAnalysesResponses = {
    /**
     * Analyses
     */
    200: {
        data: Array<WatchlistAnalysis>;
    };
};

export type ListAnalysesResponse = ListAnalysesResponses[keyof ListAnalysesResponses];

export type GetAnalysisData = {
    body?: never;
    path: {
        ticker: string;
        analysisId: string;
    };
    query?: never;
    url: '/api/v1/finance/watchlists/{ticker}/analyses/{analysisId}';
};

export type GetAnalysisErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetAnalysisResponses = {
    /**
     * Analysis
     */
    200: {
        analysis: WatchlistAnalysis;
    };
};

export type GetAnalysisResponse = GetAnalysisResponses[keyof GetAnalysisResponses];

export type AnalyzeTickerAdHocData = {
    body?: never;
    path: {
        ticker: string;
    };
    query?: never;
    url: '/api/v1/finance/watchlists/{ticker}/analyze';
};

export type AnalyzeTickerAdHocResponses = {
    /**
     * Queued
     */
    202: {
        request_id: string;
        status: string;
        ticker: string;
    };
};

export type AnalyzeTickerAdHocResponse = AnalyzeTickerAdHocResponses[keyof AnalyzeTickerAdHocResponses];

export type ComparePortfoliosData = {
    body?: never;
    path?: never;
    query: {
        ids: string;
    };
    url: '/api/v1/finance/portfolios/compare';
};

export type ComparePortfoliosErrors = {
    /**
     * Provide at least 2 portfolio IDs
     */
    400: unknown;
};

export type ComparePortfoliosResponses = {
    /**
     * Side-by-side comparison
     */
    200: {
        data: Array<PortfolioComparison>;
    };
};

export type ComparePortfoliosResponse = ComparePortfoliosResponses[keyof ComparePortfoliosResponses];

export type GetRiskProfilesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/portfolios/risk-profiles';
};

export type GetRiskProfilesResponses = {
    /**
     * Available risk profiles
     */
    200: {
        data: Array<RiskProfile>;
    };
};

export type GetRiskProfilesResponse = GetRiskProfilesResponses[keyof GetRiskProfilesResponses];

export type ListPortfoliosData = {
    body?: never;
    path?: never;
    query?: {
        ownerType?: 'organization' | 'user';
        portfolioType?: 'testing' | 'production';
        riskTier?: 'conservative' | 'balanced' | 'growth' | 'aggressive';
    };
    url: '/api/v1/finance/portfolios';
};

export type ListPortfoliosErrors = {
    /**
     * Missing org
     */
    400: unknown;
};

export type ListPortfoliosResponses = {
    /**
     * List of portfolios
     */
    200: {
        data: Array<Portfolio>;
    };
};

export type ListPortfoliosResponse = ListPortfoliosResponses[keyof ListPortfoliosResponses];

export type CreatePortfolioData = {
    body?: PortfolioCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/portfolios';
};

export type CreatePortfolioErrors = {
    /**
     * Missing org
     */
    400: unknown;
};

export type CreatePortfolioResponses = {
    /**
     * Portfolio created
     */
    201: {
        portfolio: Portfolio;
    };
};

export type CreatePortfolioResponse = CreatePortfolioResponses[keyof CreatePortfolioResponses];

export type GetPortfolioData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}';
};

export type GetPortfolioErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetPortfolioResponses = {
    /**
     * Portfolio detail with holdings
     */
    200: {
        portfolio: Portfolio;
        holdings: Array<Holding>;
    };
};

export type GetPortfolioResponse = GetPortfolioResponses[keyof GetPortfolioResponses];

export type UpdatePortfolioData = {
    body?: PortfolioUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}';
};

export type UpdatePortfolioErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdatePortfolioResponses = {
    /**
     * Updated
     */
    200: {
        portfolio: Portfolio;
    };
};

export type UpdatePortfolioResponse = UpdatePortfolioResponses[keyof UpdatePortfolioResponses];

export type GetPerformanceMetricsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/performance';
};

export type GetPerformanceMetricsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetPerformanceMetricsResponses = {
    /**
     * Performance metrics
     */
    200: {
        metrics: PerformanceMetrics;
        snapshotCount: number;
    };
};

export type GetPerformanceMetricsResponse = GetPerformanceMetricsResponses[keyof GetPerformanceMetricsResponses];

export type ListPortfolioSnapshotsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: string;
    };
    url: '/api/v1/finance/portfolios/{id}/snapshots';
};

export type ListPortfolioSnapshotsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListPortfolioSnapshotsResponses = {
    /**
     * Portfolio snapshots
     */
    200: {
        data: Array<PortfolioSnapshot>;
    };
};

export type ListPortfolioSnapshotsResponse = ListPortfolioSnapshotsResponses[keyof ListPortfolioSnapshotsResponses];

export type GetPortfolioSnapshotData = {
    body?: never;
    path: {
        id: string;
        snapshotId: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/snapshots/{snapshotId}';
};

export type GetPortfolioSnapshotErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetPortfolioSnapshotResponses = {
    /**
     * Snapshot detail
     */
    200: {
        snapshot: PortfolioSnapshot;
    };
};

export type GetPortfolioSnapshotResponse = GetPortfolioSnapshotResponses[keyof GetPortfolioSnapshotResponses];

export type GetRecommendationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/recommendations';
};

export type GetRecommendationErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetRecommendationResponses = {
    /**
     * Latest recommendation
     */
    200: {
        recommendation: AllocationRecommendation | null;
    };
};

export type GetRecommendationResponse = GetRecommendationResponses[keyof GetRecommendationResponses];

export type ApproveRecommendationData = {
    body?: RecommendationAction;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/recommendations/approve';
};

export type ApproveRecommendationErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ApproveRecommendationResponses = {
    /**
     * Approved
     */
    200: {
        result: AllocationRecommendation;
    };
};

export type ApproveRecommendationResponse = ApproveRecommendationResponses[keyof ApproveRecommendationResponses];

export type RejectRecommendationData = {
    body?: RecommendationAction;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/recommendations/reject';
};

export type RejectRecommendationErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type RejectRecommendationResponses = {
    /**
     * Rejected
     */
    200: {
        result: AllocationRecommendation;
    };
};

export type RejectRecommendationResponse = RejectRecommendationResponses[keyof RejectRecommendationResponses];

export type ListHoldingsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/holdings';
};

export type ListHoldingsErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ListHoldingsResponses = {
    /**
     * Holdings list
     */
    200: {
        data: Array<Holding>;
    };
};

export type ListHoldingsResponse = ListHoldingsResponses[keyof ListHoldingsResponses];

export type CreateHoldingData = {
    body?: HoldingCreate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/holdings';
};

export type CreateHoldingErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type CreateHoldingResponses = {
    /**
     * Holding created
     */
    200: {
        holding: Holding;
    };
};

export type CreateHoldingResponse = CreateHoldingResponses[keyof CreateHoldingResponses];

export type DeleteHoldingData = {
    body?: never;
    path: {
        id: string;
        ticker: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/holdings/{ticker}';
};

export type DeleteHoldingErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteHoldingResponses = {
    /**
     * Removed
     */
    200: {
        success: boolean;
    };
};

export type DeleteHoldingResponse = DeleteHoldingResponses[keyof DeleteHoldingResponses];

export type UpdateHoldingData = {
    body?: HoldingUpdate;
    path: {
        id: string;
        ticker: string;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/holdings/{ticker}';
};

export type UpdateHoldingErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateHoldingResponses = {
    /**
     * Holding updated
     */
    200: {
        holding: Holding;
    };
};

export type UpdateHoldingResponse = UpdateHoldingResponses[keyof UpdateHoldingResponses];

export type ListContractEventsData = {
    body?: never;
    path?: never;
    query?: {
        runId?: number;
        stepId?: string;
        limit?: number;
    };
    url: '/api/v1/finance/contracts/events';
};

export type ListContractEventsResponses = {
    /**
     * Contract events
     */
    200: ContractEventList;
};

export type ListContractEventsResponse = ListContractEventsResponses[keyof ListContractEventsResponses];

export type GetContractHealthData = {
    body?: never;
    path?: never;
    query?: {
        workflowId?: number;
    };
    url: '/api/v1/finance/contracts/health';
};

export type GetContractHealthResponses = {
    /**
     * Contract health stats
     */
    200: ContractHealth;
};

export type GetContractHealthResponse = GetContractHealthResponses[keyof GetContractHealthResponses];

export type ApplyContractResolutionData = {
    body?: ContractApplyRequest;
    path?: never;
    query?: never;
    url: '/api/v1/finance/contracts/apply';
};

export type ApplyContractResolutionErrors = {
    /**
     * Missing organization context or invalid mappings
     */
    400: unknown;
    /**
     * Policy CanManageWorkflows required
     */
    403: unknown;
    /**
     * Workflow or source step not found
     */
    404: unknown;
};

export type ApplyContractResolutionResponses = {
    /**
     * Refreshed contract health after applying the fix
     */
    200: ContractHealth;
};

export type ApplyContractResolutionResponse = ApplyContractResolutionResponses[keyof ApplyContractResolutionResponses];

export type CheckAlertPriceData = {
    body?: AlertCheckCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/alerts/check';
};

export type CheckAlertPriceResponses = {
    /**
     * Triggered alerts
     */
    200: AlertCheckResult;
};

export type CheckAlertPriceResponse = CheckAlertPriceResponses[keyof CheckAlertPriceResponses];

export type ListAlertsBySymbolData = {
    body?: never;
    path: {
        symbol: string;
    };
    query?: never;
    url: '/api/v1/finance/alerts/symbol/{symbol}';
};

export type ListAlertsBySymbolResponses = {
    /**
     * Alerts for symbol
     */
    200: {
        data: Array<PriceAlert>;
    };
};

export type ListAlertsBySymbolResponse = ListAlertsBySymbolResponses[keyof ListAlertsBySymbolResponses];

export type ListAlertsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/alerts';
};

export type ListAlertsResponses = {
    /**
     * All price alerts
     */
    200: {
        data: Array<PriceAlert>;
        stats: AlertStats;
    };
};

export type ListAlertsResponse = ListAlertsResponses[keyof ListAlertsResponses];

export type CreateAlertData = {
    body?: PriceAlertCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/alerts';
};

export type CreateAlertErrors = {
    /**
     * Invalid condition/percentChange combination
     */
    400: unknown;
};

export type CreateAlertResponses = {
    /**
     * Alert created
     */
    201: {
        success: boolean;
        alert: PriceAlert;
    };
};

export type CreateAlertResponse = CreateAlertResponses[keyof CreateAlertResponses];

export type DeleteAlertData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/alerts/{id}';
};

export type DeleteAlertErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteAlertResponses = {
    /**
     * Deleted
     */
    200: {
        success: boolean;
    };
};

export type DeleteAlertResponse = DeleteAlertResponses[keyof DeleteAlertResponses];

export type SetAlertEnabledData = {
    body?: AlertEnabledUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/alerts/{id}/enabled';
};

export type SetAlertEnabledErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type SetAlertEnabledResponses = {
    /**
     * Updated
     */
    200: {
        success: boolean;
        enabled: boolean;
    };
};

export type SetAlertEnabledResponse = SetAlertEnabledResponses[keyof SetAlertEnabledResponses];

export type ResetAlertData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/alerts/{id}/reset';
};

export type ResetAlertErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type ResetAlertResponses = {
    /**
     * Reset
     */
    200: {
        success: boolean;
    };
};

export type ResetAlertResponse = ResetAlertResponses[keyof ResetAlertResponses];

export type ListAlertRulesData = {
    body?: never;
    path?: never;
    query?: {
        kind?: AlertRuleKind;
        symbol?: string;
        enabled?: 'true' | 'false';
    };
    url: '/api/v1/finance/alert-rules';
};

export type ListAlertRulesResponses = {
    /**
     * Alert rules for the organization
     */
    200: {
        data: Array<AlertRule>;
    };
};

export type ListAlertRulesResponse = ListAlertRulesResponses[keyof ListAlertRulesResponses];

export type CreateAlertRuleData = {
    body: AlertRuleCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/alert-rules';
};

export type CreateAlertRuleErrors = {
    /**
     * Invalid params for the declared kind
     */
    400: unknown;
};

export type CreateAlertRuleResponses = {
    /**
     * Alert rule created
     */
    201: {
        success: boolean;
        rule: AlertRule;
    };
};

export type CreateAlertRuleResponse = CreateAlertRuleResponses[keyof CreateAlertRuleResponses];

export type DeleteAlertRuleData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/alert-rules/{id}';
};

export type DeleteAlertRuleErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type DeleteAlertRuleResponses = {
    /**
     * Deleted
     */
    200: {
        success: boolean;
    };
};

export type DeleteAlertRuleResponse = DeleteAlertRuleResponses[keyof DeleteAlertRuleResponses];

export type GetAlertRuleData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/alert-rules/{id}';
};

export type GetAlertRuleErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetAlertRuleResponses = {
    /**
     * Alert rule
     */
    200: {
        rule: AlertRule;
    };
};

export type GetAlertRuleResponse = GetAlertRuleResponses[keyof GetAlertRuleResponses];

export type UpdateAlertRuleData = {
    body?: AlertRuleUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/alert-rules/{id}';
};

export type UpdateAlertRuleErrors = {
    /**
     * Invalid params for the rule kind
     */
    400: unknown;
    /**
     * Not found
     */
    404: unknown;
};

export type UpdateAlertRuleResponses = {
    /**
     * Alert rule updated
     */
    200: {
        success: boolean;
        rule: AlertRule;
    };
};

export type UpdateAlertRuleResponse = UpdateAlertRuleResponses[keyof UpdateAlertRuleResponses];

export type ListMarketEventReactionTypesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/market-event-reactions/types';
};

export type ListMarketEventReactionTypesResponses = {
    /**
     * The reactions an organization can arm
     */
    200: Array<MarketEventReactionType>;
};

export type ListMarketEventReactionTypesResponse = ListMarketEventReactionTypesResponses[keyof ListMarketEventReactionTypesResponses];

export type ListMarketEventReactionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/market-event-reactions';
};

export type ListMarketEventReactionsResponses = {
    /**
     * The reactions this organization has armed
     */
    200: {
        data: Array<MarketEventReaction>;
    };
};

export type ListMarketEventReactionsResponse = ListMarketEventReactionsResponses[keyof ListMarketEventReactionsResponses];

export type CreateMarketEventReactionData = {
    body: MarketEventReactionCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/market-event-reactions';
};

export type CreateMarketEventReactionErrors = {
    /**
     * Unknown reaction, threshold out of range, or the playbook is not held
     */
    400: unknown;
};

export type CreateMarketEventReactionResponses = {
    /**
     * Armed: the detector rule and the trigger that runs the playbook
     */
    201: MarketEventReaction;
};

export type CreateMarketEventReactionResponse = CreateMarketEventReactionResponses[keyof CreateMarketEventReactionResponses];

export type DeleteMarketEventReactionData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/market-event-reactions/{id}';
};

export type DeleteMarketEventReactionErrors = {
    /**
     * No such reaction in this organization
     */
    404: unknown;
};

export type DeleteMarketEventReactionResponses = {
    /**
     * Disarmed: the trigger and its detector rule are gone
     */
    204: void;
};

export type DeleteMarketEventReactionResponse = DeleteMarketEventReactionResponses[keyof DeleteMarketEventReactionResponses];

export type ListWalletWatchesData = {
    body?: never;
    path?: never;
    query?: {
        includeRemoved?: 'true' | 'false';
    };
    url: '/api/v1/finance/wallets';
};

export type ListWalletWatchesResponses = {
    /**
     * The wallets the organization watches
     */
    200: {
        data: Array<WalletWatch>;
    };
};

export type ListWalletWatchesResponse = ListWalletWatchesResponses[keyof ListWalletWatchesResponses];

export type CreateWalletWatchData = {
    body: WalletWatchCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/wallets';
};

export type CreateWalletWatchErrors = {
    /**
     * The address is not one the chain writes
     */
    400: unknown;
};

export type CreateWalletWatchResponses = {
    /**
     * The watch (an existing one when the wallet was already watched)
     */
    201: {
        watch: WalletWatch;
        created: boolean;
    };
};

export type CreateWalletWatchResponse = CreateWalletWatchResponses[keyof CreateWalletWatchResponses];

export type DeleteWalletWatchData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/wallets/{id}';
};

export type DeleteWalletWatchErrors = {
    /**
     * No active watch with this id
     */
    404: unknown;
};

export type DeleteWalletWatchResponses = {
    /**
     * Stopped watching; the watch stays as history
     */
    200: {
        success: boolean;
    };
};

export type DeleteWalletWatchResponse = DeleteWalletWatchResponses[keyof DeleteWalletWatchResponses];

export type GetWalletWatchData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/wallets/{id}';
};

export type GetWalletWatchErrors = {
    /**
     * No such watch in this organization
     */
    404: unknown;
};

export type GetWalletWatchResponses = {
    /**
     * The wallet, its newest moves and the rules each fired
     */
    200: WalletWatchDetail;
};

export type GetWalletWatchResponse = GetWalletWatchResponses[keyof GetWalletWatchResponses];

export type ListFinanceStrategyRunsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
        scope?: string;
        runMode?: 'research' | 'backtest' | 'walk_forward' | 'cross_validation' | 'monte_carlo' | 'paper' | 'shadow' | 'canary' | 'live';
        runStatus?: 'scheduled' | 'running' | 'finished' | 'failed' | 'killed';
        researchOnly?: string;
        passed?: string;
        definitionId?: string;
        bucketDefinitionId?: string;
        minSharpe?: string;
        maxDrawdown?: string;
    };
    url: '/api/v1/finance/strategy-runs';
};

export type ListFinanceStrategyRunsErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type ListFinanceStrategyRunsResponses = {
    /**
     * Strategy runs
     */
    200: StrategyRunList;
};

export type ListFinanceStrategyRunsResponse = ListFinanceStrategyRunsResponses[keyof ListFinanceStrategyRunsResponses];

export type CreateFinanceStrategyRunData = {
    body?: StrategyRunInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategy-runs';
};

export type CreateFinanceStrategyRunErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
    /**
     * Non-research run results must be written by the internal execution producer
     */
    403: unknown;
    /**
     * Terminal run cannot be overwritten
     */
    409: unknown;
};

export type CreateFinanceStrategyRunResponses = {
    /**
     * Strategy run persisted
     */
    200: StrategyRunPersistResult;
};

export type CreateFinanceStrategyRunResponse = CreateFinanceStrategyRunResponses[keyof CreateFinanceStrategyRunResponses];

export type ListFinanceStrategyRunRequestsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
        status?: 'queued' | 'blocked' | 'dispatched' | 'running' | 'completed' | 'failed' | 'cancelled' | 'awaiting_preregistration';
        scope?: string;
        runMode?: 'research' | 'backtest' | 'walk_forward' | 'cross_validation' | 'monte_carlo' | 'paper' | 'shadow' | 'canary' | 'live';
        requestedEngine?: string;
        researchOnly?: string;
        definitionId?: string;
        bucketDefinitionId?: string;
    };
    url: '/api/v1/finance/strategy-runs/requests';
};

export type ListFinanceStrategyRunRequestsErrors = {
    /**
     * Org required
     */
    400: unknown;
};

export type ListFinanceStrategyRunRequestsResponses = {
    /**
     * Strategy run requests
     */
    200: StrategyRunRequestList;
};

export type ListFinanceStrategyRunRequestsResponse = ListFinanceStrategyRunRequestsResponses[keyof ListFinanceStrategyRunRequestsResponses];

export type CreateFinanceStrategyRunRequestData = {
    body?: StrategyRunRequestInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategy-runs/requests';
};

export type CreateFinanceStrategyRunRequestErrors = {
    /**
     * Invalid payload or missing organization context
     */
    400: unknown;
    /**
     * Strategy run request conflict
     */
    409: unknown;
};

export type CreateFinanceStrategyRunRequestResponses = {
    /**
     * Strategy run request queued for workflow/worker execution
     */
    200: StrategyRunRequestPersistResult;
};

export type CreateFinanceStrategyRunRequestResponse = CreateFinanceStrategyRunRequestResponses[keyof CreateFinanceStrategyRunRequestResponses];

export type GetFinanceStrategyRunRequestData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-runs/requests/{id}';
};

export type GetFinanceStrategyRunRequestErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetFinanceStrategyRunRequestResponses = {
    /**
     * Strategy run request detail
     */
    200: {
        data: StrategyRunRequestRecord;
    };
};

export type GetFinanceStrategyRunRequestResponse = GetFinanceStrategyRunRequestResponses[keyof GetFinanceStrategyRunRequestResponses];

export type GetFinanceStrategyRunData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-runs/{id}';
};

export type GetFinanceStrategyRunErrors = {
    /**
     * Not found
     */
    404: unknown;
};

export type GetFinanceStrategyRunResponses = {
    /**
     * Strategy run detail
     */
    200: {
        data: StrategyRunRecord;
    };
};

export type GetFinanceStrategyRunResponse = GetFinanceStrategyRunResponses[keyof GetFinanceStrategyRunResponses];

export type GetStrategyRunResultData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-runs/{id}/result';
};

export type GetStrategyRunResultErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Run not found for the organization
     */
    404: unknown;
};

export type GetStrategyRunResultResponses = {
    /**
     * Run header, summary statistics, and normalized artifact index
     */
    200: StrategyRunResultResult;
};

export type GetStrategyRunResultResponse = GetStrategyRunResultResponses[keyof GetStrategyRunResultResponses];

export type GetStrategyRunArtifactData = {
    body?: never;
    path: {
        id: string;
        kind: string;
    };
    query?: {
        from?: string;
        to?: string;
        resolution?: string;
        offset?: string;
        limit?: string;
    };
    url: '/api/v1/finance/strategy-runs/{id}/artifacts/{kind}';
};

export type GetStrategyRunArtifactErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Run, artifact ref, or output part not accessible for the organization
     */
    404: unknown;
};

export type GetStrategyRunArtifactResponses = {
    /**
     * Series kinds return LTTB-downsampled points; tabular kinds return an offset/limit page; every other kind returns the stored payload unchanged
     */
    200: StrategyRunArtifactResult;
};

export type GetStrategyRunArtifactResponse = GetStrategyRunArtifactResponses[keyof GetStrategyRunArtifactResponses];

export type GetStrategyRunAnalyticsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-runs/{id}/analytics';
};

export type GetStrategyRunAnalyticsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Run not found for the organization, or it stored no equity curve
     */
    404: unknown;
};

export type GetStrategyRunAnalyticsResponses = {
    /**
     * The run's analysis — key stats, periodical P&L, benchmarking, exposure, run-ups and drawdowns, P&L by side and signal, the trades and their distribution, streaks and time patterns — computed once per run
     */
    200: StrategyRunAnalytics;
};

export type GetStrategyRunAnalyticsResponse = GetStrategyRunAnalyticsResponses[keyof GetStrategyRunAnalyticsResponses];

export type ListStrategyDefinitionGroupsData = {
    body?: never;
    path?: never;
    query?: {
        q?: string;
        tier?: 'works_now' | 'proven';
        assetClass?: string;
        category?: 'trend_following' | 'time_series_momentum' | 'cross_sectional_momentum' | 'momentum' | 'mean_reversion' | 'breakout' | 'volatility_breakout' | 'pattern' | 'indicator_system' | 'carry' | 'fx_specific' | 'stat_arb' | 'pairs' | 'intermarket' | 'sector_rotation' | 'factor' | 'anomaly' | 'options_volatility' | 'crypto_onchain' | 'sentiment_news' | 'regime_adaptive' | 'portfolio_allocation' | 'arbitrage' | 'hybrid' | 'technical' | 'fundamental' | 'custom';
        lifecycle?: 'candidate' | 'backtest' | 'risk' | 'paper' | 'live' | 'retired';
        /**
         * score (default, highest first) or updated
         */
        sort?: 'score' | 'updated';
        limit?: number;
        offset?: number | null;
        /**
         * Only one base strategy's variants: a group's key (`template:<ref>` or `strategy:<id>`)
         */
        base?: string;
        /**
         * Keep weak variants (score grade D or F); left out by default, except for `definitionId`
         */
        includeWeak?: 'true' | 'false';
    };
    url: '/api/v1/finance/strategy-definitions/summaries/groups';
};

export type ListStrategyDefinitionGroupsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListStrategyDefinitionGroupsResponses = {
    /**
     * The organization's strategies by base strategy (the template they were born from), each led by its best variant; weak variants (grade D or F) left out unless asked for
     */
    200: StrategyDefinitionGroupList;
};

export type ListStrategyDefinitionGroupsResponse = ListStrategyDefinitionGroupsResponses[keyof ListStrategyDefinitionGroupsResponses];

export type ListStrategyDefinitionSummariesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * One strategy's row, by its active version id
         */
        definitionId?: string;
        q?: string;
        tier?: 'works_now' | 'proven';
        assetClass?: string;
        category?: 'trend_following' | 'time_series_momentum' | 'cross_sectional_momentum' | 'momentum' | 'mean_reversion' | 'breakout' | 'volatility_breakout' | 'pattern' | 'indicator_system' | 'carry' | 'fx_specific' | 'stat_arb' | 'pairs' | 'intermarket' | 'sector_rotation' | 'factor' | 'anomaly' | 'options_volatility' | 'crypto_onchain' | 'sentiment_news' | 'regime_adaptive' | 'portfolio_allocation' | 'arbitrage' | 'hybrid' | 'technical' | 'fundamental' | 'custom';
        lifecycle?: 'candidate' | 'backtest' | 'risk' | 'paper' | 'live' | 'retired';
        /**
         * score (default, highest first) or updated
         */
        sort?: 'score' | 'updated';
        limit?: number;
        offset?: number | null;
        /**
         * Only one base strategy's variants: a group's key (`template:<ref>` or `strategy:<id>`)
         */
        base?: string;
        /**
         * Keep weak variants (score grade D or F); left out by default, except for `definitionId`
         */
        includeWeak?: 'true' | 'false';
    };
    url: '/api/v1/finance/strategy-definitions/summaries';
};

export type ListStrategyDefinitionSummariesErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListStrategyDefinitionSummariesResponses = {
    /**
     * The organization's strategies (at most 200 a page), each with its score, latest finished run, lifecycle and tier standing
     */
    200: Array<StrategyDefinitionSummary>;
};

export type ListStrategyDefinitionSummariesResponse = ListStrategyDefinitionSummariesResponses[keyof ListStrategyDefinitionSummariesResponses];

export type ListStrategyDefinitionRunsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        latest?: 'true' | 'false';
        limit?: string;
        offset?: string;
        includeVersions?: 'true' | 'false';
    };
    url: '/api/v1/finance/strategy-definitions/{id}/runs';
};

export type ListStrategyDefinitionRunsErrors = {
    /**
     * Organization context required or definition id invalid
     */
    400: unknown;
};

export type ListStrategyDefinitionRunsResponses = {
    /**
     * Thin run projections for a strategy definition, newest finished first
     */
    200: StrategyDefinitionRunList;
};

export type ListStrategyDefinitionRunsResponse = ListStrategyDefinitionRunsResponses[keyof ListStrategyDefinitionRunsResponses];

export type CreateStrategyDefinitionRunData = {
    body?: CreateStrategyDefinitionRunRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-definitions/{id}/runs';
};

export type CreateStrategyDefinitionRunErrors = {
    /**
     * Organization context required, invalid definition id, or paramSet rejected
     */
    400: StrategyDefinitionRunErrorResult;
    /**
     * Strategy definition not found for the organization
     */
    404: unknown;
};

export type CreateStrategyDefinitionRunError = CreateStrategyDefinitionRunErrors[keyof CreateStrategyDefinitionRunErrors];

export type CreateStrategyDefinitionRunResponses = {
    /**
     * Run request enqueued for this definition with the supplied parameter values
     */
    201: CreateStrategyDefinitionRunResult;
};

export type CreateStrategyDefinitionRunResponse = CreateStrategyDefinitionRunResponses[keyof CreateStrategyDefinitionRunResponses];

export type AmendStrategyDefinitionParametersData = {
    body?: AmendStrategyDefinitionParametersRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-definitions/{id}/parameters';
};

export type AmendStrategyDefinitionParametersErrors = {
    /**
     * Organization context required, invalid id, or a parameter patch was rejected
     */
    400: unknown;
    /**
     * Strategy definition not found for the organization
     */
    404: unknown;
};

export type AmendStrategyDefinitionParametersResponses = {
    /**
     * Parameters amended — a new definitionVersion of the same strategy when anything changed, the existing version when the patch was a no-op
     */
    200: AmendStrategyDefinitionParametersResult;
};

export type AmendStrategyDefinitionParametersResponse = AmendStrategyDefinitionParametersResponses[keyof AmendStrategyDefinitionParametersResponses];

export type ForkStrategyDefinitionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-definitions/{id}/fork';
};

export type ForkStrategyDefinitionErrors = {
    /**
     * Organization context required or invalid definition id
     */
    400: unknown;
    /**
     * Strategy definition not found for the organization
     */
    404: unknown;
};

export type ForkStrategyDefinitionResponses = {
    /**
     * Deep-copy of the definition into a NEW candidate lineage — a fresh sourceCandidateId at definitionVersion 1, lifecycle candidate — with the indicator bindings re-persisted
     */
    201: ForkStrategyDefinitionResult;
};

export type ForkStrategyDefinitionResponse = ForkStrategyDefinitionResponses[keyof ForkStrategyDefinitionResponses];

export type ListFinanceStrategyTemplatesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategy-templates';
};

export type ListFinanceStrategyTemplatesErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
};

export type ListFinanceStrategyTemplatesResponses = {
    /**
     * Active strategy templates for this organization
     */
    200: StrategyTemplateList;
};

export type ListFinanceStrategyTemplatesResponse = ListFinanceStrategyTemplatesResponses[keyof ListFinanceStrategyTemplatesResponses];

export type GetFinanceStrategyTemplateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-templates/{id}';
};

export type GetFinanceStrategyTemplateErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Template not found
     */
    404: unknown;
};

export type GetFinanceStrategyTemplateResponses = {
    /**
     * Strategy template detail
     */
    200: StrategyTemplateGetResult;
};

export type GetFinanceStrategyTemplateResponse = GetFinanceStrategyTemplateResponses[keyof GetFinanceStrategyTemplateResponses];

export type PreviewFinanceStrategyTemplateData = {
    body?: StrategyTemplatePreviewRequest;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategy-templates/preview';
};

export type PreviewFinanceStrategyTemplateErrors = {
    /**
     * Missing organization context or invalid input
     */
    400: unknown;
    /**
     * Template not found
     */
    404: unknown;
};

export type PreviewFinanceStrategyTemplateResponses = {
    /**
     * Compiled template preview (no persistence)
     */
    200: StrategyTemplatePreviewResult;
};

export type PreviewFinanceStrategyTemplateResponse = PreviewFinanceStrategyTemplateResponses[keyof PreviewFinanceStrategyTemplateResponses];

export type EnqueueFinanceStrategyTemplateRunData = {
    body?: StrategyTemplateEnqueueRequest;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategy-templates/enqueue-run';
};

export type EnqueueFinanceStrategyTemplateRunErrors = {
    /**
     * Missing organization context, invalid scope/runMode, or invalid input
     */
    400: unknown;
    /**
     * Template not found
     */
    404: unknown;
};

export type EnqueueFinanceStrategyTemplateRunResponses = {
    /**
     * Strategy run request enqueued
     */
    200: StrategyTemplateEnqueueResult;
};

export type EnqueueFinanceStrategyTemplateRunResponse = EnqueueFinanceStrategyTemplateRunResponses[keyof EnqueueFinanceStrategyTemplateRunResponses];

export type ListFinanceProviderUnlockPromptsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
        status?: string;
        scope?: string;
        assetClass?: string;
        requiredSecret?: string;
    };
    url: '/api/v1/finance/provider-unlocks';
};

export type ListFinanceProviderUnlockPromptsErrors = {
    /**
     * Organization context is required
     */
    400: unknown;
};

export type ListFinanceProviderUnlockPromptsResponses = {
    /**
     * Provider unlock prompts for finance strategy testing and promotion gates
     */
    200: FinanceProviderUnlockPromptList;
};

export type ListFinanceProviderUnlockPromptsResponse = ListFinanceProviderUnlockPromptsResponses[keyof ListFinanceProviderUnlockPromptsResponses];

export type GetFinanceProviderUnlockPromptData = {
    body?: never;
    path: {
        unlockId: string;
    };
    query?: never;
    url: '/api/v1/finance/provider-unlocks/{unlockId}';
};

export type GetFinanceProviderUnlockPromptErrors = {
    /**
     * Organization context is required
     */
    400: unknown;
    /**
     * Provider unlock prompt not found
     */
    404: unknown;
};

export type GetFinanceProviderUnlockPromptResponses = {
    /**
     * Provider unlock prompt detail
     */
    200: FinanceProviderUnlockPromptDetailResult;
};

export type GetFinanceProviderUnlockPromptResponse = GetFinanceProviderUnlockPromptResponses[keyof GetFinanceProviderUnlockPromptResponses];

export type ListFinanceStrategyCostModelsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
        costModelId?: string;
        realismLevel?: string;
        slippageModelKind?: string;
        feeModelKind?: string;
        fillModelKind?: string;
        costAssumptionSource?: string;
    };
    url: '/api/v1/finance/strategy-execution-config/cost-models';
};

export type ListFinanceStrategyCostModelsErrors = {
    /**
     * Organization context is required
     */
    400: unknown;
};

export type ListFinanceStrategyCostModelsResponses = {
    /**
     * List finance strategy cost models
     */
    200: FinanceStrategyCostModelList;
};

export type ListFinanceStrategyCostModelsResponse = ListFinanceStrategyCostModelsResponses[keyof ListFinanceStrategyCostModelsResponses];

export type CreateFinanceStrategyCostModelData = {
    body?: {
        type?: 'strategy_cost_model';
        schemaVersion?: 'finance-strategy-cost-model/v1';
        costModelId: string;
        version: string;
        name?: string;
        realismLevel?: 'none' | 'default_broker' | 'custom';
        brokerageModel?: string;
        slippageModel?: {
            kind?: 'none' | 'fixed_basis_points' | 'constant_percent' | 'fixed_spread' | 'spread_fraction' | 'proportional_price' | 'volume_share' | 'square_root_impact' | 'almgren_chriss' | 'custom' | string;
            config?: {
                [key: string]: unknown;
            };
            costAssumptionSource?: 'none' | 'measured' | 'vendor_feed' | 'static_assumption' | 'heuristic';
            applyOnOpen?: boolean;
            allowFillBeyondLimit?: boolean;
        } | null;
        feeModel?: {
            kind?: 'none' | 'per_share' | 'per_trade' | 'per_dollar' | 'per_contract' | 'maker_taker' | 'tiered' | 'proportional_plus_fixed' | 'brokerage_named' | 'custom' | string;
            config?: {
                [key: string]: unknown;
            };
            currency?: string;
            regulatoryFees?: {
                side?: 'buy' | 'sell' | 'both' | string;
                secFeeBps?: number;
                finraTafPerShare?: number;
                exchangeFeePerShare?: number;
                clearingFeePerTrade?: number;
            };
            costAssumptionSource?: 'none' | 'measured' | 'vendor_feed' | 'static_assumption' | 'heuristic';
        } | null;
        latencyModel?: {
            kind?: 'zero' | 'fixed_ms' | 'uniform_ms' | 'normal_ms' | 'distribution' | 'custom' | string;
            config?: {
                [key: string]: unknown;
            };
            fixedLatencyMs?: number;
            latencyMeanMs?: number;
            latencyStdMs?: number;
            adverseSelectionBps?: number;
            costAssumptionSource?: 'none' | 'measured' | 'vendor_feed' | 'static_assumption' | 'heuristic';
        } | null;
        fillModel?: {
            kind?: 'immediate' | 'equity' | 'future' | 'future_option' | 'best_price' | 'parametric' | 'size_aware' | 'partial' | 'volume_sensitive' | 'session_aware' | 'competition_aware' | 'custom' | string;
            fillTiming?: 'same_bar_close' | 'next_bar_open' | 'next_bar_vwap' | 'mid' | 'worst_of_bar' | 'quote_cross' | string;
            idealizedFills?: boolean;
            config?: {
                [key: string]: unknown;
            };
            queue?: {
                [key: string]: unknown;
            };
        } | null;
        borrowCostModel?: {
            [key: string]: unknown;
        };
        financingCostModel?: {
            [key: string]: unknown;
        };
        settlementModel?: {
            [key: string]: unknown;
        };
        sourceIds?: Array<string>;
        evidenceIds?: Array<string>;
    };
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategy-execution-config/cost-models';
};

export type CreateFinanceStrategyCostModelErrors = {
    /**
     * Invalid request or missing organization context
     */
    400: unknown;
    /**
     * Cost model version already exists with different content
     */
    409: unknown;
};

export type CreateFinanceStrategyCostModelResponses = {
    /**
     * Persist a versioned finance strategy cost model
     */
    200: FinanceStrategyCostModelPersistResult;
};

export type CreateFinanceStrategyCostModelResponse = CreateFinanceStrategyCostModelResponses[keyof CreateFinanceStrategyCostModelResponses];

export type GetFinanceStrategyCostModelData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        version?: string;
    };
    url: '/api/v1/finance/strategy-execution-config/cost-models/{id}';
};

export type GetFinanceStrategyCostModelErrors = {
    /**
     * Organization context is required
     */
    400: unknown;
    /**
     * Cost model not found
     */
    404: unknown;
};

export type GetFinanceStrategyCostModelResponses = {
    /**
     * Finance strategy cost model detail
     */
    200: FinanceStrategyCostModelDetailResult;
};

export type GetFinanceStrategyCostModelResponse = GetFinanceStrategyCostModelResponses[keyof GetFinanceStrategyCostModelResponses];

export type ListFinanceStrategyLifecycleTransitionsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
        offset?: string;
        definitionId?: string;
        bucketDefinitionId?: string;
        toState?: 'candidate' | 'research_brief' | 'backtest_pending' | 'backtest_done_pass' | 'backtest_done_fail' | 'risk_pending' | 'risk_cleared' | 'risk_rejected' | 'paper_trading' | 'paper_trading_completed' | 'pending_live_approval' | 'live_trading' | 'retired' | 'archived' | 'watchlist';
        transitionType?: string;
        sourceRunId?: string;
    };
    url: '/api/v1/finance/strategy-execution-config/lifecycle-transitions';
};

export type ListFinanceStrategyLifecycleTransitionsErrors = {
    /**
     * Organization context is required
     */
    400: unknown;
};

export type ListFinanceStrategyLifecycleTransitionsResponses = {
    /**
     * List finance strategy lifecycle transitions
     */
    200: FinanceStrategyLifecycleTransitionList;
};

export type ListFinanceStrategyLifecycleTransitionsResponse = ListFinanceStrategyLifecycleTransitionsResponses[keyof ListFinanceStrategyLifecycleTransitionsResponses];

export type CreateFinanceStrategyLifecycleTransitionData = {
    body?: FinanceStrategyLifecycleTransitionCreateInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategy-execution-config/lifecycle-transitions';
};

export type CreateFinanceStrategyLifecycleTransitionErrors = {
    /**
     * Invalid request or missing organization context
     */
    400: unknown;
};

export type CreateFinanceStrategyLifecycleTransitionResponses = {
    /**
     * Create an auditable finance strategy lifecycle transition
     */
    200: FinanceStrategyLifecycleTransitionCreateResult;
};

export type CreateFinanceStrategyLifecycleTransitionResponse = CreateFinanceStrategyLifecycleTransitionResponses[keyof CreateFinanceStrategyLifecycleTransitionResponses];

export type CommitFinanceStrategyLifecycleTransitionData = {
    body?: FinanceStrategyLifecycleCommitInput;
    path?: never;
    query?: never;
    url: '/api/v1/finance/strategy-execution-config/lifecycle-transitions/commit';
};

export type CommitFinanceStrategyLifecycleTransitionErrors = {
    /**
     * Invalid request or missing organization context
     */
    400: unknown;
    /**
     * No valid approved decision authorizes this transition
     */
    403: unknown;
    /**
     * Approval decision not found
     */
    404: unknown;
    /**
     * Approval decision has already been consumed or conflicts with current state
     */
    409: unknown;
};

export type CommitFinanceStrategyLifecycleTransitionResponses = {
    /**
     * Commit an approved capital-facing lifecycle transition
     */
    200: FinanceStrategyLifecycleTransitionCreateResult;
};

export type CommitFinanceStrategyLifecycleTransitionResponse = CommitFinanceStrategyLifecycleTransitionResponses[keyof CommitFinanceStrategyLifecycleTransitionResponses];

export type GetFinanceArtifactPreviewData = {
    body?: never;
    path: {
        artifactId: string;
    };
    query?: never;
    url: '/api/v1/finance/artifacts/{artifactId}/preview';
};

export type GetFinanceArtifactPreviewErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Artifact not found or not accessible
     */
    404: unknown;
};

export type GetFinanceArtifactPreviewResponses = {
    /**
     * Metadata-only preview of a finance conversation artifact
     */
    200: FinanceArtifactPreviewResult | FinanceArtifactUnsupportedPreviewResult;
};

export type GetFinanceArtifactPreviewResponse = GetFinanceArtifactPreviewResponses[keyof GetFinanceArtifactPreviewResponses];

export type ListFinanceResearchWorkflowsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/research-workflows';
};

export type ListFinanceResearchWorkflowsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListFinanceResearchWorkflowsResponses = {
    /**
     * Research workflow list
     */
    200: FinanceResearchWorkflowList;
};

export type ListFinanceResearchWorkflowsResponse = ListFinanceResearchWorkflowsResponses[keyof ListFinanceResearchWorkflowsResponses];

export type StartFinanceResearchWorkflowRunData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/research-workflows/{id}/runs';
};

export type StartFinanceResearchWorkflowRunErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Research workflow not found or not allowlisted
     */
    404: unknown;
};

export type StartFinanceResearchWorkflowRunResponses = {
    /**
     * Research workflow run triggered
     */
    200: FinanceResearchRunStartResult;
};

export type StartFinanceResearchWorkflowRunResponse = StartFinanceResearchWorkflowRunResponses[keyof StartFinanceResearchWorkflowRunResponses];

export type ListFinancePlannerRecommendationsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
    };
    url: '/api/v1/finance/planner-recommendations';
};

export type ListFinancePlannerRecommendationsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListFinancePlannerRecommendationsResponses = {
    /**
     * Ranked WTN planner recommendations
     */
    200: FinancePlannerRecommendationsResult;
};

export type ListFinancePlannerRecommendationsResponse = ListFinancePlannerRecommendationsResponses[keyof ListFinancePlannerRecommendationsResponses];

export type GetFinanceBucketCompositionData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
    };
    url: '/api/v1/finance/bucket-composition';
};

export type GetFinanceBucketCompositionErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type GetFinanceBucketCompositionResponses = {
    /**
     * Bucket composition status with evaluations, run requests, and scores
     */
    200: FinanceBucketCompositionResult;
};

export type GetFinanceBucketCompositionResponse = GetFinanceBucketCompositionResponses[keyof GetFinanceBucketCompositionResponses];

export type ApplyFinanceBucketDecisionData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/bucket-composition/decisions/{id}/apply';
};

export type ApplyFinanceBucketDecisionErrors = {
    /**
     * Organization context required, decision not approved, expired, or payload invalid
     */
    400: unknown;
    /**
     * Policy denied
     */
    403: unknown;
    /**
     * Decision or bucket not found
     */
    404: unknown;
    /**
     * Bucket state drift, evidence stale, or decision already consumed
     */
    409: unknown;
};

export type ApplyFinanceBucketDecisionResponses = {
    /**
     * Decision applied successfully; bucket definition updated
     */
    200: FinanceBucketDecisionApplyResult;
};

export type ApplyFinanceBucketDecisionResponse = ApplyFinanceBucketDecisionResponses[keyof ApplyFinanceBucketDecisionResponses];

export type ProposeFinanceBucketReweightData = {
    body?: FinanceProposeReweightBody;
    path?: never;
    query?: never;
    url: '/api/v1/finance/bucket-composition/decisions/propose-reweight';
};

export type ProposeFinanceBucketReweightErrors = {
    /**
     * Organization context required, or the requested weights are invalid (component mismatch, out of range, or do not sum to 1)
     */
    400: unknown;
    /**
     * Policy denied
     */
    403: unknown;
    /**
     * Bucket not found for this organization
     */
    404: unknown;
    /**
     * Bucket not adjustable, no current score evidence, or composer daemon not seeded
     */
    409: unknown;
};

export type ProposeFinanceBucketReweightResponses = {
    /**
     * Pending reweight_bucket decision created (or an identical pending proposal returned)
     */
    200: FinanceProposeReweightResult;
};

export type ProposeFinanceBucketReweightResponse = ProposeFinanceBucketReweightResponses[keyof ProposeFinanceBucketReweightResponses];

export type ListFinanceIndicatorDecisionsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
    };
    url: '/api/v1/finance/indicator-decisions';
};

export type ListFinanceIndicatorDecisionsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListFinanceIndicatorDecisionsResponses = {
    /**
     * List of indicator decision requests for the organization
     */
    200: FinanceIndicatorDecisionList;
};

export type ListFinanceIndicatorDecisionsResponse = ListFinanceIndicatorDecisionsResponses[keyof ListFinanceIndicatorDecisionsResponses];

export type EnqueueFinanceIndicatorDecisionData = {
    body?: {
        symbol: string;
        exchange?: string;
        assetClass?: string;
        timeframe: string;
        windowStart: string;
        windowEnd: string;
        indicator: {
            canonicalKey: string;
        };
        parameters?: {
            [key: string]: number | string | boolean;
        };
        rules: Array<{
            signalId?: string;
            side: 'long' | 'short';
            description: string;
            left: {
                type: 'indicator';
                indicatorId: string;
                output: string;
            };
            op: '>' | '>=' | '<' | '<=' | '==' | '!=' | 'crosses_above' | 'crosses_below' | 'between' | 'score_above';
            right: {
                type: 'indicator';
                indicatorId: string;
                output: string;
            } | {
                type: 'constant';
                value: number | string | boolean;
            } | {
                type: 'field';
                field: string;
            };
        }>;
        idempotencyKey?: string;
    };
    path?: never;
    query?: never;
    url: '/api/v1/finance/indicator-decisions';
};

export type EnqueueFinanceIndicatorDecisionErrors = {
    /**
     * Invalid input or indicator not found
     */
    400: unknown;
    /**
     * Request conflict
     */
    409: unknown;
};

export type EnqueueFinanceIndicatorDecisionResponses = {
    /**
     * Indicator decision request enqueued
     */
    201: FinanceIndicatorDecisionEnqueueResult;
};

export type EnqueueFinanceIndicatorDecisionResponse = EnqueueFinanceIndicatorDecisionResponses[keyof EnqueueFinanceIndicatorDecisionResponses];

export type GetFinanceIndicatorDecisionData = {
    body?: never;
    path: {
        requestId: string;
    };
    query?: never;
    url: '/api/v1/finance/indicator-decisions/{requestId}';
};

export type GetFinanceIndicatorDecisionErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Indicator decision request not found
     */
    404: unknown;
};

export type GetFinanceIndicatorDecisionResponses = {
    /**
     * Indicator decision request summary
     */
    200: FinanceIndicatorDecisionGetResult;
};

export type GetFinanceIndicatorDecisionResponse = GetFinanceIndicatorDecisionResponses[keyof GetFinanceIndicatorDecisionResponses];

export type ListFinanceStrategyDecisionsData = {
    body?: never;
    path?: never;
    query?: {
        limit?: string;
    };
    url: '/api/v1/finance/strategy-decisions';
};

export type ListFinanceStrategyDecisionsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListFinanceStrategyDecisionsResponses = {
    /**
     * Strategy decision summaries
     */
    200: StrategyDecisionList;
};

export type ListFinanceStrategyDecisionsResponse = ListFinanceStrategyDecisionsResponses[keyof ListFinanceStrategyDecisionsResponses];

export type GetFinanceStrategyDecisionData = {
    body?: never;
    path: {
        definitionId: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-decisions/{definitionId}';
};

export type GetFinanceStrategyDecisionErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Definition not found
     */
    404: unknown;
};

export type GetFinanceStrategyDecisionResponses = {
    /**
     * Strategy decision summary
     */
    200: FinanceStrategyDecisionGetResult;
};

export type GetFinanceStrategyDecisionResponse = GetFinanceStrategyDecisionResponses[keyof GetFinanceStrategyDecisionResponses];

export type EvaluateFinanceStrategyDecisionData = {
    body?: StrategyDecisionEvaluateRequest;
    path: {
        definitionId: string;
    };
    query?: never;
    url: '/api/v1/finance/strategy-decisions/{definitionId}/evaluate';
};

export type EvaluateFinanceStrategyDecisionErrors = {
    /**
     * Organization context required or invalid body
     */
    400: unknown;
    /**
     * Definition not found
     */
    404: unknown;
};

export type EvaluateFinanceStrategyDecisionResponses = {
    /**
     * Run request enqueued
     */
    201: StrategyDecisionEvaluateResult;
};

export type EvaluateFinanceStrategyDecisionResponse = EvaluateFinanceStrategyDecisionResponses[keyof EvaluateFinanceStrategyDecisionResponses];

export type EvaluateFinanceStrategyDefinitionData = {
    body?: StrategyEvaluationRunRequest;
    path: {
        definitionId: number;
    };
    query?: never;
    url: '/api/v1/finance/strategy-evaluations/{definitionId}';
};

export type EvaluateFinanceStrategyDefinitionErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type EvaluateFinanceStrategyDefinitionResponses = {
    /**
     * Evaluation run result — assignments evaluated → satisfaction, or no_assignments when no plan is applied
     */
    200: {
        data: StrategyEvaluationRunResult;
    };
};

export type EvaluateFinanceStrategyDefinitionResponse = EvaluateFinanceStrategyDefinitionResponses[keyof EvaluateFinanceStrategyDefinitionResponses];

export type GetFinanceOperationsSummaryData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Per-section row cap (1–20, default 5)
         */
        limit?: string;
    };
    url: '/api/v1/finance/operations-summary';
};

export type GetFinanceOperationsSummaryErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type GetFinanceOperationsSummaryResponses = {
    /**
     * Aggregate finance operations summary
     */
    200: FinanceOperationsSummaryResult;
};

export type GetFinanceOperationsSummaryResponse = GetFinanceOperationsSummaryResponses[keyof GetFinanceOperationsSummaryResponses];

export type LookupFinanceCommandOptionsData = {
    body?: never;
    path?: never;
    query: {
        command: 'indicator' | 'strategy' | 'ticker' | 'research' | 'timeframe';
        q?: string;
        limit?: string;
    };
    url: '/api/v1/finance/command-lookup';
};

export type LookupFinanceCommandOptionsErrors = {
    /**
     * Invalid command or organization context required
     */
    400: unknown;
};

export type LookupFinanceCommandOptionsResponses = {
    /**
     * Command lookup options
     */
    200: FinanceCommandLookupResult;
};

export type LookupFinanceCommandOptionsResponse = LookupFinanceCommandOptionsResponses[keyof LookupFinanceCommandOptionsResponses];

export type ListFinanceConversationPersonasData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/conversation-personas';
};

export type ListFinanceConversationPersonasErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListFinanceConversationPersonasResponses = {
    /**
     * Active finance conversation personas for the org (bounded list)
     */
    200: Array<FinanceConversationPersona>;
};

export type ListFinanceConversationPersonasResponse = ListFinanceConversationPersonasResponses[keyof ListFinanceConversationPersonasResponses];

export type PreviewFinanceIndicatorImportData = {
    body?: IndicatorImportPreviewBody;
    path?: never;
    query?: never;
    url: '/api/v1/finance/indicator-imports/preview';
};

export type PreviewFinanceIndicatorImportErrors = {
    /**
     * Validation error (ambiguous input, oversized source, disallowed URL)
     */
    400: unknown;
    /**
     * Policy CanManageStrategies required
     */
    403: unknown;
};

export type PreviewFinanceIndicatorImportResponses = {
    /**
     * Non-executable indicator candidate preview from Pine Script source or URL
     */
    200: IndicatorImportPreviewResult;
};

export type PreviewFinanceIndicatorImportResponse = PreviewFinanceIndicatorImportResponses[keyof PreviewFinanceIndicatorImportResponses];

export type TranspileFinanceIndicatorImportData = {
    body?: IndicatorImportTranspileBody;
    path?: never;
    query?: never;
    url: '/api/v1/finance/indicator-imports/transpile';
};

export type TranspileFinanceIndicatorImportErrors = {
    /**
     * Validation error (missing input, unsupported features, cross-check failure, forbidden code construct)
     */
    400: unknown;
    /**
     * Policy CanManageStrategies required
     */
    403: unknown;
    /**
     * LLM unavailable — transpilation requires an active AI provider
     */
    500: unknown;
};

export type TranspileFinanceIndicatorImportResponses = {
    /**
     * DRAFT indicator definition + PyneCore implementation created. pyneCode is stored in DB only — execution requires harness proof + governed promotion.
     */
    201: IndicatorImportTranspileResult;
};

export type TranspileFinanceIndicatorImportResponse = TranspileFinanceIndicatorImportResponses[keyof TranspileFinanceIndicatorImportResponses];

export type ListFinanceIndicatorsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Filter by name / short name / canonical key
         */
        q?: string;
        /**
         * Max results (default 50, max 100)
         */
        limit?: number;
    };
    url: '/api/v1/finance/indicators';
};

export type ListFinanceIndicatorsErrors = {
    /**
     * Policy CanViewResearch required
     */
    403: unknown;
};

export type ListFinanceIndicatorsResponses = {
    /**
     * Indicator catalog — org-scoped definitions + marketplace definitions with implementations summary
     */
    200: IndicatorCatalogList;
};

export type ListFinanceIndicatorsResponse = ListFinanceIndicatorsResponses[keyof ListFinanceIndicatorsResponses];

export type ApplyFinanceIndicatorPromotionData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/indicator-promotions/decisions/{id}/apply';
};

export type ApplyFinanceIndicatorPromotionErrors = {
    /**
     * Organization context required, decision not approved, expired, or payload invalid
     */
    400: unknown;
    /**
     * Policy denied
     */
    403: unknown;
    /**
     * Decision or implementation not found
     */
    404: unknown;
    /**
     * Contract drift, non-draft implementation, or decision already consumed
     */
    409: unknown;
};

export type ApplyFinanceIndicatorPromotionResponses = {
    /**
     * Decision applied; implementation promoted to active
     */
    200: FinanceIndicatorPromotionApplyResult;
};

export type ApplyFinanceIndicatorPromotionResponse = ApplyFinanceIndicatorPromotionResponses[keyof ApplyFinanceIndicatorPromotionResponses];

export type CreateTickerResearchNoteData = {
    body: TickerResearchNoteCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/research-notes/ticker';
};

export type CreateTickerResearchNoteErrors = {
    /**
     * Organization context required or invalid input
     */
    400: unknown;
    /**
     * No ticker mentions found for this symbol in the window
     */
    404: unknown;
};

export type CreateTickerResearchNoteResponses = {
    /**
     * Ticker research note created. Source commentary — not a trading signal.
     */
    201: TickerResearchNote;
};

export type CreateTickerResearchNoteResponse = CreateTickerResearchNoteResponses[keyof CreateTickerResearchNoteResponses];

export type ListVarEstimatesData = {
    body?: never;
    path?: never;
    query?: {
        subjectScope?: string;
        subjectId?: string;
        method?: 'parametric' | 'historical' | 'monte_carlo';
        confidence?: '0.95' | '0.99';
        horizon?: '1d' | '5d' | '10d' | '20d';
        status?: 'current' | 'superseded';
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/var';
};

export type ListVarEstimatesErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListVarEstimatesResponses = {
    /**
     * Portfolio VaR estimates for the organization
     */
    200: {
        data: Array<VarEstimate>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListVarEstimatesResponse = ListVarEstimatesResponses[keyof ListVarEstimatesResponses];

export type ListVarBacktestsData = {
    body?: never;
    path?: never;
    query?: {
        subjectScope?: string;
        subjectId?: string;
        method?: 'parametric' | 'historical' | 'monte_carlo';
        confidence?: '0.95' | '0.99';
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/var/backtests';
};

export type ListVarBacktestsErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListVarBacktestsResponses = {
    /**
     * VaR backtest results (Kupiec/Christoffersen coverage tests)
     */
    200: {
        data: Array<VarBacktest>;
        total: number;
    };
};

export type ListVarBacktestsResponse = ListVarBacktestsResponses[keyof ListVarBacktestsResponses];

export type GetVarEstimateData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/var/{id}';
};

export type GetVarEstimateErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * VaR estimate not found
     */
    404: unknown;
};

export type GetVarEstimateResponses = {
    /**
     * Portfolio VaR estimate detail
     */
    200: {
        data: VarEstimate;
    };
};

export type GetVarEstimateResponse = GetVarEstimateResponses[keyof GetVarEstimateResponses];

export type ListVarComponentsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/var/{id}/components';
};

export type ListVarComponentsErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * VaR estimate not found
     */
    404: unknown;
};

export type ListVarComponentsResponses = {
    /**
     * Tail-attribution components for the VaR estimate
     */
    200: {
        data: Array<VarComponentRow>;
    };
};

export type ListVarComponentsResponse = ListVarComponentsResponses[keyof ListVarComponentsResponses];

export type ListStressScenariosData = {
    body?: never;
    path?: never;
    query?: {
        kind?: 'historical_episode' | 'correlation_to_one' | 'factor_shock' | 'sector_shock' | 'rate_twist' | 'idiosyncratic';
    };
    url: '/api/v1/finance/stress-scenarios';
};

export type ListStressScenariosErrors = {
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListStressScenariosResponses = {
    /**
     * In-tree stress scenario library (no DB — always available)
     */
    200: {
        data: Array<{
            scenarioKey: string;
            kind: 'historical_episode' | 'correlation_to_one' | 'factor_shock' | 'sector_shock' | 'rate_twist' | 'idiosyncratic';
            spec: StressScenarioSpec;
        }>;
        total: number;
    };
};

export type ListStressScenariosResponse = ListStressScenariosResponses[keyof ListStressScenariosResponses];

export type GetStressScenarioData = {
    body?: never;
    path: {
        scenarioKey: string;
    };
    query?: never;
    url: '/api/v1/finance/stress-scenarios/{scenarioKey}';
};

export type GetStressScenarioErrors = {
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * Scenario key not found in the library
     */
    404: unknown;
};

export type GetStressScenarioResponses = {
    /**
     * Stress scenario library entry
     */
    200: {
        data: {
            scenarioKey: string;
            kind: 'historical_episode' | 'correlation_to_one' | 'factor_shock' | 'sector_shock' | 'rate_twist' | 'idiosyncratic';
            spec: StressScenarioSpec;
        };
    };
};

export type GetStressScenarioResponse = GetStressScenarioResponses[keyof GetStressScenarioResponses];

export type ListStressResultsData = {
    body?: never;
    path?: never;
    query?: {
        scenarioKey?: string;
        status?: 'ready' | 'degraded' | 'blocked';
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/stress-results';
};

export type ListStressResultsErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListStressResultsResponses = {
    /**
     * Persisted stress results for the organization (latest first)
     */
    200: {
        data: Array<StressResultContract>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListStressResultsResponse = ListStressResultsResponses[keyof ListStressResultsResponses];

export type GetStressResultData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/stress-results/{id}';
};

export type GetStressResultErrors = {
    /**
     * Missing organization context or invalid id
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * Stress result not found
     */
    404: unknown;
};

export type GetStressResultResponses = {
    /**
     * Full stress result including loss, contributions, stressed vol, riskByBlock, diagnostics
     */
    200: {
        data: StressResultContract;
    };
};

export type GetStressResultResponse = GetStressResultResponses[keyof GetStressResultResponses];

export type ListAttributionRunsData = {
    body?: never;
    path?: never;
    query?: {
        subjectId?: string;
        method?: 'brinson' | 'factor';
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/attribution-runs';
};

export type ListAttributionRunsErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListAttributionRunsResponses = {
    /**
     * Attribution runs for the organization, latest computedAt first
     */
    200: {
        data: Array<AttributionRun>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListAttributionRunsResponse = ListAttributionRunsResponses[keyof ListAttributionRunsResponses];

export type GetAttributionRunData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/attribution-runs/{id}';
};

export type GetAttributionRunErrors = {
    /**
     * Missing organization context or invalid id
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * Attribution run not found
     */
    404: unknown;
};

export type GetAttributionRunResponses = {
    /**
     * Full attribution run including manifest and all effect rows
     */
    200: {
        data: AttributionRun;
    };
};

export type GetAttributionRunResponse = GetAttributionRunResponses[keyof GetAttributionRunResponses];

export type ListAttributionEffectsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        method?: 'brinson' | 'factor';
        effectKind?: 'allocation' | 'selection' | 'interaction' | 'factor_return' | 'specific' | 'total';
        periodIndex?: string;
    };
    url: '/api/v1/finance/attribution-runs/{id}/effects';
};

export type ListAttributionEffectsErrors = {
    /**
     * Missing organization context or invalid id
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * Attribution run not found
     */
    404: unknown;
};

export type ListAttributionEffectsResponses = {
    /**
     * Attribution effect rows for the run, optionally filtered
     */
    200: {
        data: Array<AttributionEffectRow>;
        total: number;
    };
};

export type ListAttributionEffectsResponse = ListAttributionEffectsResponses[keyof ListAttributionEffectsResponses];

export type ListTcaScorecardsData = {
    body?: never;
    path?: never;
    query: {
        subjectKind?: string;
        subjectId: number;
    };
    url: '/api/v1/finance/tca-scorecards';
};

export type ListTcaScorecardsErrors = {
    /**
     * Missing organization context or invalid subjectId
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListTcaScorecardsResponses = {
    /**
     * TCA best-execution scorecards for the subject, all scopes (tca:all, per-venue, per-symbol)
     */
    200: {
        data: Array<TcaScorecard>;
        total: number;
    };
};

export type ListTcaScorecardsResponse = ListTcaScorecardsResponses[keyof ListTcaScorecardsResponses];

export type ListCrowdingScoresData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * optional scope filter, e.g. crowding:factor:momentum
         */
        scope?: string;
    };
    url: '/api/v1/finance/crowding';
};

export type ListCrowdingScoresErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListCrowdingScoresResponses = {
    /**
     * Current crowding vectors (scoreType=crowding) for the org, newest first (per subject × scope × regime). Read-only.
     */
    200: {
        data: Array<CrowdingScore>;
        total: number;
    };
};

export type ListCrowdingScoresResponse = ListCrowdingScoresResponses[keyof ListCrowdingScoresResponses];

export type ListCapitalAllocationsData = {
    body?: never;
    path?: never;
    query?: {
        poolKey?: string;
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/capital-allocations';
};

export type ListCapitalAllocationsErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListCapitalAllocationsResponses = {
    /**
     * Capital allocation proposals for the organization, latest first
     */
    200: {
        data: Array<CapitalAllocationDigest>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListCapitalAllocationsResponse = ListCapitalAllocationsResponses[keyof ListCapitalAllocationsResponses];

export type GetCapitalAllocationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/capital-allocations/{id}';
};

export type GetCapitalAllocationErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * Capital allocation proposal not found
     */
    404: unknown;
};

export type GetCapitalAllocationResponses = {
    /**
     * Full capital allocation proposal including manifest and sleeves
     */
    200: {
        data: CapitalAllocationProposal;
    };
};

export type GetCapitalAllocationResponse = GetCapitalAllocationResponses[keyof GetCapitalAllocationResponses];

export type ListCapitalAllocationSleevesData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/capital-allocations/{id}/sleeves';
};

export type ListCapitalAllocationSleevesErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * Capital allocation proposal not found
     */
    404: unknown;
};

export type ListCapitalAllocationSleevesResponses = {
    /**
     * Sleeve allocation lines for one capital allocation proposal
     */
    200: {
        data: Array<CapitalAllocationSleeve>;
        total: number;
    };
};

export type ListCapitalAllocationSleevesResponse = ListCapitalAllocationSleevesResponses[keyof ListCapitalAllocationSleevesResponses];

export type SubmitCapitalAllocationData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/capital-allocations/{id}/submit-for-approval';
};

export type SubmitCapitalAllocationErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanManageRisk required
     */
    403: unknown;
    /**
     * Capital allocation proposal not found
     */
    404: unknown;
    /**
     * Governance daemon not seeded or state conflict
     */
    409: unknown;
};

export type SubmitCapitalAllocationResponses = {
    /**
     * Submit result — new or existing pending daemon_decisions row. No capital is moved.
     */
    200: {
        data: CapitalAllocationSubmitResult;
    };
};

export type SubmitCapitalAllocationResponse = SubmitCapitalAllocationResponses[keyof SubmitCapitalAllocationResponses];

export type ListCapacityCurvesData = {
    body?: never;
    path?: never;
    query?: {
        sleeveKind?: 'bucket' | 'strategy' | 'external';
        status?: 'ready' | 'research_only' | 'blocked';
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/capacity-curves';
};

export type ListCapacityCurvesErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListCapacityCurvesResponses = {
    /**
     * Capacity curves for the organization, latest computedAt first
     */
    200: {
        data: Array<CapacityCurve>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListCapacityCurvesResponse = ListCapacityCurvesResponses[keyof ListCapacityCurvesResponses];

export type GetCapacityCurveData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/capacity-curves/{id}';
};

export type GetCapacityCurveErrors = {
    /**
     * Missing organization context or invalid id
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * Capacity curve not found
     */
    404: unknown;
};

export type GetCapacityCurveResponses = {
    /**
     * Full capacity curve including manifest
     */
    200: {
        data: CapacityCurve;
    };
};

export type GetCapacityCurveResponse = GetCapacityCurveResponses[keyof GetCapacityCurveResponses];

export type GetTradingAccountData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/accounts/{id}';
};

export type GetTradingAccountErrors = {
    /**
     * Missing organization context or invalid id
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * Trading account not found
     */
    404: unknown;
};

export type GetTradingAccountResponses = {
    /**
     * Trading account header and net-liquidation
     */
    200: {
        data: TradingAccount;
    };
};

export type GetTradingAccountResponse = GetTradingAccountResponses[keyof GetTradingAccountResponses];

export type CreateDepositData = {
    body: {
        amount: number;
        currency?: string;
        idempotency_key?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/accounts/{id}/deposits';
};

export type CreateDepositErrors = {
    /**
     * Missing organization context, invalid id, or invalid body
     */
    400: unknown;
    /**
     * Policy CanManagePortfolio required
     */
    403: unknown;
    /**
     * Trading account not found
     */
    404: unknown;
};

export type CreateDepositResponses = {
    /**
     * Deposit applied (applied:false means idempotency no-op)
     */
    200: {
        data: CashMovementResult;
    };
};

export type CreateDepositResponse = CreateDepositResponses[keyof CreateDepositResponses];

export type CreateWithdrawalData = {
    body: {
        amount: number;
        currency?: string;
        idempotency_key?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/accounts/{id}/withdrawals';
};

export type CreateWithdrawalErrors = {
    /**
     * Missing organization context, invalid id, or invalid body
     */
    400: unknown;
    /**
     * Policy CanManagePortfolio required
     */
    403: unknown;
    /**
     * Trading account not found
     */
    404: unknown;
};

export type CreateWithdrawalResponses = {
    /**
     * Withdrawal applied (applied:false means idempotency no-op)
     */
    200: {
        data: CashMovementResult;
    };
};

export type CreateWithdrawalResponse = CreateWithdrawalResponses[keyof CreateWithdrawalResponses];

export type CreateAdjustmentData = {
    body: {
        amount: number;
        currency?: string;
        idempotency_key?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/accounts/{id}/adjustments';
};

export type CreateAdjustmentErrors = {
    /**
     * Missing organization context, invalid id, or invalid body
     */
    400: unknown;
    /**
     * Policy CanManagePortfolio required
     */
    403: unknown;
    /**
     * Trading account not found
     */
    404: unknown;
};

export type CreateAdjustmentResponses = {
    /**
     * Adjustment applied (applied:false means idempotency no-op)
     */
    200: {
        data: CashMovementResult;
    };
};

export type CreateAdjustmentResponse = CreateAdjustmentResponses[keyof CreateAdjustmentResponses];

export type GetAccountFxCashData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        /**
         * ISO 8601 datetime for PIT rate lookup; defaults to now.
         */
        as_of?: string;
    };
    url: '/api/v1/finance/accounts/{id}/fx/cash';
};

export type GetAccountFxCashErrors = {
    /**
     * Missing organization context or invalid id
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
    /**
     * Trading account not found
     */
    404: unknown;
};

export type GetAccountFxCashResponses = {
    /**
     * FX-translated cash breakdown per currency with base-currency total
     */
    200: {
        data: AccountFxCash;
    };
};

export type GetAccountFxCashResponse = GetAccountFxCashResponses[keyof GetAccountFxCashResponses];

export type ListPositionLotsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        symbol?: string;
        status?: 'open' | 'closed';
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/accounts/{id}/lots';
};

export type ListPositionLotsErrors = {
    /**
     * Missing organization context or invalid id
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListPositionLotsResponses = {
    /**
     * Position lots for the account, newest first
     */
    200: {
        data: Array<PositionLot>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListPositionLotsResponse = ListPositionLotsResponses[keyof ListPositionLotsResponses];

export type ListLotDisposalsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        symbol?: string;
        holding_term?: 'short' | 'long';
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/accounts/{id}/disposals';
};

export type ListLotDisposalsErrors = {
    /**
     * Missing organization context or invalid id
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListLotDisposalsResponses = {
    /**
     * Lot disposals for the account, newest first
     */
    200: {
        data: Array<LotDisposal>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListLotDisposalsResponse = ListLotDisposalsResponses[keyof ListLotDisposalsResponses];

export type ListBookSnapshotsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        snapshot_type?: 'sod' | 'eod';
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/accounts/{id}/snapshots';
};

export type ListBookSnapshotsErrors = {
    /**
     * Missing organization context or invalid id
     */
    400: unknown;
    /**
     * Policy CanViewPortfolio required
     */
    403: unknown;
};

export type ListBookSnapshotsResponses = {
    /**
     * SOD/EOD lot-book snapshots for the account, newest as_of first
     */
    200: {
        data: Array<BookSnapshot>;
        total: number;
        limit: number;
        offset: number;
    };
};

export type ListBookSnapshotsResponse = ListBookSnapshotsResponses[keyof ListBookSnapshotsResponses];

export type DtiOperatorKillSwitchData = {
    body?: DtiKillSwitchRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/dti/forward-runs/{id}/kill-switch';
};

export type DtiOperatorKillSwitchErrors = {
    /**
     * Organization context required or invalid body
     */
    400: unknown;
    /**
     * Active forward run not found
     */
    404: unknown;
};

export type DtiOperatorKillSwitchResponses = {
    /**
     * Run paused by operator kill-switch
     */
    200: DtiKillSwitchResult;
};

export type DtiOperatorKillSwitchResponse = DtiOperatorKillSwitchResponses[keyof DtiOperatorKillSwitchResponses];

export type DtiOperatorResumeData = {
    body?: DtiResumeRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/dti/forward-runs/{id}/resume';
};

export type DtiOperatorResumeErrors = {
    /**
     * Organization context required or invalid body
     */
    400: unknown;
    /**
     * Forward run not found
     */
    404: unknown;
    /**
     * Run not paused, or requires four-eyes governance approval to resume
     */
    409: unknown;
};

export type DtiOperatorResumeResponses = {
    /**
     * Run resumed by operator
     */
    200: DtiKillSwitchResult;
};

export type DtiOperatorResumeResponse = DtiOperatorResumeResponses[keyof DtiOperatorResumeResponses];

export type CreateDiscretionaryRunData = {
    body?: CreateDiscretionaryRunRequest;
    path?: never;
    query?: never;
    url: '/api/v1/finance/dti/runs';
};

export type CreateDiscretionaryRunErrors = {
    /**
     * Organization context required or invalid body
     */
    400: unknown;
    /**
     * Persona template not found for the organization
     */
    404: unknown;
};

export type CreateDiscretionaryRunResponses = {
    /**
     * Discretionary paper forward run created (or existing run returned)
     */
    201: CreateDiscretionaryRunResult;
};

export type CreateDiscretionaryRunResponse = CreateDiscretionaryRunResponses[keyof CreateDiscretionaryRunResponses];

export type GetIntelSourceStyleProfileData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/intel-sources/{id}/style-profile';
};

export type GetIntelSourceStyleProfileErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * No style profile built for this source yet
     */
    404: unknown;
};

export type GetIntelSourceStyleProfileResponses = {
    /**
     * Current trader-style profile for the source
     */
    200: IntelSourceStyleProfileResult;
};

export type GetIntelSourceStyleProfileResponse = GetIntelSourceStyleProfileResponses[keyof GetIntelSourceStyleProfileResponses];

export type GetIntelSourceViewConfirmationData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/intel-sources/{id}/view-confirmation';
};

export type GetIntelSourceViewConfirmationErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type GetIntelSourceViewConfirmationResponses = {
    /**
     * Per-horizon hit-rate + agreement + pending summary for this source
     */
    200: IntelSourceViewConfirmationResponse;
};

export type GetIntelSourceViewConfirmationResponse = GetIntelSourceViewConfirmationResponses[keyof GetIntelSourceViewConfirmationResponses];

export type GetFinanceAuditLedgerChainData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        cursor_seq?: number | null;
    };
    url: '/api/v1/finance/audit-ledger/chain';
};

export type GetFinanceAuditLedgerChainErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type GetFinanceAuditLedgerChainResponses = {
    /**
     * Keyset-paginated ledger chain. next_cursor_seq is null when no further pages exist.
     */
    200: AuditLedgerEntryList;
};

export type GetFinanceAuditLedgerChainResponse = GetFinanceAuditLedgerChainResponses[keyof GetFinanceAuditLedgerChainResponses];

export type GetFinanceAuditLedgerOrderHistoryData = {
    body?: never;
    path: {
        order_id: number;
    };
    query?: never;
    url: '/api/v1/finance/audit-ledger/orders/{order_id}';
};

export type GetFinanceAuditLedgerOrderHistoryErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type GetFinanceAuditLedgerOrderHistoryResponses = {
    /**
     * All ledger entries referencing the given order, ordered by chain_seq.
     */
    200: {
        entries: Array<AuditLedgerEntry>;
    };
};

export type GetFinanceAuditLedgerOrderHistoryResponse = GetFinanceAuditLedgerOrderHistoryResponses[keyof GetFinanceAuditLedgerOrderHistoryResponses];

export type GetFinanceAuditLedgerHeadData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/audit-ledger/head';
};

export type GetFinanceAuditLedgerHeadErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * No ledger entries exist for this organization yet
     */
    404: unknown;
};

export type GetFinanceAuditLedgerHeadResponses = {
    /**
     * Current chain head — highest committed seq + hash + entry count.
     */
    200: AuditLedgerHead;
};

export type GetFinanceAuditLedgerHeadResponse = GetFinanceAuditLedgerHeadResponses[keyof GetFinanceAuditLedgerHeadResponses];

export type VerifyFinanceAuditLedgerChainData = {
    body?: never;
    path?: never;
    query?: {
        from_seq?: number | null;
        to_seq?: number | null;
    };
    url: '/api/v1/finance/audit-ledger/verify';
};

export type VerifyFinanceAuditLedgerChainErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type VerifyFinanceAuditLedgerChainResponses = {
    /**
     * Chain integrity result. valid=true means all hashes and linkages are intact in the requested range.
     */
    200: AuditLedgerChainVerificationResult;
};

export type VerifyFinanceAuditLedgerChainResponse = VerifyFinanceAuditLedgerChainResponses[keyof VerifyFinanceAuditLedgerChainResponses];

export type ListExecutionDeploymentsData = {
    body?: never;
    path?: never;
    query?: {
        venue?: 'paper' | 'live';
        scope?: string;
        status?: 'scheduled' | 'running' | 'finished' | 'failed' | 'killed';
        definition_id?: string;
        bucket_definition_id?: string;
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/execution-deployments';
};

export type ListExecutionDeploymentsErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
};

export type ListExecutionDeploymentsResponses = {
    /**
     * Execution deployments (capital-facing strategy runs) for the organization
     */
    200: ExecutionDeploymentList;
};

export type ListExecutionDeploymentsResponse = ListExecutionDeploymentsResponses[keyof ListExecutionDeploymentsResponses];

export type CreateExecutionDeploymentData = {
    body?: ExecutionDeploymentCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/execution-deployments';
};

export type CreateExecutionDeploymentErrors = {
    /**
     * Validation error — wrong lifecycle state, ambiguous entity, or missing body
     */
    400: unknown;
    /**
     * Strategy definition or bucket definition not found
     */
    404: unknown;
};

export type CreateExecutionDeploymentResponses = {
    /**
     * Execution deployment enqueued successfully
     */
    201: {
        data: ExecutionDeployment;
    };
};

export type CreateExecutionDeploymentResponse = CreateExecutionDeploymentResponses[keyof CreateExecutionDeploymentResponses];

export type GetExecutionDeploymentData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/execution-deployments/{id}';
};

export type GetExecutionDeploymentErrors = {
    /**
     * Missing organization context
     */
    400: unknown;
    /**
     * Execution deployment not found
     */
    404: unknown;
};

export type GetExecutionDeploymentResponses = {
    /**
     * Execution deployment detail with emitted orders and fills
     */
    200: {
        data: ExecutionDeploymentRun;
    };
};

export type GetExecutionDeploymentResponse = GetExecutionDeploymentResponses[keyof GetExecutionDeploymentResponses];

export type GetPortfolioValuationData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/portfolios/{id}/valuation';
};

export type GetPortfolioValuationErrors = {
    /**
     * Portfolio not found
     */
    404: unknown;
};

export type GetPortfolioValuationResponses = {
    /**
     * Computed marks for all holdings in a portfolio
     */
    200: {
        valuation: PortfolioValuationResult;
    };
};

export type GetPortfolioValuationResponse = GetPortfolioValuationResponses[keyof GetPortfolioValuationResponses];

export type GetPositionValuationData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/api/v1/finance/positions/{id}/valuation';
};

export type GetPositionValuationErrors = {
    /**
     * Position not found
     */
    404: unknown;
};

export type GetPositionValuationResponses = {
    /**
     * Computed mark for a single position
     */
    200: {
        mark: MarkResult;
    };
};

export type GetPositionValuationResponse = GetPositionValuationResponses[keyof GetPositionValuationResponses];

export type ListFinanceModelLineageData = {
    body?: never;
    path?: never;
    query?: {
        subjectKind?: 'strategy_definition' | 'strategy_bucket_definition';
        lifecycleState?: string;
        slug?: string;
        limit?: number;
        offset?: number | null;
    };
    url: '/api/v1/finance/model-lineage';
};

export type ListFinanceModelLineageErrors = {
    /**
     * Missing org context
     */
    400: unknown;
};

export type ListFinanceModelLineageResponses = {
    /**
     * Paginated list of model-lineage projections for the org
     */
    200: ModelLineageRecordList;
};

export type ListFinanceModelLineageResponse = ListFinanceModelLineageResponses[keyof ListFinanceModelLineageResponses];

export type GetFinanceModelLineageHistoryData = {
    body?: never;
    path: {
        subjectKind: 'strategy_definition' | 'strategy_bucket_definition';
        subjectId: number;
    };
    query?: never;
    url: '/api/v1/finance/model-lineage/{subjectKind}/{subjectId}/versions';
};

export type GetFinanceModelLineageHistoryErrors = {
    /**
     * Missing org context
     */
    400: unknown;
    /**
     * Subject not found
     */
    404: unknown;
};

export type GetFinanceModelLineageHistoryResponses = {
    /**
     * Version history records for one model
     */
    200: ModelLineageRecordList;
};

export type GetFinanceModelLineageHistoryResponse = GetFinanceModelLineageHistoryResponses[keyof GetFinanceModelLineageHistoryResponses];

export type GetFinanceModelLineageData = {
    body?: never;
    path: {
        subjectKind: 'strategy_definition' | 'strategy_bucket_definition';
        subjectId: number;
        version: number;
    };
    query?: never;
    url: '/api/v1/finance/model-lineage/{subjectKind}/{subjectId}/versions/{version}';
};

export type GetFinanceModelLineageErrors = {
    /**
     * Missing org context
     */
    400: unknown;
    /**
     * Model version not found
     */
    404: unknown;
};

export type GetFinanceModelLineageResponses = {
    /**
     * Full lineage chain (record + edges) for a specific model version
     */
    200: ModelLineageGraph;
};

export type GetFinanceModelLineageResponse = GetFinanceModelLineageResponses[keyof GetFinanceModelLineageResponses];

export type GetFinanceModelLineageGraphData = {
    body?: never;
    path: {
        subjectKind: 'strategy_definition' | 'strategy_bucket_definition';
        subjectId: number;
        version: number;
    };
    query?: never;
    url: '/api/v1/finance/model-lineage/{subjectKind}/{subjectId}/versions/{version}/graph';
};

export type GetFinanceModelLineageGraphErrors = {
    /**
     * Missing org context
     */
    400: unknown;
    /**
     * Model version not found
     */
    404: unknown;
};

export type GetFinanceModelLineageGraphResponses = {
    /**
     * Provenance edge list for a specific model version
     */
    200: ModelLineageGraph;
};

export type GetFinanceModelLineageGraphResponse = GetFinanceModelLineageGraphResponses[keyof GetFinanceModelLineageGraphResponses];

export type GetFinanceKgRegimeProfileData = {
    body?: never;
    path: {
        subjectKind: string;
        subjectId: number;
    };
    query?: never;
    url: '/api/v1/finance/knowledge/signals/{subjectKind}/{subjectId}/regime-profile';
};

export type GetFinanceKgRegimeProfileErrors = {
    /**
     * Invalid params or missing org context
     */
    400: unknown;
    /**
     * No current scores found for this subject
     */
    404: unknown;
};

export type GetFinanceKgRegimeProfileResponses = {
    /**
     * Regime-conditional scoring profile for a subject. byScoreType groups the global (regime="") score with per-regime breakdowns. isRegimeConditional=true means the signal performs differently across regimes.
     */
    200: KgRegimeProfile;
};

export type GetFinanceKgRegimeProfileResponse = GetFinanceKgRegimeProfileResponses[keyof GetFinanceKgRegimeProfileResponses];

export type GetFinanceKgNodeEdgesData = {
    body?: never;
    path: {
        nodeId: number;
    };
    query?: never;
    url: '/api/v1/finance/knowledge/nodes/{nodeId}/edges';
};

export type GetFinanceKgNodeEdgesErrors = {
    /**
     * Invalid nodeId or missing org context
     */
    400: unknown;
    /**
     * Node not found for this org
     */
    404: unknown;
};

export type GetFinanceKgNodeEdgesResponses = {
    /**
     * Active KG edges for a node (src OR dst = nodeId). linkedNode is the other endpoint, batch-loaded (no N+1).
     */
    200: KgNodeEdges;
};

export type GetFinanceKgNodeEdgesResponse = GetFinanceKgNodeEdgesResponses[keyof GetFinanceKgNodeEdgesResponses];

export type SearchFinanceKgData = {
    body?: never;
    path?: never;
    query: {
        q: string;
        limit?: number;
    };
    url: '/api/v1/finance/knowledge/search';
};

export type SearchFinanceKgErrors = {
    /**
     * Invalid query params or missing org context
     */
    400: unknown;
};

export type SearchFinanceKgResponses = {
    /**
     * Hybrid lexical + pgvector node search, fused via reciprocal-rank fusion (RRF_K=60). match_type indicates which half(s) matched: keyword | semantic | hybrid. When Ollama is unreachable the vector half is skipped (keyword-only, not an error).
     */
    200: KgSearchResultList;
};

export type SearchFinanceKgResponse = SearchFinanceKgResponses[keyof SearchFinanceKgResponses];

export type ListBrokerCredentialsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/broker-credentials';
};

export type ListBrokerCredentialsResponses = {
    /**
     * List of broker credentials
     */
    200: BrokerCredentialList;
};

export type ListBrokerCredentialsResponse = ListBrokerCredentialsResponses[keyof ListBrokerCredentialsResponses];

export type CreateBrokerCredentialData = {
    body?: BrokerCredentialCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/broker-credentials';
};

export type CreateBrokerCredentialResponses = {
    /**
     * Broker credential created
     */
    201: BrokerCredential;
};

export type CreateBrokerCredentialResponse = CreateBrokerCredentialResponses[keyof CreateBrokerCredentialResponses];

export type DeleteBrokerCredentialData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/broker-credentials/{id}';
};

export type DeleteBrokerCredentialResponses = {
    /**
     * Deleted
     */
    204: void;
};

export type DeleteBrokerCredentialResponse = DeleteBrokerCredentialResponses[keyof DeleteBrokerCredentialResponses];

export type GetBrokerCredentialData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/broker-credentials/{id}';
};

export type GetBrokerCredentialResponses = {
    /**
     * Broker credential
     */
    200: BrokerCredential;
};

export type GetBrokerCredentialResponse = GetBrokerCredentialResponses[keyof GetBrokerCredentialResponses];

export type UpdateBrokerCredentialData = {
    body?: BrokerCredentialUpdate;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/broker-credentials/{id}';
};

export type UpdateBrokerCredentialResponses = {
    /**
     * Updated broker credential
     */
    200: BrokerCredential;
};

export type UpdateBrokerCredentialResponse = UpdateBrokerCredentialResponses[keyof UpdateBrokerCredentialResponses];

export type VerifyBrokerCredentialData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/broker-credentials/{id}/verify';
};

export type VerifyBrokerCredentialResponses = {
    /**
     * Verification result
     */
    200: BrokerCredentialVerifyResult;
};

export type VerifyBrokerCredentialResponse = VerifyBrokerCredentialResponses[keyof VerifyBrokerCredentialResponses];

export type ListExecutionAlgosData = {
    body?: never;
    path?: never;
    query?: {
        status?: 'working' | 'completed' | 'cancelled' | 'expired' | 'failed' | 'paused';
    };
    url: '/api/v1/finance/trading/execution-algos';
};

export type ListExecutionAlgosErrors = {
    /**
     * Unauthorized — CanViewPortfolio policy required
     */
    403: unknown;
};

export type ListExecutionAlgosResponses = {
    /**
     * Execution algos for the organization
     */
    200: ExecutionAlgoList;
};

export type ListExecutionAlgosResponse = ListExecutionAlgosResponses[keyof ListExecutionAlgosResponses];

export type CreateExecutionAlgoData = {
    body?: ExecutionAlgoCreate;
    path?: never;
    query?: never;
    url: '/api/v1/finance/trading/execution-algos';
};

export type CreateExecutionAlgoErrors = {
    /**
     * Validation error
     */
    400: unknown;
    /**
     * Unauthorized — CanTrade policy required
     */
    403: unknown;
};

export type CreateExecutionAlgoResponses = {
    /**
     * Execution algo created and scheduled
     */
    201: ExecutionAlgo;
};

export type CreateExecutionAlgoResponse = CreateExecutionAlgoResponses[keyof CreateExecutionAlgoResponses];

export type GetExecutionAlgoData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/trading/execution-algos/{id}';
};

export type GetExecutionAlgoErrors = {
    /**
     * Unauthorized — CanViewPortfolio policy required
     */
    403: unknown;
    /**
     * Execution algo not found
     */
    404: unknown;
};

export type GetExecutionAlgoResponses = {
    /**
     * Execution algo with worked quantity and in-flight child count
     */
    200: ExecutionAlgoWithSummary;
};

export type GetExecutionAlgoResponse = GetExecutionAlgoResponses[keyof GetExecutionAlgoResponses];

export type CancelExecutionAlgoData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/trading/execution-algos/{id}/cancel';
};

export type CancelExecutionAlgoErrors = {
    /**
     * Unauthorized — CanTrade policy required
     */
    403: unknown;
    /**
     * Execution algo not found
     */
    404: unknown;
    /**
     * Algo is already cancelled or in a terminal state
     */
    409: unknown;
};

export type CancelExecutionAlgoResponses = {
    /**
     * Execution algo cancelled; in-flight children cancelled where possible
     */
    200: ExecutionAlgo;
};

export type CancelExecutionAlgoResponse = CancelExecutionAlgoResponses[keyof CancelExecutionAlgoResponses];

export type PauseExecutionAlgoData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/trading/execution-algos/{id}/pause';
};

export type PauseExecutionAlgoErrors = {
    /**
     * Unauthorized — CanTrade policy required
     */
    403: unknown;
    /**
     * Execution algo not found
     */
    404: unknown;
    /**
     * Algo is not in working state
     */
    409: unknown;
};

export type PauseExecutionAlgoResponses = {
    /**
     * Execution algo paused
     */
    200: ExecutionAlgo;
};

export type PauseExecutionAlgoResponse = PauseExecutionAlgoResponses[keyof PauseExecutionAlgoResponses];

export type ResumeExecutionAlgoData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/trading/execution-algos/{id}/resume';
};

export type ResumeExecutionAlgoErrors = {
    /**
     * Unauthorized — CanTrade policy required
     */
    403: unknown;
    /**
     * Execution algo not found
     */
    404: unknown;
    /**
     * Algo is not in paused state
     */
    409: unknown;
};

export type ResumeExecutionAlgoResponses = {
    /**
     * Execution algo resumed
     */
    200: ExecutionAlgo;
};

export type ResumeExecutionAlgoResponse = ResumeExecutionAlgoResponses[keyof ResumeExecutionAlgoResponses];

export type ListForwardRunsData = {
    body?: never;
    path?: never;
    query?: {
        definitionId?: string;
        bucketDefinitionId?: string;
        status?: 'warming_up' | 'active' | 'paused' | 'stopped';
        limit?: string;
        offset?: string;
    };
    url: '/api/v1/finance/forward-runs';
};

export type ListForwardRunsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListForwardRunsResponses = {
    /**
     * Forward runs for the organization, newest first
     */
    200: ForwardRunList;
};

export type ListForwardRunsResponse = ListForwardRunsResponses[keyof ListForwardRunsResponses];

export type CreateSystematicForwardRunData = {
    body?: CreateForwardRunBody;
    path?: never;
    query?: never;
    url: '/api/v1/finance/forward-runs';
};

export type CreateSystematicForwardRunErrors = {
    /**
     * Organization context required, body invalid, or definition not paper-tradeable
     */
    400: unknown;
    /**
     * Strategy definition not found for the organization
     */
    404: unknown;
};

export type CreateSystematicForwardRunResponses = {
    /**
     * Systematic paper forward run created (or existing run returned)
     */
    201: ForwardRunCreateResult;
};

export type CreateSystematicForwardRunResponse = CreateSystematicForwardRunResponses[keyof CreateSystematicForwardRunResponses];

export type CreateBucketForwardRunData = {
    body?: CreateBucketForwardRunBody;
    path?: never;
    query?: never;
    url: '/api/v1/finance/forward-runs/bucket';
};

export type CreateBucketForwardRunErrors = {
    /**
     * Organization context required, body invalid, component missing definitionId, component definition not paper-tradeable, or live run missing account binding
     */
    400: unknown;
    /**
     * Bucket definition or component strategy definition not found
     */
    404: unknown;
};

export type CreateBucketForwardRunResponses = {
    /**
     * Bucket forward run created with PIT-frozen component weights (or existing run returned)
     */
    201: ForwardRunCreateResult;
};

export type CreateBucketForwardRunResponse = CreateBucketForwardRunResponses[keyof CreateBucketForwardRunResponses];

export type GetForwardRunData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/finance/forward-runs/{id}';
};

export type GetForwardRunErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Forward run not found for the organization
     */
    404: unknown;
};

export type GetForwardRunResponses = {
    /**
     * Forward run detail including paper equity and current positions
     */
    200: ForwardRun;
};

export type GetForwardRunResponse = GetForwardRunResponses[keyof GetForwardRunResponses];

export type ListShadowModeDaemonsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/finance/shadow-mode/daemons';
};

export type ListShadowModeDaemonsErrors = {
    /**
     * Organization context required
     */
    400: unknown;
};

export type ListShadowModeDaemonsResponses = {
    /**
     * Shadow-mode certification status for all 4 brain daemons
     */
    200: ShadowDaemonCertList;
};

export type ListShadowModeDaemonsResponse = ListShadowModeDaemonsResponses[keyof ListShadowModeDaemonsResponses];

export type GetShadowModeDaemonData = {
    body?: never;
    path: {
        daemonId: number;
    };
    query?: never;
    url: '/api/v1/finance/shadow-mode/daemons/{daemonId}';
};

export type GetShadowModeDaemonErrors = {
    /**
     * Organization context required
     */
    400: unknown;
    /**
     * Daemon not found or not a brain daemon
     */
    404: unknown;
};

export type GetShadowModeDaemonResponses = {
    /**
     * Shadow-mode certification status for one brain daemon
     */
    200: ShadowDaemonCertData;
};

export type GetShadowModeDaemonResponse = GetShadowModeDaemonResponses[keyof GetShadowModeDaemonResponses];

export type UpdateShadowModeDaemonEnrollmentData = {
    body?: ShadowDaemonEnrollUpdate;
    path: {
        daemonId: number;
    };
    query?: never;
    url: '/api/v1/finance/shadow-mode/daemons/{daemonId}';
};

export type UpdateShadowModeDaemonEnrollmentErrors = {
    /**
     * Validation error or organization context required
     */
    400: unknown;
    /**
     * Daemon not found or no cert row exists yet
     */
    404: unknown;
};

export type UpdateShadowModeDaemonEnrollmentResponses = {
    /**
     * Enrollment mode updated
     */
    200: ShadowDaemonCertData;
};

export type UpdateShadowModeDaemonEnrollmentResponse = UpdateShadowModeDaemonEnrollmentResponses[keyof UpdateShadowModeDaemonEnrollmentResponses];

export type CertifyShadowModeDaemonData = {
    body?: never;
    path: {
        daemonId: number;
    };
    query?: never;
    url: '/api/v1/finance/shadow-mode/daemons/{daemonId}/certify';
};

export type CertifyShadowModeDaemonErrors = {
    /**
     * Daemon is not eligible for certification (certStatus must be "eligible")
     */
    400: unknown;
    /**
     * Daemon not found or no cert row exists yet
     */
    404: unknown;
};

export type CertifyShadowModeDaemonResponses = {
    /**
     * Daemon certified — mode set to "certified" in the cert payload
     */
    200: ShadowDaemonCertData;
};

export type CertifyShadowModeDaemonResponse = CertifyShadowModeDaemonResponses[keyof CertifyShadowModeDaemonResponses];

export type GraduateShadowModeDaemonData = {
    body?: never;
    path: {
        daemonId: number;
    };
    query?: never;
    url: '/api/v1/finance/shadow-mode/daemons/{daemonId}/graduate';
};

export type GraduateShadowModeDaemonErrors = {
    /**
     * Daemon is not certified (mode must be "certified" before graduating)
     */
    400: unknown;
    /**
     * Daemon not found or no cert row exists yet
     */
    404: unknown;
};

export type GraduateShadowModeDaemonResponses = {
    /**
     * Daemon graduated — daemon.enabled flipped to true for live execution
     */
    200: ShadowDaemonCertData;
};

export type GraduateShadowModeDaemonResponse = GraduateShadowModeDaemonResponses[keyof GraduateShadowModeDaemonResponses];

export type GetProjectCodeOperationalMetricsData = {
    body?: never;
    path: {
        projectId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/code/metrics';
};

export type GetProjectCodeOperationalMetricsErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type GetProjectCodeOperationalMetricsResponses = {
    /**
     * Operational generated-code review, source sync, and gate carryover metrics
     */
    200: ProjectCodeOperationalMetrics;
};

export type GetProjectCodeOperationalMetricsResponse = GetProjectCodeOperationalMetricsResponses[keyof GetProjectCodeOperationalMetricsResponses];

export type GetProjectCodeWorkspaceData = {
    body?: never;
    path: {
        projectId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/code/workspace';
};

export type GetProjectCodeWorkspaceErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type GetProjectCodeWorkspaceResponses = {
    /**
     * Project code workspace projection
     */
    200: CodeWorkspaceState;
};

export type GetProjectCodeWorkspaceResponse = GetProjectCodeWorkspaceResponses[keyof GetProjectCodeWorkspaceResponses];

export type ListProjectCodeRepositoryConnectionsData = {
    body?: never;
    path: {
        projectId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/code/repository-connections';
};

export type ListProjectCodeRepositoryConnectionsErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type ListProjectCodeRepositoryConnectionsResponses = {
    /**
     * Active repository connections available to this project
     */
    200: CodeRepositoryConnectionList;
};

export type ListProjectCodeRepositoryConnectionsResponse = ListProjectCodeRepositoryConnectionsResponses[keyof ListProjectCodeRepositoryConnectionsResponses];

export type CreateProjectCodeRepositoryConnectionData = {
    body?: CodeRepositoryConnectionCreateInput;
    path: {
        projectId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/code/repository-connections';
};

export type CreateProjectCodeRepositoryConnectionErrors = {
    /**
     * Invalid repository connection input
     */
    400: unknown;
    /**
     * Project not found
     */
    404: unknown;
};

export type CreateProjectCodeRepositoryConnectionResponses = {
    /**
     * Repository connection created for this project
     */
    201: CodeRepositoryConnection;
};

export type CreateProjectCodeRepositoryConnectionResponse = CreateProjectCodeRepositoryConnectionResponses[keyof CreateProjectCodeRepositoryConnectionResponses];

export type EnableProjectCodeWorkspaceData = {
    body?: CodeWorkspaceEnableInput;
    path: {
        projectId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/code/workspace/enable';
};

export type EnableProjectCodeWorkspaceErrors = {
    /**
     * Invalid workspace input
     */
    400: unknown;
    /**
     * Project not found
     */
    404: unknown;
};

export type EnableProjectCodeWorkspaceResponses = {
    /**
     * Code workspace enablement accepted
     */
    202: CodeWorkspaceEnableResult;
};

export type EnableProjectCodeWorkspaceResponse = EnableProjectCodeWorkspaceResponses[keyof EnableProjectCodeWorkspaceResponses];

export type ListProjectCodeCheckpointsData = {
    body?: never;
    path: {
        projectId: string;
    };
    query?: {
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/code/projects/{projectId}/code/workspace/checkpoints';
};

export type ListProjectCodeCheckpointsErrors = {
    /**
     * Project or workspace not found
     */
    404: unknown;
};

export type ListProjectCodeCheckpointsResponses = {
    /**
     * Project code checkpoints
     */
    200: CodeWorkspaceCheckpointsList;
};

export type ListProjectCodeCheckpointsResponse = ListProjectCodeCheckpointsResponses[keyof ListProjectCodeCheckpointsResponses];

export type ListProjectCodeWorkspaceOperationsData = {
    body?: never;
    path: {
        projectId: string;
    };
    query?: {
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/code/projects/{projectId}/code/workspace/operations';
};

export type ListProjectCodeWorkspaceOperationsErrors = {
    /**
     * Project or workspace not found
     */
    404: unknown;
};

export type ListProjectCodeWorkspaceOperationsResponses = {
    /**
     * Project code workspace operations
     */
    200: CodeWorkspaceOperationsList;
};

export type ListProjectCodeWorkspaceOperationsResponse = ListProjectCodeWorkspaceOperationsResponses[keyof ListProjectCodeWorkspaceOperationsResponses];

export type MaterializeProjectChangeCodeData = {
    body?: CodeWorkspaceMaterializeInput;
    path: {
        projectId: string;
        changeId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/changes/{changeId}/code/materialize';
};

export type MaterializeProjectChangeCodeErrors = {
    /**
     * Invalid materialization request
     */
    400: unknown;
    /**
     * Project, change, revision, or workspace not found
     */
    404: unknown;
};

export type MaterializeProjectChangeCodeResponses = {
    /**
     * Code materialization operation queued
     */
    202: CodeWorkspaceOperationResult;
};

export type MaterializeProjectChangeCodeResponse = MaterializeProjectChangeCodeResponses[keyof MaterializeProjectChangeCodeResponses];

export type OpenProjectChangeCodeReviewData = {
    body?: CodeWorkspaceOpenReviewInput;
    path: {
        projectId: string;
        changeId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/changes/{changeId}/code/open-review';
};

export type OpenProjectChangeCodeReviewErrors = {
    /**
     * Invalid open-review request
     */
    400: unknown;
    /**
     * Project, change, or workspace not found
     */
    404: unknown;
};

export type OpenProjectChangeCodeReviewResponses = {
    /**
     * Open-review operation queued
     */
    202: CodeWorkspaceOperationResult;
};

export type OpenProjectChangeCodeReviewResponse = OpenProjectChangeCodeReviewResponses[keyof OpenProjectChangeCodeReviewResponses];

export type RollbackProjectCodeCheckpointData = {
    body?: CodeWorkspaceRollbackInput;
    path: {
        projectId: string;
        checkpointId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/code/checkpoints/{checkpointId}/rollback';
};

export type RollbackProjectCodeCheckpointErrors = {
    /**
     * Invalid rollback request
     */
    400: unknown;
    /**
     * Project, workspace, or checkpoint not found
     */
    404: unknown;
};

export type RollbackProjectCodeCheckpointResponses = {
    /**
     * Rollback operation queued
     */
    202: CodeWorkspaceOperationResult;
};

export type RollbackProjectCodeCheckpointResponse = RollbackProjectCodeCheckpointResponses[keyof RollbackProjectCodeCheckpointResponses];

export type GetProjectCodeClientDatabaseData = {
    body?: never;
    path: {
        projectId: string;
    };
    query?: {
        limit?: number;
        migrationCursor?: string;
        snapshotCursor?: string;
    };
    url: '/api/v1/code/projects/{projectId}/code/client-db';
};

export type GetProjectCodeClientDatabaseErrors = {
    /**
     * Project not found
     */
    404: unknown;
};

export type GetProjectCodeClientDatabaseResponses = {
    /**
     * Project client database target, migration ledger, and DB snapshot markers
     */
    200: CodeClientDatabaseState;
};

export type GetProjectCodeClientDatabaseResponse = GetProjectCodeClientDatabaseResponses[keyof GetProjectCodeClientDatabaseResponses];

export type ConfigureProjectCodeClientDatabaseData = {
    body: CodeClientDatabaseConfigureInput;
    path: {
        projectId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/code/client-db';
};

export type ConfigureProjectCodeClientDatabaseErrors = {
    /**
     * Invalid client database input
     */
    400: unknown;
    /**
     * Project not found
     */
    404: unknown;
};

export type ConfigureProjectCodeClientDatabaseResponses = {
    /**
     * Configured project client database target
     */
    200: CodeClientDatabaseState;
};

export type ConfigureProjectCodeClientDatabaseResponse = ConfigureProjectCodeClientDatabaseResponses[keyof ConfigureProjectCodeClientDatabaseResponses];

export type GetProjectWorkstreamCodeTuningViewData = {
    body?: never;
    path: {
        projectId: string;
        workstreamId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code';
};

export type GetProjectWorkstreamCodeTuningViewErrors = {
    /**
     * Project or workstream not found
     */
    404: unknown;
};

export type GetProjectWorkstreamCodeTuningViewResponses = {
    /**
     * Code tuning view for a focused workstream
     */
    200: CodeTuningView;
};

export type GetProjectWorkstreamCodeTuningViewResponse = GetProjectWorkstreamCodeTuningViewResponses[keyof GetProjectWorkstreamCodeTuningViewResponses];

export type EnableProjectWorkstreamCodeWorkforceData = {
    body?: never;
    path: {
        projectId: string;
        workstreamId: string;
    };
    query?: {
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/workforce/enable';
};

export type EnableProjectWorkstreamCodeWorkforceErrors = {
    /**
     * Project or workstream not found
     */
    404: unknown;
};

export type EnableProjectWorkstreamCodeWorkforceResponses = {
    /**
     * Ensure the code Project Manager is hired and visible for this workstream
     */
    200: CodeWorkforceEnable;
};

export type EnableProjectWorkstreamCodeWorkforceResponse = EnableProjectWorkstreamCodeWorkforceResponses[keyof EnableProjectWorkstreamCodeWorkforceResponses];

export type CreateProjectWorkstreamCodeGenerationRunData = {
    body?: CodeGenerationRunCreateInput;
    path: {
        projectId: string;
        workstreamId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/generation-runs';
};

export type CreateProjectWorkstreamCodeGenerationRunErrors = {
    /**
     * Invalid code generation run input
     */
    400: unknown;
    /**
     * Project or workstream not found
     */
    404: unknown;
};

export type CreateProjectWorkstreamCodeGenerationRunResponses = {
    /**
     * Code generation workflow run queued for this workstream
     */
    202: CodeGenerationRunQueued;
};

export type CreateProjectWorkstreamCodeGenerationRunResponse = CreateProjectWorkstreamCodeGenerationRunResponses[keyof CreateProjectWorkstreamCodeGenerationRunResponses];

export type ListProjectWorkstreamCodeReviewRequestsData = {
    body?: never;
    path: {
        projectId: string;
        workstreamId: string;
    };
    query?: {
        limit?: number;
        cursor?: string;
    };
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/review-requests';
};

export type ListProjectWorkstreamCodeReviewRequestsErrors = {
    /**
     * Project or workstream not found
     */
    404: unknown;
};

export type ListProjectWorkstreamCodeReviewRequestsResponses = {
    /**
     * Code review requests for a focused workstream
     */
    200: CodeReviewRequestList;
};

export type ListProjectWorkstreamCodeReviewRequestsResponse = ListProjectWorkstreamCodeReviewRequestsResponses[keyof ListProjectWorkstreamCodeReviewRequestsResponses];

export type CreateProjectWorkstreamCodeReviewRequestData = {
    body?: CodeReviewRequestCreate;
    path: {
        projectId: string;
        workstreamId: string;
        versionId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/versions/{versionId}/review-requests';
};

export type CreateProjectWorkstreamCodeReviewRequestErrors = {
    /**
     * Version is not reviewable
     */
    400: unknown;
    /**
     * Project, workstream, or version not found
     */
    404: unknown;
    /**
     * A review request is already pending
     */
    409: CodeReviewGateConflict;
};

export type CreateProjectWorkstreamCodeReviewRequestError = CreateProjectWorkstreamCodeReviewRequestErrors[keyof CreateProjectWorkstreamCodeReviewRequestErrors];

export type CreateProjectWorkstreamCodeReviewRequestResponses = {
    /**
     * Code review request created for this generated version
     */
    201: CodeReviewRequest;
};

export type CreateProjectWorkstreamCodeReviewRequestResponse = CreateProjectWorkstreamCodeReviewRequestResponses[keyof CreateProjectWorkstreamCodeReviewRequestResponses];

export type GetProjectWorkstreamCodeReviewRequestData = {
    body?: never;
    path: {
        projectId: string;
        workstreamId: string;
        reviewRequestId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/review-requests/{reviewRequestId}';
};

export type GetProjectWorkstreamCodeReviewRequestErrors = {
    /**
     * Project, workstream, or review request not found
     */
    404: unknown;
};

export type GetProjectWorkstreamCodeReviewRequestResponses = {
    /**
     * Code review request with redacted evidence summaries
     */
    200: CodeReviewRequest;
};

export type GetProjectWorkstreamCodeReviewRequestResponse = GetProjectWorkstreamCodeReviewRequestResponses[keyof GetProjectWorkstreamCodeReviewRequestResponses];

export type DecideProjectWorkstreamCodeReviewRequestData = {
    body?: CodeReviewRequestDecisionInput;
    path: {
        projectId: string;
        workstreamId: string;
        reviewRequestId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/review-requests/{reviewRequestId}/decisions';
};

export type DecideProjectWorkstreamCodeReviewRequestErrors = {
    /**
     * Requester cannot approve or accept risk for their own request
     */
    403: unknown;
    /**
     * Project, workstream, or review request not found
     */
    404: unknown;
    /**
     * Review request is no longer pending or has expired
     */
    409: CodeReviewGateConflict;
};

export type DecideProjectWorkstreamCodeReviewRequestError = DecideProjectWorkstreamCodeReviewRequestErrors[keyof DecideProjectWorkstreamCodeReviewRequestErrors];

export type DecideProjectWorkstreamCodeReviewRequestResponses = {
    /**
     * Code review request resolved
     */
    200: CodeReviewRequest;
};

export type DecideProjectWorkstreamCodeReviewRequestResponse = DecideProjectWorkstreamCodeReviewRequestResponses[keyof DecideProjectWorkstreamCodeReviewRequestResponses];

export type CreateProjectWorkstreamCodePreviewSessionData = {
    body?: CodePreviewSessionCreateBody;
    path: {
        projectId: string;
        workstreamId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions';
};

export type CreateProjectWorkstreamCodePreviewSessionErrors = {
    /**
     * Project, workstream, or code version not found
     */
    404: unknown;
    /**
     * Preview session create rate limit exceeded
     */
    429: RateLimitExceeded;
};

export type CreateProjectWorkstreamCodePreviewSessionError = CreateProjectWorkstreamCodePreviewSessionErrors[keyof CreateProjectWorkstreamCodePreviewSessionErrors];

export type CreateProjectWorkstreamCodePreviewSessionResponses = {
    /**
     * Created or resumed an opaque server-owned code preview session
     */
    200: CodePreviewSession;
};

export type CreateProjectWorkstreamCodePreviewSessionResponse = CreateProjectWorkstreamCodePreviewSessionResponses[keyof CreateProjectWorkstreamCodePreviewSessionResponses];

export type HeartbeatProjectWorkstreamCodePreviewSessionData = {
    body?: never;
    path: {
        projectId: string;
        workstreamId: string;
        sessionId: string;
    };
    query: {
        token: string;
    };
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions/{sessionId}/heartbeat';
};

export type HeartbeatProjectWorkstreamCodePreviewSessionErrors = {
    /**
     * Invalid or expired preview session token
     */
    401: unknown;
    /**
     * Preview session not found
     */
    404: unknown;
    /**
     * Preview session heartbeat rate limit exceeded
     */
    429: RateLimitExceeded;
};

export type HeartbeatProjectWorkstreamCodePreviewSessionError = HeartbeatProjectWorkstreamCodePreviewSessionErrors[keyof HeartbeatProjectWorkstreamCodePreviewSessionErrors];

export type HeartbeatProjectWorkstreamCodePreviewSessionResponses = {
    /**
     * Extended the code preview session TTL
     */
    200: CodePreviewSession;
};

export type HeartbeatProjectWorkstreamCodePreviewSessionResponse = HeartbeatProjectWorkstreamCodePreviewSessionResponses[keyof HeartbeatProjectWorkstreamCodePreviewSessionResponses];

export type StreamProjectWorkstreamCodePreviewSessionEventsData = {
    body?: never;
    path: {
        projectId: string;
        workstreamId: string;
        sessionId: string;
    };
    query: {
        token: string;
    };
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions/{sessionId}/events';
};

export type StreamProjectWorkstreamCodePreviewSessionEventsErrors = {
    /**
     * Invalid or expired preview session token
     */
    401: unknown;
    /**
     * Preview session not found
     */
    404: unknown;
    /**
     * Preview session event stream rate limit exceeded
     */
    429: RateLimitExceeded;
};

export type StreamProjectWorkstreamCodePreviewSessionEventsError = StreamProjectWorkstreamCodePreviewSessionEventsErrors[keyof StreamProjectWorkstreamCodePreviewSessionEventsErrors];

export type StreamProjectWorkstreamCodePreviewSessionEventsResponses = {
    /**
     * SSE stream for a token-scoped code preview session
     */
    200: string;
};

export type StreamProjectWorkstreamCodePreviewSessionEventsResponse = StreamProjectWorkstreamCodePreviewSessionEventsResponses[keyof StreamProjectWorkstreamCodePreviewSessionEventsResponses];

export type ViewProjectWorkstreamCodePreviewSessionData = {
    body?: never;
    path: {
        projectId: string;
        workstreamId: string;
        sessionId: string;
    };
    query: {
        token: string;
    };
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions/{sessionId}/view';
};

export type ViewProjectWorkstreamCodePreviewSessionErrors = {
    /**
     * Invalid or expired preview session token
     */
    401: unknown;
    /**
     * Preview session not found
     */
    404: unknown;
    /**
     * Preview session view rate limit exceeded
     */
    429: RateLimitExceeded;
};

export type ViewProjectWorkstreamCodePreviewSessionError = ViewProjectWorkstreamCodePreviewSessionErrors[keyof ViewProjectWorkstreamCodePreviewSessionErrors];

export type ViewProjectWorkstreamCodePreviewSessionResponses = {
    /**
     * Stable iframe HTML entrypoint for a token-scoped code preview session
     */
    200: string;
};

export type ViewProjectWorkstreamCodePreviewSessionResponse = ViewProjectWorkstreamCodePreviewSessionResponses[keyof ViewProjectWorkstreamCodePreviewSessionResponses];

export type DeleteProjectWorkstreamCodePreviewSessionData = {
    body?: never;
    path: {
        projectId: string;
        workstreamId: string;
        sessionId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/preview/sessions/{sessionId}';
};

export type DeleteProjectWorkstreamCodePreviewSessionResponses = {
    /**
     * Disposed an active code preview session when present
     */
    200: CodePreviewSessionDispose;
};

export type DeleteProjectWorkstreamCodePreviewSessionResponse = DeleteProjectWorkstreamCodePreviewSessionResponses[keyof DeleteProjectWorkstreamCodePreviewSessionResponses];

export type AcceptProjectWorkstreamCodeTuningVersionData = {
    body?: never;
    path: {
        projectId: string;
        workstreamId: string;
        versionId: string;
    };
    query?: never;
    url: '/api/v1/code/projects/{projectId}/workstreams/{workstreamId}/code/versions/{versionId}/accept';
};

export type AcceptProjectWorkstreamCodeTuningVersionErrors = {
    /**
     * Version cannot be accepted
     */
    400: unknown;
    /**
     * Project, workstream, or version not found
     */
    404: unknown;
    /**
     * Code review approval is required, expired, or does not match the current version
     */
    409: CodeReviewGateConflict;
};

export type AcceptProjectWorkstreamCodeTuningVersionError = AcceptProjectWorkstreamCodeTuningVersionErrors[keyof AcceptProjectWorkstreamCodeTuningVersionErrors];

export type AcceptProjectWorkstreamCodeTuningVersionResponses = {
    /**
     * Accepted code tuning version promoted to a project change revision
     */
    201: CodeTuningProjectChangeRevision;
};

export type AcceptProjectWorkstreamCodeTuningVersionResponse = AcceptProjectWorkstreamCodeTuningVersionResponses[keyof AcceptProjectWorkstreamCodeTuningVersionResponses];

export type HandleGitHubCodeWorkspaceWebhookData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/code/internal/workspace-webhooks/github';
};

export type HandleGitHubCodeWorkspaceWebhookErrors = {
    /**
     * Invalid webhook payload
     */
    400: unknown;
    /**
     * Invalid webhook signature
     */
    401: unknown;
};

export type HandleGitHubCodeWorkspaceWebhookResponses = {
    /**
     * GitHub webhook accepted for code workspace reconciliation
     */
    202: CodeWorkspaceWebhookResult;
};

export type HandleGitHubCodeWorkspaceWebhookResponse = HandleGitHubCodeWorkspaceWebhookResponses[keyof HandleGitHubCodeWorkspaceWebhookResponses];

export type ApiListDecisionsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * pending (default) or recently decided
         */
        status?: 'pending' | 'recent';
        /**
         * Include the requests you raised (default true)
         */
        mine?: 'true' | 'false';
        limit?: number;
    };
    url: '/api/v1/decisions';
};

export type ApiListDecisionsErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiListDecisionsError = ApiListDecisionsErrors[keyof ApiListDecisionsErrors];

export type ApiListDecisionsResponses = {
    /**
     * Requests waiting on a person (or recently decided)
     */
    200: ApiDecisionList;
};

export type ApiListDecisionsResponse = ApiListDecisionsResponses[keyof ApiListDecisionsResponses];

export type ApiApproveDecisionData = {
    body: ApiDecisionApproveRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/decisions/{id}/approve';
};

export type ApiApproveDecisionErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiApproveDecisionError = ApiApproveDecisionErrors[keyof ApiApproveDecisionErrors];

export type ApiApproveDecisionResponses = {
    /**
     * Approve a pending request as the key’s person
     */
    200: ApiDecisionReviewResult;
};

export type ApiApproveDecisionResponse = ApiApproveDecisionResponses[keyof ApiApproveDecisionResponses];

export type ApiRejectDecisionData = {
    body: ApiDecisionRejectRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/decisions/{id}/reject';
};

export type ApiRejectDecisionErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiRejectDecisionError = ApiRejectDecisionErrors[keyof ApiRejectDecisionErrors];

export type ApiRejectDecisionResponses = {
    /**
     * Turn down a pending request, with the reason
     */
    200: ApiDecisionReviewResult;
};

export type ApiRejectDecisionResponse = ApiRejectDecisionResponses[keyof ApiRejectDecisionResponses];

export type ApiGetWorkflowRunPartData = {
    body?: never;
    path: {
        /**
         * Workflow id
         */
        id: string;
        runId: string;
        partId: string;
    };
    query?: never;
    url: '/api/v1/workflows/{id}/runs/{runId}/parts/{partId}';
};

export type ApiGetWorkflowRunPartErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiGetWorkflowRunPartError = ApiGetWorkflowRunPartErrors[keyof ApiGetWorkflowRunPartErrors];

export type ApiGetWorkflowRunPartResponses = {
    /**
     * One output part of a workflow run, whole (≤ 512 KB inline)
     */
    200: ApiOutputPartResult;
};

export type ApiGetWorkflowRunPartResponse = ApiGetWorkflowRunPartResponses[keyof ApiGetWorkflowRunPartResponses];

export type ApiGetDashboardDataData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/dashboards/{id}/data';
};

export type ApiGetDashboardDataErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiGetDashboardDataError = ApiGetDashboardDataErrors[keyof ApiGetDashboardDataErrors];

export type ApiGetDashboardDataResponses = {
    /**
     * A dashboard with what each widget shows now
     */
    200: ApiDashboardResult;
};

export type ApiGetDashboardDataResponse = ApiGetDashboardDataResponses[keyof ApiGetDashboardDataResponses];

export type ApiListIntelSourcesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * A name, handle or topic to filter on
         */
        q?: string;
        limit?: number;
    };
    url: '/api/v1/intel-sources';
};

export type ApiListIntelSourcesErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiListIntelSourcesError = ApiListIntelSourcesErrors[keyof ApiListIntelSourcesErrors];

export type ApiListIntelSourcesResponses = {
    /**
     * The sources (channels, accounts, feeds) the organization knows, and whether it follows each
     */
    200: ApiIntelSourceList;
};

export type ApiListIntelSourcesResponse = ApiListIntelSourcesResponses[keyof ApiListIntelSourcesResponses];

export type ApiListIntelSourceItemsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: {
        limit?: number;
    };
    url: '/api/v1/intel-sources/{id}/content';
};

export type ApiListIntelSourceItemsErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiListIntelSourceItemsError = ApiListIntelSourceItemsErrors[keyof ApiListIntelSourceItemsErrors];

export type ApiListIntelSourceItemsResponses = {
    /**
     * A source’s newest items (videos, posts, articles), each marked analysed or not
     */
    200: ApiIntelSourceItemList;
};

export type ApiListIntelSourceItemsResponse = ApiListIntelSourceItemsResponses[keyof ApiListIntelSourceItemsResponses];

export type ApiCancelDecisionData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/decisions/{id}/cancel';
};

export type ApiCancelDecisionErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiCancelDecisionError = ApiCancelDecisionErrors[keyof ApiCancelDecisionErrors];

export type ApiCancelDecisionResponses = {
    /**
     * Withdraw a pending request the key’s person raised
     */
    200: ApiDecisionCancelResult;
};

export type ApiCancelDecisionResponse = ApiCancelDecisionResponses[keyof ApiCancelDecisionResponses];

export type ApiListStrategiesData = {
    body?: never;
    path?: never;
    query?: {
        limit?: number;
        /**
         * Only strategies at this stage
         */
        stage?: string;
        /**
         * Only what the watched content produced
         */
        source?: 'content';
        /**
         * Only strategies that earned a tier: works_now, proven, or proven:<axis>:<label>
         */
        tier?: string;
    };
    url: '/api/v1/strategies';
};

export type ApiListStrategiesErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiListStrategiesError = ApiListStrategiesErrors[keyof ApiListStrategiesErrors];

export type ApiListStrategiesResponses = {
    /**
     * The organization’s strategies
     */
    200: ApiStrategyList;
};

export type ApiListStrategiesResponse = ApiListStrategiesResponses[keyof ApiListStrategiesResponses];

export type ApiGetStrategyData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/strategies/{id}';
};

export type ApiGetStrategyErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiGetStrategyError = ApiGetStrategyErrors[keyof ApiGetStrategyErrors];

export type ApiGetStrategyResponses = {
    /**
     * One strategy: its metrics, definition, parameters, readiness and per-regime results
     */
    200: ApiStrategyResult;
};

export type ApiGetStrategyResponse = ApiGetStrategyResponses[keyof ApiGetStrategyResponses];

export type ApiListStrategyBucketsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Name to filter on
         */
        q?: string;
        limit?: number;
    };
    url: '/api/v1/strategy-buckets';
};

export type ApiListStrategyBucketsErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiListStrategyBucketsError = ApiListStrategyBucketsErrors[keyof ApiListStrategyBucketsErrors];

export type ApiListStrategyBucketsResponses = {
    /**
     * The organization’s strategy buckets
     */
    200: ApiStrategyBucketList;
};

export type ApiListStrategyBucketsResponse = ApiListStrategyBucketsResponses[keyof ApiListStrategyBucketsResponses];

export type ApiGetStrategyBucketData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/strategy-buckets/{id}';
};

export type ApiGetStrategyBucketErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiGetStrategyBucketError = ApiGetStrategyBucketErrors[keyof ApiGetStrategyBucketErrors];

export type ApiGetStrategyBucketResponses = {
    /**
     * One bucket: its legs, their weights and each leg’s latest backtest
     */
    200: ApiStrategyBucketResult;
};

export type ApiGetStrategyBucketResponse = ApiGetStrategyBucketResponses[keyof ApiGetStrategyBucketResponses];

export type ApiCompareBacktestsData = {
    body?: never;
    path?: never;
    query: {
        /**
         * 2-5 backtest ids, comma separated (run:1,run:2 or 1,2)
         */
        ids: string;
    };
    url: '/api/v1/backtests/compare';
};

export type ApiCompareBacktestsErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiCompareBacktestsError = ApiCompareBacktestsErrors[keyof ApiCompareBacktestsErrors];

export type ApiCompareBacktestsResponses = {
    /**
     * Two to five simulations side by side, with the leader of each column
     */
    200: ApiBacktestComparisonResult;
};

export type ApiCompareBacktestsResponse = ApiCompareBacktestsResponses[keyof ApiCompareBacktestsResponses];

export type ApiListMarketRegimesData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Up to 25 symbols, comma separated
         */
        symbols: string;
        /**
         * One bar size; all bar sizes when omitted
         */
        timeframe?: string;
    };
    url: '/api/v1/market-data/regimes';
};

export type ApiListMarketRegimesErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiListMarketRegimesError = ApiListMarketRegimesErrors[keyof ApiListMarketRegimesErrors];

export type ApiListMarketRegimesResponses = {
    /**
     * The current market regime of each symbol
     */
    200: ApiMarketRegimeList;
};

export type ApiListMarketRegimesResponse = ApiListMarketRegimesResponses[keyof ApiListMarketRegimesResponses];

export type ApiListBacktestsData = {
    body?: never;
    path?: never;
    query?: {
        since?: string;
        source?: 'content';
        /**
         * Only this strategy’s simulations
         */
        strategyId?: string;
        limit?: number;
    };
    url: '/api/v1/backtests';
};

export type ApiListBacktestsErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiListBacktestsError = ApiListBacktestsErrors[keyof ApiListBacktestsErrors];

export type ApiListBacktestsResponses = {
    /**
     * Simulations on record, newest first (one strategy’s, or the organization’s)
     */
    200: ApiBacktestList;
};

export type ApiListBacktestsResponse = ApiListBacktestsResponses[keyof ApiListBacktestsResponses];

export type ApiCreateBacktestData = {
    body: ApiBacktestCreate;
    path?: never;
    query?: never;
    url: '/api/v1/backtests';
};

export type ApiCreateBacktestErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiCreateBacktestError = ApiCreateBacktestErrors[keyof ApiCreateBacktestErrors];

export type ApiCreateBacktestResponses = {
    /**
     * Queue a research-only simulation of a strategy
     */
    202: ApiBacktestRunResult;
};

export type ApiCreateBacktestResponse = ApiCreateBacktestResponses[keyof ApiCreateBacktestResponses];

export type ApiGetBacktestData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/backtests/{id}';
};

export type ApiGetBacktestErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiGetBacktestError = ApiGetBacktestErrors[keyof ApiGetBacktestErrors];

export type ApiGetBacktestResponses = {
    /**
     * One simulation: its window, full statistics, scores and series sizes
     */
    200: ApiBacktestResult;
};

export type ApiGetBacktestResponse = ApiGetBacktestResponses[keyof ApiGetBacktestResponses];

export type ApiListBacktestSeriesData = {
    body?: never;
    path: {
        id: string;
        kind: 'equity' | 'trades' | 'regimes' | 'drawdown_series' | 'buy_hold_equity' | 'oos_returns_series';
    };
    query?: {
        cursor?: string;
        limit?: number;
    };
    url: '/api/v1/backtests/{id}/series/{kind}';
};

export type ApiListBacktestSeriesErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiListBacktestSeriesError = ApiListBacktestSeriesErrors[keyof ApiListBacktestSeriesErrors];

export type ApiListBacktestSeriesResponses = {
    /**
     * One page of a simulation's series (equity, trades, regimes, drawdown_series, buy_hold_equity, oos_returns_series)
     */
    200: ApiBacktestSeriesPage;
};

export type ApiListBacktestSeriesResponse = ApiListBacktestSeriesResponses[keyof ApiListBacktestSeriesResponses];

export type ApiGetBacktestAnalyticsData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/api/v1/backtests/{id}/analytics';
};

export type ApiGetBacktestAnalyticsErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiGetBacktestAnalyticsError = ApiGetBacktestAnalyticsErrors[keyof ApiGetBacktestAnalyticsErrors];

export type ApiGetBacktestAnalyticsResponses = {
    /**
     * A simulation’s full analysis, computed once per run (the same as the platform’s Strategy Tester)
     */
    200: ApiBacktestAnalyticsResult;
};

export type ApiGetBacktestAnalyticsResponse = ApiGetBacktestAnalyticsResponses[keyof ApiGetBacktestAnalyticsResponses];

export type ApiGetCandlesData = {
    body?: never;
    path?: never;
    query: {
        symbol: string;
        timeframe: string;
        from?: string;
        to?: string;
        cursor?: string;
        exchange?: string;
        format?: 'json' | 'columnar';
        limit?: number;
        countback?: number;
    };
    url: '/api/v1/market-data/candles';
};

export type ApiGetCandlesErrors = {
    /**
     * The tool refused the request
     */
    400: ApiError;
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The platform did not answer in time
     */
    504: ApiError;
};

export type ApiGetCandlesError = ApiGetCandlesErrors[keyof ApiGetCandlesErrors];

export type ApiGetCandlesResponses = {
    /**
     * A window of stored OHLCV bars for a chart ([from, to), newest page first in time order)
     */
    200: ApiCandleWindow;
};

export type ApiGetCandlesResponse = ApiGetCandlesResponses[keyof ApiGetCandlesResponses];

export type ApiStreamBacktestEventsData = {
    body?: never;
    path: {
        /**
         * A backtest id (run:<id>) or the requestId of POST /backtests
         */
        id: string;
    };
    query?: never;
    url: '/api/v1/backtests/{id}/events';
};

export type ApiStreamBacktestEventsErrors = {
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy
     */
    403: ApiError;
    /**
     * Not found (or the module is disabled)
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
};

export type ApiStreamBacktestEventsError = ApiStreamBacktestEventsErrors[keyof ApiStreamBacktestEventsErrors];

export type ApiStreamBacktestEventsResponses = {
    /**
     * A simulation’s status and progress as server-sent events, until it is done — server-sent events status / progress / done / error; each frame's data is this schema
     */
    200: ApiRunEvent;
};

export type ApiStreamBacktestEventsResponse = ApiStreamBacktestEventsResponses[keyof ApiStreamBacktestEventsResponses];

export type GetMarketDataBackupData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Only the rows of the last N UTC days (upserted on restore); absent = the whole database
         */
        days?: number;
    };
    url: '/api/v1/market-data/backup';
};

export type GetMarketDataBackupErrors = {
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * The module is disabled
     */
    404: ApiError;
    /**
     * `days` is not an integer from 1 to 3650
     */
    422: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The market database service refused or failed
     */
    502: ApiError;
    /**
     * No market database service is registered
     */
    503: ApiError;
};

export type GetMarketDataBackupError = GetMarketDataBackupErrors[keyof GetMarketDataBackupErrors];

export type GetMarketDataBackupResponses = {
    /**
     * The backup file (gzip’d SQL), named by its cut and day in `content-disposition`
     */
    200: Blob | File;
};

export type GetMarketDataBackupResponse = GetMarketDataBackupResponses[keyof GetMarketDataBackupResponses];

export type CreateMarketDataGrantsData = {
    body: {
        /**
         * The worker's id on the asking control plane
         */
        workerId: string;
        network: {
            privateAddresses: Array<string>;
            lanAddresses: Array<string>;
            publicEgress?: string;
            engineBoxReachable: boolean | null;
            probedAt: string;
        } | null;
    };
    path?: never;
    query?: never;
    url: '/api/v1/market-data/grants';
};

export type CreateMarketDataGrantsErrors = {
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * The module is disabled
     */
    404: ApiError;
    /**
     * The body is not a worker id and network
     */
    422: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
};

export type CreateMarketDataGrantsError = CreateMarketDataGrantsErrors[keyof CreateMarketDataGrantsErrors];

export type CreateMarketDataGrantsResponses = {
    /**
     * The grants, possibly none
     */
    200: {
        grants: Array<{
            instanceId: string;
            organizationId: number;
            platform: boolean;
            mode: 'primary' | 'replica';
            /**
             * The routes this worker can use, nearest first
             */
            urls: Array<string>;
            token: string;
            expiresAt: string;
        }>;
    };
};

export type CreateMarketDataGrantsResponse = CreateMarketDataGrantsResponses[keyof CreateMarketDataGrantsResponses];

export type GetMarketDataCoverageData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/market-data/coverage';
};

export type GetMarketDataCoverageErrors = {
    /**
     * Missing, invalid, revoked or expired key, or not a user key
     */
    401: unknown;
    /**
     * The key lacks the policy, or data access
     */
    403: ApiError;
    /**
     * The module is disabled
     */
    404: ApiError;
    /**
     * Rate limit exceeded (see Retry-After)
     */
    429: ApiError;
    /**
     * The market database service could not be read
     */
    502: ApiError;
    /**
     * No market database service is registered
     */
    503: ApiError;
};

export type GetMarketDataCoverageError = GetMarketDataCoverageErrors[keyof GetMarketDataCoverageErrors];

export type GetMarketDataCoverageResponses = {
    /**
     * The platform's market coverage snapshot
     */
    200: {
        /**
         * When finance-data computed this snapshot
         */
        computedAt: string;
        rows: Array<{
            /**
             * The market table, `schema.table`
             */
            table: string;
            /**
             * The series it is grouped by (a symbol), or null
             */
            entity: string | null;
            /**
             * The bar size, for `finance.candles`; null elsewhere
             */
            timeframe: string | null;
            firstAt: string | null;
            lastAt: string | null;
            rowCount: number;
        }>;
    };
};

export type GetMarketDataCoverageResponse = GetMarketDataCoverageResponses[keyof GetMarketDataCoverageResponses];
